"use strict";
var KTCardsWidget1 = {
  init: function () {
    !(function () {
      var e = document.getElementById("kt_card_widget_1_chart");
      if (e) {
        var t = e.getAttribute("data-kt-chart-color"),
          a = parseInt(KTUtil.css(e, "height")),
          l = KTUtil.getCssVariableValue("--bs-gray-500"),
          r = KTUtil.isHexColor(t)
            ? t
            : KTUtil.getCssVariableValue("--bs-" + t),
          o = KTUtil.getCssVariableValue("--bs-gray-300"),
          i = new ApexCharts(e, {
            series: [
              {
                name: "Sales",
                data: [30, 75, 55, 45, 30, 60, 75, 50],
                margin: { left: 5, right: 5 },
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "bar",
              height: a,
              toolbar: { show: !1 },
              sparkline: { enabled: !0 },
            },
            plotOptions: {
              bar: { horizontal: !1, columnWidth: ["35%"], borderRadius: 6 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            stroke: { show: !0, width: 4, colors: ["transparent"] },
            xaxis: {
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { show: !1, style: { colors: l, fontSize: "12px" } },
              crosshairs: { show: !1 },
            },
            yaxis: {
              labels: { show: !1, style: { colors: l, fontSize: "12px" } },
            },
            fill: { type: "solid" },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              x: {
                formatter: function (e) {
                  return "Feb: " + e;
                },
              },
              y: {
                formatter: function (e) {
                  return e + "%";
                },
              },
            },
            colors: [r, o],
            grid: {
              borderColor: !1,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
              padding: { top: 10, left: 25, right: 25 },
            },
          });
        setTimeout(function () {
          i.render();
        }, 300);
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTCardsWidget1),
  KTUtil.onDOMContentLoaded(function () {
    KTCardsWidget1.init();
  });
var KTCardsWidget10 = {
  init: function () {
    !(function () {
      var e = document.getElementById("kt_card_widget_10_chart");
      if (e) {
        var t = {
            size: e.getAttribute("data-kt-size")
              ? parseInt(e.getAttribute("data-kt-size"))
              : 70,
            lineWidth: e.getAttribute("data-kt-line")
              ? parseInt(e.getAttribute("data-kt-line"))
              : 11,
            rotate: e.getAttribute("data-kt-rotate")
              ? parseInt(e.getAttribute("data-kt-rotate"))
              : 145,
          },
          a = document.createElement("canvas"),
          l = document.createElement("span");
        "undefined" != typeof G_vmlCanvasManager &&
          G_vmlCanvasManager.initElement(a);
        var r = a.getContext("2d");
        (a.width = a.height = t.size),
          e.appendChild(l),
          e.appendChild(a),
          r.translate(t.size / 2, t.size / 2),
          r.rotate((t.rotate / 180 - 0.5) * Math.PI);
        var o = (t.size - t.lineWidth) / 2,
          i = function (e, t, a) {
            (a = Math.min(Math.max(0, a || 1), 1)),
              r.beginPath(),
              r.arc(0, 0, o, 0, 2 * Math.PI * a, !1),
              (r.strokeStyle = e),
              (r.lineCap = "round"),
              (r.lineWidth = t),
              r.stroke();
          };
        i("#E4E6EF", t.lineWidth, 1),
          i(KTUtil.getCssVariableValue("--bs-primary"), t.lineWidth, 100 / 150),
          i(KTUtil.getCssVariableValue("--bs-success"), t.lineWidth, 0.4);
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTCardsWidget10),
  KTUtil.onDOMContentLoaded(function () {
    KTCardsWidget10.init();
  });
var KTCardWidget12 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_card_widget_12_chart");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          r = KTUtil.getCssVariableValue("--bs-gray-800"),
          o = {
            series: [
              {
                name: "Sales",
                data: [
                  3.5, 5.7, 2.8, 5.9, 4.2, 5.6, 4.3, 4.5, 5.9, 4.5, 5.7, 4.8,
                  5.7,
                ],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: { type: "solid", opacity: 0 },
            stroke: { curve: "smooth", show: !0, width: 2, colors: [r] },
            xaxis: {
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { show: !1 },
              crosshairs: {
                position: "front",
                stroke: { color: r, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: { labels: { show: !1 } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              x: {
                formatter: function (e) {
                  return "Feb " + e;
                },
              },
              y: {
                formatter: function (e) {
                  return "10" * e + "K";
                },
              },
            },
            colors: [KTUtil.getCssVariableValue("--bs-success")],
            grid: {
              borderColor: l,
              strokeDashArray: 4,
              padding: { top: 0, right: -20, bottom: -20, left: -20 },
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: r, strokeWidth: 2 },
          };
        (e.self = new ApexCharts(t, o)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTCardWidget12),
  KTUtil.onDOMContentLoaded(function () {
    KTCardWidget12.init();
  });
var KTCardWidget13 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_card_widget_13_chart");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          r = KTUtil.getCssVariableValue("--bs-gray-800"),
          o = {
            series: [
              {
                name: "Shipments",
                data: [1.5, 4.5, 2, 3, 2, 4, 2.5, 2, 2.5, 4, 3.5, 4.5, 2.5],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: { type: "solid", opacity: 0 },
            stroke: { curve: "smooth", show: !0, width: 2, colors: [r] },
            xaxis: {
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { show: !1 },
              crosshairs: {
                position: "front",
                stroke: { color: r, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: { labels: { show: !1 } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              x: {
                formatter: function (e) {
                  return "Feb " + e;
                },
              },
              y: {
                formatter: function (e) {
                  return "10" * e + "K";
                },
              },
            },
            colors: [KTUtil.getCssVariableValue("--bs-success")],
            grid: {
              borderColor: l,
              strokeDashArray: 4,
              padding: { top: 0, right: -20, bottom: -20, left: -20 },
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: r, strokeWidth: 2 },
          };
        (e.self = new ApexCharts(t, o)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTCardWidget13),
  KTUtil.onDOMContentLoaded(function () {
    KTCardWidget13.init();
  });
var KTCardsWidget17 = {
  init: function () {
    !(function () {
      var e = document.getElementById("kt_card_widget_17_chart");
      if (e) {
        var t = {
            size: e.getAttribute("data-kt-size")
              ? parseInt(e.getAttribute("data-kt-size"))
              : 70,
            lineWidth: e.getAttribute("data-kt-line")
              ? parseInt(e.getAttribute("data-kt-line"))
              : 11,
            rotate: e.getAttribute("data-kt-rotate")
              ? parseInt(e.getAttribute("data-kt-rotate"))
              : 145,
          },
          a = document.createElement("canvas"),
          l = document.createElement("span");
        "undefined" != typeof G_vmlCanvasManager &&
          G_vmlCanvasManager.initElement(a);
        var r = a.getContext("2d");
        (a.width = a.height = t.size),
          e.appendChild(l),
          e.appendChild(a),
          r.translate(t.size / 2, t.size / 2),
          r.rotate((t.rotate / 180 - 0.5) * Math.PI);
        var o = (t.size - t.lineWidth) / 2,
          i = function (e, t, a) {
            (a = Math.min(Math.max(0, a || 1), 1)),
              r.beginPath(),
              r.arc(0, 0, o, 0, 2 * Math.PI * a, !1),
              (r.strokeStyle = e),
              (r.lineCap = "round"),
              (r.lineWidth = t),
              r.stroke();
          };
        i("#E4E6EF", t.lineWidth, 1),
          i(KTUtil.getCssVariableValue("--bs-primary"), t.lineWidth, 100 / 150),
          i(KTUtil.getCssVariableValue("--bs-success"), t.lineWidth, 0.4);
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTCardsWidget17),
  KTUtil.onDOMContentLoaded(function () {
    KTCardsWidget17.init();
  });
var KTCardsWidget19 = {
  init: function () {
    !(function () {
      var e = document.getElementById("kt_card_widget_19_chart");
      if (e) {
        var t = {
            size: e.getAttribute("data-kt-size")
              ? parseInt(e.getAttribute("data-kt-size"))
              : 70,
            lineWidth: e.getAttribute("data-kt-line")
              ? parseInt(e.getAttribute("data-kt-line"))
              : 11,
            rotate: e.getAttribute("data-kt-rotate")
              ? parseInt(e.getAttribute("data-kt-rotate"))
              : 145,
          },
          a = document.createElement("canvas"),
          l = document.createElement("span");
        "undefined" != typeof G_vmlCanvasManager &&
          G_vmlCanvasManager.initElement(a);
        var r = a.getContext("2d");
        (a.width = a.height = t.size),
          e.appendChild(l),
          e.appendChild(a),
          r.translate(t.size / 2, t.size / 2),
          r.rotate((t.rotate / 180 - 0.5) * Math.PI);
        var o = (t.size - t.lineWidth) / 2,
          i = function (e, t, a) {
            (a = Math.min(Math.max(0, a || 1), 1)),
              r.beginPath(),
              r.arc(0, 0, o, 0, 2 * Math.PI * a, !1),
              (r.strokeStyle = e),
              (r.lineCap = "round"),
              (r.lineWidth = t),
              r.stroke();
          };
        i("#E4E6EF", t.lineWidth, 1),
          i(KTUtil.getCssVariableValue("--bs-primary"), t.lineWidth, 100 / 150),
          i(KTUtil.getCssVariableValue("--bs-success"), t.lineWidth, 0.4);
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTCardsWidget19),
  KTUtil.onDOMContentLoaded(function () {
    KTCardsWidget19.init();
  });
var KTCardsWidget4 = {
  init: function () {
    !(function () {
      var e = document.getElementById("kt_card_widget_4_chart");
      if (e) {
        var t = {
            size: e.getAttribute("data-kt-size")
              ? parseInt(e.getAttribute("data-kt-size"))
              : 70,
            lineWidth: e.getAttribute("data-kt-line")
              ? parseInt(e.getAttribute("data-kt-line"))
              : 11,
            rotate: e.getAttribute("data-kt-rotate")
              ? parseInt(e.getAttribute("data-kt-rotate"))
              : 145,
          },
          a = document.createElement("canvas"),
          l = document.createElement("span");
        "undefined" != typeof G_vmlCanvasManager &&
          G_vmlCanvasManager.initElement(a);
        var r = a.getContext("2d");
        (a.width = a.height = t.size),
          e.appendChild(l),
          e.appendChild(a),
          r.translate(t.size / 2, t.size / 2),
          r.rotate((t.rotate / 180 - 0.5) * Math.PI);
        var o = (t.size - t.lineWidth) / 2,
          i = function (e, t, a) {
            (a = Math.min(Math.max(0, a || 1), 1)),
              r.beginPath(),
              r.arc(0, 0, o, 0, 2 * Math.PI * a, !1),
              (r.strokeStyle = e),
              (r.lineCap = "round"),
              (r.lineWidth = t),
              r.stroke();
          };
        i("#E4E6EF", t.lineWidth, 1),
          i(KTUtil.getCssVariableValue("--bs-danger"), t.lineWidth, 100 / 150),
          i(KTUtil.getCssVariableValue("--bs-primary"), t.lineWidth, 0.4);
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTCardsWidget4),
  KTUtil.onDOMContentLoaded(function () {
    KTCardsWidget4.init();
  });
var KTCardsWidget6 = {
  init: function () {
    !(function () {
      var e = document.getElementById("kt_card_widget_6_chart");
      if (e) {
        var t = parseInt(KTUtil.css(e, "height")),
          a = KTUtil.getCssVariableValue("--bs-gray-500"),
          l = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          r = KTUtil.getCssVariableValue("--bs-primary"),
          o = KTUtil.getCssVariableValue("--bs-gray-300"),
          i = new ApexCharts(e, {
            series: [{ name: "Sales", data: [30, 60, 53, 45, 60, 75, 53] }],
            chart: {
              fontFamily: "inherit",
              type: "bar",
              height: t,
              toolbar: { show: !1 },
              sparkline: { enabled: !0 },
            },
            plotOptions: {
              bar: { horizontal: !1, columnWidth: ["55%"], borderRadius: 6 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            stroke: { show: !0, width: 9, colors: ["transparent"] },
            xaxis: {
              axisBorder: { show: !1 },
              axisTicks: { show: !1, tickPlacement: "between" },
              labels: { show: !1, style: { colors: a, fontSize: "12px" } },
              crosshairs: { show: !1 },
            },
            yaxis: {
              labels: { show: !1, style: { colors: a, fontSize: "12px" } },
            },
            fill: { type: "solid" },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              x: {
                formatter: function (e) {
                  return "Feb: " + e;
                },
              },
              y: {
                formatter: function (e) {
                  return e + "%";
                },
              },
            },
            colors: [r, o],
            grid: {
              padding: { left: 10, right: 10 },
              borderColor: l,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
          });
        setTimeout(function () {
          i.render();
        }, 300);
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTCardsWidget6),
  KTUtil.onDOMContentLoaded(function () {
    KTCardsWidget6.init();
  });
var KTCardWidget8 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_card_widget_8_chart");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          r = KTUtil.getCssVariableValue("--bs-gray-800"),
          o = {
            series: [
              {
                name: "Sales",
                data: [
                  4.5, 5.7, 2.8, 5.9, 4.2, 5.6, 5.2, 4.5, 5.9, 4.5, 5.7, 4.8,
                  5.7,
                ],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: { type: "solid", opacity: 0 },
            stroke: { curve: "smooth", show: !0, width: 2, colors: [r] },
            xaxis: {
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { show: !1 },
              crosshairs: {
                position: "front",
                stroke: { color: r, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: { labels: { show: !1 } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              x: {
                formatter: function (e) {
                  return "Feb " + e;
                },
              },
              y: {
                formatter: function (e) {
                  return "$" + e + "K";
                },
              },
            },
            colors: [KTUtil.getCssVariableValue("--bs-success")],
            grid: {
              borderColor: l,
              strokeDashArray: 4,
              padding: { top: 0, right: -20, bottom: -20, left: -20 },
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: r, strokeWidth: 2 },
          };
        (e.self = new ApexCharts(t, o)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTCardWidget8),
  KTUtil.onDOMContentLoaded(function () {
    KTCardWidget8.init();
  });
var KTCardWidget9 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_card_widget_9_chart");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          r = KTUtil.getCssVariableValue("--bs-gray-800"),
          o = {
            series: [
              {
                name: "Visitors",
                data: [1.5, 2.5, 2, 3, 2, 4, 2.5, 2, 2.5, 4, 2.5, 4.5, 2.5],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: { type: "solid", opacity: 0 },
            stroke: { curve: "smooth", show: !0, width: 2, colors: [r] },
            xaxis: {
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { show: !1 },
              crosshairs: {
                position: "front",
                stroke: { color: r, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: { labels: { show: !1 } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              x: {
                formatter: function (e) {
                  return "Feb " + e;
                },
              },
              y: {
                formatter: function (e) {
                  return e + "K";
                },
              },
            },
            colors: [KTUtil.getCssVariableValue("--bs-success")],
            grid: {
              borderColor: l,
              strokeDashArray: 4,
              padding: { top: 0, right: -20, bottom: -20, left: -20 },
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: r, strokeWidth: 2 },
          };
        (e.self = new ApexCharts(t, o)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTCardWidget9),
  KTUtil.onDOMContentLoaded(function () {
    KTCardWidget9.init();
  });
var KTFormsWidget1 = {
  init: function () {
    !(function () {
      var e = document.querySelector("#kt_forms_widget_1_select_1");
      if (e) {
        var t = function (e) {
          if (!e.id) return e.text;
          var t = document.createElement("span"),
            a = "";
          return (
            (a +=
              '<img src="' +
              e.element.getAttribute("data-kt-select2-icon") +
              '" class="rounded-circle h-20px me-2" alt="image"/>'),
            (a += e.text),
            (t.innerHTML = a),
            $(t)
          );
        };
        $(e).select2({
          placeholder: "Select coin",
          minimumResultsForSearch: 1 / 0,
          templateSelection: t,
          templateResult: t,
        });
      }
    })(),
      (function () {
        var e = document.querySelector("#kt_forms_widget_1_select_2");
        if (e) {
          var t = function (e) {
            if (!e.id) return e.text;
            var t = document.createElement("span"),
              a = "";
            return (
              (a +=
                '<img src="' +
                e.element.getAttribute("data-kt-select2-icon") +
                '" class="rounded-circle h-20px me-2" alt="image"/>'),
              (a += e.text),
              (t.innerHTML = a),
              $(t)
            );
          };
          $(e).select2({
            placeholder: "Select coin",
            minimumResultsForSearch: 1 / 0,
            templateSelection: t,
            templateResult: t,
          });
        }
      })();
  },
};
"undefined" != typeof module && (module.exports = KTFormsWidget1),
  KTUtil.onDOMContentLoaded(function () {
    KTFormsWidget1.init();
  });
var KTTimelineWidget24 = {
  init: function () {
    var e;
    (e = document.querySelector("#kt_list_widget_24")) &&
      KTUtil.on(e, '[data-kt-element="follow"]', "click", function (e) {
        "Following" === this.innerText
          ? ((this.innerText = "Follow"),
            this.classList.add("btn-light-primary"),
            this.classList.remove("btn-primary"),
            this.blur())
          : ((this.innerText = "Following"),
            this.classList.add("btn-primary"),
            this.classList.remove("btn-light-primary"),
            this.blur());
      });
  },
};
"undefined" != typeof module && (module.exports = KTTimelineWidget24),
  KTUtil.onDOMContentLoaded(function () {
    KTTimelineWidget24.init();
  });
var KTPlayersWidget1 = {
  init: function () {
    KTUtil.on(
      document.body,
      '[data-kt-element="list-play-button"]',
      "click",
      function (e) {
        var t = this,
          a = document.querySelector('[data-kt-element="audio-track-1"]'),
          l = this.querySelector('[data-kt-element="list-play-icon"]'),
          r = this.querySelector('[data-kt-element="list-pause-icon"]');
        r.classList.contains("d-none")
          ? (a.play(), l.classList.add("d-none"), r.classList.remove("d-none"))
          : (a.pause(),
            l.classList.remove("d-none"),
            r.classList.add("d-none")),
          [].slice
            .call(
              document.querySelectorAll('[data-kt-element="list-play-button"]')
            )
            .map(function (e) {
              if (e !== t) {
                var a = e.querySelector('[data-kt-element="list-play-icon"]'),
                  l = e.querySelector('[data-kt-element="list-pause-icon"]');
                a.classList.remove("d-none"), l.classList.add("d-none");
              }
            });
      }
    );
  },
};
"undefined" != typeof module && (module.exports = KTPlayersWidget1),
  window.addEventListener("load", function () {
    KTPlayersWidget1.init();
  });
var KTPlayersWidget2 = (function () {
  var e = function () {
    var e = document.getElementById("kt_player_widget_2");
    if (e) {
      var t = e.querySelector('[data-kt-element="audio-track-1"]'),
        a = e.querySelector('[data-kt-element="progress"]'),
        l = e.querySelector('[data-kt-element="current-time"]'),
        r = e.querySelector('[data-kt-element="duration"]'),
        o = e.querySelector('[data-kt-element="play-button"]'),
        i = e.querySelector('[data-kt-element="play-icon"]'),
        s = e.querySelector('[data-kt-element="pause-icon"]'),
        n = e.querySelector('[data-kt-element="replay-button"]'),
        d = e.querySelector('[data-kt-element="shuffle-button"]'),
        m = e.querySelector('[data-kt-element="play-next-button"]'),
        c = e.querySelector('[data-kt-element="play-prev-button"]'),
        g = function (e) {
          var t = parseInt(e % 60);
          return parseInt((e / 60) % 60) + ":" + (t < 10 ? "0" : "") + t;
        };
      r.innerHTML = g(t.duration);
      t.addEventListener("timeupdate", function () {
        (l.innerHTML = g(t.currentTime)),
          (a.value = (t.currentTime / t.duration) * 100),
          this.ended &&
            (i.classList.remove("d-none"), s.classList.add("d-none"));
      }),
        o.addEventListener("click", function () {
          t.duration > 0 && !t.paused
            ? (t.pause(),
              i.classList.remove("d-none"),
              s.classList.add("d-none"))
            : t.readyState >= 2 &&
              (t.play(),
              i.classList.add("d-none"),
              s.classList.remove("d-none"));
        }),
        n.addEventListener("click", function () {
          t.readyState >= 2 &&
            ((t.currentTime = 0),
            t.play(),
            i.classList.add("d-none"),
            s.classList.remove("d-none"));
        }),
        c.addEventListener("click", function () {
          t.readyState >= 2 &&
            ((t.currentTime = 0),
            t.play(),
            i.classList.add("d-none"),
            s.classList.remove("d-none"));
        }),
        m.addEventListener("click", function () {
          t.readyState >= 2 &&
            ((t.currentTime = 0),
            t.play(),
            i.classList.add("d-none"),
            s.classList.remove("d-none"));
        }),
        d.addEventListener("click", function () {
          t.readyState >= 2 &&
            ((t.currentTime = 0),
            t.play(),
            i.classList.add("d-none"),
            s.classList.remove("d-none"));
        }),
        a.addEventListener("change", function () {
          (t.currentTime = a.value),
            i.classList.add("d-none"),
            s.classList.remove("d-none"),
            t.play();
        });
    }
  };
  return {
    init: function () {
      e();
    },
  };
})();
"undefined" != typeof module && (module.exports = KTPlayersWidget2),
  window.addEventListener("load", function () {
    KTPlayersWidget2.init();
  });
var KTMapsWidget1 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.getElementById("kt_maps_widget_1_map");
        if (e) {
          var t,
            a = function () {
              (t = am5.Root.new(e)).setThemes([am5themes_Animated.new(t)]);
              var a = t.container.children.push(
                  am5map.MapChart.new(t, {
                    panX: "translateX",
                    panY: "translateY",
                    projection: am5map.geoMercator(),
                    paddingLeft: 0,
                    paddingrIGHT: 0,
                    paddingBottom: 0,
                  })
                ),
                l = a.series.push(
                  am5map.MapPolygonSeries.new(t, {
                    geoJSON: am5geodata_worldLow,
                    exclude: ["AQ"],
                  })
                );
              l.mapPolygons.template.setAll({
                tooltipText: "{name}",
                toggleKey: "active",
                interactive: !0,
                fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-300")),
              }),
                l.mapPolygons.template.states.create("hover", {
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                }),
                l.mapPolygons.template.states.create("active", {
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                });
              var r = a.series.push(
                am5map.MapPolygonSeries.new(t, {
                  geoJSON: am5geodata_worldLow,
                  include: ["US", "BR", "DE", "AU", "JP"],
                })
              );
              r.mapPolygons.template.setAll({
                tooltipText: "{name}",
                toggleKey: "active",
                interactive: !0,
              }),
                am5.ColorSet.new(t, {}),
                r.mapPolygons.template.set(
                  "fill",
                  am5.color(KTUtil.getCssVariableValue("--bs-primary"))
                ),
                r.mapPolygons.template.states.create("hover", {
                  fill: t.interfaceColors.get("primaryButtonHover"),
                }),
                r.mapPolygons.template.states.create("active", {
                  fill: t.interfaceColors.get("primaryButtonHover"),
                }),
                a.chartContainer
                  .get("background")
                  .events.on("click", function () {
                    a.goHome();
                  }),
                a.appear(1e3, 100);
            };
          am5.ready(function () {
            a();
          }),
            KTThemeMode.on("kt.thememode.change", function () {
              t.dispose(), a();
            });
        }
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTMapsWidget1),
  KTUtil.onDOMContentLoaded(function () {
    KTMapsWidget1.init();
  });
var KTMapsWidget2 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.getElementById("kt_maps_widget_2_map");
        if (e) {
          var t,
            a = function () {
              (t = am5.Root.new(e)).setThemes([am5themes_Animated.new(t)]);
              var a = t.container.children.push(
                  am5map.MapChart.new(t, {
                    panX: "translateX",
                    panY: "translateY",
                    projection: am5map.geoMercator(),
                    paddingLeft: 0,
                    paddingrIGHT: 0,
                    paddingBottom: 0,
                  })
                ),
                l = a.series.push(
                  am5map.MapPolygonSeries.new(t, {
                    geoJSON: am5geodata_worldLow,
                    exclude: ["AQ"],
                  })
                );
              l.mapPolygons.template.setAll({
                tooltipText: "{name}",
                toggleKey: "active",
                interactive: !0,
                fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-300")),
              }),
                l.mapPolygons.template.states.create("hover", {
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                }),
                l.mapPolygons.template.states.create("active", {
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                });
              var r = a.series.push(
                am5map.MapPolygonSeries.new(t, {
                  geoJSON: am5geodata_worldLow,
                  include: ["US", "BR", "DE", "AU", "JP"],
                })
              );
              r.mapPolygons.template.setAll({
                tooltipText: "{name}",
                toggleKey: "active",
                interactive: !0,
              }),
                am5.ColorSet.new(t, {}),
                r.mapPolygons.template.set(
                  "fill",
                  am5.color(KTUtil.getCssVariableValue("--bs-primary"))
                ),
                r.mapPolygons.template.states.create("hover", {
                  fill: t.interfaceColors.get("primaryButtonHover"),
                }),
                r.mapPolygons.template.states.create("active", {
                  fill: t.interfaceColors.get("primaryButtonHover"),
                }),
                a.chartContainer
                  .get("background")
                  .events.on("click", function () {
                    a.goHome();
                  }),
                a.appear(1e3, 100);
            };
          am5.ready(function () {
            a();
          }),
            KTThemeMode.on("kt.thememode.change", function () {
              t.dispose(), a();
            });
        }
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTMapsWidget2),
  KTUtil.onDOMContentLoaded(function () {
    KTMapsWidget2.init();
  });
var KTTablesWidget14 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = { self: null, rendered: !1 },
    l = { self: null, rendered: !1 },
    r = { self: null, rendered: !1 },
    o = function (e, t, a, l) {
      var r = document.querySelector(t);
      if (r) {
        var o = parseInt(KTUtil.css(r, "height")),
          i = r.getAttribute("data-kt-chart-color"),
          s = KTUtil.getCssVariableValue("--bs-gray-300"),
          n = KTUtil.getCssVariableValue("--bs-" + i),
          d = KTUtil.getCssVariableValue("--bs-body-bg"),
          m = {
            series: [{ name: "Net Profit", data: a }],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: o,
              toolbar: { show: !1 },
              zoom: { enabled: !1 },
              sparkline: { enabled: !0 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: { type: "solid", opacity: 1 },
            stroke: { curve: "smooth", show: !0, width: 2, colors: [n] },
            xaxis: {
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { show: !1 },
              crosshairs: {
                show: !1,
                position: "front",
                stroke: { color: s, width: 1, dashArray: 3 },
              },
              tooltip: { enabled: !1 },
            },
            yaxis: { min: 0, max: 60, labels: { show: !1 } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: { enabled: !1 },
            colors: [d],
            markers: { colors: [d], strokeColor: [n], strokeWidth: 3 },
          };
        (e.self = new ApexCharts(r, m)),
          !0 === l &&
            setTimeout(function () {
              e.self.render(), (e.rendered = !0);
            }, 200);
      }
    };
  return {
    init: function () {
      var i = [7, 10, 5, 21, 6, 11, 5, 23, 5, 11, 18, 7, 21, 13];
      o(e, "#kt_table_widget_14_chart_1", i, !0);
      var s = [17, 5, 23, 2, 21, 9, 17, 23, 4, 24, 9, 17, 21, 7];
      o(t, "#kt_table_widget_14_chart_2", s, !0);
      var n = [2, 24, 5, 17, 7, 2, 12, 24, 5, 24, 2, 8, 12, 7];
      o(a, "#kt_table_widget_14_chart_3", n, !0);
      var d = [24, 3, 5, 19, 3, 7, 25, 14, 5, 14, 2, 8, 5, 17];
      o(l, "#kt_table_widget_14_chart_4", d, !0);
      var m = [3, 23, 1, 19, 3, 17, 3, 9, 25, 4, 2, 18, 25, 3];
      o(r, "#kt_table_widget_14_chart_5", m, !0),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(),
            t.rendered && t.self.destroy(),
            a.rendered && a.self.destroy(),
            l.rendered && l.self.destroy(),
            r.rendered && r.self.destroy(),
            o(e, "#kt_table_widget_14_chart_1", i, e.rendered),
            o(t, "#kt_table_widget_14_chart_2", s, t.rendered),
            o(a, "#kt_table_widget_14_chart_3", n, a.rendered),
            o(l, "#kt_table_widget_14_chart_4", d, l.rendered),
            o(r, "#kt_table_widget_14_chart_5", m, r.rendered);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTTablesWidget14),
  KTUtil.onDOMContentLoaded(function () {
    KTTablesWidget14.init();
  });
var KTTablesWidget15 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = { self: null, rendered: !1 },
    l = { self: null, rendered: !1 },
    r = { self: null, rendered: !1 },
    o = function (e, t, a, l) {
      var r = document.querySelector(t);
      if (r) {
        var o = parseInt(KTUtil.css(r, "height")),
          i = r.getAttribute("data-kt-chart-color"),
          s = KTUtil.getCssVariableValue("--bs-gray-300"),
          n = KTUtil.getCssVariableValue("--bs-" + i),
          d = KTUtil.getCssVariableValue("--bs-body-bg"),
          m = {
            series: [{ name: "Net Profit", data: a }],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: o,
              toolbar: { show: !1 },
              zoom: { enabled: !1 },
              sparkline: { enabled: !0 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: { type: "solid", opacity: 1 },
            stroke: { curve: "smooth", show: !0, width: 2, colors: [n] },
            xaxis: {
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { show: !1 },
              crosshairs: {
                show: !1,
                position: "front",
                stroke: { color: s, width: 1, dashArray: 3 },
              },
              tooltip: { enabled: !1 },
            },
            yaxis: { min: 0, max: 60, labels: { show: !1, ontSize: "12px" } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: { enabled: !1 },
            colors: [d],
            markers: { colors: [d], strokeColor: [n], strokeWidth: 3 },
          };
        (e.self = new ApexCharts(r, m)),
          !0 === l &&
            setTimeout(function () {
              e.self.render(), (e.rendered = !0);
            }, 200);
      }
    };
  return {
    init: function () {
      var i = [7, 10, 5, 21, 6, 11, 5, 23, 5, 11, 18, 7, 21, 13];
      o(e, "#kt_table_widget_15_chart_1", i, !0);
      var s = [17, 5, 23, 2, 21, 9, 17, 23, 4, 24, 9, 17, 21, 7];
      o(t, "#kt_table_widget_15_chart_2", s, !0);
      var n = [2, 24, 5, 17, 7, 2, 12, 24, 5, 24, 2, 8, 12, 7];
      o(a, "#kt_table_widget_15_chart_3", n, !0);
      var d = [24, 3, 5, 19, 3, 7, 25, 14, 5, 14, 2, 8, 5, 17];
      o(l, "#kt_table_widget_15_chart_4", d, !0);
      var m = [3, 23, 1, 19, 3, 17, 3, 9, 25, 4, 2, 18, 25, 3];
      o(r, "#kt_table_widget_15_chart_5", m, !0),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(),
            t.rendered && t.self.destroy(),
            a.rendered && a.self.destroy(),
            l.rendered && l.self.destroy(),
            r.rendered && r.self.destroy(),
            o(e, "#kt_table_widget_15_chart_1", i, e.rendered),
            o(t, "#kt_table_widget_15_chart_2", s, t.rendered),
            o(a, "#kt_table_widget_15_chart_3", n, a.rendered),
            o(l, "#kt_table_widget_15_chart_4", d, l.rendered),
            o(r, "#kt_table_widget_15_chart_5", m, r.rendered);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTTablesWidget15),
  KTUtil.onDOMContentLoaded(function () {
    KTTablesWidget15.init();
  });
var KTTablesWidget16 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = { self: null, rendered: !1 },
    l = { self: null, rendered: !1 },
    r = { self: null, rendered: !1 },
    o = { self: null, rendered: !1 },
    i = { self: null, rendered: !1 },
    s = { self: null, rendered: !1 },
    n = { self: null, rendered: !1 },
    d = { self: null, rendered: !1 },
    m = { self: null, rendered: !1 },
    c = { self: null, rendered: !1 },
    g = { self: null, rendered: !1 },
    f = { self: null, rendered: !1 },
    u = { self: null, rendered: !1 },
    h = { self: null, rendered: !1 },
    p = { self: null, rendered: !1 },
    y = { self: null, rendered: !1 },
    _ = { self: null, rendered: !1 },
    b = { self: null, rendered: !1 },
    v = function (e, t, a, l, r) {
      var o = document.querySelector(a);
      if (o) {
        var i = parseInt(KTUtil.css(o, "height")),
          s = o.getAttribute("data-kt-chart-color"),
          n =
            (KTUtil.getCssVariableValue("--bs-gray-800"),
            KTUtil.getCssVariableValue("--bs-gray-300")),
          d = KTUtil.getCssVariableValue("--bs-" + s),
          m = KTUtil.getCssVariableValue("--bs-body-bg"),
          c = {
            series: [{ name: "Net Profit", data: l }],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: i,
              toolbar: { show: !1 },
              zoom: { enabled: !1 },
              sparkline: { enabled: !0 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: { type: "solid", opacity: 1 },
            stroke: { curve: "smooth", show: !0, width: 2, colors: [d] },
            xaxis: {
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { show: !1 },
              crosshairs: {
                show: !1,
                position: "front",
                stroke: { color: n, width: 1, dashArray: 3 },
              },
              tooltip: { enabled: !1 },
            },
            yaxis: { min: 0, max: 60, labels: { show: !1, ontSize: "12px" } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: { enabled: !1 },
            colors: [m],
            markers: { colors: [m], strokeColor: [d], strokeWidth: 3 },
          };
        e.self = new ApexCharts(o, c);
        var g = document.querySelector(t);
        !0 === r &&
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200),
          g.addEventListener("shown.bs.tab", function (t) {
            !1 === e.rendered && (e.self.render(), (e.rendered = !0));
          });
      }
    };
  return {
    init: function () {
      var w = [16, 10, 15, 21, 6, 11, 5, 23, 5, 11, 18, 7, 21, 13];
      v(
        e,
        "#kt_stats_widget_16_tab_link_1",
        "#kt_table_widget_16_chart_1_1",
        w,
        !0
      );
      var T = [8, 5, 16, 3, 23, 16, 11, 15, 3, 11, 15, 7, 17, 9];
      v(
        t,
        "#kt_stats_widget_16_tab_link_1",
        "#kt_table_widget_16_chart_1_2",
        T,
        !0
      );
      var k = [8, 6, 16, 3, 23, 16, 11, 14, 3, 11, 15, 8, 17, 9];
      v(
        a,
        "#kt_stats_widget_16_tab_link_1",
        "#kt_table_widget_16_chart_1_3",
        k,
        !0
      );
      var x = [12, 5, 23, 12, 21, 9, 17, 20, 4, 24, 9, 13, 18, 9];
      v(
        l,
        "#kt_stats_widget_16_tab_link_1",
        "#kt_table_widget_16_chart_1_4",
        x,
        !0
      );
      var A = [13, 10, 15, 21, 6, 11, 5, 21, 5, 12, 18, 7, 21, 13];
      v(
        r,
        "#kt_stats_widget_16_tab_link_2",
        "#kt_table_widget_16_chart_2_1",
        A,
        !1
      );
      var C = [13, 5, 21, 12, 21, 9, 17, 20, 4, 23, 9, 17, 21, 7];
      v(
        o,
        "#kt_stats_widget_16_tab_link_2",
        "#kt_table_widget_16_chart_2_2",
        C,
        !1
      );
      var K = [8, 10, 14, 21, 6, 31, 5, 21, 5, 11, 15, 7, 23, 13];
      v(
        i,
        "#kt_stats_widget_16_tab_link_2",
        "#kt_table_widget_16_chart_2_3",
        K,
        !1
      );
      var V = [6, 10, 12, 21, 6, 11, 7, 23, 5, 12, 18, 7, 21, 15];
      v(
        s,
        "#kt_stats_widget_16_tab_link_2",
        "#kt_table_widget_16_chart_2_4",
        V,
        !1
      );
      var S = [7, 10, 5, 21, 6, 11, 5, 23, 5, 11, 18, 7, 21, 13];
      v(
        n,
        "#kt_stats_widget_16_tab_link_3",
        "#kt_table_widget_16_chart_3_1",
        S,
        !1
      );
      var U = [8, 5, 16, 2, 19, 9, 17, 21, 4, 24, 4, 13, 21, 5];
      v(
        d,
        "#kt_stats_widget_16_tab_link_3",
        "#kt_table_widget_16_chart_3_2",
        U,
        !1
      );
      var M = [15, 10, 12, 21, 6, 11, 23, 11, 5, 12, 18, 7, 21, 15];
      v(
        m,
        "#kt_stats_widget_16_tab_link_3",
        "#kt_table_widget_16_chart_3_3",
        M,
        !1
      );
      var W = [3, 9, 12, 23, 6, 11, 7, 23, 5, 12, 14, 7, 21, 8];
      v(
        c,
        "#kt_stats_widget_16_tab_link_3",
        "#kt_table_widget_16_chart_3_4",
        W,
        !1
      );
      var L = [9, 14, 15, 21, 8, 11, 5, 23, 5, 11, 18, 5, 23, 8];
      v(
        g,
        "#kt_stats_widget_16_tab_link_4",
        "#kt_table_widget_16_chart_4_1",
        L,
        !1
      );
      var z = [7, 5, 23, 12, 21, 9, 17, 15, 4, 24, 9, 17, 21, 7];
      v(
        f,
        "#kt_stats_widget_16_tab_link_4",
        "#kt_table_widget_16_chart_4_2",
        z,
        !1
      );
      var D = [8, 10, 14, 21, 6, 31, 8, 23, 5, 3, 14, 7, 21, 12];
      v(
        u,
        "#kt_stats_widget_16_tab_link_4",
        "#kt_table_widget_16_chart_4_3",
        D,
        !1
      );
      var O = [6, 12, 12, 19, 6, 11, 7, 23, 5, 12, 18, 7, 21, 15];
      v(
        h,
        "#kt_stats_widget_16_tab_link_4",
        "#kt_table_widget_16_chart_4_4",
        O,
        !1
      );
      var F = [5, 10, 15, 21, 6, 11, 5, 23, 5, 11, 17, 7, 21, 13];
      v(
        p,
        "#kt_stats_widget_16_tab_link_5",
        "#kt_table_widget_16_chart_5_1",
        F,
        !1
      );
      var I = [4, 5, 23, 12, 21, 9, 17, 15, 4, 24, 9, 17, 21, 7];
      v(
        y,
        "#kt_stats_widget_16_tab_link_5",
        "#kt_table_widget_16_chart_5_2",
        I,
        !1
      );
      var P = [7, 10, 14, 21, 6, 31, 5, 23, 5, 11, 15, 7, 21, 17];
      v(
        _,
        "#kt_stats_widget_16_tab_link_5",
        "#kt_table_widget_16_chart_5_3",
        P,
        !1
      );
      var R = [3, 10, 12, 23, 6, 11, 7, 22, 5, 12, 18, 7, 21, 14];
      v(
        b,
        "#kt_stats_widget_16_tab_link_5",
        "#kt_table_widget_16_chart_5_4",
        R,
        !1
      ),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(),
            t.rendered && t.self.destroy(),
            a.rendered && a.self.destroy(),
            l.rendered && l.self.destroy(),
            r.rendered && r.self.destroy(),
            o.rendered && o.self.destroy(),
            i.rendered && i.self.destroy(),
            s.rendered && s.self.destroy(),
            n.rendered && n.self.destroy(),
            d.rendered && d.self.destroy(),
            m.rendered && m.self.destroy(),
            c.rendered && c.self.destroy(),
            g.rendered && g.self.destroy(),
            f.rendered && f.self.destroy(),
            u.rendered && u.self.destroy(),
            h.rendered && h.self.destroy(),
            p.rendered && p.self.destroy(),
            y.rendered && y.self.destroy(),
            _.rendered && _.self.destroy(),
            b.rendered && b.self.destroy(),
            v(
              e,
              "#kt_stats_widget_16_tab_link_1",
              "#kt_table_widget_16_chart_1_1",
              w,
              e.rendered
            ),
            v(
              t,
              "#kt_stats_widget_16_tab_link_1",
              "#kt_table_widget_16_chart_1_2",
              T,
              t.rendered
            ),
            v(
              a,
              "#kt_stats_widget_16_tab_link_1",
              "#kt_table_widget_16_chart_1_3",
              k,
              a.rendered
            ),
            v(
              l,
              "#kt_stats_widget_16_tab_link_1",
              "#kt_table_widget_16_chart_1_4",
              x,
              l.rendered
            ),
            v(
              r,
              "#kt_stats_widget_16_tab_link_2",
              "#kt_table_widget_16_chart_2_1",
              A,
              r.rendered
            ),
            v(
              o,
              "#kt_stats_widget_16_tab_link_2",
              "#kt_table_widget_16_chart_2_2",
              C,
              o.rendered
            ),
            v(
              i,
              "#kt_stats_widget_16_tab_link_2",
              "#kt_table_widget_16_chart_2_3",
              K,
              i.rendered
            ),
            v(
              s,
              "#kt_stats_widget_16_tab_link_2",
              "#kt_table_widget_16_chart_2_4",
              V,
              s.rendered
            ),
            v(
              n,
              "#kt_stats_widget_16_tab_link_3",
              "#kt_table_widget_16_chart_3_1",
              S,
              n.rendered
            ),
            v(
              d,
              "#kt_stats_widget_16_tab_link_3",
              "#kt_table_widget_16_chart_3_2",
              U,
              d.rendered
            ),
            v(
              m,
              "#kt_stats_widget_16_tab_link_3",
              "#kt_table_widget_16_chart_3_3",
              M,
              m.rendered
            ),
            v(
              c,
              "#kt_stats_widget_16_tab_link_3",
              "#kt_table_widget_16_chart_3_4",
              W,
              c.rendered
            ),
            v(
              g,
              "#kt_stats_widget_16_tab_link_4",
              "#kt_table_widget_16_chart_4_1",
              L,
              g.rendered
            ),
            v(
              f,
              "#kt_stats_widget_16_tab_link_4",
              "#kt_table_widget_16_chart_4_2",
              z,
              f.rendered
            ),
            v(
              u,
              "#kt_stats_widget_16_tab_link_4",
              "#kt_table_widget_16_chart_4_3",
              D,
              u.rendered
            ),
            v(
              h,
              "#kt_stats_widget_16_tab_link_4",
              "#kt_table_widget_16_chart_4_4",
              O,
              h.rendered
            ),
            v(
              p,
              "#kt_stats_widget_16_tab_link_5",
              "#kt_table_widget_16_chart_5_1",
              F,
              p.rendered
            ),
            v(
              y,
              "#kt_stats_widget_16_tab_link_5",
              "#kt_table_widget_16_chart_5_2",
              I,
              y.rendered
            ),
            v(
              _,
              "#kt_stats_widget_16_tab_link_5",
              "#kt_table_widget_16_chart_5_3",
              P,
              _.rendered
            ),
            v(
              b,
              "#kt_stats_widget_16_tab_link_5",
              "#kt_table_widget_16_chart_5_4",
              R,
              b.rendered
            );
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTTablesWidget16),
  KTUtil.onDOMContentLoaded(function () {
    KTTablesWidget16.init();
  });
var KTTablesWidget3 = (function () {
  var e, t;
  const a = () => {
    const e = document.querySelector(
      '[data-kt-table-widget-3="filter_status"]'
    );
    $(e).on("select2:select", function (e) {
      const a = $(this).val();
      "Show All" === a ? t.search("").draw() : t.search(a).draw();
    });
  };
  return {
    init: function () {
      (e = document.querySelector("#kt_widget_table_3")) &&
        ((t = $(e).DataTable({
          info: !1,
          order: [],
          paging: !1,
          pageLength: !1,
        })),
        (() => {
          const e = document
              .querySelector('[data-kt-table-widget-3="tabs_nav"]')
              .querySelectorAll('[data-kt-table-widget-3="tab"]'),
            a = ["border-bottom", "border-3", "border-primary"];
          e.forEach((l) => {
            l.addEventListener("click", (r) => {
              const o = l.getAttribute("data-kt-table-widget-3-value");
              e.forEach((e) => {
                e.classList.remove(...a), e.classList.add("text-muted");
              }),
                l.classList.remove("text-muted"),
                l.classList.add(...a),
                "Show All" === o ? t.search("").draw() : t.search(o).draw();
            });
          });
        })(),
        a());
    },
  };
})();
"undefined" != typeof module && (module.exports = KTTablesWidget3),
  KTUtil.onDOMContentLoaded(function () {
    KTTablesWidget3.init();
  });
var KTTablesWidget4 = (function () {
  var e, t, a;
  const l = () => {
      const e = document.querySelector(
        '[data-kt-table-widget-4="filter_status"]'
      );
      $(e).on("select2:select", function (e) {
        const a = $(this).val();
        "Show All" === a ? t.search("").draw() : t.search(a).draw();
      });
    },
    r = [
      {
        image: "76",
        name: "Go Pro 8",
        description: "Latest  version of Go Pro.",
        cost: "500.00",
        qty: "1",
        total: "500.00",
        stock: "12",
      },
      {
        image: "60",
        name: "Bose Earbuds",
        description: "Top quality earbuds from Bose.",
        cost: "300.00",
        qty: "1",
        total: "300.00",
        stock: "8",
      },
      {
        image: "211",
        name: "Dry-fit Sports T-shirt",
        description: "Comfortable sportswear.",
        cost: "89.00",
        qty: "1",
        total: "89.00",
        stock: "18",
      },
      {
        image: "21",
        name: "Apple Airpod 3",
        description: "Apple's latest earbuds.",
        cost: "200.00",
        qty: "2",
        total: "400.00",
        stock: "32",
      },
      {
        image: "83",
        name: "Nike Pumps",
        description: "Apple's latest headphones.",
        cost: "200.00",
        qty: "1",
        total: "200.00",
        stock: "8",
      },
    ],
    o = () => {
      const e = document.querySelectorAll(
          '[data-kt-table-widget-4="expand_row"]'
        ),
        t = [3, 1, 3, 1, 2, 1];
      e.forEach((e, a) => {
        e.addEventListener("click", (l) => {
          l.stopImmediatePropagation(), l.preventDefault();
          const o = e.closest("tr"),
            s = ["isOpen", "border-bottom-0"],
            n = [];
          for (var d = 0; d < t[a]; d++) n.push(r[d]);
          if (o.classList.contains("isOpen")) {
            for (
              ;
              o.nextSibling &&
              "subtable_template" ===
                o.nextSibling.getAttribute("data-kt-table-widget-4");

            )
              o.nextSibling.parentNode.removeChild(o.nextSibling);
            o.classList.remove(...s), e.classList.remove("active");
          } else i(n, o), o.classList.add(...s), e.classList.add("active");
        });
      });
    },
    i = (t, l) => {
      t.forEach((r, o) => {
        const i = a.cloneNode(!0),
          s = i.querySelector('[data-kt-table-widget-4="template_image"]'),
          n = i.querySelector('[data-kt-table-widget-4="template_name"]'),
          d = i.querySelector(
            '[data-kt-table-widget-4="template_description"]'
          ),
          m = i.querySelector('[data-kt-table-widget-4="template_cost"]'),
          c = i.querySelector('[data-kt-table-widget-4="template_qty"]'),
          g = i.querySelector('[data-kt-table-widget-4="template_total"]'),
          f = i.querySelector('[data-kt-table-widget-4="template_stock"]'),
          u = s.getAttribute("data-kt-src-path");
        s.setAttribute("src", u + r.image + ".png"),
          (n.innerText = r.name),
          (d.innerText = r.description),
          (m.innerText = r.cost),
          (c.innerText = r.qty),
          (g.innerText = r.total),
          r.stock > 10
            ? (f.innerHTML =
                '<div class="badge badge-light-success">In Stock</div>')
            : (f.innerHTML =
                '<div class="badge badge-light-warning">Low Stock</div>'),
          1 === t.length || t.length;
        e.querySelector("tbody").insertBefore(i, l.nextSibling);
      });
    },
    s = () => {
      document
        .querySelectorAll('[data-kt-table-widget-4="subtable_template"]')
        .forEach((e) => {
          e.parentNode.removeChild(e);
        });
      e.querySelectorAll("tbody tr").forEach((e) => {
        e.classList.remove("isOpen"),
          e.querySelector('[data-kt-table-widget-4="expand_row"]') &&
            e
              .querySelector('[data-kt-table-widget-4="expand_row"]')
              .classList.remove("active");
      });
    };
  return {
    init: function () {
      (e = document.querySelector("#kt_table_widget_4_table")) &&
        ((() => {
          const l = document.querySelector(
            '[data-kt-table-widget-4="subtable_template"]'
          );
          (a = l.cloneNode(!0)).classList.remove("d-none"),
            l.parentNode.removeChild(l),
            (t = $(e).DataTable({
              info: !1,
              order: [],
              lengthChange: !1,
              pageLength: 6,
              ordering: !1,
              paging: !1,
              columnDefs: [
                { orderable: !1, targets: 0 },
                { orderable: !1, targets: 6 },
              ],
            })).on("draw", function () {
              s(), o();
            });
        })(),
        document
          .querySelector('[data-kt-table-widget-4="search"]')
          .addEventListener("keyup", function (e) {
            t.search(e.target.value).draw();
          }),
        l(),
        o());
    },
  };
})();
"undefined" != typeof module && (module.exports = KTTablesWidget4),
  KTUtil.onDOMContentLoaded(function () {
    KTTablesWidget4.init();
  });
var KTTablesWidget5 = (function () {
  var e, t;
  const a = () => {
    const e = document.querySelector(
      '[data-kt-table-widget-5="filter_status"]'
    );
    $(e).on("select2:select", function (e) {
      const a = $(this).val();
      "Show All" === a ? t.search("").draw() : t.search(a).draw();
    });
  };
  return {
    init: function () {
      (e = document.querySelector("#kt_table_widget_5_table")) &&
        (e.querySelectorAll("tbody tr").forEach((e) => {
          const t = e.querySelectorAll("td"),
            a = moment(t[2].innerHTML, "MMM DD, YYYY").format();
          t[2].setAttribute("data-order", a);
        }),
        (t = $(e).DataTable({
          info: !1,
          order: [],
          lengthChange: !1,
          pageLength: 6,
          paging: !1,
          columnDefs: [{ orderable: !1, targets: 1 }],
        })),
        a());
    },
  };
})();
"undefined" != typeof module && (module.exports = KTTablesWidget5),
  KTUtil.onDOMContentLoaded(function () {
    KTTablesWidget5.init();
  });
var KTSlidersWidget1 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = { self: null, rendered: !1 },
    l = function (e, t, a) {
      var l = document.querySelector(t);
      if (l && (!0 !== e.rendered || !l.classList.contains("initialized"))) {
        var r = parseInt(KTUtil.css(l, "height")),
          o = KTUtil.getCssVariableValue("--bs-primary"),
          i = {
            series: [a],
            chart: {
              fontFamily: "inherit",
              height: r,
              type: "radialBar",
              sparkline: { enabled: !0 },
            },
            plotOptions: {
              radialBar: {
                hollow: { margin: 0, size: "45%" },
                dataLabels: {
                  showOn: "always",
                  name: { show: !1 },
                  value: { show: !1 },
                },
                track: {
                  background: KTUtil.getCssVariableValue("--bs-primary-light"),
                  strokeWidth: "100%",
                },
              },
            },
            colors: [o],
            stroke: { lineCap: "round" },
            labels: ["Progress"],
          };
        (e.self = new ApexCharts(l, i)),
          e.self.render(),
          (e.rendered = !0),
          l.classList.add("initialized");
      }
    };
  return {
    init: function () {
      l(e, "#kt_slider_widget_1_chart_1", 76);
      var r = document.querySelector("#kt_sliders_widget_1_slider");
      r &&
        (r.addEventListener("slid.bs.carousel", function (e) {
          1 === e.to && l(t, "#kt_slider_widget_1_chart_2", 55),
            2 === e.to && l(a, "#kt_slider_widget_1_chart_3", 25);
        }),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && (e.self.destroy(), (e.rendered = !1)),
            t.rendered && (t.self.destroy(), (t.rendered = !1)),
            a.rendered && (a.self.destroy(), (a.rendered = !1)),
            l(e, "#kt_slider_widget_1_chart_1", 76),
            l(t, "#kt_slider_widget_1_chart_2", 55),
            l(a, "#kt_slider_widget_1_chart_3", 25);
        }));
    },
  };
})();
"undefined" != typeof module && (module.exports = KTSlidersWidget1),
  KTUtil.onDOMContentLoaded(function () {
    KTSlidersWidget1.init();
  });
var KTSlidersWidget3 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = function (e, t, a, l) {
      var r = document.querySelector(t);
      if (r && (!0 !== e.rendered || !r.classList.contains("initialized"))) {
        var o = parseInt(KTUtil.css(r, "height")),
          i = KTUtil.getCssVariableValue("--bs-gray-500"),
          s = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          n = KTUtil.getCssVariableValue("--bs-" + a),
          d = {
            series: [{ name: "Lessons", data: l }],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: o,
              toolbar: { show: !1 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0,
                stops: [0, 80, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [n] },
            xaxis: {
              categories: [
                "",
                "Apr 05",
                "Apr 06",
                "Apr 07",
                "Apr 08",
                "Apr 09",
                "Apr 11",
                "Apr 12",
                "Apr 14",
                "Apr 15",
                "Apr 16",
                "Apr 17",
                "Apr 18",
                "",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              tickAmount: 6,
              labels: {
                rotate: 0,
                rotateAlways: !0,
                style: { colors: i, fontSize: "12px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: n, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: {
              tickAmount: 4,
              max: 24,
              min: 10,
              labels: { style: { colors: i, fontSize: "12px" } },
            },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: { style: { fontSize: "12px" } },
            colors: [n],
            grid: {
              borderColor: s,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: n, strokeWidth: 3 },
          };
        (e.self = new ApexCharts(r, d)),
          e.self.render(),
          (e.rendered = !0),
          r.classList.add("initialized");
      }
    };
  return {
    init: function () {
      var l = [19, 21, 21, 20, 20, 18, 18, 20, 20, 22, 22, 21, 21, 22],
        r = [18, 22, 22, 20, 20, 18, 18, 20, 20, 18, 18, 20, 20, 22];
      a(e, "#kt_sliders_widget_3_chart_1", "danger", l);
      var o = document.querySelector("#kt_sliders_widget_3_slider");
      o &&
        (o.addEventListener("slid.bs.carousel", function (e) {
          1 === e.to && a(t, "#kt_sliders_widget_3_chart_2", "primary", r);
        }),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && (e.self.destroy(), (e.rendered = !1)),
            t.rendered && (t.self.destroy(), (t.rendered = !1)),
            a(e, "#kt_sliders_widget_3_chart_1", "danger", l),
            a(t, "#kt_sliders_widget_3_chart_2", "primary", r);
        }));
    },
  };
})();
"undefined" != typeof module && (module.exports = KTSlidersWidget3),
  KTUtil.onDOMContentLoaded(function () {
    KTSlidersWidget3.init();
  });
var KTSlidersWidget7 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = { self: null, rendered: !1 },
    l = function (e, t, a) {
      var l = document.querySelector(t);
      if (l && (!0 !== e.rendered || !l.classList.contains("initialized"))) {
        var r = parseInt(KTUtil.css(l, "height")),
          o = KTUtil.getCssVariableValue("--bs-danger"),
          i = {
            series: [a],
            chart: {
              fontFamily: "inherit",
              height: r,
              type: "radialBar",
              sparkline: { enabled: !0 },
            },
            plotOptions: {
              radialBar: {
                hollow: { margin: 0, size: "45%" },
                dataLabels: {
                  showOn: "always",
                  name: { show: !1 },
                  value: { show: !1 },
                },
                track: {
                  background: KTUtil.getCssVariableValue("--bs-white"),
                  strokeWidth: "100%",
                },
              },
            },
            colors: [o],
            stroke: { lineCap: "round" },
            labels: ["Progress"],
          };
        (e.self = new ApexCharts(l, i)),
          e.self.render(),
          (e.rendered = !0),
          l.classList.add("initialized");
      }
    };
  return {
    init: function () {
      l(e, "#kt_slider_widget_7_chart_1", 76);
      var r = document.querySelector("#kt_sliders_widget_7_slider");
      r &&
        (r.addEventListener("slid.bs.carousel", function (e) {
          1 === e.to && l(t, "#kt_slider_widget_7_chart_2", 55),
            2 === e.to && l(a, "#kt_slider_widget_7_chart_3", 25);
        }),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && (e.self.destroy(), (e.rendered = !1)),
            t.rendered && (t.self.destroy(), (t.rendered = !1)),
            a.rendered && (a.self.destroy(), (a.rendered = !1)),
            l(e, "#kt_slider_widget_7_chart_1", 76),
            l(t, "#kt_slider_widget_7_chart_2", 55),
            l(a, "#kt_slider_widget_7_chart_3", 25);
        }));
    },
  };
})();
"undefined" != typeof module && (module.exports = KTSlidersWidget7),
  KTUtil.onDOMContentLoaded(function () {
    KTSlidersWidget7.init();
  });
var KTChartsWidget1 = (function () {
  var e = { self: null, rendered: !1 },
    t = function () {
      var t = document.getElementById("kt_charts_widget_1");
      if (t) {
        var a = t.hasAttribute("data-kt-negative-color")
            ? t.getAttribute("data-kt-negative-color")
            : KTUtil.getCssVariableValue("--bs-success"),
          l = parseInt(KTUtil.css(t, "height")),
          r = KTUtil.getCssVariableValue("--bs-gray-500"),
          o = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          i = {
            series: [
              {
                name: "Subscribed",
                data: [
                  20, 30, 20, 40, 60, 75, 65, 18, 10, 5, 15, 40, 60, 18, 35, 55,
                  20,
                ],
              },
              {
                name: "Unsubscribed",
                data: [
                  -20, -15, -5, -20, -30, -15, -10, -8, -5, -5, -10, -25, -15,
                  -5, -10, -5, -15,
                ],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "bar",
              stacked: !0,
              height: l,
              toolbar: { show: !1 },
            },
            plotOptions: {
              bar: {
                columnWidth: "35%",
                barHeight: "70%",
                borderRadius: [6, 6],
              },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            xaxis: {
              categories: [
                "Jan 5",
                "Jan 7",
                "Jan 9",
                "Jan 11",
                "Jan 13",
                "Jan 15",
                "Jan 17",
                "Jan 19",
                "Jan 20",
                "Jan 21",
                "Jan 23",
                "Jan 24",
                "Jan 25",
                "Jan 26",
                "Jan 24",
                "Jan 28",
                "Jan 29",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              tickAmount: 10,
              labels: { style: { colors: [r], fontSize: "12px" } },
              crosshairs: { show: !1 },
            },
            yaxis: {
              min: -50,
              max: 80,
              tickAmount: 6,
              labels: {
                style: { colors: [r], fontSize: "12px" },
                formatter: function (e) {
                  return parseInt(e) + "K";
                },
              },
            },
            fill: { opacity: 1 },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px", borderRadius: 4 },
              y: {
                formatter: function (e) {
                  return e > 0 ? e + "K" : Math.abs(e) + "K";
                },
              },
            },
            colors: [KTUtil.getCssVariableValue("--bs-primary"), a],
            grid: {
              borderColor: o,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
          };
        (e.self = new ApexCharts(t, i)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t();
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget1),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget1.init();
  });
var KTChartsWidget10 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = { self: null, rendered: !1 },
    l = { self: null, rendered: !1 },
    r = function (e, t, a, l, r) {
      var o = document.querySelector(a);
      if (o) {
        var i = parseInt(KTUtil.css(o, "height")),
          s = KTUtil.getCssVariableValue("--bs-gray-900"),
          n = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          d = {
            series: [{ name: "Achieved Target", data: l }],
            chart: {
              fontFamily: "inherit",
              type: "bar",
              height: i,
              toolbar: { show: !1 },
            },
            plotOptions: {
              bar: {
                horizontal: !1,
                columnWidth: ["22%"],
                borderRadius: 5,
                dataLabels: { position: "top" },
                startingShape: "flat",
              },
            },
            legend: { show: !1 },
            dataLabels: {
              enabled: !0,
              offsetY: -30,
              style: { fontSize: "13px", colors: [s] },
              formatter: function (e) {
                return e + "K";
              },
            },
            stroke: { show: !0, width: 2, colors: ["transparent"] },
            xaxis: {
              categories: [
                "Metals",
                "Energy",
                "Agro",
                "Machines",
                "Transport",
                "Textile",
                "Wood",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: {
                style: {
                  colors: KTUtil.getCssVariableValue("--bs-gray-500"),
                  fontSize: "13px",
                },
              },
              crosshairs: {
                fill: { gradient: { opacityFrom: 0, opacityTo: 0 } },
              },
            },
            yaxis: {
              labels: {
                style: {
                  colors: KTUtil.getCssVariableValue("--bs-gray-500"),
                  fontSize: "13px",
                },
                formatter: function (e) {
                  return parseInt(e) + "K";
                },
              },
            },
            fill: { opacity: 1 },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return +e + "K";
                },
              },
            },
            colors: [
              KTUtil.getCssVariableValue("--bs-primary"),
              KTUtil.getCssVariableValue("--bs-primary-light"),
            ],
            grid: {
              borderColor: n,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
          };
        e.self = new ApexCharts(o, d);
        var m = document.querySelector(t);
        !0 === r &&
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200),
          m.addEventListener("shown.bs.tab", function (t) {
            !1 === e.rendered && (e.self.render(), (e.rendered = !0));
          });
      }
    };
  return {
    init: function () {
      var o = [30, 18, 43, 70, 13, 37, 23];
      r(e, "#kt_charts_widget_10_tab_1", "#kt_charts_widget_10_chart_1", o, !0);
      var i = [25, 55, 35, 50, 45, 20, 31];
      r(t, "#kt_charts_widget_10_tab_2", "#kt_charts_widget_10_chart_2", i, !1);
      var s = [45, 15, 35, 70, 45, 50, 21];
      r(a, "#kt_charts_widget_10_tab_3", "#kt_charts_widget_10_chart_3", s, !1);
      var n = [15, 55, 25, 50, 25, 60, 31];
      r(l, "#kt_charts_widget_10_tab_4", "#kt_charts_widget_10_chart_4", n, !1),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(),
            t.rendered && t.self.destroy(),
            a.rendered && a.self.destroy(),
            l.rendered && l.self.destroy(),
            r(
              e,
              "#kt_charts_widget_10_tab_1",
              "#kt_charts_widget_10_chart_1",
              o,
              e.rendered
            ),
            r(
              t,
              "#kt_charts_widget_10_tab_2",
              "#kt_charts_widget_10_chart_2",
              i,
              t.rendered
            ),
            r(
              a,
              "#kt_charts_widget_10_tab_3",
              "#kt_charts_widget_10_chart_3",
              s,
              a.rendered
            ),
            r(
              l,
              "#kt_charts_widget_10_tab_4",
              "#kt_charts_widget_10_chart_4",
              n,
              l.rendered
            );
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget10),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget10.init();
  });
var KTChartsWidget11 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = { self: null, rendered: !1 },
    l = function (e, t, a, l, r) {
      var o = document.querySelector(a),
        i = parseInt(KTUtil.css(o, "height"));
      if (o) {
        var s = KTUtil.getCssVariableValue("--bs-gray-500"),
          n = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          d = KTUtil.getCssVariableValue("--bs-success"),
          m = {
            series: [{ name: "Deliveries", data: l }],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: i,
              toolbar: { show: !1 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0,
                stops: [0, 80, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [d] },
            xaxis: {
              categories: [
                "",
                "Apr 02",
                "Apr 06",
                "Apr 06",
                "Apr 05",
                "Apr 06",
                "Apr 10",
                "Apr 08",
                "Apr 09",
                "Apr 14",
                "Apr 10",
                "Apr 12",
                "Apr 18",
                "Apr 14",
                "Apr 15",
                "Apr 14",
                "Apr 17",
                "Apr 18",
                "Apr 02",
                "Apr 06",
                "Apr 18",
                "Apr 05",
                "Apr 06",
                "Apr 10",
                "Apr 08",
                "Apr 22",
                "Apr 14",
                "Apr 11",
                "Apr 12",
                "",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              tickAmount: 5,
              labels: {
                rotate: 0,
                rotateAlways: !0,
                style: { colors: s, fontSize: "13px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: d, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "13px" },
              },
            },
            yaxis: {
              tickAmount: 4,
              max: 24,
              min: 10,
              labels: { style: { colors: s, fontSize: "13px" } },
            },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return +e;
                },
              },
            },
            colors: [d],
            grid: {
              borderColor: n,
              strokeDashArray: 3,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: d, strokeWidth: 3 },
          };
        e.self = new ApexCharts(o, m);
        var c = document.querySelector(t);
        !0 === r &&
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200),
          c.addEventListener("shown.bs.tab", function (t) {
            !1 === e.rendered && (e.self.render(), (e.rendered = !0));
          });
      }
    };
  return {
    init: function () {
      var r = [
        16, 19, 19, 16, 16, 14, 15, 15, 17, 17, 19, 19, 18, 18, 20, 20, 18, 18,
        22, 22, 20, 20, 18, 18, 20, 20, 18, 20, 20, 22,
      ];
      l(e, "#kt_charts_widget_11_tab_1", "#kt_charts_widget_11_chart_1", r, !1);
      var o = [
        18, 18, 20, 20, 18, 18, 22, 22, 20, 20, 18, 18, 20, 20, 18, 18, 20, 20,
        22, 15, 18, 18, 17, 17, 15, 15, 17, 17, 19, 17,
      ];
      l(t, "#kt_charts_widget_11_tab_2", "#kt_charts_widget_11_chart_2", o, !1);
      var i = [
        17, 20, 20, 19, 19, 17, 17, 19, 19, 21, 21, 19, 19, 21, 21, 18, 18, 16,
        17, 17, 19, 19, 21, 21, 19, 19, 17, 17, 18, 18,
      ];
      l(a, "#kt_charts_widget_11_tab_3", "#kt_charts_widget_11_chart_3", i, !0),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(),
            t.rendered && t.self.destroy(),
            a.rendered && a.self.destroy(),
            l(
              e,
              "#kt_charts_widget_11_tab_1",
              "#kt_charts_widget_11_chart_1",
              r,
              e.rendered
            ),
            l(
              t,
              "#kt_charts_widget_11_tab_2",
              "#kt_charts_widget_11_chart_2",
              o,
              t.rendered
            ),
            l(
              a,
              "#kt_charts_widget_11_tab_3",
              "#kt_charts_widget_11_chart_3",
              i,
              a.rendered
            );
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget11),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget11.init();
  });
var KTChartsWidget12 = (function () {
  var e = function (e, t, a, l) {
    var r = document.querySelector(t);
    if (r) {
      var o = parseInt(KTUtil.css(r, "height")),
        i = KTUtil.getCssVariableValue("--bs-gray-900"),
        s = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
        n = {
          series: [{ name: "Deliveries", data: a }],
          chart: {
            fontFamily: "inherit",
            type: "bar",
            height: o,
            toolbar: { show: !1 },
          },
          plotOptions: {
            bar: {
              horizontal: !1,
              columnWidth: ["22%"],
              borderRadius: 5,
              dataLabels: { position: "top" },
              startingShape: "flat",
            },
          },
          legend: { show: !1 },
          dataLabels: {
            enabled: !0,
            offsetY: -28,
            style: { fontSize: "13px", colors: i },
            formatter: function (e) {
              return e + "K";
            },
          },
          stroke: { show: !0, width: 2, colors: ["transparent"] },
          xaxis: {
            categories: [
              "Grossey",
              "Pet Food",
              "Flowers",
              "Restaurant",
              "Kids Toys",
              "Clothing",
              "Still Water",
            ],
            axisBorder: { show: !1 },
            axisTicks: { show: !1 },
            labels: {
              style: {
                colors: KTUtil.getCssVariableValue("--bs-gray-500"),
                fontSize: "13px",
              },
            },
            crosshairs: {
              fill: { gradient: { opacityFrom: 0, opacityTo: 0 } },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: KTUtil.getCssVariableValue("--bs-gray-500"),
                fontSize: "13px",
              },
              formatter: function (e) {
                return e + "K";
              },
            },
          },
          fill: { opacity: 1 },
          states: {
            normal: { filter: { type: "none", value: 0 } },
            hover: { filter: { type: "none", value: 0 } },
            active: {
              allowMultipleDataPointsSelection: !1,
              filter: { type: "none", value: 0 },
            },
          },
          tooltip: {
            style: { fontSize: "12px" },
            y: {
              formatter: function (e) {
                return +e + "K";
              },
            },
          },
          colors: [
            KTUtil.getCssVariableValue("--bs-primary"),
            KTUtil.getCssVariableValue("--bs-primary-light"),
          ],
          grid: {
            borderColor: s,
            strokeDashArray: 4,
            yaxis: { lines: { show: !0 } },
          },
        },
        d = new ApexCharts(r, n),
        m = !1,
        c = document.querySelector(e);
      !0 === l && (d.render(), (m = !0)),
        c.addEventListener("shown.bs.tab", function (e) {
          0 == m && (d.render(), (m = !0));
        });
    }
  };
  return {
    init: function () {
      e(
        "#kt_charts_widget_12_tab_1",
        "#kt_charts_widget_12_chart_1",
        [54, 42, 75, 110, 23, 87, 50],
        !0
      ),
        e(
          "#kt_charts_widget_12_tab_2",
          "#kt_charts_widget_12_chart_2",
          [25, 55, 35, 50, 45, 20, 31],
          !1
        ),
        e(
          "#kt_charts_widget_12_tab_3",
          "#kt_charts_widget_12_chart_3",
          [45, 15, 35, 70, 45, 50, 21],
          !1
        );
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget12),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget12.init();
  });
var KTChartsWidget13 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.getElementById("kt_charts_widget_13_chart");
        if (e) {
          var t,
            a = function () {
              (t = am5.Root.new(e)).setThemes([am5themes_Animated.new(t)]);
              var a = t.container.children.push(
                am5xy.XYChart.new(t, {
                  panX: !0,
                  panY: !0,
                  wheelX: "panX",
                  wheelY: "zoomX",
                })
              );
              a.set(
                "cursor",
                am5xy.XYCursor.new(t, { behavior: "none" })
              ).lineY.set("visible", !1);
              var l = [
                  { year: "2003", cars: 1587, motorcycles: 650, bicycles: 121 },
                  { year: "2004", cars: 1567, motorcycles: 683, bicycles: 146 },
                  { year: "2005", cars: 1617, motorcycles: 691, bicycles: 138 },
                  { year: "2006", cars: 1630, motorcycles: 642, bicycles: 127 },
                  { year: "2007", cars: 1660, motorcycles: 699, bicycles: 105 },
                  { year: "2008", cars: 1683, motorcycles: 721, bicycles: 109 },
                  { year: "2009", cars: 1691, motorcycles: 737, bicycles: 112 },
                  { year: "2010", cars: 1298, motorcycles: 680, bicycles: 101 },
                  { year: "2011", cars: 1275, motorcycles: 664, bicycles: 97 },
                  { year: "2012", cars: 1246, motorcycles: 648, bicycles: 93 },
                  { year: "2013", cars: 1318, motorcycles: 697, bicycles: 111 },
                  { year: "2014", cars: 1213, motorcycles: 633, bicycles: 87 },
                  { year: "2015", cars: 1199, motorcycles: 621, bicycles: 79 },
                  { year: "2016", cars: 1110, motorcycles: 210, bicycles: 81 },
                  { year: "2017", cars: 1165, motorcycles: 232, bicycles: 75 },
                  { year: "2018", cars: 1145, motorcycles: 219, bicycles: 88 },
                  { year: "2019", cars: 1163, motorcycles: 201, bicycles: 82 },
                  { year: "2020", cars: 1180, motorcycles: 285, bicycles: 87 },
                  { year: "2021", cars: 1159, motorcycles: 277, bicycles: 71 },
                ],
                r = a.xAxes.push(
                  am5xy.CategoryAxis.new(t, {
                    categoryField: "year",
                    startLocation: 0.5,
                    endLocation: 0.5,
                    renderer: am5xy.AxisRendererX.new(t, {}),
                    tooltip: am5.Tooltip.new(t, {}),
                  })
                );
              r
                .get("renderer")
                .grid.template.setAll({ disabled: !0, strokeOpacity: 0 }),
                r
                  .get("renderer")
                  .labels.template.setAll({
                    fontWeight: "400",
                    fontSize: 13,
                    fill: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-500")
                    ),
                  }),
                r.data.setAll(l);
              var o = a.yAxes.push(
                am5xy.ValueAxis.new(t, {
                  renderer: am5xy.AxisRendererY.new(t, {}),
                })
              );
              function i(e, i, s) {
                var n = a.series.push(
                  am5xy.LineSeries.new(t, {
                    name: e,
                    xAxis: r,
                    yAxis: o,
                    stacked: !0,
                    valueYField: i,
                    categoryXField: "year",
                    fill: am5.color(s),
                    tooltip: am5.Tooltip.new(t, {
                      pointerOrientation: "horizontal",
                      labelText: "[bold]{name}[/]\n{categoryX}: {valueY}",
                    }),
                  })
                );
                n.fills.template.setAll({ fillOpacity: 0.5, visible: !0 }),
                  n.data.setAll(l),
                  n.appear(1e3);
              }
              o
                .get("renderer")
                .grid.template.setAll({
                  stroke: am5.color(
                    KTUtil.getCssVariableValue("--bs-gray-300")
                  ),
                  strokeWidth: 1,
                  strokeOpacity: 1,
                  strokeDasharray: [3],
                }),
                o
                  .get("renderer")
                  .labels.template.setAll({
                    fontWeight: "400",
                    fontSize: 13,
                    fill: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-500")
                    ),
                  }),
                i("Cars", "cars", KTUtil.getCssVariableValue("--bs-primary")),
                i(
                  "Motorcycles",
                  "motorcycles",
                  KTUtil.getCssVariableValue("--bs-success")
                ),
                i(
                  "Bicycles",
                  "bicycles",
                  KTUtil.getCssVariableValue("--bs-warning")
                ),
                a.set(
                  "scrollbarX",
                  am5.Scrollbar.new(t, {
                    orientation: "horizontal",
                    marginBottom: 25,
                    height: 8,
                  })
                );
              var s = r.makeDataItem({ category: "2016", endCategory: "2021" });
              r.createAxisRange(s),
                s
                  .get("grid")
                  .setAll({
                    stroke: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-200")
                    ),
                    strokeOpacity: 0.5,
                    strokeDasharray: [3],
                  }),
                s
                  .get("axisFill")
                  .setAll({
                    fill: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-200")
                    ),
                    fillOpacity: 0.1,
                  }),
                s
                  .get("label")
                  .setAll({
                    inside: !0,
                    text: "Fines increased",
                    rotation: 90,
                    centerX: am5.p100,
                    centerY: am5.p100,
                    location: 0,
                    paddingBottom: 10,
                    paddingRight: 15,
                  });
              var n = r.makeDataItem({ category: "2021" });
              r.createAxisRange(n),
                n
                  .get("grid")
                  .setAll({
                    stroke: am5.color(
                      KTUtil.getCssVariableValue("--bs-danger")
                    ),
                    strokeOpacity: 1,
                    strokeDasharray: [3],
                  }),
                n
                  .get("label")
                  .setAll({
                    inside: !0,
                    text: "Fee introduced",
                    rotation: 90,
                    centerX: am5.p100,
                    centerY: am5.p100,
                    location: 0,
                    paddingBottom: 10,
                    paddingRight: 15,
                  }),
                a.appear(1e3, 100);
            };
          am5.ready(function () {
            a();
          }),
            KTThemeMode.on("kt.thememode.change", function () {
              t.dispose(), a();
            });
        }
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTChartsWidget13),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget13.init();
  });
var KTChartsWidget14 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.getElementById("kt_charts_widget_14_chart");
        e &&
          am5.ready(function () {
            var t = am5.Root.new(e);
            t.setThemes([am5themes_Animated.new(t)]);
            var a = t.container.children.push(
                am5radar.RadarChart.new(t, {
                  panX: !1,
                  panY: !1,
                  wheelX: "panX",
                  wheelY: "zoomX",
                  innerRadius: am5.percent(20),
                  startAngle: -90,
                  endAngle: 180,
                })
              ),
              l = [
                {
                  category: "Research",
                  value: 80,
                  full: 100,
                  columnSettings: {
                    fillOpacity: 1,
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-info")),
                  },
                },
                {
                  category: "Marketing",
                  value: 35,
                  full: 100,
                  columnSettings: {
                    fillOpacity: 1,
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-danger")),
                  },
                },
                {
                  category: "Distribution",
                  value: 92,
                  full: 100,
                  columnSettings: {
                    fillOpacity: 1,
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-primary")),
                  },
                },
                {
                  category: "Human Resources",
                  value: 68,
                  full: 100,
                  columnSettings: {
                    fillOpacity: 1,
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                  },
                },
              ];
            a.set(
              "cursor",
              am5radar.RadarCursor.new(t, { behavior: "zoomX" })
            ).lineY.set("visible", !1);
            var r = am5radar.AxisRendererCircular.new(t, {});
            r.labels.template.setAll({ radius: 10 }),
              r.grid.template.setAll({ forceHidden: !0 });
            var o = a.xAxes.push(
              am5xy.ValueAxis.new(t, {
                renderer: r,
                min: 0,
                max: 100,
                strictMinMax: !0,
                numberFormat: "#'%'",
                tooltip: am5.Tooltip.new(t, {}),
              })
            );
            o.get("renderer").labels.template.setAll({
              fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
              fontWeight: "500",
              fontSize: 16,
            });
            var i = am5radar.AxisRendererRadial.new(t, { minGridDistance: 20 });
            i.labels.template.setAll({
              centerX: am5.p100,
              fontWeight: "500",
              fontSize: 18,
              fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
              templateField: "columnSettings",
            }),
              i.grid.template.setAll({ forceHidden: !0 });
            var s = a.yAxes.push(
              am5xy.CategoryAxis.new(t, {
                categoryField: "category",
                renderer: i,
              })
            );
            s.data.setAll(l);
            var n = a.series.push(
              am5radar.RadarColumnSeries.new(t, {
                xAxis: o,
                yAxis: s,
                clustered: !1,
                valueXField: "full",
                categoryYField: "category",
                fill: t.interfaceColors.get("alternativeBackground"),
              })
            );
            n.columns.template.setAll({
              width: am5.p100,
              fillOpacity: 0.08,
              strokeOpacity: 0,
              cornerRadius: 20,
            }),
              n.data.setAll(l);
            var d = a.series.push(
              am5radar.RadarColumnSeries.new(t, {
                xAxis: o,
                yAxis: s,
                clustered: !1,
                valueXField: "value",
                categoryYField: "category",
              })
            );
            d.columns.template.setAll({
              width: am5.p100,
              strokeOpacity: 0,
              tooltipText: "{category}: {valueX}%",
              cornerRadius: 20,
              templateField: "columnSettings",
            }),
              d.data.setAll(l),
              n.appear(1e3),
              d.appear(1e3),
              a.appear(1e3, 100);
          });
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTChartsWidget14),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget14.init();
  });
var KTChartsWidget15 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.getElementById("kt_charts_widget_15_chart");
        if (e) {
          var t,
            a = function () {
              (t = am5.Root.new(e)).setThemes([am5themes_Animated.new(t)]);
              var a = t.container.children.push(
                  am5xy.XYChart.new(t, {
                    panX: !1,
                    panY: !1,
                    layout: t.verticalLayout,
                  })
                ),
                l =
                  (a.get("colors"),
                  [
                    {
                      country: "US",
                      visits: 725,
                      icon: "https://www.amcharts.com/wp-content/uploads/flags/united-states.svg",
                      columnSettings: {
                        fill: am5.color(
                          KTUtil.getCssVariableValue("--bs-primary")
                        ),
                      },
                    },
                    {
                      country: "UK",
                      visits: 625,
                      icon: "https://www.amcharts.com/wp-content/uploads/flags/united-kingdom.svg",
                      columnSettings: {
                        fill: am5.color(
                          KTUtil.getCssVariableValue("--bs-primary")
                        ),
                      },
                    },
                    {
                      country: "China",
                      visits: 602,
                      icon: "https://www.amcharts.com/wp-content/uploads/flags/china.svg",
                      columnSettings: {
                        fill: am5.color(
                          KTUtil.getCssVariableValue("--bs-primary")
                        ),
                      },
                    },
                    {
                      country: "Japan",
                      visits: 509,
                      icon: "https://www.amcharts.com/wp-content/uploads/flags/japan.svg",
                      columnSettings: {
                        fill: am5.color(
                          KTUtil.getCssVariableValue("--bs-primary")
                        ),
                      },
                    },
                    {
                      country: "Germany",
                      visits: 322,
                      icon: "https://www.amcharts.com/wp-content/uploads/flags/germany.svg",
                      columnSettings: {
                        fill: am5.color(
                          KTUtil.getCssVariableValue("--bs-primary")
                        ),
                      },
                    },
                    {
                      country: "France",
                      visits: 214,
                      icon: "https://www.amcharts.com/wp-content/uploads/flags/france.svg",
                      columnSettings: {
                        fill: am5.color(
                          KTUtil.getCssVariableValue("--bs-primary")
                        ),
                      },
                    },
                    {
                      country: "India",
                      visits: 204,
                      icon: "https://www.amcharts.com/wp-content/uploads/flags/india.svg",
                      columnSettings: {
                        fill: am5.color(
                          KTUtil.getCssVariableValue("--bs-primary")
                        ),
                      },
                    },
                    {
                      country: "Spain",
                      visits: 200,
                      icon: "https://www.amcharts.com/wp-content/uploads/flags/spain.svg",
                      columnSettings: {
                        fill: am5.color(
                          KTUtil.getCssVariableValue("--bs-primary")
                        ),
                      },
                    },
                    {
                      country: "Italy",
                      visits: 165,
                      icon: "https://www.amcharts.com/wp-content/uploads/flags/italy.svg",
                      columnSettings: {
                        fill: am5.color(
                          KTUtil.getCssVariableValue("--bs-primary")
                        ),
                      },
                    },
                    {
                      country: "Russia",
                      visits: 152,
                      icon: "https://www.amcharts.com/wp-content/uploads/flags/russia.svg",
                      columnSettings: {
                        fill: am5.color(
                          KTUtil.getCssVariableValue("--bs-primary")
                        ),
                      },
                    },
                    {
                      country: "Norway",
                      visits: 125,
                      icon: "https://www.amcharts.com/wp-content/uploads/flags/norway.svg",
                      columnSettings: {
                        fill: am5.color(
                          KTUtil.getCssVariableValue("--bs-primary")
                        ),
                      },
                    },
                    {
                      country: "Canada",
                      visits: 99,
                      icon: "https://www.amcharts.com/wp-content/uploads/flags/canada.svg",
                      columnSettings: {
                        fill: am5.color(
                          KTUtil.getCssVariableValue("--bs-primary")
                        ),
                      },
                    },
                  ]),
                r = a.xAxes.push(
                  am5xy.CategoryAxis.new(t, {
                    categoryField: "country",
                    renderer: am5xy.AxisRendererX.new(t, {
                      minGridDistance: 30,
                    }),
                    bullet: function (e, t, a) {
                      return am5xy.AxisBullet.new(e, {
                        location: 0.5,
                        sprite: am5.Picture.new(e, {
                          width: 24,
                          height: 24,
                          centerY: am5.p50,
                          centerX: am5.p50,
                          src: a.dataContext.icon,
                        }),
                      });
                    },
                  })
                );
              r
                .get("renderer")
                .labels.template.setAll({
                  paddingTop: 20,
                  fontWeight: "400",
                  fontSize: 10,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
                }),
                r
                  .get("renderer")
                  .grid.template.setAll({ disabled: !0, strokeOpacity: 0 }),
                r.data.setAll(l);
              var o = a.yAxes.push(
                am5xy.ValueAxis.new(t, {
                  renderer: am5xy.AxisRendererY.new(t, {}),
                })
              );
              o
                .get("renderer")
                .grid.template.setAll({
                  stroke: am5.color(
                    KTUtil.getCssVariableValue("--bs-gray-300")
                  ),
                  strokeWidth: 1,
                  strokeOpacity: 1,
                  strokeDasharray: [3],
                }),
                o
                  .get("renderer")
                  .labels.template.setAll({
                    fontWeight: "400",
                    fontSize: 10,
                    fill: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-500")
                    ),
                  });
              var i = a.series.push(
                am5xy.ColumnSeries.new(t, {
                  xAxis: r,
                  yAxis: o,
                  valueYField: "visits",
                  categoryXField: "country",
                })
              );
              i.columns.template.setAll({
                tooltipText: "{categoryX}: {valueY}",
                tooltipY: 0,
                strokeOpacity: 0,
                templateField: "columnSettings",
              }),
                i.columns.template.setAll({
                  strokeOpacity: 0,
                  cornerRadiusBR: 0,
                  cornerRadiusTR: 6,
                  cornerRadiusBL: 0,
                  cornerRadiusTL: 6,
                }),
                i.data.setAll(l),
                i.appear(),
                a.appear(1e3, 100);
            };
          am5.ready(function () {
            a();
          }),
            KTThemeMode.on("kt.thememode.change", function () {
              t.dispose(), a();
            });
        }
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTChartsWidget15),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget15.init();
  });
var KTChartsWidget16 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.getElementById("kt_charts_widget_16_chart");
        if (e) {
          var t,
            a = function () {
              (t = am5.Root.new(e)).setThemes([am5themes_Animated.new(t)]);
              var a = t.container.children.push(
                  am5xy.XYChart.new(t, {
                    panX: !1,
                    panY: !1,
                    wheelX: "panX",
                    wheelY: "zoomX",
                    layout: t.verticalLayout,
                  })
                ),
                l =
                  (a.get("colors"),
                  [
                    { country: "US", visits: 725 },
                    { country: "UK", visits: 625 },
                    { country: "China", visits: 602 },
                    { country: "Japan", visits: 509 },
                    { country: "Germany", visits: 322 },
                    { country: "France", visits: 214 },
                    { country: "India", visits: 204 },
                    { country: "Spain", visits: 198 },
                    { country: "Italy", visits: 165 },
                    { country: "Russia", visits: 130 },
                    { country: "Norway", visits: 93 },
                    { country: "Canada", visits: 41 },
                  ]);
              !(function () {
                for (var e = 0, t = 0; t < l.length; t++) e += l[t].visits;
                var a = 0;
                for (t = 0; t < l.length; t++)
                  (a += l[t].visits), (l[t].pareto = (a / e) * 100);
              })();
              var r = a.xAxes.push(
                am5xy.CategoryAxis.new(t, {
                  categoryField: "country",
                  renderer: am5xy.AxisRendererX.new(t, { minGridDistance: 30 }),
                })
              );
              r
                .get("renderer")
                .labels.template.setAll({
                  paddingTop: 10,
                  fontWeight: "400",
                  fontSize: 13,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
                }),
                r
                  .get("renderer")
                  .grid.template.setAll({ disabled: !0, strokeOpacity: 0 }),
                r.data.setAll(l);
              var o = a.yAxes.push(
                am5xy.ValueAxis.new(t, {
                  renderer: am5xy.AxisRendererY.new(t, {}),
                })
              );
              o
                .get("renderer")
                .labels.template.setAll({
                  paddingLeft: 10,
                  fontWeight: "400",
                  fontSize: 13,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
                }),
                o
                  .get("renderer")
                  .grid.template.setAll({
                    stroke: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-300")
                    ),
                    strokeWidth: 1,
                    strokeOpacity: 1,
                    strokeDasharray: [3],
                  });
              var i = am5xy.AxisRendererY.new(t, { opposite: !0 }),
                s = a.yAxes.push(
                  am5xy.ValueAxis.new(t, {
                    renderer: i,
                    min: 0,
                    max: 100,
                    strictMinMax: !0,
                  })
                );
              s
                .get("renderer")
                .labels.template.setAll({
                  fontWeight: "400",
                  fontSize: 13,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
                }),
                i.grid.template.set("forceHidden", !0),
                s.set("numberFormat", "#'%");
              var n = a.series.push(
                am5xy.ColumnSeries.new(t, {
                  xAxis: r,
                  yAxis: o,
                  valueYField: "visits",
                  categoryXField: "country",
                })
              );
              n.columns.template.setAll({
                tooltipText: "{categoryX}: {valueY}",
                tooltipY: 0,
                strokeOpacity: 0,
                cornerRadiusTL: 6,
                cornerRadiusTR: 6,
              }),
                n.columns.template.adapters.add("fill", function (e, t) {
                  return a
                    .get("colors")
                    .getIndex(n.dataItems.indexOf(t.dataItem));
                });
              var d = a.series.push(
                am5xy.LineSeries.new(t, {
                  xAxis: r,
                  yAxis: s,
                  valueYField: "pareto",
                  categoryXField: "country",
                  stroke: am5.color(KTUtil.getCssVariableValue("--bs-dark")),
                  maskBullets: !1,
                })
              );
              d.bullets.push(function () {
                return am5.Bullet.new(t, {
                  locationY: 1,
                  sprite: am5.Circle.new(t, {
                    radius: 5,
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-primary")),
                    stroke: am5.color(KTUtil.getCssVariableValue("--bs-dark")),
                  }),
                });
              }),
                n.data.setAll(l),
                d.data.setAll(l),
                n.appear(),
                a.appear(1e3, 100);
            };
          am5.ready(function () {
            a();
          }),
            KTThemeMode.on("kt.thememode.change", function () {
              t.dispose(), a();
            });
        }
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTChartsWidget16),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget16.init();
  });
var KTChartsWidget17 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.getElementById("kt_charts_widget_17_chart");
        if (e) {
          var t,
            a = function () {
              (t = am5.Root.new(e)).setThemes([am5themes_Animated.new(t)]);
              var a = t.container.children
                .push(
                  am5percent.PieChart.new(t, {
                    startAngle: 180,
                    endAngle: 360,
                    layout: t.verticalLayout,
                    innerRadius: am5.percent(50),
                  })
                )
                .series.push(
                  am5percent.PieSeries.new(t, {
                    startAngle: 180,
                    endAngle: 360,
                    valueField: "value",
                    categoryField: "category",
                    alignLabels: !1,
                  })
                );
              a.labels.template.setAll({
                fontWeight: "400",
                fontSize: 13,
                fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
              }),
                a.states.create("hidden", { startAngle: 180, endAngle: 180 }),
                a.slices.template.setAll({ cornerRadius: 5 }),
                a.ticks.template.setAll({ forceHidden: !0 }),
                a.data.setAll([
                  {
                    value: 10,
                    category: "One",
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-primary")),
                  },
                  {
                    value: 9,
                    category: "Two",
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                  },
                  {
                    value: 6,
                    category: "Three",
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-danger")),
                  },
                  {
                    value: 5,
                    category: "Four",
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-warning")),
                  },
                  {
                    value: 4,
                    category: "Five",
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-info")),
                  },
                  {
                    value: 3,
                    category: "Six",
                    fill: am5.color(
                      KTUtil.getCssVariableValue("--bs-secondary")
                    ),
                  },
                ]),
                a.appear(1e3, 100);
            };
          am5.ready(function () {
            a();
          }),
            KTThemeMode.on("kt.thememode.change", function () {
              t.dispose(), a();
            });
        }
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTChartsWidget17),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget17.init();
  });
var KTChartsWidget18 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_charts_widget_18_chart");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-gray-900"),
          r = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          o = {
            series: [
              { name: "Spent time", data: [54, 42, 75, 110, 23, 87, 50] },
            ],
            chart: {
              fontFamily: "inherit",
              type: "bar",
              height: a,
              toolbar: { show: !1 },
            },
            plotOptions: {
              bar: {
                horizontal: !1,
                columnWidth: ["28%"],
                borderRadius: 5,
                dataLabels: { position: "top" },
                startingShape: "flat",
              },
            },
            legend: { show: !1 },
            dataLabels: {
              enabled: !0,
              offsetY: -28,
              style: { fontSize: "13px", colors: [l] },
              formatter: function (e) {
                return e;
              },
            },
            stroke: { show: !0, width: 2, colors: ["transparent"] },
            xaxis: {
              categories: [
                "QA Analysis",
                "Marketing",
                "Web Dev",
                "Maths",
                "Front-end Dev",
                "Physics",
                "Phylosophy",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: {
                style: {
                  colors: KTUtil.getCssVariableValue("--bs-gray-500"),
                  fontSize: "13px",
                },
              },
              crosshairs: {
                fill: { gradient: { opacityFrom: 0, opacityTo: 0 } },
              },
            },
            yaxis: {
              labels: {
                style: {
                  colors: KTUtil.getCssVariableValue("--bs-gray-500"),
                  fontSize: "13px",
                },
                formatter: function (e) {
                  return e + "H";
                },
              },
            },
            fill: { opacity: 1 },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return +e + " hours";
                },
              },
            },
            colors: [
              KTUtil.getCssVariableValue("--bs-primary"),
              KTUtil.getCssVariableValue("--bs-primary-light"),
            ],
            grid: {
              borderColor: r,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
          };
        (e.self = new ApexCharts(t, o)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget18),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget18.init();
  });
var KTChartsWidget19 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.getElementById("kt_charts_widget_19_chart_1");
        if (e) {
          var t,
            a = function () {
              (t = am5.Root.new(e)).setThemes([am5themes_Animated.new(t)]);
              var a = t.container.children.push(
                  am5radar.RadarChart.new(t, {
                    panX: !1,
                    panY: !1,
                    wheelX: "panX",
                    wheelY: "zoomX",
                    innerRadius: am5.percent(20),
                    startAngle: -90,
                    endAngle: 180,
                  })
                ),
                l = [
                  {
                    category: "Research",
                    value: 80,
                    full: 100,
                    columnSettings: {
                      fillOpacity: 1,
                      fill: am5.color(KTUtil.getCssVariableValue("--bs-info")),
                    },
                  },
                  {
                    category: "Marketing",
                    value: 35,
                    full: 100,
                    columnSettings: {
                      fillOpacity: 1,
                      fill: am5.color(
                        KTUtil.getCssVariableValue("--bs-danger")
                      ),
                    },
                  },
                  {
                    category: "Distribution",
                    value: 92,
                    full: 100,
                    columnSettings: {
                      fillOpacity: 1,
                      fill: am5.color(
                        KTUtil.getCssVariableValue("--bs-primary")
                      ),
                    },
                  },
                  {
                    category: "Human Resources",
                    value: 68,
                    full: 100,
                    columnSettings: {
                      fillOpacity: 1,
                      fill: am5.color(
                        KTUtil.getCssVariableValue("--bs-success")
                      ),
                    },
                  },
                ];
              a.set(
                "cursor",
                am5radar.RadarCursor.new(t, { behavior: "zoomX" })
              ).lineY.set("visible", !1);
              var r = am5radar.AxisRendererCircular.new(t, {});
              r.labels.template.setAll({ radius: 10 }),
                r.grid.template.setAll({ forceHidden: !0 });
              var o = a.xAxes.push(
                am5xy.ValueAxis.new(t, {
                  renderer: r,
                  min: 0,
                  max: 100,
                  strictMinMax: !0,
                  numberFormat: "#'%'",
                  tooltip: am5.Tooltip.new(t, {}),
                })
              );
              o.get("renderer").labels.template.setAll({
                fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
                fontWeight: "500",
                fontSize: 16,
              });
              var i = am5radar.AxisRendererRadial.new(t, {
                minGridDistance: 20,
              });
              i.labels.template.setAll({
                centerX: am5.p100,
                fontWeight: "500",
                fontSize: 18,
                fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
                templateField: "columnSettings",
              }),
                i.grid.template.setAll({ forceHidden: !0 });
              var s = a.yAxes.push(
                am5xy.CategoryAxis.new(t, {
                  categoryField: "category",
                  renderer: i,
                })
              );
              s.data.setAll(l);
              var n = a.series.push(
                am5radar.RadarColumnSeries.new(t, {
                  xAxis: o,
                  yAxis: s,
                  clustered: !1,
                  valueXField: "full",
                  categoryYField: "category",
                  fill: t.interfaceColors.get("alternativeBackground"),
                })
              );
              n.columns.template.setAll({
                width: am5.p100,
                fillOpacity: 0.08,
                strokeOpacity: 0,
                cornerRadius: 20,
              }),
                n.data.setAll(l);
              var d = a.series.push(
                am5radar.RadarColumnSeries.new(t, {
                  xAxis: o,
                  yAxis: s,
                  clustered: !1,
                  valueXField: "value",
                  categoryYField: "category",
                })
              );
              d.columns.template.setAll({
                width: am5.p100,
                strokeOpacity: 0,
                tooltipText: "{category}: {valueX}%",
                cornerRadius: 20,
                templateField: "columnSettings",
              }),
                d.data.setAll(l),
                n.appear(1e3),
                d.appear(1e3),
                a.appear(1e3, 100);
            };
          am5.ready(function () {
            a();
          }),
            KTThemeMode.on("kt.thememode.change", function () {
              t.dispose(), a();
            });
        }
      }
    })(),
      (function () {
        if ("undefined" != typeof am5) {
          var e,
            t = document.getElementById("kt_charts_widget_19_chart_2");
          if (t) {
            var a = function () {
              (e = am5.Root.new(t)).setThemes([am5themes_Animated.new(e)]);
              var a = e.container.children.push(
                  am5radar.RadarChart.new(e, {
                    panX: !1,
                    panY: !1,
                    wheelX: "panX",
                    wheelY: "zoomX",
                    innerRadius: am5.percent(20),
                    startAngle: -90,
                    endAngle: 180,
                  })
                ),
                l = [
                  {
                    category: "Research",
                    value: 40,
                    full: 100,
                    columnSettings: {
                      fillOpacity: 1,
                      fill: am5.color(KTUtil.getCssVariableValue("--bs-info")),
                    },
                  },
                  {
                    category: "Marketing",
                    value: 50,
                    full: 100,
                    columnSettings: {
                      fillOpacity: 1,
                      fill: am5.color(
                        KTUtil.getCssVariableValue("--bs-danger")
                      ),
                    },
                  },
                  {
                    category: "Distribution",
                    value: 80,
                    full: 100,
                    columnSettings: {
                      fillOpacity: 1,
                      fill: am5.color(
                        KTUtil.getCssVariableValue("--bs-primary")
                      ),
                    },
                  },
                  {
                    category: "Human Resources",
                    value: 70,
                    full: 100,
                    columnSettings: {
                      fillOpacity: 1,
                      fill: am5.color(
                        KTUtil.getCssVariableValue("--bs-success")
                      ),
                    },
                  },
                ];
              a.set(
                "cursor",
                am5radar.RadarCursor.new(e, { behavior: "zoomX" })
              ).lineY.set("visible", !1);
              var r = am5radar.AxisRendererCircular.new(e, {});
              r.labels.template.setAll({ radius: 10 }),
                r.grid.template.setAll({ forceHidden: !0 });
              var o = a.xAxes.push(
                  am5xy.ValueAxis.new(e, {
                    renderer: r,
                    min: 0,
                    max: 100,
                    strictMinMax: !0,
                    numberFormat: "#'%'",
                    tooltip: am5.Tooltip.new(e, {}),
                  })
                ),
                i = am5radar.AxisRendererRadial.new(e, { minGridDistance: 20 });
              i.labels.template.setAll({
                centerX: am5.p100,
                fontWeight: "500",
                fontSize: 18,
                fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
                templateField: "columnSettings",
              }),
                i.grid.template.setAll({ forceHidden: !0 });
              var s = a.yAxes.push(
                am5xy.CategoryAxis.new(e, {
                  categoryField: "category",
                  renderer: i,
                })
              );
              s.data.setAll(l);
              var n = a.series.push(
                am5radar.RadarColumnSeries.new(e, {
                  xAxis: o,
                  yAxis: s,
                  clustered: !1,
                  valueXField: "full",
                  categoryYField: "category",
                  fill: e.interfaceColors.get("alternativeBackground"),
                })
              );
              n.columns.template.setAll({
                width: am5.p100,
                fillOpacity: 0.08,
                strokeOpacity: 0,
                cornerRadius: 20,
              }),
                n.data.setAll(l);
              var d = a.series.push(
                am5radar.RadarColumnSeries.new(e, {
                  xAxis: o,
                  yAxis: s,
                  clustered: !1,
                  valueXField: "value",
                  categoryYField: "category",
                })
              );
              d.columns.template.setAll({
                width: am5.p100,
                strokeOpacity: 0,
                tooltipText: "{category}: {valueX}%",
                cornerRadius: 20,
                templateField: "columnSettings",
              }),
                d.data.setAll(l),
                n.appear(1e3),
                d.appear(1e3),
                a.appear(1e3, 100);
            };
            am5.ready(function () {
              a();
            }),
              KTThemeMode.on("kt.thememode.change", function () {
                e.dispose(), a();
              });
          }
        }
      })();
  },
};
"undefined" != typeof module && (module.exports = KTChartsWidget19),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget19.init();
  });
var KTChartsWidget2 = (function () {
  var e = { self: null, rendered: !1 },
    t = function () {
      var t = document.getElementById("kt_charts_widget_2");
      if (t) {
        var a = t.getAttribute("data-kt-chart-color"),
          l = parseInt(KTUtil.css(t, "height")),
          r = KTUtil.getCssVariableValue("--bs-gray-800"),
          o = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          i = KTUtil.getCssVariableValue("--bs-" + a),
          s = KTUtil.getCssVariableValue("--bs-" + a + "-light"),
          n = {
            series: [
              {
                name: "Overview",
                data: [15, 15, 45, 45, 25, 25, 55, 55, 20, 20, 37],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: l,
              toolbar: { show: !1 },
              zoom: { enabled: !1 },
              sparkline: { enabled: !0 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: { type: "solid", opacity: 1 },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [i] },
            xaxis: {
              categories: [
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { show: !1, style: { colors: r, fontSize: "12px" } },
              crosshairs: {
                show: !1,
                position: "front",
                stroke: { color: o, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: {
              min: 0,
              max: 60,
              labels: { show: !1, style: { colors: r, fontSize: "12px" } },
            },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return e;
                },
              },
            },
            colors: [s],
            markers: { colors: s, strokeColor: i, strokeWidth: 3 },
          };
        (e.self = new ApexCharts(t, n)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t();
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget2),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget2.init();
  });
var KTChartsWidget20 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_charts_widget_20");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-gray-500"),
          r = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          o = KTUtil.getCssVariableValue("--bs-danger"),
          i = KTUtil.getCssVariableValue("--bs-danger"),
          s = {
            series: [
              {
                name: t.getAttribute("data-kt-chart-info"),
                data: [
                  34.5, 34.5, 35, 35, 35.5, 35.5, 35, 35, 35.5, 35.5, 35, 35,
                  34.5, 34.5, 35, 35, 35.4, 35.4, 35,
                ],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0,
                stops: [0, 80, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [o] },
            xaxis: {
              categories: [
                "",
                "Apr 02",
                "Apr 03",
                "Apr 04",
                "Apr 05",
                "Apr 06",
                "Apr 07",
                "Apr 08",
                "Apr 09",
                "Apr 10",
                "Apr 11",
                "Apr 12",
                "Apr 13",
                "Apr 14",
                "Apr 17",
                "Apr 18",
                "Apr 19",
                "Apr 21",
                "",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              tickAmount: 6,
              labels: {
                rotate: 0,
                rotateAlways: !0,
                style: { colors: l, fontSize: "12px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: o, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: {
              max: 36.3,
              min: 33,
              tickAmount: 6,
              labels: {
                style: { colors: l, fontSize: "12px" },
                formatter: function (e) {
                  return "$" + parseInt(10 * e);
                },
              },
            },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return "$" + parseInt(10 * e);
                },
              },
            },
            colors: [i],
            grid: {
              borderColor: r,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: o, strokeWidth: 3 },
          };
        (e.self = new ApexCharts(t, s)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget20),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget20.init();
  });
var KTChartsWidget21 = {
  init: function () {
    !(function () {
      var e = document.getElementById("kt_charts_widget_21");
      if (e) {
        var t = new ApexCharts(e, {
          type: "serial",
          theme: "light",
          legend: {
            equalWidths: !1,
            useGraphSettings: !0,
            valueAlign: "left",
            valueWidth: 120,
          },
          dataProvider: [
            {
              date: "2012-01-01",
              distance: 227,
              townName: "New York",
              townName2: "New York",
              townSize: 25,
              latitude: 40.71,
              duration: 408,
            },
            {
              date: "2012-01-02",
              distance: 371,
              townName: "Washington",
              townSize: 14,
              latitude: 38.89,
              duration: 482,
            },
            {
              date: "2012-01-03",
              distance: 433,
              townName: "Wilmington",
              townSize: 6,
              latitude: 34.22,
              duration: 562,
            },
            {
              date: "2012-01-04",
              distance: 345,
              townName: "Jacksonville",
              townSize: 7,
              latitude: 30.35,
              duration: 379,
            },
            {
              date: "2012-01-05",
              distance: 480,
              townName: "Miami",
              townName2: "Miami",
              townSize: 10,
              latitude: 25.83,
              duration: 501,
            },
            {
              date: "2012-01-06",
              distance: 386,
              townName: "Tallahassee",
              townSize: 7,
              latitude: 30.46,
              duration: 443,
            },
            {
              date: "2012-01-07",
              distance: 348,
              townName: "New Orleans",
              townSize: 10,
              latitude: 29.94,
              duration: 405,
            },
            {
              date: "2012-01-08",
              distance: 238,
              townName: "Houston",
              townName2: "Houston",
              townSize: 16,
              latitude: 29.76,
              duration: 309,
            },
            {
              date: "2012-01-09",
              distance: 218,
              townName: "Dalas",
              townSize: 17,
              latitude: 32.8,
              duration: 287,
            },
            {
              date: "2012-01-10",
              distance: 349,
              townName: "Oklahoma City",
              townSize: 11,
              latitude: 35.49,
              duration: 485,
            },
            {
              date: "2012-01-11",
              distance: 603,
              townName: "Kansas City",
              townSize: 10,
              latitude: 39.1,
              duration: 890,
            },
            {
              date: "2012-01-12",
              distance: 534,
              townName: "Denver",
              townName2: "Denver",
              townSize: 18,
              latitude: 39.74,
              duration: 810,
            },
            {
              date: "2012-01-13",
              townName: "Salt Lake City",
              townSize: 12,
              distance: 425,
              duration: 670,
              latitude: 40.75,
              dashLength: 8,
              alpha: 0.4,
            },
            {
              date: "2012-01-14",
              latitude: 36.1,
              duration: 470,
              townName: "Las Vegas",
              townName2: "Las Vegas",
            },
            { date: "2012-01-15" },
            { date: "2012-01-16" },
            { date: "2012-01-17" },
            { date: "2012-01-18" },
            { date: "2012-01-19" },
          ],
          valueAxes: [
            {
              id: "distanceAxis",
              axisAlpha: 0,
              gridAlpha: 0,
              position: "left",
              title: "distance",
            },
            {
              id: "latitudeAxis",
              axisAlpha: 0,
              gridAlpha: 0,
              labelsEnabled: !1,
              position: "right",
            },
            {
              id: "durationAxis",
              duration: "mm",
              durationUnits: { hh: "h ", mm: "min" },
              axisAlpha: 0,
              gridAlpha: 0,
              inside: !0,
              position: "right",
              title: "duration",
            },
          ],
          graphs: [
            {
              alphaField: "alpha",
              balloonText: "[[value]] miles",
              dashLengthField: "dashLength",
              fillAlphas: 0.7,
              legendPeriodValueText: "total: [[value.sum]] mi",
              legendValueText: "[[value]] mi",
              title: "distance",
              type: "column",
              valueField: "distance",
              valueAxis: "distanceAxis",
            },
            {
              balloonText: "latitude:[[value]]",
              bullet: "round",
              bulletBorderAlpha: 1,
              useLineColorForBulletBorder: !0,
              bulletColor: "#FFFFFF",
              bulletSizeField: "townSize",
              dashLengthField: "dashLength",
              descriptionField: "townName",
              labelPosition: "right",
              labelText: "[[townName2]]",
              legendValueText: "[[value]]/[[description]]",
              title: "latitude/city",
              fillAlphas: 0,
              valueField: "latitude",
              valueAxis: "latitudeAxis",
            },
            {
              bullet: "square",
              bulletBorderAlpha: 1,
              bulletBorderThickness: 1,
              dashLengthField: "dashLength",
              legendValueText: "[[value]]",
              title: "duration",
              fillAlphas: 0,
              valueField: "duration",
              valueAxis: "durationAxis",
            },
          ],
          chartCursor: {
            categoryBalloonDateFormat: "DD",
            cursorAlpha: 0.1,
            cursorColor: "#000000",
            fullWidth: !0,
            valueBalloonsEnabled: !1,
            zoomable: !1,
          },
          dataDateFormat: "YYYY-MM-DD",
          categoryField: "date",
          categoryAxis: {
            dateFormats: [
              { period: "DD", format: "DD" },
              { period: "WW", format: "MMM DD" },
              { period: "MM", format: "MMM" },
              { period: "YYYY", format: "YYYY" },
            ],
            parseDates: !0,
            autoGridCount: !1,
            axisColor: "#555555",
            gridAlpha: 0.1,
            gridColor: "#FFFFFF",
            gridCount: 50,
          },
          export: { enabled: !0 },
        });
        setTimeout(function () {
          t.render();
        }, 200);
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTChartsWidget21),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget21.init();
  });
var KTChartsWidget22 = (function () {
  var e = function (e, t, a, l) {
    var r = document.querySelector(t);
    if (r) {
      parseInt(KTUtil.css(r, "height"));
      var o = {
          series: a,
          chart: { fontFamily: "inherit", type: "donut", width: 250 },
          plotOptions: {
            pie: {
              donut: { size: "50%", labels: { value: { fontSize: "10px" } } },
            },
          },
          colors: [
            KTUtil.getCssVariableValue("--bs-info"),
            KTUtil.getCssVariableValue("--bs-success"),
            KTUtil.getCssVariableValue("--bs-primary"),
            KTUtil.getCssVariableValue("--bs-danger"),
          ],
          stroke: { width: 0 },
          labels: ["Sales", "Sales", "Sales", "Sales"],
          legend: { show: !1 },
          fill: { type: "false" },
        },
        i = new ApexCharts(r, o),
        s = !1,
        n = document.querySelector(e);
      !0 === l && (i.render(), (s = !0)),
        n.addEventListener("shown.bs.tab", function (e) {
          0 == s && (i.render(), (s = !0));
        });
    }
  };
  return {
    init: function () {
      e(
        "#kt_chart_widgets_22_tab_1",
        "#kt_chart_widgets_22_chart_1",
        [20, 100, 15, 25],
        !0
      ),
        e(
          "#kt_chart_widgets_22_tab_2",
          "#kt_chart_widgets_22_chart_2",
          [70, 13, 11, 2],
          !1
        );
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget22),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget22.init();
  });
var KTChartsWidget23 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.getElementById("kt_charts_widget_23");
        if (e) {
          var t,
            a = function () {
              (t = am5.Root.new(e)).setThemes([am5themes_Animated.new(t)]);
              var a = t.container.children.push(
                  am5xy.XYChart.new(t, {
                    panX: !1,
                    panY: !1,
                    layout: t.verticalLayout,
                  })
                ),
                l = [
                  {
                    year: "2016",
                    income: 23.5,
                    expenses: 21.1,
                    columnSettings: {
                      fill: am5.color(
                        KTUtil.getCssVariableValue("--bs-primary")
                      ),
                    },
                  },
                  {
                    year: "2017",
                    income: 26.2,
                    expenses: 30.5,
                    columnSettings: {
                      fill: am5.color(
                        KTUtil.getCssVariableValue("--bs-primary")
                      ),
                    },
                  },
                  {
                    year: "2018",
                    income: 30.1,
                    expenses: 34.9,
                    columnSettings: {
                      fill: am5.color(
                        KTUtil.getCssVariableValue("--bs-primary")
                      ),
                    },
                  },
                  {
                    year: "2019",
                    income: 29.5,
                    expenses: 31.1,
                    columnSettings: {
                      fill: am5.color(
                        KTUtil.getCssVariableValue("--bs-primary")
                      ),
                    },
                  },
                  {
                    year: "2020",
                    income: 30.6,
                    expenses: 28.2,
                    strokeSettings: { strokeWidth: 3, strokeDasharray: [5, 5] },
                    columnSettings: {
                      fill: am5.color(
                        KTUtil.getCssVariableValue("--bs-primary")
                      ),
                    },
                  },
                  {
                    year: "2021",
                    income: 40.6,
                    expenses: 28.2,
                    strokeSettings: { strokeWidth: 3, strokeDasharray: [5, 5] },
                    columnSettings: {
                      fill: am5.color(
                        KTUtil.getCssVariableValue("--bs-primary")
                      ),
                    },
                  },
                  {
                    year: "2022",
                    income: 34.1,
                    expenses: 32.9,
                    strokeSettings: { strokeWidth: 3, strokeDasharray: [5, 5] },
                    columnSettings: {
                      fill: am5.color(
                        KTUtil.getCssVariableValue("--bs-primary")
                      ),
                    },
                  },
                ],
                r = a.xAxes.push(
                  am5xy.CategoryAxis.new(t, {
                    categoryField: "year",
                    renderer: am5xy.AxisRendererX.new(t, {}),
                  })
                );
              r.data.setAll(l),
                r
                  .get("renderer")
                  .labels.template.setAll({
                    paddingTop: 20,
                    fontWeight: "400",
                    fontSize: 11,
                    fill: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-500")
                    ),
                  }),
                r
                  .get("renderer")
                  .grid.template.setAll({ disabled: !0, strokeOpacity: 0 });
              var o = a.yAxes.push(
                am5xy.ValueAxis.new(t, {
                  min: 0,
                  extraMax: 0.1,
                  renderer: am5xy.AxisRendererY.new(t, {}),
                })
              );
              o
                .get("renderer")
                .labels.template.setAll({
                  paddingTop: 0,
                  fontWeight: "400",
                  fontSize: 11,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
                }),
                o
                  .get("renderer")
                  .grid.template.setAll({
                    stroke: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-300")
                    ),
                    strokeWidth: 1,
                    strokeOpacity: 1,
                    strokeDasharray: [3],
                  });
              var i = a.series.push(
                am5xy.ColumnSeries.new(t, {
                  name: "Income",
                  xAxis: r,
                  yAxis: o,
                  valueYField: "income",
                  categoryXField: "year",
                  tooltip: am5.Tooltip.new(t, {
                    pointerOrientation: "horizontal",
                    labelText: "{name} in {categoryX}: {valueY} {info}",
                  }),
                })
              );
              i.columns.template.setAll({
                tooltipY: am5.percent(10),
                templateField: "columnSettings",
              }),
                i.data.setAll(l);
              var s = a.series.push(
                am5xy.LineSeries.new(t, {
                  name: "Expenses",
                  xAxis: r,
                  yAxis: o,
                  valueYField: "expenses",
                  categoryXField: "year",
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                  stroke: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                  tooltip: am5.Tooltip.new(t, {
                    pointerOrientation: "horizontal",
                    labelText: "{name} in {categoryX}: {valueY} {info}",
                  }),
                })
              );
              s.strokes.template.setAll({
                stroke: am5.color(KTUtil.getCssVariableValue("--bs-success")),
              }),
                s.strokes.template.setAll({
                  strokeWidth: 3,
                  templateField: "strokeSettings",
                }),
                s.data.setAll(l),
                s.bullets.push(function () {
                  return am5.Bullet.new(t, {
                    sprite: am5.Circle.new(t, {
                      strokeWidth: 3,
                      stroke: am5.color(
                        KTUtil.getCssVariableValue("--bs-success")
                      ),
                      radius: 5,
                      fill: am5.color(
                        KTUtil.getCssVariableValue("--bs-success-light")
                      ),
                    }),
                  });
                }),
                i.columns.template.setAll({
                  strokeOpacity: 0,
                  cornerRadiusBR: 0,
                  cornerRadiusTR: 6,
                  cornerRadiusBL: 0,
                  cornerRadiusTL: 6,
                }),
                a.set("cursor", am5xy.XYCursor.new(t, {})),
                a.get("cursor").lineX.setAll({ visible: !1 }),
                a.get("cursor").lineY.setAll({ visible: !1 });
              var n = a.children.push(
                am5.Legend.new(t, { centerX: am5.p50, x: am5.p50 })
              );
              n.data.setAll(a.series.values),
                n.labels.template.setAll({
                  fontWeight: "600",
                  fontSize: 14,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-700")),
                }),
                a.appear(1e3, 100),
                i.appear();
            };
          am5.ready(function () {
            a();
          }),
            KTThemeMode.on("kt.thememode.change", function () {
              t.dispose(), a();
            });
        }
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTChartsWidget23),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget23.init();
  });
var KTChartsWidget24 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.getElementById("kt_charts_widget_24");
        if (e) {
          var t,
            a = function () {
              var a = [
                  { age: "0 to 5", male: 10175713, female: 9736305 },
                  { age: "5 to 9", male: 10470147, female: 10031835 },
                  { age: "10 to 14", male: 10561873, female: 10117913 },
                  { age: "15 to 17", male: 6447043, female: 6142996 },
                  { age: "18 to 21", male: 9349745, female: 8874664 },
                  { age: "22 to 24", male: 6722248, female: 6422017 },
                  { age: "25 to 29", male: 10989596, female: 10708414 },
                  { age: "30 to 34", male: 10625791, female: 10557848 },
                  { age: "35 to 39", male: 9899569, female: 9956213 },
                  { age: "40 to 44", male: 10330986, female: 10465142 },
                  { age: "45 to 49", male: 10571984, female: 10798384 },
                  { age: "50 to 54", male: 11051409, female: 11474081 },
                  { age: "55 to 59", male: 10173646, female: 10828301 },
                  { age: "60 to 64", male: 8824852, female: 9590829 },
                  { age: "65 to 69", male: 6876271, female: 7671175 },
                  { age: "70 to 74", male: 4867513, female: 5720208 },
                  { age: "75 to 79", male: 3416432, female: 4313697 },
                  { age: "80 to 84", male: 2378691, female: 3432738 },
                  { age: "85 and Older", male: 2000771, female: 3937981 },
                ],
                l = {
                  AK: [
                    { age: "0 to 5", male: 28346, female: 26607 },
                    { age: "10 to 14", male: 26350, female: 24821 },
                    { age: "15 to 17", male: 15929, female: 14735 },
                    { age: "18 to 21", male: 25360, female: 19030 },
                    { age: "22 to 24", male: 20755, female: 15663 },
                    { age: "25 to 29", male: 32415, female: 28259 },
                    { age: "30 to 34", male: 28232, female: 25272 },
                    { age: "35 to 39", male: 24217, female: 22002 },
                    { age: "40 to 44", male: 23429, female: 21968 },
                    { age: "45 to 49", male: 24764, female: 22784 },
                    { age: "5 to 9", male: 26276, female: 25063 },
                    { age: "50 to 54", male: 27623, female: 25503 },
                    { age: "55 to 59", male: 26300, female: 25198 },
                    { age: "60 to 64", male: 21798, female: 18970 },
                    { age: "65 to 69", male: 13758, female: 12899 },
                    { age: "70 to 74", male: 8877, female: 8269 },
                    { age: "75 to 79", male: 4834, female: 4894 },
                    { age: "80 to 84", male: 3015, female: 3758 },
                    { age: "85 and Older", male: 1882, female: 3520 },
                  ],
                  AL: [
                    { age: "0 to 5", male: 150860, female: 144194 },
                    { age: "10 to 14", male: 161596, female: 156841 },
                    { age: "15 to 17", male: 98307, female: 94462 },
                    { age: "18 to 21", male: 142173, female: 136514 },
                    { age: "22 to 24", male: 99164, female: 101444 },
                    { age: "25 to 29", male: 154977, female: 159815 },
                    { age: "30 to 34", male: 150036, female: 156764 },
                    { age: "35 to 39", male: 141667, female: 152220 },
                    { age: "40 to 44", male: 155693, female: 159835 },
                    { age: "45 to 49", male: 156413, female: 163909 },
                    { age: "5 to 9", male: 156380, female: 149334 },
                    { age: "50 to 54", male: 166863, female: 178187 },
                    { age: "55 to 59", male: 156994, female: 169355 },
                    { age: "60 to 64", male: 140659, female: 156638 },
                    { age: "65 to 69", male: 112724, female: 128494 },
                    { age: "70 to 74", male: 79258, female: 96507 },
                    { age: "75 to 79", male: 55122, female: 75371 },
                    { age: "80 to 84", male: 36252, female: 53976 },
                    { age: "85 and Older", male: 25955, female: 55667 },
                  ],
                  AR: [
                    { age: "0 to 5", male: 98246, female: 93534 },
                    { age: "10 to 14", male: 99707, female: 96862 },
                    { age: "15 to 17", male: 60521, female: 57735 },
                    { age: "18 to 21", male: 87209, female: 81936 },
                    { age: "22 to 24", male: 59114, female: 59387 },
                    { age: "25 to 29", male: 96190, female: 96573 },
                    { age: "30 to 34", male: 96273, female: 95632 },
                    { age: "35 to 39", male: 90371, female: 90620 },
                    { age: "40 to 44", male: 91881, female: 93777 },
                    { age: "45 to 49", male: 93238, female: 95476 },
                    { age: "5 to 9", male: 103613, female: 97603 },
                    { age: "50 to 54", male: 98960, female: 102953 },
                    { age: "55 to 59", male: 92133, female: 100676 },
                    { age: "60 to 64", male: 84082, female: 90243 },
                    { age: "65 to 69", male: 70121, female: 76669 },
                    { age: "70 to 74", male: 52154, female: 61686 },
                    { age: "75 to 79", male: 36856, female: 44371 },
                    { age: "80 to 84", male: 23098, female: 35328 },
                    { age: "85 and Older", male: 18146, female: 35234 },
                  ],
                  AZ: [
                    { age: "0 to 5", male: 221511, female: 212324 },
                    { age: "10 to 14", male: 233530, female: 222965 },
                    { age: "15 to 17", male: 138926, female: 132399 },
                    { age: "18 to 21", male: 200240, female: 187786 },
                    { age: "22 to 24", male: 142852, female: 132457 },
                    { age: "25 to 29", male: 231488, female: 215985 },
                    { age: "30 to 34", male: 223754, female: 214946 },
                    { age: "35 to 39", male: 206718, female: 202482 },
                    { age: "40 to 44", male: 213591, female: 210621 },
                    { age: "45 to 49", male: 205830, female: 206081 },
                    { age: "5 to 9", male: 231249, female: 224385 },
                    { age: "50 to 54", male: 210386, female: 218328 },
                    { age: "55 to 59", male: 192614, female: 209767 },
                    { age: "60 to 64", male: 178325, female: 200313 },
                    { age: "65 to 69", male: 155852, female: 174407 },
                    { age: "70 to 74", male: 121878, female: 136840 },
                    { age: "75 to 79", male: 87470, female: 96953 },
                    { age: "80 to 84", male: 58553, female: 69559 },
                    { age: "85 and Older", male: 44321, female: 74242 },
                  ],
                  CA: [
                    { age: "0 to 5", male: 1283763, female: 1228013 },
                    { age: "10 to 14", male: 1297819, female: 1245016 },
                    { age: "15 to 17", male: 811114, female: 773387 },
                    { age: "18 to 21", male: 1179739, female: 1100368 },
                    { age: "22 to 24", male: 883323, female: 825833 },
                    { age: "25 to 29", male: 1478557, female: 1387516 },
                    { age: "30 to 34", male: 1399835, female: 1348430 },
                    { age: "35 to 39", male: 1287803, female: 1271908 },
                    { age: "40 to 44", male: 1308311, female: 1309907 },
                    { age: "45 to 49", male: 1306719, female: 1303528 },
                    { age: "5 to 9", male: 1295030, female: 1240201 },
                    { age: "50 to 54", male: 1305323, female: 1330645 },
                    { age: "55 to 59", male: 1161821, female: 1223440 },
                    { age: "60 to 64", male: 975874, female: 1060921 },
                    { age: "65 to 69", male: 734814, female: 833926 },
                    { age: "70 to 74", male: 515115, female: 604615 },
                    { age: "75 to 79", male: 363282, female: 455568 },
                    { age: "80 to 84", male: 264126, female: 363937 },
                    { age: "85 and Older", male: 234767, female: 427170 },
                  ],
                  CO: [
                    { age: "0 to 5", male: 173245, female: 163629 },
                    { age: "10 to 14", male: 179579, female: 170930 },
                    { age: "15 to 17", male: 102577, female: 98569 },
                    { age: "18 to 21", male: 152713, female: 139268 },
                    { age: "22 to 24", male: 116654, female: 108238 },
                    { age: "25 to 29", male: 204625, female: 188680 },
                    { age: "30 to 34", male: 200624, female: 188616 },
                    { age: "35 to 39", male: 183386, female: 175326 },
                    { age: "40 to 44", male: 184422, female: 173654 },
                    { age: "45 to 49", male: 174730, female: 172981 },
                    { age: "5 to 9", male: 179803, female: 173524 },
                    { age: "50 to 54", male: 183543, female: 187757 },
                    { age: "55 to 59", male: 170717, female: 179537 },
                    { age: "60 to 64", male: 150815, female: 155924 },
                    { age: "65 to 69", male: 111094, female: 119530 },
                    { age: "70 to 74", male: 72252, female: 80168 },
                    { age: "75 to 79", male: 49142, female: 59393 },
                    { age: "80 to 84", male: 31894, female: 43881 },
                    { age: "85 and Older", male: 26852, female: 50634 },
                  ],
                  CT: [
                    { age: "0 to 5", male: 97647, female: 93798 },
                    { age: "10 to 14", male: 118032, female: 113043 },
                    { age: "15 to 17", male: 75546, female: 71687 },
                    { age: "18 to 21", male: 106966, female: 102763 },
                    { age: "22 to 24", male: 71125, female: 64777 },
                    { age: "25 to 29", male: 112189, female: 108170 },
                    { age: "30 to 34", male: 107223, female: 109096 },
                    { age: "35 to 39", male: 102424, female: 106008 },
                    { age: "40 to 44", male: 116664, female: 123744 },
                    { age: "45 to 49", male: 131872, female: 139406 },
                    { age: "5 to 9", male: 110043, female: 104940 },
                    { age: "50 to 54", male: 138644, female: 146532 },
                    { age: "55 to 59", male: 126670, female: 132895 },
                    { age: "60 to 64", male: 104701, female: 114339 },
                    { age: "65 to 69", male: 80178, female: 91052 },
                    { age: "70 to 74", male: 55237, female: 65488 },
                    { age: "75 to 79", male: 38844, female: 51544 },
                    { age: "80 to 84", male: 28908, female: 43036 },
                    { age: "85 and Older", male: 28694, female: 59297 },
                  ],
                  DC: [
                    { age: "0 to 5", male: 20585, female: 19848 },
                    { age: "10 to 14", male: 12723, female: 11991 },
                    { age: "15 to 17", male: 7740, female: 7901 },
                    { age: "18 to 21", male: 22350, female: 25467 },
                    { age: "22 to 24", male: 15325, female: 19085 },
                    { age: "25 to 29", male: 35295, female: 41913 },
                    { age: "30 to 34", male: 32716, female: 35553 },
                    { age: "35 to 39", male: 23748, female: 24922 },
                    { age: "40 to 44", male: 21158, female: 20113 },
                    { age: "45 to 49", male: 19279, female: 18956 },
                    { age: "5 to 9", male: 14999, female: 15518 },
                    { age: "50 to 54", male: 19249, female: 19279 },
                    { age: "55 to 59", male: 17592, female: 18716 },
                    { age: "60 to 64", male: 14272, female: 17892 },
                    { age: "65 to 69", male: 9740, female: 13375 },
                    { age: "70 to 74", male: 8221, female: 9761 },
                    { age: "75 to 79", male: 5071, female: 7601 },
                    { age: "80 to 84", male: 3399, female: 5619 },
                    { age: "85 and Older", male: 3212, female: 7300 },
                  ],
                  DE: [
                    { age: "0 to 5", male: 28382, female: 27430 },
                    { age: "10 to 14", male: 29482, female: 27484 },
                    { age: "15 to 17", male: 17589, female: 16828 },
                    { age: "18 to 21", male: 26852, female: 26911 },
                    { age: "22 to 24", male: 19006, female: 18413 },
                    { age: "25 to 29", male: 30933, female: 31146 },
                    { age: "30 to 34", male: 28602, female: 29431 },
                    { age: "35 to 39", male: 26498, female: 28738 },
                    { age: "40 to 44", male: 27674, female: 28519 },
                    { age: "45 to 49", male: 30582, female: 32924 },
                    { age: "5 to 9", male: 28224, female: 28735 },
                    { age: "50 to 54", male: 32444, female: 35052 },
                    { age: "55 to 59", male: 29048, female: 34377 },
                    { age: "60 to 64", male: 27925, female: 30017 },
                    { age: "65 to 69", male: 22767, female: 26707 },
                    { age: "70 to 74", male: 17121, female: 19327 },
                    { age: "75 to 79", male: 11479, female: 14264 },
                    { age: "80 to 84", male: 7473, female: 10353 },
                    { age: "85 and Older", male: 6332, female: 11385 },
                  ],
                  FL: [
                    { age: "0 to 5", male: 552054, female: 529003 },
                    { age: "10 to 14", male: 582351, female: 558377 },
                    { age: "15 to 17", male: 363538, female: 345048 },
                    { age: "18 to 21", male: 528013, female: 498162 },
                    { age: "22 to 24", male: 385515, female: 368754 },
                    { age: "25 to 29", male: 641710, female: 622134 },
                    { age: "30 to 34", male: 602467, female: 602634 },
                    { age: "35 to 39", male: 579722, female: 585089 },
                    { age: "40 to 44", male: 623074, female: 639410 },
                    { age: "45 to 49", male: 659376, female: 677305 },
                    { age: "5 to 9", male: 567479, female: 543273 },
                    { age: "50 to 54", male: 687625, female: 723103 },
                    { age: "55 to 59", male: 626363, female: 685728 },
                    { age: "60 to 64", male: 566282, female: 651192 },
                    { age: "65 to 69", male: 517513, female: 589377 },
                    { age: "70 to 74", male: 407275, female: 470688 },
                    { age: "75 to 79", male: 305530, female: 361107 },
                    { age: "80 to 84", male: 219362, female: 281016 },
                    { age: "85 and Older", male: 184760, female: 314363 },
                  ],
                  GA: [
                    { age: "0 to 5", male: 338979, female: 326326 },
                    { age: "10 to 14", male: 356404, female: 351833 },
                    { age: "15 to 17", male: 211908, female: 203412 },
                    { age: "18 to 21", male: 305617, female: 289233 },
                    { age: "22 to 24", male: 214032, female: 206526 },
                    { age: "25 to 29", male: 342885, female: 343115 },
                    { age: "30 to 34", male: 333159, female: 348125 },
                    { age: "35 to 39", male: 325121, female: 345251 },
                    { age: "40 to 44", male: 348120, female: 363703 },
                    { age: "45 to 49", male: 343559, female: 358754 },
                    { age: "5 to 9", male: 362147, female: 340071 },
                    { age: "50 to 54", male: 338424, female: 359362 },
                    { age: "55 to 59", male: 294734, female: 325653 },
                    { age: "60 to 64", male: 254497, female: 285276 },
                    { age: "65 to 69", male: 198714, female: 226714 },
                    { age: "70 to 74", male: 135107, female: 164091 },
                    { age: "75 to 79", male: 88135, female: 115830 },
                    { age: "80 to 84", male: 53792, female: 84961 },
                    { age: "85 and Older", male: 37997, female: 85126 },
                  ],
                  HI: [
                    { age: "0 to 5", male: 46668, female: 44389 },
                    { age: "10 to 14", male: 42590, female: 41289 },
                    { age: "15 to 17", male: 24759, female: 23961 },
                    { age: "18 to 21", male: 39937, female: 32348 },
                    { age: "22 to 24", male: 35270, female: 28495 },
                    { age: "25 to 29", male: 58033, female: 48700 },
                    { age: "30 to 34", male: 51544, female: 47286 },
                    { age: "35 to 39", male: 44144, female: 42208 },
                    { age: "40 to 44", male: 45731, female: 43404 },
                    { age: "45 to 49", male: 44336, female: 44134 },
                    { age: "5 to 9", male: 44115, female: 40426 },
                    { age: "50 to 54", male: 46481, female: 46908 },
                    { age: "55 to 59", male: 45959, female: 47379 },
                    { age: "60 to 64", male: 42420, female: 43735 },
                    { age: "65 to 69", male: 34846, female: 36670 },
                    { age: "70 to 74", male: 22981, female: 25496 },
                    { age: "75 to 79", male: 15219, female: 18755 },
                    { age: "80 to 84", male: 11142, female: 17952 },
                    { age: "85 and Older", male: 13696, female: 22893 },
                  ],
                  IA: [
                    { age: "0 to 5", male: 100400, female: 96170 },
                    { age: "10 to 14", male: 104674, female: 98485 },
                    { age: "15 to 17", male: 62452, female: 59605 },
                    { age: "18 to 21", male: 96966, female: 91782 },
                    { age: "22 to 24", male: 66307, female: 62504 },
                    { age: "25 to 29", male: 98079, female: 93653 },
                    { age: "30 to 34", male: 100924, female: 97248 },
                    { age: "35 to 39", male: 90980, female: 89632 },
                    { age: "40 to 44", male: 92961, female: 90218 },
                    { age: "45 to 49", male: 98877, female: 96654 },
                    { age: "5 to 9", male: 104279, female: 100558 },
                    { age: "50 to 54", male: 109267, female: 110142 },
                    { age: "55 to 59", male: 104021, female: 106042 },
                    { age: "60 to 64", male: 95379, female: 95499 },
                    { age: "65 to 69", male: 68276, female: 73624 },
                    { age: "70 to 74", male: 50414, female: 56973 },
                    { age: "75 to 79", male: 37867, female: 48121 },
                    { age: "80 to 84", male: 27523, female: 39851 },
                    { age: "85 and Older", male: 24949, female: 52170 },
                  ],
                  ID: [
                    { age: "0 to 5", male: 58355, female: 56478 },
                    { age: "10 to 14", male: 62528, female: 59881 },
                    { age: "15 to 17", male: 36373, female: 33687 },
                    { age: "18 to 21", male: 45752, female: 45590 },
                    { age: "22 to 24", male: 34595, female: 30216 },
                    { age: "25 to 29", male: 53998, female: 52077 },
                    { age: "30 to 34", male: 54217, female: 52091 },
                    { age: "35 to 39", male: 51247, female: 47801 },
                    { age: "40 to 44", male: 49113, female: 49853 },
                    { age: "45 to 49", male: 48392, female: 48288 },
                    { age: "5 to 9", male: 63107, female: 59237 },
                    { age: "50 to 54", male: 51805, female: 52984 },
                    { age: "55 to 59", male: 49226, female: 51868 },
                    { age: "60 to 64", male: 47343, female: 47631 },
                    { age: "65 to 69", male: 38436, female: 38133 },
                    { age: "70 to 74", male: 26243, female: 28577 },
                    { age: "75 to 79", male: 18404, female: 20325 },
                    { age: "80 to 84", male: 11653, female: 15313 },
                    { age: "85 and Older", male: 9677, female: 16053 },
                  ],
                  IL: [
                    { age: "0 to 5", male: 408295, female: 392900 },
                    { age: "10 to 14", male: 437688, female: 419077 },
                    { age: "15 to 17", male: 269202, female: 257213 },
                    { age: "18 to 21", male: 369219, female: 353570 },
                    { age: "22 to 24", male: 268501, female: 258559 },
                    { age: "25 to 29", male: 448001, female: 442418 },
                    { age: "30 to 34", male: 445416, female: 445729 },
                    { age: "35 to 39", male: 416265, female: 418999 },
                    { age: "40 to 44", male: 425825, female: 427573 },
                    { age: "45 to 49", male: 433177, female: 441116 },
                    { age: "5 to 9", male: 427121, female: 412238 },
                    { age: "50 to 54", male: 454039, female: 470982 },
                    { age: "55 to 59", male: 414948, female: 442280 },
                    { age: "60 to 64", male: 354782, female: 380640 },
                    { age: "65 to 69", male: 259363, female: 292899 },
                    { age: "70 to 74", male: 184622, female: 223905 },
                    { age: "75 to 79", male: 129016, female: 171743 },
                    { age: "80 to 84", male: 91973, female: 139204 },
                    { age: "85 and Older", male: 79446, female: 165817 },
                  ],
                  IN: [
                    { age: "0 to 5", male: 215697, female: 205242 },
                    { age: "10 to 14", male: 229911, female: 221563 },
                    { age: "15 to 17", male: 139494, female: 132879 },
                    { age: "18 to 21", male: 198763, female: 194206 },
                    { age: "22 to 24", male: 140805, female: 131947 },
                    { age: "25 to 29", male: 210315, female: 208593 },
                    { age: "30 to 34", male: 211656, female: 210103 },
                    { age: "35 to 39", male: 201979, female: 200693 },
                    { age: "40 to 44", male: 212114, female: 212653 },
                    { age: "45 to 49", male: 216446, female: 219033 },
                    { age: "5 to 9", male: 226901, female: 214964 },
                    { age: "50 to 54", male: 232241, female: 237844 },
                    { age: "55 to 59", male: 217033, female: 228674 },
                    { age: "60 to 64", male: 186412, female: 197353 },
                    { age: "65 to 69", male: 140336, female: 156256 },
                    { age: "70 to 74", male: 99402, female: 116834 },
                    { age: "75 to 79", male: 68758, female: 88794 },
                    { age: "80 to 84", male: 47628, female: 72061 },
                    { age: "85 and Older", male: 39372, female: 83690 },
                  ],
                  KS: [
                    { age: "0 to 5", male: 102716, female: 98004 },
                    { age: "10 to 14", male: 102335, female: 99132 },
                    { age: "15 to 17", male: 60870, female: 57957 },
                    { age: "18 to 21", male: 90593, female: 83299 },
                    { age: "22 to 24", male: 66512, female: 59368 },
                    { age: "25 to 29", male: 99384, female: 93840 },
                    { age: "30 to 34", male: 98020, female: 94075 },
                    { age: "35 to 39", male: 87763, female: 85422 },
                    { age: "40 to 44", male: 87647, female: 84970 },
                    { age: "45 to 49", male: 89233, female: 88877 },
                    { age: "5 to 9", male: 103861, female: 98642 },
                    { age: "50 to 54", male: 98398, female: 101197 },
                    { age: "55 to 59", male: 95861, female: 96152 },
                    { age: "60 to 64", male: 79440, female: 85124 },
                    { age: "65 to 69", male: 60035, female: 64369 },
                    { age: "70 to 74", male: 42434, female: 49221 },
                    { age: "75 to 79", male: 30967, female: 39425 },
                    { age: "80 to 84", male: 23026, female: 33863 },
                    { age: "85 and Older", male: 20767, female: 40188 },
                  ],
                  KY: [
                    { age: "0 to 5", male: 142062, female: 134389 },
                    { age: "10 to 14", male: 147586, female: 138629 },
                    { age: "15 to 17", male: 87696, female: 83139 },
                    { age: "18 to 21", male: 128249, female: 121099 },
                    { age: "22 to 24", male: 90794, female: 85930 },
                    { age: "25 to 29", male: 140811, female: 139855 },
                    { age: "30 to 34", male: 142732, female: 142551 },
                    { age: "35 to 39", male: 137211, female: 136524 },
                    { age: "40 to 44", male: 145358, female: 145251 },
                    { age: "45 to 49", male: 148883, female: 150922 },
                    { age: "5 to 9", male: 143532, female: 139032 },
                    { age: "50 to 54", male: 156890, female: 163054 },
                    { age: "55 to 59", male: 147006, female: 156302 },
                    { age: "60 to 64", male: 129457, female: 139434 },
                    { age: "65 to 69", male: 100883, female: 112696 },
                    { age: "70 to 74", male: 71867, female: 83665 },
                    { age: "75 to 79", male: 47828, female: 62775 },
                    { age: "80 to 84", male: 31477, female: 46386 },
                    { age: "85 and Older", male: 23886, female: 51512 },
                  ],
                  LA: [
                    { age: "0 to 5", male: 157642, female: 152324 },
                    { age: "10 to 14", male: 157781, female: 149752 },
                    { age: "15 to 17", male: 93357, female: 90227 },
                    { age: "18 to 21", male: 136496, female: 131202 },
                    { age: "22 to 24", male: 101438, female: 101480 },
                    { age: "25 to 29", male: 167414, female: 168886 },
                    { age: "30 to 34", male: 160094, female: 161424 },
                    { age: "35 to 39", male: 142182, female: 141813 },
                    { age: "40 to 44", male: 138717, female: 144789 },
                    { age: "45 to 49", male: 145906, female: 152340 },
                    { age: "5 to 9", male: 159193, female: 154320 },
                    { age: "50 to 54", male: 157743, female: 167125 },
                    { age: "55 to 59", male: 149001, female: 161295 },
                    { age: "60 to 64", male: 129265, female: 139378 },
                    { age: "65 to 69", male: 98404, female: 106844 },
                    { age: "70 to 74", male: 65845, female: 83779 },
                    { age: "75 to 79", male: 47365, female: 60745 },
                    { age: "80 to 84", male: 29452, female: 48839 },
                    { age: "85 and Older", male: 23861, female: 47535 },
                  ],
                  MA: [
                    { age: "0 to 5", male: 187066, female: 178775 },
                    { age: "10 to 14", male: 205530, female: 195312 },
                    { age: "15 to 17", male: 129433, female: 123212 },
                    { age: "18 to 21", male: 207432, female: 213820 },
                    { age: "22 to 24", male: 140356, female: 135839 },
                    { age: "25 to 29", male: 235172, female: 237653 },
                    { age: "30 to 34", male: 216220, female: 221692 },
                    { age: "35 to 39", male: 196293, female: 202730 },
                    { age: "40 to 44", male: 218111, female: 231277 },
                    { age: "45 to 49", male: 237629, female: 249926 },
                    { age: "5 to 9", male: 191958, female: 186343 },
                    { age: "50 to 54", male: 247973, female: 260886 },
                    { age: "55 to 59", male: 227238, female: 241029 },
                    { age: "60 to 64", male: 189981, female: 211282 },
                    { age: "65 to 69", male: 146129, female: 164268 },
                    { age: "70 to 74", male: 100745, female: 123577 },
                    { age: "75 to 79", male: 70828, female: 92141 },
                    { age: "80 to 84", male: 52074, female: 81603 },
                    { age: "85 and Older", male: 49482, female: 104571 },
                  ],
                  MD: [
                    { age: "0 to 5", male: 187617, female: 180105 },
                    { age: "10 to 14", male: 191787, female: 185380 },
                    { age: "15 to 17", male: 118027, female: 113549 },
                    { age: "18 to 21", male: 166991, female: 159589 },
                    { age: "22 to 24", male: 120617, female: 116602 },
                    { age: "25 to 29", male: 205555, female: 206944 },
                    { age: "30 to 34", male: 196824, female: 203989 },
                    { age: "35 to 39", male: 179340, female: 193957 },
                    { age: "40 to 44", male: 195388, female: 205570 },
                    { age: "45 to 49", male: 208382, female: 225458 },
                    { age: "5 to 9", male: 189781, female: 182034 },
                    { age: "50 to 54", male: 217574, female: 235604 },
                    { age: "55 to 59", male: 193789, female: 210582 },
                    { age: "60 to 64", male: 161828, female: 186524 },
                    { age: "65 to 69", male: 123204, female: 144193 },
                    { age: "70 to 74", male: 84114, female: 101563 },
                    { age: "75 to 79", male: 56755, female: 75715 },
                    { age: "80 to 84", male: 39615, female: 59728 },
                    { age: "85 and Older", male: 35455, female: 70809 },
                  ],
                  ME: [
                    { age: "0 to 5", male: 33298, female: 32108 },
                    { age: "10 to 14", male: 38254, female: 36846 },
                    { age: "15 to 17", male: 24842, female: 23688 },
                    { age: "18 to 21", male: 35315, female: 33777 },
                    { age: "22 to 24", male: 23007, female: 21971 },
                    { age: "25 to 29", male: 37685, female: 38353 },
                    { age: "30 to 34", male: 36838, female: 37697 },
                    { age: "35 to 39", male: 35988, female: 37686 },
                    { age: "40 to 44", male: 42092, female: 42912 },
                    { age: "45 to 49", male: 47141, female: 49161 },
                    { age: "5 to 9", male: 38066, female: 35151 },
                    { age: "50 to 54", male: 53458, female: 55451 },
                    { age: "55 to 59", male: 51789, female: 55407 },
                    { age: "60 to 64", male: 47171, female: 49840 },
                    { age: "65 to 69", male: 37495, female: 39678 },
                    { age: "70 to 74", male: 26300, female: 28932 },
                    { age: "75 to 79", male: 18197, female: 22047 },
                    { age: "80 to 84", male: 12824, female: 18302 },
                    { age: "85 and Older", male: 10321, female: 20012 },
                  ],
                  MI: [
                    { age: "0 to 5", male: 295157, female: 280629 },
                    { age: "10 to 14", male: 329983, female: 319870 },
                    { age: "15 to 17", male: 210017, female: 199977 },
                    { age: "18 to 21", male: 299937, female: 287188 },
                    { age: "22 to 24", male: 208270, female: 202858 },
                    { age: "25 to 29", male: 303606, female: 298013 },
                    { age: "30 to 34", male: 292780, female: 296303 },
                    { age: "35 to 39", male: 283925, female: 288526 },
                    { age: "40 to 44", male: 314544, female: 319923 },
                    { age: "45 to 49", male: 337524, female: 344097 },
                    { age: "5 to 9", male: 316345, female: 297675 },
                    { age: "50 to 54", male: 366054, female: 378332 },
                    { age: "55 to 59", male: 349590, female: 369347 },
                    { age: "60 to 64", male: 303421, female: 323815 },
                    { age: "65 to 69", male: 230810, female: 252455 },
                    { age: "70 to 74", male: 161676, female: 186453 },
                    { age: "75 to 79", male: 112555, female: 141554 },
                    { age: "80 to 84", male: 78669, female: 116914 },
                    { age: "85 and Older", male: 67110, female: 134669 },
                  ],
                  MN: [
                    { age: "0 to 5", male: 178616, female: 170645 },
                    { age: "10 to 14", male: 180951, female: 174374 },
                    { age: "15 to 17", male: 110001, female: 104197 },
                    { age: "18 to 21", male: 148247, female: 144611 },
                    { age: "22 to 24", male: 108864, female: 103755 },
                    { age: "25 to 29", male: 185766, female: 180698 },
                    { age: "30 to 34", male: 189374, female: 184845 },
                    { age: "35 to 39", male: 166613, female: 160534 },
                    { age: "40 to 44", male: 172583, female: 171011 },
                    { age: "45 to 49", male: 184130, female: 182785 },
                    { age: "5 to 9", male: 185244, female: 176674 },
                    { age: "50 to 54", male: 202427, female: 203327 },
                    { age: "55 to 59", male: 187216, female: 189980 },
                    { age: "60 to 64", male: 157586, female: 160588 },
                    { age: "65 to 69", male: 114903, female: 121985 },
                    { age: "70 to 74", male: 81660, female: 92401 },
                    { age: "75 to 79", male: 57855, female: 72839 },
                    { age: "80 to 84", male: 42192, female: 58545 },
                    { age: "85 and Older", male: 37938, female: 73211 },
                  ],
                  MO: [
                    { age: "0 to 5", male: 192851, female: 183921 },
                    { age: "10 to 14", male: 201273, female: 190020 },
                    { age: "15 to 17", male: 122944, female: 116383 },
                    { age: "18 to 21", male: 175782, female: 169076 },
                    { age: "22 to 24", male: 124584, female: 123027 },
                    { age: "25 to 29", male: 200511, female: 200134 },
                    { age: "30 to 34", male: 197781, female: 198735 },
                    { age: "35 to 39", male: 181485, female: 180002 },
                    { age: "40 to 44", male: 183318, female: 188038 },
                    { age: "45 to 49", male: 194538, female: 199735 },
                    { age: "5 to 9", male: 200091, female: 193196 },
                    { age: "50 to 54", male: 218663, female: 225083 },
                    { age: "55 to 59", male: 199513, female: 216459 },
                    { age: "60 to 64", male: 176036, female: 187668 },
                    { age: "65 to 69", male: 135605, female: 150815 },
                    { age: "70 to 74", male: 99845, female: 117802 },
                    { age: "75 to 79", male: 70734, female: 88769 },
                    { age: "80 to 84", male: 48118, female: 72085 },
                    { age: "85 and Older", male: 40331, female: 80497 },
                  ],
                  MS: [
                    { age: "0 to 5", male: 100654, female: 97079 },
                    { age: "10 to 14", male: 107363, female: 101958 },
                    { age: "15 to 17", male: 62923, female: 60591 },
                    { age: "18 to 21", male: 94460, female: 94304 },
                    { age: "22 to 24", male: 63870, female: 58909 },
                    { age: "25 to 29", male: 96027, female: 98023 },
                    { age: "30 to 34", male: 95533, female: 98837 },
                    { age: "35 to 39", male: 88278, female: 92876 },
                    { age: "40 to 44", male: 93579, female: 97851 },
                    { age: "45 to 49", male: 92103, female: 98871 },
                    { age: "5 to 9", male: 104911, female: 100694 },
                    { age: "50 to 54", male: 98578, female: 106516 },
                    { age: "55 to 59", male: 94835, female: 101616 },
                    { age: "60 to 64", male: 80677, female: 91332 },
                    { age: "65 to 69", male: 64386, female: 72940 },
                    { age: "70 to 74", male: 46712, female: 56013 },
                    { age: "75 to 79", male: 32079, female: 42598 },
                    { age: "80 to 84", male: 19966, female: 32724 },
                    { age: "85 and Older", male: 14789, female: 32626 },
                  ],
                  MT: [
                    { age: "0 to 5", male: 31021, female: 29676 },
                    { age: "10 to 14", male: 30960, female: 29710 },
                    { age: "15 to 17", male: 19558, female: 18061 },
                    { age: "18 to 21", male: 30975, female: 27314 },
                    { age: "22 to 24", male: 21419, female: 20153 },
                    { age: "25 to 29", male: 32300, female: 30805 },
                    { age: "30 to 34", male: 33167, female: 30964 },
                    { age: "35 to 39", male: 29772, female: 28999 },
                    { age: "40 to 44", male: 28538, female: 27311 },
                    { age: "45 to 49", male: 30820, female: 30608 },
                    { age: "5 to 9", male: 33641, female: 31763 },
                    { age: "50 to 54", male: 36761, female: 37476 },
                    { age: "55 to 59", male: 38291, female: 40028 },
                    { age: "60 to 64", male: 35306, female: 35021 },
                    { age: "65 to 69", male: 27786, female: 27047 },
                    { age: "70 to 74", male: 19708, female: 19938 },
                    { age: "75 to 79", male: 13344, female: 14751 },
                    { age: "80 to 84", male: 9435, female: 11392 },
                    { age: "85 and Older", male: 7361, female: 13519 },
                  ],
                  NC: [
                    { age: "0 to 5", male: 311288, female: 299882 },
                    { age: "10 to 14", male: 333622, female: 316123 },
                    { age: "15 to 17", male: 194507, female: 185872 },
                    { age: "18 to 21", male: 299506, female: 275504 },
                    { age: "22 to 24", male: 207910, female: 196277 },
                    { age: "25 to 29", male: 317709, female: 324593 },
                    { age: "30 to 34", male: 311582, female: 323483 },
                    { age: "35 to 39", male: 308195, female: 319405 },
                    { age: "40 to 44", male: 334818, female: 349484 },
                    { age: "45 to 49", male: 331086, female: 345940 },
                    { age: "5 to 9", male: 325977, female: 316564 },
                    { age: "50 to 54", male: 334674, female: 355791 },
                    { age: "55 to 59", male: 308840, female: 341170 },
                    { age: "60 to 64", male: 270508, female: 303831 },
                    { age: "65 to 69", male: 225997, female: 254521 },
                    { age: "70 to 74", male: 154010, female: 186677 },
                    { age: "75 to 79", male: 106165, female: 139937 },
                    { age: "80 to 84", male: 68871, female: 104839 },
                    { age: "85 and Older", male: 50143, female: 110032 },
                  ],
                  ND: [
                    { age: "0 to 5", male: 24524, female: 24340 },
                    { age: "10 to 14", male: 20939, female: 20728 },
                    { age: "15 to 17", male: 13197, female: 12227 },
                    { age: "18 to 21", male: 27439, female: 22447 },
                    { age: "22 to 24", male: 21413, female: 19299 },
                    { age: "25 to 29", male: 29543, female: 24602 },
                    { age: "30 to 34", male: 26425, female: 22798 },
                    { age: "35 to 39", male: 21846, female: 19046 },
                    { age: "40 to 44", male: 20123, female: 19010 },
                    { age: "45 to 49", male: 21386, female: 20572 },
                    { age: "5 to 9", male: 24336, female: 22721 },
                    { age: "50 to 54", male: 25126, female: 24631 },
                    { age: "55 to 59", male: 24412, female: 24022 },
                    { age: "60 to 64", male: 21598, female: 20250 },
                    { age: "65 to 69", male: 14868, female: 14633 },
                    { age: "70 to 74", male: 10729, female: 11878 },
                    { age: "75 to 79", male: 8086, female: 9626 },
                    { age: "80 to 84", male: 6222, female: 9241 },
                    { age: "85 and Older", male: 5751, female: 11606 },
                  ],
                  NE: [
                    { age: "0 to 5", male: 67062, female: 62974 },
                    { age: "10 to 14", male: 64843, female: 62695 },
                    { age: "15 to 17", male: 38679, female: 36116 },
                    { age: "18 to 21", male: 56143, female: 54195 },
                    { age: "22 to 24", male: 40531, female: 38139 },
                    { age: "25 to 29", male: 64277, female: 61028 },
                    { age: "30 to 34", male: 64230, female: 62423 },
                    { age: "35 to 39", male: 57741, female: 55950 },
                    { age: "40 to 44", male: 56139, female: 54518 },
                    { age: "45 to 49", male: 57526, female: 57077 },
                    { age: "5 to 9", male: 68079, female: 64509 },
                    { age: "50 to 54", male: 64444, female: 65106 },
                    { age: "55 to 59", male: 61285, female: 62057 },
                    { age: "60 to 64", male: 52560, female: 54977 },
                    { age: "65 to 69", male: 39372, female: 41007 },
                    { age: "70 to 74", male: 27091, female: 31903 },
                    { age: "75 to 79", male: 20472, female: 26808 },
                    { age: "80 to 84", male: 15625, female: 21401 },
                    { age: "85 and Older", male: 13507, female: 26876 },
                  ],
                  NH: [
                    { age: "0 to 5", male: 33531, female: 32061 },
                    { age: "10 to 14", male: 40472, female: 39574 },
                    { age: "15 to 17", male: 26632, female: 25155 },
                    { age: "18 to 21", male: 39600, female: 39270 },
                    { age: "22 to 24", male: 25067, female: 23439 },
                    { age: "25 to 29", male: 39514, female: 37529 },
                    { age: "30 to 34", male: 37282, female: 37104 },
                    { age: "35 to 39", male: 37177, female: 38432 },
                    { age: "40 to 44", male: 43571, female: 43894 },
                    { age: "45 to 49", male: 50559, female: 51423 },
                    { age: "5 to 9", male: 37873, female: 36382 },
                    { age: "50 to 54", male: 55573, female: 57097 },
                    { age: "55 to 59", male: 50802, female: 52906 },
                    { age: "60 to 64", male: 44934, female: 45384 },
                    { age: "65 to 69", male: 33322, female: 34773 },
                    { age: "70 to 74", male: 22786, female: 25421 },
                    { age: "75 to 79", male: 14988, female: 18865 },
                    { age: "80 to 84", male: 10661, female: 14921 },
                    { age: "85 and Older", male: 9140, female: 17087 },
                  ],
                  NJ: [
                    { age: "0 to 5", male: 272239, female: 261405 },
                    { age: "10 to 14", male: 296798, female: 281395 },
                    { age: "15 to 17", male: 183608, female: 174902 },
                    { age: "18 to 21", male: 236406, female: 219234 },
                    { age: "22 to 24", male: 171414, female: 162551 },
                    { age: "25 to 29", male: 288078, female: 278395 },
                    { age: "30 to 34", male: 286242, female: 288661 },
                    { age: "35 to 39", male: 278323, female: 286407 },
                    { age: "40 to 44", male: 306371, female: 315976 },
                    { age: "45 to 49", male: 324604, female: 340805 },
                    { age: "5 to 9", male: 280348, female: 272618 },
                    { age: "50 to 54", male: 335379, female: 351753 },
                    { age: "55 to 59", male: 297889, female: 316509 },
                    { age: "60 to 64", male: 243909, female: 272971 },
                    { age: "65 to 69", male: 187928, female: 216233 },
                    { age: "70 to 74", male: 130458, female: 162862 },
                    { age: "75 to 79", male: 92629, female: 121544 },
                    { age: "80 to 84", male: 68009, female: 107002 },
                    { age: "85 and Older", male: 62395, female: 130163 },
                  ],
                  NM: [
                    { age: "0 to 5", male: 70556, female: 67433 },
                    { age: "10 to 14", male: 72070, female: 69774 },
                    { age: "15 to 17", male: 42831, female: 41474 },
                    { age: "18 to 21", male: 61671, female: 59289 },
                    { age: "22 to 24", male: 47139, female: 41506 },
                    { age: "25 to 29", male: 73009, female: 67866 },
                    { age: "30 to 34", male: 69394, female: 66383 },
                    { age: "35 to 39", male: 62108, female: 60810 },
                    { age: "40 to 44", male: 61075, female: 61508 },
                    { age: "45 to 49", male: 62327, female: 64988 },
                    { age: "5 to 9", male: 72877, female: 69675 },
                    { age: "50 to 54", male: 69856, female: 73683 },
                    { age: "55 to 59", male: 66381, female: 73952 },
                    { age: "60 to 64", male: 61719, female: 66285 },
                    { age: "65 to 69", male: 48657, female: 54175 },
                    { age: "70 to 74", male: 35942, female: 39668 },
                    { age: "75 to 79", male: 24922, female: 29968 },
                    { age: "80 to 84", male: 16894, female: 21049 },
                    { age: "85 and Older", male: 12986, female: 22217 },
                  ],
                  NV: [
                    { age: "0 to 5", male: 91556, female: 87252 },
                    { age: "10 to 14", male: 92376, female: 90127 },
                    { age: "15 to 17", male: 56635, female: 53976 },
                    { age: "18 to 21", male: 72185, female: 68570 },
                    { age: "22 to 24", male: 57429, female: 54635 },
                    { age: "25 to 29", male: 103079, female: 98260 },
                    { age: "30 to 34", male: 101626, female: 97574 },
                    { age: "35 to 39", male: 95952, female: 91752 },
                    { age: "40 to 44", male: 98405, female: 96018 },
                    { age: "45 to 49", male: 98297, female: 92880 },
                    { age: "5 to 9", male: 97639, female: 92019 },
                    { age: "50 to 54", male: 96647, female: 93838 },
                    { age: "55 to 59", male: 86430, female: 90916 },
                    { age: "60 to 64", male: 79651, female: 82206 },
                    { age: "65 to 69", male: 65973, female: 70582 },
                    { age: "70 to 74", male: 48879, female: 50485 },
                    { age: "75 to 79", male: 31798, female: 33652 },
                    { age: "80 to 84", male: 19722, female: 23399 },
                    { age: "85 and Older", male: 13456, female: 22760 },
                  ],
                  NY: [
                    { age: "0 to 5", male: 601900, female: 574532 },
                    { age: "10 to 14", male: 602877, female: 576846 },
                    { age: "15 to 17", male: 381224, female: 364149 },
                    { age: "18 to 21", male: 579276, female: 563517 },
                    { age: "22 to 24", male: 423461, female: 419351 },
                    { age: "25 to 29", male: 722290, female: 728064 },
                    { age: "30 to 34", male: 668918, female: 684340 },
                    { age: "35 to 39", male: 607495, female: 628810 },
                    { age: "40 to 44", male: 632186, female: 660306 },
                    { age: "45 to 49", male: 674516, female: 708960 },
                    { age: "5 to 9", male: 588624, female: 561622 },
                    { age: "50 to 54", male: 695357, female: 740342 },
                    { age: "55 to 59", male: 633602, female: 685163 },
                    { age: "60 to 64", male: 540901, female: 604110 },
                    { age: "65 to 69", male: 409399, female: 483158 },
                    { age: "70 to 74", male: 287440, female: 357971 },
                    { age: "75 to 79", male: 207495, female: 274626 },
                    { age: "80 to 84", male: 150642, female: 231063 },
                    { age: "85 and Older", male: 134198, female: 284443 },
                  ],
                  OH: [
                    { age: "0 to 5", male: 356598, female: 339398 },
                    { age: "10 to 14", male: 385542, female: 371142 },
                    { age: "15 to 17", male: 239825, female: 228296 },
                    { age: "18 to 21", male: 331115, female: 318019 },
                    { age: "22 to 24", male: 227916, female: 225400 },
                    { age: "25 to 29", male: 369646, female: 367475 },
                    { age: "30 to 34", male: 356757, female: 359375 },
                    { age: "35 to 39", male: 338273, female: 340410 },
                    { age: "40 to 44", male: 368578, female: 375476 },
                    { age: "45 to 49", male: 385388, female: 394341 },
                    { age: "5 to 9", male: 376976, female: 358242 },
                    { age: "50 to 54", male: 420561, female: 438290 },
                    { age: "55 to 59", male: 403067, female: 427137 },
                    { age: "60 to 64", male: 350563, female: 374890 },
                    { age: "65 to 69", male: 262844, female: 292745 },
                    { age: "70 to 74", male: 183419, female: 222552 },
                    { age: "75 to 79", male: 131940, female: 173303 },
                    { age: "80 to 84", male: 93267, female: 140079 },
                    { age: "85 and Older", male: 80618, female: 166514 },
                  ],
                  OK: [
                    { age: "0 to 5", male: 135423, female: 130297 },
                    { age: "10 to 14", male: 133539, female: 128110 },
                    { age: "15 to 17", male: 79207, female: 74080 },
                    { age: "18 to 21", male: 115423, female: 107651 },
                    { age: "22 to 24", male: 85610, female: 80749 },
                    { age: "25 to 29", male: 135217, female: 130966 },
                    { age: "30 to 34", male: 132683, female: 128496 },
                    { age: "35 to 39", male: 118240, female: 116104 },
                    { age: "40 to 44", male: 118534, female: 117501 },
                    { age: "45 to 49", male: 117065, female: 118300 },
                    { age: "5 to 9", male: 137212, female: 130040 },
                    { age: "50 to 54", male: 129964, female: 132941 },
                    { age: "55 to 59", male: 121988, female: 129033 },
                    { age: "60 to 64", male: 105018, female: 113144 },
                    { age: "65 to 69", male: 82818, female: 93914 },
                    { age: "70 to 74", male: 62979, female: 71856 },
                    { age: "75 to 79", male: 43899, female: 54848 },
                    { age: "80 to 84", male: 29237, female: 42044 },
                    { age: "85 and Older", male: 22888, female: 42715 },
                  ],
                  OR: [
                    { age: "0 to 5", male: 118561, female: 112841 },
                    { age: "10 to 14", male: 123223, female: 116373 },
                    { age: "15 to 17", male: 75620, female: 71764 },
                    { age: "18 to 21", male: 106121, female: 103044 },
                    { age: "22 to 24", male: 79106, female: 75639 },
                    { age: "25 to 29", male: 134241, female: 131539 },
                    { age: "30 to 34", male: 137090, female: 135734 },
                    { age: "35 to 39", male: 128812, female: 126071 },
                    { age: "40 to 44", male: 131405, female: 126875 },
                    { age: "45 to 49", male: 125373, female: 125074 },
                    { age: "5 to 9", male: 122920, female: 119049 },
                    { age: "50 to 54", male: 131932, female: 137021 },
                    { age: "55 to 59", male: 130434, female: 141380 },
                    { age: "60 to 64", male: 129063, female: 136051 },
                    { age: "65 to 69", male: 99577, female: 106208 },
                    { age: "70 to 74", male: 69028, female: 77428 },
                    { age: "75 to 79", male: 46055, female: 53682 },
                    { age: "80 to 84", male: 30900, female: 41853 },
                    { age: "85 and Older", male: 28992, female: 53154 },
                  ],
                  PA: [
                    { age: "0 to 5", male: 367290, female: 350371 },
                    { age: "10 to 14", male: 393719, female: 374666 },
                    { age: "15 to 17", male: 250754, female: 236670 },
                    { age: "18 to 21", male: 378940, female: 369819 },
                    { age: "22 to 24", male: 251063, female: 243391 },
                    { age: "25 to 29", male: 420247, female: 410193 },
                    { age: "30 to 34", male: 391190, female: 387225 },
                    { age: "35 to 39", male: 365742, female: 365646 },
                    { age: "40 to 44", male: 399152, female: 405848 },
                    { age: "45 to 49", male: 435250, female: 446328 },
                    { age: "5 to 9", male: 381910, female: 366854 },
                    { age: "50 to 54", male: 472070, female: 489057 },
                    { age: "55 to 59", male: 456215, female: 475044 },
                    { age: "60 to 64", male: 390595, female: 419924 },
                    { age: "65 to 69", male: 301610, female: 335127 },
                    { age: "70 to 74", male: 212200, female: 256188 },
                    { age: "75 to 79", male: 156335, female: 205974 },
                    { age: "80 to 84", male: 117050, female: 178358 },
                    { age: "85 and Older", male: 104012, female: 217532 },
                  ],
                  RI: [
                    { age: "0 to 5", male: 28289, female: 26941 },
                    { age: "10 to 14", male: 31383, female: 30724 },
                    { age: "15 to 17", male: 20093, female: 19249 },
                    { age: "18 to 21", male: 35376, female: 37870 },
                    { age: "22 to 24", male: 23397, female: 21358 },
                    { age: "25 to 29", male: 35958, female: 34710 },
                    { age: "30 to 34", male: 32410, female: 32567 },
                    { age: "35 to 39", male: 30325, female: 31145 },
                    { age: "40 to 44", male: 32542, female: 34087 },
                    { age: "45 to 49", male: 36151, female: 38462 },
                    { age: "5 to 9", male: 30462, female: 27878 },
                    { age: "50 to 54", male: 38419, female: 41642 },
                    { age: "55 to 59", male: 36706, female: 39127 },
                    { age: "60 to 64", male: 30349, female: 33752 },
                    { age: "65 to 69", male: 23462, female: 26311 },
                    { age: "70 to 74", male: 16385, female: 19335 },
                    { age: "75 to 79", male: 10978, female: 14833 },
                    { age: "80 to 84", male: 9224, female: 13439 },
                    { age: "85 and Older", male: 8479, female: 19843 },
                  ],
                  SC: [
                    { age: "0 to 5", male: 148363, female: 144218 },
                    { age: "10 to 14", male: 153051, female: 148064 },
                    { age: "15 to 17", male: 92781, female: 88090 },
                    { age: "18 to 21", male: 150464, female: 136857 },
                    { age: "22 to 24", male: 99237, female: 99178 },
                    { age: "25 to 29", male: 156273, female: 156982 },
                    { age: "30 to 34", male: 148237, female: 153197 },
                    { age: "35 to 39", male: 139949, female: 146281 },
                    { age: "40 to 44", male: 151524, female: 157192 },
                    { age: "45 to 49", male: 153110, female: 163562 },
                    { age: "5 to 9", male: 156323, female: 150943 },
                    { age: "50 to 54", male: 161003, female: 173752 },
                    { age: "55 to 59", male: 150770, female: 169238 },
                    { age: "60 to 64", male: 141268, female: 160890 },
                    { age: "65 to 69", male: 120618, female: 137154 },
                    { age: "70 to 74", male: 85197, female: 97581 },
                    { age: "75 to 79", male: 55278, female: 69067 },
                    { age: "80 to 84", male: 33979, female: 50585 },
                    { age: "85 and Older", male: 24984, female: 52336 },
                  ],
                  SD: [
                    { age: "0 to 5", male: 30615, female: 29377 },
                    { age: "10 to 14", male: 28360, female: 26492 },
                    { age: "15 to 17", male: 17193, female: 16250 },
                    { age: "18 to 21", male: 25514, female: 24234 },
                    { age: "22 to 24", male: 18413, female: 16324 },
                    { age: "25 to 29", male: 29131, female: 26757 },
                    { age: "30 to 34", male: 28133, female: 26710 },
                    { age: "35 to 39", male: 24971, female: 23347 },
                    { age: "40 to 44", male: 24234, female: 23231 },
                    { age: "45 to 49", male: 25555, female: 24867 },
                    { age: "5 to 9", male: 30399, female: 28980 },
                    { age: "50 to 54", male: 29754, female: 29530 },
                    { age: "55 to 59", male: 29075, female: 28968 },
                    { age: "60 to 64", male: 25633, female: 25530 },
                    { age: "65 to 69", male: 19320, female: 18489 },
                    { age: "70 to 74", male: 12964, female: 14702 },
                    { age: "75 to 79", male: 9646, female: 12077 },
                    { age: "80 to 84", male: 7669, female: 10566 },
                    { age: "85 and Older", male: 6898, female: 13282 },
                  ],
                  TN: [
                    { age: "0 to 5", male: 204457, female: 196347 },
                    { age: "10 to 14", male: 217061, female: 206350 },
                    { age: "15 to 17", male: 129690, female: 124122 },
                    { age: "18 to 21", male: 183910, female: 175377 },
                    { age: "22 to 24", male: 132501, female: 134905 },
                    { age: "25 to 29", male: 210618, female: 214944 },
                    { age: "30 to 34", male: 209305, female: 214151 },
                    { age: "35 to 39", male: 200270, female: 207520 },
                    { age: "40 to 44", male: 216542, female: 219178 },
                    { age: "45 to 49", male: 217059, female: 224473 },
                    { age: "5 to 9", male: 210365, female: 204494 },
                    { age: "50 to 54", male: 223663, female: 238025 },
                    { age: "55 to 59", male: 210228, female: 229974 },
                    { age: "60 to 64", male: 186739, female: 207022 },
                    { age: "65 to 69", male: 153737, female: 171357 },
                    { age: "70 to 74", male: 108743, female: 125362 },
                    { age: "75 to 79", male: 72813, female: 94077 },
                    { age: "80 to 84", male: 46556, female: 71212 },
                    { age: "85 and Older", male: 33499, female: 72969 },
                  ],
                  TX: [
                    { age: "0 to 5", male: 996070, female: 955235 },
                    { age: "10 to 14", male: 998209, female: 959762 },
                    { age: "15 to 17", male: 587712, female: 561008 },
                    { age: "18 to 21", male: 818590, female: 756451 },
                    { age: "22 to 24", male: 582570, female: 556850 },
                    { age: "25 to 29", male: 982673, female: 948564 },
                    { age: "30 to 34", male: 961403, female: 947710 },
                    { age: "35 to 39", male: 897542, female: 898907 },
                    { age: "40 to 44", male: 897922, female: 908091 },
                    { age: "45 to 49", male: 857621, female: 865642 },
                    { age: "5 to 9", male: 1021123, female: 979891 },
                    { age: "50 to 54", male: 861849, female: 880746 },
                    { age: "55 to 59", male: 761410, female: 799294 },
                    { age: "60 to 64", male: 635465, female: 692072 },
                    { age: "65 to 69", male: 483436, female: 533368 },
                    { age: "70 to 74", male: 330457, female: 389996 },
                    { age: "75 to 79", male: 228243, female: 289446 },
                    { age: "80 to 84", male: 153391, female: 219572 },
                    { age: "85 and Older", male: 115630, female: 224693 },
                  ],
                  UT: [
                    { age: "0 to 5", male: 130873, female: 124371 },
                    { age: "10 to 14", male: 128076, female: 120364 },
                    { age: "15 to 17", male: 70832, female: 66798 },
                    { age: "18 to 21", male: 87877, female: 92950 },
                    { age: "22 to 24", male: 79431, female: 71405 },
                    { age: "25 to 29", male: 109125, female: 106576 },
                    { age: "30 to 34", male: 115198, female: 110546 },
                    { age: "35 to 39", male: 102771, female: 99664 },
                    { age: "40 to 44", male: 88181, female: 83229 },
                    { age: "45 to 49", male: 76552, female: 74993 },
                    { age: "5 to 9", male: 131094, female: 125110 },
                    { age: "50 to 54", male: 76913, female: 78113 },
                    { age: "55 to 59", male: 71490, female: 73221 },
                    { age: "60 to 64", male: 60996, female: 63835 },
                    { age: "65 to 69", male: 45491, female: 49273 },
                    { age: "70 to 74", male: 32191, female: 35931 },
                    { age: "75 to 79", male: 23112, female: 27761 },
                    { age: "80 to 84", male: 15827, female: 20155 },
                    { age: "85 and Older", male: 13199, female: 19855 },
                  ],
                  VA: [
                    { age: "0 to 5", male: 262278, female: 25e4 },
                    { age: "10 to 14", male: 266247, female: 251516 },
                    { age: "15 to 17", male: 160174, female: 153149 },
                    { age: "18 to 21", male: 248284, female: 233796 },
                    { age: "22 to 24", male: 175833, female: 167676 },
                    { age: "25 to 29", male: 296682, female: 287052 },
                    { age: "30 to 34", male: 286536, female: 283804 },
                    { age: "35 to 39", male: 264490, female: 265951 },
                    { age: "40 to 44", male: 278474, female: 286095 },
                    { age: "45 to 49", male: 286793, female: 297558 },
                    { age: "5 to 9", male: 264413, female: 256891 },
                    { age: "50 to 54", male: 296096, female: 309898 },
                    { age: "55 to 59", male: 262954, female: 283219 },
                    { age: "60 to 64", male: 228721, female: 250389 },
                    { age: "65 to 69", male: 178498, female: 197033 },
                    { age: "70 to 74", male: 123597, female: 146376 },
                    { age: "75 to 79", male: 82281, female: 103044 },
                    { age: "80 to 84", male: 55037, female: 80081 },
                    { age: "85 and Older", male: 43560, female: 92154 },
                  ],
                  VT: [
                    { age: "0 to 5", male: 15766, female: 14629 },
                    { age: "10 to 14", male: 18674, female: 17317 },
                    { age: "15 to 17", male: 11909, female: 11565 },
                    { age: "18 to 21", male: 21686, female: 20502 },
                    { age: "22 to 24", male: 12648, female: 11840 },
                    { age: "25 to 29", male: 18005, female: 17548 },
                    { age: "30 to 34", male: 17565, female: 18161 },
                    { age: "35 to 39", male: 16856, female: 17454 },
                    { age: "40 to 44", male: 19431, female: 19600 },
                    { age: "45 to 49", male: 21315, female: 22377 },
                    { age: "5 to 9", male: 17073, female: 16338 },
                    { age: "50 to 54", male: 24629, female: 26080 },
                    { age: "55 to 59", male: 24925, female: 25588 },
                    { age: "60 to 64", male: 21769, female: 23081 },
                    { age: "65 to 69", male: 16842, female: 17925 },
                    { age: "70 to 74", male: 11855, female: 12331 },
                    { age: "75 to 79", male: 7639, female: 9192 },
                    { age: "80 to 84", male: 5291, female: 8001 },
                    { age: "85 and Older", male: 4695, female: 8502 },
                  ],
                  WA: [
                    { age: "0 to 5", male: 228403, female: 217400 },
                    { age: "10 to 14", male: 224142, female: 217269 },
                    { age: "15 to 17", male: 136967, female: 130193 },
                    { age: "18 to 21", male: 195001, female: 179996 },
                    { age: "22 to 24", male: 151577, female: 140876 },
                    { age: "25 to 29", male: 260873, female: 244497 },
                    { age: "30 to 34", male: 252612, female: 243147 },
                    { age: "35 to 39", male: 230325, female: 223596 },
                    { age: "40 to 44", male: 234066, female: 228073 },
                    { age: "45 to 49", male: 233107, female: 230232 },
                    { age: "5 to 9", male: 227824, female: 214378 },
                    { age: "50 to 54", male: 245685, female: 247691 },
                    { age: "55 to 59", male: 231612, female: 241813 },
                    { age: "60 to 64", male: 206233, female: 219560 },
                    { age: "65 to 69", male: 158697, female: 170678 },
                    { age: "70 to 74", male: 107931, female: 118093 },
                    { age: "75 to 79", male: 70497, female: 83476 },
                    { age: "80 to 84", male: 48802, female: 66167 },
                    { age: "85 and Older", male: 43371, female: 80604 },
                  ],
                  WI: [
                    { age: "0 to 5", male: 176217, female: 168178 },
                    { age: "10 to 14", male: 191911, female: 180587 },
                    { age: "15 to 17", male: 115730, female: 110660 },
                    { age: "18 to 21", male: 167063, female: 161358 },
                    { age: "22 to 24", male: 117861, female: 113393 },
                    { age: "25 to 29", male: 183464, female: 176718 },
                    { age: "30 to 34", male: 187494, female: 181605 },
                    { age: "35 to 39", male: 172689, female: 168116 },
                    { age: "40 to 44", male: 179862, female: 176322 },
                    { age: "45 to 49", male: 198114, female: 197462 },
                    { age: "5 to 9", male: 186006, female: 180034 },
                    { age: "50 to 54", male: 217886, female: 219813 },
                    { age: "55 to 59", male: 204370, female: 206108 },
                    { age: "60 to 64", male: 176161, female: 178738 },
                    { age: "65 to 69", male: 130349, female: 136552 },
                    { age: "70 to 74", male: 90955, female: 103217 },
                    { age: "75 to 79", male: 65738, female: 81341 },
                    { age: "80 to 84", male: 48337, female: 67614 },
                    { age: "85 and Older", male: 41178, female: 82916 },
                  ],
                  WV: [
                    { age: "0 to 5", male: 52472, female: 50287 },
                    { age: "10 to 14", male: 55269, female: 52689 },
                    { age: "15 to 17", male: 34100, female: 32359 },
                    { age: "18 to 21", male: 51801, female: 48967 },
                    { age: "22 to 24", male: 35920, female: 34241 },
                    { age: "25 to 29", male: 54564, female: 52255 },
                    { age: "30 to 34", male: 56430, female: 55121 },
                    { age: "35 to 39", male: 55764, female: 55399 },
                    { age: "40 to 44", male: 60662, female: 59373 },
                    { age: "45 to 49", male: 61771, female: 61257 },
                    { age: "5 to 9", male: 53707, female: 51490 },
                    { age: "50 to 54", male: 66156, female: 68671 },
                    { age: "55 to 59", male: 66936, female: 71680 },
                    { age: "60 to 64", male: 65717, female: 67056 },
                    { age: "65 to 69", male: 51285, female: 54807 },
                    { age: "70 to 74", male: 36504, female: 39946 },
                    { age: "75 to 79", male: 25738, female: 31619 },
                    { age: "80 to 84", male: 16397, female: 24351 },
                    { age: "85 and Older", male: 12438, female: 26221 },
                  ],
                  WY: [
                    { age: "0 to 5", male: 19649, female: 18996 },
                    { age: "10 to 14", male: 20703, female: 17785 },
                    { age: "15 to 17", male: 11500, female: 10383 },
                    { age: "18 to 21", male: 18008, female: 15534 },
                    { age: "22 to 24", male: 12727, female: 11405 },
                    { age: "25 to 29", male: 21459, female: 19350 },
                    { age: "30 to 34", male: 21008, female: 19465 },
                    { age: "35 to 39", male: 18573, female: 17022 },
                    { age: "40 to 44", male: 17553, female: 16402 },
                    { age: "45 to 49", male: 17580, female: 16702 },
                    { age: "5 to 9", male: 19198, female: 19519 },
                    { age: "50 to 54", male: 20337, female: 20958 },
                    { age: "55 to 59", male: 21523, female: 21e3 },
                    { age: "60 to 64", male: 19048, female: 18292 },
                    { age: "65 to 69", male: 13999, female: 13130 },
                    { age: "70 to 74", male: 8710, female: 9880 },
                    { age: "75 to 79", male: 6149, female: 6938 },
                    { age: "80 to 84", male: 4442, female: 5560 },
                    { age: "85 and Older", male: 3395, female: 5797 },
                  ],
                };
              function r(e) {
                for (var t = 0, a = 0, l = 0; l < e.length; l++)
                  (t += (r = e[l]).male), (a += r.female);
                for (l = 0; l < e.length; l++) {
                  var r;
                  ((r = e[l]).malePercent =
                    (-1 * Math.round((r.male / t) * 1e4)) / 100),
                    (r.femalePercent = Math.round((r.female / a) * 1e4) / 100);
                }
                return e;
              }
              (a = r(a)),
                (t = am5.Root.new(e)).setThemes([am5themes_Animated.new(t)]);
              var o = t.container.children.push(
                am5.Container.new(t, {
                  layout: t.horizontalLayout,
                  width: am5.p100,
                  height: am5.p100,
                })
              );
              t.numberFormatter.setAll({ numberFormat: "#.##as" });
              var i = o.children.push(
                  am5xy.XYChart.new(t, {
                    panX: !1,
                    panY: !1,
                    wheelX: "none",
                    wheelY: "none",
                    layout: t.verticalLayout,
                    width: am5.percent(60),
                  })
                ),
                s = i.yAxes.push(
                  am5xy.CategoryAxis.new(t, {
                    categoryField: "age",
                    renderer: am5xy.AxisRendererY.new(t, {}),
                  })
                );
              s
                .get("renderer")
                .labels.template.setAll({
                  paddingTop: 0,
                  fontWeight: "400",
                  fontSize: 11,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
                }),
                s
                  .get("renderer")
                  .grid.template.setAll({
                    stroke: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-300")
                    ),
                    strokeWidth: 1,
                    strokeOpacity: 1,
                    strokeDasharray: [3],
                  }),
                s.data.setAll(a);
              var n = i.yAxes.push(
                am5xy.CategoryAxis.new(t, {
                  categoryField: "age",
                  renderer: am5xy.AxisRendererY.new(t, { opposite: !0 }),
                })
              );
              n
                .get("renderer")
                .grid.template.setAll({
                  stroke: am5.color(
                    KTUtil.getCssVariableValue("--bs-gray-300")
                  ),
                  strokeWidth: 1,
                  strokeOpacity: 1,
                  strokeDasharray: [3],
                }),
                n
                  .get("renderer")
                  .labels.template.setAll({
                    paddingTop: 0,
                    fontWeight: "400",
                    fontSize: 11,
                    fill: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-500")
                    ),
                  }),
                n.data.setAll(a);
              var d = i.xAxes.push(
                am5xy.ValueAxis.new(t, {
                  min: -10,
                  max: 10,
                  numberFormat: "#.s'%'",
                  renderer: am5xy.AxisRendererX.new(t, { minGridDistance: 40 }),
                })
              );
              d
                .get("renderer")
                .labels.template.setAll({
                  paddingTop: 20,
                  fontWeight: "400",
                  fontSize: 11,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
                }),
                d
                  .get("renderer")
                  .grid.template.setAll({ disabled: !0, strokeOpacity: 0 });
              var m = i.series.push(
                am5xy.ColumnSeries.new(t, {
                  name: "Males",
                  xAxis: d,
                  yAxis: s,
                  valueXField: "malePercent",
                  categoryYField: "age",
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                  clustered: !1,
                })
              );
              m.columns.template.setAll({
                tooltipText:
                  "Males, age {categoryY}: {male} ({malePercent.formatNumber('#.0s')}%)",
                tooltipX: am5.p100,
                cornerRadiusBR: 4,
                cornerRadiusTR: 4,
                cornerRadiusBL: 0,
                cornerRadiusTL: 0,
              }),
                m.data.setAll(a);
              var c = i.series.push(
                am5xy.ColumnSeries.new(t, {
                  name: "Males",
                  xAxis: d,
                  yAxis: s,
                  valueXField: "femalePercent",
                  categoryYField: "age",
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-primary")),
                  clustered: !1,
                })
              );
              c.columns.template.setAll({
                tooltipText:
                  "Males, age {categoryY}: {female} ({femalePercent.formatNumber('#.0s')}%)",
                tooltipX: am5.p100,
                cornerRadiusBR: 4,
                cornerRadiusTR: 4,
                cornerRadiusBL: 0,
                cornerRadiusTL: 0,
              }),
                c.data.setAll(a),
                i.plotContainer.children.push(
                  am5.Label.new(t, {
                    text: "Males",
                    fontSize: 13,
                    fontWeight: "500",
                    y: 5,
                    x: 5,
                    fill: m.get("fill"),
                  })
                ),
                i.plotContainer.children.push(
                  am5.Label.new(t, {
                    text: "Females",
                    fontSize: 13,
                    fontWeight: "500",
                    y: 5,
                    x: am5.p100,
                    centerX: am5.p100,
                    dx: -5,
                    fill: c.get("fill"),
                  })
                );
              var g = o.children.push(
                am5map.MapChart.new(t, {
                  panX: "none",
                  panY: "none",
                  wheelY: "none",
                  projection: am5map.geoAlbersUsa(),
                  width: am5.percent(40),
                })
              );
              i.getTooltip().set("autoTextColor", !1);
              var f,
                u = g.children.push(
                  am5.Label.new(t, {
                    text: "United States",
                    fontSize: 14,
                    fontWeight: "500",
                    fill: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-800")
                    ),
                    y: 20,
                    x: am5.p50,
                    centerX: am5.p50,
                  })
                ),
                h = g.series.push(
                  am5map.MapPolygonSeries.new(t, {
                    fill: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-300")
                    ),
                    geoJSON: am5geodata_usaLow,
                  })
                );
              h.mapPolygons.template.setAll({
                tooltipText: "{name}",
                interactive: !0,
              }),
                h.mapPolygons.template.states.create("hover", {
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                }),
                h.mapPolygons.template.states.create("active", {
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                }),
                h.mapPolygons.template.events.on("click", function (e) {
                  f && f.set("active", !1), (f = e.target).set("active", !0);
                  for (
                    var t = e.target.dataItem.dataContext.id.split("-").pop(),
                      a = r(l[t]),
                      o = 0;
                    o < a.length;
                    o++
                  )
                    m.data.setIndex(o, a[o]), c.data.setIndex(o, a[o]);
                  u.set("text", e.target.dataItem.dataContext.name);
                });
            };
          am5.ready(function () {
            a();
          }),
            KTThemeMode.on("kt.thememode.change", function () {
              t.dispose(), a();
            });
        }
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTChartsWidget24),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget24.init();
  });
var KTChartsWidget25 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.getElementById("kt_charts_widget_25_chart_1");
        if (e) {
          var t,
            a = function () {
              (t = am5.Root.new(e)).setThemes([am5themes_Animated.new(t)]);
              var a = t.container.children.push(
                am5radar.RadarChart.new(t, {
                  panX: !1,
                  panY: !1,
                  wheelX: "panX",
                  wheelY: "zoomX",
                  innerRadius: am5.percent(40),
                  radius: am5.percent(70),
                  arrangeTooltips: !1,
                })
              );
              a.set(
                "cursor",
                am5radar.RadarCursor.new(t, { behavior: "zoomX" })
              ).lineY.set("visible", !1);
              var l = am5radar.AxisRendererCircular.new(t, {
                minGridDistance: 30,
              });
              l.labels.template.setAll({
                textType: "radial",
                radius: 10,
                paddingTop: 0,
                paddingBottom: 0,
                centerY: am5.p50,
                fontWeight: "400",
                fontSize: 11,
                fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-700")),
              }),
                l.grid.template.setAll({
                  location: 0.5,
                  strokeDasharray: [2, 2],
                  stroke: KTUtil.getCssVariableValue("--bs-gray-400"),
                });
              var r = a.xAxes.push(
                  am5xy.CategoryAxis.new(t, {
                    maxDeviation: 0,
                    categoryField: "name",
                    renderer: l,
                  })
                ),
                o = am5radar.AxisRendererRadial.new(t, { minGridDistance: 30 });
              o.labels.template.setAll({
                fontWeight: "500",
                fontSize: 12,
                fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-700")),
              });
              var i = a.yAxes.push(am5xy.ValueAxis.new(t, { renderer: o }));
              o.grid.template.setAll({
                strokeDasharray: [2, 2],
                stroke: KTUtil.getCssVariableValue("--bs-gray-400"),
              });
              var s = a.series.push(
                am5radar.RadarLineSeries.new(t, {
                  name: "Revenue",
                  xAxis: r,
                  yAxis: i,
                  valueYField: "value1",
                  categoryXField: "name",
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-primary")),
                })
              );
              s.strokes.template.setAll({ strokeOpacity: 0 }),
                s.fills.template.setAll({
                  visible: !0,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-primary")),
                  fillOpacity: 0.5,
                });
              var n = a.series.push(
                am5radar.RadarLineSeries.new(t, {
                  name: "Expense",
                  xAxis: r,
                  yAxis: i,
                  valueYField: "value2",
                  categoryXField: "name",
                  stacked: !0,
                  tooltip: am5.Tooltip.new(t, {
                    labelText: "Revenue: {value1}\nExpense:{value2}",
                  }),
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                })
              );
              n.strokes.template.setAll({ strokeOpacity: 0 }),
                n.fills.template.setAll({
                  visible: !0,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-primary")),
                  fillOpacity: 0.5,
                });
              var d = a.radarContainer.children.push(
                am5.Legend.new(t, {
                  width: 150,
                  centerX: am5.p50,
                  centerY: am5.p50,
                })
              );
              d.data.setAll([s, n]),
                d.labels.template.setAll({
                  fontWeight: "600",
                  fontSize: 13,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-700")),
                });
              var m = [
                { name: "Openlane", value1: 160.2, value2: 26.9 },
                { name: "Yearin", value1: 120.1, value2: 50.5 },
                { name: "Goodsilron", value1: 150.7, value2: 12.3 },
                { name: "Condax", value1: 69.4, value2: 74.5 },
                { name: "Opentech", value1: 78.5, value2: 29.7 },
                { name: "Golddex", value1: 77.6, value2: 102.2 },
                { name: "Isdom", value1: 69.8, value2: 22.6 },
                { name: "Plusstrip", value1: 63.6, value2: 45.3 },
                { name: "Kinnamplus", value1: 59.7, value2: 12.8 },
                { name: "Zumgoity", value1: 64.3, value2: 19.6 },
                { name: "Stanredtax", value1: 52.9, value2: 96.3 },
                { name: "Conecom", value1: 42.9, value2: 11.9 },
                { name: "Zencorporation", value1: 40.9, value2: 16.8 },
                { name: "Iselectrics", value1: 39.2, value2: 9.9 },
                { name: "Treequote", value1: 76.6, value2: 36.9 },
                { name: "Sumace", value1: 34.8, value2: 14.6 },
                { name: "Lexiqvolax", value1: 32.1, value2: 35.6 },
                { name: "Sunnamplex", value1: 31.8, value2: 5.9 },
                { name: "Faxquote", value1: 29.3, value2: 14.7 },
                { name: "Donware", value1: 23, value2: 2.8 },
                { name: "Warephase", value1: 21.5, value2: 12.1 },
                { name: "Donquadtech", value1: 19.7, value2: 10.8 },
                { name: "Nam-zim", value1: 15.5, value2: 4.1 },
                { name: "Y-corporation", value1: 14.2, value2: 11.3 },
              ];
              s.data.setAll(m),
                n.data.setAll(m),
                r.data.setAll(m),
                s.appear(1e3),
                n.appear(1e3),
                a.appear(1e3, 100);
            };
          am5.ready(function () {
            a();
          }),
            KTThemeMode.on("kt.thememode.change", function () {
              t.dispose(), a();
            });
        }
      }
    })(),
      (function () {
        if ("undefined" != typeof am5) {
          var e = document.getElementById("kt_charts_widget_25_chart_2");
          if (e) {
            var t,
              a = function () {
                (t = am5.Root.new(e)).setThemes([am5themes_Animated.new(t)]);
                var a = t.container.children.push(
                  am5radar.RadarChart.new(t, {
                    panX: !1,
                    panY: !1,
                    wheelX: "panX",
                    wheelY: "zoomX",
                    innerRadius: am5.percent(40),
                    radius: am5.percent(70),
                    arrangeTooltips: !1,
                  })
                );
                a.set(
                  "cursor",
                  am5radar.RadarCursor.new(t, { behavior: "zoomX" })
                ).lineY.set("visible", !1);
                var l = am5radar.AxisRendererCircular.new(t, {
                  minGridDistance: 30,
                });
                l.labels.template.setAll({
                  textType: "radial",
                  radius: 10,
                  paddingTop: 0,
                  paddingBottom: 0,
                  centerY: am5.p50,
                  fontWeight: "400",
                  fontSize: 11,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-700")),
                }),
                  l.grid.template.setAll({
                    location: 0.5,
                    strokeDasharray: [2, 2],
                    stroke: KTUtil.getCssVariableValue("--bs-gray-400"),
                  });
                var r = a.xAxes.push(
                    am5xy.CategoryAxis.new(t, {
                      maxDeviation: 0,
                      categoryField: "name",
                      renderer: l,
                    })
                  ),
                  o = am5radar.AxisRendererRadial.new(t, {
                    minGridDistance: 30,
                  }),
                  i = a.yAxes.push(am5xy.ValueAxis.new(t, { renderer: o }));
                o.grid.template.setAll({
                  strokeDasharray: [2, 2],
                  stroke: KTUtil.getCssVariableValue("--bs-gray-400"),
                }),
                  o.labels.template.setAll({
                    fontWeight: "500",
                    fontSize: 12,
                    fill: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-700")
                    ),
                  });
                var s = a.series.push(
                  am5radar.RadarLineSeries.new(t, {
                    name: "Revenue",
                    xAxis: r,
                    yAxis: i,
                    valueYField: "value1",
                    categoryXField: "name",
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-primary")),
                  })
                );
                s.strokes.template.setAll({ strokeOpacity: 0 }),
                  s.fills.template.setAll({
                    visible: !0,
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-primary")),
                    fillOpacity: 0.5,
                  });
                var n = a.series.push(
                  am5radar.RadarLineSeries.new(t, {
                    name: "Expense",
                    xAxis: r,
                    yAxis: i,
                    valueYField: "value2",
                    categoryXField: "name",
                    stacked: !0,
                    tooltip: am5.Tooltip.new(t, {
                      labelText: "Revenue: {value1}\nExpense:{value2}",
                    }),
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                  })
                );
                n.strokes.template.setAll({ strokeOpacity: 0 }),
                  n.fills.template.setAll({
                    visible: !0,
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-primary")),
                    fillOpacity: 0.5,
                  });
                var d = a.radarContainer.children.push(
                  am5.Legend.new(t, {
                    width: 150,
                    centerX: am5.p50,
                    centerY: am5.p50,
                  })
                );
                d.data.setAll([s, n]),
                  d.labels.template.setAll({
                    fontWeight: "600",
                    fontSize: 13,
                    fill: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-700")
                    ),
                  });
                var m = [
                  { name: "Openlane", value1: 160.2, value2: 66.9 },
                  { name: "Yearin", value1: 150.1, value2: 50.5 },
                  { name: "Goodsilron", value1: 120.7, value2: 32.3 },
                  { name: "Condax", value1: 89.4, value2: 74.5 },
                  { name: "Opentech", value1: 78.5, value2: 29.7 },
                  { name: "Golddex", value1: 77.6, value2: 102.2 },
                  { name: "Isdom", value1: 69.8, value2: 22.6 },
                  { name: "Plusstrip", value1: 63.6, value2: 45.3 },
                  { name: "Kinnamplus", value1: 59.7, value2: 12.8 },
                  { name: "Zumgoity", value1: 54.3, value2: 19.6 },
                  { name: "Stanredtax", value1: 52.9, value2: 96.3 },
                  { name: "Conecom", value1: 42.9, value2: 11.9 },
                  { name: "Zencorporation", value1: 40.9, value2: 16.8 },
                  { name: "Iselectrics", value1: 39.2, value2: 9.9 },
                  { name: "Treequote", value1: 36.6, value2: 36.9 },
                  { name: "Sumace", value1: 34.8, value2: 14.6 },
                  { name: "Lexiqvolax", value1: 32.1, value2: 35.6 },
                  { name: "Sunnamplex", value1: 31.8, value2: 5.9 },
                  { name: "Faxquote", value1: 29.3, value2: 14.7 },
                  { name: "Donware", value1: 23, value2: 2.8 },
                  { name: "Warephase", value1: 21.5, value2: 12.1 },
                  { name: "Donquadtech", value1: 19.7, value2: 10.8 },
                  { name: "Nam-zim", value1: 15.5, value2: 4.1 },
                  { name: "Y-corporation", value1: 14.2, value2: 11.3 },
                ];
                s.data.setAll(m),
                  n.data.setAll(m),
                  r.data.setAll(m),
                  s.appear(1e3),
                  n.appear(1e3),
                  a.appear(1e3, 100);
              };
            am5.ready(function () {
              a();
            }),
              KTThemeMode.on("kt.thememode.change", function () {
                t.dispose(), a();
              });
          }
        }
      })();
  },
};
"undefined" != typeof module && (module.exports = KTChartsWidget25),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget25.init();
  });
var KTChartsWidget26 = (function () {
  var e = { self: null, rendered: !1 },
    t = function () {
      var t = document.getElementById("kt_charts_widget_26");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-gray-500"),
          r = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          o = KTUtil.getCssVariableValue("--bs-primary"),
          i = KTUtil.getCssVariableValue("--bs-primary"),
          s = {
            series: [
              {
                name: t.getAttribute("data-kt-chart-info"),
                data: [
                  34.5, 34.5, 35, 35, 35.5, 35.5, 35, 35, 35.5, 35.5, 35, 35,
                  34.5, 34.5, 35, 35, 35.5, 35.5, 35,
                ],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0,
                stops: [0, 80, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [o] },
            xaxis: {
              categories: [
                "",
                "Apr 02",
                "Apr 03",
                "Apr 04",
                "Apr 05",
                "Apr 06",
                "Apr 07",
                "Apr 08",
                "Apr 09",
                "Apr 10",
                "Apr 11",
                "Apr 12",
                "Apr 13",
                "Apr 14",
                "Apr 17",
                "Apr 18",
                "Apr 19",
                "Apr 21",
                "",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              tickAmount: 6,
              labels: {
                rotate: 0,
                rotateAlways: !0,
                style: { colors: l, fontSize: "12px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: o, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: {
              max: 36.3,
              min: 33,
              tickAmount: 6,
              labels: {
                style: { colors: l, fontSize: "12px" },
                formatter: function (e) {
                  return "$" + parseInt(10 * e);
                },
              },
            },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return "$" + parseInt(10 * e);
                },
              },
            },
            colors: [i],
            grid: {
              borderColor: r,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: o, strokeWidth: 3 },
          };
        (e.self = new ApexCharts(t, s)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t();
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget26),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget26.init();
  });
var KTChartsWidget27 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_charts_widget_27");
      if (t) {
        var a = KTUtil.getCssVariableValue("--bs-gray-800"),
          l = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          r = {
            series: [
              { name: "Sessions", data: [12.478, 7.546, 6.083, 5.041, 4.42] },
            ],
            chart: {
              fontFamily: "inherit",
              type: "bar",
              height: 350,
              toolbar: { show: !1 },
            },
            plotOptions: {
              bar: {
                borderRadius: 8,
                horizontal: !0,
                distributed: !0,
                barHeight: 50,
                dataLabels: { position: "bottom" },
              },
            },
            dataLabels: {
              enabled: !0,
              textAnchor: "start",
              offsetX: 0,
              formatter: function (e, t) {
                e *= 1e3;
                return wNumb({ thousand: "," }).to(e);
              },
              style: { fontSize: "14px", fontWeight: "600", align: "left" },
            },
            legend: { show: !1 },
            colors: ["#3E97FF", "#F1416C", "#50CD89", "#FFC700", "#7239EA"],
            xaxis: {
              categories: ["USA", "India", "Canada", "Brasil", "France"],
              labels: {
                formatter: function (e) {
                  return e + "K";
                },
                style: {
                  colors: a,
                  fontSize: "14px",
                  fontWeight: "600",
                  align: "left",
                },
              },
              axisBorder: { show: !1 },
            },
            yaxis: {
              labels: {
                formatter: function (e, t) {
                  return Number.isInteger(e)
                    ? e + " - " + parseInt((100 * e) / 18).toString() + "%"
                    : e;
                },
                style: { colors: a, fontSize: "14px", fontWeight: "600" },
                offsetY: 2,
                align: "left",
              },
            },
            grid: {
              borderColor: l,
              xaxis: { lines: { show: !0 } },
              yaxis: { lines: { show: !1 } },
              strokeDashArray: 4,
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return e;
                },
              },
            },
          };
        (e.self = new ApexCharts(t, r)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget27),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget27.init();
  });
var KTChartsWidget28 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_charts_widget_28");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-gray-500"),
          r = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          o = KTUtil.getCssVariableValue("--bs-info"),
          i = {
            series: [
              {
                name: "Links",
                data: [
                  190, 230, 230, 200, 200, 190, 190, 200, 200, 220, 220, 200,
                  200, 210, 210,
                ],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0,
                stops: [0, 80, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [o] },
            xaxis: {
              categories: [
                "May 04",
                "May 05",
                "May 06",
                "May 09",
                "May 10",
                "May 12",
                "May 14",
                "May 17",
                "May 18",
                "May 20",
                "May 22",
                "May 24",
                "May 26",
                "May 28",
                "May 30",
              ],
              axisBorder: { show: !1 },
              offsetX: 20,
              axisTicks: { show: !1 },
              tickAmount: 3,
              labels: {
                rotate: 0,
                rotateAlways: !1,
                style: { colors: l, fontSize: "12px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: o, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: {
              tickAmount: 4,
              max: 250,
              min: 100,
              labels: {
                style: { colors: l, fontSize: "12px" },
                formatter: function (e) {
                  return e;
                },
              },
            },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return e;
                },
              },
            },
            colors: [o],
            grid: {
              borderColor: r,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: o, strokeWidth: 3 },
          };
        (e.self = new ApexCharts(t, i)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget28),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget28.init();
  });
var KTChartsWidget29 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_charts_widget_29");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-gray-500"),
          r = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          o = KTUtil.getCssVariableValue("--bs-warning"),
          i = {
            series: [
              {
                name: "Position",
                data: [4, 7.5, 7.5, 6, 6, 4, 4, 6, 6, 8, 8, 6, 6, 7, 7],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0,
                stops: [0, 80, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [o] },
            xaxis: {
              categories: [
                "Apr 02",
                "Apr 03",
                "Apr 04",
                "Apr 05",
                "Apr 06",
                "Apr 09",
                "Apr 10",
                "Apr 12",
                "Apr 14",
                "Apr 17",
                "Apr 18",
                "Apr 18",
                "Apr 20",
                "Apr 22",
                "Apr 24",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              offsetX: 20,
              tickAmount: 4,
              labels: {
                rotate: 0,
                rotateAlways: !1,
                style: { colors: l, fontSize: "12px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: o, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: {
              tickAmount: 4,
              max: 10,
              min: 1,
              labels: {
                style: { colors: l, fontSize: "12px" },
                formatter: function (e) {
                  return e;
                },
              },
            },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return e;
                },
              },
            },
            colors: [o],
            grid: {
              borderColor: r,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: o, strokeWidth: 3 },
          };
        (e.self = new ApexCharts(t, i)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget29),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget29.init();
  });
var KTChartsWidget3 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_charts_widget_3");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-gray-500"),
          r = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          o = KTUtil.getCssVariableValue("--bs-success"),
          i = {
            series: [
              {
                name: "Sales",
                data: [
                  18, 18, 20, 20, 18, 18, 22, 22, 20, 20, 18, 18, 20, 20, 18,
                  18, 20, 20, 22,
                ],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0,
                stops: [0, 80, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [o] },
            xaxis: {
              categories: [
                "",
                "Apr 02",
                "Apr 03",
                "Apr 04",
                "Apr 05",
                "Apr 06",
                "Apr 07",
                "Apr 08",
                "Apr 09",
                "Apr 10",
                "Apr 11",
                "Apr 12",
                "Apr 13",
                "Apr 14",
                "Apr 15",
                "Apr 16",
                "Apr 17",
                "Apr 18",
                "",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              tickAmount: 6,
              labels: {
                rotate: 0,
                rotateAlways: !0,
                style: { colors: l, fontSize: "12px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: o, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: {
              tickAmount: 4,
              max: 24,
              min: 10,
              labels: {
                style: { colors: l, fontSize: "12px" },
                formatter: function (e) {
                  return "$" + e + "K";
                },
              },
            },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return "$" + e + "K";
                },
              },
            },
            colors: [KTUtil.getCssVariableValue("--bs-success")],
            grid: {
              borderColor: r,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: o, strokeWidth: 3 },
          };
        (e.self = new ApexCharts(t, i)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget3),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget3.init();
  });
var KTChartsWidget30 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.getElementById("kt_charts_widget_30_chart");
        if (e) {
          var t,
            a = function () {
              (t = am5.Root.new(e)).setThemes([am5themes_Animated.new(t)]);
              var a = t.container.children
                .push(
                  am5percent.PieChart.new(t, {
                    startAngle: 180,
                    endAngle: 360,
                    layout: t.verticalLayout,
                    innerRadius: am5.percent(50),
                  })
                )
                .series.push(
                  am5percent.PieSeries.new(t, {
                    startAngle: 180,
                    endAngle: 360,
                    valueField: "value",
                    categoryField: "category",
                    alignLabels: !1,
                  })
                );
              a.labels.template.setAll({
                fontWeight: "400",
                fontSize: 13,
                fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
              }),
                a.states.create("hidden", { startAngle: 180, endAngle: 180 }),
                a.slices.template.setAll({ cornerRadius: 5 }),
                a.ticks.template.setAll({ forceHidden: !0 }),
                a.data.setAll([
                  {
                    value: 10,
                    category: "One",
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-primary")),
                  },
                  {
                    value: 9,
                    category: "Two",
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                  },
                  {
                    value: 6,
                    category: "Three",
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-danger")),
                  },
                  {
                    value: 5,
                    category: "Four",
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-warning")),
                  },
                  {
                    value: 4,
                    category: "Five",
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-info")),
                  },
                  {
                    value: 3,
                    category: "Six",
                    fill: am5.color(
                      KTUtil.getCssVariableValue("--bs-secondary")
                    ),
                  },
                ]),
                a.appear(1e3, 100);
            };
          am5.ready(function () {
            a();
          }),
            KTThemeMode.on("kt.thememode.change", function () {
              t.dispose(), a();
            });
        }
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTChartsWidget30),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget30.init();
  });
var KTChartsWidget31 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.getElementById("kt_charts_widget_31_chart");
        if (e) {
          var t,
            a,
            l = function () {
              (a = am5.Root.new(e)).setThemes([am5themes_Animated.new(a)]),
                (t = a.container.children.push(
                  am5radar.RadarChart.new(a, {
                    panX: !1,
                    panY: !1,
                    wheelX: "panX",
                    wheelY: "zoomX",
                    innerRadius: am5.percent(40),
                    radius: am5.percent(70),
                    arrangeTooltips: !1,
                  })
                ))
                  .set(
                    "cursor",
                    am5radar.RadarCursor.new(a, { behavior: "zoomX" })
                  )
                  .lineY.set("visible", !1);
              var l = am5radar.AxisRendererCircular.new(a, {
                minGridDistance: 30,
              });
              l.labels.template.setAll({
                textType: "radial",
                radius: 10,
                paddingTop: 0,
                paddingBottom: 0,
                centerY: am5.p50,
                fontWeight: "400",
                fontSize: 11,
                fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-800")),
              }),
                l.grid.template.setAll({
                  location: 0.5,
                  strokeDasharray: [2, 2],
                  stroke: KTUtil.getCssVariableValue("--bs-gray-400"),
                });
              var r = t.xAxes.push(
                  am5xy.CategoryAxis.new(a, {
                    maxDeviation: 0,
                    categoryField: "name",
                    renderer: l,
                  })
                ),
                o = am5radar.AxisRendererRadial.new(a, { minGridDistance: 30 });
              o.labels.template.setAll({
                fontWeight: "500",
                fontSize: 12,
                fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-700")),
              });
              var i = t.yAxes.push(am5xy.ValueAxis.new(a, { renderer: o }));
              o.grid.template.setAll({
                strokeDasharray: [2, 2],
                stroke: KTUtil.getCssVariableValue("--bs-gray-400"),
              });
              var s = t.series.push(
                am5radar.RadarLineSeries.new(a, {
                  name: "Revenue",
                  xAxis: r,
                  yAxis: i,
                  valueYField: "value1",
                  categoryXField: "name",
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-primary")),
                })
              );
              s.strokes.template.setAll({ strokeOpacity: 0 }),
                s.fills.template.setAll({
                  visible: !0,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-primary")),
                  fillOpacity: 0.5,
                });
              var n = t.series.push(
                am5radar.RadarLineSeries.new(a, {
                  name: "Expense",
                  xAxis: r,
                  yAxis: i,
                  valueYField: "value2",
                  categoryXField: "name",
                  stacked: !0,
                  tooltip: am5.Tooltip.new(a, {
                    labelText: "Revenue: {value1}\nExpense:{value2}",
                  }),
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-success")),
                })
              );
              n.strokes.template.setAll({ strokeOpacity: 0 }),
                n.fills.template.setAll({
                  visible: !0,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-primary")),
                  fillOpacity: 0.5,
                });
              var d = t.radarContainer.children.push(
                am5.Legend.new(a, {
                  width: 150,
                  centerX: am5.p50,
                  centerY: am5.p50,
                })
              );
              d.data.setAll([s, n]),
                d.labels.template.setAll({
                  fontWeight: "600",
                  fontSize: 13,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-700")),
                });
              var m = [
                { name: "Openlane", value1: 160.2, value2: 26.9 },
                { name: "Yearin", value1: 120.1, value2: 50.5 },
                { name: "Goodsilron", value1: 150.7, value2: 12.3 },
                { name: "Condax", value1: 69.4, value2: 74.5 },
                { name: "Opentech", value1: 78.5, value2: 29.7 },
                { name: "Golddex", value1: 77.6, value2: 102.2 },
                { name: "Isdom", value1: 69.8, value2: 22.6 },
                { name: "Plusstrip", value1: 63.6, value2: 45.3 },
                { name: "Kinnamplus", value1: 59.7, value2: 12.8 },
                { name: "Zumgoity", value1: 64.3, value2: 19.6 },
                { name: "Stanredtax", value1: 52.9, value2: 96.3 },
                { name: "Conecom", value1: 42.9, value2: 11.9 },
                { name: "Zencorporation", value1: 40.9, value2: 16.8 },
                { name: "Iselectrics", value1: 39.2, value2: 9.9 },
                { name: "Treequote", value1: 76.6, value2: 36.9 },
                { name: "Sumace", value1: 34.8, value2: 14.6 },
                { name: "Lexiqvolax", value1: 32.1, value2: 35.6 },
                { name: "Sunnamplex", value1: 31.8, value2: 5.9 },
                { name: "Faxquote", value1: 29.3, value2: 14.7 },
                { name: "Donware", value1: 23, value2: 2.8 },
                { name: "Warephase", value1: 21.5, value2: 12.1 },
                { name: "Donquadtech", value1: 19.7, value2: 10.8 },
                { name: "Nam-zim", value1: 15.5, value2: 4.1 },
                { name: "Y-corporation", value1: 14.2, value2: 11.3 },
              ];
              s.data.setAll(m),
                n.data.setAll(m),
                r.data.setAll(m),
                s.appear(1e3),
                n.appear(1e3),
                t.appear(1e3, 100);
            };
          am5.ready(function () {
            l();
          }),
            KTThemeMode.on("kt.thememode.change", function () {
              a.dispose(), l();
            });
        }
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTChartsWidget31),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget31.init();
  });
var KTChartsWidget32 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = { self: null, rendered: !1 },
    l = function (e, t, a, l, r) {
      var o = document.querySelector(a);
      if (o) {
        var i = parseInt(KTUtil.css(o, "height")),
          s = KTUtil.getCssVariableValue("--bs-gray-900"),
          n = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          d = {
            series: [{ name: "Deliveries", data: l }],
            chart: {
              fontFamily: "inherit",
              type: "bar",
              height: i,
              toolbar: { show: !1 },
            },
            plotOptions: {
              bar: {
                horizontal: !1,
                columnWidth: ["22%"],
                borderRadius: 5,
                dataLabels: { position: "top" },
                startingShape: "flat",
              },
            },
            legend: { show: !1 },
            dataLabels: {
              enabled: !0,
              offsetY: -28,
              style: { fontSize: "13px", colors: [s] },
            },
            stroke: { show: !0, width: 2, colors: ["transparent"] },
            xaxis: {
              categories: [
                "Grossey",
                "Pet Food",
                "Flowers",
                "Restaurant",
                "Kids Toys",
                "Clothing",
                "Still Water",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: {
                style: {
                  colors: KTUtil.getCssVariableValue("--bs-gray-500"),
                  fontSize: "13px",
                },
              },
              crosshairs: {
                fill: { gradient: { opacityFrom: 0, opacityTo: 0 } },
              },
            },
            yaxis: {
              labels: {
                style: {
                  colors: KTUtil.getCssVariableValue("--bs-gray-500"),
                  fontSize: "13px",
                },
              },
            },
            fill: { opacity: 1 },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: { style: { fontSize: "12px" } },
            colors: [
              KTUtil.getCssVariableValue("--bs-primary"),
              KTUtil.getCssVariableValue("--bs-primary-light"),
            ],
            grid: {
              borderColor: n,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
          };
        e.self = new ApexCharts(o, d);
        var m = document.querySelector(t);
        !0 === r &&
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200),
          m.addEventListener("shown.bs.tab", function (t) {
            !1 === e.rendered && (e.self.render(), (e.rendered = !0));
          });
      }
    };
  return {
    init: function () {
      var r = [54, 42, 75, 110, 23, 87, 50];
      l(e, "#kt_charts_widget_32_tab_1", "#kt_charts_widget_32_chart_1", r, !0);
      var o = [25, 55, 35, 50, 45, 20, 31];
      l(t, "#kt_charts_widget_32_tab_2", "#kt_charts_widget_32_chart_2", o, !1);
      var i = [45, 15, 35, 70, 45, 50, 21];
      l(a, "#kt_charts_widget_32_tab_3", "#kt_charts_widget_32_chart_3", i, !1),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(),
            t.rendered && t.self.destroy(),
            a.rendered && a.self.destroy(),
            l(
              e,
              "#kt_charts_widget_32_tab_1",
              "#kt_charts_widget_32_chart_1",
              r,
              e.rendered
            ),
            l(
              t,
              "#kt_charts_widget_32_tab_2",
              "#kt_charts_widget_32_chart_2",
              o,
              t.rendered
            ),
            l(
              a,
              "#kt_charts_widget_32_tab_3",
              "#kt_charts_widget_32_chart_3",
              i,
              a.rendered
            );
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget32),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget32.init();
  });
var KTChartsWidget33 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = { self: null, rendered: !1 },
    l = { self: null, rendered: !1 },
    r = { self: null, rendered: !1 },
    o = function (e, t, a, l, r, o) {
      var i = document.querySelector(a);
      if (i) {
        var s = i.getAttribute("data-kt-chart-color"),
          n = parseInt(KTUtil.css(i, "height")),
          d = KTUtil.getCssVariableValue("--bs-gray-500"),
          m = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          c = KTUtil.getCssVariableValue("--bs-" + s),
          g = {
            series: [{ name: "Etherium ", data: l }],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: n,
              toolbar: { show: !1 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0.2,
                stops: [15, 120, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [c] },
            xaxis: {
              categories: r,
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              offsetX: 20,
              tickAmount: 4,
              labels: {
                rotate: 0,
                rotateAlways: !1,
                show: !1,
                style: { colors: d, fontSize: "12px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: c, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: { tickAmount: 4, max: 4e3, min: 1e3, labels: { show: !1 } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return e + "$";
                },
              },
            },
            colors: [c],
            grid: {
              borderColor: m,
              strokeDashArray: 3,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: c, strokeWidth: 3 },
          };
        e.self = new ApexCharts(i, g);
        var f = document.querySelector(t);
        !0 === o &&
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200),
          f.addEventListener("shown.bs.tab", function (t) {
            !1 === e.rendered && (e.self.render(), (e.rendered = !0));
          });
      }
    };
  return {
    init: function () {
      var i = [
          2100, 3200, 3200, 2400, 2400, 1800, 1800, 2400, 2400, 3200, 3200, 3e3,
          3e3, 3250, 3250,
        ],
        s = [
          "10AM",
          "10.30AM",
          "11AM",
          "11.15AM",
          "11.30AM",
          "12PM",
          "1PM",
          "2PM",
          "3PM",
          "4PM",
          "5PM",
          "6PM",
          "7PM",
          "8PM",
          "9PM",
        ];
      o(
        e,
        "#kt_charts_widget_33_tab_1",
        "#kt_charts_widget_33_chart_1",
        i,
        s,
        !0
      );
      var n = [
          2300, 2300, 2e3, 3200, 3200, 2800, 2400, 2400, 3100, 2900, 3100, 3100,
          2600, 2600, 3200,
        ],
        d = [
          "Apr 01",
          "Apr 02",
          "Apr 03",
          "Apr 04",
          "Apr 05",
          "Apr 06",
          "Apr 07",
          "Apr 08",
          "Apr 09",
          "Apr 10",
          "Apr 11",
          "Apr 12",
          "Apr 13",
          "Apr 14",
          "Apr 15",
        ];
      o(
        t,
        "#kt_charts_widget_33_tab_2",
        "#kt_charts_widget_33_chart_2",
        n,
        d,
        !1
      );
      var m = [
          2600, 3200, 2300, 2300, 2e3, 3200, 3100, 2900, 3200, 3200, 2600, 3100,
          2800, 2400, 2400,
        ],
        c = [
          "Apr 02",
          "Apr 03",
          "Apr 04",
          "Apr 05",
          "Apr 06",
          "Apr 09",
          "Apr 10",
          "Apr 12",
          "Apr 14",
          "Apr 17",
          "Apr 18",
          "Apr 18",
          "Apr 20",
          "Apr 22",
          "Apr 24",
        ];
      o(
        a,
        "#kt_charts_widget_33_tab_3",
        "#kt_charts_widget_33_chart_3",
        m,
        c,
        !1
      );
      var g = [
          1800, 1800, 2400, 2400, 3200, 3200, 3e3, 2100, 3200, 3300, 2400, 2400,
          3e3, 3200, 3100,
        ],
        f = [
          "Jun 2021",
          "Jul 2021",
          "Aug 2021",
          "Sep 2021",
          "Oct 2021",
          "Nov 2021",
          "Dec 2021",
          "Jan 2022",
          "Feb 2022",
          "Mar 2022",
          "Apr 2022",
          "May 2022",
          "Jun 2022",
          "Jul 2022",
          "Aug 2022",
        ];
      o(
        l,
        "#kt_charts_widget_33_tab_4",
        "#kt_charts_widget_33_chart_4",
        g,
        f,
        !1
      );
      var u = [
          3e3, 2100, 3300, 3100, 1800, 1800, 2400, 2400, 3100, 3100, 2400, 2400,
          3e3, 2400, 2800,
        ],
        h = [
          "Sep 2021",
          "Oct 2021",
          "Nov 2021",
          "Dec 2021",
          "Jan 2022",
          "Feb 2022",
          "Mar 2022",
          "Apr 2022",
          "May 2022",
          "Jun 2022",
          "Jul 2022",
          "Aug 2022",
          "Sep 2022",
          "Oct 2022",
          "Nov 2022",
        ];
      o(
        r,
        "#kt_charts_widget_33_tab_5",
        "#kt_charts_widget_33_chart_5",
        u,
        h,
        !1
      ),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(),
            t.rendered && t.self.destroy(),
            a.rendered && a.self.destroy(),
            l.rendered && l.self.destroy(),
            r.rendered && r.self.destroy(),
            o(
              e,
              "#kt_charts_widget_33_tab_1",
              "#kt_charts_widget_33_chart_1",
              i,
              s,
              e.rendered
            ),
            o(
              t,
              "#kt_charts_widget_33_tab_2",
              "#kt_charts_widget_33_chart_2",
              n,
              d,
              t.rendered
            ),
            o(
              a,
              "#kt_charts_widget_33_tab_3",
              "#kt_charts_widget_33_chart_3",
              m,
              c,
              a.rendered
            ),
            o(
              l,
              "#kt_charts_widget_33_tab_4",
              "#kt_charts_widget_33_chart_4",
              g,
              f,
              l.rendered
            ),
            o(
              r,
              "#kt_charts_widget_33_tab_5",
              "#kt_charts_widget_33_chart_5",
              u,
              h,
              r.rendered
            );
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget33),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget33.init();
  });
var KTChartsWidget34 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = { self: null, rendered: !1 },
    l = { self: null, rendered: !1 },
    r = { self: null, rendered: !1 },
    o = function (e, t, a, l, r, o) {
      var i = document.querySelector(a);
      if (i) {
        var s = parseInt(KTUtil.css(i, "height")),
          n = i.getAttribute("data-kt-chart-color"),
          d = KTUtil.getCssVariableValue("--bs-gray-500"),
          m = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          c = KTUtil.getCssVariableValue("--bs-" + n),
          g = {
            series: [{ name: "Earnings", data: l }],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: s,
              toolbar: { show: !1 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0.2,
                stops: [15, 120, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [c] },
            xaxis: {
              categories: r,
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              offsetX: 20,
              tickAmount: 4,
              labels: {
                rotate: 0,
                rotateAlways: !1,
                show: !1,
                style: { colors: d, fontSize: "12px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: c, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: { tickAmount: 4, max: 4e3, min: 1e3, labels: { show: !1 } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return e + "$";
                },
              },
            },
            colors: [c],
            grid: {
              borderColor: m,
              strokeDashArray: 3,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: c, strokeWidth: 3 },
          };
        e.self = new ApexCharts(i, g);
        var f = document.querySelector(t);
        !0 === o &&
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200),
          f.addEventListener("shown.bs.tab", function (t) {
            !1 === e.rendered && (e.self.render(), (e.rendered = !0));
          });
      }
    };
  return {
    init: function () {
      var i = [
          2100, 2800, 2800, 2400, 2400, 1800, 1800, 2400, 2400, 3200, 3200,
          2800, 2800, 3250, 3250,
        ],
        s = [
          "10AM",
          "10.30AM",
          "11AM",
          "11.15AM",
          "11.30AM",
          "12PM",
          "1PM",
          "2PM",
          "3PM",
          "4PM",
          "5PM",
          "6PM",
          "7PM",
          "8PM",
          "9PM",
        ];
      o(
        e,
        "#kt_charts_widget_34_tab_1",
        "#kt_charts_widget_34_chart_1",
        i,
        s,
        !0
      );
      var n = [
          2300, 2300, 2e3, 3100, 3100, 2800, 2400, 2400, 3100, 2900, 3200, 3200,
          2600, 2600, 3200,
        ],
        d = [
          "Apr 01",
          "Apr 02",
          "Apr 03",
          "Apr 04",
          "Apr 05",
          "Apr 06",
          "Apr 07",
          "Apr 08",
          "Apr 09",
          "Apr 10",
          "Apr 11",
          "Apr 12",
          "Apr 13",
          "Apr 14",
          "Apr 15",
        ];
      o(
        t,
        "#kt_charts_widget_34_tab_2",
        "#kt_charts_widget_34_chart_2",
        n,
        d,
        !1
      );
      var m = [
          2600, 3400, 2300, 2300, 2e3, 3100, 3100, 2900, 3200, 3200, 2600, 3100,
          2800, 2400, 2400,
        ],
        c = [
          "Apr 02",
          "Apr 03",
          "Apr 04",
          "Apr 05",
          "Apr 06",
          "Apr 09",
          "Apr 10",
          "Apr 12",
          "Apr 14",
          "Apr 17",
          "Apr 18",
          "Apr 18",
          "Apr 20",
          "Apr 22",
          "Apr 24",
        ];
      o(
        a,
        "#kt_charts_widget_34_tab_3",
        "#kt_charts_widget_34_chart_3",
        m,
        c,
        !1
      );
      var g = [
          1800, 1800, 2400, 2400, 3100, 3100, 3e3, 2100, 3200, 3200, 2400, 2400,
          3e3, 3200, 3100,
        ],
        f = [
          "Jun 2021",
          "Jul 2021",
          "Aug 2021",
          "Sep 2021",
          "Oct 2021",
          "Nov 2021",
          "Dec 2021",
          "Jan 2022",
          "Feb 2022",
          "Mar 2022",
          "Apr 2022",
          "May 2022",
          "Jun 2022",
          "Jul 2022",
          "Aug 2022",
        ];
      o(
        l,
        "#kt_charts_widget_34_tab_4",
        "#kt_charts_widget_34_chart_4",
        g,
        f,
        !1
      );
      var u = [
          3e3, 2100, 3200, 3200, 1800, 1800, 2400, 2400, 3100, 3100, 2400, 2400,
          3e3, 2400, 2800,
        ],
        h = [
          "Sep 2021",
          "Oct 2021",
          "Nov 2021",
          "Dec 2021",
          "Jan 2022",
          "Feb 2022",
          "Mar 2022",
          "Apr 2022",
          "May 2022",
          "Jun 2022",
          "Jul 2022",
          "Aug 2022",
          "Sep 2022",
          "Oct 2022",
          "Nov 2022",
        ];
      o(
        r,
        "#kt_charts_widget_34_tab_5",
        "#kt_charts_widget_34_chart_5",
        u,
        h,
        !1
      ),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(),
            t.rendered && t.self.destroy(),
            a.rendered && a.self.destroy(),
            l.rendered && l.self.destroy(),
            r.rendered && r.self.destroy(),
            o(
              e,
              "#kt_charts_widget_34_tab_1",
              "#kt_charts_widget_34_chart_1",
              i,
              s,
              e.rendered
            ),
            o(
              t,
              "#kt_charts_widget_34_tab_2",
              "#kt_charts_widget_34_chart_2",
              n,
              d,
              t.rendered
            ),
            o(
              a,
              "#kt_charts_widget_34_tab_3",
              "#kt_charts_widget_34_chart_3",
              m,
              c,
              a.rendered
            ),
            o(
              l,
              "#kt_charts_widget_34_tab_4",
              "#kt_charts_widget_34_chart_4",
              g,
              f,
              l.rendered
            ),
            o(
              r,
              "#kt_charts_widget_34_tab_5",
              "#kt_charts_widget_34_chart_5",
              u,
              h,
              r.rendered
            );
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget34),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget34.init();
  });
var KTChartsWidget35 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = { self: null, rendered: !1 },
    l = { self: null, rendered: !1 },
    r = { self: null, rendered: !1 },
    o = function (e, t, a, l, r, o) {
      var i = document.querySelector(a);
      if (i) {
        var s = parseInt(KTUtil.css(i, "height")),
          n = i.getAttribute("data-kt-chart-color"),
          d = KTUtil.getCssVariableValue("--bs-gray-500"),
          m = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          c = KTUtil.getCssVariableValue("--bs-" + n),
          g = {
            series: [{ name: "Earnings", data: l }],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: s,
              toolbar: { show: !1 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0.2,
                stops: [15, 120, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [c] },
            xaxis: {
              categories: r,
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              offsetX: 20,
              tickAmount: 4,
              labels: {
                rotate: 0,
                rotateAlways: !1,
                show: !1,
                style: { colors: d, fontSize: "12px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: c, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: { tickAmount: 4, max: 4e3, min: 1e3, labels: { show: !1 } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return e + "$";
                },
              },
            },
            colors: [c],
            grid: {
              borderColor: m,
              strokeDashArray: 3,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: c, strokeWidth: 3 },
          };
        e.self = new ApexCharts(i, g);
        var f = document.querySelector(t);
        !0 === o &&
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200),
          f.addEventListener("shown.bs.tab", function (t) {
            !1 === e.rendered && (e.self.render(), (e.rendered = !0));
          });
      }
    };
  return {
    init: function () {
      var i = [
          2100, 3100, 3100, 2400, 2400, 1800, 1800, 2400, 2400, 3200, 3200,
          2800, 2800, 3250, 3250,
        ],
        s = [
          "10AM",
          "10.30AM",
          "11AM",
          "11.15AM",
          "11.30AM",
          "12PM",
          "1PM",
          "2PM",
          "3PM",
          "4PM",
          "5PM",
          "6PM",
          "7PM",
          "8PM",
          "9PM",
        ];
      o(
        e,
        "#kt_charts_widget_35_tab_1",
        "#kt_charts_widget_35_chart_1",
        i,
        s,
        !0
      );
      var n = [
          2300, 2300, 2e3, 3200, 3200, 2800, 2400, 2400, 3100, 2900, 3200, 3200,
          2600, 2600, 3200,
        ],
        d = [
          "Apr 01",
          "Apr 02",
          "Apr 03",
          "Apr 04",
          "Apr 05",
          "Apr 06",
          "Apr 07",
          "Apr 08",
          "Apr 09",
          "Apr 10",
          "Apr 11",
          "Apr 12",
          "Apr 13",
          "Apr 14",
          "Apr 15",
        ];
      o(
        t,
        "#kt_charts_widget_35_tab_2",
        "#kt_charts_widget_35_chart_2",
        n,
        d,
        !1
      );
      var m = [
          2600, 3200, 2300, 2300, 2e3, 3200, 3100, 2900, 3400, 3400, 2600, 3200,
          2800, 2400, 2400,
        ],
        c = [
          "Apr 02",
          "Apr 03",
          "Apr 04",
          "Apr 05",
          "Apr 06",
          "Apr 09",
          "Apr 10",
          "Apr 12",
          "Apr 14",
          "Apr 17",
          "Apr 18",
          "Apr 18",
          "Apr 20",
          "Apr 22",
          "Apr 24",
        ];
      o(
        a,
        "#kt_charts_widget_35_tab_3",
        "#kt_charts_widget_35_chart_3",
        m,
        c,
        !1
      );
      var g = [
          1800, 1800, 2400, 2400, 3200, 3200, 3e3, 2100, 3200, 3200, 2400, 2400,
          3e3, 3200, 3100,
        ],
        f = [
          "Jun 2021",
          "Jul 2021",
          "Aug 2021",
          "Sep 2021",
          "Oct 2021",
          "Nov 2021",
          "Dec 2021",
          "Jan 2022",
          "Feb 2022",
          "Mar 2022",
          "Apr 2022",
          "May 2022",
          "Jun 2022",
          "Jul 2022",
          "Aug 2022",
        ];
      o(
        l,
        "#kt_charts_widget_35_tab_4",
        "#kt_charts_widget_35_chart_4",
        g,
        f,
        !1
      );
      var u = [
          3200, 2100, 3200, 3200, 3200, 3500, 3e3, 2400, 3250, 2400, 2400, 3250,
          3e3, 2400, 2800,
        ],
        h = [
          "Sep 2021",
          "Oct 2021",
          "Nov 2021",
          "Dec 2021",
          "Jan 2022",
          "Feb 2022",
          "Mar 2022",
          "Apr 2022",
          "May 2022",
          "Jun 2022",
          "Jul 2022",
          "Aug 2022",
          "Sep 2022",
          "Oct 2022",
          "Nov 2022",
        ];
      o(
        r,
        "#kt_charts_widget_35_tab_5",
        "#kt_charts_widget_35_chart_5",
        u,
        h,
        !1
      ),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(),
            t.rendered && t.self.destroy(),
            a.rendered && a.self.destroy(),
            l.rendered && l.self.destroy(),
            r.rendered && r.self.destroy(),
            o(
              e,
              "#kt_charts_widget_35_tab_1",
              "#kt_charts_widget_35_chart_1",
              i,
              s,
              e.rendered
            ),
            o(
              t,
              "#kt_charts_widget_35_tab_2",
              "#kt_charts_widget_35_chart_2",
              n,
              d,
              t.rendered
            ),
            o(
              a,
              "#kt_charts_widget_35_tab_3",
              "#kt_charts_widget_35_chart_3",
              m,
              c,
              a.rendered
            ),
            o(
              l,
              "#kt_charts_widget_35_tab_4",
              "#kt_charts_widget_35_chart_4",
              g,
              f,
              l.rendered
            ),
            o(
              r,
              "#kt_charts_widget_35_tab_5",
              "#kt_charts_widget_35_chart_5",
              u,
              h,
              r.rendered
            );
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget35),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget35.init();
  });
var KTChartsWidget36 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_charts_widget_36");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-gray-500"),
          r = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          o = KTUtil.getCssVariableValue("--bs-primary"),
          i = KTUtil.getCssVariableValue("--bs-primary"),
          s = KTUtil.getCssVariableValue("--bs-success"),
          n = {
            series: [
              {
                name: "Inbound Calls",
                data: [
                  65, 80, 80, 60, 60, 45, 45, 80, 80, 70, 70, 90, 90, 80, 80,
                  80, 60, 60, 50,
                ],
              },
              {
                name: "Outbound Calls",
                data: [
                  90, 110, 110, 95, 95, 85, 85, 95, 95, 115, 115, 100, 100, 115,
                  115, 95, 95, 85, 85,
                ],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0.2,
                stops: [15, 120, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [o, s] },
            xaxis: {
              categories: [
                "",
                "8 AM",
                "81 AM",
                "9 AM",
                "10 AM",
                "11 AM",
                "12 PM",
                "13 PM",
                "14 PM",
                "15 PM",
                "16 PM",
                "17 PM",
                "18 PM",
                "18:20 PM",
                "18:20 PM",
                "19 PM",
                "20 PM",
                "21 PM",
                "",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              tickAmount: 6,
              labels: {
                rotate: 0,
                rotateAlways: !0,
                style: { colors: l, fontSize: "12px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: [o, s], width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: {
              max: 120,
              min: 30,
              tickAmount: 6,
              labels: { style: { colors: l, fontSize: "12px" } },
            },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: { style: { fontSize: "12px" } },
            colors: [i, KTUtil.getCssVariableValue("--bs-success")],
            grid: {
              borderColor: r,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: [o, s], strokeWidth: 3 },
          };
        (e.self = new ApexCharts(t, n)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget36),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget36.init();
  });
var KTChartsWidget37 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = { self: null, rendered: !1 },
    l = { self: null, rendered: !1 },
    r = function (e, t, a, l, r, o) {
      var i = document.querySelector(a);
      if (i) {
        var s = parseInt(KTUtil.css(i, "height")),
          n = i.getAttribute("data-kt-chart-color"),
          d = KTUtil.getCssVariableValue("--bs-gray-500"),
          m = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          c = KTUtil.getCssVariableValue("--bs-" + n),
          g = {
            series: [{ name: "Earnings", data: l }],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: s,
              toolbar: { show: !1 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0.2,
                stops: [15, 120, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [c] },
            xaxis: {
              categories: r,
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              offsetX: 20,
              tickAmount: 4,
              labels: {
                rotate: 0,
                rotateAlways: !1,
                show: !1,
                style: { colors: d, fontSize: "12px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: c, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: { tickAmount: 4, max: 4e3, min: 1e3, labels: { show: !1 } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return e + "$";
                },
              },
            },
            colors: [c],
            grid: {
              borderColor: m,
              strokeDashArray: 3,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: c, strokeWidth: 3 },
          };
        e.self = new ApexCharts(i, g);
        var f = document.querySelector(t);
        !0 === o &&
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200),
          f.addEventListener("shown.bs.tab", function (t) {
            !1 === e.rendered && (e.self.render(), (e.rendered = !0));
          });
      }
    };
  return {
    init: function () {
      var o = [
          2100, 3200, 3200, 2400, 2400, 1800, 1800, 2400, 2400, 3200, 3200, 3e3,
          3e3, 3250, 3250,
        ],
        i = [
          "10AM",
          "10.30AM",
          "11AM",
          "11.15AM",
          "11.30AM",
          "12PM",
          "1PM",
          "2PM",
          "3PM",
          "4PM",
          "5PM",
          "6PM",
          "7PM",
          "8PM",
          "9PM",
        ];
      r(
        e,
        "#kt_charts_widget_37_tab_1",
        "#kt_charts_widget_37_chart_1",
        o,
        i,
        !0
      );
      var s = [
          2300, 2300, 2e3, 3200, 3200, 2800, 2400, 2400, 3100, 2900, 3100, 3100,
          2600, 2600, 3200,
        ],
        n = [
          "Apr 01",
          "Apr 02",
          "Apr 03",
          "Apr 04",
          "Apr 05",
          "Apr 06",
          "Apr 07",
          "Apr 08",
          "Apr 09",
          "Apr 10",
          "Apr 11",
          "Apr 12",
          "Apr 13",
          "Apr 14",
          "Apr 15",
        ];
      r(
        t,
        "#kt_charts_widget_37_tab_2",
        "#kt_charts_widget_37_chart_2",
        s,
        n,
        !1
      );
      var d = [
          2600, 3200, 2300, 2300, 2e3, 3200, 3100, 2900, 3200, 3200, 2600, 3100,
          2800, 2400, 2400,
        ],
        m = [
          "Apr 02",
          "Apr 03",
          "Apr 04",
          "Apr 05",
          "Apr 06",
          "Apr 09",
          "Apr 10",
          "Apr 12",
          "Apr 14",
          "Apr 17",
          "Apr 18",
          "Apr 18",
          "Apr 20",
          "Apr 22",
          "Apr 24",
        ];
      r(
        a,
        "#kt_charts_widget_37_tab_3",
        "#kt_charts_widget_37_chart_3",
        d,
        m,
        !1
      );
      var c = [
          1800, 1800, 2400, 2400, 3200, 3200, 3e3, 2100, 3200, 3300, 2400, 2400,
          3e3, 3200, 3100,
        ],
        g = [
          "Jun 2021",
          "Jul 2021",
          "Aug 2021",
          "Sep 2021",
          "Oct 2021",
          "Nov 2021",
          "Dec 2021",
          "Jan 2022",
          "Feb 2022",
          "Mar 2022",
          "Apr 2022",
          "May 2022",
          "Jun 2022",
          "Jul 2022",
          "Aug 2022",
        ];
      r(
        l,
        "#kt_charts_widget_37_tab_4",
        "#kt_charts_widget_37_chart_4",
        c,
        g,
        !1
      ),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(),
            t.rendered && t.self.destroy(),
            a.rendered && a.self.destroy(),
            l.rendered && l.self.destroy(),
            r(
              e,
              "#kt_charts_widget_37_tab_1",
              "#kt_charts_widget_37_chart_1",
              o,
              i,
              e.rendered
            ),
            r(
              t,
              "#kt_charts_widget_37_tab_2",
              "#kt_charts_widget_37_chart_2",
              s,
              n,
              t.rendered
            ),
            r(
              a,
              "#kt_charts_widget_37_tab_3",
              "#kt_charts_widget_37_chart_3",
              d,
              m,
              a.rendered
            ),
            r(
              l,
              "#kt_charts_widget_37_tab_4",
              "#kt_charts_widget_37_chart_4",
              c,
              g,
              l.rendered
            );
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget37),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget37.init();
  });
var KTChartsWidget38 = (function () {
  var e = { self: null, rendered: !1 },
    t = function () {
      var t = document.getElementById("kt_charts_widget_38_chart");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-gray-900"),
          r = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          o = {
            series: [
              { name: "LOI Issued", data: [54, 42, 75, 110, 23, 87, 50] },
            ],
            chart: {
              fontFamily: "inherit",
              type: "bar",
              height: a,
              toolbar: { show: !1 },
            },
            plotOptions: {
              bar: {
                horizontal: !1,
                columnWidth: ["28%"],
                borderRadius: 5,
                dataLabels: { position: "top" },
                startingShape: "flat",
              },
            },
            legend: { show: !1 },
            dataLabels: {
              enabled: !0,
              offsetY: -28,
              style: { fontSize: "13px", colors: [l] },
              formatter: function (e) {
                return e;
              },
            },
            stroke: { show: !0, width: 2, colors: ["transparent"] },
            xaxis: {
              categories: ["E2E", "IMC", "SSMC", "SSBD", "ICCD", "PAN", "SBN"],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: {
                style: {
                  colors: KTUtil.getCssVariableValue("--bs-gray-500"),
                  fontSize: "13px",
                },
              },
              crosshairs: {
                fill: { gradient: { opacityFrom: 0, opacityTo: 0 } },
              },
            },
            yaxis: {
              labels: {
                style: {
                  colors: KTUtil.getCssVariableValue("--bs-gray-500"),
                  fontSize: "13px",
                },
                formatter: function (e) {
                  return e + "M";
                },
              },
            },
            fill: { opacity: 1 },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return +e + "M";
                },
              },
            },
            colors: [
              KTUtil.getCssVariableValue("--bs-primary"),
              KTUtil.getCssVariableValue("--bs-primary-light"),
            ],
            grid: {
              borderColor: r,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
          };
        (e.self = new ApexCharts(t, o)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t();
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget38),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget38.init();
  });
var KTChartsWidget39 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.querySelector("#kt_charts_widget_39_chart");
        if (e) {
          var t,
            a = function () {
              if ((t = am5.Root.new(e))) {
                t.setThemes([am5themes_Animated.new(t)]);
                var a = t.container.children.push(
                    am5radar.RadarChart.new(t, {
                      panX: !1,
                      panY: !1,
                      wheelX: "panX",
                      wheelY: "zoomX",
                    })
                  ),
                  l = am5radar.AxisRendererCircular.new(t, {});
                l.labels.template.setAll({ radius: 10 }),
                  l.grid.template.setAll({
                    stroke: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-700")
                    ),
                  });
                var r = am5radar.AxisRendererRadial.new(t, {
                  minGridDistance: 20,
                });
                r.grid.template.setAll({
                  stroke: am5.color(
                    KTUtil.getCssVariableValue("--bs-gray-700")
                  ),
                });
                var o = a.xAxes.push(
                    am5xy.CategoryAxis.new(t, {
                      maxDeviation: 0,
                      categoryField: "category",
                      renderer: l,
                      tooltip: am5.Tooltip.new(t, {}),
                    })
                  ),
                  i = a.yAxes.push(
                    am5xy.ValueAxis.new(t, { min: 0, max: 10, renderer: r })
                  );
                l.labels.template.setAll({
                  fontSize: 11,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-800")),
                }),
                  r.labels.template.setAll({
                    fontSize: 11,
                    fill: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-800")
                    ),
                  });
                var s = a.series.push(
                  am5radar.RadarColumnSeries.new(t, {
                    xAxis: o,
                    yAxis: i,
                    valueYField: "value",
                    categoryXField: "category",
                  })
                );
                s.columns.template.setAll({
                  tooltipText: "{categoryX}: {valueY}",
                  templateField: "columnSettings",
                  strokeOpacity: 0,
                  width: am5.p100,
                });
                var n = [
                  {
                    category: "Spain",
                    value: 5,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                  {
                    category: "Spain",
                    value: 4,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                  {
                    category: "United States",
                    value: 9,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                  {
                    category: "Italy",
                    value: 7,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                  {
                    category: "France",
                    value: 8,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                  {
                    category: "Norway",
                    value: 4,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                  {
                    category: "Brasil",
                    value: 7,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                  {
                    category: "Canada",
                    value: 5,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                ];
                s.data.setAll(n),
                  o.data.setAll(n),
                  s.appear(1e3),
                  a.appear(1e3, 100);
              }
            };
          am5.ready(function () {
            a();
          }),
            KTThemeMode.on("kt.thememode.change", function () {
              t.dispose(), a();
            });
        }
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTChartsWidget39),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget39.init();
  });
var KTChartsWidget4 = (function () {
  var e = { self: null, rendered: !1 },
    t = function () {
      var t = document.getElementById("kt_charts_widget_4");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-gray-500"),
          r = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          o = KTUtil.getCssVariableValue("--bs-primary"),
          i = {
            series: [
              {
                name: "Sales",
                data: [
                  34.5, 34.5, 35, 35, 35.5, 35.5, 35, 35, 35.5, 35.5, 35, 35,
                  34.5, 34.5, 35, 35, 35.5, 35.5, 35,
                ],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0,
                stops: [0, 80, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [o] },
            xaxis: {
              categories: [
                "",
                "Apr 02",
                "Apr 03",
                "Apr 04",
                "Apr 05",
                "Apr 06",
                "Apr 07",
                "Apr 08",
                "Apr 09",
                "Apr 10",
                "Apr 11",
                "Apr 12",
                "Apr 13",
                "Apr 14",
                "Apr 17",
                "Apr 18",
                "Apr 19",
                "Apr 21",
                "",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              tickAmount: 6,
              labels: {
                rotate: 0,
                rotateAlways: !0,
                style: { colors: l, fontSize: "12px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: o, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: {
              max: 36.3,
              min: 33,
              tickAmount: 6,
              labels: {
                style: { colors: l, fontSize: "12px" },
                formatter: function (e) {
                  return "$" + parseInt(10 * e);
                },
              },
            },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return "$" + parseInt(10 * e);
                },
              },
            },
            colors: [KTUtil.getCssVariableValue("--bs-primary")],
            grid: {
              borderColor: r,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: o, strokeWidth: 3 },
          };
        (e.self = new ApexCharts(t, i)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t();
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget4),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget4.init();
  });
var KTChartsWidget40 = {
  init: function () {
    !(function () {
      if ("undefined" != typeof am5) {
        var e = document.querySelector("#kt_charts_widget_40_chart");
        if (e) {
          var t,
            a = function () {
              if ((t = am5.Root.new(e))) {
                t.setThemes([am5themes_Animated.new(t)]);
                var a = t.container.children.push(
                    am5radar.RadarChart.new(t, {
                      panX: !1,
                      panY: !1,
                      wheelX: "panX",
                      wheelY: "zoomX",
                    })
                  ),
                  l = am5radar.AxisRendererCircular.new(t, {});
                l.labels.template.setAll({ radius: 10 }),
                  l.grid.template.setAll({
                    stroke: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-700")
                    ),
                  });
                var r = am5radar.AxisRendererRadial.new(t, {
                  minGridDistance: 20,
                });
                r.grid.template.setAll({
                  stroke: am5.color(
                    KTUtil.getCssVariableValue("--bs-gray-700")
                  ),
                });
                var o = a.xAxes.push(
                    am5xy.CategoryAxis.new(t, {
                      maxDeviation: 0,
                      categoryField: "category",
                      renderer: l,
                      tooltip: am5.Tooltip.new(t, {}),
                    })
                  ),
                  i = a.yAxes.push(
                    am5xy.ValueAxis.new(t, { min: 0, max: 10, renderer: r })
                  );
                l.labels.template.setAll({
                  fontSize: 11,
                  fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-800")),
                }),
                  r.labels.template.setAll({
                    fontSize: 11,
                    fill: am5.color(
                      KTUtil.getCssVariableValue("--bs-gray-800")
                    ),
                  });
                var s = a.series.push(
                  am5radar.RadarColumnSeries.new(t, {
                    xAxis: o,
                    yAxis: i,
                    valueYField: "value",
                    categoryXField: "category",
                  })
                );
                s.columns.template.setAll({
                  tooltipText: "{categoryX}: {valueY}",
                  templateField: "columnSettings",
                  strokeOpacity: 0,
                  width: am5.p100,
                });
                var n = [
                  {
                    category: "Spain",
                    value: 5,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                  {
                    category: "Spain",
                    value: 4,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                  {
                    category: "United States",
                    value: 9,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                  {
                    category: "Italy",
                    value: 7,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                  {
                    category: "France",
                    value: 8,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                  {
                    category: "Norway",
                    value: 4,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                  {
                    category: "Brasil",
                    value: 7,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                  {
                    category: "Canada",
                    value: 5,
                    columnSettings: { fill: a.get("colors").next() },
                  },
                ];
                s.data.setAll(n),
                  o.data.setAll(n),
                  s.appear(1e3),
                  a.appear(1e3, 100);
              }
            };
          am5.ready(function () {
            a();
          }),
            KTThemeMode.on("kt.thememode.change", function () {
              t.dispose(), a();
            });
        }
      }
    })();
  },
};
"undefined" != typeof module && (module.exports = KTChartsWidget40),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget40.init();
  });
var KTChartsWidget41 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = { self: null, rendered: !1 },
    l = { self: null, rendered: !1 },
    r = { self: null, rendered: !1 },
    o = function (e, t, a, l, r, o) {
      var i = document.querySelector(a);
      if (i) {
        var s = parseInt(KTUtil.css(i, "height")),
          n = i.getAttribute("data-kt-chart-color"),
          d = KTUtil.getCssVariableValue("--bs-gray-500"),
          m = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          c = KTUtil.getCssVariableValue("--bs-" + n),
          g = {
            series: [{ name: "Earnings", data: l }],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: s,
              toolbar: { show: !1 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0.2,
                stops: [15, 120, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [c] },
            xaxis: {
              categories: r,
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              offsetX: 20,
              tickAmount: 4,
              labels: {
                rotate: 0,
                rotateAlways: !1,
                show: !1,
                style: { colors: d, fontSize: "12px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: c, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: { tickAmount: 4, max: 4e3, min: 1e3, labels: { show: !1 } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return e + "$";
                },
              },
            },
            colors: [c],
            grid: {
              borderColor: m,
              strokeDashArray: 3,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: c, strokeWidth: 3 },
          };
        e.self = new ApexCharts(i, g);
        var f = document.querySelector(t);
        !0 === o &&
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200),
          f.addEventListener("shown.bs.tab", function (t) {
            !1 === e.rendered && (e.self.render(), (e.rendered = !0));
          });
      }
    };
  return {
    init: function () {
      var i = [
          2100, 3100, 3100, 2400, 2400, 1800, 1800, 2400, 2400, 3200, 3200,
          2800, 2800, 3250, 3250,
        ],
        s = [
          "10AM",
          "10.30AM",
          "11AM",
          "11.15AM",
          "11.30AM",
          "12PM",
          "1PM",
          "2PM",
          "3PM",
          "4PM",
          "5PM",
          "6PM",
          "7PM",
          "8PM",
          "9PM",
        ];
      o(
        e,
        "#kt_charts_widget_41_tab_1",
        "#kt_charts_widget_41_chart_1",
        i,
        s,
        !0
      );
      var n = [
          2300, 2300, 2e3, 3200, 3200, 2800, 2400, 2400, 3100, 2900, 3200, 3200,
          2600, 2600, 3200,
        ],
        d = [
          "Apr 01",
          "Apr 02",
          "Apr 03",
          "Apr 04",
          "Apr 05",
          "Apr 06",
          "Apr 07",
          "Apr 08",
          "Apr 09",
          "Apr 10",
          "Apr 11",
          "Apr 12",
          "Apr 13",
          "Apr 14",
          "Apr 15",
        ];
      o(
        t,
        "#kt_charts_widget_41_tab_2",
        "#kt_charts_widget_41_chart_2",
        n,
        d,
        !1
      );
      var m = [
          2600, 3200, 2300, 2300, 2e3, 3200, 3100, 2900, 3400, 3400, 2600, 3200,
          2800, 2400, 2400,
        ],
        c = [
          "Apr 02",
          "Apr 03",
          "Apr 04",
          "Apr 05",
          "Apr 06",
          "Apr 09",
          "Apr 10",
          "Apr 12",
          "Apr 14",
          "Apr 17",
          "Apr 18",
          "Apr 18",
          "Apr 20",
          "Apr 22",
          "Apr 24",
        ];
      o(
        a,
        "#kt_charts_widget_41_tab_3",
        "#kt_charts_widget_41_chart_3",
        m,
        c,
        !1
      );
      var g = [
          1800, 1800, 2400, 2400, 3200, 3200, 3e3, 2100, 3200, 3200, 2400, 2400,
          3e3, 3200, 3100,
        ],
        f = [
          "Jun 2021",
          "Jul 2021",
          "Aug 2021",
          "Sep 2021",
          "Oct 2021",
          "Nov 2021",
          "Dec 2021",
          "Jan 2022",
          "Feb 2022",
          "Mar 2022",
          "Apr 2022",
          "May 2022",
          "Jun 2022",
          "Jul 2022",
          "Aug 2022",
        ];
      o(
        l,
        "#kt_charts_widget_41_tab_4",
        "#kt_charts_widget_41_chart_4",
        g,
        f,
        !1
      );
      var u = [
          3200, 2100, 3200, 3200, 3200, 3500, 3e3, 2400, 3250, 2400, 2400, 3250,
          3e3, 2400, 2800,
        ],
        h = [
          "Sep 2021",
          "Oct 2021",
          "Nov 2021",
          "Dec 2021",
          "Jan 2022",
          "Feb 2022",
          "Mar 2022",
          "Apr 2022",
          "May 2022",
          "Jun 2022",
          "Jul 2022",
          "Aug 2022",
          "Sep 2022",
          "Oct 2022",
          "Nov 2022",
        ];
      o(
        r,
        "#kt_charts_widget_41_tab_5",
        "#kt_charts_widget_41_chart_5",
        u,
        h,
        !1
      ),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(),
            t.rendered && t.self.destroy(),
            a.rendered && a.self.destroy(),
            l.rendered && l.self.destroy(),
            r.rendered && r.self.destroy(),
            o(
              e,
              "#kt_charts_widget_41_tab_1",
              "#kt_charts_widget_41_chart_1",
              i,
              s,
              e.rendered
            ),
            o(
              t,
              "#kt_charts_widget_41_tab_2",
              "#kt_charts_widget_41_chart_2",
              n,
              d,
              t.rendered
            ),
            o(
              a,
              "#kt_charts_widget_41_tab_3",
              "#kt_charts_widget_41_chart_3",
              m,
              c,
              a.rendered
            ),
            o(
              l,
              "#kt_charts_widget_41_tab_4",
              "#kt_charts_widget_41_chart_4",
              g,
              f,
              l.rendered
            ),
            o(
              r,
              "#kt_charts_widget_41_tab_5",
              "#kt_charts_widget_41_chart_5",
              u,
              h,
              r.rendered
            );
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget41),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget41.init();
  });
var KTChartsWidget42 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_charts_widget_42");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-gray-500"),
          r = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          o = KTUtil.getCssVariableValue("--bs-primary"),
          i = KTUtil.getCssVariableValue("--bs-success"),
          s = {
            series: [
              {
                name: "Inbound Calls",
                data: [45, 80, 53, 80, 75, 100, 76, 117, 76, 110, 70, 112],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [o, i] },
            xaxis: {
              categories: [
                "",
                "29 Sep",
                "1 Aug",
                "2 Aug",
                "3 Aug",
                "4 Aug",
                "5 Aug",
                "6 Aug",
                "7 Aug",
                "8 Aug",
                "9 Aug",
                "10 Aug",
                "11 Aug",
                "12 Aug",
                "13 Aug",
                "14 Aug",
                "15 Aug",
                "16 Aug",
                "",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              tickAmount: 6,
              labels: {
                rotate: 0,
                rotateAlways: !0,
                style: { colors: l, fontSize: "12px" },
              },
              crosshairs: {
                position: "front",
                stroke: { color: [o, i], width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: {
              max: 120,
              min: 30,
              tickAmount: 6,
              labels: { style: { colors: l, fontSize: "12px" } },
            },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: { style: { fontSize: "12px" } },
            colors: [o, i],
            grid: {
              borderColor: r,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
            markers: { strokeColor: [o, i], strokeWidth: 3 },
          };
        (e.self = new ApexCharts(t, s)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget42),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget42.init();
  });
var KTChartsWidget43 = (function () {
  var e = { self: null, rendered: !1 },
    t = function () {
      var t = document.getElementById("kt_charts_widget_43");
      if (t) {
        var a = t.getAttribute("data-kt-chart-color"),
          l = parseInt(KTUtil.css(t, "height")),
          r = KTUtil.getCssVariableValue("--bs-gray-800"),
          o = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          i = KTUtil.getCssVariableValue("--bs-" + a),
          s = KTUtil.getCssVariableValue("--bs-" + a + "-light"),
          n = {
            series: [
              {
                name: "Overview",
                data: [30, 30, 45, 45, 35, 35, 25, 25, 50, 50],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: l,
              toolbar: { show: !1 },
              zoom: { enabled: !1 },
              sparkline: { enabled: !0 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: { type: "solid", opacity: 1 },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [i] },
            xaxis: {
              categories: [
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { show: !1, style: { colors: r, fontSize: "12px" } },
              crosshairs: {
                show: !1,
                position: "front",
                stroke: { color: o, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: {
              min: 0,
              max: 60,
              labels: { show: !1, style: { colors: r, fontSize: "12px" } },
            },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return e;
                },
              },
            },
            colors: [s],
            markers: { colors: s, strokeColor: i, strokeWidth: 3 },
          };
        (e.self = new ApexCharts(t, n)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t();
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget43),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget43.init();
  });
var KTChartsWidget44 = (function () {
  var e = { self: null, rendered: !1 },
    t = function () {
      var t = document.getElementById("kt_charts_widget_44");
      if (t) {
        var a = t.getAttribute("data-kt-chart-color"),
          l = parseInt(KTUtil.css(t, "height")),
          r = KTUtil.getCssVariableValue("--bs-gray-800"),
          o = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          i = KTUtil.getCssVariableValue("--bs-" + a),
          s = KTUtil.getCssVariableValue("--bs-" + a + "-light"),
          n = {
            series: [
              { name: "Overview", data: [20, 37, 22, 45, 20, 50, 25, 57, 40] },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: l,
              toolbar: { show: !1 },
              zoom: { enabled: !1 },
              sparkline: { enabled: !0 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: { type: "solid", opacity: 1 },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [i] },
            xaxis: {
              categories: [
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { show: !1, style: { colors: r, fontSize: "12px" } },
              crosshairs: {
                show: !1,
                position: "front",
                stroke: { color: o, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: {
              min: 0,
              max: 60,
              labels: { show: !1, style: { colors: r, fontSize: "12px" } },
            },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return e;
                },
              },
            },
            colors: [s],
            markers: { colors: s, strokeColor: i, strokeWidth: 3 },
          };
        (e.self = new ApexCharts(t, n)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t();
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget44),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget44.init();
  });
var KTChartsWidget45 = (function () {
  var e = { self: null, rendered: !1 },
    t = function () {
      var t = document.getElementById("kt_charts_widget_45");
      if (t) {
        var a = t.getAttribute("data-kt-chart-color"),
          l = parseInt(KTUtil.css(t, "height")),
          r = KTUtil.getCssVariableValue("--bs-gray-800"),
          o = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          i = KTUtil.getCssVariableValue("--bs-" + a),
          s = KTUtil.getCssVariableValue("--bs-" + a),
          n = {
            series: [{ name: "Overview", data: [15, 15, 42, 42, 13, 13, 35] }],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: l,
              toolbar: { show: !1 },
              zoom: { enabled: !1 },
              sparkline: { enabled: !0 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.3,
                opacityTo: 0.2,
                stops: [15, 120, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 3, colors: [i] },
            xaxis: {
              categories: ["Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { show: !1, style: { colors: r, fontSize: "12px" } },
              crosshairs: {
                show: !1,
                position: "front",
                stroke: { color: o, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: {
              min: 0,
              max: 60,
              labels: { show: !1, style: { colors: r, fontSize: "12px" } },
            },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return e;
                },
              },
            },
            colors: [s],
            markers: { colors: s, strokeColor: i, strokeWidth: 3 },
          };
        (e.self = new ApexCharts(t, n)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t();
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget45),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget45.init();
  });
var KTChartsWidget46 = (function () {
  var e = { self: null, rendered: !1 },
    t = function () {
      var t = document.getElementById("kt_charts_widget_46");
      if (t) {
        var a = t.hasAttribute("data-kt-negative-color")
            ? t.getAttribute("data-kt-negative-color")
            : KTUtil.getCssVariableValue("--bs-gary-500"),
          l = parseInt(KTUtil.css(t, "height")),
          r = KTUtil.getCssVariableValue("--bs-gray-500"),
          o = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          i = {
            series: [
              {
                name: "Subscribed",
                data: [
                  20, 30, 20, 40, 60, 75, 65, 18, 10, 5, 15, 40, 60, 18, 35, 55,
                  20,
                ],
              },
              {
                name: "Unsubscribed",
                data: [
                  -20, -15, -5, -20, -30, -15, -10, -8, -5, -5, -10, -25, -15,
                  -5, -10, -5, -15,
                ],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "bar",
              stacked: !0,
              height: l,
              toolbar: { show: !1 },
            },
            plotOptions: {
              bar: {
                columnWidth: "35%",
                barHeight: "70%",
                borderRadius: [4, 4],
              },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            xaxis: {
              categories: [
                "Jan 5",
                "Jan 7",
                "Jan 9",
                "Jan 11",
                "Jan 13",
                "Jan 15",
                "Jan 17",
                "Jan 19",
                "Jan 20",
                "Jan 21",
                "Jan 23",
                "Jan 24",
                "Jan 25",
                "Jan 26",
                "Jan 24",
                "Jan 28",
                "Jan 29",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              tickAmount: 10,
              labels: { style: { colors: [r], fontSize: "12px" } },
              crosshairs: { show: !1 },
            },
            yaxis: {
              min: -100,
              max: 150,
              tickAmount: 5,
              labels: {
                style: { colors: [r], fontSize: "12px" },
                formatter: function (e) {
                  return parseInt(e);
                },
              },
            },
            fill: { opacity: 1 },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px", borderRadius: 4 },
              y: {
                formatter: function (e) {
                  return e > 0 ? e + "K" : Math.abs(e) + "K";
                },
              },
            },
            colors: [KTUtil.getCssVariableValue("--bs-gray-800"), a],
            grid: {
              borderColor: o,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
          };
        (e.self = new ApexCharts(t, i)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t();
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget46),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget46.init();
  });
var KTChartsWidget47 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_charts_widget_47");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-white"),
          r = {
            series: [
              {
                name: "Sales",
                data: [
                  5, 5, 15, 15, 19, 16, 27, 24, 34, 25, 40, 30, 19, 17, 22, 10,
                  14, 14,
                ],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.5,
                opacityTo: 0,
                stops: [0, 80, 100],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 2, colors: [l] },
            xaxis: {
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { show: !1 },
              crosshairs: {
                position: "front",
                stroke: { color: l, width: 1, dashArray: 3 },
              },
              tooltip: { enabled: !1 },
            },
            yaxis: { labels: { show: !1 } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: { enabled: !1 },
            colors: [KTUtil.getCssVariableValue("--bs-white")],
            grid: { yaxis: { lines: { show: !1 } } },
            markers: { strokeColor: l, strokeWidth: 2 },
          };
        (e.self = new ApexCharts(t, r)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget47),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget47.init();
  });
var KTChartsWidget48 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_charts_widget_48");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-danger"),
          r = {
            series: [
              {
                name: "Sales",
                data: [
                  5, 5, 15, 15, 19, 16, 27, 24, 34, 25, 40, 30, 19, 17, 22, 10,
                  14, 14,
                ],
              },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.5,
                opacityTo: 0,
                stops: [0, 120, 50],
              },
            },
            stroke: { curve: "smooth", show: !0, width: 2, colors: [l] },
            xaxis: {
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { show: !1 },
              crosshairs: {
                position: "front",
                stroke: { color: l, width: 1, dashArray: 3 },
              },
              tooltip: { enabled: !1 },
            },
            yaxis: { labels: { show: !1 } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: { enabled: !1 },
            colors: [KTUtil.getCssVariableValue("--bs-danger")],
            grid: { yaxis: { lines: { show: !1 } } },
            markers: { strokeColor: l, strokeWidth: 2 },
          };
        (e.self = new ApexCharts(t, r)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget48),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget48.init();
  });
var KTChartsWidget5 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_charts_widget_5");
      if (t) {
        var a = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          l = {
            series: [{ data: [15, 12, 10, 8, 7, 4, 3], show: !1 }],
            chart: { type: "bar", height: 350, toolbar: { show: !1 } },
            plotOptions: {
              bar: {
                borderRadius: 4,
                horizontal: !0,
                distributed: !0,
                barHeight: 23,
              },
            },
            dataLabels: { enabled: !1 },
            legend: { show: !1 },
            colors: [
              "#3E97FF",
              "#F1416C",
              "#50CD89",
              "#FFC700",
              "#7239EA",
              "#50CDCD",
              "#3F4254",
            ],
            xaxis: {
              categories: [
                "Phones",
                "Laptops",
                "Headsets",
                "Games",
                "Keyboardsy",
                "Monitors",
                "Speakers",
              ],
              labels: {
                formatter: function (e) {
                  return e + "K";
                },
                style: {
                  colors: KTUtil.getCssVariableValue("--bs-gray-400"),
                  fontSize: "14px",
                  fontWeight: "600",
                  align: "left",
                },
              },
              axisBorder: { show: !1 },
            },
            yaxis: {
              labels: {
                style: {
                  colors: KTUtil.getCssVariableValue("--bs-gray-800"),
                  fontSize: "14px",
                  fontWeight: "600",
                },
                offsetY: 2,
                align: "left",
              },
            },
            grid: {
              borderColor: a,
              xaxis: { lines: { show: !0 } },
              yaxis: { lines: { show: !1 } },
              strokeDashArray: 4,
            },
          };
        (e.self = new ApexCharts(t, l)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget5),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget5.init();
  });
var KTChartsWidget6 = (function () {
  var e = { self: null, rendered: !1 },
    t = function (e) {
      var t = document.getElementById("kt_charts_widget_6");
      if (t) {
        var a = KTUtil.getCssVariableValue("--bs-gray-800"),
          l = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          r = {
            series: [{ name: "Sales", data: [15, 12, 10, 8, 7] }],
            chart: {
              fontFamily: "inherit",
              type: "bar",
              height: 350,
              toolbar: { show: !1 },
            },
            plotOptions: {
              bar: {
                borderRadius: 8,
                horizontal: !0,
                distributed: !0,
                barHeight: 50,
                dataLabels: { position: "bottom" },
              },
            },
            dataLabels: {
              enabled: !0,
              textAnchor: "start",
              offsetX: 0,
              formatter: function (e, t) {
                e *= 1e3;
                return wNumb({ thousand: "," }).to(e);
              },
              style: { fontSize: "14px", fontWeight: "600", align: "left" },
            },
            legend: { show: !1 },
            colors: ["#3E97FF", "#F1416C", "#50CD89", "#FFC700", "#7239EA"],
            xaxis: {
              categories: [
                "ECR - 90%",
                "FGI - 82%",
                "EOQ - 75%",
                "FMG - 60%",
                "PLG - 50%",
              ],
              labels: {
                formatter: function (e) {
                  return e + "K";
                },
                style: {
                  colors: [a],
                  fontSize: "14px",
                  fontWeight: "600",
                  align: "left",
                },
              },
              axisBorder: { show: !1 },
            },
            yaxis: {
              labels: {
                formatter: function (e, t) {
                  return Number.isInteger(e)
                    ? e + " - " + parseInt((100 * e) / 18).toString() + "%"
                    : e;
                },
                style: { colors: a, fontSize: "14px", fontWeight: "600" },
                offsetY: 2,
                align: "left",
              },
            },
            grid: {
              borderColor: l,
              xaxis: { lines: { show: !0 } },
              yaxis: { lines: { show: !1 } },
              strokeDashArray: 4,
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return e + "K";
                },
              },
            },
          };
        (e.self = new ApexCharts(t, r)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(e),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t(e);
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget6),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget6.init();
  });
var KTChartsWidget7 = (function () {
  var e = function (e) {
    var t = document.querySelector(e);
    if (t) {
      var a = parseInt(KTUtil.css(t, "height")),
        l = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
        r = {
          series: [
            { name: "Net Profit", data: data1 },
            { name: "Revenue", data: data2 },
          ],
          chart: {
            fontFamily: "inherit",
            type: "bar",
            height: a,
            toolbar: { show: !1 },
          },
          plotOptions: {
            bar: { horizontal: !1, columnWidth: ["40%"], borderRadius: [6] },
          },
          legend: { show: !1 },
          dataLabels: { enabled: !1 },
          stroke: { show: !0, width: 2, colors: ["transparent"] },
          xaxis: {
            categories: ["Feb", "Mar", "Apr", "May", "Jun", "Jul"],
            axisBorder: { show: !1 },
            axisTicks: { show: !1 },
            labels: {
              style: {
                colors: KTUtil.getCssVariableValue("--bs-gray-700"),
                fontSize: "12px",
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: KTUtil.getCssVariableValue("--bs-gray-700"),
                fontSize: "12px",
              },
            },
          },
          fill: { opacity: 1 },
          states: {
            normal: { filter: { type: "none", value: 0 } },
            hover: { filter: { type: "none", value: 0 } },
            active: {
              allowMultipleDataPointsSelection: !1,
              filter: { type: "none", value: 0 },
            },
          },
          tooltip: {
            style: { fontSize: "12px" },
            y: {
              formatter: function (e) {
                return "$" + e + " thousands";
              },
            },
          },
          colors: [
            KTUtil.getCssVariableValue("--bs-primary"),
            KTUtil.getCssVariableValue("--bs-primary-light"),
          ],
          grid: {
            borderColor: l,
            strokeDashArray: 4,
            yaxis: { lines: { show: !0 } },
          },
        },
        o = new ApexCharts(t, r),
        i = !1,
        s = document.querySelector(tabSelector);
      !0 === initByDefault && (o.render(), (i = !0)),
        s.addEventListener("shown.bs.tab", function (e) {
          0 == i && (o.render(), (i = !0));
        }),
        (o = new ApexCharts(t, r)).render();
    }
  };
  return {
    init: function () {
      e("#kt_chart_widget_7_tab_1"),
        e("#kt_chart_widget_7_tab_2"),
        e("#kt_chart_widget_7_tab_3"),
        e("#kt_chart_widget_7_tab_4");
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget7),
  KTUtil.onDOMContentLoaded(function () {});
var KTChartsWidget8 = (function () {
  var e = { self: null, rendered: !1 },
    t = { self: null, rendered: !1 },
    a = function (e, t, a, l, r) {
      var o = document.querySelector(a);
      if (o) {
        var i = parseInt(KTUtil.css(o, "height")),
          s = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          n = {
            series: [
              { name: "Social Campaigns", data: l[0] },
              { name: "Email Newsletter", data: l[1] },
              { name: "TV Campaign", data: l[2] },
              { name: "Google Ads", data: l[3] },
              { name: "Courses", data: l[4] },
              { name: "Radio", data: l[5] },
            ],
            chart: {
              fontFamily: "inherit",
              type: "bubble",
              height: i,
              toolbar: { show: !1 },
            },
            plotOptions: { bubble: {} },
            stroke: { show: !1, width: 0 },
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            xaxis: {
              type: "numeric",
              tickAmount: 7,
              min: 0,
              max: 700,
              axisBorder: { show: !1 },
              axisTicks: { show: !0, height: 0 },
              labels: {
                show: !0,
                trim: !0,
                style: {
                  colors: KTUtil.getCssVariableValue("--bs-gray-500"),
                  fontSize: "13px",
                },
              },
            },
            yaxis: {
              tickAmount: 7,
              min: 0,
              max: 700,
              labels: {
                style: {
                  colors: KTUtil.getCssVariableValue("--bs-gray-500"),
                  fontSize: "13px",
                },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              x: {
                formatter: function (e) {
                  return "Clicks: " + e;
                },
              },
              y: {
                formatter: function (e) {
                  return "$" + e + "K";
                },
              },
              z: { title: "Impression: " },
            },
            crosshairs: {
              show: !0,
              position: "front",
              stroke: {
                color: KTUtil.getCssVariableValue("--bs-border-dashed-color"),
                width: 1,
                dashArray: 0,
              },
            },
            colors: [
              KTUtil.getCssVariableValue("--bs-primary"),
              KTUtil.getCssVariableValue("--bs-success"),
              KTUtil.getCssVariableValue("--bs-warning"),
              KTUtil.getCssVariableValue("--bs-danger"),
              KTUtil.getCssVariableValue("--bs-info"),
              "#43CED7",
            ],
            fill: { opacity: 1 },
            markers: { strokeWidth: 0 },
            grid: {
              borderColor: s,
              strokeDashArray: 4,
              padding: { right: 20 },
              yaxis: { lines: { show: !0 } },
            },
          };
        e.self = new ApexCharts(o, n);
        var d = document.querySelector(t);
        !0 === r &&
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200),
          d.addEventListener("shown.bs.tab", function (t) {
            !1 === e.rendered && (e.self.render(), (e.rendered = !0));
          });
      }
    };
  return {
    init: function () {
      var l = [
          [[100, 250, 30]],
          [[225, 300, 35]],
          [[300, 350, 25]],
          [[350, 350, 20]],
          [[450, 400, 25]],
          [[550, 350, 35]],
        ],
        r = [
          [[125, 300, 40]],
          [[250, 350, 35]],
          [[350, 450, 30]],
          [[450, 250, 25]],
          [[500, 500, 30]],
          [[600, 250, 28]],
        ];
      a(
        e,
        "#kt_chart_widget_8_week_toggle",
        "#kt_chart_widget_8_week_chart",
        l,
        !1
      ),
        a(
          t,
          "#kt_chart_widget_8_month_toggle",
          "#kt_chart_widget_8_month_chart",
          r,
          !0
        );
      KTThemeMode.on("kt.thememode.change", function () {
        e.rendered && e.self.destroy(),
          t.rendered && t.self.destroy(),
          a(
            e,
            "#kt_chart_widget_8_week_toggle",
            "#kt_chart_widget_8_week_chart",
            l,
            e.rendered
          ),
          a(
            t,
            "#kt_chart_widget_8_month_toggle",
            "#kt_chart_widget_8_month_chart",
            r,
            t.rendered
          );
      });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget8),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget8.init();
  });
var KTChartsWidget9 = (function () {
  var e = { self: null, rendered: !1 },
    t = function () {
      var t = document.getElementById("kt_charts_widget_9");
      if (t) {
        var a = parseInt(KTUtil.css(t, "height")),
          l = KTUtil.getCssVariableValue("--bs-gray-400"),
          r = KTUtil.getCssVariableValue("--bs-border-dashed-color"),
          o = KTUtil.getCssVariableValue("--bs-gray-200"),
          i = KTUtil.getCssVariableValue("--bs-primary"),
          s = {
            series: [
              { name: "Order", data: [21, 21, 26, 26, 31, 31, 27] },
              { name: "Revenue", data: [12, 16, 16, 21, 21, 18, 18] },
            ],
            chart: {
              fontFamily: "inherit",
              type: "area",
              height: a,
              toolbar: { show: !1 },
            },
            plotOptions: {},
            legend: { show: !1 },
            dataLabels: { enabled: !1 },
            fill: { type: "solid", opacity: 1 },
            stroke: { curve: "smooth", colors: [o] },
            xaxis: {
              categories: [
                "",
                "06 Sep",
                "13 Sep",
                "20 Sep",
                "27 Sep",
                "30 Sep",
                "",
              ],
              axisBorder: { show: !1 },
              axisTicks: { show: !1 },
              labels: { style: { colors: l, fontSize: "12px" } },
              crosshairs: {
                position: "front",
                stroke: { color: l, width: 1, dashArray: 3 },
              },
              tooltip: {
                enabled: !0,
                formatter: void 0,
                offsetY: 0,
                style: { fontSize: "12px" },
              },
            },
            yaxis: { labels: { style: { colors: l, fontSize: "12px" } } },
            states: {
              normal: { filter: { type: "none", value: 0 } },
              hover: { filter: { type: "none", value: 0 } },
              active: {
                allowMultipleDataPointsSelection: !1,
                filter: { type: "none", value: 0 },
              },
            },
            tooltip: {
              style: { fontSize: "12px" },
              y: {
                formatter: function (e) {
                  return "$" + e + " thousands";
                },
              },
            },
            crosshairs: {
              show: !0,
              position: "front",
              stroke: {
                color: KTUtil.getCssVariableValue("--bs-border-dashed-color"),
                width: 1,
                dashArray: 0,
              },
            },
            colors: [o, i],
            grid: {
              borderColor: r,
              strokeDashArray: 4,
              yaxis: { lines: { show: !0 } },
            },
            markers: {
              colors: [o, i],
              strokeColor: [
                KTUtil.getCssVariableValue("--bs-primary"),
                KTUtil.getCssVariableValue("--bs-gray-300"),
              ],
              strokeWidth: 3,
            },
          };
        (e.self = new ApexCharts(t, s)),
          setTimeout(function () {
            e.self.render(), (e.rendered = !0);
          }, 200);
      }
    };
  return {
    init: function () {
      t(),
        KTThemeMode.on("kt.thememode.change", function () {
          e.rendered && e.self.destroy(), t();
        });
    },
  };
})();
"undefined" != typeof module && (module.exports = KTChartsWidget9),
  KTUtil.onDOMContentLoaded(function () {
    KTChartsWidget9.init();
  });
var KTTimelineWidget1 = (function () {
  const e = () => {
      document
        .querySelectorAll('[data-kt-timeline-widget-1="tab"]')
        .forEach((e) => {
          e.addEventListener("shown.bs.tab", (a) => {
            "#kt_timeline_widget_1_tab_week" === e.getAttribute("href") &&
              (() => {
                const e = document.querySelector("#kt_timeline_widget_1_2");
                if (!e) return;
                if (e.innerHTML) return;
                var a = Date.now(),
                  l = e.getAttribute("data-kt-timeline-widget-1-image-root"),
                  r = new vis.DataSet([
                    { id: 1, content: "Research", order: 1 },
                    { id: 2, content: "Phase 2.6 QA", order: 2 },
                    { id: 3, content: "UI Design", order: 3 },
                    { id: 4, content: "Development", order: 4 },
                  ]),
                  o = new vis.DataSet([
                    {
                      id: 1,
                      group: 1,
                      start: a,
                      end: moment(a).add(7, "days"),
                      content: "Framework",
                      progress: "71%",
                      color: "primary",
                      users: ["avatars/300-6.jpg", "avatars/300-1.jpg"],
                    },
                    {
                      id: 2,
                      group: 2,
                      start: moment(a).add(7, "days"),
                      end: moment(a).add(14, "days"),
                      content: "Accessibility",
                      progress: "84%",
                      color: "success",
                      users: ["avatars/300-2.jpg"],
                    },
                    {
                      id: 3,
                      group: 3,
                      start: moment(a).add(3, "days"),
                      end: moment(a).add(20, "days"),
                      content: "Microsites",
                      progress: "69%",
                      color: "danger",
                      users: ["avatars/300-5.jpg", "avatars/300-20.jpg"],
                    },
                    {
                      id: 4,
                      group: 4,
                      start: moment(a).add(10, "days"),
                      end: moment(a).add(21, "days"),
                      content: "Deployment",
                      progress: "74%",
                      color: "info",
                      users: [
                        "avatars/300-23.jpg",
                        "avatars/300-12.jpg",
                        "avatars/300-9.jpg",
                      ],
                    },
                  ]),
                  i = {
                    zoomable: !1,
                    moveable: !1,
                    selectable: !1,
                    margin: { item: { horizontal: 10, vertical: 35 } },
                    showCurrentTime: !1,
                    xss: {
                      disabled: !1,
                      filterOptions: {
                        whiteList: {
                          div: ["class", "style"],
                          img: ["data-kt-timeline-avatar-src", "alt"],
                          a: ["href", "class"],
                        },
                      },
                    },
                    template: function (e) {
                      const t = e.users;
                      let a = "";
                      return (
                        t.forEach((e) => {
                          a += `<div class="symbol symbol-circle symbol-25px"><img data-kt-timeline-avatar-src="${
                            l + e
                          }" alt="" /></div>`;
                        }),
                        `<div class="rounded-pill bg-light-${e.color} d-flex align-items-center position-relative h-40px w-100 p-2 overflow-hidden">\n                    <div class="position-absolute rounded-pill d-block bg-${e.color} start-0 top-0 h-100 z-index-1" style="width: ${e.progress};"></div>\n        \n                    <div class="d-flex align-items-center position-relative z-index-2">\n                        <div class="symbol-group symbol-hover flex-nowrap me-3">\n                            ${a}\n                        </div>\n        \n                        <a href="#" class="fw-bold text-white text-hover-dark">${e.content}</a>\n                    </div>\n        \n                    <div class="d-flex flex-center bg-body rounded-pill fs-7 fw-bolder ms-auto h-100 px-3 position-relative z-index-2">\n                        ${e.progress}\n                    </div>\n                </div>        \n                `
                      );
                    },
                    onInitialDrawComplete: function () {
                      t();
                      const a = e.closest(
                          '[data-kt-timeline-widget-1-blockui="true"]'
                        ),
                        l = KTBlockUI.getInstance(a);
                      l.isBlocked() &&
                        setTimeout(() => {
                          l.release();
                        }, 1e3);
                    },
                  };
                const s = new vis.Timeline(e, o, r, i);
                s.on("currentTimeTick", () => {
                  s.off("currentTimeTick");
                });
              })(),
              "#kt_timeline_widget_1_tab_month" === e.getAttribute("href") &&
                (() => {
                  const e = document.querySelector("#kt_timeline_widget_1_3");
                  if (!e) return;
                  if (e.innerHTML) return;
                  var a = Date.now(),
                    l = e.getAttribute("data-kt-timeline-widget-1-image-root"),
                    r = new vis.DataSet([
                      { id: "research", content: "Research", order: 1 },
                      { id: "qa", content: "Phase 2.6 QA", order: 2 },
                      { id: "ui", content: "UI Design", order: 3 },
                      { id: "dev", content: "Development", order: 4 },
                    ]),
                    o = new vis.DataSet([
                      {
                        id: 1,
                        group: "research",
                        start: a,
                        end: moment(a).add(2, "months"),
                        content: "Tags",
                        progress: "79%",
                        color: "primary",
                        users: ["avatars/300-6.jpg", "avatars/300-1.jpg"],
                      },
                      {
                        id: 2,
                        group: "qa",
                        start: moment(a).add(0.5, "months"),
                        end: moment(a).add(5, "months"),
                        content: "Testing",
                        progress: "64%",
                        color: "success",
                        users: ["avatars/300-2.jpg"],
                      },
                      {
                        id: 3,
                        group: "ui",
                        start: moment(a).add(2, "months"),
                        end: moment(a).add(6.5, "months"),
                        content: "Media",
                        progress: "82%",
                        color: "danger",
                        users: ["avatars/300-5.jpg", "avatars/300-20.jpg"],
                      },
                      {
                        id: 4,
                        group: "dev",
                        start: moment(a).add(4, "months"),
                        end: moment(a).add(7, "months"),
                        content: "Plugins",
                        progress: "58%",
                        color: "info",
                        users: [
                          "avatars/300-23.jpg",
                          "avatars/300-12.jpg",
                          "avatars/300-9.jpg",
                        ],
                      },
                    ]),
                    i = {
                      zoomable: !1,
                      moveable: !1,
                      selectable: !1,
                      margin: { item: { horizontal: 10, vertical: 35 } },
                      showCurrentTime: !1,
                      xss: {
                        disabled: !1,
                        filterOptions: {
                          whiteList: {
                            div: ["class", "style"],
                            img: ["data-kt-timeline-avatar-src", "alt"],
                            a: ["href", "class"],
                          },
                        },
                      },
                      template: function (e) {
                        const t = e.users;
                        let a = "";
                        return (
                          t.forEach((e) => {
                            a += `<div class="symbol symbol-circle symbol-25px"><img data-kt-timeline-avatar-src="${
                              l + e
                            }" alt="" /></div>`;
                          }),
                          `<div class="rounded-pill bg-light-${e.color} d-flex align-items-center position-relative h-40px w-100 p-2 overflow-hidden">\n                    <div class="position-absolute rounded-pill d-block bg-${e.color} start-0 top-0 h-100 z-index-1" style="width: ${e.progress};"></div>\n        \n                    <div class="d-flex align-items-center position-relative z-index-2">\n                        <div class="symbol-group symbol-hover flex-nowrap me-3">\n                            ${a}\n                        </div>\n        \n                        <a href="#" class="fw-bold text-white text-hover-dark">${e.content}</a>\n                    </div>\n        \n                    <div class="d-flex flex-center bg-body rounded-pill fs-7 fw-bolder ms-auto h-100 px-3 position-relative z-index-2">\n                        ${e.progress}\n                    </div>\n                </div>        \n                `
                        );
                      },
                      onInitialDrawComplete: function () {
                        t();
                        const a = e.closest(
                            '[data-kt-timeline-widget-1-blockui="true"]'
                          ),
                          l = KTBlockUI.getInstance(a);
                        l.isBlocked() &&
                          setTimeout(() => {
                            l.release();
                          }, 1e3);
                      },
                    };
                  const s = new vis.Timeline(e, o, r, i);
                  s.on("currentTimeTick", () => {
                    s.off("currentTimeTick");
                  });
                })();
          });
        });
    },
    t = () => {
      const e = document.querySelectorAll("[data-kt-timeline-avatar-src]");
      e &&
        e.forEach((e) => {
          e.setAttribute("src", e.getAttribute("data-kt-timeline-avatar-src")),
            e.removeAttribute("data-kt-timeline-avatar-src");
        });
    };
  return {
    init: function () {
      (() => {
        const e = document.querySelector("#kt_timeline_widget_1_1");
        if (!e) return;
        if (e.innerHTML) return;
        var a = Date.now(),
          l = e.getAttribute("data-kt-timeline-widget-1-image-root"),
          r = new vis.DataSet([
            { id: "research", content: "Research", order: 1 },
            { id: "qa", content: "Phase 2.6 QA", order: 2 },
            { id: "ui", content: "UI Design", order: 3 },
            { id: "dev", content: "Development", order: 4 },
          ]),
          o = new vis.DataSet([
            {
              id: 1,
              group: "research",
              start: a,
              end: moment(a).add(1.5, "hours"),
              content: "Meeting",
              progress: "60%",
              color: "primary",
              users: ["avatars/300-6.jpg", "avatars/300-1.jpg"],
            },
            {
              id: 2,
              group: "qa",
              start: moment(a).add(1, "hours"),
              end: moment(a).add(2, "hours"),
              content: "Testing",
              progress: "47%",
              color: "success",
              users: ["avatars/300-2.jpg"],
            },
            {
              id: 3,
              group: "ui",
              start: moment(a).add(30, "minutes"),
              end: moment(a).add(2.5, "hours"),
              content: "Landing page",
              progress: "55%",
              color: "danger",
              users: ["avatars/300-5.jpg", "avatars/300-20.jpg"],
            },
            {
              id: 4,
              group: "dev",
              start: moment(a).add(1.5, "hours"),
              end: moment(a).add(3, "hours"),
              content: "Products module",
              progress: "75%",
              color: "info",
              users: [
                "avatars/300-23.jpg",
                "avatars/300-12.jpg",
                "avatars/300-9.jpg",
              ],
            },
          ]),
          i = {
            zoomable: !1,
            moveable: !1,
            selectable: !1,
            margin: { item: { horizontal: 10, vertical: 35 } },
            showCurrentTime: !1,
            xss: {
              disabled: !1,
              filterOptions: {
                whiteList: {
                  div: ["class", "style"],
                  img: ["data-kt-timeline-avatar-src", "alt"],
                  a: ["href", "class"],
                },
              },
            },
            template: function (e) {
              const t = e.users;
              let a = "";
              return (
                t.forEach((e) => {
                  a += `<div class="symbol symbol-circle symbol-25px"><img data-kt-timeline-avatar-src="${
                    l + e
                  }" alt="" /></div>`;
                }),
                `<div class="rounded-pill bg-light-${e.color} d-flex align-items-center position-relative h-40px w-100 p-2 overflow-hidden">\n                    <div class="position-absolute rounded-pill d-block bg-${e.color} start-0 top-0 h-100 z-index-1" style="width: ${e.progress};"></div>\n        \n                    <div class="d-flex align-items-center position-relative z-index-2">\n                        <div class="symbol-group symbol-hover flex-nowrap me-3">\n                            ${a}\n                        </div>\n        \n                        <a href="#" class="fw-bold text-white text-hover-dark">${e.content}</a>\n                    </div>\n        \n                    <div class="d-flex flex-center bg-body rounded-pill fs-7 fw-bolder ms-auto h-100 px-3 position-relative z-index-2">\n                        ${e.progress}\n                    </div>\n                </div>        \n                `
              );
            },
            onInitialDrawComplete: function () {
              t();
              const a = e.closest('[data-kt-timeline-widget-1-blockui="true"]'),
                l = KTBlockUI.getInstance(a);
              l.isBlocked() &&
                setTimeout(() => {
                  l.release();
                }, 1e3);
            },
          };
        const s = new vis.Timeline(e, o, r, i);
        s.on("currentTimeTick", () => {
          s.off("currentTimeTick");
        });
      })(),
        document
          .querySelectorAll('[data-kt-timeline-widget-1-blockui="true"]')
          .forEach((e) => {
            new KTBlockUI(e, { overlayClass: "bg-body" }).block();
          }),
        e();
    },
  };
})();
"undefined" != typeof module && (module.exports = KTTimelineWidget1),
  KTUtil.onDOMContentLoaded(function () {
    KTTimelineWidget1.init();
  });
var KTTimelineWidget2 = {
  init: function () {
    var e;
    (e = document.querySelector("#kt_timeline_widget_2_card")) &&
      KTUtil.on(e, '[data-kt-element="checkbox"]', "change", function (e) {
        var t = this.closest(".form-check"),
          a = this.closest("tr"),
          l = a.querySelector('[data-kt-element="bullet"]'),
          r = a.querySelector('[data-kt-element="status"]');
        !0 === this.checked
          ? (t.classList.add("form-check-success"),
            l.classList.remove("bg-primary"),
            l.classList.add("bg-success"),
            (r.innerText = "Done"),
            r.classList.remove("badge-light-primary"),
            r.classList.add("badge-light-success"))
          : (t.classList.remove("form-check-success"),
            l.classList.remove("bg-success"),
            l.classList.add("bg-primary"),
            (r.innerText = "In Process"),
            r.classList.remove("badge-light-success"),
            r.classList.add("badge-light-primary"));
      });
  },
};
"undefined" != typeof module && (module.exports = KTTimelineWidget2),
  KTUtil.onDOMContentLoaded(function () {
    KTTimelineWidget2.init();
  });
var KTTimelineWidget4 = (function () {
  const e = () => {
      document
        .querySelectorAll('[data-kt-timeline-widget-4="tab"]')
        .forEach((e) => {
          e.addEventListener("shown.bs.tab", (a) => {
            "#kt_timeline_widget_4_tab_week" === e.getAttribute("href") &&
              (() => {
                const e = document.querySelector("#kt_timeline_widget_4_2");
                if (!e) return;
                if (e.innerHTML) return;
                var a = Date.now(),
                  l = e.getAttribute("data-kt-timeline-widget-4-image-root"),
                  r = new vis.DataSet([
                    { id: 1, content: "Research", order: 1 },
                    { id: 2, content: "Phase 2.6 QA", order: 2 },
                    { id: 3, content: "UI Design", order: 3 },
                    { id: 4, content: "Development", order: 4 },
                  ]),
                  o = new vis.DataSet([
                    {
                      id: 1,
                      group: 1,
                      start: a,
                      end: moment(a).add(7, "days"),
                      content: "Framework",
                      progress: "71%",
                      color: "primary",
                      users: ["avatars/300-6.jpg", "avatars/300-1.jpg"],
                    },
                    {
                      id: 2,
                      group: 2,
                      start: moment(a).add(7, "days"),
                      end: moment(a).add(14, "days"),
                      content: "Accessibility",
                      progress: "84%",
                      color: "success",
                      users: ["avatars/300-2.jpg"],
                    },
                    {
                      id: 3,
                      group: 3,
                      start: moment(a).add(3, "days"),
                      end: moment(a).add(20, "days"),
                      content: "Microsites",
                      progress: "69%",
                      color: "danger",
                      users: ["avatars/300-5.jpg", "avatars/300-20.jpg"],
                    },
                    {
                      id: 4,
                      group: 4,
                      start: moment(a).add(10, "days"),
                      end: moment(a).add(21, "days"),
                      content: "Deployment",
                      progress: "74%",
                      color: "info",
                      users: [
                        "avatars/300-23.jpg",
                        "avatars/300-12.jpg",
                        "avatars/300-9.jpg",
                      ],
                    },
                  ]),
                  i = {
                    zoomable: !1,
                    moveable: !1,
                    selectable: !1,
                    margin: { item: { horizontal: 10, vertical: 35 } },
                    showCurrentTime: !1,
                    xss: {
                      disabled: !1,
                      filterOptions: {
                        whiteList: {
                          div: ["class", "style"],
                          img: ["data-kt-timeline-avatar-src", "alt"],
                          a: ["href", "class"],
                        },
                      },
                    },
                    template: function (e) {
                      const t = e.users;
                      let a = "";
                      return (
                        t.forEach((e) => {
                          a += `<div class="symbol symbol-circle symbol-25px"><img data-kt-timeline-avatar-src="${
                            l + e
                          }" alt="" /></div>`;
                        }),
                        `<div class="rounded-pill bg-light-${e.color} d-flex align-items-center position-relative h-40px w-100 p-2 overflow-hidden">\n                    <div class="position-absolute rounded-pill d-block bg-${e.color} start-0 top-0 h-100 z-index-1" style="width: ${e.progress};"></div>\n        \n                    <div class="d-flex align-items-center position-relative z-index-2">\n                        <div class="symbol-group symbol-hover flex-nowrap me-3">\n                            ${a}\n                        </div>\n        \n                        <a href="#" class="fw-bold text-white text-hover-dark">${e.content}</a>\n                    </div>\n        \n                    <div class="d-flex flex-center bg-body rounded-pill fs-7 fw-bolder ms-auto h-100 px-3 position-relative z-index-2">\n                        ${e.progress}\n                    </div>\n                </div>        \n                `
                      );
                    },
                    onInitialDrawComplete: function () {
                      t();
                      const a = e.closest(
                          '[data-kt-timeline-widget-4-blockui="true"]'
                        ),
                        l = KTBlockUI.getInstance(a);
                      l.isBlocked() &&
                        setTimeout(() => {
                          l.release();
                        }, 1e3);
                    },
                  };
                const s = new vis.Timeline(e, o, r, i);
                s.on("currentTimeTick", () => {
                  s.off("currentTimeTick");
                });
              })(),
              "#kt_timeline_widget_4_tab_month" === e.getAttribute("href") &&
                (() => {
                  const e = document.querySelector("#kt_timeline_widget_4_3");
                  if (!e) return;
                  if (e.innerHTML) return;
                  var a = Date.now(),
                    l = e.getAttribute("data-kt-timeline-widget-4-image-root"),
                    r = new vis.DataSet([
                      { id: "research", content: "Research", order: 1 },
                      { id: "qa", content: "Phase 2.6 QA", order: 2 },
                      { id: "ui", content: "UI Design", order: 3 },
                      { id: "dev", content: "Development", order: 4 },
                    ]),
                    o = new vis.DataSet([
                      {
                        id: 1,
                        group: "research",
                        start: a,
                        end: moment(a).add(2, "months"),
                        content: "Tags",
                        progress: "79%",
                        color: "primary",
                        users: ["avatars/300-6.jpg", "avatars/300-1.jpg"],
                      },
                      {
                        id: 2,
                        group: "qa",
                        start: moment(a).add(0.5, "months"),
                        end: moment(a).add(5, "months"),
                        content: "Testing",
                        progress: "64%",
                        color: "success",
                        users: ["avatars/300-2.jpg"],
                      },
                      {
                        id: 3,
                        group: "ui",
                        start: moment(a).add(2, "months"),
                        end: moment(a).add(6.5, "months"),
                        content: "Media",
                        progress: "82%",
                        color: "danger",
                        users: ["avatars/300-5.jpg", "avatars/300-20.jpg"],
                      },
                      {
                        id: 4,
                        group: "dev",
                        start: moment(a).add(4, "months"),
                        end: moment(a).add(7, "months"),
                        content: "Plugins",
                        progress: "58%",
                        color: "info",
                        users: [
                          "avatars/300-23.jpg",
                          "avatars/300-12.jpg",
                          "avatars/300-9.jpg",
                        ],
                      },
                    ]),
                    i = {
                      zoomable: !1,
                      moveable: !1,
                      selectable: !1,
                      margin: { item: { horizontal: 10, vertical: 35 } },
                      showCurrentTime: !1,
                      xss: {
                        disabled: !1,
                        filterOptions: {
                          whiteList: {
                            div: ["class", "style"],
                            img: ["data-kt-timeline-avatar-src", "alt"],
                            a: ["href", "class"],
                          },
                        },
                      },
                      template: function (e) {
                        const t = e.users;
                        let a = "";
                        return (
                          t.forEach((e) => {
                            a += `<div class="symbol symbol-circle symbol-25px"><img data-kt-timeline-avatar-src="${
                              l + e
                            }" alt="" /></div>`;
                          }),
                          `<div class="rounded-pill bg-light-${e.color} d-flex align-items-center position-relative h-40px w-100 p-2 overflow-hidden">\n                    <div class="position-absolute rounded-pill d-block bg-${e.color} start-0 top-0 h-100 z-index-1" style="width: ${e.progress};"></div>\n        \n                    <div class="d-flex align-items-center position-relative z-index-2">\n                        <div class="symbol-group symbol-hover flex-nowrap me-3">\n                            ${a}\n                        </div>\n        \n                        <a href="#" class="fw-bold text-white text-hover-dark">${e.content}</a>\n                    </div>\n        \n                    <div class="d-flex flex-center bg-body rounded-pill fs-7 fw-bolder ms-auto h-100 px-3 position-relative z-index-2">\n                        ${e.progress}\n                    </div>\n                </div>        \n                `
                        );
                      },
                      onInitialDrawComplete: function () {
                        t();
                        const a = e.closest(
                            '[data-kt-timeline-widget-4-blockui="true"]'
                          ),
                          l = KTBlockUI.getInstance(a);
                        l.isBlocked() &&
                          setTimeout(() => {
                            l.release();
                          }, 1e3);
                      },
                    };
                  const s = new vis.Timeline(e, o, r, i);
                  s.on("currentTimeTick", () => {
                    s.off("currentTimeTick");
                  });
                })(),
              "#kt_timeline_widget_4_tab_2022" === e.getAttribute("href") &&
                (() => {
                  const e = document.querySelector("#kt_timeline_widget_4_4");
                  if (!e) return;
                  if (e.innerHTML) return;
                  var a = Date.now(),
                    l = e.getAttribute("data-kt-timeline-widget-4-image-root"),
                    r = new vis.DataSet([
                      { id: "research", content: "Research", order: 1 },
                      { id: "qa", content: "Phase 2.6 QA", order: 2 },
                      { id: "ui", content: "UI Design", order: 3 },
                      { id: "dev", content: "Development", order: 4 },
                    ]),
                    o = new vis.DataSet([
                      {
                        id: 1,
                        group: "research",
                        start: a,
                        end: moment(a).add(2, "months"),
                        content: "Tags",
                        progress: "51%",
                        color: "primary",
                        users: ["avatars/300-7.jpg", "avatars/300-2.jpg"],
                      },
                      {
                        id: 2,
                        group: "qa",
                        start: moment(a).add(0.5, "months"),
                        end: moment(a).add(5, "months"),
                        content: "Testing",
                        progress: "64%",
                        color: "success",
                        users: ["avatars/300-2.jpg"],
                      },
                      {
                        id: 3,
                        group: "ui",
                        start: moment(a).add(2, "months"),
                        end: moment(a).add(6.5, "months"),
                        content: "Media",
                        progress: "54%",
                        color: "danger",
                        users: ["avatars/300-5.jpg", "avatars/300-21.jpg"],
                      },
                      {
                        id: 4,
                        group: "dev",
                        start: moment(a).add(4, "months"),
                        end: moment(a).add(7, "months"),
                        content: "Plugins",
                        progress: "348%",
                        color: "info",
                        users: [
                          "avatars/300-3.jpg",
                          "avatars/300-11.jpg",
                          "avatars/300-13.jpg",
                        ],
                      },
                    ]),
                    i = {
                      zoomable: !1,
                      moveable: !1,
                      selectable: !1,
                      margin: { item: { horizontal: 10, vertical: 35 } },
                      showCurrentTime: !1,
                      xss: {
                        disabled: !1,
                        filterOptions: {
                          whiteList: {
                            div: ["class", "style"],
                            img: ["data-kt-timeline-avatar-src", "alt"],
                            a: ["href", "class"],
                          },
                        },
                      },
                      template: function (e) {
                        const t = e.users;
                        let a = "";
                        return (
                          t.forEach((e) => {
                            a += `<div class="symbol symbol-circle symbol-25px"><img data-kt-timeline-avatar-src="${
                              l + e
                            }" alt="" /></div>`;
                          }),
                          `<div class="rounded-pill bg-light-${e.color} d-flex align-items-center position-relative h-40px w-100 p-2 overflow-hidden">\n                    <div class="position-absolute rounded-pill d-block bg-${e.color} start-0 top-0 h-100 z-index-1" style="width: ${e.progress};"></div>\n        \n                    <div class="d-flex align-items-center position-relative z-index-2">\n                        <div class="symbol-group symbol-hover flex-nowrap me-3">\n                            ${a}\n                        </div>\n        \n                        <a href="#" class="fw-bold text-white text-hover-dark">${e.content}</a>\n                    </div>\n        \n                    <div class="d-flex flex-center bg-body rounded-pill fs-7 fw-bolder ms-auto h-100 px-3 position-relative z-index-2">\n                        ${e.progress}\n                    </div>\n                </div>        \n                `
                        );
                      },
                      onInitialDrawComplete: function () {
                        t();
                        const a = e.closest(
                            '[data-kt-timeline-widget-4-blockui="true"]'
                          ),
                          l = KTBlockUI.getInstance(a);
                        l.isBlocked() &&
                          setTimeout(() => {
                            l.release();
                          }, 1e3);
                      },
                    };
                  const s = new vis.Timeline(e, o, r, i);
                  s.on("currentTimeTick", () => {
                    s.off("currentTimeTick");
                  });
                })();
          });
        });
    },
    t = () => {
      const e = document.querySelectorAll("[data-kt-timeline-avatar-src]");
      e &&
        e.forEach((e) => {
          e.setAttribute("src", e.getAttribute("data-kt-timeline-avatar-src")),
            e.removeAttribute("data-kt-timeline-avatar-src");
        });
    };
  return {
    init: function () {
      (() => {
        const e = document.querySelector("#kt_timeline_widget_4_1");
        if (!e) return;
        if (e.innerHTML) return;
        var a = Date.now(),
          l = e.getAttribute("data-kt-timeline-widget-4-image-root"),
          r = new vis.DataSet([
            { id: "research", content: "Research", order: 1 },
            { id: "qa", content: "Phase 2.6 QA", order: 2 },
            { id: "ui", content: "UI Design", order: 3 },
            { id: "dev", content: "Development", order: 4 },
          ]),
          o = new vis.DataSet([
            {
              id: 1,
              group: "research",
              start: a,
              end: moment(a).add(1.5, "hours"),
              content: "Meeting",
              progress: "60%",
              color: "primary",
              users: ["avatars/300-6.jpg", "avatars/300-1.jpg"],
            },
            {
              id: 2,
              group: "qa",
              start: moment(a).add(1, "hours"),
              end: moment(a).add(2, "hours"),
              content: "Testing",
              progress: "47%",
              color: "success",
              users: ["avatars/300-2.jpg"],
            },
            {
              id: 3,
              group: "ui",
              start: moment(a).add(30, "minutes"),
              end: moment(a).add(2.5, "hours"),
              content: "Landing page",
              progress: "55%",
              color: "danger",
              users: ["avatars/300-5.jpg", "avatars/300-20.jpg"],
            },
            {
              id: 4,
              group: "dev",
              start: moment(a).add(1.5, "hours"),
              end: moment(a).add(3, "hours"),
              content: "Products module",
              progress: "75%",
              color: "info",
              users: [
                "avatars/300-23.jpg",
                "avatars/300-12.jpg",
                "avatars/300-9.jpg",
              ],
            },
          ]),
          i = {
            zoomable: !1,
            moveable: !1,
            selectable: !1,
            margin: { item: { horizontal: 10, vertical: 35 } },
            showCurrentTime: !1,
            xss: {
              disabled: !1,
              filterOptions: {
                whiteList: {
                  div: ["class", "style"],
                  img: ["data-kt-timeline-avatar-src", "alt"],
                  a: ["href", "class"],
                },
              },
            },
            template: function (e) {
              const t = e.users;
              let a = "";
              return (
                t.forEach((e) => {
                  a += `<div class="symbol symbol-circle symbol-25px"><img data-kt-timeline-avatar-src="${
                    l + e
                  }" alt="" /></div>`;
                }),
                `<div class="rounded-pill bg-light-${e.color} d-flex align-items-center position-relative h-40px w-100 p-2 overflow-hidden">\n                    <div class="position-absolute rounded-pill d-block bg-${e.color} start-0 top-0 h-100 z-index-1" style="width: ${e.progress};"></div>\n        \n                    <div class="d-flex align-items-center position-relative z-index-2">\n                        <div class="symbol-group symbol-hover flex-nowrap me-3">\n                            ${a}\n                        </div>\n        \n                        <a href="#" class="fw-bold text-white text-hover-dark">${e.content}</a>\n                    </div>\n        \n                    <div class="d-flex flex-center bg-body rounded-pill fs-7 fw-bolder ms-auto h-100 px-3 position-relative z-index-2">\n                        ${e.progress}\n                    </div>\n                </div>        \n                `
              );
            },
            onInitialDrawComplete: function () {
              t();
              const a = e.closest('[data-kt-timeline-widget-4-blockui="true"]'),
                l = KTBlockUI.getInstance(a);
              l.isBlocked() &&
                setTimeout(() => {
                  l.release();
                }, 1e3);
            },
          };
        const s = new vis.Timeline(e, o, r, i);
        s.on("currentTimeTick", () => {
          s.off("currentTimeTick");
        });
      })(),
        document
          .querySelectorAll('[data-kt-timeline-widget-4-blockui="true"]')
          .forEach((e) => {
            new KTBlockUI(e, { overlayClass: "bg-body" }).block();
          }),
        e();
    },
  };
})();
"undefined" != typeof module && (module.exports = KTTimelineWidget4),
  KTUtil.onDOMContentLoaded(function () {
    KTTimelineWidget4.init();
  });

"use strict";var KTWidgets={init:function(){var e,t,a,o,r;!function(){if(document.querySelector("#kt_dashboard_daterangepicker")){var e=$("#kt_dashboard_daterangepicker"),t=moment(),a=moment();e.daterangepicker({direction:KTUtil.isRTL(),startDate:t,endDate:a,opens:"left",applyClass:"btn-primary",cancelClass:"btn-light-primary",ranges:{Today:[moment(),moment()],Yesterday:[moment().subtract(1,"days"),moment().subtract(1,"days")],"Last 7 Days":[moment().subtract(6,"days"),moment()],"Last 30 Days":[moment().subtract(29,"days"),moment()],"This Month":[moment().startOf("month"),moment().endOf("month")],"Last Month":[moment().subtract(1,"month").startOf("month"),moment().subtract(1,"month").endOf("month")]}},o),o(t,a,"")}function o(e,t,a){var o="",r="";t-e<100||"Today"==a?(o="Today:",r=e.format("MMM D")):"Yesterday"==a?(o="Yesterday:",r=e.format("MMM D")):r=e.format("MMM D")+" - "+t.format("MMM D"),$("#kt_dashboard_daterangepicker_date").html(r),$("#kt_dashboard_daterangepicker_title").html(o)}}(),(e=document.querySelector("#kt_user_menu_dark_mode_toggle"))&&e.addEventListener("click",(function(){window.location.href=this.getAttribute("data-kt-url")})),t=document.querySelectorAll(".statistics-widget-3-chart"),[].slice.call(t).map((function(e){var t=parseInt(KTUtil.css(e,"height"));if(e){var a=e.getAttribute("data-kt-chart-color"),o=KTUtil.getCssVariableValue("--bs-gray-800"),r=KTUtil.getCssVariableValue("--bs-"+a),s=KTUtil.getCssVariableValue("--bs-"+a+"-light");new ApexCharts(e,{series:[{name:"Net Profit",data:[30,45,32,70,40]}],chart:{fontFamily:"inherit",type:"area",height:t,toolbar:{show:!1},zoom:{enabled:!1},sparkline:{enabled:!0}},plotOptions:{},legend:{show:!1},dataLabels:{enabled:!1},fill:{type:"solid",opacity:.3},stroke:{curve:"smooth",show:!0,width:3,colors:[r]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{show:!1,style:{colors:o,fontSize:"12px"}},crosshairs:{show:!1,position:"front",stroke:{color:"#E4E6EF",width:1,dashArray:3}},tooltip:{enabled:!0,formatter:void 0,offsetY:0,style:{fontSize:"12px"}}},yaxis:{min:0,max:80,labels:{show:!1,style:{colors:o,fontSize:"12px"}}},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[r],markers:{colors:[r],strokeColor:[s],strokeWidth:3}}).render()}})),function(){var e=document.querySelectorAll(".statistics-widget-4-chart");[].slice.call(e).map((function(e){var t=parseInt(KTUtil.css(e,"height"));if(e){var a=e.getAttribute("data-kt-chart-color"),o=KTUtil.getCssVariableValue("--bs-gray-800"),r=KTUtil.getCssVariableValue("--bs-"+a),s=KTUtil.getCssVariableValue("--bs-"+a+"-light");new ApexCharts(e,{series:[{name:"Net Profit",data:[40,40,30,30,35,35,50]}],chart:{fontFamily:"inherit",type:"area",height:t,toolbar:{show:!1},zoom:{enabled:!1},sparkline:{enabled:!0}},plotOptions:{},legend:{show:!1},dataLabels:{enabled:!1},fill:{type:"solid",opacity:.3},stroke:{curve:"smooth",show:!0,width:3,colors:[r]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul","Aug"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{show:!1,style:{colors:o,fontSize:"12px"}},crosshairs:{show:!1,position:"front",stroke:{color:"#E4E6EF",width:1,dashArray:3}},tooltip:{enabled:!0,formatter:void 0,offsetY:0,style:{fontSize:"12px"}}},yaxis:{min:0,max:60,labels:{show:!1,style:{colors:o,fontSize:"12px"}}},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[r],markers:{colors:[r],strokeColor:[s],strokeWidth:3}}).render()}}))}(),function(){var e=document.getElementById("kt_charts_widget_1_chart");if(e){var t={self:null,rendered:!1},a=function(){var a=parseInt(KTUtil.css(e,"height")),o=KTUtil.getCssVariableValue("--bs-gray-500"),r=KTUtil.getCssVariableValue("--bs-gray-200"),s={series:[{name:"Net Profit",data:[44,55,57,56,61,58]},{name:"Revenue",data:[76,85,101,98,87,105]}],chart:{fontFamily:"inherit",type:"bar",height:a,toolbar:{show:!1}},plotOptions:{bar:{horizontal:!1,columnWidth:["30%"],borderRadius:[6]}},legend:{show:!1},dataLabels:{enabled:!1},stroke:{show:!0,width:2,colors:["transparent"]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{style:{colors:o,fontSize:"12px"}}},yaxis:{labels:{style:{colors:o,fontSize:"12px"}}},fill:{opacity:1},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[KTUtil.getCssVariableValue("--bs-primary"),KTUtil.getCssVariableValue("--bs-gray-300")],grid:{borderColor:r,strokeDashArray:4,yaxis:{lines:{show:!0}}}};t.self=new ApexCharts(e,s),t.self.render(),t.rendered=!0};a(),KTThemeMode.on("kt.thememode.change",(function(){t.rendered&&t.self.destroy(),a()}))}}(),function(){var e=document.getElementById("kt_charts_widget_2_chart");if(e){var t={self:null,rendered:!1},a=function(){var a=parseInt(KTUtil.css(e,"height")),o=KTUtil.getCssVariableValue("--bs-gray-500"),r=KTUtil.getCssVariableValue("--bs-gray-200"),s={series:[{name:"Net Profit",data:[44,55,57,56,61,58]},{name:"Revenue",data:[76,85,101,98,87,105]}],chart:{fontFamily:"inherit",type:"bar",height:a,toolbar:{show:!1}},plotOptions:{bar:{horizontal:!1,columnWidth:["30%"],borderRadius:4}},legend:{show:!1},dataLabels:{enabled:!1},stroke:{show:!0,width:2,colors:["transparent"]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{style:{colors:o,fontSize:"12px"}}},yaxis:{labels:{style:{colors:o,fontSize:"12px"}}},fill:{opacity:1},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[KTUtil.getCssVariableValue("--bs-warning"),KTUtil.getCssVariableValue("--bs-gray-300")],grid:{borderColor:r,strokeDashArray:4,yaxis:{lines:{show:!0}}}};t.self=new ApexCharts(e,s),t.self.render(),t.rendered=!0};a(),KTThemeMode.on("kt.thememode.change",(function(){t.rendered&&t.self.destroy(),a()}))}}(),function(){var e=document.getElementById("kt_charts_widget_3_chart");if(e){var t={self:null,rendered:!1},a=function(){parseInt(KTUtil.css(e,"height"));var a=KTUtil.getCssVariableValue("--bs-gray-500"),o=KTUtil.getCssVariableValue("--bs-gray-200"),r=KTUtil.getCssVariableValue("--bs-info"),s={series:[{name:"Net Profit",data:[30,40,40,90,90,70,70]}],chart:{fontFamily:"inherit",type:"area",height:350,toolbar:{show:!1}},plotOptions:{},legend:{show:!1},dataLabels:{enabled:!1},fill:{type:"solid",opacity:1},stroke:{curve:"smooth",show:!0,width:3,colors:[r]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul","Aug"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{style:{colors:a,fontSize:"12px"}},crosshairs:{position:"front",stroke:{color:r,width:1,dashArray:3}},tooltip:{enabled:!0,formatter:void 0,offsetY:0,style:{fontSize:"12px"}}},yaxis:{labels:{style:{colors:a,fontSize:"12px"}}},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[KTUtil.getCssVariableValue("--bs-info-light")],grid:{borderColor:o,strokeDashArray:4,yaxis:{lines:{show:!0}}},markers:{strokeColor:r,strokeWidth:3}};t.self=new ApexCharts(e,s),t.self.render(),t.rendered=!0};a(),KTThemeMode.on("kt.thememode.change",(function(){t.rendered&&t.self.destroy(),a()}))}}(),function(){var e=document.getElementById("kt_charts_widget_4_chart");if(e){var t={self:null,rendered:!1},a=function(){parseInt(KTUtil.css(e,"height"));var a=KTUtil.getCssVariableValue("--bs-gray-500"),o=KTUtil.getCssVariableValue("--bs-gray-200"),r=KTUtil.getCssVariableValue("--bs-success"),s=KTUtil.getCssVariableValue("--bs-success-light"),l=KTUtil.getCssVariableValue("--bs-warning"),i=KTUtil.getCssVariableValue("--bs-warning-light"),n={series:[{name:"Net Profit",data:[60,50,80,40,100,60]},{name:"Revenue",data:[70,60,110,40,50,70]}],chart:{fontFamily:"inherit",type:"area",height:350,toolbar:{show:!1}},plotOptions:{},legend:{show:!1},dataLabels:{enabled:!1},fill:{type:"solid",opacity:1},stroke:{curve:"smooth"},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{style:{colors:a,fontSize:"12px"}},crosshairs:{position:"front",stroke:{color:a,width:1,dashArray:3}},tooltip:{enabled:!0,formatter:void 0,offsetY:0,style:{fontSize:"12px"}}},yaxis:{labels:{style:{colors:a,fontSize:"12px"}}},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[r,l],grid:{borderColor:o,strokeDashArray:4,yaxis:{lines:{show:!0}}},markers:{colors:[s,i],strokeColor:[s,i],strokeWidth:3}};t.self=new ApexCharts(e,n),t.self.render(),t.rendered=!0};a(),KTThemeMode.on("kt.thememode.change",(function(){t.rendered&&t.self.destroy(),a()}))}}(),function(){var e=document.getElementById("kt_charts_widget_5_chart");if(e){var t={self:null,rendered:!1},a=function(){parseInt(KTUtil.css(e,"height"));var a=KTUtil.getCssVariableValue("--bs-gray-500"),o=KTUtil.getCssVariableValue("--bs-gray-200"),r={series:[{name:"Net Profit",data:[40,50,65,70,50,30]},{name:"Revenue",data:[-30,-40,-55,-60,-40,-20]}],chart:{fontFamily:"inherit",type:"bar",stacked:!0,height:350,toolbar:{show:!1}},plotOptions:{bar:{horizontal:!1,columnWidth:["12%"],borderRadius:[6,6]}},legend:{show:!1},dataLabels:{enabled:!1},stroke:{show:!0,width:2,colors:["transparent"]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{style:{colors:a,fontSize:"12px"}}},yaxis:{min:-80,max:80,labels:{style:{colors:a,fontSize:"12px"}}},fill:{opacity:1},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[KTUtil.getCssVariableValue("--bs-primary"),KTUtil.getCssVariableValue("--bs-info")],grid:{borderColor:o,strokeDashArray:4,yaxis:{lines:{show:!0}}}};t.self=new ApexCharts(e,r),t.self.render(),t.rendered=!0};a(),KTThemeMode.on("kt.thememode.change",(function(){t.rendered&&t.self.destroy(),a()}))}}(),function(){var e=document.getElementById("kt_charts_widget_6_chart");if(e){var t={self:null,rendered:!1},a=function(){parseInt(KTUtil.css(e,"height"));var a=KTUtil.getCssVariableValue("--bs-gray-500"),o=KTUtil.getCssVariableValue("--bs-gray-200"),r=KTUtil.getCssVariableValue("--bs-primary"),s=KTUtil.getCssVariableValue("--bs-primary-light"),l={series:[{name:"Net Profit",type:"bar",stacked:!0,data:[40,50,65,70,50,30]},{name:"Revenue",type:"bar",stacked:!0,data:[20,20,25,30,30,20]},{name:"Expenses",type:"area",data:[50,80,60,90,50,70]}],chart:{fontFamily:"inherit",stacked:!0,height:350,toolbar:{show:!1}},plotOptions:{bar:{stacked:!0,horizontal:!1,borderRadius:4,columnWidth:["12%"]}},legend:{show:!1},dataLabels:{enabled:!1},stroke:{curve:"smooth",show:!0,width:2,colors:["transparent"]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{style:{colors:a,fontSize:"12px"}}},yaxis:{max:120,labels:{style:{colors:a,fontSize:"12px"}}},fill:{opacity:1},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[r,KTUtil.getCssVariableValue("--bs-info"),s],grid:{borderColor:o,strokeDashArray:4,yaxis:{lines:{show:!0}},padding:{top:0,right:0,bottom:0,left:0}}};t.self=new ApexCharts(e,l),t.self.render(),t.rendered=!0};a(),KTThemeMode.on("kt.thememode.change",(function(){t.rendered&&t.self.destroy(),a()}))}}(),function(){var e=document.getElementById("kt_charts_widget_7_chart");if(e){var t={self:null,rendered:!1},a=function(){var a=parseInt(KTUtil.css(e,"height")),o=KTUtil.getCssVariableValue("--bs-gray-500"),r=KTUtil.getCssVariableValue("--bs-gray-200"),s=KTUtil.getCssVariableValue("--bs-gray-300"),l=KTUtil.getCssVariableValue("--bs-warning"),i=KTUtil.getCssVariableValue("--bs-warning-light"),n=KTUtil.getCssVariableValue("--bs-success"),d=KTUtil.getCssVariableValue("--bs-success-light"),c=KTUtil.getCssVariableValue("--bs-primary"),h={series:[{name:"Net Profit",data:[30,30,50,50,35,35]},{name:"Revenue",data:[55,20,20,20,70,70]},{name:"Expenses",data:[60,60,40,40,30,30]}],chart:{fontFamily:"inherit",type:"area",height:a,toolbar:{show:!1},zoom:{enabled:!1},sparkline:{enabled:!0}},plotOptions:{},legend:{show:!1},dataLabels:{enabled:!1},fill:{type:"solid",opacity:1},stroke:{curve:"smooth",show:!0,width:2,colors:[l,"transparent","transparent"]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{show:!1,style:{colors:o,fontSize:"12px"}},crosshairs:{show:!1,position:"front",stroke:{color:s,width:1,dashArray:3}},tooltip:{enabled:!0,formatter:void 0,offsetY:0,style:{fontSize:"12px"}}},yaxis:{labels:{show:!1,style:{colors:o,fontSize:"12px"}}},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[l,n,c],grid:{borderColor:r,strokeDashArray:4,yaxis:{lines:{show:!0}}},markers:{colors:[i,d,KTUtil.getCssVariableValue("--bs-primary-light")],strokeColor:[l,n,c],strokeWidth:3}};t.self=new ApexCharts(e,h),t.self.render(),t.rendered=!0};a(),KTThemeMode.on("kt.thememode.change",(function(){t.rendered&&t.self.destroy(),a()}))}}(),function(){var e=document.getElementById("kt_charts_widget_8_chart");if(e){var t={self:null,rendered:!1},a=function(){var a=parseInt(KTUtil.css(e,"height")),o=KTUtil.getCssVariableValue("--bs-gray-500"),r=KTUtil.getCssVariableValue("--bs-gray-200"),s=KTUtil.getCssVariableValue("--bs-gray-300"),l=KTUtil.getCssVariableValue("--bs-warning"),i=KTUtil.getCssVariableValue("--bs-warning-light"),n=KTUtil.getCssVariableValue("--bs-success"),d=KTUtil.getCssVariableValue("--bs-success-light"),c=KTUtil.getCssVariableValue("--bs-primary"),h={series:[{name:"Net Profit",data:[30,30,50,50,35,35]},{name:"Revenue",data:[55,20,20,20,70,70]},{name:"Expenses",data:[60,60,40,40,30,30]}],chart:{fontFamily:"inherit",type:"area",height:a,toolbar:{show:!1},zoom:{enabled:!1},sparkline:{enabled:!0}},plotOptions:{},legend:{show:!1},dataLabels:{enabled:!1},fill:{type:"solid",opacity:1},stroke:{curve:"smooth",show:!0,width:2,colors:[l,n,c]},xaxis:{x:0,offsetX:0,offsetY:0,padding:{left:0,right:0,top:0},categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{show:!1,style:{colors:o,fontSize:"12px"}},crosshairs:{show:!1,position:"front",stroke:{color:s,width:1,dashArray:3}},tooltip:{enabled:!0,formatter:void 0,offsetY:0,style:{fontSize:"12px"}}},yaxis:{y:0,offsetX:0,offsetY:0,padding:{left:0,right:0},labels:{show:!1,style:{colors:o,fontSize:"12px"}}},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[i,d,KTUtil.getCssVariableValue("--bs-primary-light")],grid:{borderColor:r,strokeDashArray:4,padding:{top:0,bottom:0,left:0,right:0}},markers:{colors:[l,n,c],strokeColor:[l,n,c],strokeWidth:3}};t.self=new ApexCharts(e,h),t.self.render(),t.rendered=!0};a(),KTThemeMode.on("kt.thememode.change",(function(){t.rendered&&t.self.destroy(),a()}))}}(),function(){var e,t,a,o=document.querySelectorAll(".mixed-widget-2-chart"),r=KTUtil.getCssVariableValue("--bs-gray-500"),s=KTUtil.getCssVariableValue("--bs-gray-200");[].slice.call(o).map((function(o){a=parseInt(KTUtil.css(o,"height")),e=KTUtil.getCssVariableValue("--bs-"+o.getAttribute("data-kt-color")),t=KTUtil.colorDarken(e,15),new ApexCharts(o,{series:[{name:"Net Profit",data:[30,45,32,70,40,40,40]}],chart:{fontFamily:"inherit",type:"area",height:a,toolbar:{show:!1},zoom:{enabled:!1},sparkline:{enabled:!0},dropShadow:{enabled:!0,enabledOnSeries:void 0,top:5,left:0,blur:3,color:t,opacity:.5}},plotOptions:{},legend:{show:!1},dataLabels:{enabled:!1},fill:{type:"solid",opacity:0},stroke:{curve:"smooth",show:!0,width:3,colors:[t]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul","Aug"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{show:!1,style:{colors:r,fontSize:"12px"}},crosshairs:{show:!1,position:"front",stroke:{color:s,width:1,dashArray:3}}},yaxis:{min:0,max:80,labels:{show:!1,style:{colors:r,fontSize:"12px"}}},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}},marker:{show:!1}},colors:["transparent"],markers:{colors:[e],strokeColor:[t],strokeWidth:3}}).render()}))}(),function(){var e=document.querySelectorAll(".mixed-widget-3-chart");[].slice.call(e).map((function(e){var t=parseInt(KTUtil.css(e,"height"));if(e){var a=e.getAttribute("data-kt-chart-color"),o=KTUtil.getCssVariableValue("--bs-gray-800"),r=KTUtil.getCssVariableValue("--bs-gray-300"),s=KTUtil.getCssVariableValue("--bs-"+a),l=KTUtil.getCssVariableValue("--bs-"+a+"-light");new ApexCharts(e,{series:[{name:"Net Profit",data:[30,25,45,30,55,55]}],chart:{fontFamily:"inherit",type:"area",height:t,toolbar:{show:!1},zoom:{enabled:!1},sparkline:{enabled:!0}},plotOptions:{},legend:{show:!1},dataLabels:{enabled:!1},fill:{type:"solid",opacity:1},stroke:{curve:"smooth",show:!0,width:3,colors:[s]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{show:!1,style:{colors:o,fontSize:"12px"}},crosshairs:{show:!1,position:"front",stroke:{color:r,width:1,dashArray:3}},tooltip:{enabled:!0,formatter:void 0,offsetY:0,style:{fontSize:"12px"}}},yaxis:{min:0,max:60,labels:{show:!1,style:{colors:o,fontSize:"12px"}}},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[l],markers:{colors:[l],strokeColor:[s],strokeWidth:3}}).render()}}))}(),function(){var e=document.querySelectorAll(".mixed-widget-4-chart");[].slice.call(e).map((function(e){var t=parseInt(KTUtil.css(e,"height"));if(e){var a=e.getAttribute("data-kt-chart-color"),o=KTUtil.getCssVariableValue("--bs-"+a),r=KTUtil.getCssVariableValue("--bs-"+a+"-light"),s=KTUtil.getCssVariableValue("--bs-gray-700");new ApexCharts(e,{series:[74],chart:{fontFamily:"inherit",height:t,type:"radialBar"},plotOptions:{radialBar:{hollow:{margin:0,size:"65%"},dataLabels:{showOn:"always",name:{show:!1,fontWeight:"700"},value:{color:s,fontSize:"30px",fontWeight:"700",offsetY:12,show:!0,formatter:function(e){return e+"%"}}},track:{background:r,strokeWidth:"100%"}}},colors:[o],stroke:{lineCap:"round"},labels:["Progress"]}).render()}}))}(),function(){var e=document.querySelectorAll(".mixed-widget-5-chart"),t=function(e,t){var a=parseInt(KTUtil.css(t,"height"));if(t){var o=t.getAttribute("data-kt-chart-color"),r=KTUtil.getCssVariableValue("--bs-gray-800"),s=KTUtil.getCssVariableValue("--bs-gray-300"),l=KTUtil.getCssVariableValue("--bs-"+o),i=KTUtil.getCssVariableValue("--bs-"+o+"-light"),n={series:[{name:"Net Profit",data:[30,30,60,25,25,40]}],chart:{fontFamily:"inherit",type:"area",height:a,toolbar:{show:!1},zoom:{enabled:!1},sparkline:{enabled:!0}},plotOptions:{},legend:{show:!1},dataLabels:{enabled:!1},fill:{type:"solid",opacity:1},fill1:{type:"gradient",opacity:1,gradient:{type:"vertical",shadeIntensity:.5,gradientToColors:void 0,inverseColors:!0,opacityFrom:1,opacityTo:.375,stops:[25,50,100],colorStops:[]}},stroke:{curve:"smooth",show:!0,width:3,colors:[l]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{show:!1,style:{colors:r,fontSize:"12px"}},crosshairs:{show:!1,position:"front",stroke:{color:s,width:1,dashArray:3}},tooltip:{enabled:!0,formatter:void 0,offsetY:0,style:{fontSize:"12px"}}},yaxis:{min:0,max:65,labels:{show:!1,style:{colors:r,fontSize:"12px"}}},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[i],markers:{colors:[i],strokeColor:[l],strokeWidth:3}};e.self=new ApexCharts(t,n),e.self.render(),e.rendered=!0}};[].slice.call(e).map((function(e){var a={self:null,rendered:!1};t(a,e),KTThemeMode.on("kt.thememode.change",(function(){a.rendered&&a.self.destroy(),t(a,e)}))}))}(),function(){var e=document.querySelectorAll(".mixed-widget-6-chart");[].slice.call(e).map((function(e){var t=parseInt(KTUtil.css(e,"height"));if(e){var a=e.getAttribute("data-kt-chart-color"),o=KTUtil.getCssVariableValue("--bs-gray-800"),r=KTUtil.getCssVariableValue("--bs-gray-300"),s=KTUtil.getCssVariableValue("--bs-"+a),l=KTUtil.getCssVariableValue("--bs-"+a+"-light");new ApexCharts(e,{series:[{name:"Net Profit",data:[30,25,45,30,55,55]}],chart:{fontFamily:"inherit",type:"area",height:t,toolbar:{show:!1},zoom:{enabled:!1},sparkline:{enabled:!0}},plotOptions:{},legend:{show:!1},dataLabels:{enabled:!1},fill:{type:"solid",opacity:1},stroke:{curve:"smooth",show:!0,width:3,colors:[s]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{show:!1,style:{colors:o,fontSize:"12px"}},crosshairs:{show:!1,position:"front",stroke:{color:r,width:1,dashArray:3}},tooltip:{enabled:!0,formatter:void 0,offsetY:0,style:{fontSize:"12px"}}},yaxis:{min:0,max:60,labels:{show:!1,style:{colors:o,fontSize:"12px"}}},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[l],markers:{colors:[l],strokeColor:[s],strokeWidth:3}}).render()}}))}(),function(){var e=document.querySelectorAll(".mixed-widget-7-chart");[].slice.call(e).map((function(e){var t=parseInt(KTUtil.css(e,"height"));if(e){var a=e.getAttribute("data-kt-chart-color"),o=KTUtil.getCssVariableValue("--bs-gray-800"),r=KTUtil.getCssVariableValue("--bs-gray-300"),s=KTUtil.getCssVariableValue("--bs-"+a),l=KTUtil.getCssVariableValue("--bs-"+a+"-light");new ApexCharts(e,{series:[{name:"Net Profit",data:[15,25,15,40,20,50]}],chart:{fontFamily:"inherit",type:"area",height:t,toolbar:{show:!1},zoom:{enabled:!1},sparkline:{enabled:!0}},plotOptions:{},legend:{show:!1},dataLabels:{enabled:!1},fill:{type:"solid",opacity:1},stroke:{curve:"smooth",show:!0,width:3,colors:[s]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{show:!1,style:{colors:o,fontSize:"12px"}},crosshairs:{show:!1,position:"front",stroke:{color:r,width:1,dashArray:3}},tooltip:{enabled:!0,formatter:void 0,offsetY:0,style:{fontSize:"12px"}}},yaxis:{min:0,max:60,labels:{show:!1,style:{colors:o,fontSize:"12px"}}},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[l],markers:{colors:[l],strokeColor:[s],strokeWidth:3}}).render()}}))}(),function(){var e,t,a,o=document.querySelectorAll(".mixed-widget-10-chart"),r=KTUtil.getCssVariableValue("--bs-gray-500"),s=KTUtil.getCssVariableValue("--bs-gray-200"),l=KTUtil.getCssVariableValue("--bs-gray-300");[].slice.call(o).map((function(o){e=o.getAttribute("data-kt-color"),t=parseInt(KTUtil.css(o,"height")),a=KTUtil.getCssVariableValue("--bs-"+e),new ApexCharts(o,{series:[{name:"Net Profit",data:[50,60,70,80,60,50,70,60]},{name:"Revenue",data:[50,60,70,80,60,50,70,60]}],chart:{fontFamily:"inherit",type:"bar",height:t,toolbar:{show:!1}},plotOptions:{bar:{horizontal:!1,columnWidth:["50%"],borderRadius:4}},legend:{show:!1},dataLabels:{enabled:!1},stroke:{show:!0,width:2,colors:["transparent"]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul","Aug","Sep"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{style:{colors:r,fontSize:"12px"}}},yaxis:{y:0,offsetX:0,offsetY:0,labels:{style:{colors:r,fontSize:"12px"}}},fill:{type:"solid"},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" revenue"}}},colors:[a,l],grid:{padding:{top:10},borderColor:s,strokeDashArray:4,yaxis:{lines:{show:!0}}}}).render()}))}(),function(){var e,t=document.querySelectorAll(".mixed-widget-12-chart"),a=KTUtil.getCssVariableValue("--bs-gray-500"),o=KTUtil.getCssVariableValue("--bs-gray-200");[].slice.call(t).map((function(t){e=parseInt(KTUtil.css(t,"height")),new ApexCharts(t,{series:[{name:"Net Profit",data:[35,65,75,55,45,60,55]},{name:"Revenue",data:[40,70,80,60,50,65,60]}],chart:{fontFamily:"inherit",type:"bar",height:e,toolbar:{show:!1},sparkline:{enabled:!0}},plotOptions:{bar:{horizontal:!1,columnWidth:["30%"],borderRadius:2}},legend:{show:!1},dataLabels:{enabled:!1},stroke:{show:!0,width:1,colors:["transparent"]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{style:{colors:a,fontSize:"12px"}}},yaxis:{min:0,max:100,labels:{style:{colors:a,fontSize:"12px"}}},fill:{type:["solid","solid"],opacity:[.25,1]},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}},marker:{show:!1}},colors:["#ffffff","#ffffff"],grid:{borderColor:o,strokeDashArray:4,yaxis:{lines:{show:!0}},padding:{left:20,right:20}}}).render()}))}(),function(){var e,t=document.querySelectorAll(".mixed-widget-13-chart");[].slice.call(t).map((function(t){if(e=parseInt(KTUtil.css(t,"height")),t){var a=KTUtil.getCssVariableValue("--bs-gray-800"),o=KTUtil.getCssVariableValue("--bs-gray-300");new ApexCharts(t,{series:[{name:"Net Profit",data:[15,25,15,40,20,50]}],grid:{show:!1,padding:{top:0,bottom:0,left:0,right:0}},chart:{fontFamily:"inherit",type:"area",height:e,toolbar:{show:!1},zoom:{enabled:!1},sparkline:{enabled:!0}},plotOptions:{},legend:{show:!1},dataLabels:{enabled:!1},fill:{type:"gradient",gradient:{opacityFrom:.4,opacityTo:0,stops:[20,120,120,120]}},stroke:{curve:"smooth",show:!0,width:3,colors:["#FFFFFF"]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{show:!1,style:{colors:a,fontSize:"12px"}},crosshairs:{show:!1,position:"front",stroke:{color:o,width:1,dashArray:3}},tooltip:{enabled:!0,formatter:void 0,offsetY:0,style:{fontSize:"12px"}}},yaxis:{min:0,max:60,labels:{show:!1,style:{colors:a,fontSize:"12px"}}},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:["#ffffff"],markers:{colors:[a],strokeColor:[o],strokeWidth:3}}).render()}}))}(),function(){var e,t=document.querySelectorAll(".mixed-widget-14-chart");[].slice.call(t).map((function(t){e=parseInt(KTUtil.css(t,"height"));var a=KTUtil.getCssVariableValue("--bs-gray-800");new ApexCharts(t,{series:[{name:"Inflation",data:[1,2.1,1,2.1,4.1,6.1,4.1,4.1,2.1,4.1,2.1,3.1,1,1,2.1]}],chart:{fontFamily:"inherit",height:e,type:"bar",toolbar:{show:!1}},grid:{show:!1,padding:{top:0,bottom:0,left:0,right:0}},colors:["#ffffff"],plotOptions:{bar:{borderRadius:2.5,dataLabels:{position:"top"},columnWidth:"20%"}},dataLabels:{enabled:!1,formatter:function(e){return e+"%"},offsetY:-20,style:{fontSize:"12px",colors:["#304758"]}},xaxis:{labels:{show:!1},categories:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec","Jan","Feb","Mar"],position:"top",axisBorder:{show:!1},axisTicks:{show:!1},crosshairs:{show:!1},tooltip:{enabled:!1}},yaxis:{show:!1,axisBorder:{show:!1},axisTicks:{show:!1,background:a},labels:{show:!1,formatter:function(e){return e+"%"}}}}).render()}))}(),function(){var e=document.getElementById("kt_charts_mixed_widget_16_chart"),t=parseInt(KTUtil.css(e,"height"));if(e){var a={labels:["Total Members"],series:[74],chart:{fontFamily:"inherit",height:t,type:"radialBar",offsetY:0},plotOptions:{radialBar:{startAngle:-90,endAngle:90,hollow:{margin:0,size:"70%"},dataLabels:{showOn:"always",name:{show:!0,fontSize:"13px",fontWeight:"700",offsetY:-5,color:KTUtil.getCssVariableValue("--bs-gray-500")},value:{color:KTUtil.getCssVariableValue("--bs-gray-700"),fontSize:"30px",fontWeight:"700",offsetY:-40,show:!0}},track:{background:KTUtil.getCssVariableValue("--bs-primary-light"),strokeWidth:"100%"}}},colors:[KTUtil.getCssVariableValue("--bs-primary")],stroke:{lineCap:"round"}};new ApexCharts(e,a).render()}}(),function(){var e=document.querySelectorAll(".mixed-widget-17-chart");[].slice.call(e).map((function(e){var t=parseInt(KTUtil.css(e,"height"));if(e){var a=e.getAttribute("data-kt-chart-color"),o={labels:["Total Orders"],series:[75],chart:{fontFamily:"inherit",height:t,type:"radialBar",offsetY:0},plotOptions:{radialBar:{startAngle:-90,endAngle:90,hollow:{margin:0,size:"55%"},dataLabels:{showOn:"always",name:{show:!0,fontSize:"12px",fontWeight:"700",offsetY:-5,color:KTUtil.getCssVariableValue("--bs-gray-500")},value:{color:KTUtil.getCssVariableValue("--bs-gray-900"),fontSize:"24px",fontWeight:"600",offsetY:-40,show:!0,formatter:function(e){return"8,346"}}},track:{background:KTUtil.getCssVariableValue("--bs-gray-300"),strokeWidth:"100%"}}},colors:[KTUtil.getCssVariableValue("--bs-"+a)],stroke:{lineCap:"round"}};new ApexCharts(e,o).render()}}))}(),function(){var e=document.getElementById("kt_charts_mixed_widget_18_chart"),t=parseInt(KTUtil.css(e,"height"));if(e){var a=KTUtil.getCssVariableValue("--bs-gray-800"),o=KTUtil.getCssVariableValue("--bs-gray-800"),r="dark"===KTThemeMode.getMode()?KTUtil.getCssVariableValue("--bs-gray-200"):"#D6D6E0";new ApexCharts(e,{series:[{name:"Net Profit",data:[30,25,45,30,55,55]}],chart:{fontFamily:"inherit",type:"area",height:t,toolbar:{show:!1},zoom:{enabled:!1},sparkline:{enabled:!0}},plotOptions:{},legend:{show:!1},dataLabels:{enabled:!1},fill:{type:"solid",opacity:1},stroke:{curve:"smooth",show:!0,width:3,colors:[o]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{show:!1,style:{colors:a,fontSize:"12px"}},crosshairs:{show:!1,position:"front",stroke:{color:o,width:1,dashArray:3}},tooltip:{enabled:!0,formatter:void 0,offsetY:0,style:{fontSize:"12px"}}},yaxis:{min:0,max:60,labels:{show:!1,style:{colors:a,fontSize:"12px"}}},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[r],markers:{colors:[r],strokeColor:[o],strokeWidth:3}}).render()}}(),function(){var e={self:null,rendered:!1};function t(){var t=document.getElementById("kt_charts_mixed_widget_19_chart"),a=parseInt(KTUtil.css(t,"height"));if(t){var o=KTUtil.getCssVariableValue("--bs-gray-800"),r=KTUtil.getCssVariableValue("--bs-info"),s=KTUtil.getCssVariableValue("--bs-info-light"),l={series:[{name:"Net Profit",data:[30,25,45,30,55,55]}],chart:{fontFamily:"inherit",type:"area",height:a,toolbar:{show:!1},zoom:{enabled:!1},sparkline:{enabled:!0}},plotOptions:{},legend:{show:!1},dataLabels:{enabled:!1},fill:{type:"solid",opacity:1},stroke:{curve:"smooth",show:!0,width:3,colors:[r]},xaxis:{categories:["Feb","Mar","Apr","May","Jun","Jul"],axisBorder:{show:!1},axisTicks:{show:!1},labels:{show:!1,style:{colors:o,fontSize:"12px"}},crosshairs:{show:!1,position:"front",stroke:{color:r,width:1,dashArray:3}},tooltip:{enabled:!0,formatter:void 0,offsetY:0,style:{fontSize:"12px"}}},yaxis:{min:0,max:60,labels:{show:!1,style:{colors:o,fontSize:"12px"}}},states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"none",value:0}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"none",value:0}}},tooltip:{style:{fontSize:"12px"},y:{formatter:function(e){return"$"+e+" thousands"}}},colors:[s],markers:{colors:[s],strokeColor:[r],strokeWidth:3}};e.self=new ApexCharts(t,l),setTimeout((function(){e.self.render(),e.rendered=!0}),200)}}t(),KTThemeMode.on("kt.thememode.change",(function(){e.rendered&&e.self.destroy(),t()}))}(),(a=document.querySelector("#kt_forms_widget_1_form"))&&a&&new Quill("#kt_forms_widget_1_editor",{modules:{toolbar:{container:"#kt_forms_widget_1_editor_toolbar"}},placeholder:"What is on your mind ?",theme:"snow"}),o=document.querySelector("#kt_widget_5_load_more_btn"),r=document.querySelector("#kt_widget_5"),o&&o.addEventListener("click",(function(e){e.preventDefault(),o.setAttribute("data-kt-indicator","on"),setTimeout((function(){o.removeAttribute("data-kt-indicator"),r.classList.remove("d-none"),o.classList.add("d-none"),KTUtil.scrollTo(r,200)}),2e3)})),function(){if("undefined"!=typeof FullCalendar&&document.querySelector("#kt_calendar_widget_1")){var e=moment().startOf("day"),t=e.format("YYYY-MM"),a=e.clone().subtract(1,"day").format("YYYY-MM-DD"),o=e.format("YYYY-MM-DD"),r=e.clone().add(1,"day").format("YYYY-MM-DD"),s=document.getElementById("kt_calendar_widget_1");new FullCalendar.Calendar(s,{headerToolbar:{left:"prev,next today",center:"title",right:"dayGridMonth,timeGridWeek,timeGridDay,listMonth"},height:800,contentHeight:780,aspectRatio:3,nowIndicator:!0,now:o+"T09:25:00",views:{dayGridMonth:{buttonText:"month"},timeGridWeek:{buttonText:"week"},timeGridDay:{buttonText:"day"}},initialView:"dayGridMonth",initialDate:o,editable:!0,dayMaxEvents:!0,navLinks:!0,events:[{title:"All Day Event",start:t+"-01",description:"Toto lorem ipsum dolor sit incid idunt ut",className:"fc-event-danger fc-event-solid-warning"},{title:"Reporting",start:t+"-14T13:30:00",description:"Lorem ipsum dolor incid idunt ut labore",end:t+"-14",className:"fc-event-success"},{title:"Company Trip",start:t+"-02",description:"Lorem ipsum dolor sit tempor incid",end:t+"-03",className:"fc-event-primary"},{title:"ICT Expo 2017 - Product Release",start:t+"-03",description:"Lorem ipsum dolor sit tempor inci",end:t+"-05",className:"fc-event-light fc-event-solid-primary"},{title:"Dinner",start:t+"-12",description:"Lorem ipsum dolor sit amet, conse ctetur",end:t+"-10"},{id:999,title:"Repeating Event",start:t+"-09T16:00:00",description:"Lorem ipsum dolor sit ncididunt ut labore",className:"fc-event-danger"},{id:1e3,title:"Repeating Event",description:"Lorem ipsum dolor sit amet, labore",start:t+"-16T16:00:00"},{title:"Conference",start:a,end:r,description:"Lorem ipsum dolor eius mod tempor labore",className:"fc-event-primary"},{title:"Meeting",start:o+"T10:30:00",end:o+"T12:30:00",description:"Lorem ipsum dolor eiu idunt ut labore"},{title:"Lunch",start:o+"T12:00:00",className:"fc-event-info",description:"Lorem ipsum dolor sit amet, ut labore"},{title:"Meeting",start:o+"T14:30:00",className:"fc-event-warning",description:"Lorem ipsum conse ctetur adipi scing"},{title:"Happy Hour",start:o+"T17:30:00",className:"fc-event-info",description:"Lorem ipsum dolor sit amet, conse ctetur"},{title:"Dinner",start:r+"T05:00:00",className:"fc-event-solid-danger fc-event-light",description:"Lorem ipsum dolor sit ctetur adipi scing"},{title:"Birthday Party",start:r+"T07:00:00",className:"fc-event-primary",description:"Lorem ipsum dolor sit amet, scing"},{title:"Click for Google",url:"http://google.com/",start:t+"-28",className:"fc-event-solid-info fc-event-light",description:"Lorem ipsum dolor sit amet, labore"}]}).render()}}()}};"undefined"!=typeof module&&void 0!==module.exports&&(module.exports=KTWidgets),KTUtil.onDOMContentLoaded((function(){KTWidgets.init()}));
"use strict";var KTAppChat=function(){var e=function(e){var t=e.querySelector('[data-kt-element="messages"]'),n=e.querySelector('[data-kt-element="input"]');if(0!==n.value.length){var o,a=t.querySelector('[data-kt-element="template-out"]'),l=t.querySelector('[data-kt-element="template-in"]');(o=a.cloneNode(!0)).classList.remove("d-none"),o.querySelector('[data-kt-element="message-text"]').innerText=n.value,n.value="",t.appendChild(o),t.scrollTop=t.scrollHeight,setTimeout((function(){(o=l.cloneNode(!0)).classList.remove("d-none"),o.querySelector('[data-kt-element="message-text"]').innerText="Thank you for your awesome support!",t.appendChild(o),t.scrollTop=t.scrollHeight}),2e3)}};return{init:function(t){!function(t){t&&(KTUtil.on(t,'[data-kt-element="input"]',"keydown",(function(n){if(13==n.keyCode)return e(t),n.preventDefault(),!1})),KTUtil.on(t,'[data-kt-element="send"]',"click",(function(n){e(t)})))}(t)}}}();KTUtil.onDOMContentLoaded((function(){KTAppChat.init(document.querySelector("#kt_chat_messenger")),KTAppChat.init(document.querySelector("#kt_drawer_chat_messenger"))}));
"use strict";var KTModalUpgradePlan=function(){var t,n,e,a,i=function(n){[].slice.call(t.querySelectorAll("[data-kt-plan-price-month]")).map((function(t){var e=t.getAttribute("data-kt-plan-price-month"),a=t.getAttribute("data-kt-plan-price-annual");"month"===n?t.innerHTML=e:"annual"===n&&(t.innerHTML=a)}))};return{init:function(){(t=document.querySelector("#kt_modal_upgrade_plan"))&&(n=t.querySelector('[data-kt-plan="month"]'),e=t.querySelector('[data-kt-plan="annual"]'),a=document.querySelector("#kt_modal_upgrade_plan_btn"),n.addEventListener("click",(function(t){t.preventDefault(),n.classList.add("active"),e.classList.remove("active"),i("month")})),e.addEventListener("click",(function(t){t.preventDefault(),n.classList.remove("active"),e.classList.add("active"),i("annual")})),a&&a.addEventListener("click",(function(n){n.preventDefault();var e=this;swal.fire({text:"Are you sure you would like to upgrade to selected plan ?",icon:"warning",buttonsStyling:!1,showDenyButton:!0,confirmButtonText:"Yes",denyButtonText:"No",customClass:{confirmButton:"btn btn-primary",denyButton:"btn btn-light-danger"}}).then((n=>{n.isConfirmed&&(e.setAttribute("data-kt-indicator","on"),e.disabled=!0,setTimeout((function(){Swal.fire({text:"Your subscription plan has been successfully upgraded",icon:"success",confirmButtonText:"Ok",buttonsStyling:!1,customClass:{confirmButton:"btn btn-light-primary"}}).then((n=>{bootstrap.Modal.getInstance(t).hide()}))}),2e3))}))})),i())}}}();KTUtil.onDOMContentLoaded((function(){KTModalUpgradePlan.init()}));
"use strict";var KTCreateApp=function(){var e,t,o,r,a,i,n=[];return{init:function(){(e=document.querySelector("#kt_modal_create_app"))&&(new bootstrap.Modal(e),t=document.querySelector("#kt_modal_create_app_stepper"),o=document.querySelector("#kt_modal_create_app_form"),r=t.querySelector('[data-kt-stepper-action="submit"]'),a=t.querySelector('[data-kt-stepper-action="next"]'),(i=new KTStepper(t)).on("kt.stepper.changed",(function(e){4===i.getCurrentStepIndex()?(r.classList.remove("d-none"),r.classList.add("d-inline-block"),a.classList.add("d-none")):5===i.getCurrentStepIndex()?(r.classList.add("d-none"),a.classList.add("d-none")):(r.classList.remove("d-inline-block"),r.classList.remove("d-none"),a.classList.remove("d-none"))})),i.on("kt.stepper.next",(function(e){console.log("stepper.next");var t=n[e.getCurrentStepIndex()-1];t?t.validate().then((function(t){console.log("validated!"),"Valid"==t?e.goNext():Swal.fire({text:"Sorry, looks like there are some errors detected, please try again.",icon:"error",buttonsStyling:!1,confirmButtonText:"Ok, got it!",customClass:{confirmButton:"btn btn-light"}}).then((function(){}))})):(e.goNext(),KTUtil.scrollTop())})),i.on("kt.stepper.previous",(function(e){console.log("stepper.previous"),e.goPrevious(),KTUtil.scrollTop()})),r.addEventListener("click",(function(e){n[3].validate().then((function(t){console.log("validated!"),"Valid"==t?(e.preventDefault(),r.disabled=!0,r.setAttribute("data-kt-indicator","on"),setTimeout((function(){r.removeAttribute("data-kt-indicator"),r.disabled=!1,i.goNext()}),2e3)):Swal.fire({text:"Sorry, looks like there are some errors detected, please try again.",icon:"error",buttonsStyling:!1,confirmButtonText:"Ok, got it!",customClass:{confirmButton:"btn btn-light"}}).then((function(){KTUtil.scrollTop()}))}))})),$(o.querySelector('[name="card_expiry_month"]')).on("change",(function(){n[3].revalidateField("card_expiry_month")})),$(o.querySelector('[name="card_expiry_year"]')).on("change",(function(){n[3].revalidateField("card_expiry_year")})),n.push(FormValidation.formValidation(o,{fields:{name:{validators:{notEmpty:{message:"App name is required"}}},category:{validators:{notEmpty:{message:"Category is required"}}}},plugins:{trigger:new FormValidation.plugins.Trigger,bootstrap:new FormValidation.plugins.Bootstrap5({rowSelector:".fv-row",eleInvalidClass:"",eleValidClass:""})}})),n.push(FormValidation.formValidation(o,{fields:{framework:{validators:{notEmpty:{message:"Framework is required"}}}},plugins:{trigger:new FormValidation.plugins.Trigger,bootstrap:new FormValidation.plugins.Bootstrap5({rowSelector:".fv-row",eleInvalidClass:"",eleValidClass:""})}})),n.push(FormValidation.formValidation(o,{fields:{dbname:{validators:{notEmpty:{message:"Database name is required"}}},dbengine:{validators:{notEmpty:{message:"Database engine is required"}}}},plugins:{trigger:new FormValidation.plugins.Trigger,bootstrap:new FormValidation.plugins.Bootstrap5({rowSelector:".fv-row",eleInvalidClass:"",eleValidClass:""})}})),n.push(FormValidation.formValidation(o,{fields:{card_name:{validators:{notEmpty:{message:"Name on card is required"}}},card_number:{validators:{notEmpty:{message:"Card member is required"},creditCard:{message:"Card number is not valid"}}},card_expiry_month:{validators:{notEmpty:{message:"Month is required"}}},card_expiry_year:{validators:{notEmpty:{message:"Year is required"}}},card_cvv:{validators:{notEmpty:{message:"CVV is required"},digits:{message:"CVV must contain only digits"},stringLength:{min:3,max:4,message:"CVV must contain 3 to 4 digits only"}}}},plugins:{trigger:new FormValidation.plugins.Trigger,bootstrap:new FormValidation.plugins.Bootstrap5({rowSelector:".fv-row",eleInvalidClass:"",eleValidClass:""})}})))}}}();KTUtil.onDOMContentLoaded((function(){KTCreateApp.init()}));
"use strict";var KTModalNewTarget=function(){var t,e,n,a,o,i;return{init:function(){(i=document.querySelector("#kt_modal_new_target"))&&(o=new bootstrap.Modal(i),a=document.querySelector("#kt_modal_new_target_form"),t=document.getElementById("kt_modal_new_target_submit"),e=document.getElementById("kt_modal_new_target_cancel"),new Tagify(a.querySelector('[name="tags"]'),{whitelist:["Important","Urgent","High","Medium","Low"],maxTags:5,dropdown:{maxItems:10,enabled:0,closeOnSelect:!1}}).on("change",(function(){n.revalidateField("tags")})),$(a.querySelector('[name="due_date"]')).flatpickr({enableTime:!0,dateFormat:"d, M Y, H:i"}),$(a.querySelector('[name="team_assign"]')).on("change",(function(){n.revalidateField("team_assign")})),n=FormValidation.formValidation(a,{fields:{target_title:{validators:{notEmpty:{message:"Target title is required"}}},target_assign:{validators:{notEmpty:{message:"Target assign is required"}}},target_due_date:{validators:{notEmpty:{message:"Target due date is required"}}},target_tags:{validators:{notEmpty:{message:"Target tags are required"}}},"targets_notifications[]":{validators:{notEmpty:{message:"Please select at least one communication method"}}}},plugins:{trigger:new FormValidation.plugins.Trigger,bootstrap:new FormValidation.plugins.Bootstrap5({rowSelector:".fv-row",eleInvalidClass:"",eleValidClass:""})}}),t.addEventListener("click",(function(e){e.preventDefault(),n&&n.validate().then((function(e){console.log("validated!"),"Valid"==e?(t.setAttribute("data-kt-indicator","on"),t.disabled=!0,setTimeout((function(){t.removeAttribute("data-kt-indicator"),t.disabled=!1,Swal.fire({text:"Form has been successfully submitted!",icon:"success",buttonsStyling:!1,confirmButtonText:"Ok, got it!",customClass:{confirmButton:"btn btn-primary"}}).then((function(t){t.isConfirmed&&o.hide()}))}),2e3)):Swal.fire({text:"Sorry, looks like there are some errors detected, please try again.",icon:"error",buttonsStyling:!1,confirmButtonText:"Ok, got it!",customClass:{confirmButton:"btn btn-primary"}})}))})),e.addEventListener("click",(function(t){t.preventDefault(),Swal.fire({text:"Are you sure you would like to cancel?",icon:"warning",showCancelButton:!0,buttonsStyling:!1,confirmButtonText:"Yes, cancel it!",cancelButtonText:"No, return",customClass:{confirmButton:"btn btn-primary",cancelButton:"btn btn-active-light"}}).then((function(t){t.value?(a.reset(),o.hide()):"cancel"===t.dismiss&&Swal.fire({text:"Your form has not been cancelled!.",icon:"error",buttonsStyling:!1,confirmButtonText:"Ok, got it!",customClass:{confirmButton:"btn btn-primary"}})}))})))}}}();KTUtil.onDOMContentLoaded((function(){KTModalNewTarget.init()}));
"use strict";var KTModalUserSearch=function(){var e,t,n,s,a,r=function(e){setTimeout((function(){var a=KTUtil.getRandomInt(1,3);t.classList.add("d-none"),3===a?(n.classList.add("d-none"),s.classList.remove("d-none")):(n.classList.remove("d-none"),s.classList.add("d-none")),e.complete()}),1500)},o=function(e){t.classList.remove("d-none"),n.classList.add("d-none"),s.classList.add("d-none")};return{init:function(){(e=document.querySelector("#kt_modal_users_search_handler"))&&(e.querySelector('[data-kt-search-element="wrapper"]'),t=e.querySelector('[data-kt-search-element="suggestions"]'),n=e.querySelector('[data-kt-search-element="results"]'),s=e.querySelector('[data-kt-search-element="empty"]'),(a=new KTSearch(e)).on("kt.search.process",r),a.on("kt.search.clear",o))}}}();KTUtil.onDOMContentLoaded((function(){KTModalUserSearch.init()}));
import {
	Controls,
	MOUSE,
	Quaternion,
	Spherical,
	TOUCH,
	Vector2,
	Vector3,
	Plane,
	Ray,
	MathUtils
} from 'three';

/**
 * Fires when the camera has been transformed by the controls.
 *
 * @event OrbitControls#change
 * @type {Object}
 */
const _changeEvent = { type: 'change' };

/**
 * Fires when an interaction was initiated.
 *
 * @event OrbitControls#start
 * @type {Object}
 */
const _startEvent = { type: 'start' };

/**
 * Fires when an interaction has finished.
 *
 * @event OrbitControls#end
 * @type {Object}
 */
const _endEvent = { type: 'end' };

const _ray = new Ray();
const _plane = new Plane();
const _TILT_LIMIT = Math.cos( 70 * MathUtils.DEG2RAD );

const _v = new Vector3();
const _twoPI = 2 * Math.PI;

const _STATE = {
	NONE: - 1,
	ROTATE: 0,
	DOLLY: 1,
	PAN: 2,
	TOUCH_ROTATE: 3,
	TOUCH_PAN: 4,
	TOUCH_DOLLY_PAN: 5,
	TOUCH_DOLLY_ROTATE: 6
};
const _EPS = 0.000001;


/**
 * Orbit controls allow the camera to orbit around a target.
 *
 * OrbitControls performs orbiting, dollying (zooming), and panning. Unlike {@link TrackballControls},
 * it maintains the "up" direction `object.up` (+Y by default).
 *
 * - Orbit: Left mouse / touch: one-finger move.
 * - Zoom: Middle mouse, or mousewheel / touch: two-finger spread or squish.
 * - Pan: Right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move.
 *
 * ```js
 * const controls = new OrbitControls( camera, renderer.domElement );
 *
 * // controls.update() must be called after any manual changes to the camera's transform
 * camera.position.set( 0, 20, 100 );
 * controls.update();
 *
 * function animate() {
 *
 * 	// required if controls.enableDamping or controls.autoRotate are set to true
 * 	controls.update();
 *
 * 	renderer.render( scene, camera );
 *
 * }
 * ```
 *
 * @augments Controls
 * @three_import import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
 */
class OrbitControls extends Controls {

	/**
	 * Constructs a new controls instance.
	 *
	 * @param {Object3D} object - The object that is managed by the controls.
	 * @param {?HTMLElement} domElement - The HTML element used for event listeners.
	 */
	constructor( object, domElement = null ) {

		super( object, domElement );

		this.state = _STATE.NONE;

		/**
		 * The focus point of the controls, the `object` orbits around this.
		 * It can be updated manually at any point to change the focus of the controls.
		 *
		 * @type {Vector3}
		 */
		this.target = new Vector3();

		/**
		 * The focus point of the `minTargetRadius` and `maxTargetRadius` limits.
		 * It can be updated manually at any point to change the center of interest
		 * for the `target`.
		 *
		 * @type {Vector3}
		 */
		this.cursor = new Vector3();

		/**
		 * How far you can dolly in (perspective camera only).
		 *
		 * @type {number}
		 * @default 0
		 */
		this.minDistance = 0;

		/**
		 * How far you can dolly out (perspective camera only).
		 *
		 * @type {number}
		 * @default Infinity
		 */
		this.maxDistance = Infinity;

		/**
		 * How far you can zoom in (orthographic camera only).
		 *
		 * @type {number}
		 * @default 0
		 */
		this.minZoom = 0;

		/**
		 * How far you can zoom out (orthographic camera only).
		 *
		 * @type {number}
		 * @default Infinity
		 */
		this.maxZoom = Infinity;

		/**
		 * How close you can get the target to the 3D `cursor`.
		 *
		 * @type {number}
		 * @default 0
		 */
		this.minTargetRadius = 0;

		/**
		 * How far you can move the target from the 3D `cursor`.
		 *
		 * @type {number}
		 * @default Infinity
		 */
		this.maxTargetRadius = Infinity;

		/**
		 * How far you can orbit vertically, lower limit. Range is `[0, Math.PI]` radians.
		 *
		 * @type {number}
		 * @default 0
		 */
		this.minPolarAngle = 0;

		/**
		 * How far you can orbit vertically, upper limit. Range is `[0, Math.PI]` radians.
		 *
		 * @type {number}
		 * @default Math.PI
		 */
		this.maxPolarAngle = Math.PI;

		/**
		 * How far you can orbit horizontally, lower limit. If set, the interval `[ min, max ]`
		 * must be a sub-interval of `[ - 2 PI, 2 PI ]`, with `( max - min < 2 PI )`.
		 *
		 * @type {number}
		 * @default -Infinity
		 */
		this.minAzimuthAngle = - Infinity;

		/**
		 * How far you can orbit horizontally, upper limit. If set, the interval `[ min, max ]`
		 * must be a sub-interval of `[ - 2 PI, 2 PI ]`, with `( max - min < 2 PI )`.
		 *
		 * @type {number}
		 * @default -Infinity
		 */
		this.maxAzimuthAngle = Infinity;

		/**
		 * Set to `true` to enable damping (inertia), which can be used to give a sense of weight
		 * to the controls. Note that if this is enabled, you must call `update()` in your animation
		 * loop.
		 *
		 * @type {boolean}
		 * @default false
		 */
		this.enableDamping = false;

		/**
		 * The damping inertia used if `enableDamping` is set to `true`.
		 *
		 * Note that for this to work, you must call `update()` in your animation loop.
		 *
		 * @type {number}
		 * @default 0.05
		 */
		this.dampingFactor = 0.05;

		/**
		 * Enable or disable zooming (dollying) of the camera.
		 *
		 * @type {boolean}
		 * @default true
		 */
		this.enableZoom = true;

		/**
		 * Speed of zooming / dollying.
		 *
		 * @type {number}
		 * @default 1
		 */
		this.zoomSpeed = 1.0;

		/**
		 * Enable or disable horizontal and vertical rotation of the camera.
		 *
		 * Note that it is possible to disable a single axis by setting the min and max of the
		 * `minPolarAngle` or `minAzimuthAngle` to the same value, which will cause the vertical
		 * or horizontal rotation to be fixed at that value.
		 *
		 * @type {boolean}
		 * @default true
		 */
		this.enableRotate = true;

		/**
		 * Speed of rotation.
		 *
		 * @type {number}
		 * @default 1
		 */
		this.rotateSpeed = 1.0;

		/**
		 * How fast to rotate the camera when the keyboard is used.
		 *
		 * @type {number}
		 * @default 1
		 */
		this.keyRotateSpeed = 1.0;

		/**
		 * Enable or disable camera panning.
		 *
		 * @type {boolean}
		 * @default true
		 */
		this.enablePan = true;

		/**
		 * Speed of panning.
		 *
		 * @type {number}
		 * @default 1
		 */
		this.panSpeed = 1.0;

		/**
		 * Defines how the camera's position is translated when panning. If `true`, the camera pans
		 * in screen space. Otherwise, the camera pans in the plane orthogonal to the camera's up
		 * direction.
		 *
		 * @type {boolean}
		 * @default true
		 */
		this.screenSpacePanning = true;

		/**
		 * How fast to pan the camera when the keyboard is used in
		 * pixels per keypress.
		 *
		 * @type {number}
		 * @default 7
		 */
		this.keyPanSpeed = 7.0;

		/**
		 * Setting this property to `true` allows to zoom to the cursor's position.
		 *
		 * @type {boolean}
		 * @default false
		 */
		this.zoomToCursor = false;

		/**
		 * Set to true to automatically rotate around the target
		 *
		 * Note that if this is enabled, you must call `update()` in your animation loop.
		 * If you want the auto-rotate speed to be independent of the frame rate (the refresh
		 * rate of the display), you must pass the time `deltaTime`, in seconds, to `update()`.
		 *
		 * @type {boolean}
		 * @default false
		 */
		this.autoRotate = false;

		/**
		 * How fast to rotate around the target if `autoRotate` is `true`. The default  equates to 30 seconds
		 * per orbit at 60fps.
		 *
		 * Note that if `autoRotate` is enabled, you must call `update()` in your animation loop.
		 *
		 * @type {number}
		 * @default 2
		 */
		this.autoRotateSpeed = 2.0;

		/**
		 * This object contains references to the keycodes for controlling camera panning.
		 *
		 * ```js
		 * controls.keys = {
		 * 	LEFT: 'ArrowLeft', //left arrow
		 * 	UP: 'ArrowUp', // up arrow
		 * 	RIGHT: 'ArrowRight', // right arrow
		 * 	BOTTOM: 'ArrowDown' // down arrow
		 * }
		 * ```
		 * @type {Object}
		 */
		this.keys = { LEFT: 'ArrowLeft', UP: 'ArrowUp', RIGHT: 'ArrowRight', BOTTOM: 'ArrowDown' };

		/**
		 * This object contains references to the mouse actions used by the controls.
		 *
		 * ```js
		 * controls.mouseButtons = {
		 * 	LEFT: THREE.MOUSE.ROTATE,
		 * 	MIDDLE: THREE.MOUSE.DOLLY,
		 * 	RIGHT: THREE.MOUSE.PAN
		 * }
		 * ```
		 * @type {Object}
		 */
		this.mouseButtons = { LEFT: MOUSE.ROTATE, MIDDLE: MOUSE.DOLLY, RIGHT: MOUSE.PAN };

		/**
		 * This object contains references to the touch actions used by the controls.
		 *
		 * ```js
		 * controls.mouseButtons = {
		 * 	ONE: THREE.TOUCH.ROTATE,
		 * 	TWO: THREE.TOUCH.DOLLY_PAN
		 * }
		 * ```
		 * @type {Object}
		 */
		this.touches = { ONE: TOUCH.ROTATE, TWO: TOUCH.DOLLY_PAN };

		/**
		 * Used internally by `saveState()` and `reset()`.
		 *
		 * @type {Vector3}
		 */
		this.target0 = this.target.clone();

		/**
		 * Used internally by `saveState()` and `reset()`.
		 *
		 * @type {Vector3}
		 */
		this.position0 = this.object.position.clone();

		/**
		 * Used internally by `saveState()` and `reset()`.
		 *
		 * @type {number}
		 */
		this.zoom0 = this.object.zoom;

		// the target DOM element for key events
		this._domElementKeyEvents = null;

		// internals

		this._lastPosition = new Vector3();
		this._lastQuaternion = new Quaternion();
		this._lastTargetPosition = new Vector3();

		// so camera.up is the orbit axis
		this._quat = new Quaternion().setFromUnitVectors( object.up, new Vector3( 0, 1, 0 ) );
		this._quatInverse = this._quat.clone().invert();

		// current position in spherical coordinates
		this._spherical = new Spherical();
		this._sphericalDelta = new Spherical();

		this._scale = 1;
		this._panOffset = new Vector3();

		this._rotateStart = new Vector2();
		this._rotateEnd = new Vector2();
		this._rotateDelta = new Vector2();

		this._panStart = new Vector2();
		this._panEnd = new Vector2();
		this._panDelta = new Vector2();

		this._dollyStart = new Vector2();
		this._dollyEnd = new Vector2();
		this._dollyDelta = new Vector2();

		this._dollyDirection = new Vector3();
		this._mouse = new Vector2();
		this._performCursorZoom = false;

		this._pointers = [];
		this._pointerPositions = {};

		this._controlActive = false;

		// event listeners

		this._onPointerMove = onPointerMove.bind( this );
		this._onPointerDown = onPointerDown.bind( this );
		this._onPointerUp = onPointerUp.bind( this );
		this._onContextMenu = onContextMenu.bind( this );
		this._onMouseWheel = onMouseWheel.bind( this );
		this._onKeyDown = onKeyDown.bind( this );

		this._onTouchStart = onTouchStart.bind( this );
		this._onTouchMove = onTouchMove.bind( this );

		this._onMouseDown = onMouseDown.bind( this );
		this._onMouseMove = onMouseMove.bind( this );

		this._interceptControlDown = interceptControlDown.bind( this );
		this._interceptControlUp = interceptControlUp.bind( this );

		//

		if ( this.domElement !== null ) {

			this.connect( this.domElement );

		}

		this.update();

	}

	connect( element ) {

		super.connect( element );

		this.domElement.addEventListener( 'pointerdown', this._onPointerDown );
		this.domElement.addEventListener( 'pointercancel', this._onPointerUp );

		this.domElement.addEventListener( 'contextmenu', this._onContextMenu );
		this.domElement.addEventListener( 'wheel', this._onMouseWheel, { passive: false } );

		const document = this.domElement.getRootNode(); // offscreen canvas compatibility
		document.addEventListener( 'keydown', this._interceptControlDown, { passive: true, capture: true } );

		this.domElement.style.touchAction = 'none'; // disable touch scroll

	}

	disconnect() {

		this.domElement.removeEventListener( 'pointerdown', this._onPointerDown );
		this.domElement.removeEventListener( 'pointermove', this._onPointerMove );
		this.domElement.removeEventListener( 'pointerup', this._onPointerUp );
		this.domElement.removeEventListener( 'pointercancel', this._onPointerUp );

		this.domElement.removeEventListener( 'wheel', this._onMouseWheel );
		this.domElement.removeEventListener( 'contextmenu', this._onContextMenu );

		this.stopListenToKeyEvents();

		const document = this.domElement.getRootNode(); // offscreen canvas compatibility
		document.removeEventListener( 'keydown', this._interceptControlDown, { capture: true } );

		this.domElement.style.touchAction = 'auto';

	}

	dispose() {

		this.disconnect();

	}

	/**
	 * Get the current vertical rotation, in radians.
	 *
	 * @return {number} The current vertical rotation, in radians.
	 */
	getPolarAngle() {

		return this._spherical.phi;

	}

	/**
	 * Get the current horizontal rotation, in radians.
	 *
	 * @return {number} The current horizontal rotation, in radians.
	 */
	getAzimuthalAngle() {

		return this._spherical.theta;

	}

	/**
	 * Returns the distance from the camera to the target.
	 *
	 * @return {number} The distance from the camera to the target.
	 */
	getDistance() {

		return this.object.position.distanceTo( this.target );

	}

	/**
	 * Adds key event listeners to the given DOM element.
	 * `window` is a recommended argument for using this method.
	 *
	 * @param {HTMLElement} domElement - The DOM element
	 */
	listenToKeyEvents( domElement ) {

		domElement.addEventListener( 'keydown', this._onKeyDown );
		this._domElementKeyEvents = domElement;

	}

	/**
	 * Removes the key event listener previously defined with `listenToKeyEvents()`.
	 */
	stopListenToKeyEvents() {

		if ( this._domElementKeyEvents !== null ) {

			this._domElementKeyEvents.removeEventListener( 'keydown', this._onKeyDown );
			this._domElementKeyEvents = null;

		}

	}

	/**
	 * Save the current state of the controls. This can later be recovered with `reset()`.
	 */
	saveState() {

		this.target0.copy( this.target );
		this.position0.copy( this.object.position );
		this.zoom0 = this.object.zoom;

	}

	/**
	 * Reset the controls to their state from either the last time the `saveState()`
	 * was called, or the initial state.
	 */
	reset() {

		this.target.copy( this.target0 );
		this.object.position.copy( this.position0 );
		this.object.zoom = this.zoom0;

		this.object.updateProjectionMatrix();
		this.dispatchEvent( _changeEvent );

		this.update();

		this.state = _STATE.NONE;

	}

	update( deltaTime = null ) {

		const position = this.object.position;

		_v.copy( position ).sub( this.target );

		// rotate offset to "y-axis-is-up" space
		_v.applyQuaternion( this._quat );

		// angle from z-axis around y-axis
		this._spherical.setFromVector3( _v );

		if ( this.autoRotate && this.state === _STATE.NONE ) {

			this._rotateLeft( this._getAutoRotationAngle( deltaTime ) );

		}

		if ( this.enableDamping ) {

			this._spherical.theta += this._sphericalDelta.theta * this.dampingFactor;
			this._spherical.phi += this._sphericalDelta.phi * this.dampingFactor;

		} else {

			this._spherical.theta += this._sphericalDelta.theta;
			this._spherical.phi += this._sphericalDelta.phi;

		}

		// restrict theta to be between desired limits

		let min = this.minAzimuthAngle;
		let max = this.maxAzimuthAngle;

		if ( isFinite( min ) && isFinite( max ) ) {

			if ( min < - Math.PI ) min += _twoPI; else if ( min > Math.PI ) min -= _twoPI;

			if ( max < - Math.PI ) max += _twoPI; else if ( max > Math.PI ) max -= _twoPI;

			if ( min <= max ) {

				this._spherical.theta = Math.max( min, Math.min( max, this._spherical.theta ) );

			} else {

				this._spherical.theta = ( this._spherical.theta > ( min + max ) / 2 ) ?
					Math.max( min, this._spherical.theta ) :
					Math.min( max, this._spherical.theta );

			}

		}

		// restrict phi to be between desired limits
		this._spherical.phi = Math.max( this.minPolarAngle, Math.min( this.maxPolarAngle, this._spherical.phi ) );

		this._spherical.makeSafe();


		// move target to panned location

		if ( this.enableDamping === true ) {

			this.target.addScaledVector( this._panOffset, this.dampingFactor );

		} else {

			this.target.add( this._panOffset );

		}

		// Limit the target distance from the cursor to create a sphere around the center of interest
		this.target.sub( this.cursor );
		this.target.clampLength( this.minTargetRadius, this.maxTargetRadius );
		this.target.add( this.cursor );

		let zoomChanged = false;
		// adjust the camera position based on zoom only if we're not zooming to the cursor or if it's an ortho camera
		// we adjust zoom later in these cases
		if ( this.zoomToCursor && this._performCursorZoom || this.object.isOrthographicCamera ) {

			this._spherical.radius = this._clampDistance( this._spherical.radius );

		} else {

			const prevRadius = this._spherical.radius;
			this._spherical.radius = this._clampDistance( this._spherical.radius * this._scale );
			zoomChanged = prevRadius != this._spherical.radius;

		}

		_v.setFromSpherical( this._spherical );

		// rotate offset back to "camera-up-vector-is-up" space
		_v.applyQuaternion( this._quatInverse );

		position.copy( this.target ).add( _v );

		this.object.lookAt( this.target );

		if ( this.enableDamping === true ) {

			this._sphericalDelta.theta *= ( 1 - this.dampingFactor );
			this._sphericalDelta.phi *= ( 1 - this.dampingFactor );

			this._panOffset.multiplyScalar( 1 - this.dampingFactor );

		} else {

			this._sphericalDelta.set( 0, 0, 0 );

			this._panOffset.set( 0, 0, 0 );

		}

		// adjust camera position
		if ( this.zoomToCursor && this._performCursorZoom ) {

			let newRadius = null;
			if ( this.object.isPerspectiveCamera ) {

				// move the camera down the pointer ray
				// this method avoids floating point error
				const prevRadius = _v.length();
				newRadius = this._clampDistance( prevRadius * this._scale );

				const radiusDelta = prevRadius - newRadius;
				this.object.position.addScaledVector( this._dollyDirection, radiusDelta );
				this.object.updateMatrixWorld();

				zoomChanged = !! radiusDelta;

			} else if ( this.object.isOrthographicCamera ) {

				// adjust the ortho camera position based on zoom changes
				const mouseBefore = new Vector3( this._mouse.x, this._mouse.y, 0 );
				mouseBefore.unproject( this.object );

				const prevZoom = this.object.zoom;
				this.object.zoom = Math.max( this.minZoom, Math.min( this.maxZoom, this.object.zoom / this._scale ) );
				this.object.updateProjectionMatrix();

				zoomChanged = prevZoom !== this.object.zoom;

				const mouseAfter = new Vector3( this._mouse.x, this._mouse.y, 0 );
				mouseAfter.unproject( this.object );

				this.object.position.sub( mouseAfter ).add( mouseBefore );
				this.object.updateMatrixWorld();

				newRadius = _v.length();

			} else {

				console.warn( 'WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled.' );
				this.zoomToCursor = false;

			}

			// handle the placement of the target
			if ( newRadius !== null ) {

				if ( this.screenSpacePanning ) {

					// position the orbit target in front of the new camera position
					this.target.set( 0, 0, - 1 )
						.transformDirection( this.object.matrix )
						.multiplyScalar( newRadius )
						.add( this.object.position );

				} else {

					// get the ray and translation plane to compute target
					_ray.origin.copy( this.object.position );
					_ray.direction.set( 0, 0, - 1 ).transformDirection( this.object.matrix );

					// if the camera is 20 degrees above the horizon then don't adjust the focus target to avoid
					// extremely large values
					if ( Math.abs( this.object.up.dot( _ray.direction ) ) < _TILT_LIMIT ) {

						this.object.lookAt( this.target );

					} else {

						_plane.setFromNormalAndCoplanarPoint( this.object.up, this.target );
						_ray.intersectPlane( _plane, this.target );

					}

				}

			}

		} else if ( this.object.isOrthographicCamera ) {

			const prevZoom = this.object.zoom;
			this.object.zoom = Math.max( this.minZoom, Math.min( this.maxZoom, this.object.zoom / this._scale ) );

			if ( prevZoom !== this.object.zoom ) {

				this.object.updateProjectionMatrix();
				zoomChanged = true;

			}

		}

		this._scale = 1;
		this._performCursorZoom = false;

		// update condition is:
		// min(camera displacement, camera rotation in radians)^2 > EPS
		// using small-angle approximation cos(x/2) = 1 - x^2 / 8

		if ( zoomChanged ||
			this._lastPosition.distanceToSquared( this.object.position ) > _EPS ||
			8 * ( 1 - this._lastQuaternion.dot( this.object.quaternion ) ) > _EPS ||
			this._lastTargetPosition.distanceToSquared( this.target ) > _EPS ) {

			this.dispatchEvent( _changeEvent );

			this._lastPosition.copy( this.object.position );
			this._lastQuaternion.copy( this.object.quaternion );
			this._lastTargetPosition.copy( this.target );

			return true;

		}

		return false;

	}

	_getAutoRotationAngle( deltaTime ) {

		if ( deltaTime !== null ) {

			return ( _twoPI / 60 * this.autoRotateSpeed ) * deltaTime;

		} else {

			return _twoPI / 60 / 60 * this.autoRotateSpeed;

		}

	}

	_getZoomScale( delta ) {

		const normalizedDelta = Math.abs( delta * 0.01 );
		return Math.pow( 0.95, this.zoomSpeed * normalizedDelta );

	}

	_rotateLeft( angle ) {

		this._sphericalDelta.theta -= angle;

	}

	_rotateUp( angle ) {

		this._sphericalDelta.phi -= angle;

	}

	_panLeft( distance, objectMatrix ) {

		_v.setFromMatrixColumn( objectMatrix, 0 ); // get X column of objectMatrix
		_v.multiplyScalar( - distance );

		this._panOffset.add( _v );

	}

	_panUp( distance, objectMatrix ) {

		if ( this.screenSpacePanning === true ) {

			_v.setFromMatrixColumn( objectMatrix, 1 );

		} else {

			_v.setFromMatrixColumn( objectMatrix, 0 );
			_v.crossVectors( this.object.up, _v );

		}

		_v.multiplyScalar( distance );

		this._panOffset.add( _v );

	}

	// deltaX and deltaY are in pixels; right and down are positive
	_pan( deltaX, deltaY ) {

		const element = this.domElement;

		if ( this.object.isPerspectiveCamera ) {

			// perspective
			const position = this.object.position;
			_v.copy( position ).sub( this.target );
			let targetDistance = _v.length();

			// half of the fov is center to top of screen
			targetDistance *= Math.tan( ( this.object.fov / 2 ) * Math.PI / 180.0 );

			// we use only clientHeight here so aspect ratio does not distort speed
			this._panLeft( 2 * deltaX * targetDistance / element.clientHeight, this.object.matrix );
			this._panUp( 2 * deltaY * targetDistance / element.clientHeight, this.object.matrix );

		} else if ( this.object.isOrthographicCamera ) {

			// orthographic
			this._panLeft( deltaX * ( this.object.right - this.object.left ) / this.object.zoom / element.clientWidth, this.object.matrix );
			this._panUp( deltaY * ( this.object.top - this.object.bottom ) / this.object.zoom / element.clientHeight, this.object.matrix );

		} else {

			// camera neither orthographic nor perspective
			console.warn( 'WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.' );
			this.enablePan = false;

		}

	}

	_dollyOut( dollyScale ) {

		if ( this.object.isPerspectiveCamera || this.object.isOrthographicCamera ) {

			this._scale /= dollyScale;

		} else {

			console.warn( 'WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.' );
			this.enableZoom = false;

		}

	}

	_dollyIn( dollyScale ) {

		if ( this.object.isPerspectiveCamera || this.object.isOrthographicCamera ) {

			this._scale *= dollyScale;

		} else {

			console.warn( 'WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.' );
			this.enableZoom = false;

		}

	}

	_updateZoomParameters( x, y ) {

		if ( ! this.zoomToCursor ) {

			return;

		}

		this._performCursorZoom = true;

		const rect = this.domElement.getBoundingClientRect();
		const dx = x - rect.left;
		const dy = y - rect.top;
		const w = rect.width;
		const h = rect.height;

		this._mouse.x = ( dx / w ) * 2 - 1;
		this._mouse.y = - ( dy / h ) * 2 + 1;

		this._dollyDirection.set( this._mouse.x, this._mouse.y, 1 ).unproject( this.object ).sub( this.object.position ).normalize();

	}

	_clampDistance( dist ) {

		return Math.max( this.minDistance, Math.min( this.maxDistance, dist ) );

	}

	//
	// event callbacks - update the object state
	//

	_handleMouseDownRotate( event ) {

		this._rotateStart.set( event.clientX, event.clientY );

	}

	_handleMouseDownDolly( event ) {

		this._updateZoomParameters( event.clientX, event.clientX );
		this._dollyStart.set( event.clientX, event.clientY );

	}

	_handleMouseDownPan( event ) {

		this._panStart.set( event.clientX, event.clientY );

	}

	_handleMouseMoveRotate( event ) {

		this._rotateEnd.set( event.clientX, event.clientY );

		this._rotateDelta.subVectors( this._rotateEnd, this._rotateStart ).multiplyScalar( this.rotateSpeed );

		const element = this.domElement;

		this._rotateLeft( _twoPI * this._rotateDelta.x / element.clientHeight ); // yes, height

		this._rotateUp( _twoPI * this._rotateDelta.y / element.clientHeight );

		this._rotateStart.copy( this._rotateEnd );

		this.update();

	}

	_handleMouseMoveDolly( event ) {

		this._dollyEnd.set( event.clientX, event.clientY );

		this._dollyDelta.subVectors( this._dollyEnd, this._dollyStart );

		if ( this._dollyDelta.y > 0 ) {

			this._dollyOut( this._getZoomScale( this._dollyDelta.y ) );

		} else if ( this._dollyDelta.y < 0 ) {

			this._dollyIn( this._getZoomScale( this._dollyDelta.y ) );

		}

		this._dollyStart.copy( this._dollyEnd );

		this.update();

	}

	_handleMouseMovePan( event ) {

		this._panEnd.set( event.clientX, event.clientY );

		this._panDelta.subVectors( this._panEnd, this._panStart ).multiplyScalar( this.panSpeed );

		this._pan( this._panDelta.x, this._panDelta.y );

		this._panStart.copy( this._panEnd );

		this.update();

	}

	_handleMouseWheel( event ) {

		this._updateZoomParameters( event.clientX, event.clientY );

		if ( event.deltaY < 0 ) {

			this._dollyIn( this._getZoomScale( event.deltaY ) );

		} else if ( event.deltaY > 0 ) {

			this._dollyOut( this._getZoomScale( event.deltaY ) );

		}

		this.update();

	}

	_handleKeyDown( event ) {

		let needsUpdate = false;

		switch ( event.code ) {

			case this.keys.UP:

				if ( event.ctrlKey || event.metaKey || event.shiftKey ) {

					if ( this.enableRotate ) {

						this._rotateUp( _twoPI * this.keyRotateSpeed / this.domElement.clientHeight );

					}

				} else {

					if ( this.enablePan ) {

						this._pan( 0, this.keyPanSpeed );

					}

				}

				needsUpdate = true;
				break;

			case this.keys.BOTTOM:

				if ( event.ctrlKey || event.metaKey || event.shiftKey ) {

					if ( this.enableRotate ) {

						this._rotateUp( - _twoPI * this.keyRotateSpeed / this.domElement.clientHeight );

					}

				} else {

					if ( this.enablePan ) {

						this._pan( 0, - this.keyPanSpeed );

					}

				}

				needsUpdate = true;
				break;

			case this.keys.LEFT:

				if ( event.ctrlKey || event.metaKey || event.shiftKey ) {

					if ( this.enableRotate ) {

						this._rotateLeft( _twoPI * this.keyRotateSpeed / this.domElement.clientHeight );

					}

				} else {

					if ( this.enablePan ) {

						this._pan( this.keyPanSpeed, 0 );

					}

				}

				needsUpdate = true;
				break;

			case this.keys.RIGHT:

				if ( event.ctrlKey || event.metaKey || event.shiftKey ) {

					if ( this.enableRotate ) {

						this._rotateLeft( - _twoPI * this.keyRotateSpeed / this.domElement.clientHeight );

					}

				} else {

					if ( this.enablePan ) {

						this._pan( - this.keyPanSpeed, 0 );

					}

				}

				needsUpdate = true;
				break;

		}

		if ( needsUpdate ) {

			// prevent the browser from scrolling on cursor keys
			event.preventDefault();

			this.update();

		}


	}

	_handleTouchStartRotate( event ) {

		if ( this._pointers.length === 1 ) {

			this._rotateStart.set( event.pageX, event.pageY );

		} else {

			const position = this._getSecondPointerPosition( event );

			const x = 0.5 * ( event.pageX + position.x );
			const y = 0.5 * ( event.pageY + position.y );

			this._rotateStart.set( x, y );

		}

	}

	_handleTouchStartPan( event ) {

		if ( this._pointers.length === 1 ) {

			this._panStart.set( event.pageX, event.pageY );

		} else {

			const position = this._getSecondPointerPosition( event );

			const x = 0.5 * ( event.pageX + position.x );
			const y = 0.5 * ( event.pageY + position.y );

			this._panStart.set( x, y );

		}

	}

	_handleTouchStartDolly( event ) {

		const position = this._getSecondPointerPosition( event );

		const dx = event.pageX - position.x;
		const dy = event.pageY - position.y;

		const distance = Math.sqrt( dx * dx + dy * dy );

		this._dollyStart.set( 0, distance );

	}

	_handleTouchStartDollyPan( event ) {

		if ( this.enableZoom ) this._handleTouchStartDolly( event );

		if ( this.enablePan ) this._handleTouchStartPan( event );

	}

	_handleTouchStartDollyRotate( event ) {

		if ( this.enableZoom ) this._handleTouchStartDolly( event );

		if ( this.enableRotate ) this._handleTouchStartRotate( event );

	}

	_handleTouchMoveRotate( event ) {

		if ( this._pointers.length == 1 ) {

			this._rotateEnd.set( event.pageX, event.pageY );

		} else {

			const position = this._getSecondPointerPosition( event );

			const x = 0.5 * ( event.pageX + position.x );
			const y = 0.5 * ( event.pageY + position.y );

			this._rotateEnd.set( x, y );

		}

		this._rotateDelta.subVectors( this._rotateEnd, this._rotateStart ).multiplyScalar( this.rotateSpeed );

		const element = this.domElement;

		this._rotateLeft( _twoPI * this._rotateDelta.x / element.clientHeight ); // yes, height

		this._rotateUp( _twoPI * this._rotateDelta.y / element.clientHeight );

		this._rotateStart.copy( this._rotateEnd );

	}

	_handleTouchMovePan( event ) {

		if ( this._pointers.length === 1 ) {

			this._panEnd.set( event.pageX, event.pageY );

		} else {

			const position = this._getSecondPointerPosition( event );

			const x = 0.5 * ( event.pageX + position.x );
			const y = 0.5 * ( event.pageY + position.y );

			this._panEnd.set( x, y );

		}

		this._panDelta.subVectors( this._panEnd, this._panStart ).multiplyScalar( this.panSpeed );

		this._pan( this._panDelta.x, this._panDelta.y );

		this._panStart.copy( this._panEnd );

	}

	_handleTouchMoveDolly( event ) {

		const position = this._getSecondPointerPosition( event );

		const dx = event.pageX - position.x;
		const dy = event.pageY - position.y;

		const distance = Math.sqrt( dx * dx + dy * dy );

		this._dollyEnd.set( 0, distance );

		this._dollyDelta.set( 0, Math.pow( this._dollyEnd.y / this._dollyStart.y, this.zoomSpeed ) );

		this._dollyOut( this._dollyDelta.y );

		this._dollyStart.copy( this._dollyEnd );

		const centerX = ( event.pageX + position.x ) * 0.5;
		const centerY = ( event.pageY + position.y ) * 0.5;

		this._updateZoomParameters( centerX, centerY );

	}

	_handleTouchMoveDollyPan( event ) {

		if ( this.enableZoom ) this._handleTouchMoveDolly( event );

		if ( this.enablePan ) this._handleTouchMovePan( event );

	}

	_handleTouchMoveDollyRotate( event ) {

		if ( this.enableZoom ) this._handleTouchMoveDolly( event );

		if ( this.enableRotate ) this._handleTouchMoveRotate( event );

	}

	// pointers

	_addPointer( event ) {

		this._pointers.push( event.pointerId );

	}

	_removePointer( event ) {

		delete this._pointerPositions[ event.pointerId ];

		for ( let i = 0; i < this._pointers.length; i ++ ) {

			if ( this._pointers[ i ] == event.pointerId ) {

				this._pointers.splice( i, 1 );
				return;

			}

		}

	}

	_isTrackingPointer( event ) {

		for ( let i = 0; i < this._pointers.length; i ++ ) {

			if ( this._pointers[ i ] == event.pointerId ) return true;

		}

		return false;

	}

	_trackPointer( event ) {

		let position = this._pointerPositions[ event.pointerId ];

		if ( position === undefined ) {

			position = new Vector2();
			this._pointerPositions[ event.pointerId ] = position;

		}

		position.set( event.pageX, event.pageY );

	}

	_getSecondPointerPosition( event ) {

		const pointerId = ( event.pointerId === this._pointers[ 0 ] ) ? this._pointers[ 1 ] : this._pointers[ 0 ];

		return this._pointerPositions[ pointerId ];

	}

	//

	_customWheelEvent( event ) {

		const mode = event.deltaMode;

		// minimal wheel event altered to meet delta-zoom demand
		const newEvent = {
			clientX: event.clientX,
			clientY: event.clientY,
			deltaY: event.deltaY,
		};

		switch ( mode ) {

			case 1: // LINE_MODE
				newEvent.deltaY *= 16;
				break;

			case 2: // PAGE_MODE
				newEvent.deltaY *= 100;
				break;

		}

		// detect if event was triggered by pinching
		if ( event.ctrlKey && ! this._controlActive ) {

			newEvent.deltaY *= 10;

		}

		return newEvent;

	}

}

function onPointerDown( event ) {

	if ( this.enabled === false ) return;

	if ( this._pointers.length === 0 ) {

		this.domElement.setPointerCapture( event.pointerId );

		this.domElement.addEventListener( 'pointermove', this._onPointerMove );
		this.domElement.addEventListener( 'pointerup', this._onPointerUp );

	}

	//

	if ( this._isTrackingPointer( event ) ) return;

	//

	this._addPointer( event );

	if ( event.pointerType === 'touch' ) {

		this._onTouchStart( event );

	} else {

		this._onMouseDown( event );

	}

}

function onPointerMove( event ) {

	if ( this.enabled === false ) return;

	if ( event.pointerType === 'touch' ) {

		this._onTouchMove( event );

	} else {

		this._onMouseMove( event );

	}

}

function onPointerUp( event ) {

	this._removePointer( event );

	switch ( this._pointers.length ) {

		case 0:

			this.domElement.releasePointerCapture( event.pointerId );

			this.domElement.removeEventListener( 'pointermove', this._onPointerMove );
			this.domElement.removeEventListener( 'pointerup', this._onPointerUp );

			this.dispatchEvent( _endEvent );

			this.state = _STATE.NONE;

			break;

		case 1:

			const pointerId = this._pointers[ 0 ];
			const position = this._pointerPositions[ pointerId ];

			// minimal placeholder event - allows state correction on pointer-up
			this._onTouchStart( { pointerId: pointerId, pageX: position.x, pageY: position.y } );

			break;

	}

}

function onMouseDown( event ) {

	let mouseAction;

	switch ( event.button ) {

		case 0:

			mouseAction = this.mouseButtons.LEFT;
			break;

		case 1:

			mouseAction = this.mouseButtons.MIDDLE;
			break;

		case 2:

			mouseAction = this.mouseButtons.RIGHT;
			break;

		default:

			mouseAction = - 1;

	}

	switch ( mouseAction ) {

		case MOUSE.DOLLY:

			if ( this.enableZoom === false ) return;

			this._handleMouseDownDolly( event );

			this.state = _STATE.DOLLY;

			break;

		case MOUSE.ROTATE:

			if ( event.ctrlKey || event.metaKey || event.shiftKey ) {

				if ( this.enablePan === false ) return;

				this._handleMouseDownPan( event );

				this.state = _STATE.PAN;

			} else {

				if ( this.enableRotate === false ) return;

				this._handleMouseDownRotate( event );

				this.state = _STATE.ROTATE;

			}

			break;

		case MOUSE.PAN:

			if ( event.ctrlKey || event.metaKey || event.shiftKey ) {

				if ( this.enableRotate === false ) return;

				this._handleMouseDownRotate( event );

				this.state = _STATE.ROTATE;

			} else {

				if ( this.enablePan === false ) return;

				this._handleMouseDownPan( event );

				this.state = _STATE.PAN;

			}

			break;

		default:

			this.state = _STATE.NONE;

	}

	if ( this.state !== _STATE.NONE ) {

		this.dispatchEvent( _startEvent );

	}

}

function onMouseMove( event ) {

	switch ( this.state ) {

		case _STATE.ROTATE:

			if ( this.enableRotate === false ) return;

			this._handleMouseMoveRotate( event );

			break;

		case _STATE.DOLLY:

			if ( this.enableZoom === false ) return;

			this._handleMouseMoveDolly( event );

			break;

		case _STATE.PAN:

			if ( this.enablePan === false ) return;

			this._handleMouseMovePan( event );

			break;

	}

}

function onMouseWheel( event ) {

	if ( this.enabled === false || this.enableZoom === false || this.state !== _STATE.NONE ) return;

	event.preventDefault();

	this.dispatchEvent( _startEvent );

	this._handleMouseWheel( this._customWheelEvent( event ) );

	this.dispatchEvent( _endEvent );

}

function onKeyDown( event ) {

	if ( this.enabled === false ) return;

	this._handleKeyDown( event );

}

function onTouchStart( event ) {

	this._trackPointer( event );

	switch ( this._pointers.length ) {

		case 1:

			switch ( this.touches.ONE ) {

				case TOUCH.ROTATE:

					if ( this.enableRotate === false ) return;

					this._handleTouchStartRotate( event );

					this.state = _STATE.TOUCH_ROTATE;

					break;

				case TOUCH.PAN:

					if ( this.enablePan === false ) return;

					this._handleTouchStartPan( event );

					this.state = _STATE.TOUCH_PAN;

					break;

				default:

					this.state = _STATE.NONE;

			}

			break;

		case 2:

			switch ( this.touches.TWO ) {

				case TOUCH.DOLLY_PAN:

					if ( this.enableZoom === false && this.enablePan === false ) return;

					this._handleTouchStartDollyPan( event );

					this.state = _STATE.TOUCH_DOLLY_PAN;

					break;

				case TOUCH.DOLLY_ROTATE:

					if ( this.enableZoom === false && this.enableRotate === false ) return;

					this._handleTouchStartDollyRotate( event );

					this.state = _STATE.TOUCH_DOLLY_ROTATE;

					break;

				default:

					this.state = _STATE.NONE;

			}

			break;

		default:

			this.state = _STATE.NONE;

	}

	if ( this.state !== _STATE.NONE ) {

		this.dispatchEvent( _startEvent );

	}

}

function onTouchMove( event ) {

	this._trackPointer( event );

	switch ( this.state ) {

		case _STATE.TOUCH_ROTATE:

			if ( this.enableRotate === false ) return;

			this._handleTouchMoveRotate( event );

			this.update();

			break;

		case _STATE.TOUCH_PAN:

			if ( this.enablePan === false ) return;

			this._handleTouchMovePan( event );

			this.update();

			break;

		case _STATE.TOUCH_DOLLY_PAN:

			if ( this.enableZoom === false && this.enablePan === false ) return;

			this._handleTouchMoveDollyPan( event );

			this.update();

			break;

		case _STATE.TOUCH_DOLLY_ROTATE:

			if ( this.enableZoom === false && this.enableRotate === false ) return;

			this._handleTouchMoveDollyRotate( event );

			this.update();

			break;

		default:

			this.state = _STATE.NONE;

	}

}

function onContextMenu( event ) {

	if ( this.enabled === false ) return;

	event.preventDefault();

}

function interceptControlDown( event ) {

	if ( event.key === 'Control' ) {

		this._controlActive = true;

		const document = this.domElement.getRootNode(); // offscreen canvas compatibility

		document.addEventListener( 'keyup', this._interceptControlUp, { passive: true, capture: true } );

	}

}

function interceptControlUp( event ) {

	if ( event.key === 'Control' ) {

		this._controlActive = false;

		const document = this.domElement.getRootNode(); // offscreen canvas compatibility

		document.removeEventListener( 'keyup', this._interceptControlUp, { passive: true, capture: true } );

	}

}

export { OrbitControls };

/*
 * International Telephone Input v17.0.19
 * https://github.com/jackocnr/intl-tel-input.git
 * Licensed under the MIT license
 */

!function(a){"object"==typeof module&&module.exports?module.exports=a():window.intlTelInput=a()}(function(a){"use strict";return function(){function b(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}function c(a,b){for(var c=0;c<b.length;c++){var d=b[c];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(a,d.key,d)}}function d(a,b,d){return b&&c(a.prototype,b),d&&c(a,d),a}for(var e=[["Afghanistan (‫افغانستان‬‎)","af","93"],["Albania (Shqipëri)","al","355"],["Algeria (‫الجزائر‬‎)","dz","213"],["American Samoa","as","1",5,["684"]],["Andorra","ad","376"],["Angola","ao","244"],["Anguilla","ai","1",6,["264"]],["Antigua and Barbuda","ag","1",7,["268"]],["Argentina","ar","54"],["Armenia (Հայաստան)","am","374"],["Aruba","aw","297"],["Ascension Island","ac","247"],["Australia","au","61",0],["Austria (Österreich)","at","43"],["Azerbaijan (Azərbaycan)","az","994"],["Bahamas","bs","1",8,["242"]],["Bahrain (‫البحرين‬‎)","bh","973"],["Bangladesh (বাংলাদেশ)","bd","880"],["Barbados","bb","1",9,["246"]],["Belarus (Беларусь)","by","375"],["Belgium (België)","be","32"],["Belize","bz","501"],["Benin (Bénin)","bj","229"],["Bermuda","bm","1",10,["441"]],["Bhutan (འབྲུག)","bt","975"],["Bolivia","bo","591"],["Bosnia and Herzegovina (Босна и Херцеговина)","ba","387"],["Botswana","bw","267"],["Brazil (Brasil)","br","55"],["British Indian Ocean Territory","io","246"],["British Virgin Islands","vg","1",11,["284"]],["Brunei","bn","673"],["Bulgaria (България)","bg","359"],["Burkina Faso","bf","226"],["Burundi (Uburundi)","bi","257"],["Cambodia (កម្ពុជា)","kh","855"],["Cameroon (Cameroun)","cm","237"],["Canada","ca","1",1,["204","226","236","249","250","289","306","343","365","387","403","416","418","431","437","438","450","506","514","519","548","579","581","587","604","613","639","647","672","705","709","742","778","780","782","807","819","825","867","873","902","905"]],["Cape Verde (Kabu Verdi)","cv","238"],["Caribbean Netherlands","bq","599",1,["3","4","7"]],["Cayman Islands","ky","1",12,["345"]],["Central African Republic (République centrafricaine)","cf","236"],["Chad (Tchad)","td","235"],["Chile","cl","56"],["China (中国)","cn","86"],["Christmas Island","cx","61",2,["89164"]],["Cocos (Keeling) Islands","cc","61",1,["89162"]],["Colombia","co","57"],["Comoros (‫جزر القمر‬‎)","km","269"],["Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)","cd","243"],["Congo (Republic) (Congo-Brazzaville)","cg","242"],["Cook Islands","ck","682"],["Costa Rica","cr","506"],["Côte d’Ivoire","ci","225"],["Croatia (Hrvatska)","hr","385"],["Cuba","cu","53"],["Curaçao","cw","599",0],["Cyprus (Κύπρος)","cy","357"],["Czech Republic (Česká republika)","cz","420"],["Denmark (Danmark)","dk","45"],["Djibouti","dj","253"],["Dominica","dm","1",13,["767"]],["Dominican Republic (República Dominicana)","do","1",2,["809","829","849"]],["Ecuador","ec","593"],["Egypt (‫مصر‬‎)","eg","20"],["El Salvador","sv","503"],["Equatorial Guinea (Guinea Ecuatorial)","gq","240"],["Eritrea","er","291"],["Estonia (Eesti)","ee","372"],["Eswatini","sz","268"],["Ethiopia","et","251"],["Falkland Islands (Islas Malvinas)","fk","500"],["Faroe Islands (Føroyar)","fo","298"],["Fiji","fj","679"],["Finland (Suomi)","fi","358",0],["France","fr","33"],["French Guiana (Guyane française)","gf","594"],["French Polynesia (Polynésie française)","pf","689"],["Gabon","ga","241"],["Gambia","gm","220"],["Georgia (საქართველო)","ge","995"],["Germany (Deutschland)","de","49"],["Ghana (Gaana)","gh","233"],["Gibraltar","gi","350"],["Greece (Ελλάδα)","gr","30"],["Greenland (Kalaallit Nunaat)","gl","299"],["Grenada","gd","1",14,["473"]],["Guadeloupe","gp","590",0],["Guam","gu","1",15,["671"]],["Guatemala","gt","502"],["Guernsey","gg","44",1,["1481","7781","7839","7911"]],["Guinea (Guinée)","gn","224"],["Guinea-Bissau (Guiné Bissau)","gw","245"],["Guyana","gy","592"],["Haiti","ht","509"],["Honduras","hn","504"],["Hong Kong (香港)","hk","852"],["Hungary (Magyarország)","hu","36"],["Iceland (Ísland)","is","354"],["India (भारत)","in","91"],["Indonesia","id","62"],["Iran (‫ایران‬‎)","ir","98"],["Iraq (‫العراق‬‎)","iq","964"],["Ireland","ie","353"],["Isle of Man","im","44",2,["1624","74576","7524","7924","7624"]],["Israel (‫ישראל‬‎)","il","972"],["Italy (Italia)","it","39",0],["Jamaica","jm","1",4,["876","658"]],["Japan (日本)","jp","81"],["Jersey","je","44",3,["1534","7509","7700","7797","7829","7937"]],["Jordan (‫الأردن‬‎)","jo","962"],["Kazakhstan (Казахстан)","kz","7",1,["33","7"]],["Kenya","ke","254"],["Kiribati","ki","686"],["Kosovo","xk","383"],["Kuwait (‫الكويت‬‎)","kw","965"],["Kyrgyzstan (Кыргызстан)","kg","996"],["Laos (ລາວ)","la","856"],["Latvia (Latvija)","lv","371"],["Lebanon (‫لبنان‬‎)","lb","961"],["Lesotho","ls","266"],["Liberia","lr","231"],["Libya (‫ليبيا‬‎)","ly","218"],["Liechtenstein","li","423"],["Lithuania (Lietuva)","lt","370"],["Luxembourg","lu","352"],["Macau (澳門)","mo","853"],["North Macedonia (Македонија)","mk","389"],["Madagascar (Madagasikara)","mg","261"],["Malawi","mw","265"],["Malaysia","my","60"],["Maldives","mv","960"],["Mali","ml","223"],["Malta","mt","356"],["Marshall Islands","mh","692"],["Martinique","mq","596"],["Mauritania (‫موريتانيا‬‎)","mr","222"],["Mauritius (Moris)","mu","230"],["Mayotte","yt","262",1,["269","639"]],["Mexico (México)","mx","52"],["Micronesia","fm","691"],["Moldova (Republica Moldova)","md","373"],["Monaco","mc","377"],["Mongolia (Монгол)","mn","976"],["Montenegro (Crna Gora)","me","382"],["Montserrat","ms","1",16,["664"]],["Morocco (‫المغرب‬‎)","ma","212",0],["Mozambique (Moçambique)","mz","258"],["Myanmar (Burma) (မြန်မာ)","mm","95"],["Namibia (Namibië)","na","264"],["Nauru","nr","674"],["Nepal (नेपाल)","np","977"],["Netherlands (Nederland)","nl","31"],["New Caledonia (Nouvelle-Calédonie)","nc","687"],["New Zealand","nz","64"],["Nicaragua","ni","505"],["Niger (Nijar)","ne","227"],["Nigeria","ng","234"],["Niue","nu","683"],["Norfolk Island","nf","672"],["North Korea (조선 민주주의 인민 공화국)","kp","850"],["Northern Mariana Islands","mp","1",17,["670"]],["Norway (Norge)","no","47",0],["Oman (‫عُمان‬‎)","om","968"],["Pakistan (‫پاکستان‬‎)","pk","92"],["Palau","pw","680"],["Palestine (‫فلسطين‬‎)","ps","970"],["Panama (Panamá)","pa","507"],["Papua New Guinea","pg","675"],["Paraguay","py","595"],["Peru (Perú)","pe","51"],["Philippines","ph","63"],["Poland (Polska)","pl","48"],["Portugal","pt","351"],["Puerto Rico","pr","1",3,["787","939"]],["Qatar (‫قطر‬‎)","qa","974"],["Réunion (La Réunion)","re","262",0],["Romania (România)","ro","40"],["Russia (Россия)","ru","7",0],["Rwanda","rw","250"],["Saint Barthélemy","bl","590",1],["Saint Helena","sh","290"],["Saint Kitts and Nevis","kn","1",18,["869"]],["Saint Lucia","lc","1",19,["758"]],["Saint Martin (Saint-Martin (partie française))","mf","590",2],["Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)","pm","508"],["Saint Vincent and the Grenadines","vc","1",20,["784"]],["Samoa","ws","685"],["San Marino","sm","378"],["São Tomé and Príncipe (São Tomé e Príncipe)","st","239"],["Saudi Arabia (‫المملكة العربية السعودية‬‎)","sa","966"],["Senegal (Sénégal)","sn","221"],["Serbia (Србија)","rs","381"],["Seychelles","sc","248"],["Sierra Leone","sl","232"],["Singapore","sg","65"],["Sint Maarten","sx","1",21,["721"]],["Slovakia (Slovensko)","sk","421"],["Slovenia (Slovenija)","si","386"],["Solomon Islands","sb","677"],["Somalia (Soomaaliya)","so","252"],["South Africa","za","27"],["South Korea (대한민국)","kr","82"],["South Sudan (‫جنوب السودان‬‎)","ss","211"],["Spain (España)","es","34"],["Sri Lanka (ශ්‍රී ලංකාව)","lk","94"],["Sudan (‫السودان‬‎)","sd","249"],["Suriname","sr","597"],["Svalbard and Jan Mayen","sj","47",1,["79"]],["Sweden (Sverige)","se","46"],["Switzerland (Schweiz)","ch","41"],["Syria (‫سوريا‬‎)","sy","963"],["Taiwan (台灣)","tw","886"],["Tajikistan","tj","992"],["Tanzania","tz","255"],["Thailand (ไทย)","th","66"],["Timor-Leste","tl","670"],["Togo","tg","228"],["Tokelau","tk","690"],["Tonga","to","676"],["Trinidad and Tobago","tt","1",22,["868"]],["Tunisia (‫تونس‬‎)","tn","216"],["Turkey (Türkiye)","tr","90"],["Turkmenistan","tm","993"],["Turks and Caicos Islands","tc","1",23,["649"]],["Tuvalu","tv","688"],["U.S. Virgin Islands","vi","1",24,["340"]],["Uganda","ug","256"],["Ukraine (Україна)","ua","380"],["United Arab Emirates (‫الإمارات العربية المتحدة‬‎)","ae","971"],["United Kingdom","gb","44",0],["United States","us","1",0],["Uruguay","uy","598"],["Uzbekistan (Oʻzbekiston)","uz","998"],["Vanuatu","vu","678"],["Vatican City (Città del Vaticano)","va","39",1,["06698"]],["Venezuela","ve","58"],["Vietnam (Việt Nam)","vn","84"],["Wallis and Futuna (Wallis-et-Futuna)","wf","681"],["Western Sahara (‫الصحراء الغربية‬‎)","eh","212",1,["5288","5289"]],["Yemen (‫اليمن‬‎)","ye","967"],["Zambia","zm","260"],["Zimbabwe","zw","263"],["Åland Islands","ax","358",1,["18"]]],f=0;f<e.length;f++){var g=e[f];e[f]={name:g[0],iso2:g[1],dialCode:g[2],priority:g[3]||0,areaCodes:g[4]||null}}var h={getInstance:function(a){var b=a.getAttribute("data-intl-tel-input-id");return window.intlTelInputGlobals.instances[b]},instances:{},documentReady:function(){return"complete"===document.readyState}};"object"==typeof window&&(window.intlTelInputGlobals=h);var i=0,j={allowDropdown:!0,autoHideDialCode:!0,autoPlaceholder:"polite",customContainer:"",customPlaceholder:null,dropdownContainer:null,excludeCountries:[],formatOnDisplay:!0,geoIpLookup:null,hiddenInput:"",initialCountry:"",localizedCountries:null,nationalMode:!0,onlyCountries:[],placeholderNumberType:"MOBILE",preferredCountries:["us","gb"],separateDialCode:!1,utilsScript:""},k=["800","822","833","844","855","866","877","880","881","882","883","884","885","886","887","888","889"],l=function(a,b){for(var c=Object.keys(a),d=0;d<c.length;d++)b(c[d],a[c[d]])},m=function(a){l(window.intlTelInputGlobals.instances,function(b){window.intlTelInputGlobals.instances[b][a]()})},n=function(){function c(a,d){var e=this;b(this,c),this.id=i++,this.a=a,this.b=null,this.c=null;var f=d||{};this.d={},l(j,function(a,b){e.d[a]=f.hasOwnProperty(a)?f[a]:b}),this.e=Boolean(a.getAttribute("placeholder"))}return d(c,[{key:"_init",value:function(){var a=this;if(this.d.nationalMode&&(this.d.autoHideDialCode=!1),this.d.separateDialCode&&(this.d.autoHideDialCode=this.d.nationalMode=!1),this.g=/Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),this.g&&(document.body.classList.add("iti-mobile"),this.d.dropdownContainer||(this.d.dropdownContainer=document.body)),"undefined"!=typeof Promise){var b=new Promise(function(b,c){a.h=b,a.i=c}),c=new Promise(function(b,c){a.i0=b,a.i1=c});this.promise=Promise.all([b,c])}else this.h=this.i=function(){},this.i0=this.i1=function(){};this.s={},this._b(),this._f(),this._h(),this._i(),this._i3()}},{key:"_b",value:function(){this._d(),this._d2(),this._e(),this.d.localizedCountries&&this._d0(),(this.d.onlyCountries.length||this.d.localizedCountries)&&this.p.sort(this._d1)}},{key:"_c",value:function(b,c,d){c.length>this.countryCodeMaxLen&&(this.countryCodeMaxLen=c.length),this.q.hasOwnProperty(c)||(this.q[c]=[]);for(var e=0;e<this.q[c].length;e++)if(this.q[c][e]===b)return;var f=d!==a?d:this.q[c].length;this.q[c][f]=b}},{key:"_d",value:function(){if(this.d.onlyCountries.length){var a=this.d.onlyCountries.map(function(a){return a.toLowerCase()});this.p=e.filter(function(b){return a.indexOf(b.iso2)>-1})}else if(this.d.excludeCountries.length){var b=this.d.excludeCountries.map(function(a){return a.toLowerCase()});this.p=e.filter(function(a){return-1===b.indexOf(a.iso2)})}else this.p=e}},{key:"_d0",value:function(){for(var a=0;a<this.p.length;a++){var b=this.p[a].iso2.toLowerCase();this.d.localizedCountries.hasOwnProperty(b)&&(this.p[a].name=this.d.localizedCountries[b])}}},{key:"_d1",value:function(a,b){return a.name.localeCompare(b.name)}},{key:"_d2",value:function(){this.countryCodeMaxLen=0,this.dialCodes={},this.q={};for(var a=0;a<this.p.length;a++){var b=this.p[a];this.dialCodes[b.dialCode]||(this.dialCodes[b.dialCode]=!0),this._c(b.iso2,b.dialCode,b.priority)}for(var c=0;c<this.p.length;c++){var d=this.p[c];if(d.areaCodes)for(var e=this.q[d.dialCode][0],f=0;f<d.areaCodes.length;f++){for(var g=d.areaCodes[f],h=1;h<g.length;h++){var i=d.dialCode+g.substr(0,h);this._c(e,i),this._c(d.iso2,i)}this._c(d.iso2,d.dialCode+g)}}}},{key:"_e",value:function(){this.preferredCountries=[];for(var a=0;a<this.d.preferredCountries.length;a++){var b=this.d.preferredCountries[a].toLowerCase(),c=this._y(b,!1,!0);c&&this.preferredCountries.push(c)}}},{key:"_e2",value:function(a,b,c){var d=document.createElement(a);return b&&l(b,function(a,b){return d.setAttribute(a,b)}),c&&c.appendChild(d),d}},{key:"_f",value:function(){this.a.hasAttribute("autocomplete")||this.a.form&&this.a.form.hasAttribute("autocomplete")||this.a.setAttribute("autocomplete","off");var a="iti";this.d.allowDropdown&&(a+=" iti--allow-dropdown"),this.d.separateDialCode&&(a+=" iti--separate-dial-code"),this.d.customContainer&&(a+=" ",a+=this.d.customContainer);var b=this._e2("div",{"class":a});if(this.a.parentNode.insertBefore(b,this.a),this.k=this._e2("div",{"class":"iti__flag-container"},b),b.appendChild(this.a),this.selectedFlag=this._e2("div",{"class":"iti__selected-flag",role:"combobox","aria-controls":"iti-".concat(this.id,"__country-listbox"),"aria-owns":"iti-".concat(this.id,"__country-listbox"),"aria-expanded":"false"},this.k),this.l=this._e2("div",{"class":"iti__flag"},this.selectedFlag),this.d.separateDialCode&&(this.t=this._e2("div",{"class":"iti__selected-dial-code"},this.selectedFlag)),this.d.allowDropdown&&(this.selectedFlag.setAttribute("tabindex","0"),this.u=this._e2("div",{"class":"iti__arrow"},this.selectedFlag),this.m=this._e2("ul",{"class":"iti__country-list iti__hide",id:"iti-".concat(this.id,"__country-listbox"),role:"listbox","aria-label":"List of countries"}),this.preferredCountries.length&&(this._g(this.preferredCountries,"iti__preferred",!0),this._e2("li",{"class":"iti__divider",role:"separator","aria-disabled":"true"},this.m)),this._g(this.p,"iti__standard"),this.d.dropdownContainer?(this.dropdown=this._e2("div",{"class":"iti iti--container"}),this.dropdown.appendChild(this.m)):this.k.appendChild(this.m)),this.d.hiddenInput){var c=this.d.hiddenInput,d=this.a.getAttribute("name");if(d){var e=d.lastIndexOf("[");-1!==e&&(c="".concat(d.substr(0,e),"[").concat(c,"]"))}this.hiddenInput=this._e2("input",{type:"hidden",name:c}),b.appendChild(this.hiddenInput)}}},{key:"_g",value:function(a,b,c){for(var d="",e=0;e<a.length;e++){var f=a[e],g=c?"-preferred":"";d+="<li class='iti__country ".concat(b,"' tabIndex='-1' id='iti-").concat(this.id,"__item-").concat(f.iso2).concat(g,"' role='option' data-dial-code='").concat(f.dialCode,"' data-country-code='").concat(f.iso2,"' aria-selected='false'>"),d+="<div class='iti__flag-box'><div class='iti__flag iti__".concat(f.iso2,"'></div></div>"),d+="<span class='iti__country-name'>".concat(f.name,"</span>"),d+="<span class='iti__dial-code'>+".concat(f.dialCode,"</span>"),d+="</li>"}this.m.insertAdjacentHTML("beforeend",d)}},{key:"_h",value:function(){var a=this.a.getAttribute("value"),b=this.a.value,c=a&&"+"===a.charAt(0)&&(!b||"+"!==b.charAt(0)),d=c?a:b,e=this._5(d),f=this._w(d),g=this.d,h=g.initialCountry,i=g.nationalMode,j=g.autoHideDialCode,k=g.separateDialCode;e&&!f?this._v(d):"auto"!==h&&(h?this._z(h.toLowerCase()):e&&f?this._z("us"):(this.j=this.preferredCountries.length?this.preferredCountries[0].iso2:this.p[0].iso2,d||this._z(this.j)),d||i||j||k||(this.a.value="+".concat(this.s.dialCode))),d&&this._u(d)}},{key:"_i",value:function(){this._j(),this.d.autoHideDialCode&&this._l(),this.d.allowDropdown&&this._i2(),this.hiddenInput&&this._i0()}},{key:"_i0",value:function(){var a=this;this._a14=function(){a.hiddenInput.value=a.getNumber()},this.a.form&&this.a.form.addEventListener("submit",this._a14)}},{key:"_i1",value:function(){for(var a=this.a;a&&"LABEL"!==a.tagName;)a=a.parentNode;return a}},{key:"_i2",value:function(){var a=this;this._a9=function(b){a.m.classList.contains("iti__hide")?a.a.focus():b.preventDefault()};var b=this._i1();b&&b.addEventListener("click",this._a9),this._a10=function(){!a.m.classList.contains("iti__hide")||a.a.disabled||a.a.readOnly||a._n()},this.selectedFlag.addEventListener("click",this._a10),this._a11=function(b){a.m.classList.contains("iti__hide")&&-1!==["ArrowUp","Up","ArrowDown","Down"," ","Enter"].indexOf(b.key)&&(b.preventDefault(),b.stopPropagation(),a._n()),"Tab"===b.key&&a._2()},this.k.addEventListener("keydown",this._a11)}},{key:"_i3",value:function(){var a=this;this.d.utilsScript&&!window.intlTelInputUtils?window.intlTelInputGlobals.documentReady()?window.intlTelInputGlobals.loadUtils(this.d.utilsScript):window.addEventListener("load",function(){window.intlTelInputGlobals.loadUtils(a.d.utilsScript)}):this.i0(),"auto"===this.d.initialCountry?this._i4():this.h()}},{key:"_i4",value:function(){window.intlTelInputGlobals.autoCountry?this.handleAutoCountry():window.intlTelInputGlobals.startedLoadingAutoCountry||(window.intlTelInputGlobals.startedLoadingAutoCountry=!0,"function"==typeof this.d.geoIpLookup&&this.d.geoIpLookup(function(a){window.intlTelInputGlobals.autoCountry=a.toLowerCase(),setTimeout(function(){return m("handleAutoCountry")})},function(){return m("rejectAutoCountryPromise")}))}},{key:"_j",value:function(){var a=this;this._a12=function(){a._v(a.a.value)&&a._m2CountryChange()},this.a.addEventListener("keyup",this._a12),this._a13=function(){setTimeout(a._a12)},this.a.addEventListener("cut",this._a13),this.a.addEventListener("paste",this._a13)}},{key:"_j2",value:function(a){var b=this.a.getAttribute("maxlength");return b&&a.length>b?a.substr(0,b):a}},{key:"_l",value:function(){var a=this;this._a8=function(){a._l2()},this.a.form&&this.a.form.addEventListener("submit",this._a8),this.a.addEventListener("blur",this._a8)}},{key:"_l2",value:function(){if("+"===this.a.value.charAt(0)){var a=this._m(this.a.value);a&&this.s.dialCode!==a||(this.a.value="")}}},{key:"_m",value:function(a){return a.replace(/\D/g,"")}},{key:"_m2",value:function(a){var b=document.createEvent("Event");b.initEvent(a,!0,!0),this.a.dispatchEvent(b)}},{key:"_n",value:function(){this.m.classList.remove("iti__hide"),this.selectedFlag.setAttribute("aria-expanded","true"),this._o(),this.b&&(this._x(this.b,!1),this._3(this.b,!0)),this._p(),this.u.classList.add("iti__arrow--up"),this._m2("open:countrydropdown")}},{key:"_n2",value:function(a,b,c){c&&!a.classList.contains(b)?a.classList.add(b):!c&&a.classList.contains(b)&&a.classList.remove(b)}},{key:"_o",value:function(){var a=this;if(this.d.dropdownContainer&&this.d.dropdownContainer.appendChild(this.dropdown),!this.g){var b=this.a.getBoundingClientRect(),c=window.pageYOffset||document.documentElement.scrollTop,d=b.top+c,e=this.m.offsetHeight,f=d+this.a.offsetHeight+e<c+window.innerHeight,g=d-e>c;if(this._n2(this.m,"iti__country-list--dropup",!f&&g),this.d.dropdownContainer){var h=!f&&g?0:this.a.offsetHeight;this.dropdown.style.top="".concat(d+h,"px"),this.dropdown.style.left="".concat(b.left+document.body.scrollLeft,"px"),this._a4=function(){return a._2()},window.addEventListener("scroll",this._a4)}}}},{key:"_o2",value:function(a){for(var b=a;b&&b!==this.m&&!b.classList.contains("iti__country");)b=b.parentNode;return b===this.m?null:b}},{key:"_p",value:function(){var a=this;this._a0=function(b){var c=a._o2(b.target);c&&a._x(c,!1)},this.m.addEventListener("mouseover",this._a0),this._a1=function(b){var c=a._o2(b.target);c&&a._1(c)},this.m.addEventListener("click",this._a1);var b=!0;this._a2=function(){b||a._2(),b=!1},document.documentElement.addEventListener("click",this._a2);var c="",d=null;this._a3=function(b){b.preventDefault(),"ArrowUp"===b.key||"Up"===b.key||"ArrowDown"===b.key||"Down"===b.key?a._q(b.key):"Enter"===b.key?a._r():"Escape"===b.key?a._2():/^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(b.key)&&(d&&clearTimeout(d),c+=b.key.toLowerCase(),a._s(c),d=setTimeout(function(){c=""},1e3))},document.addEventListener("keydown",this._a3)}},{key:"_q",value:function(a){var b="ArrowUp"===a||"Up"===a?this.c.previousElementSibling:this.c.nextElementSibling;b&&(b.classList.contains("iti__divider")&&(b="ArrowUp"===a||"Up"===a?b.previousElementSibling:b.nextElementSibling),this._x(b,!0))}},{key:"_r",value:function(){this.c&&this._1(this.c)}},{key:"_s",value:function(a){for(var b=0;b<this.p.length;b++)if(this._t(this.p[b].name,a)){var c=this.m.querySelector("#iti-".concat(this.id,"__item-").concat(this.p[b].iso2));this._x(c,!1),this._3(c,!0);break}}},{key:"_t",value:function(a,b){return a.substr(0,b.length).toLowerCase()===b}},{key:"_u",value:function(a){var b=a;if(this.d.formatOnDisplay&&window.intlTelInputUtils&&this.s){var c=!this.d.separateDialCode&&(this.d.nationalMode||"+"!==b.charAt(0)),d=intlTelInputUtils.numberFormat,e=d.NATIONAL,f=d.INTERNATIONAL,g=c?e:f;b=intlTelInputUtils.formatNumber(b,this.s.iso2,g)}b=this._7(b),this.a.value=b}},{key:"_v",value:function(a){var b=a,c=this.s.dialCode,d="1"===c;b&&this.d.nationalMode&&d&&"+"!==b.charAt(0)&&("1"!==b.charAt(0)&&(b="1".concat(b)),b="+".concat(b)),this.d.separateDialCode&&c&&"+"!==b.charAt(0)&&(b="+".concat(c).concat(b));var e=this._5(b,!0),f=this._m(b),g=null;if(e){var h=this.q[this._m(e)],i=-1!==h.indexOf(this.s.iso2)&&f.length<=e.length-1;if(!("1"===c&&this._w(f))&&!i)for(var j=0;j<h.length;j++)if(h[j]){g=h[j];break}}else"+"===b.charAt(0)&&f.length?g="":b&&"+"!==b||(g=this.j);return null!==g&&this._z(g)}},{key:"_w",value:function(a){var b=this._m(a);if("1"===b.charAt(0)){var c=b.substr(1,3);return-1!==k.indexOf(c)}return!1}},{key:"_x",value:function(a,b){var c=this.c;c&&c.classList.remove("iti__highlight"),this.c=a,this.c.classList.add("iti__highlight"),b&&this.c.focus()}},{key:"_y",value:function(a,b,c){for(var d=b?e:this.p,f=0;f<d.length;f++)if(d[f].iso2===a)return d[f];if(c)return null;throw new Error("No country data for '".concat(a,"'"))}},{key:"_z",value:function(a){var b=this.s.iso2?this.s:{};this.s=a?this._y(a,!1,!1):{},this.s.iso2&&(this.j=this.s.iso2),this.l.setAttribute("class","iti__flag iti__".concat(a));var c=a?"".concat(this.s.name,": +").concat(this.s.dialCode):"Unknown";if(this.selectedFlag.setAttribute("title",c),this.d.separateDialCode){var d=this.s.dialCode?"+".concat(this.s.dialCode):"";this.t.innerHTML=d;var e=this.selectedFlag.offsetWidth||this._z2();this.a.style.paddingLeft="".concat(e+6,"px")}if(this._0(),this.d.allowDropdown){var f=this.b;if(f&&(f.classList.remove("iti__active"),f.setAttribute("aria-selected","false")),a){var g=this.m.querySelector("#iti-".concat(this.id,"__item-").concat(a,"-preferred"))||this.m.querySelector("#iti-".concat(this.id,"__item-").concat(a));g.setAttribute("aria-selected","true"),g.classList.add("iti__active"),this.b=g,this.selectedFlag.setAttribute("aria-activedescendant",g.getAttribute("id"))}}return b.iso2!==a}},{key:"_z2",value:function(){var a=this.a.parentNode.cloneNode();a.style.visibility="hidden",document.body.appendChild(a);var b=this.k.cloneNode();a.appendChild(b);var c=this.selectedFlag.cloneNode(!0);b.appendChild(c);var d=c.offsetWidth;return a.parentNode.removeChild(a),d}},{key:"_0",value:function(){var a="aggressive"===this.d.autoPlaceholder||!this.e&&"polite"===this.d.autoPlaceholder;if(window.intlTelInputUtils&&a){var b=intlTelInputUtils.numberType[this.d.placeholderNumberType],c=this.s.iso2?intlTelInputUtils.getExampleNumber(this.s.iso2,this.d.nationalMode,b):"";c=this._7(c),"function"==typeof this.d.customPlaceholder&&(c=this.d.customPlaceholder(c,this.s)),this.a.setAttribute("placeholder",c)}}},{key:"_1",value:function(a){var b=this._z(a.getAttribute("data-country-code"));this._2(),this._4(a.getAttribute("data-dial-code"),!0),this.a.focus();var c=this.a.value.length;this.a.setSelectionRange(c,c),b&&this._m2CountryChange()}},{key:"_2",value:function(){this.m.classList.add("iti__hide"),this.selectedFlag.setAttribute("aria-expanded","false"),this.u.classList.remove("iti__arrow--up"),document.removeEventListener("keydown",this._a3),document.documentElement.removeEventListener("click",this._a2),this.m.removeEventListener("mouseover",this._a0),this.m.removeEventListener("click",this._a1),this.d.dropdownContainer&&(this.g||window.removeEventListener("scroll",this._a4),this.dropdown.parentNode&&this.dropdown.parentNode.removeChild(this.dropdown)),this._m2("close:countrydropdown")}},{key:"_3",value:function(a,b){var c=this.m,d=window.pageYOffset||document.documentElement.scrollTop,e=c.offsetHeight,f=c.getBoundingClientRect().top+d,g=f+e,h=a.offsetHeight,i=a.getBoundingClientRect().top+d,j=i+h,k=i-f+c.scrollTop,l=e/2-h/2;if(i<f)b&&(k-=l),c.scrollTop=k;else if(j>g){b&&(k+=l);var m=e-h;c.scrollTop=k-m}}},{key:"_4",value:function(a,b){var c,d=this.a.value,e="+".concat(a);if("+"===d.charAt(0)){var f=this._5(d);c=f?d.replace(f,e):e}else{if(this.d.nationalMode||this.d.separateDialCode)return;if(d)c=e+d;else{if(!b&&this.d.autoHideDialCode)return;c=e}}this.a.value=c}},{key:"_5",value:function(a,b){var c="";if("+"===a.charAt(0))for(var d="",e=0;e<a.length;e++){var f=a.charAt(e);if(!isNaN(parseInt(f,10))){if(d+=f,b)this.q[d]&&(c=a.substr(0,e+1));else if(this.dialCodes[d]){c=a.substr(0,e+1);break}if(d.length===this.countryCodeMaxLen)break}}return c}},{key:"_6",value:function(){var a=this.a.value.trim(),b=this.s.dialCode,c=this._m(a);return(this.d.separateDialCode&&"+"!==a.charAt(0)&&b&&c?"+".concat(b):"")+a}},{key:"_7",value:function(a){var b=a;if(this.d.separateDialCode){var c=this._5(b);if(c){c="+".concat(this.s.dialCode);var d=" "===b[c.length]||"-"===b[c.length]?c.length+1:c.length;b=b.substr(d)}}return this._j2(b)}},{key:"_m2CountryChange",value:function(){this._m2("countrychange")}},{key:"handleAutoCountry",value:function(){"auto"===this.d.initialCountry&&(this.j=window.intlTelInputGlobals.autoCountry,this.a.value||this.setCountry(this.j),this.h())}},{key:"handleUtils",value:function(){window.intlTelInputUtils&&(this.a.value&&this._u(this.a.value),this._0()),this.i0()}},{key:"destroy",value:function(){var a=this.a.form;if(this.d.allowDropdown){this._2(),this.selectedFlag.removeEventListener("click",this._a10),this.k.removeEventListener("keydown",this._a11);var b=this._i1();b&&b.removeEventListener("click",this._a9)}this.hiddenInput&&a&&a.removeEventListener("submit",this._a14),this.d.autoHideDialCode&&(a&&a.removeEventListener("submit",this._a8),this.a.removeEventListener("blur",this._a8)),this.a.removeEventListener("keyup",this._a12),this.a.removeEventListener("cut",this._a13),this.a.removeEventListener("paste",this._a13),this.a.removeAttribute("data-intl-tel-input-id");var c=this.a.parentNode;c.parentNode.insertBefore(this.a,c),c.parentNode.removeChild(c),delete window.intlTelInputGlobals.instances[this.id]}},{key:"getExtension",value:function(){return window.intlTelInputUtils?intlTelInputUtils.getExtension(this._6(),this.s.iso2):""}},{key:"getNumber",value:function(a){if(window.intlTelInputUtils){
var b=this.s.iso2;return intlTelInputUtils.formatNumber(this._6(),b,a)}return""}},{key:"getNumberType",value:function(){return window.intlTelInputUtils?intlTelInputUtils.getNumberType(this._6(),this.s.iso2):-99}},{key:"getSelectedCountryData",value:function(){return this.s}},{key:"getValidationError",value:function(){if(window.intlTelInputUtils){var a=this.s.iso2;return intlTelInputUtils.getValidationError(this._6(),a)}return-99}},{key:"isValidNumber",value:function(){var a=this._6().trim(),b=this.d.nationalMode?this.s.iso2:"";return window.intlTelInputUtils?intlTelInputUtils.isValidNumber(a,b):null}},{key:"setCountry",value:function(a){var b=a.toLowerCase();this.l.classList.contains("iti__".concat(b))||(this._z(b),this._4(this.s.dialCode,!1),this._m2CountryChange())}},{key:"setNumber",value:function(a){var b=this._v(a);this._u(a),b&&this._m2CountryChange()}},{key:"setPlaceholderNumberType",value:function(a){this.d.placeholderNumberType=a,this._0()}}]),c}();h.getCountryData=function(){return e};var o=function(a,b,c){var d=document.createElement("script");d.onload=function(){m("handleUtils"),b&&b()},d.onerror=function(){m("rejectUtilsScriptPromise"),c&&c()},d.className="iti-load-utils",d.async=!0,d.src=a,document.body.appendChild(d)};return h.loadUtils=function(a){if(!window.intlTelInputUtils&&!window.intlTelInputGlobals.startedLoadingUtilsScript){if(window.intlTelInputGlobals.startedLoadingUtilsScript=!0,"undefined"!=typeof Promise)return new Promise(function(b,c){return o(a,b,c)});o(a)}return null},h.defaults=j,h.version="17.0.19",function(a,b){var c=new n(a,b);return c._init(),a.setAttribute("data-intl-tel-input-id",c.id),window.intlTelInputGlobals.instances[c.id]=c,c}}()});
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
!function(a,b,c,d){"use strict";function e(a,b,c){return setTimeout(j(a,c),b)}function f(a,b,c){return Array.isArray(a)?(g(a,c[b],c),!0):!1}function g(a,b,c){var e;if(a)if(a.forEach)a.forEach(b,c);else if(a.length!==d)for(e=0;e<a.length;)b.call(c,a[e],e,a),e++;else for(e in a)a.hasOwnProperty(e)&&b.call(c,a[e],e,a)}function h(b,c,d){var e="DEPRECATED METHOD: "+c+"\n"+d+" AT \n";return function(){var c=new Error("get-stack-trace"),d=c&&c.stack?c.stack.replace(/^[^\(]+?[\n$]/gm,"").replace(/^\s+at\s+/gm,"").replace(/^Object.<anonymous>\s*\(/gm,"{anonymous}()@"):"Unknown Stack Trace",f=a.console&&(a.console.warn||a.console.log);return f&&f.call(a.console,e,d),b.apply(this,arguments)}}function i(a,b,c){var d,e=b.prototype;d=a.prototype=Object.create(e),d.constructor=a,d._super=e,c&&la(d,c)}function j(a,b){return function(){return a.apply(b,arguments)}}function k(a,b){return typeof a==oa?a.apply(b?b[0]||d:d,b):a}function l(a,b){return a===d?b:a}function m(a,b,c){g(q(b),function(b){a.addEventListener(b,c,!1)})}function n(a,b,c){g(q(b),function(b){a.removeEventListener(b,c,!1)})}function o(a,b){for(;a;){if(a==b)return!0;a=a.parentNode}return!1}function p(a,b){return a.indexOf(b)>-1}function q(a){return a.trim().split(/\s+/g)}function r(a,b,c){if(a.indexOf&&!c)return a.indexOf(b);for(var d=0;d<a.length;){if(c&&a[d][c]==b||!c&&a[d]===b)return d;d++}return-1}function s(a){return Array.prototype.slice.call(a,0)}function t(a,b,c){for(var d=[],e=[],f=0;f<a.length;){var g=b?a[f][b]:a[f];r(e,g)<0&&d.push(a[f]),e[f]=g,f++}return c&&(d=b?d.sort(function(a,c){return a[b]>c[b]}):d.sort()),d}function u(a,b){for(var c,e,f=b[0].toUpperCase()+b.slice(1),g=0;g<ma.length;){if(c=ma[g],e=c?c+f:b,e in a)return e;g++}return d}function v(){return ua++}function w(b){var c=b.ownerDocument||b;return c.defaultView||c.parentWindow||a}function x(a,b){var c=this;this.manager=a,this.callback=b,this.element=a.element,this.target=a.options.inputTarget,this.domHandler=function(b){k(a.options.enable,[a])&&c.handler(b)},this.init()}function y(a){var b,c=a.options.inputClass;return new(b=c?c:xa?M:ya?P:wa?R:L)(a,z)}function z(a,b,c){var d=c.pointers.length,e=c.changedPointers.length,f=b&Ea&&d-e===0,g=b&(Ga|Ha)&&d-e===0;c.isFirst=!!f,c.isFinal=!!g,f&&(a.session={}),c.eventType=b,A(a,c),a.emit("hammer.input",c),a.recognize(c),a.session.prevInput=c}function A(a,b){var c=a.session,d=b.pointers,e=d.length;c.firstInput||(c.firstInput=D(b)),e>1&&!c.firstMultiple?c.firstMultiple=D(b):1===e&&(c.firstMultiple=!1);var f=c.firstInput,g=c.firstMultiple,h=g?g.center:f.center,i=b.center=E(d);b.timeStamp=ra(),b.deltaTime=b.timeStamp-f.timeStamp,b.angle=I(h,i),b.distance=H(h,i),B(c,b),b.offsetDirection=G(b.deltaX,b.deltaY);var j=F(b.deltaTime,b.deltaX,b.deltaY);b.overallVelocityX=j.x,b.overallVelocityY=j.y,b.overallVelocity=qa(j.x)>qa(j.y)?j.x:j.y,b.scale=g?K(g.pointers,d):1,b.rotation=g?J(g.pointers,d):0,b.maxPointers=c.prevInput?b.pointers.length>c.prevInput.maxPointers?b.pointers.length:c.prevInput.maxPointers:b.pointers.length,C(c,b);var k=a.element;o(b.srcEvent.target,k)&&(k=b.srcEvent.target),b.target=k}function B(a,b){var c=b.center,d=a.offsetDelta||{},e=a.prevDelta||{},f=a.prevInput||{};b.eventType!==Ea&&f.eventType!==Ga||(e=a.prevDelta={x:f.deltaX||0,y:f.deltaY||0},d=a.offsetDelta={x:c.x,y:c.y}),b.deltaX=e.x+(c.x-d.x),b.deltaY=e.y+(c.y-d.y)}function C(a,b){var c,e,f,g,h=a.lastInterval||b,i=b.timeStamp-h.timeStamp;if(b.eventType!=Ha&&(i>Da||h.velocity===d)){var j=b.deltaX-h.deltaX,k=b.deltaY-h.deltaY,l=F(i,j,k);e=l.x,f=l.y,c=qa(l.x)>qa(l.y)?l.x:l.y,g=G(j,k),a.lastInterval=b}else c=h.velocity,e=h.velocityX,f=h.velocityY,g=h.direction;b.velocity=c,b.velocityX=e,b.velocityY=f,b.direction=g}function D(a){for(var b=[],c=0;c<a.pointers.length;)b[c]={clientX:pa(a.pointers[c].clientX),clientY:pa(a.pointers[c].clientY)},c++;return{timeStamp:ra(),pointers:b,center:E(b),deltaX:a.deltaX,deltaY:a.deltaY}}function E(a){var b=a.length;if(1===b)return{x:pa(a[0].clientX),y:pa(a[0].clientY)};for(var c=0,d=0,e=0;b>e;)c+=a[e].clientX,d+=a[e].clientY,e++;return{x:pa(c/b),y:pa(d/b)}}function F(a,b,c){return{x:b/a||0,y:c/a||0}}function G(a,b){return a===b?Ia:qa(a)>=qa(b)?0>a?Ja:Ka:0>b?La:Ma}function H(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return Math.sqrt(d*d+e*e)}function I(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return 180*Math.atan2(e,d)/Math.PI}function J(a,b){return I(b[1],b[0],Ra)+I(a[1],a[0],Ra)}function K(a,b){return H(b[0],b[1],Ra)/H(a[0],a[1],Ra)}function L(){this.evEl=Ta,this.evWin=Ua,this.pressed=!1,x.apply(this,arguments)}function M(){this.evEl=Xa,this.evWin=Ya,x.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function N(){this.evTarget=$a,this.evWin=_a,this.started=!1,x.apply(this,arguments)}function O(a,b){var c=s(a.touches),d=s(a.changedTouches);return b&(Ga|Ha)&&(c=t(c.concat(d),"identifier",!0)),[c,d]}function P(){this.evTarget=bb,this.targetIds={},x.apply(this,arguments)}function Q(a,b){var c=s(a.touches),d=this.targetIds;if(b&(Ea|Fa)&&1===c.length)return d[c[0].identifier]=!0,[c,c];var e,f,g=s(a.changedTouches),h=[],i=this.target;if(f=c.filter(function(a){return o(a.target,i)}),b===Ea)for(e=0;e<f.length;)d[f[e].identifier]=!0,e++;for(e=0;e<g.length;)d[g[e].identifier]&&h.push(g[e]),b&(Ga|Ha)&&delete d[g[e].identifier],e++;return h.length?[t(f.concat(h),"identifier",!0),h]:void 0}function R(){x.apply(this,arguments);var a=j(this.handler,this);this.touch=new P(this.manager,a),this.mouse=new L(this.manager,a),this.primaryTouch=null,this.lastTouches=[]}function S(a,b){a&Ea?(this.primaryTouch=b.changedPointers[0].identifier,T.call(this,b)):a&(Ga|Ha)&&T.call(this,b)}function T(a){var b=a.changedPointers[0];if(b.identifier===this.primaryTouch){var c={x:b.clientX,y:b.clientY};this.lastTouches.push(c);var d=this.lastTouches,e=function(){var a=d.indexOf(c);a>-1&&d.splice(a,1)};setTimeout(e,cb)}}function U(a){for(var b=a.srcEvent.clientX,c=a.srcEvent.clientY,d=0;d<this.lastTouches.length;d++){var e=this.lastTouches[d],f=Math.abs(b-e.x),g=Math.abs(c-e.y);if(db>=f&&db>=g)return!0}return!1}function V(a,b){this.manager=a,this.set(b)}function W(a){if(p(a,jb))return jb;var b=p(a,kb),c=p(a,lb);return b&&c?jb:b||c?b?kb:lb:p(a,ib)?ib:hb}function X(){if(!fb)return!1;var b={},c=a.CSS&&a.CSS.supports;return["auto","manipulation","pan-y","pan-x","pan-x pan-y","none"].forEach(function(d){b[d]=c?a.CSS.supports("touch-action",d):!0}),b}function Y(a){this.options=la({},this.defaults,a||{}),this.id=v(),this.manager=null,this.options.enable=l(this.options.enable,!0),this.state=nb,this.simultaneous={},this.requireFail=[]}function Z(a){return a&sb?"cancel":a&qb?"end":a&pb?"move":a&ob?"start":""}function $(a){return a==Ma?"down":a==La?"up":a==Ja?"left":a==Ka?"right":""}function _(a,b){var c=b.manager;return c?c.get(a):a}function aa(){Y.apply(this,arguments)}function ba(){aa.apply(this,arguments),this.pX=null,this.pY=null}function ca(){aa.apply(this,arguments)}function da(){Y.apply(this,arguments),this._timer=null,this._input=null}function ea(){aa.apply(this,arguments)}function fa(){aa.apply(this,arguments)}function ga(){Y.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function ha(a,b){return b=b||{},b.recognizers=l(b.recognizers,ha.defaults.preset),new ia(a,b)}function ia(a,b){this.options=la({},ha.defaults,b||{}),this.options.inputTarget=this.options.inputTarget||a,this.handlers={},this.session={},this.recognizers=[],this.oldCssProps={},this.element=a,this.input=y(this),this.touchAction=new V(this,this.options.touchAction),ja(this,!0),g(this.options.recognizers,function(a){var b=this.add(new a[0](a[1]));a[2]&&b.recognizeWith(a[2]),a[3]&&b.requireFailure(a[3])},this)}function ja(a,b){var c=a.element;if(c.style){var d;g(a.options.cssProps,function(e,f){d=u(c.style,f),b?(a.oldCssProps[d]=c.style[d],c.style[d]=e):c.style[d]=a.oldCssProps[d]||""}),b||(a.oldCssProps={})}}function ka(a,c){var d=b.createEvent("Event");d.initEvent(a,!0,!0),d.gesture=c,c.target.dispatchEvent(d)}var la,ma=["","webkit","Moz","MS","ms","o"],na=b.createElement("div"),oa="function",pa=Math.round,qa=Math.abs,ra=Date.now;la="function"!=typeof Object.assign?function(a){if(a===d||null===a)throw new TypeError("Cannot convert undefined or null to object");for(var b=Object(a),c=1;c<arguments.length;c++){var e=arguments[c];if(e!==d&&null!==e)for(var f in e)e.hasOwnProperty(f)&&(b[f]=e[f])}return b}:Object.assign;var sa=h(function(a,b,c){for(var e=Object.keys(b),f=0;f<e.length;)(!c||c&&a[e[f]]===d)&&(a[e[f]]=b[e[f]]),f++;return a},"extend","Use `assign`."),ta=h(function(a,b){return sa(a,b,!0)},"merge","Use `assign`."),ua=1,va=/mobile|tablet|ip(ad|hone|od)|android/i,wa="ontouchstart"in a,xa=u(a,"PointerEvent")!==d,ya=wa&&va.test(navigator.userAgent),za="touch",Aa="pen",Ba="mouse",Ca="kinect",Da=25,Ea=1,Fa=2,Ga=4,Ha=8,Ia=1,Ja=2,Ka=4,La=8,Ma=16,Na=Ja|Ka,Oa=La|Ma,Pa=Na|Oa,Qa=["x","y"],Ra=["clientX","clientY"];x.prototype={handler:function(){},init:function(){this.evEl&&m(this.element,this.evEl,this.domHandler),this.evTarget&&m(this.target,this.evTarget,this.domHandler),this.evWin&&m(w(this.element),this.evWin,this.domHandler)},destroy:function(){this.evEl&&n(this.element,this.evEl,this.domHandler),this.evTarget&&n(this.target,this.evTarget,this.domHandler),this.evWin&&n(w(this.element),this.evWin,this.domHandler)}};var Sa={mousedown:Ea,mousemove:Fa,mouseup:Ga},Ta="mousedown",Ua="mousemove mouseup";i(L,x,{handler:function(a){var b=Sa[a.type];b&Ea&&0===a.button&&(this.pressed=!0),b&Fa&&1!==a.which&&(b=Ga),this.pressed&&(b&Ga&&(this.pressed=!1),this.callback(this.manager,b,{pointers:[a],changedPointers:[a],pointerType:Ba,srcEvent:a}))}});var Va={pointerdown:Ea,pointermove:Fa,pointerup:Ga,pointercancel:Ha,pointerout:Ha},Wa={2:za,3:Aa,4:Ba,5:Ca},Xa="pointerdown",Ya="pointermove pointerup pointercancel";a.MSPointerEvent&&!a.PointerEvent&&(Xa="MSPointerDown",Ya="MSPointerMove MSPointerUp MSPointerCancel"),i(M,x,{handler:function(a){var b=this.store,c=!1,d=a.type.toLowerCase().replace("ms",""),e=Va[d],f=Wa[a.pointerType]||a.pointerType,g=f==za,h=r(b,a.pointerId,"pointerId");e&Ea&&(0===a.button||g)?0>h&&(b.push(a),h=b.length-1):e&(Ga|Ha)&&(c=!0),0>h||(b[h]=a,this.callback(this.manager,e,{pointers:b,changedPointers:[a],pointerType:f,srcEvent:a}),c&&b.splice(h,1))}});var Za={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},$a="touchstart",_a="touchstart touchmove touchend touchcancel";i(N,x,{handler:function(a){var b=Za[a.type];if(b===Ea&&(this.started=!0),this.started){var c=O.call(this,a,b);b&(Ga|Ha)&&c[0].length-c[1].length===0&&(this.started=!1),this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}}});var ab={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},bb="touchstart touchmove touchend touchcancel";i(P,x,{handler:function(a){var b=ab[a.type],c=Q.call(this,a,b);c&&this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}});var cb=2500,db=25;i(R,x,{handler:function(a,b,c){var d=c.pointerType==za,e=c.pointerType==Ba;if(!(e&&c.sourceCapabilities&&c.sourceCapabilities.firesTouchEvents)){if(d)S.call(this,b,c);else if(e&&U.call(this,c))return;this.callback(a,b,c)}},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var eb=u(na.style,"touchAction"),fb=eb!==d,gb="compute",hb="auto",ib="manipulation",jb="none",kb="pan-x",lb="pan-y",mb=X();V.prototype={set:function(a){a==gb&&(a=this.compute()),fb&&this.manager.element.style&&mb[a]&&(this.manager.element.style[eb]=a),this.actions=a.toLowerCase().trim()},update:function(){this.set(this.manager.options.touchAction)},compute:function(){var a=[];return g(this.manager.recognizers,function(b){k(b.options.enable,[b])&&(a=a.concat(b.getTouchAction()))}),W(a.join(" "))},preventDefaults:function(a){var b=a.srcEvent,c=a.offsetDirection;if(this.manager.session.prevented)return void b.preventDefault();var d=this.actions,e=p(d,jb)&&!mb[jb],f=p(d,lb)&&!mb[lb],g=p(d,kb)&&!mb[kb];if(e){var h=1===a.pointers.length,i=a.distance<2,j=a.deltaTime<250;if(h&&i&&j)return}return g&&f?void 0:e||f&&c&Na||g&&c&Oa?this.preventSrc(b):void 0},preventSrc:function(a){this.manager.session.prevented=!0,a.preventDefault()}};var nb=1,ob=2,pb=4,qb=8,rb=qb,sb=16,tb=32;Y.prototype={defaults:{},set:function(a){return la(this.options,a),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function(a){if(f(a,"recognizeWith",this))return this;var b=this.simultaneous;return a=_(a,this),b[a.id]||(b[a.id]=a,a.recognizeWith(this)),this},dropRecognizeWith:function(a){return f(a,"dropRecognizeWith",this)?this:(a=_(a,this),delete this.simultaneous[a.id],this)},requireFailure:function(a){if(f(a,"requireFailure",this))return this;var b=this.requireFail;return a=_(a,this),-1===r(b,a)&&(b.push(a),a.requireFailure(this)),this},dropRequireFailure:function(a){if(f(a,"dropRequireFailure",this))return this;a=_(a,this);var b=r(this.requireFail,a);return b>-1&&this.requireFail.splice(b,1),this},hasRequireFailures:function(){return this.requireFail.length>0},canRecognizeWith:function(a){return!!this.simultaneous[a.id]},emit:function(a){function b(b){c.manager.emit(b,a)}var c=this,d=this.state;qb>d&&b(c.options.event+Z(d)),b(c.options.event),a.additionalEvent&&b(a.additionalEvent),d>=qb&&b(c.options.event+Z(d))},tryEmit:function(a){return this.canEmit()?this.emit(a):void(this.state=tb)},canEmit:function(){for(var a=0;a<this.requireFail.length;){if(!(this.requireFail[a].state&(tb|nb)))return!1;a++}return!0},recognize:function(a){var b=la({},a);return k(this.options.enable,[this,b])?(this.state&(rb|sb|tb)&&(this.state=nb),this.state=this.process(b),void(this.state&(ob|pb|qb|sb)&&this.tryEmit(b))):(this.reset(),void(this.state=tb))},process:function(a){},getTouchAction:function(){},reset:function(){}},i(aa,Y,{defaults:{pointers:1},attrTest:function(a){var b=this.options.pointers;return 0===b||a.pointers.length===b},process:function(a){var b=this.state,c=a.eventType,d=b&(ob|pb),e=this.attrTest(a);return d&&(c&Ha||!e)?b|sb:d||e?c&Ga?b|qb:b&ob?b|pb:ob:tb}}),i(ba,aa,{defaults:{event:"pan",threshold:10,pointers:1,direction:Pa},getTouchAction:function(){var a=this.options.direction,b=[];return a&Na&&b.push(lb),a&Oa&&b.push(kb),b},directionTest:function(a){var b=this.options,c=!0,d=a.distance,e=a.direction,f=a.deltaX,g=a.deltaY;return e&b.direction||(b.direction&Na?(e=0===f?Ia:0>f?Ja:Ka,c=f!=this.pX,d=Math.abs(a.deltaX)):(e=0===g?Ia:0>g?La:Ma,c=g!=this.pY,d=Math.abs(a.deltaY))),a.direction=e,c&&d>b.threshold&&e&b.direction},attrTest:function(a){return aa.prototype.attrTest.call(this,a)&&(this.state&ob||!(this.state&ob)&&this.directionTest(a))},emit:function(a){this.pX=a.deltaX,this.pY=a.deltaY;var b=$(a.direction);b&&(a.additionalEvent=this.options.event+b),this._super.emit.call(this,a)}}),i(ca,aa,{defaults:{event:"pinch",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.scale-1)>this.options.threshold||this.state&ob)},emit:function(a){if(1!==a.scale){var b=a.scale<1?"in":"out";a.additionalEvent=this.options.event+b}this._super.emit.call(this,a)}}),i(da,Y,{defaults:{event:"press",pointers:1,time:251,threshold:9},getTouchAction:function(){return[hb]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime>b.time;if(this._input=a,!d||!c||a.eventType&(Ga|Ha)&&!f)this.reset();else if(a.eventType&Ea)this.reset(),this._timer=e(function(){this.state=rb,this.tryEmit()},b.time,this);else if(a.eventType&Ga)return rb;return tb},reset:function(){clearTimeout(this._timer)},emit:function(a){this.state===rb&&(a&&a.eventType&Ga?this.manager.emit(this.options.event+"up",a):(this._input.timeStamp=ra(),this.manager.emit(this.options.event,this._input)))}}),i(ea,aa,{defaults:{event:"rotate",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.rotation)>this.options.threshold||this.state&ob)}}),i(fa,aa,{defaults:{event:"swipe",threshold:10,velocity:.3,direction:Na|Oa,pointers:1},getTouchAction:function(){return ba.prototype.getTouchAction.call(this)},attrTest:function(a){var b,c=this.options.direction;return c&(Na|Oa)?b=a.overallVelocity:c&Na?b=a.overallVelocityX:c&Oa&&(b=a.overallVelocityY),this._super.attrTest.call(this,a)&&c&a.offsetDirection&&a.distance>this.options.threshold&&a.maxPointers==this.options.pointers&&qa(b)>this.options.velocity&&a.eventType&Ga},emit:function(a){var b=$(a.offsetDirection);b&&this.manager.emit(this.options.event+b,a),this.manager.emit(this.options.event,a)}}),i(ga,Y,{defaults:{event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:9,posThreshold:10},getTouchAction:function(){return[ib]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime<b.time;if(this.reset(),a.eventType&Ea&&0===this.count)return this.failTimeout();if(d&&f&&c){if(a.eventType!=Ga)return this.failTimeout();var g=this.pTime?a.timeStamp-this.pTime<b.interval:!0,h=!this.pCenter||H(this.pCenter,a.center)<b.posThreshold;this.pTime=a.timeStamp,this.pCenter=a.center,h&&g?this.count+=1:this.count=1,this._input=a;var i=this.count%b.taps;if(0===i)return this.hasRequireFailures()?(this._timer=e(function(){this.state=rb,this.tryEmit()},b.interval,this),ob):rb}return tb},failTimeout:function(){return this._timer=e(function(){this.state=tb},this.options.interval,this),tb},reset:function(){clearTimeout(this._timer)},emit:function(){this.state==rb&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),ha.VERSION="2.0.7",ha.defaults={domEvents:!1,touchAction:gb,enable:!0,inputTarget:null,inputClass:null,preset:[[ea,{enable:!1}],[ca,{enable:!1},["rotate"]],[fa,{direction:Na}],[ba,{direction:Na},["swipe"]],[ga],[ga,{event:"doubletap",taps:2},["tap"]],[da]],cssProps:{userSelect:"none",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}};var ub=1,vb=2;ia.prototype={set:function(a){return la(this.options,a),a.touchAction&&this.touchAction.update(),a.inputTarget&&(this.input.destroy(),this.input.target=a.inputTarget,this.input.init()),this},stop:function(a){this.session.stopped=a?vb:ub},recognize:function(a){var b=this.session;if(!b.stopped){this.touchAction.preventDefaults(a);var c,d=this.recognizers,e=b.curRecognizer;(!e||e&&e.state&rb)&&(e=b.curRecognizer=null);for(var f=0;f<d.length;)c=d[f],b.stopped===vb||e&&c!=e&&!c.canRecognizeWith(e)?c.reset():c.recognize(a),!e&&c.state&(ob|pb|qb)&&(e=b.curRecognizer=c),f++}},get:function(a){if(a instanceof Y)return a;for(var b=this.recognizers,c=0;c<b.length;c++)if(b[c].options.event==a)return b[c];return null},add:function(a){if(f(a,"add",this))return this;var b=this.get(a.options.event);return b&&this.remove(b),this.recognizers.push(a),a.manager=this,this.touchAction.update(),a},remove:function(a){if(f(a,"remove",this))return this;if(a=this.get(a)){var b=this.recognizers,c=r(b,a);-1!==c&&(b.splice(c,1),this.touchAction.update())}return this},on:function(a,b){if(a!==d&&b!==d){var c=this.handlers;return g(q(a),function(a){c[a]=c[a]||[],c[a].push(b)}),this}},off:function(a,b){if(a!==d){var c=this.handlers;return g(q(a),function(a){b?c[a]&&c[a].splice(r(c[a],b),1):delete c[a]}),this}},emit:function(a,b){this.options.domEvents&&ka(a,b);var c=this.handlers[a]&&this.handlers[a].slice();if(c&&c.length){b.type=a,b.preventDefault=function(){b.srcEvent.preventDefault()};for(var d=0;d<c.length;)c[d](b),d++}},destroy:function(){this.element&&ja(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},la(ha,{INPUT_START:Ea,INPUT_MOVE:Fa,INPUT_END:Ga,INPUT_CANCEL:Ha,STATE_POSSIBLE:nb,STATE_BEGAN:ob,STATE_CHANGED:pb,STATE_ENDED:qb,STATE_RECOGNIZED:rb,STATE_CANCELLED:sb,STATE_FAILED:tb,DIRECTION_NONE:Ia,DIRECTION_LEFT:Ja,DIRECTION_RIGHT:Ka,DIRECTION_UP:La,DIRECTION_DOWN:Ma,DIRECTION_HORIZONTAL:Na,DIRECTION_VERTICAL:Oa,DIRECTION_ALL:Pa,Manager:ia,Input:x,TouchAction:V,TouchInput:P,MouseInput:L,PointerEventInput:M,TouchMouseInput:R,SingleTouchInput:N,Recognizer:Y,AttrRecognizer:aa,Tap:ga,Pan:ba,Swipe:fa,Pinch:ca,Rotate:ea,Press:da,on:m,off:n,each:g,merge:ta,extend:sa,assign:la,inherit:i,bindFn:j,prefixed:u});var wb="undefined"!=typeof a?a:"undefined"!=typeof self?self:{};wb.Hammer=ha,"function"==typeof define&&define.amd?define(function(){return ha}):"undefined"!=typeof module&&module.exports?module.exports=ha:a[c]=ha}(window,document,"Hammer");
//# sourceMappingURL=hammer.min.js.map
/*! dicom-parser - 1.8.12 - 2023-02-20 | (c) 2017 Chris Hafey | https://github.com/cornerstonejs/dicomParser */
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t(require("zlib")):"function"==typeof define&&define.amd?define("dicom-parser",["zlib"],t):"object"==typeof exports?exports["dicom-parser"]=t(require("zlib")):e.dicomParser=t(e.zlib)}(this,function(r){return a=[function(e,t){e.exports=r},function(e,t,s){"use strict";s.r(t),s.d(t,"isStringVr",function(){return d}),s.d(t,"isPrivateTag",function(){return f}),s.d(t,"parsePN",function(){return a}),s.d(t,"parseTM",function(){return n}),s.d(t,"parseDA",function(){return o}),s.d(t,"explicitElementToString",function(){return l}),s.d(t,"explicitDataSetToJS",function(){return u}),s.d(t,"createJPEGBasicOffsetTable",function(){return p}),s.d(t,"parseDicomDataSetExplicit",function(){return q}),s.d(t,"parseDicomDataSetImplicit",function(){return T}),s.d(t,"readFixedString",function(){return b}),s.d(t,"alloc",function(){return k}),s.d(t,"version",function(){return L}),s.d(t,"bigEndianByteArrayParser",function(){return N}),s.d(t,"ByteStream",function(){return J}),s.d(t,"sharedCopy",function(){return j}),s.d(t,"DataSet",function(){return w}),s.d(t,"findAndSetUNElementLength",function(){return y}),s.d(t,"findEndOfEncapsulatedElement",function(){return g}),s.d(t,"findItemDelimitationItemAndSetElementLength",function(){return x}),s.d(t,"littleEndianByteArrayParser",function(){return M}),s.d(t,"parseDicom",function(){return V}),s.d(t,"readDicomElementExplicit",function(){return B}),s.d(t,"readDicomElementImplicit",function(){return A}),s.d(t,"readEncapsulatedImageFrame",function(){return W}),s.d(t,"readEncapsulatedPixelData",function(){return K}),s.d(t,"readEncapsulatedPixelDataFromFragments",function(){return _}),s.d(t,"readPart10Header",function(){return G}),s.d(t,"readSequenceItemsExplicit",function(){return I}),s.d(t,"readSequenceItemsImplicit",function(){return F}),s.d(t,"readSequenceItem",function(){return S}),s.d(t,"readTag",function(){return h});var r={AE:!0,AS:!0,AT:!1,CS:!0,DA:!0,DS:!0,DT:!0,FL:!1,FD:!1,IS:!0,LO:!0,LT:!0,OB:!1,OD:!1,OF:!1,OW:!1,PN:!0,SH:!0,SL:!1,SQ:!1,SS:!1,ST:!0,TM:!0,UI:!0,UL:!1,UN:void 0,UR:!0,US:!1,UT:!0},d=function(e){return r[e]},f=function(e){e=parseInt(e[4],16);if(isNaN(e))throw"dicomParser.isPrivateTag: cannot parse last character of group";return e%2==1},a=function(e){if(void 0!==e){e=e.split("^");return{familyName:e[0],givenName:e[1],middleName:e[2],prefix:e[3],suffix:e[4]}}};function n(e,t){if(2<=e.length){var r=parseInt(e.substring(0,2),10),a=4<=e.length?parseInt(e.substring(2,4),10):void 0,n=6<=e.length?parseInt(e.substring(4,6),10):void 0,i=8<=e.length?e.substring(7,13):void 0,i=i?parseInt(i,10)*Math.pow(10,6-i.length):void 0;if(t&&(isNaN(r)||void 0!==a&&isNaN(a)||void 0!==n&&isNaN(n)||void 0!==i&&isNaN(i)||r<0||23<r||a&&(a<0||59<a)||n&&(n<0||59<n)||i&&(i<0||999999<i)))throw"invalid TM '".concat(e,"'");return{hours:r,minutes:a,seconds:n,fractionalSeconds:i}}if(t)throw"invalid TM '".concat(e,"'")}function i(e,t,r){return!isNaN(r)&&(0<t&&t<=12&&0<e&&e<=function(e,t){switch(e){case 2:return t%4==0&&t%100||t%400==0?29:28;case 9:case 4:case 6:case 11:return 30;default:return 31}}(t,r))}function o(e,t){if(e&&8===e.length){var r=parseInt(e.substring(0,4),10),a=parseInt(e.substring(4,6),10),n=parseInt(e.substring(6,8),10);if(t&&!0!==i(n,a,r))throw"invalid DA '".concat(e,"'");return{year:r,month:a,day:n}}if(t)throw"invalid DA '".concat(e,"'")}function l(n,e){if(void 0===n||void 0===e)throw"dicomParser.explicitElementToString: missing required parameters";if(void 0===e.vr)throw"dicomParser.explicitElementToString: cannot convert implicit element to string";var t,r=e.vr,i=e.tag;function a(e,t){for(var r="",a=0;a<e;a++)0!==a&&(r+="/"),r+=t.call(n,i,a).toString();return r}if(!0===d(r))t=n.string(i);else{if("AT"===r){var o=n.uint32(i);return void 0===o?void 0:"x".concat((o=o<0?4294967295+o+1:o).toString(16).toUpperCase())}"US"===r?t=a(e.length/2,n.uint16):"SS"===r?t=a(e.length/2,n.int16):"UL"===r?t=a(e.length/4,n.uint32):"SL"===r?t=a(e.length/4,n.int32):"FD"===r?t=a(e.length/8,n.double):"FL"===r&&(t=a(e.length/4,n.float))}return t}function u(e,t){if(void 0===e)throw"dicomParser.explicitDataSetToJS: missing required parameter dataSet";t=t||{omitPrivateAttibutes:!0,maxElementLength:128};var r,a={};for(r in e.elements){var n=e.elements[r];if(!0!==t.omitPrivateAttibutes||!f(r))if(n.items){for(var i=[],o=0;o<n.items.length;o++)i.push(u(n.items[o].dataSet,t));a[r]=i}else{var s=void 0;n.length<t.maxElementLength&&(s=l(e,n)),a[r]=void 0!==s?s:{dataOffset:n.dataOffset,length:n.length}}}return a}function c(e,t){return 255===e.byteArray[t]&&217===e.byteArray[t+1]}function m(e,t,r){for(var a,n,i=r;i<t.fragments.length;i++)if(a=e,n=i,n=t.fragments[n],!(!c(a,n.position+n.length-2)&&!c(a,n.position+n.length-3)))return i}function p(e,t,r){if(void 0===e)throw"dicomParser.createJPEGBasicOffsetTable: missing required parameter dataSet";if(void 0===t)throw"dicomParser.createJPEGBasicOffsetTable: missing required parameter pixelDataElement";if("x7fe00010"!==t.tag)throw"dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to non pixel data tag (expected tag = x7fe00010'";if(!0!==t.encapsulatedPixelData)throw"dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";if(!0!==t.hadUndefinedLength)throw"dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";if(void 0===t.basicOffsetTable)throw"dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";if(void 0===t.fragments)throw"dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";if(t.fragments.length<=0)throw"dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";if(r&&r.length<=0)throw"dicomParser.createJPEGBasicOffsetTable: parameter 'fragments' must not be zero length";r=r||t.fragments;for(var a=[],n=0;;){a.push(t.fragments[n].offset);var i=m(e,t,n);if(void 0===i||i===t.fragments.length-1)return a;n=i+1}}function h(e){if(void 0===e)throw"dicomParser.readTag: missing required parameter 'byteStream'";var t=256*e.readUint16()*256,e=e.readUint16();return"x".concat("00000000".concat((t+e).toString(16)).substr(-8))}function g(e,t,r){if(void 0===e)throw"dicomParser.findEndOfEncapsulatedElement: missing required parameter 'byteStream'";if(void 0===t)throw"dicomParser.findEndOfEncapsulatedElement: missing required parameter 'element'";if(t.encapsulatedPixelData=!0,t.basicOffsetTable=[],t.fragments=[],"xfffee000"!==h(e))throw"dicomParser.findEndOfEncapsulatedElement: basic offset table not found";for(var a=e.readUint32()/4,n=0;n<a;n++){var i=e.readUint32();t.basicOffsetTable.push(i)}for(var o=e.position;e.position<e.byteArray.length;){var s=h(e),d=e.readUint32();if("xfffee0dd"===s)return e.seek(d),void(t.length=e.position-t.dataOffset);if("xfffee000"!==s)return r&&r.push("unexpected tag ".concat(s," while searching for end of pixel data element with undefined length")),d>e.byteArray.length-e.position&&(d=e.byteArray.length-e.position),t.fragments.push({offset:e.position-o-8,position:e.position,length:d}),e.seek(d),void(t.length=e.position-t.dataOffset);t.fragments.push({offset:e.position-o-8,position:e.position,length:d}),e.seek(d)}r&&r.push("pixel data element ".concat(t.tag," missing sequence delimiter tag xfffee0dd"))}function y(e,t){if(void 0===e)throw"dicomParser.findAndSetUNElementLength: missing required parameter 'byteStream'";for(var r=e.byteArray.length-8;e.position<=r;)if(65534===e.readUint16()){var a=e.readUint16();if(57565===a)return 0!==e.readUint32()&&e.warnings("encountered non zero length following item delimiter at position ".concat(e.position-4," while reading element of undefined length with tag ").concat(t.tag)),void(t.length=e.position-t.dataOffset)}t.length=e.byteArray.length-t.dataOffset,e.seek(e.byteArray.length-e.position)}function b(e,t,r){if(r<0)throw"dicomParser.readFixedString - length cannot be less than 0";if(t+r>e.length)throw"dicomParser.readFixedString: attempt to read past end of buffer";for(var a,n="",i=0;i<r;i++){if(0===(a=e[t+i]))return t+=r,n;n+=String.fromCharCode(a)}return n}function v(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function P(e,t){return void 0!==e.parser?e.parser:t}var w=function(){function a(e,t,r){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,a),this.byteArrayParser=e,this.byteArray=t,this.elements=r}var e,t,r;return e=a,(t=[{key:"uint16",value:function(e,t){e=this.elements[e];if(t=void 0!==t?t:0,e&&0!==e.length)return P(e,this.byteArrayParser).readUint16(this.byteArray,e.dataOffset+2*t)}},{key:"int16",value:function(e,t){e=this.elements[e];if(t=void 0!==t?t:0,e&&0!==e.length)return P(e,this.byteArrayParser).readInt16(this.byteArray,e.dataOffset+2*t)}},{key:"uint32",value:function(e,t){e=this.elements[e];if(t=void 0!==t?t:0,e&&0!==e.length)return P(e,this.byteArrayParser).readUint32(this.byteArray,e.dataOffset+4*t)}},{key:"int32",value:function(e,t){e=this.elements[e];if(t=void 0!==t?t:0,e&&0!==e.length)return P(e,this.byteArrayParser).readInt32(this.byteArray,e.dataOffset+4*t)}},{key:"float",value:function(e,t){e=this.elements[e];if(t=void 0!==t?t:0,e&&0!==e.length)return P(e,this.byteArrayParser).readFloat(this.byteArray,e.dataOffset+4*t)}},{key:"double",value:function(e,t){e=this.elements[e];if(t=void 0!==t?t:0,e&&0!==e.length)return P(e,this.byteArrayParser).readDouble(this.byteArray,e.dataOffset+8*t)}},{key:"numStringValues",value:function(e){e=this.elements[e];if(e&&0<e.length){e=b(this.byteArray,e.dataOffset,e.length).match(/\\/g);return null===e?1:e.length+1}}},{key:"string",value:function(e,t){e=this.elements[e];if(e&&e.Value)return e.Value;if(e&&0<e.length){e=b(this.byteArray,e.dataOffset,e.length);return 0<=t?e.split("\\")[t].trim():e.trim()}}},{key:"text",value:function(e,t){e=this.elements[e];if(e&&0<e.length){e=b(this.byteArray,e.dataOffset,e.length);return 0<=t?e.split("\\")[t].replace(/ +$/,""):e.replace(/ +$/,"")}}},{key:"floatString",value:function(e,t){var r=this.elements[e];if(r&&0<r.length){t=this.string(e,t=void 0!==t?t:0);if(void 0!==t)return parseFloat(t)}}},{key:"intString",value:function(e,t){var r=this.elements[e];if(r&&0<r.length){t=this.string(e,t=void 0!==t?t:0);if(void 0!==t)return parseInt(t)}}},{key:"attributeTag",value:function(e){var t=this.elements[e];if(t&&4===t.length){var r=P(t,this.byteArrayParser).readUint16,e=this.byteArray,t=t.dataOffset;return"x".concat("00000000".concat((256*r(e,t)*256+r(e,t+2)).toString(16)).substr(-8))}}}])&&v(e.prototype,t),r&&v(e,r),Object.defineProperty(e,"prototype",{writable:!1}),a}();function x(e,t){if(void 0===e)throw"dicomParser.readDicomElementImplicit: missing required parameter 'byteStream'";for(var r=e.byteArray.length-8;e.position<=r;)if(65534===e.readUint16()){var a=e.readUint16();if(57357===a)return 0!==e.readUint32()&&e.warnings("encountered non zero length following item delimiter at position ".concat(e.position-4," while reading element of undefined length with tag ").concat(t.tag)),void(t.length=e.position-t.dataOffset)}t.length=e.byteArray.length-t.dataOffset,e.seek(e.byteArray.length-e.position)}var E=function(e,t){if(void 0!==e.vr)return"SQ"===e.vr;if(t.position+4<=t.byteArray.length){e=h(t);return t.seek(-4),"xfffee000"===e||"xfffee0dd"===e}return t.warnings.push("eof encountered before finding sequence item tag or sequence delimiter tag in peeking to determine VR"),!1};function A(e,t,r){if(void 0===e)throw"dicomParser.readDicomElementImplicit: missing required parameter 'byteStream'";var a=h(e),a={tag:a,vr:void 0!==r?r(a):void 0,length:e.readUint32(),dataOffset:e.position};return 4294967295===a.length&&(a.hadUndefinedLength=!0),a.tag===t||(!E(a,e)||f(a.tag)&&!a.hadUndefinedLength?a.hadUndefinedLength?x(e,a):e.seek(a.length):(F(e,a,r),f(a.tag)&&(a.items=void 0))),a}function S(e){if(void 0===e)throw"dicomParser.readSequenceItem: missing required parameter 'byteStream'";var t={tag:h(e),length:e.readUint32(),dataOffset:e.position};if("xfffee000"!==t.tag)throw"dicomParser.readSequenceItem: item tag (FFFE,E000) not found at offset ".concat(e.position);return t}function D(e,t){var r=S(e);return 4294967295===r.length?(r.hadUndefinedLength=!0,r.dataSet=function(e,t){for(var r={};e.position<e.byteArray.length;){var a=A(e,void 0,t);if("xfffee00d"===(r[a.tag]=a).tag)return new w(e.byteArrayParser,e.byteArray,r)}return e.warnings.push("eof encountered before finding sequence item delimiter in sequence item of undefined length"),new w(e.byteArrayParser,e.byteArray,r)}(e,t),r.length=e.position-r.dataOffset):(r.dataSet=new w(e.byteArrayParser,e.byteArray,{}),T(r.dataSet,e,e.position+r.length,{vrCallback:t})),r}function F(e,t,r){if(void 0===e)throw"dicomParser.readSequenceItemsImplicit: missing required parameter 'byteStream'";if(void 0===t)throw"dicomParser.readSequenceItemsImplicit: missing required parameter 'element'";t.items=[],(4294967295===t.length?function(e,t,r){for(;e.position+4<=e.byteArray.length;){var a=h(e);if(e.seek(-4),"xfffee0dd"===a)return t.length=e.position-t.dataOffset,e.seek(8);a=D(e,r);t.items.push(a)}e.warnings.push("eof encountered before finding sequence delimiter in sequence of undefined length"),t.length=e.byteArray.length-t.dataOffset}:function(e,t,r){for(var a=t.dataOffset+t.length;e.position<a;){var n=D(e,r);t.items.push(n)}})(e,t,r)}function O(e,t){var r=S(e);return 4294967295===r.length?(r.hadUndefinedLength=!0,r.dataSet=function(e,t){for(var r={};e.position<e.byteArray.length;){var a=B(e,t);if("xfffee00d"===(r[a.tag]=a).tag)return new w(e.byteArrayParser,e.byteArray,r)}return t.push("eof encountered before finding item delimiter tag while reading sequence item of undefined length"),new w(e.byteArrayParser,e.byteArray,r)}(e,t),r.length=e.position-r.dataOffset):(r.dataSet=new w(e.byteArrayParser,e.byteArray,{}),q(r.dataSet,e,e.position+r.length)),r}function I(e,t,r){if(void 0===e)throw"dicomParser.readSequenceItemsExplicit: missing required parameter 'byteStream'";if(void 0===t)throw"dicomParser.readSequenceItemsExplicit: missing required parameter 'element'";t.items=[],(4294967295===t.length?function(e,t,r){for(;e.position+4<=e.byteArray.length;){var a=h(e);if(e.seek(-4),"xfffee0dd"===a)return t.length=e.position-t.dataOffset,e.seek(8);a=O(e,r);t.items.push(a)}r.push("eof encountered before finding sequence delimitation tag while reading sequence of undefined length"),t.length=e.position-t.dataOffset}:function(e,t,r){for(var a=t.dataOffset+t.length;e.position<a;){var n=O(e,r);t.items.push(n)}})(e,t,r)}var U=function(e){return"OB"===e||"OD"===e||"OL"===e||"OW"===e||"SQ"===e||"OF"===e||"UC"===e||"UR"===e||"UT"===e||"UN"===e?4:2};function B(e,t,r){if(void 0===e)throw"dicomParser.readDicomElementExplicit: missing required parameter 'byteStream'";var a={tag:h(e),vr:e.readFixedString(2)};return 2===U(a.vr)?a.length=e.readUint16():(e.seek(2),a.length=e.readUint32()),a.dataOffset=e.position,4294967295===a.length&&(a.hadUndefinedLength=!0),a.tag===r||("SQ"===a.vr?I(e,a,t):4294967295===a.length?"x7fe00010"===a.tag?g(e,a,t):("UN"===a.vr?F:x)(e,a):e.seek(a.length)),a}function q(e,t,r){var a=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{};if(r=void 0===r?t.byteArray.length:r,void 0===t)throw"dicomParser.parseDicomDataSetExplicit: missing required parameter 'byteStream'";if(r<t.position||r>t.byteArray.length)throw"dicomParser.parseDicomDataSetExplicit: invalid value for parameter 'maxP osition'";for(var n=e.elements;t.position<r;){var i=B(t,e.warnings,a.untilTag);if((n[i.tag]=i).tag===a.untilTag)return}if(t.position>r)throw"dicomParser:parseDicomDataSetExplicit: buffer overrun"}function T(e,t,r){var a=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{};if(r=void 0===r?e.byteArray.length:r,void 0===t)throw"dicomParser.parseDicomDataSetImplicit: missing required parameter 'byteStream'";if(r<t.position||r>t.byteArray.length)throw"dicomParser.parseDicomDataSetImplicit: invalid value for parameter 'maxPosition'";for(var n=e.elements;t.position<r;){var i=A(t,a.untilTag,a.vrCallback);if((n[i.tag]=i).tag===a.untilTag)return}}function k(e,t){if("undefined"!=typeof Buffer&&e instanceof Buffer)return Buffer.alloc(t);if(e instanceof Uint8Array)return new Uint8Array(t);throw"dicomParser.alloc: unknown type for byteArray"}var L="1.8.12",N={readUint16:function(e,t){if(t<0)throw"bigEndianByteArrayParser.readUint16: position cannot be less than 0";if(t+2>e.length)throw"bigEndianByteArrayParser.readUint16: attempt to read past end of buffer";return(e[t]<<8)+e[t+1]},readInt16:function(e,t){if(t<0)throw"bigEndianByteArrayParser.readInt16: position cannot be less than 0";if(t+2>e.length)throw"bigEndianByteArrayParser.readInt16: attempt to read past end of buffer";t=(e[t]<<8)+e[t+1];return t=32768&t?t-65535-1:t},readUint32:function(e,t){if(t<0)throw"bigEndianByteArrayParser.readUint32: position cannot be less than 0";if(t+4>e.length)throw"bigEndianByteArrayParser.readUint32: attempt to read past end of buffer";return 256*(256*(256*e[t]+e[t+1])+e[t+2])+e[t+3]},readInt32:function(e,t){if(t<0)throw"bigEndianByteArrayParser.readInt32: position cannot be less than 0";if(t+4>e.length)throw"bigEndianByteArrayParser.readInt32: attempt to read past end of buffer";return(e[t]<<24)+(e[t+1]<<16)+(e[t+2]<<8)+e[t+3]},readFloat:function(e,t){if(t<0)throw"bigEndianByteArrayParser.readFloat: position cannot be less than 0";if(t+4>e.length)throw"bigEndianByteArrayParser.readFloat: attempt to read past end of buffer";var r=new Uint8Array(4);return r[3]=e[t],r[2]=e[t+1],r[1]=e[t+2],r[0]=e[t+3],new Float32Array(r.buffer)[0]},readDouble:function(e,t){if(t<0)throw"bigEndianByteArrayParser.readDouble: position cannot be less than 0";if(t+8>e.length)throw"bigEndianByteArrayParser.readDouble: attempt to read past end of buffer";var r=new Uint8Array(8);return r[7]=e[t],r[6]=e[t+1],r[5]=e[t+2],r[4]=e[t+3],r[3]=e[t+4],r[2]=e[t+5],r[1]=e[t+6],r[0]=e[t+7],new Float64Array(r.buffer)[0]}};function j(e,t,r){if("undefined"!=typeof Buffer&&e instanceof Buffer)return e.slice(t,t+r);if(e instanceof Uint8Array)return new Uint8Array(e.buffer,e.byteOffset+t,r);throw"dicomParser.from: unknown type for byteArray"}function C(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}var J=function(){function a(e,t,r){if(!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,a),void 0===e)throw"dicomParser.ByteStream: missing required parameter 'byteArrayParser'";if(void 0===t)throw"dicomParser.ByteStream: missing required parameter 'byteArray'";if(t instanceof Uint8Array==!1&&("undefined"==typeof Buffer||t instanceof Buffer==!1))throw"dicomParser.ByteStream: parameter byteArray is not of type Uint8Array or Buffer";if(r<0)throw"dicomParser.ByteStream: parameter 'position' cannot be less than 0";if(r>=t.length)throw"dicomParser.ByteStream: parameter 'position' cannot be greater than or equal to 'byteArray' length";this.byteArrayParser=e,this.byteArray=t,this.position=r||0,this.warnings=[]}var e,t,r;return e=a,(t=[{key:"seek",value:function(e){if(this.position+e<0)throw"dicomParser.ByteStream.prototype.seek: cannot seek to position < 0";this.position+=e}},{key:"readByteStream",value:function(e){if(this.position+e>this.byteArray.length)throw"dicomParser.ByteStream.prototype.readByteStream: readByteStream - buffer overread";var t=j(this.byteArray,this.position,e);return this.position+=e,new a(this.byteArrayParser,t)}},{key:"getSize",value:function(){return this.byteArray.length}},{key:"readUint16",value:function(){var e=this.byteArrayParser.readUint16(this.byteArray,this.position);return this.position+=2,e}},{key:"readUint32",value:function(){var e=this.byteArrayParser.readUint32(this.byteArray,this.position);return this.position+=4,e}},{key:"readFixedString",value:function(e){var t=b(this.byteArray,this.position,e);return this.position+=e,t}}])&&C(e.prototype,t),r&&C(e,r),Object.defineProperty(e,"prototype",{writable:!1}),a}(),M={readUint16:function(e,t){if(t<0)throw"littleEndianByteArrayParser.readUint16: position cannot be less than 0";if(t+2>e.length)throw"littleEndianByteArrayParser.readUint16: attempt to read past end of buffer";return e[t]+256*e[t+1]},readInt16:function(e,t){if(t<0)throw"littleEndianByteArrayParser.readInt16: position cannot be less than 0";if(t+2>e.length)throw"littleEndianByteArrayParser.readInt16: attempt to read past end of buffer";t=e[t]+(e[t+1]<<8);return t=32768&t?t-65535-1:t},readUint32:function(e,t){if(t<0)throw"littleEndianByteArrayParser.readUint32: position cannot be less than 0";if(t+4>e.length)throw"littleEndianByteArrayParser.readUint32: attempt to read past end of buffer";return e[t]+256*e[t+1]+256*e[t+2]*256+256*e[t+3]*256*256},readInt32:function(e,t){if(t<0)throw"littleEndianByteArrayParser.readInt32: position cannot be less than 0";if(t+4>e.length)throw"littleEndianByteArrayParser.readInt32: attempt to read past end of buffer";return e[t]+(e[t+1]<<8)+(e[t+2]<<16)+(e[t+3]<<24)},readFloat:function(e,t){if(t<0)throw"littleEndianByteArrayParser.readFloat: position cannot be less than 0";if(t+4>e.length)throw"littleEndianByteArrayParser.readFloat: attempt to read past end of buffer";var r=new Uint8Array(4);return r[0]=e[t],r[1]=e[t+1],r[2]=e[t+2],r[3]=e[t+3],new Float32Array(r.buffer)[0]},readDouble:function(e,t){if(t<0)throw"littleEndianByteArrayParser.readDouble: position cannot be less than 0";if(t+8>e.length)throw"littleEndianByteArrayParser.readDouble: attempt to read past end of buffer";var r=new Uint8Array(8);return r[0]=e[t],r[1]=e[t+1],r[2]=e[t+2],r[3]=e[t+3],r[4]=e[t+4],r[5]=e[t+5],r[6]=e[t+6],r[7]=e[t+7],new Float64Array(r.buffer)[0]}};function G(e){var i=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};if(void 0===e)throw"dicomParser.readPart10Header: missing required parameter 'byteArray'";var o=i.TransferSyntaxUID,s=new J(M,e);return function(){var e=function(){if(s.getSize()<=132&&o)return!1;if(s.seek(128),"DICM"===s.readFixedString(4))return!0;if(!(i||{}).TransferSyntaxUID)throw"dicomParser.readPart10Header: DICM prefix not found at location 132 - this is not a valid DICOM P10 file.";return s.seek(0),!1}(),t=[],r={};if(!e)return s.position=0,{elements:{x00020010:{tag:"x00020010",vr:"UI",Value:o}},warnings:t};for(;s.position<s.byteArray.length;){var a=s.position,n=B(s,t);if("x0002ffff"<n.tag){s.position=a;break}n.parser=M,r[n.tag]=n}return(e=new w(s.byteArrayParser,s.byteArray,r)).warnings=s.warnings,e.position=s.position,e}()}var z="1.2.840.10008.1.2.2";function V(i){var o=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};if(void 0===i)throw new Error("dicomParser.parseDicom: missing required parameter 'byteArray'");var e,a=function(e){if(void 0===e.elements.x00020010)throw new Error("dicomParser.parseDicom: missing required meta header attribute 0002,0010");e=e.elements.x00020010;return e&&e.Value||b(i,e.dataOffset,e.length)};function t(t){var e=a(t),r="1.2.840.10008.1.2"!==e,e=function(e,t){var r="[object process]"===Object.prototype.toString.call("undefined"!=typeof process?process:0);if("1.2.840.10008.1.2.1.99"!==e)return new J(e===z?N:M,i,t);if(o&&o.inflater){e=o.inflater(i,t);return new J(M,e,0)}if(!0==r){var a=s(0),n=j(i,t,i.length-t),a=a.inflateRawSync(n),n=k(i,a.length+t);return i.copy(n,0,0,t),a.copy(n,t),new J(M,n,0)}if("undefined"==typeof pako)throw"dicomParser.parseDicom: no inflater available to handle deflate transfer syntax";return a=i.slice(t),n=pako.inflateRaw(a),(a=k(i,n.length+t)).set(i.slice(0,t),0),a.set(n,t),new J(M,a,0)}(e,t.position),t=new w(e.byteArrayParser,e.byteArray,{});t.warnings=e.warnings;try{(r?q:T)(t,e,e.byteArray.length,o)}catch(e){throw{exception:e,dataSet:t}}return t}return function(e,t){for(var r in e.elements)e.elements.hasOwnProperty(r)&&(t.elements[r]=e.elements[r]);return void 0!==e.warnings&&(t.warnings=e.warnings.concat(t.warnings)),t}(e=G(i,o),t(e))}var R=function(e,t,r){for(var a=0,n=t;n<t+r;n++)a+=e[n].length;return a};function _(e,t,r,a,n){if(n=n||t.fragments,void 0===e)throw"dicomParser.readEncapsulatedPixelDataFromFragments: missing required parameter 'dataSet'";if(void 0===t)throw"dicomParser.readEncapsulatedPixelDataFromFragments: missing required parameter 'pixelDataElement'";if(void 0===r)throw"dicomParser.readEncapsulatedPixelDataFromFragments: missing required parameter 'startFragmentIndex'";if(void 0===(a=a||1))throw"dicomParser.readEncapsulatedPixelDataFromFragments: missing required parameter 'numFragments'";if("x7fe00010"!==t.tag)throw"dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to non pixel data tag (expected tag = x7fe00010";if(!0!==t.encapsulatedPixelData)throw"dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";if(!0!==t.hadUndefinedLength)throw"dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";if(void 0===t.basicOffsetTable)throw"dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";if(void 0===t.fragments)throw"dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";if(t.fragments.length<=0)throw"dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";if(r<0)throw"dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'startFragmentIndex' must be >= 0";if(r>=t.fragments.length)throw"dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'startFragmentIndex' must be < number of fragments";if(a<1)throw"dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'numFragments' must be > 0";if(r+a>t.fragments.length)throw"dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'startFragment' + 'numFragments' < number of fragments";var i=new J(e.byteArrayParser,e.byteArray,t.dataOffset),t=S(i);if("xfffee000"!==t.tag)throw"dicomParser.readEncapsulatedPixelData: missing basic offset table xfffee000";i.seek(t.length);var o=i.position;if(1===a)return j(i.byteArray,o+n[r].offset+8,n[r].length);for(var t=R(n,r,a),s=k(i.byteArray,t),d=0,f=r;f<r+a;f++)for(var l=o+n[f].offset+8,u=0;u<n[f].length;u++)s[d++]=i.byteArray[l++];return s}var H=function(e,t){for(var r=0;r<e.length;r++)if(e[r].offset===t)return r},Q=function(e,t,r,a){if(e===t.length-1)return r.length-a;for(var n=t[e+1],i=a+1;i<r.length;i++)if(r[i].offset===n)return i-a;throw"dicomParser.calculateNumberOfFragmentsForFrame: could not find fragment with offset matching basic offset table"};function W(e,t,r,a,n){if(a=a||t.basicOffsetTable,n=n||t.fragments,void 0===e)throw"dicomParser.readEncapsulatedImageFrame: missing required parameter 'dataSet'";if(void 0===t)throw"dicomParser.readEncapsulatedImageFrame: missing required parameter 'pixelDataElement'";if(void 0===r)throw"dicomParser.readEncapsulatedImageFrame: missing required parameter 'frameIndex'";if(void 0===a)throw"dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' does not have basicOffsetTable";if("x7fe00010"!==t.tag)throw"dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' refers to non pixel data tag (expected tag = x7fe00010)";if(!0!==t.encapsulatedPixelData)throw"dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";if(!0!==t.hadUndefinedLength)throw"dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' refers to pixel data element that does not have undefined length";if(void 0===t.fragments)throw"dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' refers to pixel data element that does not have fragments";if(0===a.length)throw"dicomParser.readEncapsulatedImageFrame: basicOffsetTable has zero entries";if(r<0)throw"dicomParser.readEncapsulatedImageFrame: parameter 'frameIndex' must be >= 0";if(r>=a.length)throw"dicomParser.readEncapsulatedImageFrame: parameter 'frameIndex' must be < basicOffsetTable.length";var i=a[r],i=H(n,i);if(void 0===i)throw"dicomParser.readEncapsulatedImageFrame: unable to find fragment that matches basic offset table entry";return _(e,t,i,Q(r,a,n,i),n)}var $=!1;function K(e,t,r){if($||($=!0,console&&console.log&&console.log("WARNING: dicomParser.readEncapsulatedPixelData() has been deprecated")),void 0===e)throw"dicomParser.readEncapsulatedPixelData: missing required parameter 'dataSet'";if(void 0===t)throw"dicomParser.readEncapsulatedPixelData: missing required parameter 'element'";if(void 0===r)throw"dicomParser.readEncapsulatedPixelData: missing required parameter 'frame'";if("x7fe00010"!==t.tag)throw"dicomParser.readEncapsulatedPixelData: parameter 'element' refers to non pixel data tag (expected tag = x7fe00010)";if(!0!==t.encapsulatedPixelData)throw"dicomParser.readEncapsulatedPixelData: parameter 'element' refers to pixel data element that does not have encapsulated pixel data";if(!0!==t.hadUndefinedLength)throw"dicomParser.readEncapsulatedPixelData: parameter 'element' refers to pixel data element that does not have encapsulated pixel data";if(void 0===t.basicOffsetTable)throw"dicomParser.readEncapsulatedPixelData: parameter 'element' refers to pixel data element that does not have encapsulated pixel data";if(void 0===t.fragments)throw"dicomParser.readEncapsulatedPixelData: parameter 'element' refers to pixel data element that does not have encapsulated pixel data";if(r<0)throw"dicomParser.readEncapsulatedPixelData: parameter 'frame' must be >= 0";return 0!==t.basicOffsetTable.length?W(e,t,r):_(e,t,0,t.fragments.length)}t.default={isStringVr:d,isPrivateTag:f,parsePN:a,parseTM:n,parseDA:o,explicitElementToString:l,explicitDataSetToJS:u,createJPEGBasicOffsetTable:p,parseDicomDataSetExplicit:q,parseDicomDataSetImplicit:T,readFixedString:b,alloc:k,version:L,bigEndianByteArrayParser:N,ByteStream:J,sharedCopy:j,DataSet:w,findAndSetUNElementLength:y,findEndOfEncapsulatedElement:g,findItemDelimitationItemAndSetElementLength:x,littleEndianByteArrayParser:M,parseDicom:V,readDicomElementExplicit:B,readDicomElementImplicit:A,readEncapsulatedImageFrame:W,readEncapsulatedPixelData:K,readEncapsulatedPixelDataFromFragments:_,readPart10Header:G,readSequenceItemsExplicit:I,readSequenceItemsImplicit:F,readSequenceItem:S,readTag:h,LEI:"1.2.840.10008.1.2",LEE:"1.2.840.10008.1.2.1"}}],i={},n.m=a,n.c=i,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var a in t)n.d(r,a,function(e){return t[e]}.bind(null,a));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=1);function n(e){if(i[e])return i[e].exports;var t=i[e]={i:e,l:!1,exports:{}};return a[e].call(t.exports,t,t.exports,n),t.l=!0,t.exports}var a,i});
//# sourceMappingURL=dicomParser.min.js.map
/*! cornerstone-core - 2.6.1 - 2021-11-19 | (c) 2016 Chris Hafey | https://github.com/cornerstonejs/cornerstone */
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define("cornerstone-core",[],t):"object"==typeof exports?exports["cornerstone-core"]=t():e.cornerstone=t()}(window,function(){return function(r){var n={};function a(e){if(n[e])return n[e].exports;var t=n[e]={i:e,l:!1,exports:{}};return r[e].call(t.exports,t,t.exports,a),t.l=!0,t.exports}return a.m=r,a.c=n,a.d=function(e,t,r){a.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},a.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},a.t=function(t,e){if(1&e&&(t=a(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(a.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var n in t)a.d(r,n,function(e){return t[e]}.bind(null,n));return r},a.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return a.d(t,"a",t),t},a.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},a.p="",a(a.s=0)}([function(e,t,r){"use strict";function a(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}r.r(t);var T={NEW_IMAGE:"cornerstonenewimage",INVALIDATED:"cornerstoneinvalidated",PRE_RENDER:"cornerstoneprerender",IMAGE_CACHE_MAXIMUM_SIZE_CHANGED:"cornerstoneimagecachemaximumsizechanged",IMAGE_CACHE_PROMISE_REMOVED:"cornerstoneimagecachepromiseremoved",IMAGE_CACHE_FULL:"cornerstoneimagecachefull",IMAGE_CACHE_CHANGED:"cornerstoneimagecachechanged",WEBGL_TEXTURE_REMOVED:"cornerstonewebgltextureremoved",WEBGL_TEXTURE_CACHE_FULL:"cornerstonewebgltexturecachefull",IMAGE_LOADED:"cornerstoneimageloaded",IMAGE_LOAD_PROGRESS:"cornerstoneimageloadprogress",IMAGE_LOAD_FAILED:"cornerstoneimageloadfailed",ELEMENT_RESIZED:"cornerstoneelementresized",IMAGE_RENDERED:"cornerstoneimagerendered",LAYER_ADDED:"cornerstonelayeradded",LAYER_REMOVED:"cornerstonelayerremoved",ACTIVE_LAYER_CHANGED:"cornerstoneactivelayerchanged",ELEMENT_DISABLED:"cornerstoneelementdisabled",ELEMENT_ENABLED:"cornerstoneelementenabled"},o=new(function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.listeners={},this.namespaces={}}var t,r,n;return t=e,(r=[{key:"addEventNamespaceListener",value:function(e,t){e.indexOf(".")<=0||(this.namespaces[e]=t,this.addEventListener(e.split(".")[0],t))}},{key:"removeEventNamespaceListener",value:function(e){e.indexOf(".")<=0||!this.namespaces[e]||(this.removeEventListener(e.split(".")[0],this.namespaces[e]),delete this.namespaces[e])}},{key:"addEventListener",value:function(e,t){0<e.indexOf(".")?this.addEventNamespaceListener(e,t):(e in this.listeners||(this.listeners[e]=[]),this.listeners[e].push(t))}},{key:"removeEventListener",value:function(e,t){if(0<e.indexOf("."))this.removeEventNamespaceListener(e);else if(e in this.listeners)for(var r=this.listeners[e],n=0,a=r.length;n<a;n++)if(r[n]===t)return void r.splice(n,1)}},{key:"dispatchEvent",value:function(e){if(!(e.type in this.listeners))return!0;for(var t=this.listeners[e.type].slice(),r=0,n=t.length;r<n;r++)t[r].call(this,e);return!e.defaultPrevented}}])&&a(t.prototype,r),n&&a(t,n),e}()),n=[];function C(e){if(void 0===e)throw new Error("getEnabledElement: parameter element must not be undefined");for(var t=0;t<n.length;t++)if(n[t].element===e)return n[t];throw new Error("element not enabled")}function i(e){if(void 0===e)throw new Error("getEnabledElement: enabledElement element must not be undefined");n.push(e)}function l(t){var r=[];return n.forEach(function(e){e.image&&e.image.imageId===t&&r.push(e)}),r}function s(){return n}function u(){return Math.floor(65536*(1+Math.random())).toString(16).substring(1)}var d={viewport:{}},m=function(e){d.viewport=e||{}};function c(e,t){if(null==e)throw new Error(t)}var L=function(e){var t,r=1<arguments.length&&void 0!==arguments[1]?arguments[1]:null;return c(e,"getImageSize: parameter image must not be undefined"),c(e.width,"getImageSize: parameter image must have width"),c(e.height,"getImageSize: parameter image must have height"),null!=(t=r)&&0!==t&&180!==t?{height:e.width,width:e.height}:{width:e.width,height:e.height}},f=function(e,t){var r=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;c(e,"getImageScale: parameter windowSize must not be undefined"),c(t,"getImageScale: parameter image must not be undefined");var n=L(t,r),a=t.rowPixelSpacing||1,i=t.columnPixelSpacing||1,o=1,l=1;a<i?l=i/a:o=a/i;var s=e.height/n.height/o,u=e.width/n.width/l;return{verticalScale:s,horizontalScale:u,scaleFactor:Math.min(u,s)}},g=function(e,t){if(void 0===e)throw new Error("getDefaultViewport: parameter canvas must not be undefined");return void 0===t?(r={scale:1,translation:{x:0,y:0},voi:{windowWidth:void 0,windowCenter:void 0},invert:!1,pixelReplication:!1,rotation:0,hflip:!1,vflip:!1,modalityLUT:void 0,voiLUT:void 0,colormap:void 0,labelmap:!1,displayedArea:void 0},Object.assign({},r,d.viewport)):{scale:f(e,t,0).scaleFactor,translation:{x:0,y:0},voi:{windowWidth:t.windowWidth,windowCenter:t.windowCenter},invert:t.invert,pixelReplication:!1,rotation:0,hflip:!1,vflip:!1,modalityLUT:t.modalityLUT,voiLUT:t.voiLUT,colormap:t.colormap,labelmap:Boolean(t.labelmap),displayedArea:void 0};var r},v=function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:null;if(t&&t.displayedArea)return t.displayedArea;if(void 0===e)throw new Error("getDisplayedArea: parameter image must not be undefined");return{tlhc:{x:1,y:1},brhc:{x:e.columns,y:e.rows},rowPixelSpacing:void 0===e.rowPixelSpacing?1:e.rowPixelSpacing,columnPixelSpacing:void 0===e.columnPixelSpacing?1:e.columnPixelSpacing,presentationSizeMode:"NONE"}},h=function(e){var t=1<arguments.length&&void 0!==arguments[1]&&arguments[1];e.needsRedraw=!0,t&&(e.invalid=!0)},P=function(e){var t=1<arguments.length&&void 0!==arguments[1]&&arguments[1],r=C(e);h(r,t)};function R(e,t){var r,n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;return"function"==typeof window.CustomEvent?r=new CustomEvent(t,{detail:n,cancelable:!0}):(r=document.createEvent("CustomEvent")).initCustomEvent(t,!0,!0,n),e.dispatchEvent(r)}function p(e,t,r){R(t.element,e,{viewport:t.viewport,element:t.element,image:t.image,enabledElement:t,layerId:r})}function w(e,t){if(e.layerId===t.layerId)throw new Error("rescaleImage: both arguments represent the same layer");var r=e.image,n=t.image;if(r.imageId&&n.imageId){var a=v(n,t.viewport),i=v(r,e.viewport),o=a.columnPixelSpacing*n.width/(i.columnPixelSpacing*r.width),l=t.viewport.scale/e.viewport.scale*o;t.viewport.scale=e.viewport.scale*l}}function b(e,t,r){var n,a="".concat(u()+u(),"-").concat(u(),"-").concat(u(),"-").concat(u(),"-").concat(u()).concat(u()).concat(u()),i=C(e),o=i.layers;t&&(n=g(i.canvas,t),r&&r.viewport&&(n=Object.assign(n,r.viewport))),!1!==i.syncViewports&&(i.syncViewports=!0);var l={image:t,layerId:a,viewport:n,options:r||{},renderingTools:{}};return o.length&&t&&w(o[0],l),o.push(l),p(T.LAYER_ADDED,i,a),1===o.length&&t&&D(e,a),a}function y(e,t){var r=C(e),n=r.layers,a=r.layers.findIndex(function(e){return e.layerId===t});-1!==a&&(n.splice(a,1),t===r.activeLayerId&&n.length&&D(e,n[0].layerId),p(T.LAYER_REMOVED,r,t))}function x(e,t){return C(e).layers.find(function(e){return e.layerId===t})}function E(e){return C(e).layers}function I(e){return C(e).layers.filter(function(e){return e.options&&!1!==e.options.visible&&0!==e.options.opacity})}function D(e,t){var r=C(e);if(r.activeLayerId!==t){var n=r.layers.findIndex(function(e){return e.layerId===t});if(-1===n)throw new Error("setActiveLayer: layer not found in layers array");var a=r.layers[n];if(!a.image)throw new Error("setActiveLayer: layer with undefined image cannot be set as active.");r.activeLayerId=t,r.image=a.image,r.viewport=a.viewport,P(e),p(T.ACTIVE_LAYER_CHANGED,r,t)}}function S(e,t,r){var n,a=C(e),i=a.layers[0];if(!(n=r?x(e,r):A(e)))throw new Error("setLayerImage: Layer not found");if(n.image=t){if(!n.viewport){var o=g(a.canvas,t);n.options&&n.options.viewport&&(n.viewport=Object.assign(o,n.options.viewport)),i.layerId!==r&&w(i,n)}}else n.viewport=void 0}function A(e){var t=C(e);return t.layers.find(function(e){return e.layerId===t.activeLayerId})}function _(e){var t=C(e);t.layers=[],delete t.activeLayerId,delete t.lastSyncViewportsState}function M(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function O(e,t,r){if(1<e)throw new Error("HSVToRGB expects hue < 1");var n=[];if(0===t)return n[0]=r,n[1]=r,n[2]=r,n;var a=Math.floor(6*e),i=6*e-a,o=r*(1-t),l=r*(1-t*i),s=r*(1-t*(1-i));switch(a){case 0:case 6:n[0]=r,n[1]=s,n[2]=o;break;case 1:n[0]=l,n[1]=r,n[2]=o;break;case 2:n[0]=o,n[1]=r,n[2]=s;break;case 3:n[0]=o,n[1]=l,n[2]=r;break;case 4:n[0]=s,n[1]=o,n[2]=r;break;case 5:n[0]=r,n[1]=o,n[2]=l}return n}var V=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.NumberOfColors=256,this.Ramp="linear",this.TableRange=[0,255],this.HueRange=[0,.66667],this.SaturationRange=[1,1],this.ValueRange=[1,1],this.AlphaRange=[1,1],this.NaNColor=[128,0,0,255],this.BelowRangeColor=[0,0,0,255],this.UseBelowRangeColor=!0,this.AboveRangeColor=[255,255,255,255],this.UseAboveRangeColor=!0,this.InputRange=[0,255],this.Table=[]}var t,r,n;return t=e,(r=[{key:"setNumberOfTableValues",value:function(e){this.NumberOfColors=e}},{key:"setRamp",value:function(e){this.Ramp=e}},{key:"setTableRange",value:function(e,t){this.TableRange[0]=e,this.TableRange[1]=t}},{key:"setHueRange",value:function(e,t){this.HueRange[0]=e,this.HueRange[1]=t}},{key:"setSaturationRange",value:function(e,t){this.SaturationRange[0]=e,this.SaturationRange[1]=t}},{key:"setValueRange",value:function(e,t){this.ValueRange[0]=e,this.ValueRange[1]=t}},{key:"setRange",value:function(e,t){this.InputRange[0]=e,this.InputRange[1]=t}},{key:"setAlphaRange",value:function(e,t){this.AlphaRange[0]=e,this.AlphaRange[1]=t}},{key:"getColor",value:function(e){return this.mapValue(e)}},{key:"build",value:function(e){if(!(1<this.Table.length)||e){this.Table=[];var t,r,n,a,i=this.NumberOfColors-1;i?(t=(this.HueRange[1]-this.HueRange[0])/i,r=(this.SaturationRange[1]-this.SaturationRange[0])/i,n=(this.ValueRange[1]-this.ValueRange[0])/i,a=(this.AlphaRange[1]-this.AlphaRange[0])/i):t=r=n=a=0;for(var o=0;o<=i;o++){var l=this.HueRange[0]+o*t,s=this.SaturationRange[0]+o*r,u=this.ValueRange[0]+o*n,d=this.AlphaRange[0]+o*a,m=O(l,s,u),c=[];switch(this.Ramp){case"scurve":c[0]=Math.floor(127.5*(1+Math.cos((1-m[0])*Math.PI))),c[1]=Math.floor(127.5*(1+Math.cos((1-m[1])*Math.PI))),c[2]=Math.floor(127.5*(1+Math.cos((1-m[2])*Math.PI))),c[3]=Math.floor(255*d);break;case"linear":c[0]=Math.floor(255*m[0]+.5),c[1]=Math.floor(255*m[1]+.5),c[2]=Math.floor(255*m[2]+.5),c[3]=Math.floor(255*d+.5);break;case"sqrt":c[0]=Math.floor(255*Math.sqrt(m[0])+.5),c[1]=Math.floor(255*Math.sqrt(m[1])+.5),c[2]=Math.floor(255*Math.sqrt(m[2])+.5),c[3]=Math.floor(255*Math.sqrt(d)+.5);break;default:throw new Error("Invalid Ramp value (".concat(this.Ramp,")"))}this.Table.push(c)}this.buildSpecialColors()}}},{key:"buildSpecialColors",value:function(){var e=this.NumberOfColors,t=e+0,r=e+1,n=e+2;this.UseBelowRangeColor||0===e?this.Table[t]=this.BelowRangeColor:this.Table[t]=this.Table[0],this.UseAboveRangeColor||0===e?this.Table[r]=this.AboveRangeColor:this.Table[r]=this.Table[e-1],this.Table[n]=this.NaNColor}},{key:"mapValue",value:function(e){var t=this.getIndex(e);if(t<0)return this.NaNColor;if(0===t){if(this.UseBelowRangeColor&&e<this.TableRange[0])return this.BelowRangeColor}else if(t===this.NumberOfColors-1&&this.UseAboveRangeColor&&e>this.TableRange[1])return this.AboveRangeColor;return this.Table[t]}},{key:"getIndex",value:function(e){var t={Range:[]};if(t.MaxIndex=this.NumberOfColors-1,t.Shift=-this.TableRange[0],this.TableRange[1]<=this.TableRange[0]?t.Scale=Number.MAX_VALUE:t.Scale=t.MaxIndex/(this.TableRange[1]-this.TableRange[0]),t.Range[0]=this.TableRange[0],t.Range[1]=this.TableRange[1],isNaN(e))return-1;var r,n,a,i=(a=(r=e)<(n=t).Range[0]?n.MaxIndex+0+1.5:r>n.Range[1]?n.MaxIndex+1+1.5:(r+n.Shift)*n.Scale,Math.floor(a));return i===this.NumberOfColors+0?i=0:i===this.NumberOfColors+1&&(i=this.NumberOfColors-1),i}},{key:"setTableValue",value:function(e,t){if(5===arguments.length&&(t=Array.prototype.slice.call(arguments,1)),e<0)throw new Error("Can't set the table value for negative index (".concat(e,")"));e>=this.NumberOfColors&&new Error("Index ".concat(e," is greater than the number of colors ").concat(this.NumberOfColors)),this.Table[e]=t,0!==e&&e!==this.NumberOfColors-1||this.buildSpecialColors()}}])&&M(t.prototype,r),n&&M(t,n),e}(),U=[0,0,0,0],N={hotIron:{name:"Hot Iron",numOfColors:256,colors:[[0,0,0,255],[2,0,0,255],[4,0,0,255],[6,0,0,255],[8,0,0,255],[10,0,0,255],[12,0,0,255],[14,0,0,255],[16,0,0,255],[18,0,0,255],[20,0,0,255],[22,0,0,255],[24,0,0,255],[26,0,0,255],[28,0,0,255],[30,0,0,255],[32,0,0,255],[34,0,0,255],[36,0,0,255],[38,0,0,255],[40,0,0,255],[42,0,0,255],[44,0,0,255],[46,0,0,255],[48,0,0,255],[50,0,0,255],[52,0,0,255],[54,0,0,255],[56,0,0,255],[58,0,0,255],[60,0,0,255],[62,0,0,255],[64,0,0,255],[66,0,0,255],[68,0,0,255],[70,0,0,255],[72,0,0,255],[74,0,0,255],[76,0,0,255],[78,0,0,255],[80,0,0,255],[82,0,0,255],[84,0,0,255],[86,0,0,255],[88,0,0,255],[90,0,0,255],[92,0,0,255],[94,0,0,255],[96,0,0,255],[98,0,0,255],[100,0,0,255],[102,0,0,255],[104,0,0,255],[106,0,0,255],[108,0,0,255],[110,0,0,255],[112,0,0,255],[114,0,0,255],[116,0,0,255],[118,0,0,255],[120,0,0,255],[122,0,0,255],[124,0,0,255],[126,0,0,255],[128,0,0,255],[130,0,0,255],[132,0,0,255],[134,0,0,255],[136,0,0,255],[138,0,0,255],[140,0,0,255],[142,0,0,255],[144,0,0,255],[146,0,0,255],[148,0,0,255],[150,0,0,255],[152,0,0,255],[154,0,0,255],[156,0,0,255],[158,0,0,255],[160,0,0,255],[162,0,0,255],[164,0,0,255],[166,0,0,255],[168,0,0,255],[170,0,0,255],[172,0,0,255],[174,0,0,255],[176,0,0,255],[178,0,0,255],[180,0,0,255],[182,0,0,255],[184,0,0,255],[186,0,0,255],[188,0,0,255],[190,0,0,255],[192,0,0,255],[194,0,0,255],[196,0,0,255],[198,0,0,255],[200,0,0,255],[202,0,0,255],[204,0,0,255],[206,0,0,255],[208,0,0,255],[210,0,0,255],[212,0,0,255],[214,0,0,255],[216,0,0,255],[218,0,0,255],[220,0,0,255],[222,0,0,255],[224,0,0,255],[226,0,0,255],[228,0,0,255],[230,0,0,255],[232,0,0,255],[234,0,0,255],[236,0,0,255],[238,0,0,255],[240,0,0,255],[242,0,0,255],[244,0,0,255],[246,0,0,255],[248,0,0,255],[250,0,0,255],[252,0,0,255],[254,0,0,255],[255,0,0,255],[255,2,0,255],[255,4,0,255],[255,6,0,255],[255,8,0,255],[255,10,0,255],[255,12,0,255],[255,14,0,255],[255,16,0,255],[255,18,0,255],[255,20,0,255],[255,22,0,255],[255,24,0,255],[255,26,0,255],[255,28,0,255],[255,30,0,255],[255,32,0,255],[255,34,0,255],[255,36,0,255],[255,38,0,255],[255,40,0,255],[255,42,0,255],[255,44,0,255],[255,46,0,255],[255,48,0,255],[255,50,0,255],[255,52,0,255],[255,54,0,255],[255,56,0,255],[255,58,0,255],[255,60,0,255],[255,62,0,255],[255,64,0,255],[255,66,0,255],[255,68,0,255],[255,70,0,255],[255,72,0,255],[255,74,0,255],[255,76,0,255],[255,78,0,255],[255,80,0,255],[255,82,0,255],[255,84,0,255],[255,86,0,255],[255,88,0,255],[255,90,0,255],[255,92,0,255],[255,94,0,255],[255,96,0,255],[255,98,0,255],[255,100,0,255],[255,102,0,255],[255,104,0,255],[255,106,0,255],[255,108,0,255],[255,110,0,255],[255,112,0,255],[255,114,0,255],[255,116,0,255],[255,118,0,255],[255,120,0,255],[255,122,0,255],[255,124,0,255],[255,126,0,255],[255,128,4,255],[255,130,8,255],[255,132,12,255],[255,134,16,255],[255,136,20,255],[255,138,24,255],[255,140,28,255],[255,142,32,255],[255,144,36,255],[255,146,40,255],[255,148,44,255],[255,150,48,255],[255,152,52,255],[255,154,56,255],[255,156,60,255],[255,158,64,255],[255,160,68,255],[255,162,72,255],[255,164,76,255],[255,166,80,255],[255,168,84,255],[255,170,88,255],[255,172,92,255],[255,174,96,255],[255,176,100,255],[255,178,104,255],[255,180,108,255],[255,182,112,255],[255,184,116,255],[255,186,120,255],[255,188,124,255],[255,190,128,255],[255,192,132,255],[255,194,136,255],[255,196,140,255],[255,198,144,255],[255,200,148,255],[255,202,152,255],[255,204,156,255],[255,206,160,255],[255,208,164,255],[255,210,168,255],[255,212,172,255],[255,214,176,255],[255,216,180,255],[255,218,184,255],[255,220,188,255],[255,222,192,255],[255,224,196,255],[255,226,200,255],[255,228,204,255],[255,230,208,255],[255,232,212,255],[255,234,216,255],[255,236,220,255],[255,238,224,255],[255,240,228,255],[255,242,232,255],[255,244,236,255],[255,246,240,255],[255,248,244,255],[255,250,248,255],[255,252,252,255],[255,255,255,255]]},pet:{name:"PET",numColors:256,colors:[[0,0,0,255],[0,2,1,255],[0,4,3,255],[0,6,5,255],[0,8,7,255],[0,10,9,255],[0,12,11,255],[0,14,13,255],[0,16,15,255],[0,18,17,255],[0,20,19,255],[0,22,21,255],[0,24,23,255],[0,26,25,255],[0,28,27,255],[0,30,29,255],[0,32,31,255],[0,34,33,255],[0,36,35,255],[0,38,37,255],[0,40,39,255],[0,42,41,255],[0,44,43,255],[0,46,45,255],[0,48,47,255],[0,50,49,255],[0,52,51,255],[0,54,53,255],[0,56,55,255],[0,58,57,255],[0,60,59,255],[0,62,61,255],[0,65,63,255],[0,67,65,255],[0,69,67,255],[0,71,69,255],[0,73,71,255],[0,75,73,255],[0,77,75,255],[0,79,77,255],[0,81,79,255],[0,83,81,255],[0,85,83,255],[0,87,85,255],[0,89,87,255],[0,91,89,255],[0,93,91,255],[0,95,93,255],[0,97,95,255],[0,99,97,255],[0,101,99,255],[0,103,101,255],[0,105,103,255],[0,107,105,255],[0,109,107,255],[0,111,109,255],[0,113,111,255],[0,115,113,255],[0,117,115,255],[0,119,117,255],[0,121,119,255],[0,123,121,255],[0,125,123,255],[0,128,125,255],[1,126,127,255],[3,124,129,255],[5,122,131,255],[7,120,133,255],[9,118,135,255],[11,116,137,255],[13,114,139,255],[15,112,141,255],[17,110,143,255],[19,108,145,255],[21,106,147,255],[23,104,149,255],[25,102,151,255],[27,100,153,255],[29,98,155,255],[31,96,157,255],[33,94,159,255],[35,92,161,255],[37,90,163,255],[39,88,165,255],[41,86,167,255],[43,84,169,255],[45,82,171,255],[47,80,173,255],[49,78,175,255],[51,76,177,255],[53,74,179,255],[55,72,181,255],[57,70,183,255],[59,68,185,255],[61,66,187,255],[63,64,189,255],[65,63,191,255],[67,61,193,255],[69,59,195,255],[71,57,197,255],[73,55,199,255],[75,53,201,255],[77,51,203,255],[79,49,205,255],[81,47,207,255],[83,45,209,255],[85,43,211,255],[86,41,213,255],[88,39,215,255],[90,37,217,255],[92,35,219,255],[94,33,221,255],[96,31,223,255],[98,29,225,255],[100,27,227,255],[102,25,229,255],[104,23,231,255],[106,21,233,255],[108,19,235,255],[110,17,237,255],[112,15,239,255],[114,13,241,255],[116,11,243,255],[118,9,245,255],[120,7,247,255],[122,5,249,255],[124,3,251,255],[126,1,253,255],[128,0,255,255],[130,2,252,255],[132,4,248,255],[134,6,244,255],[136,8,240,255],[138,10,236,255],[140,12,232,255],[142,14,228,255],[144,16,224,255],[146,18,220,255],[148,20,216,255],[150,22,212,255],[152,24,208,255],[154,26,204,255],[156,28,200,255],[158,30,196,255],[160,32,192,255],[162,34,188,255],[164,36,184,255],[166,38,180,255],[168,40,176,255],[170,42,172,255],[171,44,168,255],[173,46,164,255],[175,48,160,255],[177,50,156,255],[179,52,152,255],[181,54,148,255],[183,56,144,255],[185,58,140,255],[187,60,136,255],[189,62,132,255],[191,64,128,255],[193,66,124,255],[195,68,120,255],[197,70,116,255],[199,72,112,255],[201,74,108,255],[203,76,104,255],[205,78,100,255],[207,80,96,255],[209,82,92,255],[211,84,88,255],[213,86,84,255],[215,88,80,255],[217,90,76,255],[219,92,72,255],[221,94,68,255],[223,96,64,255],[225,98,60,255],[227,100,56,255],[229,102,52,255],[231,104,48,255],[233,106,44,255],[235,108,40,255],[237,110,36,255],[239,112,32,255],[241,114,28,255],[243,116,24,255],[245,118,20,255],[247,120,16,255],[249,122,12,255],[251,124,8,255],[253,126,4,255],[255,128,0,255],[255,130,4,255],[255,132,8,255],[255,134,12,255],[255,136,16,255],[255,138,20,255],[255,140,24,255],[255,142,28,255],[255,144,32,255],[255,146,36,255],[255,148,40,255],[255,150,44,255],[255,152,48,255],[255,154,52,255],[255,156,56,255],[255,158,60,255],[255,160,64,255],[255,162,68,255],[255,164,72,255],[255,166,76,255],[255,168,80,255],[255,170,85,255],[255,172,89,255],[255,174,93,255],[255,176,97,255],[255,178,101,255],[255,180,105,255],[255,182,109,255],[255,184,113,255],[255,186,117,255],[255,188,121,255],[255,190,125,255],[255,192,129,255],[255,194,133,255],[255,196,137,255],[255,198,141,255],[255,200,145,255],[255,202,149,255],[255,204,153,255],[255,206,157,255],[255,208,161,255],[255,210,165,255],[255,212,170,255],[255,214,174,255],[255,216,178,255],[255,218,182,255],[255,220,186,255],[255,222,190,255],[255,224,194,255],[255,226,198,255],[255,228,202,255],[255,230,206,255],[255,232,210,255],[255,234,214,255],[255,236,218,255],[255,238,222,255],[255,240,226,255],[255,242,230,255],[255,244,234,255],[255,246,238,255],[255,248,242,255],[255,250,246,255],[255,252,250,255],[255,255,255,255]]},hotMetalBlue:{name:"Hot Metal Blue",numColors:256,colors:[[0,0,0,255],[0,0,2,255],[0,0,4,255],[0,0,6,255],[0,0,8,255],[0,0,10,255],[0,0,12,255],[0,0,14,255],[0,0,16,255],[0,0,17,255],[0,0,19,255],[0,0,21,255],[0,0,23,255],[0,0,25,255],[0,0,27,255],[0,0,29,255],[0,0,31,255],[0,0,33,255],[0,0,35,255],[0,0,37,255],[0,0,39,255],[0,0,41,255],[0,0,43,255],[0,0,45,255],[0,0,47,255],[0,0,49,255],[0,0,51,255],[0,0,53,255],[0,0,55,255],[0,0,57,255],[0,0,59,255],[0,0,61,255],[0,0,63,255],[0,0,65,255],[0,0,67,255],[0,0,69,255],[0,0,71,255],[0,0,73,255],[0,0,75,255],[0,0,77,255],[0,0,79,255],[0,0,81,255],[0,0,83,255],[0,0,84,255],[0,0,86,255],[0,0,88,255],[0,0,90,255],[0,0,92,255],[0,0,94,255],[0,0,96,255],[0,0,98,255],[0,0,100,255],[0,0,102,255],[0,0,104,255],[0,0,106,255],[0,0,108,255],[0,0,110,255],[0,0,112,255],[0,0,114,255],[0,0,116,255],[0,0,117,255],[0,0,119,255],[0,0,121,255],[0,0,123,255],[0,0,125,255],[0,0,127,255],[0,0,129,255],[0,0,131,255],[0,0,133,255],[0,0,135,255],[0,0,137,255],[0,0,139,255],[0,0,141,255],[0,0,143,255],[0,0,145,255],[0,0,147,255],[0,0,149,255],[0,0,151,255],[0,0,153,255],[0,0,155,255],[0,0,157,255],[0,0,159,255],[0,0,161,255],[0,0,163,255],[0,0,165,255],[0,0,167,255],[3,0,169,255],[6,0,171,255],[9,0,173,255],[12,0,175,255],[15,0,177,255],[18,0,179,255],[21,0,181,255],[24,0,183,255],[26,0,184,255],[29,0,186,255],[32,0,188,255],[35,0,190,255],[38,0,192,255],[41,0,194,255],[44,0,196,255],[47,0,198,255],[50,0,200,255],[52,0,197,255],[55,0,194,255],[57,0,191,255],[59,0,188,255],[62,0,185,255],[64,0,182,255],[66,0,179,255],[69,0,176,255],[71,0,174,255],[74,0,171,255],[76,0,168,255],[78,0,165,255],[81,0,162,255],[83,0,159,255],[85,0,156,255],[88,0,153,255],[90,0,150,255],[93,2,144,255],[96,4,138,255],[99,6,132,255],[102,8,126,255],[105,9,121,255],[108,11,115,255],[111,13,109,255],[114,15,103,255],[116,17,97,255],[119,19,91,255],[122,21,85,255],[125,23,79,255],[128,24,74,255],[131,26,68,255],[134,28,62,255],[137,30,56,255],[140,32,50,255],[143,34,47,255],[146,36,44,255],[149,38,41,255],[152,40,38,255],[155,41,35,255],[158,43,32,255],[161,45,29,255],[164,47,26,255],[166,49,24,255],[169,51,21,255],[172,53,18,255],[175,55,15,255],[178,56,12,255],[181,58,9,255],[184,60,6,255],[187,62,3,255],[190,64,0,255],[194,66,0,255],[198,68,0,255],[201,70,0,255],[205,72,0,255],[209,73,0,255],[213,75,0,255],[217,77,0,255],[221,79,0,255],[224,81,0,255],[228,83,0,255],[232,85,0,255],[236,87,0,255],[240,88,0,255],[244,90,0,255],[247,92,0,255],[251,94,0,255],[255,96,0,255],[255,98,3,255],[255,100,6,255],[255,102,9,255],[255,104,12,255],[255,105,15,255],[255,107,18,255],[255,109,21,255],[255,111,24,255],[255,113,26,255],[255,115,29,255],[255,117,32,255],[255,119,35,255],[255,120,38,255],[255,122,41,255],[255,124,44,255],[255,126,47,255],[255,128,50,255],[255,130,53,255],[255,132,56,255],[255,134,59,255],[255,136,62,255],[255,137,65,255],[255,139,68,255],[255,141,71,255],[255,143,74,255],[255,145,76,255],[255,147,79,255],[255,149,82,255],[255,151,85,255],[255,152,88,255],[255,154,91,255],[255,156,94,255],[255,158,97,255],[255,160,100,255],[255,162,103,255],[255,164,106,255],[255,166,109,255],[255,168,112,255],[255,169,115,255],[255,171,118,255],[255,173,121,255],[255,175,124,255],[255,177,126,255],[255,179,129,255],[255,181,132,255],[255,183,135,255],[255,184,138,255],[255,186,141,255],[255,188,144,255],[255,190,147,255],[255,192,150,255],[255,194,153,255],[255,196,156,255],[255,198,159,255],[255,200,162,255],[255,201,165,255],[255,203,168,255],[255,205,171,255],[255,207,174,255],[255,209,176,255],[255,211,179,255],[255,213,182,255],[255,215,185,255],[255,216,188,255],[255,218,191,255],[255,220,194,255],[255,222,197,255],[255,224,200,255],[255,226,203,255],[255,228,206,255],[255,229,210,255],[255,231,213,255],[255,233,216,255],[255,235,219,255],[255,237,223,255],[255,239,226,255],[255,240,229,255],[255,242,232,255],[255,244,236,255],[255,246,239,255],[255,248,242,255],[255,250,245,255],[255,251,249,255],[255,253,252,255],[255,255,255,255]]},pet20Step:{name:"PET 20 Step",numColors:256,colors:[[0,0,0,255],[0,0,0,255],[0,0,0,255],[0,0,0,255],[0,0,0,255],[0,0,0,255],[0,0,0,255],[0,0,0,255],[0,0,0,255],[0,0,0,255],[0,0,0,255],[0,0,0,255],[0,0,0,255],[96,0,80,255],[96,0,80,255],[96,0,80,255],[96,0,80,255],[96,0,80,255],[96,0,80,255],[96,0,80,255],[96,0,80,255],[96,0,80,255],[96,0,80,255],[96,0,80,255],[96,0,80,255],[96,0,80,255],[48,48,80,255],[48,48,80,255],[48,48,80,255],[48,48,80,255],[48,48,80,255],[48,48,80,255],[48,48,80,255],[48,48,80,255],[48,48,80,255],[48,48,80,255],[48,48,80,255],[48,48,80,255],[48,48,80,255],[48,48,112,255],[48,48,112,255],[48,48,112,255],[48,48,112,255],[48,48,112,255],[48,48,112,255],[48,48,112,255],[48,48,112,255],[48,48,112,255],[48,48,112,255],[48,48,112,255],[48,48,112,255],[80,80,128,255],[80,80,128,255],[80,80,128,255],[80,80,128,255],[80,80,128,255],[80,80,128,255],[80,80,128,255],[80,80,128,255],[80,80,128,255],[80,80,128,255],[80,80,128,255],[80,80,128,255],[80,80,128,255],[96,96,176,255],[96,96,176,255],[96,96,176,255],[96,96,176,255],[96,96,176,255],[96,96,176,255],[96,96,176,255],[96,96,176,255],[96,96,176,255],[96,96,176,255],[96,96,176,255],[96,96,176,255],[96,96,176,255],[112,112,192,255],[112,112,192,255],[112,112,192,255],[112,112,192,255],[112,112,192,255],[112,112,192,255],[112,112,192,255],[112,112,192,255],[112,112,192,255],[112,112,192,255],[112,112,192,255],[112,112,192,255],[112,112,192,255],[128,128,224,255],[128,128,224,255],[128,128,224,255],[128,128,224,255],[128,128,224,255],[128,128,224,255],[128,128,224,255],[128,128,224,255],[128,128,224,255],[128,128,224,255],[128,128,224,255],[128,128,224,255],[48,96,48,255],[48,96,48,255],[48,96,48,255],[48,96,48,255],[48,96,48,255],[48,96,48,255],[48,96,48,255],[48,96,48,255],[48,96,48,255],[48,96,48,255],[48,96,48,255],[48,96,48,255],[48,96,48,255],[48,144,48,255],[48,144,48,255],[48,144,48,255],[48,144,48,255],[48,144,48,255],[48,144,48,255],[48,144,48,255],[48,144,48,255],[48,144,48,255],[48,144,48,255],[48,144,48,255],[48,144,48,255],[48,144,48,255],[80,192,80,255],[80,192,80,255],[80,192,80,255],[80,192,80,255],[80,192,80,255],[80,192,80,255],[80,192,80,255],[80,192,80,255],[80,192,80,255],[80,192,80,255],[80,192,80,255],[80,192,80,255],[80,192,80,255],[64,224,64,255],[64,224,64,255],[64,224,64,255],[64,224,64,255],[64,224,64,255],[64,224,64,255],[64,224,64,255],[64,224,64,255],[64,224,64,255],[64,224,64,255],[64,224,64,255],[64,224,64,255],[224,224,80,255],[224,224,80,255],[224,224,80,255],[224,224,80,255],[224,224,80,255],[224,224,80,255],[224,224,80,255],[224,224,80,255],[224,224,80,255],[224,224,80,255],[224,224,80,255],[224,224,80,255],[224,224,80,255],[208,208,96,255],[208,208,96,255],[208,208,96,255],[208,208,96,255],[208,208,96,255],[208,208,96,255],[208,208,96,255],[208,208,96,255],[208,208,96,255],[208,208,96,255],[208,208,96,255],[208,208,96,255],[208,208,96,255],[208,176,64,255],[208,176,64,255],[208,176,64,255],[208,176,64,255],[208,176,64,255],[208,176,64,255],[208,176,64,255],[208,176,64,255],[208,176,64,255],[208,176,64,255],[208,176,64,255],[208,176,64,255],[208,176,64,255],[208,144,0,255],[208,144,0,255],[208,144,0,255],[208,144,0,255],[208,144,0,255],[208,144,0,255],[208,144,0,255],[208,144,0,255],[208,144,0,255],[208,144,0,255],[208,144,0,255],[208,144,0,255],[192,96,0,255],[192,96,0,255],[192,96,0,255],[192,96,0,255],[192,96,0,255],[192,96,0,255],[192,96,0,255],[192,96,0,255],[192,96,0,255],[192,96,0,255],[192,96,0,255],[192,96,0,255],[192,96,0,255],[176,48,0,255],[176,48,0,255],[176,48,0,255],[176,48,0,255],[176,48,0,255],[176,48,0,255],[176,48,0,255],[176,48,0,255],[176,48,0,255],[176,48,0,255],[176,48,0,255],[176,48,0,255],[176,48,0,255],[255,0,0,255],[255,0,0,255],[255,0,0,255],[255,0,0,255],[255,0,0,255],[255,0,0,255],[255,0,0,255],[255,0,0,255],[255,0,0,255],[255,0,0,255],[255,0,0,255],[255,0,0,255],[255,0,0,255],[255,255,255,255],[255,255,255,255],[255,255,255,255],[255,255,255,255],[255,255,255,255],[255,255,255,255],[255,255,255,255],[255,255,255,255],[255,255,255,255],[255,255,255,255],[255,255,255,255],[255,255,255,255],[255,255,255,255]]},gray:{name:"Gray",numColors:256,gamma:1,segmentedData:{red:[[0,0,0],[1,1,1]],green:[[0,0,0],[1,1,1]],blue:[[0,0,0],[1,1,1]]}},jet:{name:"Jet",numColors:256,gamma:1,segmentedData:{red:[[0,0,0],[.35,0,0],[.66,1,1],[.89,1,1],[1,.5,.5]],green:[[0,0,0],[.125,0,0],[.375,1,1],[.64,1,1],[.91,0,0],[1,0,0]],blue:[[0,.5,.5],[.11,1,1],[.34,1,1],[.65,0,0],[1,0,0]]}},hsv:{name:"HSV",numColors:256,gamma:1,segmentedData:{red:[[0,1,1],[.15873,1,1],[.174603,.96875,.96875],[.333333,.03125,.03125],[.349206,0,0],[.666667,0,0],[.68254,.03125,.03125],[.84127,.96875,.96875],[.857143,1,1],[1,1,1]],green:[[0,0,0],[.15873,.9375,.9375],[.174603,1,1],[.507937,1,1],[.666667,.0625,.0625],[.68254,0,0],[1,0,0]],blue:[[0,0,0],[.333333,0,0],[.349206,.0625,.0625],[.507937,1,1],[.84127,1,1],[.857143,.9375,.9375],[1,.09375,.09375]]}},hot:{name:"Hot",numColors:256,gamma:1,segmentedData:{red:[[0,.0416,.0416],[.365079,1,1],[1,1,1]],green:[[0,0,0],[.365079,0,0],[.746032,1,1],[1,1,1]],blue:[[0,0,0],[.746032,0,0],[1,1,1]]}},cool:{name:"Cool",numColors:256,gamma:1,segmentedData:{red:[[0,0,0],[1,1,1]],green:[[0,1,1],[1,0,0]],blue:[[0,1,1],[1,1,1]]}},spring:{name:"Spring",numColors:256,gamma:1,segmentedData:{red:[[0,1,1],[1,1,1]],green:[[0,0,0],[1,1,1]],blue:[[0,1,1],[1,0,0]]}},summer:{name:"Summer",numColors:256,gamma:1,segmentedData:{red:[[0,0,0],[1,1,1]],green:[[0,.5,.5],[1,1,1]],blue:[[0,.4,.4],[1,.4,.4]]}},autumn:{name:"Autumn",numColors:256,gamma:1,segmentedData:{red:[[0,1,1],[1,1,1]],green:[[0,0,0],[1,1,1]],blue:[[0,0,0],[1,0,0]]}},winter:{name:"Winter",numColors:256,gamma:1,segmentedData:{red:[[0,0,0],[1,0,0]],green:[[0,0,0],[1,1,1]],blue:[[0,1,1],[1,.5,.5]]}},bone:{name:"Bone",numColors:256,gamma:1,segmentedData:{red:[[0,0,0],[.746032,.652778,.652778],[1,1,1]],green:[[0,0,0],[.365079,.319444,.319444],[.746032,.777778,.777778],[1,1,1]],blue:[[0,0,0],[.365079,.444444,.444444],[1,1,1]]}},copper:{name:"Copper",numColors:256,gamma:1,segmentedData:{red:[[0,0,0],[.809524,1,1],[1,1,1]],green:[[0,0,0],[1,.7812,.7812]],blue:[[0,0,0],[1,.4975,.4975]]}},spectral:{name:"Spectral",numColors:256,gamma:1,segmentedData:{red:[[0,0,0],[.05,.4667,.4667],[.1,.5333,.5333],[.15,0,0],[.2,0,0],[.25,0,0],[.3,0,0],[.35,0,0],[.4,0,0],[.45,0,0],[.5,0,0],[.55,0,0],[.6,0,0],[.65,.7333,.7333],[.7,.9333,.9333],[.75,1,1],[.8,1,1],[.85,1,1],[.9,.8667,.8667],[.95,.8,.8],[1,.8,.8]],green:[[0,0,0],[.05,0,0],[.1,0,0],[.15,0,0],[.2,0,0],[.25,.4667,.4667],[.3,.6,.6],[.35,.6667,.6667],[.4,.6667,.6667],[.45,.6,.6],[.5,.7333,.7333],[.55,.8667,.8667],[.6,1,1],[.65,1,1],[.7,.9333,.9333],[.75,.8,.8],[.8,.6,.6],[.85,0,0],[.9,0,0],[.95,0,0],[1,.8,.8]],blue:[[0,0,0],[.05,.5333,.5333],[.1,.6,.6],[.15,.6667,.6667],[.2,.8667,.8667],[.25,.8667,.8667],[.3,.8667,.8667],[.35,.6667,.6667],[.4,.5333,.5333],[.45,0,0],[.5,0,0],[.55,0,0],[.6,0,0],[.65,0,0],[.7,0,0],[.75,0,0],[.8,0,0],[.85,0,0],[.9,0,0],[.95,0,0],[1,.8,.8]]}},coolwarm:{name:"CoolWarm",numColors:256,gamma:1,segmentedData:{red:[[0,.2298057,.2298057],[.03125,.26623388,.26623388],[.0625,.30386891,.30386891],[.09375,.342804478,.342804478],[.125,.38301334,.38301334],[.15625,.424369608,.424369608],[.1875,.46666708,.46666708],[.21875,.509635204,.509635204],[.25,.552953156,.552953156],[.28125,.596262162,.596262162],[.3125,.639176211,.639176211],[.34375,.681291281,.681291281],[.375,.722193294,.722193294],[.40625,.761464949,.761464949],[.4375,.798691636,.798691636],[.46875,.833466556,.833466556],[.5,.865395197,.865395197],[.53125,.897787179,.897787179],[.5625,.924127593,.924127593],[.59375,.944468518,.944468518],[.625,.958852946,.958852946],[.65625,.96732803,.96732803],[.6875,.969954137,.969954137],[.71875,.966811177,.966811177],[.75,.958003065,.958003065],[.78125,.943660866,.943660866],[.8125,.923944917,.923944917],[.84375,.89904617,.89904617],[.875,.869186849,.869186849],[.90625,.834620542,.834620542],[.9375,.795631745,.795631745],[.96875,.752534934,.752534934],[1,.705673158,.705673158]],green:[[0,.298717966,.298717966],[.03125,.353094838,.353094838],[.0625,.406535296,.406535296],[.09375,.458757618,.458757618],[.125,.50941904,.50941904],[.15625,.558148092,.558148092],[.1875,.604562568,.604562568],[.21875,.648280772,.648280772],[.25,.688929332,.688929332],[.28125,.726149107,.726149107],[.3125,.759599947,.759599947],[.34375,.788964712,.788964712],[.375,.813952739,.813952739],[.40625,.834302879,.834302879],[.4375,.849786142,.849786142],[.46875,.860207984,.860207984],[.5,.86541021,.86541021],[.53125,.848937047,.848937047],[.5625,.827384882,.827384882],[.59375,.800927443,.800927443],[.625,.769767752,.769767752],[.65625,.734132809,.734132809],[.6875,.694266682,.694266682],[.71875,.650421156,.650421156],[.75,.602842431,.602842431],[.78125,.551750968,.551750968],[.8125,.49730856,.49730856],[.84375,.439559467,.439559467],[.875,.378313092,.378313092],[.90625,.312874446,.312874446],[.9375,.24128379,.24128379],[.96875,.157246067,.157246067],[1,.01555616,.01555616]],blue:[[0,.753683153,.753683153],[.03125,.801466763,.801466763],[.0625,.84495867,.84495867],[.09375,.883725899,.883725899],[.125,.917387822,.917387822],[.15625,.945619588,.945619588],[.1875,.968154911,.968154911],[.21875,.98478814,.98478814],[.25,.995375608,.995375608],[.28125,.999836203,.999836203],[.3125,.998151185,.998151185],[.34375,.990363227,.990363227],[.375,.976574709,.976574709],[.40625,.956945269,.956945269],[.4375,.931688648,.931688648],[.46875,.901068838,.901068838],[.5,.865395561,.865395561],[.53125,.820880546,.820880546],[.5625,.774508472,.774508472],[.59375,.726736146,.726736146],[.625,.678007945,.678007945],[.65625,.628751763,.628751763],[.6875,.579375448,.579375448],[.71875,.530263762,.530263762],[.75,.481775914,.481775914],[.78125,.434243684,.434243684],[.8125,.387970225,.387970225],[.84375,.343229596,.343229596],[.875,.300267182,.300267182],[.90625,.259301199,.259301199],[.9375,.220525627,.220525627],[.96875,.184115123,.184115123],[1,.150232812,.150232812]]}},blues:{name:"Blues",numColors:256,gamma:1,segmentedData:{red:[[0,.9686274528503418,.9686274528503418],[.125,.8705882430076599,.8705882430076599],[.25,.7764706015586853,.7764706015586853],[.375,.6196078658103943,.6196078658103943],[.5,.41960784792900085,.41960784792900085],[.625,.25882354378700256,.25882354378700256],[.75,.12941177189350128,.12941177189350128],[.875,.0313725508749485,.0313725508749485],[1,.0313725508749485,.0313725508749485]],green:[[0,.9843137264251709,.9843137264251709],[.125,.9215686321258545,.9215686321258545],[.25,.8588235378265381,.8588235378265381],[.375,.7921568751335144,.7921568751335144],[.5,.6823529601097107,.6823529601097107],[.625,.572549045085907,.572549045085907],[.75,.4431372582912445,.4431372582912445],[.875,.3176470696926117,.3176470696926117],[1,.1882352977991104,.1882352977991104]],blue:[[0,1,1],[.125,.9686274528503418,.9686274528503418],[.25,.9372549057006836,.9372549057006836],[.375,.8823529481887817,.8823529481887817],[.5,.8392156958580017,.8392156958580017],[.625,.7764706015586853,.7764706015586853],[.75,.7098039388656616,.7098039388656616],[.875,.6117647290229797,.6117647290229797],[1,.41960784792900085,.41960784792900085]]}}};function B(e,t){for(var r=0,n=e.length-1;r<=n;){var a=r+Math.floor((n-r)/2),i=e[a];if(i===t)return a;t<i?n=a-1:r=a+1}return r}function k(e,t,r){var n,a=[],i=[],o=[],l=[];for(r=null===r?1:r,n=0;n<t.length;n++){var s=t[n];a.push((e-1)*s[0]),i.push(s[1]),o.push(s[1])}var u=function(e,t,r){for(var n=(t-e)/((r=null===r?100:r)-1),a=[];0<r--;)a.push(e),e+=n;return a[a.length-1]=t,a}(0,1,e);for(n=0;n<e;n++)u[n]=(e-1)*Math.pow(u[n],r);var d=function(e,t){var r,n=[],a=t.length;for(e.sort(function(e,t){return e-t}),r=0;r<a;r++)n[r]=B(e,t[r]);return n}(a,u);for(n=1;n<e-1;n++){var m=d[n],c=(u[n]-a[m-1])/(a[m]-a[m-1]),f=i[m]-o[m-1];l[n]=c*f+o[m-1]}return l[0]=o[0],l[e-1]=i[t.length-1],l}function F(e,t){var n=N[e];return n||(n=N[e]=t||{name:"",colors:[]}),!n.colors&&n.segmentedData&&(n.colors=function(e,t,r){var n,a=[];r=null===r?1:r;var i=k(t=null===t?256:t,e.red,r),o=k(t,e.green,r),l=k(t,e.blue,r);for(n=0;n<t;n++){var s=[Math.round(255*i[n]),Math.round(255*o[n]),Math.round(255*l[n]),255];a.push(s)}return a}(n.segmentedData,n.numColors,n.gamma)),{getId:function(){return e},getColorSchemeName:function(){return n.name},setColorSchemeName:function(e){n.name=e},getNumberOfColors:function(){return n.colors.length},setNumberOfColors:function(e){for(;n.colors.length<e;)n.colors.push(U);n.colors.length=e},getColor:function(e){return this.isValidIndex(e)?n.colors[e]:U},getColorRepeating:function(e){var t=n.colors.length;return e=t?e%t:0,this.getColor(e)},setColor:function(e,t){this.isValidIndex(e)&&(n.colors[e]=t)},addColor:function(e){n.colors.push(e)},insertColor:function(e,t){this.isValidIndex(e)&&n.colors.splice(e,1,t)},removeColor:function(e){this.isValidIndex(e)&&n.colors.splice(e,1)},clearColors:function(){n.colors=[]},buildLookupTable:function(e){if(e){var t=n.colors.length;e.setNumberOfTableValues(t);for(var r=0;r<t;r++)e.setTableValue(r,n.colors[r])}},createLookupTable:function(){var e=new V;return this.buildLookupTable(e),e},isValidIndex:function(e){return 0<=e&&e<n.colors.length}}}var G={getColormap:F,getColormapsList:function(){var r=[];return Object.keys(N).forEach(function(e){if(N.hasOwnProperty(e)){var t=N[e];r.push({id:e,name:t.name})}}),r.sort(function(e,t){var r=e.name.toLowerCase(),n=t.name.toLowerCase();return r===n?0:r<n?-1:1}),r},LookupTable:V};function z(e,t){if(e.color&&!e.falseColor)throw new Error("Color transforms are not implemented yet");var r,n,a=e.minPixelValue,i=0,o=0,l=e.width*e.height,s=e.origPixelData||e.getPixelData(),u=new Uint8Array(4*l);if(e.color=!0,e.falseColor=!0,e.origPixelData=s,t instanceof G.LookupTable)for(t.build();o<l;)r=s[o++],n=t.mapValue(r),u[i++]=n[0],u[i++]=n[1],u[i++]=n[2],u[i++]=n[3];else if(a<0)for(;o<l;)r=s[o++],u[i++]=t[r+-a][0],u[i++]=t[r+-a][1],u[i++]=t[r+-a][2],u[i++]=t[r+-a][3];else for(;o<l;)r=s[o++],u[i++]=t[r][0],u[i++]=t[r][1],u[i++]=t[r][2],u[i++]=t[r][3];e.rgba=!0,e.cachedLut=void 0,e.render=void 0,e.slope=1,e.intercept=0,e.minPixelValue=0,e.maxPixelValue=255,e.windowWidth=255,e.windowCenter=128,e.getPixelData=function(){return u}}function q(e){return!(!e.restore||"function"!=typeof e.restore)&&(e.restore(),!0)}function W(e,t){if(e.color&&!e.falseColor)throw new Error("Color transforms are not implemented yet");var r;(r=t)&&"string"==typeof r&&(r=F(r));var n=(t=r).getId();if(e.colormapId===n)return!1;if(q(e),n){var a=e.minPixelValue||0,i=e.maxPixelValue||255;e.restore=function(t){if(t.restore)return t.restore;var r=t.color,n=t.rgba,a=t.cachedLut,i=t.slope,o=t.windowWidth,l=t.windowCenter,s=t.minPixelValue,u=t.maxPixelValue;return function(){if(t.color=r,t.rgba=n,t.cachedLut=a,t.slope=i,t.windowWidth=o,t.windowCenter=l,t.minPixelValue=s,t.maxPixelValue=u,t.origPixelData){var e=t.origPixelData;t.getPixelData=function(){return e}}t.origPixelData=void 0,t.colormapId=void 0,t.falseColor=void 0}}(e);var o=t.createLookupTable();o.setTableRange(a,i),z(e,o);var l=function(e){for(var t,r=Number.MAX_VALUE,n=Number.MIN_VALUE,a=e.length,i=0;i<a;i++)r=r<(t=e[i])?r:t,n=t<n?n:t;return{minPixelValue:r,maxPixelValue:n}}(e.getPixelData());e.minPixelValue=l.minPixelValue,e.maxPixelValue=l.maxPixelValue,e.windowWidth=255,e.windowCenter=128,e.colormapId=n}return!0}function j(e,t){return W(C(e).image,t)}function H(e,t){var r=C(e);return!1===r.data.hasOwnProperty(t)&&(r.data[t]={}),r.data[t]}function X(e,t){delete C(e).data[t]}var Y=1073741824,K=0,Z={},$=[];function J(){if(!(K<=Y)){for($.sort(function(e,t){return e.timeStamp>t.timeStamp?-1:e.timeStamp<t.timeStamp?1:0});Y<K;){var e=$[$.length-1].imageId;te(e),R(o,T.IMAGE_CACHE_PROMISE_REMOVED,{imageId:e})}var t=re();R(o,T.IMAGE_CACHE_FULL,t)}}function Q(t,e){if(void 0===t)throw new Error("putImageLoadObject: imageId must not be undefined");if(void 0===e.promise)throw new Error("putImageLoadObject: imageLoadObject.promise must not be undefined");if(!0===Z.hasOwnProperty(t))throw new Error("putImageLoadObject: imageId already in cache");if(e.cancelFn&&"function"!=typeof e.cancelFn)throw new Error("putImageLoadObject: imageLoadObject.cancelFn must be a function");var r={loaded:!1,imageId:t,sharedCacheKey:void 0,imageLoadObject:e,timeStamp:Date.now(),sizeInBytes:0};Z[t]=r,$.push(r),e.promise.then(function(e){if(-1!==$.indexOf(r)){if(r.loaded=!0,void 0===(r.image=e).sizeInBytes)throw new Error("putImageLoadObject: image.sizeInBytes must not be undefined");if(void 0===e.sizeInBytes.toFixed)throw new Error("putImageLoadObject: image.sizeInBytes is not a number");r.sizeInBytes=e.sizeInBytes,K+=r.sizeInBytes;var t={action:"addImage",image:r};R(o,T.IMAGE_CACHE_CHANGED,t),r.sharedCacheKey=e.sharedCacheKey,J()}},function(){var e=Z[t];$.splice($.indexOf(e),1),delete Z[t]})}function ee(e){if(void 0===e)throw new Error("getImageLoadObject: imageId must not be undefined");var t=Z[e];if(void 0!==t)return t.timeStamp=Date.now(),t.imageLoadObject}function te(e){if(void 0===e)throw new Error("removeImageLoadObject: imageId must not be undefined");var t=Z[e];if(void 0===t)throw new Error("removeImageLoadObject: imageId was not present in imageCache");$.splice($.indexOf(t),1),K-=t.sizeInBytes;var r,n={action:"deleteImage",image:t};R(o,T.IMAGE_CACHE_CHANGED,n),(r=t.imageLoadObject).promise.then(function(){r.decache&&r.decache()},function(){r.decache&&r.decache()}),delete Z[e]}function re(){return{maximumSizeInBytes:Y,cacheSizeInBytes:K,numberOfImagesCached:$.length}}var ne,ae={imageCache:Z,cachedImages:$,setMaximumSizeBytes:function(e){if(void 0===e)throw new Error("setMaximumSizeBytes: parameter numBytes must not be undefined");if(void 0===e.toFixed)throw new Error("setMaximumSizeBytes: parameter numBytes must be a number");Y=e,R(o,T.IMAGE_CACHE_MAXIMUM_SIZE_CHANGED),J()},putImageLoadObject:Q,getImageLoadObject:ee,removeImageLoadObject:te,getCacheInfo:re,purgeCache:function(){for(;0<$.length;)te($[0].imageId)},changeImageIdCacheSize:function(e,n){var a=Z[e];a&&a.imageLoadObject.promise.then(function(e){var t=n-e.sizeInBytes;e.sizeInBytes=n,a.sizeInBytes=n,K+=t;var r={action:"changeImageSize",image:e};R(o,T.IMAGE_CACHE_CHANGED,r)})}},ie={};function oe(r,e){var t=r.indexOf(":"),n=r.substring(0,t),a=ie[n];if(null==a){if(void 0!==ne)return ne(r);throw new Error("loadImageFromImageLoader: no image loader for imageId")}var i=a(r,e);return i.promise.then(function(e){R(o,T.IMAGE_LOADED,{image:e})},function(e){var t={imageId:r,error:e};R(o,T.IMAGE_LOAD_FAILED,t)}),i}function le(e,t){if(void 0===e)throw new Error("loadImage: parameter imageId must not be undefined");var r=ee(e);return void 0!==r?r.promise:oe(e,t).promise}function se(e,t){if(void 0===e)throw new Error("loadAndCacheImage: parameter imageId must not be undefined");var r=ee(e);return void 0!==r||Q(e,r=oe(e,t)),r.promise}function ue(e,t){ie[e]=t}function de(e){var t=ne;return ne=e,t}function me(e,t){var r="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!r){if(Array.isArray(e)||(r=function(e,t){if(!e)return;if("string"==typeof e)return ce(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return ce(e,t)}(e))||t&&e&&"number"==typeof e.length){r&&(e=r);var n=0,a=function(){};return{s:a,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:a}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,o=!0,l=!1;return{s:function(){r=r.call(e)},n:function(){var e=r.next();return o=e.done,e},e:function(e){l=!0,i=e},f:function(){try{o||null==r.return||r.return()}finally{if(l)throw i}}}}function ce(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function fe(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function ge(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}var ve=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),ge(this,"requestPool",void 0),ge(this,"awake",void 0),ge(this,"numRequests",void 0),ge(this,"maxNumRequests",void 0),ge(this,"grabDelay",void 0),ge(this,"timeoutHandle",void 0),this.requestPool={interaction:{0:[]},thumbnail:{0:[]},prefetch:{0:[]}},this.awake=!1,this.grabDelay=5,this.numRequests={interaction:0,thumbnail:0,prefetch:0},this.maxNumRequests={interaction:6,thumbnail:6,prefetch:5}}var t,r,n;return t=e,(r=[{key:"destroy",value:function(){this.timeoutHandle&&window.clearTimeout(this.timeoutHandle)}},{key:"addRequest",value:function(e,t,r){var n=3<arguments.length&&void 0!==arguments[3]?arguments[3]:0,a=4<arguments.length&&void 0!==arguments[4]&&arguments[4],i={requestFn:e,type:t,additionalDetails:r};void 0===this.requestPool[t][n]&&(this.requestPool[t][n]=[]),a?this.requestPool[t][n].unshift(i):this.requestPool[t][n].push(i),this.awake||(this.awake=!0,this.startGrabbing())}},{key:"filterRequests",value:function(r){var n=this;Object.keys(this.requestPool).forEach(function(e){var t=n.requestPool[e];Object.keys(t).forEach(function(e){t[e]=t[e].filter(function(e){return r(e)})})})}},{key:"clearRequestStack",value:function(e){if(!this.requestPool[e])throw new Error("No category for the type ".concat(e," found"));this.requestPool[e]={0:[]}}},{key:"sendRequest",value:function(e){var t=this,r=e.requestFn,n=e.type;this.numRequests[n]++,this.awake=!0,r().finally(function(){t.numRequests[n]--,t.startAgain()})}},{key:"startGrabbing",value:function(){for(var e=this.maxNumRequests.interaction+this.maxNumRequests.thumbnail+this.maxNumRequests.prefetch-(this.numRequests.interaction+this.numRequests.thumbnail+this.numRequests.prefetch),t=0;t<e;t++){var r=this.getNextRequest();if(!1===r)break;r&&this.sendRequest(r)}}},{key:"startAgain",value:function(){var e=this;this.awake&&(this.grabDelay?this.timeoutHandle=window.setTimeout(function(){e.startGrabbing()},this.grabDelay):this.startGrabbing())}},{key:"getSortedPriorityGroups",value:function(t){var r=this;return Object.keys(this.requestPool[t]).map(Number).filter(function(e){return r.requestPool[t][e].length}).sort()}},{key:"getNextRequest",value:function(){var e,t=this.getSortedPriorityGroups("interaction"),r=me(t);try{for(r.s();!(e=r.n()).done;){var n=e.value;if(this.requestPool.interaction[n].length&&this.numRequests.interaction<this.maxNumRequests.interaction)return this.requestPool.interaction[n].shift()}}catch(e){r.e(e)}finally{r.f()}var a,i=this.getSortedPriorityGroups("thumbnail"),o=me(i);try{for(o.s();!(a=o.n()).done;){var l=a.value;if(this.requestPool.thumbnail[l].length&&this.numRequests.thumbnail<this.maxNumRequests.thumbnail)return this.requestPool.thumbnail[l].shift()}}catch(e){o.e(e)}finally{o.f()}var s,u=this.getSortedPriorityGroups("prefetch"),d=me(u);try{for(d.s();!(s=d.n()).done;){var m=s.value;if(this.requestPool.prefetch[m].length&&this.numRequests.prefetch<this.maxNumRequests.prefetch)return this.requestPool.prefetch[m].shift()}}catch(e){d.e(e)}finally{d.f()}return t.length||i.length||u.length||(this.awake=!1),!1}},{key:"getRequestPool",value:function(){return this.requestPool}}])&&fe(t.prototype,r),n&&fe(t,n),e}(),he=new ve;he.maxNumRequests={interaction:1e3,thumbnail:1e3,prefetch:1e3},he.grabDelay=0;var pe=he,we=new ve;we.maxNumRequests={interaction:20,thumbnail:20,prefetch:20},we.grabDelay=0;var be=we;function ye(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var xe=function(){function t(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),this.reset()}var e,r,n;return e=t,(r=[{key:"reset",value:function(){this.m=[1,0,0,1,0,0]}},{key:"clone",value:function(){var e=new t;return e.m[0]=this.m[0],e.m[1]=this.m[1],e.m[2]=this.m[2],e.m[3]=this.m[3],e.m[4]=this.m[4],e.m[5]=this.m[5],e}},{key:"multiply",value:function(e){var t=this.m[0]*e.m[0]+this.m[2]*e.m[1],r=this.m[1]*e.m[0]+this.m[3]*e.m[1],n=this.m[0]*e.m[2]+this.m[2]*e.m[3],a=this.m[1]*e.m[2]+this.m[3]*e.m[3],i=this.m[0]*e.m[4]+this.m[2]*e.m[5]+this.m[4],o=this.m[1]*e.m[4]+this.m[3]*e.m[5]+this.m[5];this.m[0]=t,this.m[1]=r,this.m[2]=n,this.m[3]=a,this.m[4]=i,this.m[5]=o}},{key:"invert",value:function(){var e=1/(this.m[0]*this.m[3]-this.m[1]*this.m[2]),t=this.m[3]*e,r=-this.m[1]*e,n=-this.m[2]*e,a=this.m[0]*e,i=e*(this.m[2]*this.m[5]-this.m[3]*this.m[4]),o=e*(this.m[1]*this.m[4]-this.m[0]*this.m[5]);this.m[0]=t,this.m[1]=r,this.m[2]=n,this.m[3]=a,this.m[4]=i,this.m[5]=o}},{key:"rotate",value:function(e){var t=Math.cos(e),r=Math.sin(e),n=this.m[0]*t+this.m[2]*r,a=this.m[1]*t+this.m[3]*r,i=this.m[0]*-r+this.m[2]*t,o=this.m[1]*-r+this.m[3]*t;this.m[0]=n,this.m[1]=a,this.m[2]=i,this.m[3]=o}},{key:"translate",value:function(e,t){this.m[4]+=this.m[0]*e+this.m[2]*t,this.m[5]+=this.m[1]*e+this.m[3]*t}},{key:"scale",value:function(e,t){this.m[0]*=e,this.m[1]*=e,this.m[2]*=t,this.m[3]*=t}},{key:"transformPoint",value:function(e,t){var r=e,n=t;return{x:e=r*this.m[0]+n*this.m[2]+this.m[4],y:t=r*this.m[1]+n*this.m[3]+this.m[5]}}}])&&ye(e.prototype,r),n&&ye(e,n),t}(),Ee=function(e,t){var r=new xe;r.translate(e.canvas.width/2,e.canvas.height/2);var n=e.viewport.rotation;0!==n&&r.rotate(n*Math.PI/180);var a=e.viewport.scale,i=e.viewport.scale,o=v(e.image,e.viewport),l=o.tlhc.x-1,s=o.tlhc.y-1,u=o.brhc.x-l,d=o.brhc.y-s;if("NONE"===o.presentationSizeMode)e.image.rowPixelSpacing<e.image.columnPixelSpacing?a*=e.image.columnPixelSpacing/e.image.rowPixelSpacing:e.image.columnPixelSpacing<e.image.rowPixelSpacing&&(i*=e.image.rowPixelSpacing/e.image.columnPixelSpacing);else if(a=o.columnPixelSpacing,i=o.rowPixelSpacing,"SCALE TO FIT"===o.presentationSizeMode){var m=e.canvas.height/(d*i),c=e.canvas.width/(u*a);a=i=Math.min(c,m),o.rowPixelSpacing<o.columnPixelSpacing?a*=o.columnPixelSpacing/o.rowPixelSpacing:o.columnPixelSpacing<o.rowPixelSpacing&&(i*=o.rowPixelSpacing/o.columnPixelSpacing)}return r.scale(a,i),0!==n&&r.rotate(-n*Math.PI/180),r.translate(e.viewport.translation.x,e.viewport.translation.y),0!==n&&r.rotate(n*Math.PI/180),void 0!==t&&r.scale(t,t),e.viewport.hflip&&r.scale(-1,1),e.viewport.vflip&&r.scale(1,-1),r.translate(-u/2,-d/2),r.translate(-l,-s),r},Ie=function(e){return Ee(e)},Te=function(e,t){var r=C(e),n=Ie(r);return n.invert(),n.transformPoint(t.x,t.y)},Ce=function(e){if(void 0===e)throw new Error("disable: element must not be undefined");for(var t=s(),r=0;r<t.length;r++)if(t[r].element===e){var n={element:e};R(e,T.ELEMENT_DISABLED,n),R(o,T.ELEMENT_DISABLED,n),t[r].element.removeChild(t[r].canvas),t[r].canvas=void 0,t.splice(r,1);break}},Le=function(){return window.performance?performance.now():Date.now()},Pe=function(e,t,r){if(void 0===e)throw new Error("displayImage: parameter element must not be undefined");if(void 0===t)throw new Error("displayImage: parameter image must not be undefined");var n,a=C(e),i=a.image;if(a.image=t,a.layers&&a.layers.length&&S(e,t),void 0===a.viewport&&(a.viewport=g(a.canvas,t)),r)for(var o in r)null!==r[o]&&(a.viewport[o]=r[o]);void 0!==a.lastImageTimeStamp&&(n=(1e3/(Le()-a.lastImageTimeStamp)).toFixed());a.lastImageTimeStamp=Le();var l={viewport:a.viewport,element:a.element,image:a.image,oldImage:i,enabledElement:a,frameRate:n};R(a.element,T.NEW_IMAGE,l),P(e)},Re=function(e){var t=C(e);h(t)},De=function(){for(var e=s(),t=0;t<e.length;t++){var r=e[t];!0===r.invalid&&h(r,!0)}},Se=function(e){var t=C(e),r=t.image;t.viewport.scale=f(t.canvas,r,t.viewport.rotation).scaleFactor,t.viewport.translation.x=0,t.viewport.translation.y=0,P(e)};var Ae=function(e,t){var r,n,a=C(e),i=a.canvas.width,o=a.canvas.height;r=e,(n=a.canvas).width!==r.clientWidth&&(n.width=r.clientWidth,n.style.width="".concat(r.clientWidth,"px")),n.height!==r.clientHeight&&(n.height=r.clientHeight,n.style.height="".concat(r.clientHeight,"px"));var l,s,u,d,m,c,f,g,v,h,p,w,b,y,x,E,I={element:e};(R(e,T.ELEMENT_RESIZED,I),void 0!==a.image)&&(t||(v=i,h=o,p=(g=a).viewport.scale,w=L(g.image,g.viewport.rotation),b=Math.round(w.width*p),y=Math.round(w.height*p),x=g.viewport.translation.x,E=g.viewport.translation.y,b===v&&y<=h||b<=v&&y===h&&0===x&&0===E)?Se(e):(s=i,u=o,d=(l=a).viewport.scale,m=l.canvas.width/s,c=l.canvas.height/u,f=Math.sqrt(m*c),l.viewport.scale=f*d,P(e)))},_e=function(e){var t=(e.viewport||{}).invert,r=(e.options||{}).fillStyle;return-1!==["black","white"].indexOf(r)&&t?"white":"black"},Me=function(e,t,r){var n=Le(),a=e.getPixelData();e.stats.lastGetPixelDataTime=Le()-n;var i=a.length,o=e.minPixelValue,l=3,s=0;if(n=Le(),a instanceof Int16Array)if(o<0)for(;s<i;)r[l]=t[a[s++]+-o],l+=4;else for(;s<i;)r[l]=t[a[s++]],l+=4;else if(a instanceof Uint16Array)for(;s<i;)r[l]=t[a[s++]],l+=4;else if(o<0)for(;s<i;)r[l]=t[a[s++]+-o],l+=4;else for(;s<i;)r[l]=t[a[s++]],l+=4;e.stats.lastStoredPixelDataToCanvasImageDataTime=Le()-n},Oe=function(e,t,r){var n=Le(),a=e.getPixelData();e.stats.lastGetPixelDataTime=Le()-n;var i,o=a.length,l=e.minPixelValue,s=0,u=0;if(n=Le(),a instanceof Int16Array)if(l<0)for(;u<o;)i=t[a[u++]+-l],r[s++]=i,r[s++]=i,r[s++]=i,r[s++]=255;else for(;u<o;)i=t[a[u++]],r[s++]=i,r[s++]=i,r[s++]=i,r[s++]=255;else if(a instanceof Uint16Array)for(;u<o;)i=t[a[u++]],r[s++]=i,r[s++]=i,r[s++]=i,r[s++]=255;else if(l<0)for(;u<o;)i=t[a[u++]+-l],r[s++]=i,r[s++]=i,r[s++]=i,r[s++]=255;else for(;u<o;)i=t[a[u++]],r[s++]=i,r[s++]=i,r[s++]=i,r[s++]=255;e.stats.lastStoredPixelDataToCanvasImageDataTime=Le()-n},Ve=function(e,t,r){if(void 0===e)throw new Error("setToPixelCoordinateSystem: parameter enabledElement must not be undefined");if(void 0===t)throw new Error("setToPixelCoordinateSystem: parameter context must not be undefined");var n=Ee(e,r);t.setTransform(n.m[0],n.m[1],n.m[2],n.m[3],n.m[4],n.m[5])},Ue={};var Ne={storedPixelDataToImageData:function(e){for(var t=e.getPixelData(),r=new Uint8Array(e.width*e.height*3),n=0,a=0;a<t.length;a++){var i=Math.abs(t[a]);r[n++]=255&i,r[n++]=i>>8,r[n++]=t[a]<0?0:1}return r}};Ue.frag="precision mediump float;uniform sampler2D u_image;uniform float ww;uniform float wc;uniform float slope;uniform float intercept;uniform int invert;varying vec2 v_texCoord;void main() {vec4 color = texture2D(u_image, v_texCoord);float intensity = color.r*256.0 + color.g*65536.0;if (color.b == 0.0)intensity = -intensity;intensity = intensity * slope + intercept;float center0 = wc - 0.5;float width0 = max(ww, 1.0);intensity = (intensity - center0) / width0 + 0.5;intensity = clamp(intensity, 0.0, 1.0);gl_FragColor = vec4(intensity, intensity, intensity, 1.0);if (invert == 1)gl_FragColor.rgb = 1.0 - gl_FragColor.rgb;}";var Be={};var ke={storedPixelDataToImageData:function(e){for(var t=e.getPixelData(),r=new Uint8Array(e.width*e.height*2),n=0,a=0;a<t.length;a++)r[n++]=t[a],r[n++]=t[a]<0?0:1;return r}};Be.frag="precision mediump float;uniform sampler2D u_image;uniform float ww;uniform float wc;uniform float slope;uniform float intercept;uniform int invert;varying vec2 v_texCoord;void main() {vec4 color = texture2D(u_image, v_texCoord);float intensity = color.r*256.;if (color.a == 0.0)intensity = -intensity;intensity = intensity * slope + intercept;float center0 = wc - 0.5;float width0 = max(ww, 1.0);intensity = (intensity - center0) / width0 + 0.5;intensity = clamp(intensity, 0.0, 1.0);gl_FragColor = vec4(intensity, intensity, intensity, 1.0);if (invert == 1)gl_FragColor.rgb = 1.0 - gl_FragColor.rgb;}";var Fe={};var Ge={storedPixelDataToImageData:function(e){var t=e.minPixelValue,r=0,n=0,a=e.width*e.height*4,i=e.width*e.height*3,o=e.getPixelData(),l=new Uint8Array(i);if(t<0)for(;n<a;)l[r++]=o[n++]+-t,l[r++]=o[n++]+-t,l[r++]=o[n++]+-t,n+=1;else for(;n<a;)l[r++]=o[n++],l[r++]=o[n++],l[r++]=o[n++],n+=1;return l}};Fe.frag="precision mediump float;uniform sampler2D u_image;uniform float ww;uniform float wc;uniform float slope;uniform float intercept;uniform float minPixelValue;uniform int invert;varying vec2 v_texCoord;void main() {vec3 color = texture2D(u_image, v_texCoord).xyz;color = color * 256.0 * slope + intercept;float center0 = wc - 0.5 - minPixelValue;float width0 = max(ww, 1.0);color = (color - center0) / width0 + 0.5;gl_FragColor = vec4(color, 1);if (invert == 1)gl_FragColor.rgb = 1. - gl_FragColor.rgb;}";var ze={};var qe={storedPixelDataToImageData:function(e){for(var t=e.getPixelData(),r=new Uint8Array(e.width*e.height*2),n=0,a=0;a<t.length;a++){var i=t[a];r[n++]=255&i,r[n++]=i>>8}return r}};ze.frag="precision mediump float;uniform sampler2D u_image;uniform float ww;uniform float wc;uniform float slope;uniform float intercept;uniform int invert;varying vec2 v_texCoord;void main() {vec4 color = texture2D(u_image, v_texCoord);float intensity = color.r*256.0 + color.a*65536.0;intensity = intensity * slope + intercept;float center0 = wc - 0.5;float width0 = max(ww, 1.0);intensity = (intensity - center0) / width0 + 0.5;intensity = clamp(intensity, 0.0, 1.0);gl_FragColor = vec4(intensity, intensity, intensity, 1.0);if (invert == 1)gl_FragColor.rgb = 1.0 - gl_FragColor.rgb;}";var We={};var je={storedPixelDataToImageData:function(e){return e.getPixelData()}};We.frag="precision mediump float;uniform sampler2D u_image;uniform float ww;uniform float wc;uniform float slope;uniform float intercept;uniform int invert;varying vec2 v_texCoord;void main() {vec4 color = texture2D(u_image, v_texCoord);float intensity = color.r*256.0;intensity = intensity * slope + intercept;float center0 = wc - 0.5;float width0 = max(ww, 1.0);intensity = (intensity - center0) / width0 + 0.5;intensity = clamp(intensity, 0.0, 1.0);gl_FragColor = vec4(intensity, intensity, intensity, 1.0);if (invert == 1)gl_FragColor.rgb = 1.0 - gl_FragColor.rgb;}";var He={int16:Ue,int8:Be,rgb:Fe,uint16:ze,uint8:We},Xe={int16:Ne,int8:ke,rgb:Ge,uint16:qe,uint8:je},Ye="attribute vec2 a_position;attribute vec2 a_texCoord;uniform vec2 u_resolution;varying vec2 v_texCoord;void main() {vec2 zeroToOne = a_position / u_resolution;vec2 zeroToTwo = zeroToOne * 2.0;vec2 clipSpace = zeroToTwo - 1.0;gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);v_texCoord = a_texCoord;}",Ke={},Ze=[],$e=268435456,Je=0;function Qe(){if(!(Je<=$e)){for(Ze.sort(function(e,t){return e.timeStamp>t.timeStamp?-1:e.timeStamp<t.timeStamp?1:0});$e<Je;){var e=Ze[Ze.length-1];Je-=e.sizeInBytes,delete Ke[e.imageId],Ze.pop(),R(o,T.WEBGL_TEXTURE_REMOVED,{imageId:e.imageId})}var t={maximumSizeInBytes:$e,cacheSizeInBytes:Je,numberOfImagesCached:Ze.length};R(o,T.WEBGL_TEXTURE_CACHE_FULL,t)}}var et={purgeCache:function(){for(;0<Ze.length;){var e=Ze.pop();delete Ke[e.imageId]}Je=0},getImageTexture:function(e){if(void 0===e)throw new Error("getImageTexture: imageId must not be undefined");var t=Ke[e];if(void 0!==t)return t.timeStamp=new Date,t.imageTexture},putImageTexture:function(e,t){var r=e.imageId;if(void 0===e)throw new Error("putImageTexture: image must not be undefined");if(void 0===r)throw new Error("putImageTexture: imageId must not be undefined");if(void 0===t)throw new Error("putImageTexture: imageTexture must not be undefined");if(!0===Object.prototype.hasOwnProperty.call(Ke,r))throw new Error("putImageTexture: imageId already in cache");var n={imageId:r,imageTexture:t,timeStamp:new Date,sizeInBytes:t.sizeInBytes};if(Ke[r]=n,Ze.push(n),void 0===t.sizeInBytes)throw new Error("putImageTexture: imageTexture.sizeInBytes must not be undefined");if(void 0===t.sizeInBytes.toFixed)throw new Error("putImageTexture: imageTexture.sizeInBytes is not a number");Je+=n.sizeInBytes,Qe()},removeImageTexture:function(e){if(void 0===e)throw new Error("removeImageTexture: imageId must not be undefined");var t=Ke[e];if(void 0===t)throw new Error("removeImageTexture: imageId must not be undefined");return Ze.splice(Ze.indexOf(t),1),Je-=t.sizeInBytes,delete Ke[e],t.imageTexture},setMaximumSizeBytes:function(e){if(void 0===e)throw new Error("setMaximumSizeBytes: parameter numBytes must not be undefined");if(void 0===e.toFixed)throw new Error("setMaximumSizeBytes: parameter numBytes must be a number");$e=e,Qe()}};function tt(e,t,r){var n=e.createShader(r);if(e.shaderSource(n,t),e.compileShader(n),!e.getShaderParameter(n,e.COMPILE_STATUS)&&!e.isContextLost()){var a=e.getShaderInfoLog(n);console.error("Could not compile shader:\n".concat(a))}return n}var rt,nt,at,it=function(e,t,r){return function(e,t,r){var n=e.createProgram();if(e.attachShader(n,t),e.attachShader(n,r),e.linkProgram(n),!e.getProgramParameter(n,e.LINK_STATUS)&&!e.isContextLost()){var a=e.getProgramInfoLog(n);console.error("WebGL program filed to link:\n".concat(a))}return n}(e,tt(e,t,e.VERTEX_SHADER),tt(e,r,e.FRAGMENT_SHADER))},ot=document.createElement("canvas"),lt=!1;function st(){!0!==lt&&function(e){rt=null;try{var t={desynchronized:!0,preserveDrawingBuffer:!0};rt=e.getContext("webgl",t)||e.getContext("experimental-webgl",t),e.removeEventListener("webglcontextlost",ut,!1),e.addEventListener("webglcontextlost",ut,!1),e.removeEventListener("webglcontextrestored",dt,!1),e.addEventListener("webglcontextrestored",dt,!1)}catch(e){throw new Error("Error creating WebGL context")}rt||(console.error("Unable to initialize WebGL. Your browser may not support it."),rt=null);return rt}(ot)&&(at=rt.createBuffer(),rt.bindBuffer(rt.ARRAY_BUFFER,at),rt.bufferData(rt.ARRAY_BUFFER,new Float32Array([1,1,0,1,1,0,0,0]),rt.STATIC_DRAW),nt=rt.createBuffer(),rt.bindBuffer(rt.ARRAY_BUFFER,nt),rt.bufferData(rt.ARRAY_BUFFER,new Float32Array([1,1,0,1,1,0,0,0]),rt.STATIC_DRAW),function(){for(var e in He){var t=He[e];t.attributes={},t.uniforms={},t.vert=Ye,t.program=it(rt,t.vert,t.frag),t.attributes.texCoordLocation=rt.getAttribLocation(t.program,"a_texCoord"),rt.enableVertexAttribArray(t.attributes.texCoordLocation),t.attributes.positionLocation=rt.getAttribLocation(t.program,"a_position"),rt.enableVertexAttribArray(t.attributes.positionLocation),t.uniforms.resolutionLocation=rt.getUniformLocation(t.program,"u_resolution")}}(),lt=!0)}function ut(e){e.preventDefault(),console.warn("WebGL Context Lost!")}function dt(e){e.preventDefault(),lt=!1,et.purgeCache(),st()}function mt(e){if(e.color)return"rgb";var t=e.getPixelData();return t instanceof Int16Array?"int16":t instanceof Uint16Array?"uint16":t instanceof Int8Array?"int8":"uint8"}function ct(e){var t=et.getImageTexture(e.imageId);return t||(t=function(e){var t={uint8:rt.LUMINANCE,int8:rt.LUMINANCE_ALPHA,uint16:rt.LUMINANCE_ALPHA,int16:rt.RGB,rgb:rt.RGB},r=mt(e),n=t[r],a=rt.createTexture();rt.bindTexture(rt.TEXTURE_2D,a),rt.texParameteri(rt.TEXTURE_2D,rt.TEXTURE_MIN_FILTER,rt.NEAREST),rt.texParameteri(rt.TEXTURE_2D,rt.TEXTURE_MAG_FILTER,rt.NEAREST),rt.texParameteri(rt.TEXTURE_2D,rt.TEXTURE_WRAP_S,rt.CLAMP_TO_EDGE),rt.texParameteri(rt.TEXTURE_2D,rt.TEXTURE_WRAP_T,rt.CLAMP_TO_EDGE),rt.pixelStorei(rt.UNPACK_ALIGNMENT,1);var i=Xe[r].storedPixelDataToImageData(e,e.width,e.height);return rt.texImage2D(rt.TEXTURE_2D,0,n,e.width,e.height,0,n,rt.UNSIGNED_BYTE,i),{texture:a,sizeInBytes:e.width*e.height*{int8:1,uint16:2,int16:3,rgb:3}[r]}}(e),et.putImageTexture(e,t)),t.texture}function ft(e,t,r,n,a){for(var i in rt.clearColor(1,0,0,1),rt.viewport(0,0,n,a),rt.clear(rt.COLOR_BUFFER_BIT|rt.DEPTH_BUFFER_BIT),rt.useProgram(e.program),rt.bindBuffer(rt.ARRAY_BUFFER,nt),rt.vertexAttribPointer(e.attributes.texCoordLocation,2,rt.FLOAT,!1,0,0),rt.bindBuffer(rt.ARRAY_BUFFER,at),rt.vertexAttribPointer(e.attributes.positionLocation,2,rt.FLOAT,!1,0,0),t){var o=rt.getUniformLocation(e.program,i);if(o){var l=t[i],s=l.type,u=l.value;"i"===s?rt.uniform1i(o,u):"f"===s?rt.uniform1f(o,u):"2f"===s&&rt.uniform2f(o,u[0],u[1])}}var d,m,c;m=n,c=a,(d=rt).bufferData(d.ARRAY_BUFFER,new Float32Array([m,c,0,c,m,0,0,0]),d.STATIC_DRAW),rt.activeTexture(rt.TEXTURE0),rt.bindTexture(rt.TEXTURE_2D,r),rt.drawArrays(rt.TRIANGLE_STRIP,0,4)}var gt={createProgramFromString:it,renderer:{render:function(e){var t=e.image;ot.width=t.width,ot.height=t.height;var r,n=e.viewport,a=(r=mt(t),He.hasOwnProperty(r)?He[r]:He.rgb),i=ct(t);return ft(a,{u_resolution:{type:"2f",value:[t.width,t.height]},wc:{type:"f",value:n.voi.windowCenter},ww:{type:"f",value:n.voi.windowWidth},slope:{type:"f",value:t.slope},intercept:{type:"f",value:t.intercept},minPixelValue:{type:"f",value:t.minPixelValue},invert:{type:"i",value:n.invert?1:0}},i,t.width,t.height),ot},initRenderer:st,getRenderCanvas:function(){return ot},isWebGLAvailable:function(){var e={failIfMajorPerformanceCaveat:!0};try{var t=document.createElement("canvas");return Boolean(window.WebGLRenderingContext)&&(t.getContext("webgl",e)||t.getContext("experimental-webgl",e))}catch(e){return!1}}},textureCache:et};Object.defineProperty(gt,"isWebGLInitialized",{enumerable:!0,configurable:!1,get:function(){return lt}});var vt=gt;function ht(e,t){if(!((r=e).voiLUT&&r.voiLUT.lut&&0<r.voiLUT.lut.length||void 0!==r.voi.windowWidth&&void 0!==r.voi.windowCenter)){var r,n=t.maxPixelValue*t.slope+t.intercept,a=t.minPixelValue*t.slope+t.intercept,i=n-a,o=(n+a)/2;void 0===e.voi?e.voi={windowWidth:i,windowCenter:o}:(e.voi.windowWidth=i,e.voi.windowCenter=o)}}var pt=function(e,t){return!e&&!t||!(!e||!t)&&e.id===t.id};var wt=function(e,t,r){return r?(a=(n=r).lut[0],i=n.lut[n.lut.length-1],o=n.firstValueMapped+n.lut.length,function(e){return e<n.firstValueMapped?a:o<=e?i:n.lut[e]}):(l=e,s=t,function(e){return e*l+s});var n,a,i,o,l,s};function bt(e){return function(e){if(Array.isArray(e))return yt(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return yt(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return yt(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function yt(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}var xt=function(e,t,r,n){return r?(a=r,i=n,o=Math.max.apply(Math,bt(a.lut)).toString(2).length-8,l=a.lut[0]>>o,s=a.lut[a.lut.length-1]>>o,u=a.firstValueMapped+a.lut.length-1,function(e){return e<a.firstValueMapped?l:u<=e?s:i?a.lut[Math.round(e)-a.firstValueMapped]>>o:a.lut[e-a.firstValueMapped]>>o}):(d=e,m=t,function(e){return 255*((e-m)/d+.5)});var a,i,o,l,s,u,d,m},Et=function(e,t,r,n,a,i){var o=e.maxPixelValue,l=e.minPixelValue,s=Math.min(l,0);if(void 0===e.cachedLut){var u=o-s+1;e.cachedLut={},e.cachedLut.lutArray=new Uint8ClampedArray(u)}var d=e.cachedLut.lutArray,m=Boolean(e.slope%1)||Boolean(e.intercept%1),c=wt(e.slope,e.intercept,a),f=xt(t,r,i,m);if(!0===n)for(var g=l;g<=o;g++)d[g+-s]=255-f(c(g));else for(var v=l;v<=o;v++)d[v+-s]=f(c(v));return d},It=function(e,t,r){return void 0!==e.cachedLut&&e.cachedLut.windowCenter===t.voi.windowCenter&&e.cachedLut.windowWidth===t.voi.windowWidth&&pt(e.cachedLut.modalityLUT,t.modalityLUT)&&pt(e.cachedLut.voiLUT,t.voiLUT)&&e.cachedLut.invert===t.invert&&!0!==r||(ht(t,e),Et(e,t.voi.windowWidth,t.voi.windowCenter,t.invert,t.modalityLUT,t.voiLUT),e.cachedLut.windowWidth=t.voi.windowWidth,e.cachedLut.windowCenter=t.voi.windowCenter,e.cachedLut.invert=t.invert,e.cachedLut.voiLUT=t.voiLUT,e.cachedLut.modalityLUT=t.modalityLUT),e.cachedLut.lutArray},Tt=function(e,t){var r=e.renderingTools.lastRenderedImageId,n=e.renderingTools.lastRenderedViewport;return t.imageId!==r||!n||n.windowCenter!==e.viewport.voi.windowCenter||n.windowWidth!==e.viewport.voi.windowWidth||n.invert!==e.viewport.invert||n.rotation!==e.viewport.rotation||n.hflip!==e.viewport.hflip||n.vflip!==e.viewport.vflip||n.modalityLUT!==e.viewport.modalityLUT||n.voiLUT!==e.viewport.voiLUT||n.colormap!==e.viewport.colormap},Ct=function(e,t){var r=e.renderingTools.renderCanvas;r.width=t.width,r.height=t.height;var n=r.getContext("2d",{desynchronized:!0});n.fillStyle="white",n.fillRect(0,0,r.width,r.height);var a=n.getImageData(0,0,t.width,t.height);e.renderingTools.renderCanvasContext=n,e.renderingTools.renderCanvasData=a},Lt=function(e){var t=e.image.imageId,r=e.viewport,n=e.image.color;return e.renderingTools.lastRenderedImageId=t,e.renderingTools.lastRenderedIsColor=n,e.renderingTools.lastRenderedViewport={windowCenter:r.voi.windowCenter,windowWidth:r.voi.windowWidth,invert:r.invert,rotation:r.rotation,hflip:r.hflip,vflip:r.vflip,modalityLUT:r.modalityLUT,voiLUT:r.voiLUT,colormap:r.colormap},e.renderingTools};function Pt(e,t,r){var n=!(3<arguments.length&&void 0!==arguments[3])||arguments[3],a=!0===e.renderingTools.lastRenderedIsColor;e.renderingTools.renderCanvas&&!a||(e.renderingTools.renderCanvas=document.createElement("canvas"),Ct(e,t));var i=e.renderingTools.renderCanvas;if(!1===Tt(e,t)&&!0!==r)return i;i.width===t.width&&i.height===t.height||Ct(e,t);var o=Le(),l=It(t,e.viewport,r);t.stats=t.stats||{},t.stats.lastLutGenerateTime=Le()-o;var s=e.renderingTools.renderCanvasData,u=e.renderingTools.renderCanvasContext;return n?Me(t,l,s.data):Oe(t,l,s.data),o=Le(),u.putImageData(s,0,0),t.stats.lastPutImageDataTime=Le()-o,i}function Rt(e,t){if(void 0===e)throw new Error("drawImage: enabledElement parameter must not be undefined");var r=e.image;if(void 0===r)throw new Error("drawImage: image must be loaded before it can be drawn");var n,a=e.canvas.getContext("2d",{desynchronized:!0});a.setTransform(1,0,0,1,0,0),a.fillStyle=_e(e),a.fillRect(0,0,e.canvas.width,e.canvas.height),a.imageSmoothingEnabled=!e.viewport.pixelReplication,a.mozImageSmoothingEnabled=a.imageSmoothingEnabled,Ve(e,a),n=e.options&&e.options.renderer&&"webgl"===e.options.renderer.toLowerCase()?vt.renderer.render(e):Pt(e,r,t);var i=v(e.image,e.viewport),o=i.tlhc.x-1,l=i.tlhc.y-1,s=i.brhc.x-o,u=i.brhc.y-l;a.drawImage(n,o,l,s,u,o,l,s,u),e.renderingTools=Lt(e)}var Dt=function(e,t,r,n,a){var i=e.maxPixelValue,o=e.minPixelValue,l=Math.min(o,0);if(void 0===e.cachedLut){var s=i-l+1;e.cachedLut={},e.cachedLut.lutArray=new Uint8ClampedArray(s)}var u=e.cachedLut.lutArray,d=xt(t,r,a);if(!0===n)for(var m=o;m<=i;m++)u[m+-l]=255-d(m);else for(var c=o;c<=i;c++)u[c+-l]=d(c);return u},St=function(e,t,r){var n=Le(),a=e.getPixelData();e.stats.lastGetPixelDataTime=Le()-n;var i=e.minPixelValue,o=0,l=0,s=a.length;if(n=Le(),i<0)for(;l<s;)r[o++]=t[a[l++]+-i],r[o++]=t[a[l++]+-i],r[o]=t[a[l]+-i],l+=2,o+=2;else for(;l<s;)r[o++]=t[a[l++]],r[o++]=t[a[l++]],r[o]=t[a[l]],l+=2,o+=2;e.stats.lastStoredPixelDataToCanvasImageDataTime=Le()-n},At=function(e,t,r){var n=Le(),a=e.getPixelData();e.stats.lastGetPixelDataTime=Le()-n;var i=e.minPixelValue,o=0,l=0,s=a.length;if(n=Le(),i<0)for(;l<s;)r[o++]=t[a[l++]+-i],r[o++]=t[a[l++]+-i],r[o++]=t[a[l++]+-i],r[o++]=a[l++];else for(;l<s;)r[o++]=t[a[l++]],r[o++]=t[a[l++]],r[o++]=t[a[l++]],r[o++]=a[l++];e.stats.lastStoredPixelDataToCanvasImageDataTime=Le()-n};function _t(e,t,r){var n=!0===e.renderingTools.lastRenderedIsColor;e.renderingTools.renderCanvas&&n||(e.renderingTools.renderCanvas=document.createElement("canvas"));var a=e.renderingTools.renderCanvas;if(255===e.viewport.voi.windowWidth&&128===e.viewport.voi.windowCenter&&!1===e.viewport.invert&&t.getCanvas&&t.getCanvas())return t.getCanvas();if(!1===Tt(e,t)&&!0!==r)return a;a.width===t.width&&a.height===t.height||Ct(e,t);var i,o,l=Le(),s=(i=t,o=e.viewport,void 0!==i.cachedLut&&i.cachedLut.windowCenter===o.voi.windowCenter&&i.cachedLut.windowWidth===o.voi.windowWidth&&i.cachedLut.invert===o.invert||(Dt(i,o.voi.windowWidth,o.voi.windowCenter,o.invert),i.cachedLut.windowWidth=o.voi.windowWidth,i.cachedLut.windowCenter=o.voi.windowCenter,i.cachedLut.invert=o.invert),i.cachedLut.lutArray);t.stats=t.stats||{},t.stats.lastLutGenerateTime=Le()-l;var u=e.renderingTools.renderCanvasData,d=e.renderingTools.renderCanvasContext;return t.rgba?At(t,s,u.data):St(t,s,u.data),l=Le(),d.putImageData(u,0,0),t.stats.lastPutImageDataTime=Le()-l,a}function Mt(e,t){if(void 0===e)throw new Error("renderColorImage: enabledElement parameter must not be undefined");var r=e.image;if(void 0===r)throw new Error("renderColorImage: image must be loaded before it can be drawn");var n,a=e.canvas.getContext("2d",{desynchronized:!0});a.setTransform(1,0,0,1,0,0),a.fillStyle=_e(e),a.fillRect(0,0,e.canvas.width,e.canvas.height),a.imageSmoothingEnabled=!e.viewport.pixelReplication,a.mozImageSmoothingEnabled=a.imageSmoothingEnabled,Ve(e,a),n=e.options&&e.options.renderer&&"webgl"===e.options.renderer.toLowerCase()?vt.renderer.render(e):_t(e,r,t);var i=v(e.image,e.viewport),o=i.tlhc.x-1,l=i.tlhc.y-1,s=i.brhc.x-o,u=i.brhc.y-l;a.drawImage(n,o,l,s,u,o,l,s,u),e.renderingTools=Lt(e)}var Ot=function(e,t,r,n){var a=Le(),i=e.getPixelData();e.stats.lastGetPixelDataTime=Le()-a;var o,l,s=i.length,u=e.minPixelValue,d=0,m=0;if(a=Le(),l=r instanceof G.LookupTable?r.Table:r,u<0)for(;m<s;)o=l[t[i[m++]+-u]],n[d++]=o[0],n[d++]=o[1],n[d++]=o[2],n[d++]=o[3];else for(;m<s;)o=l[t[i[m++]]],n[d++]=o[0],n[d++]=o[1],n[d++]=o[2],n[d++]=o[3];e.stats.lastStoredPixelDataToCanvasImageDataTime=Le()-a};function Vt(e,t,r){e.renderingTools.renderCanvas||(e.renderingTools.renderCanvas=document.createElement("canvas"));var n=e.renderingTools.renderCanvas,a=e.viewport.colormap||e.options.colormap;if(e.options&&e.options.colormap&&console.warn("enabledElement.options.colormap is deprecated. Use enabledElement.viewport.colormap instead"),a&&"string"==typeof a&&(a=G.getColormap(a)),!a)throw new Error("renderPseudoColorImage: colormap not found.");var i=a.getId();if(!1===Tt(e,t)&&!0!==r&&e.renderingTools.colormapId===i)return n;n.width===t.width&&n.height===t.height||Ct(e,t);var o=Le();e.renderingTools.colorLut&&!r&&e.renderingTools.colormapId===i||(a.setNumberOfColors(256),e.renderingTools.colorLut=a.createLookupTable(),e.renderingTools.colormapId=i);var l=It(t,e.viewport,r);t.stats=t.stats||{},t.stats.lastLutGenerateTime=Le()-o;var s=e.renderingTools.colorLut,u=e.renderingTools.renderCanvasData,d=e.renderingTools.renderCanvasContext;return Ot(t,l,s,u.data),o=Le(),d.putImageData(u,0,0),t.stats.lastPutImageDataTime=Le()-o,n}function Ut(e,t){if(void 0===e)throw new Error("drawImage: enabledElement parameter must not be undefined");var r=e.image;if(void 0===r)throw new Error("drawImage: image must be loaded before it can be drawn");var n=e.canvas.getContext("2d",{desynchronized:!0});n.setTransform(1,0,0,1,0,0),n.fillStyle=_e(e),n.fillRect(0,0,e.canvas.width,e.canvas.height),n.imageSmoothingEnabled=!e.viewport.pixelReplication,n.mozImageSmoothingEnabled=n.imageSmoothingEnabled,Ve(e,n);var a=Vt(e,r,t),i=v(e.image,e.viewport),o=i.tlhc.x-1,l=i.tlhc.y-1,s=i.brhc.x-o,u=i.brhc.y-l;n.drawImage(a,o,l,s,u,o,l,s,u),e.renderingTools=Lt(e)}var Nt=function(e,t,r){var n=Le(),a=e.getPixelData();e.stats.lastGetPixelDataTime=Le()-n;var i,o,l=a.length,s=e.minPixelValue,u=0,d=0;if(n=Le(),o=t instanceof G.LookupTable?t.Table:t,s<0)for(;d<l;)i=o[a[d++]+-s],r[u++]=i[0],r[u++]=i[1],r[u++]=i[2],r[u++]=i[3];else for(;d<l;)i=o[a[d++]],r[u++]=i[0],r[u++]=i[1],r[u++]=i[2],r[u++]=i[3];e.stats.lastStoredPixelDataToCanvasImageDataTime=Le()-n};function Bt(e,t,r){e.renderingTools.renderCanvas||(e.renderingTools.renderCanvas=document.createElement("canvas"));var n=e.renderingTools.renderCanvas,a=e.viewport.colormap||e.options.colormap;if(e.options.colormap&&console.warn("enabledElement.options.colormap is deprecated. Use enabledElement.viewport.colormap instead"),a&&"string"==typeof a&&(a=G.getColormap(a)),!a)throw new Error("renderLabelMapImage: colormap not found.");var i=a.getId();if(!1===Tt(e,t)&&!0!==r&&e.renderingTools.colormapId===i)return n;n.width===t.width&&n.height===t.height||Ct(e,t);var o=Le();e.renderingTools.colorLut&&!r&&e.renderingTools.colormapId===i||(e.renderingTools.colorLut=a.createLookupTable(),e.renderingTools.colormapId=i),t.stats=t.stats||{},t.stats.lastLutGenerateTime=Le()-o;var l=e.renderingTools.colorLut,s=e.renderingTools.renderCanvasData,u=e.renderingTools.renderCanvasContext;return Nt(t,l,s.data),o=Le(),u.putImageData(s,0,0),t.stats.lastPutImageDataTime=Le()-o,n}function kt(e,t){if(void 0===e)throw new Error("renderLabelMapImage: enabledElement parameter must not be undefined");var r=e.image;if(void 0===r)throw new Error("renderLabelMapImage: image must be loaded before it can be drawn");var n=e.canvas.getContext("2d",{desynchronized:!0});n.setTransform(1,0,0,1,0,0),n.fillStyle=_e(e),n.fillRect(0,0,e.canvas.width,e.canvas.height),n.imageSmoothingEnabled=!e.viewport.pixelReplication,n.mozImageSmoothingEnabled=n.imageSmoothingEnabled,Ve(e,n);var a=Bt(e,r,t),i=v(e.image,e.viewport),o=i.tlhc.x-1,l=i.tlhc.y-1,s=i.brhc.x-o,u=i.brhc.y-l;n.drawImage(a,o,l,s,u,o,l,s,u),e.renderingTools=Lt(e)}function Ft(e){var t=e.syncProps||{};t.originalScale=e.viewport.scale,e.syncProps=t}function Gt(e,a){e.forEach(function(e){if(e!==a&&e.viewport&&a.viewport){e.syncProps||Ft(e);var t,r,n=(r=e,(t=a).syncProps||Ft(t),r.syncProps||Ft(r),r.syncProps.originalScale/t.syncProps.originalScale);e.viewport.scale=a.viewport.scale*n,e.viewport.rotation=a.viewport.rotation,e.viewport.translation={x:a.viewport.translation.x/n,y:a.viewport.translation.y/n},e.viewport.hflip=a.viewport.hflip,e.viewport.vflip=a.viewport.vflip}})}function zt(d,e,m){e.forEach(function(e,t){if(e.image){d.save(),e.canvas=d.canvas,Ve(e,d);var r=e.viewport.colormap||e.options.colormap,n=e.viewport.labelmap,a=e.invalid||m;if(r&&""!==r&&!0===n)!function(e,t){if(void 0===e)throw new Error("addLabelMapLayer: layer parameter must not be undefined");var r=e.image;if(void 0===r)throw new Error("addLabelMapLayer: image must be loaded before it can be drawn");e.canvas=Bt(e,r,t);var n=e.canvas.getContext("2d",{desynchronized:!0});n.imageSmoothingEnabled=!e.viewport.pixelReplication,n.mozImageSmoothingEnabled=n.imageSmoothingEnabled,e.renderingTools=Lt(e)}(e,a);else if(r&&""!==r)!function(e,t){if(void 0===e)throw new Error("addPseudoColorLayer: layer parameter must not be undefined");var r=e.image;if(void 0===r)throw new Error("addPseudoColorLayer: image must be loaded before it can be drawn");e.canvas=Vt(e,r,t);var n=e.canvas.getContext("2d",{desynchronized:!0});n.imageSmoothingEnabled=!e.viewport.pixelReplication,n.mozImageSmoothingEnabled=n.imageSmoothingEnabled,e.renderingTools=Lt(e)}(e,a);else if(!0===e.image.color)!function(e,t){if(void 0===e)throw new Error("addColorLayer: layer parameter must not be undefined");var r=e.image;if(void 0===r)throw new Error("addColorLayer: image must be loaded before it can be drawn");r.rgba=!0,e.canvas=_t(e,r,t);var n=e.canvas.getContext("2d",{desynchronized:!0});n.imageSmoothingEnabled=!e.viewport.pixelReplication,n.mozImageSmoothingEnabled=n.imageSmoothingEnabled,e.renderingTools=Lt(e)}(e,a);else{!function(e,t){var r=2<arguments.length&&void 0!==arguments[2]&&arguments[2];if(void 0===e)throw new Error("addGrayscaleLayer: layer parameter must not be undefined");var n=e.image;if(void 0===n)throw new Error("addGrayscaleLayer: image must be loaded before it can be drawn");e.canvas=Pt(e,n,t,r);var a=e.canvas.getContext("2d",{desynchronized:!0});a.imageSmoothingEnabled=!e.viewport.pixelReplication,a.mozImageSmoothingEnabled=a.imageSmoothingEnabled,e.renderingTools=Lt(e)}(e,a,0===t)}e.options&&e.options.opacity?d.globalAlpha=e.options.opacity:d.globalAlpha=1,e.options&&e.options.fillStyle&&(d.fillStyle=e.options.fillStyle),d.imageSmoothingEnabled=!e.viewport.pixelReplication,d.mozImageSmoothingEnabled=d.imageSmoothingEnabled;var i=v(e.image,e.viewport),o=i.tlhc.x-1,l=i.tlhc.y-1,s=i.brhc.x-o,u=i.brhc.y-l;d.drawImage(e.canvas,o,l,s,u,o,l,s,u),d.restore(),e.invalid=!1}})}var qt=function(e,t){var r=e.image,n=e.element,a=e.layers||[];if(e.canvas&&e.image){var i=Le();if(r.stats={lastGetPixelDataTime:-1,lastStoredPixelDataToCanvasImageDataTime:-1,lastPutImageDataTime:-1,lastRenderTime:-1,lastLutGenerateTime:-1},a&&a.length)!function(e,t){var r=e.element,n=E(r),a=A(r),i=I(r),o=!e.lastSyncViewportsState&&e.syncViewports;e.lastSyncViewportsState=e.syncViewports,o&&n.forEach(function(e){e.viewport&&Ft(e)}),!0===e.syncViewports&&Gt(i,a);var l=e.canvas.getContext("2d",{desynchronized:!0});l.setTransform(1,0,0,1,0,0),l.fillStyle="black",l.fillRect(0,0,e.canvas.width,e.canvas.height),zt(l,i,t)}(e,t);else if(r){var o=r.render;o||(o=e.viewport.colormap&&""!==e.viewport.colormap&&!0===e.image.labelmap?kt:e.viewport.colormap&&""!==e.viewport.colormap?Ut:r.color?Mt:Rt),o(e,t)}var l=Le()-i,s={viewport:e.viewport,element:n,image:r,enabledElement:e,canvasContext:e.canvas.getContext("2d",{desynchronized:!0}),renderTimeInMs:l};r.stats.lastRenderTime=l,e.invalid=!1,e.needsRedraw=!1,R(n,T.IMAGE_RENDERED,s)}};var Wt=function(e){return window.requestAnimationFrame(e)||window.webkitRequestAnimationFrame(e)||window.mozRequestAnimationFrame(e)||window.oRequestAnimationFrame(e)||window.msRequestAnimationFrame(e)||(t=e,void window.setTimeout(t,1e3/60));var t},jt=function(e){return vt.renderer.isWebGLAvailable()?(vt.renderer.initRenderer(),e.renderer="webgl",e.desynchronized=!0,e.preserveDrawingBuffer=!0):(console.error("WebGL not available, falling back to Canvas renderer"),delete e.renderer,delete e.preserveDrawingBuffer,!1)},Ht="cornerstone-canvas";function Xt(e){var t,r,n="canvas.".concat(Ht);return e.querySelector(n)||(t=e,(r=document.createElement("canvas")).style.display="block",r.classList.add(Ht),t.appendChild(r),r)}var Yt=function(e,t){if(void 0===e)throw new Error("enable: parameter element cannot be undefined");t&&t.renderer&&"webgl"===t.renderer.toLowerCase()&&jt(t);var r,a={element:e,canvas:Xt(e),image:void 0,invalid:!1,needsRedraw:!0,options:Object.assign({},t),layers:[],data:{},renderingTools:{},uuid:(r=(new Date).getTime(),"undefined"!=typeof performance&&"function"==typeof performance.now&&(r+=performance.now()),"x.x.x.x.x.x.xxxx.xxx.x.x.xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx".replace(/[xy]/g,function(e){var t=(r+16*Math.random())%16|0;return r=Math.floor(r/16),("x"===e?t:3&t|8).toString(16)}))};i(a),R(o,T.ELEMENT_ENABLED,a),Ae(e,!0),function e(t){if(void 0!==a.canvas){var r,n={enabledElement:a,timestamp:t};R(a.element,T.PRE_RENDER,n),a.needsRedraw&&(void 0!==(r=a).image||0<r.layers.length)&&qt(a,a.invalid),Wt(e)}}()},Kt=function(e,t){var r=C(e);return g(r.canvas,t)},Zt=function(e){return C(e).image},$t=function(e,t,r,n,a){if(void 0===e)throw new Error("getStoredPixels: parameter element must not be undefined");t=Math.round(t),r=Math.round(r);for(var i=C(e),o=[],l=0,s=i.image.getPixelData(),u=0;u<a;u++)for(var d=0;d<n;d++){var m=(u+r)*i.image.columns+(d+t);o[l++]=s[m]}return o},Jt=function(e,t,r,n,a){var i=$t(e,t,r,n,a),o=C(e),l=wt(o.image.slope,o.image.intercept,o.viewport.modalityLUT);return i.map(l)},Qt=function(e){var t=C(e).viewport;if(void 0!==t)return Object.assign({},t)},er={drawImage:h,generateLut:Et,getDefaultViewport:g,requestAnimationFrame:Wt,setDefaultViewport:m,storedPixelDataToCanvasImageData:Me,storedPixelDataToCanvasImageDataRGBA:Oe,storedPixelDataToCanvasImageDataColorLUT:Nt,storedPixelDataToCanvasImageDataPseudocolorLUT:Ot,storedColorPixelDataToCanvasImageData:St,getTransform:Ie,calculateTransform:Ee,Transform:xe},tr=function(e){var t=C(e);t.invalid=!0,t.needsRedraw=!0;var r={element:e};R(e,T.INVALIDATED,r)},rr=function(e){l(e).forEach(function(e){h(e,!0)})},nr=[];var ar={addProvider:function(e){var t,r=1<arguments.length&&void 0!==arguments[1]?arguments[1]:0;for(t=0;t<nr.length&&!(nr[t].priority<=r);t++);nr.splice(t,0,{priority:r,provider:e})},removeProvider:function(e){for(var t=0;t<nr.length;t++)if(nr[t].provider===e){nr.splice(t,1);break}},get:function(e,t){for(var r=0;r<nr.length;r++){var n=nr[r].provider(e,t);if(void 0!==n)return n}}},ir=function(e,t,r){var n=C(e);if(void 0===n.image)throw new Error("image has not been loaded yet");var a=e.getBoundingClientRect(),i={x:t-a.left-window.pageXOffset,y:r-a.top-window.pageYOffset},o=Ie(n);return o.invert(),o.transformPoint(i.x,i.y)},or=function(e,t){var r=C(e);return Ie(r).transformPoint(t.x,t.y)};var lr=function(e,t){var r=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null,n=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;if(void 0===e)throw new Error("renderToCanvas: parameter canvas cannot be undefined");n&&n.renderer&&"webgl"===n.renderer.toLowerCase()&&jt(n);var a=g(e,t);r&&Object.assign(a,r);var i,o={element:i=e,canvas:i,image:t,invalid:!0,needsRedraw:!0,options:n,layers:[],data:{},renderingTools:{},viewport:a},l={enabledElement:o,timestamp:Date.now()};R(o.element,T.PRE_RENDER,l),qt(o,o.invalid)};function sr(e,t){if(void 0===e)throw new Error("renderWebImage: enabledElement parameter must not be undefined");var r=e.image;if(void 0===r)throw new Error("renderWebImage: image must be loaded before it can be drawn");if(e.viewport.voi.windowWidth===e.image.windowWidth&&e.viewport.voi.windowCenter===e.image.windowCenter&&!1===e.viewport.invert){var n=e.canvas.getContext("2d",{desynchronized:!0});n.setTransform(1,0,0,1,0,0),n.fillStyle="black",n.fillRect(0,0,e.canvas.width,e.canvas.height),n.imageSmoothingEnabled=!e.viewport.pixelReplication,n.mozImageSmoothingEnabled=n.imageSmoothingEnabled,Ve(e,n);var a=v(e.image,e.viewport),i=a.tlhc.x-1,o=a.tlhc.y-1,l=a.brhc.x-i,s=a.brhc.y-o;n.drawImage(r.getImage(),i,o,l,s,i,o,l,s)}else Mt(e,t)}var ur={colorImage:Mt,grayscaleImage:Rt,webImage:sr,pseudoColorImage:Ut,labelMapImage:kt,toCanvas:lr},dr=function(e){var t=C(e);t.viewport=g(t.canvas,t.image),P(e)},mr=function(e,t){var r=C(e);if(void 0===r.viewport&&(r.viewport=g(r.canvas)),t)for(var n in t)null!==t[n]&&(r.viewport[n]=t[n]);r.viewport.voi.windowWidth&&(r.viewport.voi.windowWidth=Math.max(r.viewport.voi.windowWidth,1e-6)),r.viewport.scale&&(r.viewport.scale=Math.max(r.viewport.scale,1e-4)),r.viewport.rotation%=360,r.viewport.rotation<0&&(r.viewport.rotation+=360),r.image&&P(e)};r.d(t,"drawImage",function(){return h}),r.d(t,"generateLut",function(){return Et}),r.d(t,"getDefaultViewport",function(){return g}),r.d(t,"setDefaultViewport",function(){return m}),r.d(t,"requestAnimationFrame",function(){return Wt}),r.d(t,"storedPixelDataToCanvasImageData",function(){return Me}),r.d(t,"storedColorPixelDataToCanvasImageData",function(){return St}),r.d(t,"storedPixelDataToCanvasImageDataColorLUT",function(){return Nt}),r.d(t,"storedPixelDataToCanvasImageDataPseudocolorLUT",function(){return Ot}),r.d(t,"internal",function(){return er}),r.d(t,"renderLabelMapImage",function(){return kt}),r.d(t,"renderPseudoColorImage",function(){return Ut}),r.d(t,"renderColorImage",function(){return Mt}),r.d(t,"renderGrayscaleImage",function(){return Rt}),r.d(t,"renderWebImage",function(){return sr}),r.d(t,"renderToCanvas",function(){return lr}),r.d(t,"canvasToPixel",function(){return Te}),r.d(t,"disable",function(){return Ce}),r.d(t,"displayImage",function(){return Pe}),r.d(t,"draw",function(){return Re}),r.d(t,"drawInvalidated",function(){return De}),r.d(t,"enable",function(){return Yt}),r.d(t,"getElementData",function(){return H}),r.d(t,"removeElementData",function(){return X}),r.d(t,"getEnabledElement",function(){return C}),r.d(t,"addEnabledElement",function(){return i}),r.d(t,"getEnabledElementsByImageId",function(){return l}),r.d(t,"getEnabledElements",function(){return s}),r.d(t,"addLayer",function(){return b}),r.d(t,"removeLayer",function(){return y}),r.d(t,"getLayer",function(){return x}),r.d(t,"getLayers",function(){return E}),r.d(t,"getVisibleLayers",function(){return I}),r.d(t,"setActiveLayer",function(){return D}),r.d(t,"getActiveLayer",function(){return A}),r.d(t,"purgeLayers",function(){return _}),r.d(t,"setLayerImage",function(){return S}),r.d(t,"fitToWindow",function(){return Se}),r.d(t,"getDefaultViewportForImage",function(){return Kt}),r.d(t,"getDisplayedArea",function(){return v}),r.d(t,"getImage",function(){return Zt}),r.d(t,"getPixels",function(){return Jt}),r.d(t,"getStoredPixels",function(){return $t}),r.d(t,"getViewport",function(){return Qt}),r.d(t,"loadImage",function(){return le}),r.d(t,"loadAndCacheImage",function(){return se}),r.d(t,"registerImageLoader",function(){return ue}),r.d(t,"registerUnknownImageLoader",function(){return de}),r.d(t,"invalidate",function(){return tr}),r.d(t,"invalidateImageId",function(){return rr}),r.d(t,"pageToPixel",function(){return ir}),r.d(t,"pixelToCanvas",function(){return or}),r.d(t,"reset",function(){return dr}),r.d(t,"resize",function(){return Ae}),r.d(t,"setToPixelCoordinateSystem",function(){return Ve}),r.d(t,"setViewport",function(){return mr}),r.d(t,"updateImage",function(){return P}),r.d(t,"pixelDataToFalseColorData",function(){return z}),r.d(t,"rendering",function(){return ur}),r.d(t,"imageCache",function(){return ae}),r.d(t,"metaData",function(){return ar}),r.d(t,"webGL",function(){return vt}),r.d(t,"colors",function(){return G}),r.d(t,"convertImageToFalseColorImage",function(){return W}),r.d(t,"convertToFalseColorImage",function(){return j}),r.d(t,"restoreImage",function(){return q}),r.d(t,"EVENTS",function(){return T}),r.d(t,"events",function(){return o}),r.d(t,"triggerEvent",function(){return R}),r.d(t,"imageLoadPoolManager",function(){return pe}),r.d(t,"imageRetrievalPoolManager",function(){return be}),r.d(t,"RequestPoolManager",function(){return ve});var cr={drawImage:h,generateLut:Et,getDefaultViewport:g,requestAnimationFrame:Wt,storedPixelDataToCanvasImageData:Me,storedColorPixelDataToCanvasImageData:St,storedPixelDataToCanvasImageDataColorLUT:Nt,storedPixelDataToCanvasImageDataPseudocolorLUT:Ot,internal:er,renderLabelMapImage:kt,renderPseudoColorImage:Ut,renderColorImage:Mt,renderGrayscaleImage:Rt,renderWebImage:sr,renderToCanvas:lr,canvasToPixel:Te,disable:Ce,displayImage:Pe,draw:Re,drawInvalidated:De,enable:Yt,getElementData:H,removeElementData:X,getEnabledElement:C,addEnabledElement:i,getEnabledElementsByImageId:l,getEnabledElements:s,addLayer:b,removeLayer:y,getLayer:x,getLayers:E,getVisibleLayers:I,setActiveLayer:D,getActiveLayer:A,purgeLayers:_,setLayerImage:S,fitToWindow:Se,getDefaultViewportForImage:Kt,getDisplayedArea:v,setDefaultViewport:m,getImage:Zt,getPixels:Jt,getStoredPixels:$t,getViewport:Qt,loadImage:le,loadAndCacheImage:se,registerImageLoader:ue,registerUnknownImageLoader:de,invalidate:tr,invalidateImageId:rr,pageToPixel:ir,pixelToCanvas:or,reset:dr,resize:Ae,setToPixelCoordinateSystem:Ve,setViewport:mr,updateImage:P,pixelDataToFalseColorData:z,rendering:ur,imageCache:ae,metaData:ar,webGL:vt,colors:G,convertImageToFalseColorImage:W,convertToFalseColorImage:j,restoreImage:q,EVENTS:T,events:o,triggerEvent:R,imageLoadPoolManager:pe,imageRetrievalPoolManager:be,RequestPoolManager:ve};t.default=cr}])});
//# sourceMappingURL=cornerstone.min.js.map
/*! cornerstone-math - 0.1.10 - 2022-06-09 | (c) 2017 Chris Hafey | https://github.com/cornerstonejs/cornerstoneMath */
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define("cornerstone-math",[],e):"object"==typeof exports?exports["cornerstone-math"]=e():t.cornerstoneMath=e()}(window,function(){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var r=e[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)n.d(i,r,function(e){return t[e]}.bind(null,r));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=4)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),r=function(t){return t&&t.__esModule?t:{default:t}}(n(2)),o=n(1);var s=function(){function t(e,n,i){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.x=e||0,this.y=n||0,this.z=i||0}return i(t,[{key:"set",value:function(t,e,n){return this.x=t,this.y=e,this.z=n,this}},{key:"setX",value:function(t){return this.x=t,this}},{key:"setY",value:function(t){return this.y=t,this}},{key:"setZ",value:function(t){return this.z=t,this}},{key:"setComponent",value:function(t,e){switch(t){case 0:this.x=e;break;case 1:this.y=e;break;case 2:this.z=e;break;default:throw new Error("index is out of range: "+t)}}},{key:"getComponent",value:function(t){switch(t){case 0:return this.x;case 1:return this.y;case 2:return this.z;default:throw new Error("index is out of range: "+t)}}},{key:"copy",value:function(t){return this.x=t.x,this.y=t.y,this.z=t.z,this}},{key:"add",value:function(t,e){return void 0!==e?(console.warn("DEPRECATED: Vector3's .add() now only accepts one argument. Use .addVectors( a, b ) instead."),this.addVectors(t,e)):(this.x+=t.x,this.y+=t.y,this.z+=t.z,this)}},{key:"addScalar",value:function(t){return this.x+=t,this.y+=t,this.z+=t,this}},{key:"addVectors",value:function(t,e){return this.x=t.x+e.x,this.y=t.y+e.y,this.z=t.z+e.z,this}},{key:"sub",value:function(t,e){return void 0!==e?(console.warn("DEPRECATED: Vector3's .sub() now only accepts one argument. Use .subVectors( a, b ) instead."),this.subVectors(t,e)):(this.x-=t.x,this.y-=t.y,this.z-=t.z,this)}},{key:"subVectors",value:function(t,e){return this.x=t.x-e.x,this.y=t.y-e.y,this.z=t.z-e.z,this}},{key:"multiply",value:function(t,e){return void 0!==e?(console.warn("DEPRECATED: Vector3's .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead."),this.multiplyVectors(t,e)):(this.x*=t.x,this.y*=t.y,this.z*=t.z,this)}},{key:"multiplyScalar",value:function(t){return this.x*=t,this.y*=t,this.z*=t,this}},{key:"multiplyVectors",value:function(t,e){return this.x=t.x*e.x,this.y=t.y*e.y,this.z=t.z*e.z,this}},{key:"applyMatrix3",value:function(t){var e=this.x,n=this.y,i=this.z,r=t.elements;return this.x=r[0]*e+r[3]*n+r[6]*i,this.y=r[1]*e+r[4]*n+r[7]*i,this.z=r[2]*e+r[5]*n+r[8]*i,this}},{key:"applyMatrix4",value:function(t){var e=this.x,n=this.y,i=this.z,r=t.elements;return this.x=r[0]*e+r[4]*n+r[8]*i+r[12],this.y=r[1]*e+r[5]*n+r[9]*i+r[13],this.z=r[2]*e+r[6]*n+r[10]*i+r[14],this}},{key:"applyProjection",value:function(t){var e=this.x,n=this.y,i=this.z,r=t.elements,o=1/(r[3]*e+r[7]*n+r[11]*i+r[15]);return this.x=(r[0]*e+r[4]*n+r[8]*i+r[12])*o,this.y=(r[1]*e+r[5]*n+r[9]*i+r[13])*o,this.z=(r[2]*e+r[6]*n+r[10]*i+r[14])*o,this}},{key:"applyQuaternion",value:function(t){var e=this.x,n=this.y,i=this.z,r=t.x,o=t.y,s=t.z,a=t.w,u=a*e+o*i-s*n,h=a*n+s*e-r*i,l=a*i+r*n-o*e,c=-r*e-o*n-s*i;return this.x=u*a+c*-r+h*-s-l*-o,this.y=h*a+c*-o+l*-r-u*-s,this.z=l*a+c*-s+u*-o-h*-r,this}},{key:"transformDirection",value:function(t){var e=this.x,n=this.y,i=this.z,r=t.elements;return this.x=r[0]*e+r[4]*n+r[8]*i,this.y=r[1]*e+r[5]*n+r[9]*i,this.z=r[2]*e+r[6]*n+r[10]*i,this.normalize(),this}},{key:"divide",value:function(t){return this.x/=t.x,this.y/=t.y,this.z/=t.z,this}},{key:"divideScalar",value:function(t){if(0!==t){var e=1/t;this.x*=e,this.y*=e,this.z*=e}else this.x=0,this.y=0,this.z=0;return this}},{key:"min",value:function(t){return this.x>t.x&&(this.x=t.x),this.y>t.y&&(this.y=t.y),this.z>t.z&&(this.z=t.z),this}},{key:"max",value:function(t){return this.x<t.x&&(this.x=t.x),this.y<t.y&&(this.y=t.y),this.z<t.z&&(this.z=t.z),this}},{key:"clamp",value:function(t,e){return this.x<t.x?this.x=t.x:this.x>e.x&&(this.x=e.x),this.y<t.y?this.y=t.y:this.y>e.y&&(this.y=e.y),this.z<t.z?this.z=t.z:this.z>e.z&&(this.z=e.z),this}},{key:"floor",value:function(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this}},{key:"ceil",value:function(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this}},{key:"round",value:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this}},{key:"roundToZero",value:function(){return this.x=this.x<0?Math.ceil(this.x):Math.floor(this.x),this.y=this.y<0?Math.ceil(this.y):Math.floor(this.y),this.z=this.z<0?Math.ceil(this.z):Math.floor(this.z),this}},{key:"negate",value:function(){return this.multiplyScalar(-1)}},{key:"dot",value:function(t){return this.x*t.x+this.y*t.y+this.z*t.z}},{key:"lengthSq",value:function(){return this.x*this.x+this.y*this.y+this.z*this.z}},{key:"length",value:function(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z)}},{key:"lengthManhattan",value:function(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)}},{key:"normalize",value:function(){return this.divideScalar(this.length())}},{key:"setLength",value:function(t){var e=this.length();return 0!==e&&t!==e&&this.multiplyScalar(t/e),this}},{key:"lerp",value:function(t,e){return this.x+=(t.x-this.x)*e,this.y+=(t.y-this.y)*e,this.z+=(t.z-this.z)*e,this}},{key:"cross",value:function(t,e){if(void 0!==e)return console.warn("DEPRECATED: Vector3's .cross() now only accepts one argument. Use .crossVectors( a, b ) instead."),this.crossVectors(t,e);var n=this.x,i=this.y,r=this.z;return this.x=i*t.z-r*t.y,this.y=r*t.x-n*t.z,this.z=n*t.y-i*t.x,this}},{key:"crossVectors",value:function(t,e){var n=t.x,i=t.y,r=t.z,o=e.x,s=e.y,a=e.z;return this.x=i*a-r*s,this.y=r*o-n*a,this.z=n*s-i*o,this}},{key:"angleTo",value:function(t){var e=this.dot(t)/(this.length()*t.length());return Math.acos((0,o.clamp)(e,-1,1))}},{key:"distanceTo",value:function(t){return Math.sqrt(this.distanceToSquared(t))}},{key:"distanceToSquared",value:function(t){var e=this.x-t.x,n=this.y-t.y,i=this.z-t.z;return e*e+n*n+i*i}},{key:"setFromMatrixPosition",value:function(t){return this.x=t.elements[12],this.y=t.elements[13],this.z=t.elements[14],this}},{key:"setFromMatrixScale",value:function(t){var e=this.set(t.elements[0],t.elements[1],t.elements[2]).length(),n=this.set(t.elements[4],t.elements[5],t.elements[6]).length(),i=this.set(t.elements[8],t.elements[9],t.elements[10]).length();return this.x=e,this.y=n,this.z=i,this}},{key:"setFromMatrixColumn",value:function(t,e){var n=4*t,i=e.elements;return this.x=i[n],this.y=i[n+1],this.z=i[n+2],this}},{key:"equals",value:function(t){return t.x===this.x&&t.y===this.y&&t.z===this.z}},{key:"fromArray",value:function(t){return this.x=t[0],this.y=t[1],this.z=t[2],this}},{key:"toArray",value:function(){return[this.x,this.y,this.z]}},{key:"clone",value:function(){return new t(this.x,this.y,this.z)}}]),t}();s.prototype.projectOnVector=function(){var t=void 0,e=void 0;return function(n){return void 0===t&&(t=new s),t.copy(n).normalize(),e=this.dot(t),this.copy(t).multiplyScalar(e)}}(),s.prototype.projectOnPlane=function(){var t=void 0;return function(e){return void 0===t&&(t=new s),t.copy(this).projectOnVector(e),this.sub(t)}}(),s.prototype.reflect=function(){var t=void 0;return function(e){return void 0===t&&(t=new s),this.sub(t.copy(e).multiplyScalar(2*this.dot(e)))}}(),s.prototype.clampScalar=function(){var t=void 0,e=void 0;return function(n,i){return void 0===t&&(t=new s,e=new s),t.set(n,n,n),e.set(i,i,i),this.clamp(t,e)}}(),s.prototype.applyAxisAngle=function(){var t=void 0;return function(e,n){return void 0===t&&(t=new r.default),this.applyQuaternion(t.setFromAxisAngle(e.normalize(),n)),this}}(),e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=1e-4;e.clamp=function(t,e,n){return t<e?e:t>n?n:t},e.degToRad=function(t){return t*(Math.PI/180)},e.approximatelyEquals=function(t,e,n){var r=n||i;return Math.abs(t-e)<=r*Math.max(1,Math.abs(t),Math.abs(e))},e.radToDeg=function(t){return t*(180/Math.PI)},e.sign=function(t){return"number"==typeof t?t?t<0?-1:1:t==t?0:NaN:NaN}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}();var r=function(){function t(e,n,i,r){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.x=e||0,this.y=n||0,this.z=i||0,this.w=void 0!==r?r:1}return i(t,[{key:"setFromAxisAngle",value:function(t,e){var n=e/2,i=Math.sin(n);return this.x=t.x*i,this.y=t.y*i,this.z=t.z*i,this.w=Math.cos(n),this}},{key:"multiplyQuaternions",value:function(t,e){var n=t.x,i=t.y,r=t.z,o=t.w,s=e.x,a=e.y,u=e.z,h=e.w;return this.x=n*h+o*s+i*u-r*a,this.y=i*h+o*a+r*s-n*u,this.z=r*h+o*u+n*a-i*s,this.w=o*h-n*s-i*a-r*u,this}},{key:"setFromRotationMatrix",value:function(t){var e=t.elements,n=e[0],i=e[4],r=e[8],o=e[1],s=e[5],a=e[9],u=e[2],h=e[6],l=e[10],c=n+s+l,y=void 0;return c>0?(y=.5/Math.sqrt(c+1),this.w=.25/y,this.x=(h-a)*y,this.y=(r-u)*y,this.z=(o-i)*y):n>s&&n>l?(y=2*Math.sqrt(1+n-s-l),this.w=(h-a)/y,this.x=.25*y,this.y=(i+o)/y,this.z=(r+u)/y):s>l?(y=2*Math.sqrt(1+s-n-l),this.w=(r-u)/y,this.x=(i+o)/y,this.y=.25*y,this.z=(a+h)/y):(y=2*Math.sqrt(1+l-n-s),this.w=(o-i)/y,this.x=(r+u)/y,this.y=(a+h)/y,this.z=.25*y),this}}]),t}();e.default=r},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=n(1);function r(t){return t*t}function o(t,e){return r(t.x-e.x)+r(t.y-e.y)}var s={distanceToPoint:function(t,e){return Math.sqrt(function(t,e){var n=o(t.start,t.end);if(0===n)return o(e,t.start);var i=((e.x-t.start.x)*(t.end.x-t.start.x)+(e.y-t.start.y)*(t.end.y-t.start.y))/n;return o(e,i<0?t.start:i>1?t.end:{x:t.start.x+i*(t.end.x-t.start.x),y:t.start.y+i*(t.end.y-t.start.y)})}(t,e))},intersectLine:function(t,e){var n,r,o,s,a,u,h,l,c,y,f,d={},v=t.start.x,p=t.start.y,x=t.end.x,m=t.end.y,g=e.start.x,b=e.start.y,z=e.end.x,k=e.end.y,M=void 0;if(y=(n=m-p)*z+(o=v-x)*k+(a=x*p-v*m),(0===(c=n*g+o*b+a)||0===y||(0,i.sign)(c)!==(0,i.sign)(y))&&(l=(r=k-b)*x+(s=g-z)*m+(u=z*b-g*k),0===(h=r*v+s*p+u)||0===l||(0,i.sign)(h)!==(0,i.sign)(l))){f=n*s-r*o,M=o*u-s*a;var w=parseFloat(M/f);M=r*a-n*u;var P=parseFloat(M/f);return d.x=w,d.y=P,d}}};e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.Vector3=e.rect=e.quaternion=e.point=e.Plane=e.Matrix4=e.sign=e.radToDeg=e.degToRad=e.clamp=e.lineSegment=e.Line3=void 0;var i=y(n(5)),r=y(n(3)),o=n(1),s=y(n(6)),a=y(n(7)),u=y(n(8)),h=y(n(2)),l=y(n(9)),c=y(n(0));function y(t){return t&&t.__esModule?t:{default:t}}var f={Line3:i.default,lineSegment:r.default,clamp:o.clamp,degToRad:o.degToRad,radToDeg:o.radToDeg,sign:o.sign,Matrix4:s.default,Plane:a.default,point:u.default,quaternion:h.default,rect:l.default,Vector3:c.default};e.Line3=i.default,e.lineSegment=r.default,e.clamp=o.clamp,e.degToRad=o.degToRad,e.radToDeg=o.radToDeg,e.sign=o.sign,e.Matrix4=s.default,e.Plane=a.default,e.point=u.default,e.quaternion=h.default,e.rect=l.default,e.Vector3=c.default,e.default=f},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),r=function(t){return t&&t.__esModule?t:{default:t}}(n(0)),o=n(1);var s=function(){function t(e,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.start=void 0!==e?e:new r.default,this.end=void 0!==n?n:new r.default}return i(t,[{key:"set",value:function(t,e){return this.start.copy(t),this.end.copy(e),this}},{key:"copy",value:function(t){return this.start.copy(t.start),this.end.copy(t.end),this}},{key:"center",value:function(t){return(t||new r.default).addVectors(this.start,this.end).multiplyScalar(.5)}},{key:"delta",value:function(t){return(t||new r.default).subVectors(this.end,this.start)}},{key:"distanceSq",value:function(){return this.start.distanceToSquared(this.end)}},{key:"distance",value:function(){return this.start.distanceTo(this.end)}},{key:"at",value:function(t,e){var n=e||new r.default;return this.delta(n).multiplyScalar(t).add(this.start)}},{key:"closestPointToPointParameter",value:function(t,e){var n=new r.default,i=new r.default;n.subVectors(t,this.start),i.subVectors(this.end,this.start);var s=i.dot(i),a=i.dot(n)/s;return e&&(a=(0,o.clamp)(a,0,1)),a}},{key:"closestPointToPoint",value:function(t,e,n){var i=this.closestPointToPointParameter(t,e),o=n||new r.default;return this.delta(o).multiplyScalar(i).add(this.start)}},{key:"applyMatrix4",value:function(t){return this.start.applyMatrix4(t),this.end.applyMatrix4(t),this}},{key:"equals",value:function(t){return t.start.equals(this.start)&&t.end.equals(this.end)}},{key:"clone",value:function(){return(new t).copy(this)}},{key:"intersectLine",value:function(t){var e=this.end.clone().sub(this.start),n=t.end.clone().sub(t.start),i=t.start.clone().sub(this.start),r=e.clone().cross(n),s=i.clone().cross(n),a=i.dot(r)/(i.lengthSq()*r.lengthSq());if((0,o.approximatelyEquals)(a,0)){var u=s.dot(r)/r.lengthSq();if(!(u>1||isNaN(u))){var h=this.start.clone().add(e.clone().multiplyScalar(u));return h.clone().sub(t.start).lengthSq()+h.clone().sub(t.end).lengthSq()<=t.distanceSq()?h:void 0}}}}]),t}();e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),r=function(t){return t&&t.__esModule?t:{default:t}}(n(0));var o=function(){function t(e,n,i,r,o,s,a,u,h,l,c,y,f,d,v,p){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.elements=new Float32Array(16);var x=this.elements;x[0]=void 0!==e?e:1,x[4]=n||0,x[8]=i||0,x[12]=r||0,x[1]=o||0,x[5]=void 0!==s?s:1,x[9]=a||0,x[13]=u||0,x[2]=h||0,x[6]=l||0,x[10]=void 0!==c?c:1,x[14]=y||0,x[3]=f||0,x[7]=d||0,x[11]=v||0,x[15]=void 0!==p?p:1}return i(t,[{key:"makeRotationFromQuaternion",value:function(t){var e=this.elements,n=t.x,i=t.y,r=t.z,o=t.w,s=n+n,a=i+i,u=r+r,h=n*s,l=n*a,c=n*u,y=i*a,f=i*u,d=r*u,v=o*s,p=o*a,x=o*u;return e[0]=1-(y+d),e[4]=l-x,e[8]=c+p,e[1]=l+x,e[5]=1-(h+d),e[9]=f-v,e[2]=c-p,e[6]=f+v,e[10]=1-(h+y),e[3]=0,e[7]=0,e[11]=0,e[12]=0,e[13]=0,e[14]=0,e[15]=1,this}},{key:"multiplyMatrices",value:function(t,e){var n=t.elements,i=e.elements,r=this.elements,o=n[0],s=n[4],a=n[8],u=n[12],h=n[1],l=n[5],c=n[9],y=n[13],f=n[2],d=n[6],v=n[10],p=n[14],x=n[3],m=n[7],g=n[11],b=n[15],z=i[0],k=i[4],M=i[8],w=i[12],P=i[1],R=i[5],L=i[9],T=i[13],S=i[2],_=i[6],q=i[10],j=i[14],V=i[3],E=i[7],O=i[11],C=i[15];return r[0]=o*z+s*P+a*S+u*V,r[4]=o*k+s*R+a*_+u*E,r[8]=o*M+s*L+a*q+u*O,r[12]=o*w+s*T+a*j+u*C,r[1]=h*z+l*P+c*S+y*V,r[5]=h*k+l*R+c*_+y*E,r[9]=h*M+l*L+c*q+y*O,r[13]=h*w+l*T+c*j+y*C,r[2]=f*z+d*P+v*S+p*V,r[6]=f*k+d*R+v*_+p*E,r[10]=f*M+d*L+v*q+p*O,r[14]=f*w+d*T+v*j+p*C,r[3]=x*z+m*P+g*S+b*V,r[7]=x*k+m*R+g*_+b*E,r[11]=x*M+m*L+g*q+b*O,r[15]=x*w+m*T+g*j+b*C,this}},{key:"multiply",value:function(t,e){return void 0!==e?(console.warn("DEPRECATED: Matrix4's .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead."),this.multiplyMatrices(t,e)):this.multiplyMatrices(this,t)}},{key:"getInverse",value:function(t,e){var n=this.elements,i=t.elements,r=i[0],o=i[4],s=i[8],a=i[12],u=i[1],h=i[5],l=i[9],c=i[13],y=i[2],f=i[6],d=i[10],v=i[14],p=i[3],x=i[7],m=i[11],g=i[15];n[0]=l*v*x-c*d*x+c*f*m-h*v*m-l*f*g+h*d*g,n[4]=a*d*x-s*v*x-a*f*m+o*v*m+s*f*g-o*d*g,n[8]=s*c*x-a*l*x+a*h*m-o*c*m-s*h*g+o*l*g,n[12]=a*l*f-s*c*f-a*h*d+o*c*d+s*h*v-o*l*v,n[1]=c*d*p-l*v*p-c*y*m+u*v*m+l*y*g-u*d*g,n[5]=s*v*p-a*d*p+a*y*m-r*v*m-s*y*g+r*d*g,n[9]=a*l*p-s*c*p-a*u*m+r*c*m+s*u*g-r*l*g,n[13]=s*c*y-a*l*y+a*u*d-r*c*d-s*u*v+r*l*v,n[2]=h*v*p-c*f*p+c*y*x-u*v*x-h*y*g+u*f*g,n[6]=a*f*p-o*v*p-a*y*x+r*v*x+o*y*g-r*f*g,n[10]=o*c*p-a*h*p+a*u*x-r*c*x-o*u*g+r*h*g,n[14]=a*h*y-o*c*y-a*u*f+r*c*f+o*u*v-r*h*v,n[3]=l*f*p-h*d*p-l*y*x+u*d*x+h*y*m-u*f*m,n[7]=o*d*p-s*f*p+s*y*x-r*d*x-o*y*m+r*f*m,n[11]=s*h*p-o*l*p-s*u*x+r*l*x+o*u*m-r*h*m,n[15]=o*l*y-s*h*y+s*u*f-r*l*f-o*u*d+r*h*d;var b=r*n[0]+u*n[4]+y*n[8]+p*n[12];if(0===b){var z="Matrix4.getInverse(): can't invert matrix, determinant is 0";if(e)throw new Error(z);return console.warn(z),this.identity(),this}return this.multiplyScalar(1/b),this}},{key:"applyToVector3Array",value:function(){var t=new r.default;return function(e,n,i){void 0===n&&(n=0),void 0===i&&(i=e.length);for(var r=0,o=n;r<i;r+=3,o+=3)t.x=e[o],t.y=e[o+1],t.z=e[o+2],t.applyMatrix4(this),e[o]=t.x,e[o+1]=t.y,e[o+2]=t.z;return e}}},{key:"makeTranslation",value:function(t,e,n){return this.set(1,0,0,t,0,1,0,e,0,0,1,n,0,0,0,1),this}},{key:"multiplyScalar",value:function(t){var e=this.elements;return e[0]*=t,e[4]*=t,e[8]*=t,e[12]*=t,e[1]*=t,e[5]*=t,e[9]*=t,e[13]*=t,e[2]*=t,e[6]*=t,e[10]*=t,e[14]*=t,e[3]*=t,e[7]*=t,e[11]*=t,e[15]*=t,this}},{key:"set",value:function(t,e,n,i,r,o,s,a,u,h,l,c,y,f,d,v){var p=this.elements;return p[0]=t,p[4]=e,p[8]=n,p[12]=i,p[1]=r,p[5]=o,p[9]=s,p[13]=a,p[2]=u,p[6]=h,p[10]=l,p[14]=c,p[3]=y,p[7]=f,p[11]=d,p[15]=v,this}},{key:"makeScale",value:function(t,e,n){return this.set(t,0,0,0,0,e,0,0,0,0,n,0,0,0,0,1),this}}]),t}();e.default=o},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),r=function(t){return t&&t.__esModule?t:{default:t}}(n(0));var o=function(){function t(e,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.normal=void 0!==e?e:new r.default(1,0,0),this.constant=void 0!==n?n:0}return i(t,[{key:"set",value:function(t,e){return this.normal.copy(t),this.constant=e,this}},{key:"setComponents",value:function(t,e,n,i){return this.normal.set(t,e,n),this.constant=i,this}},{key:"setFromNormalAndCoplanarPoint",value:function(t,e){return this.normal.copy(t),this.constant=-e.dot(this.normal),this}},{key:"copy",value:function(t){return this.normal.copy(t.normal),this.constant=t.constant,this}},{key:"normalize",value:function(){var t=1/this.normal.length();return this.normal.multiplyScalar(t),this.constant*=t,this}},{key:"negate",value:function(){return this.constant*=-1,this.normal.negate(),this}},{key:"distanceToPoint",value:function(t){return this.normal.dot(t)+this.constant}},{key:"distanceToSphere",value:function(t){return this.distanceToPoint(t.center)-t.radius}},{key:"projectPoint",value:function(t,e){return this.orthoPoint(t,e).sub(t).negate()}},{key:"orthoPoint",value:function(t,e){var n=this.distanceToPoint(t);return(e||new r.default).copy(this.normal).multiplyScalar(n)}},{key:"isIntersectionLine",value:function(t){var e=this.distanceToPoint(t.start),n=this.distanceToPoint(t.end);return e<0&&n>0||n<0&&e>0}},{key:"intersectPlane",value:function(t){var e=this.normal.clone().cross(t.normal),n={origin:new r.default,direction:e};if(this.normal.clone().cross(t.normal).length<1e-10)return n.direction=new r.default,n;var i=this.constant,o=t.constant,s=this.normal.clone().dot(t.normal),a=-(i-o*s)/(1-s*s),u=-(o-i*s)/(1-s*s);return n.origin=this.normal.clone().multiplyScalar(a).add(t.normal.clone().multiplyScalar(u)),n}},{key:"coplanarPoint",value:function(t){return(t||new r.default).copy(this.normal).multiplyScalar(-this.constant)}},{key:"translate",value:function(t){return this.constant=this.constant-t.dot(this.normal),this}},{key:"equals",value:function(t){return t.normal.equals(this.normal)&&t.constant===this.constant}},{key:"clone",value:function(){return(new t).copy(this)}}]),t}();o.prototype.setFromCoplanarPoints=function(){var t=new r.default,e=new r.default;return function(n,i,r){var o=t.subVectors(r,i).cross(e.subVectors(n,i)).normalize();return this.setFromNormalAndCoplanarPoint(o,n),this}}(),o.prototype.intersectLine=function(){var t=new r.default;return function(e,n){var i=n||new r.default,o=e.delta(t),s=this.normal.dot(o);if(0===s)return 0===this.distanceToPoint(e.start)?i.copy(e.start):void 0;var a=-(e.start.dot(this.normal)+this.constant)/s;return a<0||a>1?void 0:i.copy(o).multiplyScalar(a).add(e.start)}}(),e.default=o},function(t,e,n){"use strict";function i(t,e){return{x:t.x-e.x,y:t.y-e.y}}function r(t,e){return Math.sqrt(o(t,e))}function o(t,e){var n=i(t,e);return n.x*n.x+n.y*n.y}Object.defineProperty(e,"__esModule",{value:!0});var s={subtract:i,copy:function(t){return{x:t.x,y:t.y}},pageToPoint:function(t){return{x:t.pageX,y:t.pageY}},distance:r,distanceSquared:o,insideRect:function(t,e){return!(t.x<e.left||t.x>e.left+e.width||t.y<e.top||t.y>e.top+e.height)},findClosestPoint:function(t,e){var n=[],i=void 0;return t.forEach(function(t,o){var s=r(t,e);n.push(s),i=0===o?s:Math.min(s,i)}),t[n.indexOf(i)]}};e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=function(t){return t&&t.__esModule?t:{default:t}}(n(3));function r(t){return{topLeft:{x:t.left,y:t.top},bottomRight:{x:t.left+t.width,y:t.top+t.height}}}var o={distanceToPoint:function(t,e){var n=655535;return function(t){return[{start:{x:t.left,y:t.top},end:{x:t.left+t.width,y:t.top}},{start:{x:t.left+t.width,y:t.top},end:{x:t.left+t.width,y:t.top+t.height}},{start:{x:t.left+t.width,y:t.top+t.height},end:{x:t.left,y:t.top+t.height}},{start:{x:t.left,y:t.top+t.height},end:{x:t.left,y:t.top}}]}(t).forEach(function(t){var r=i.default.distanceToPoint(t,e);r<n&&(n=r)}),n},getIntersectionRect:function(t,e){var n={topLeft:{},bottomRight:{}};if(function(t,e){var n=void 0,i=void 0,o=r(t),s=r(e);return n=t.width>=0?e.width>=0?!(o.bottomRight.x<=s.topLeft.x||s.bottomRight.x<=o.topLeft.x):!(o.bottomRight.x<=s.bottomRight.x||s.topLeft.x<=o.topLeft.x):e.width>=0?!(o.topLeft.x<=s.topLeft.x||s.bottomRight.x<=o.bottomRight.x):!(o.topLeft.x<=s.bottomRight.x||s.topLeft.x<=o.bottomRight.x),i=t.height>=0?e.height>=0?!(o.bottomRight.y<=s.topLeft.y||s.bottomRight.y<=o.topLeft.y):!(o.bottomRight.y<=s.bottomRight.y||s.topLeft.y<=o.topLeft.y):e.height>=0?!(o.topLeft.y<=s.topLeft.y||s.bottomRight.y<=o.bottomRight.y):!(o.topLeft.y<=s.bottomRight.y||s.top<=o.bottomRight.y),n&&i}(t,e)){var i=r(t),o=r(e);return t.width>=0?e.width>=0?(n.topLeft.x=Math.max(i.topLeft.x,o.topLeft.x),n.bottomRight.x=Math.min(i.bottomRight.x,o.bottomRight.x)):(n.topLeft.x=Math.max(i.topLeft.x,o.bottomRight.x),n.bottomRight.x=Math.min(i.bottomRight.x,o.topLeft.x)):e.width>=0?(n.topLeft.x=Math.min(i.topLeft.x,o.bottomRight.x),n.bottomRight.x=Math.max(i.bottomRight.x,o.topLeft.x)):(n.topLeft.x=Math.min(i.topLeft.x,o.topLeft.x),n.bottomRight.x=Math.max(i.bottomRight.x,o.bottomRight.x)),t.height>=0?e.height>=0?(n.topLeft.y=Math.max(i.topLeft.y,o.topLeft.y),n.bottomRight.y=Math.min(i.bottomRight.y,o.bottomRight.y)):(n.topLeft.y=Math.max(i.topLeft.y,o.bottomRight.y),n.bottomRight.y=Math.min(i.bottomRight.y,o.topLeft.y)):e.height>=0?(n.topLeft.y=Math.min(i.topLeft.y,o.bottomRight.y),n.bottomRight.y=Math.max(i.bottomRight.y,o.topLeft.y)):(n.topLeft.y=Math.min(i.topLeft.y,o.topLeft.y),n.bottomRight.y=Math.max(i.bottomRight.y,o.bottomRight.y)),n}}};e.default=o}])});
//# sourceMappingURL=cornerstoneMath.min.js.map
/*! cornerstone-tools - 6.0.10 - 2023-07-21 | (c) 2017 Chris Hafey | https://github.com/cornerstonejs/cornerstoneTools */
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define("cornerstone-tools",[],t):"object"==typeof exports?exports["cornerstone-tools"]=t():e.cornerstoneTools=t()}(window,(function(){return function(e){var t={};function n(a){if(t[a])return t[a].exports;var o=t[a]={i:a,l:!1,exports:{}};return e[a].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,a){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:a})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var a=Object.create(null);if(n.r(a),Object.defineProperty(a,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(a,o,function(t){return e[t]}.bind(null,o));return a},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=25)}([function(e,t){e.exports=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}},function(e,t){function n(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}e.exports=function(e,t,a){return t&&n(e.prototype,t),a&&n(e,a),e}},function(e,t,n){var a=n(8),o=n(5);e.exports=function(e,t){return!t||"object"!==a(t)&&"function"!=typeof t?o(e):t}},function(e,t){function n(t){return e.exports=n=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)},n(t)}e.exports=n},function(e,t,n){var a=n(14);e.exports=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&a(e,t)}},function(e,t){e.exports=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}},function(e,t,n){var a=n(16),o=n(17),i=n(18);e.exports=function(e){return a(e)||o(e)||i()}},function(e,t,n){var a=n(20),o=n(21),i=n(22);e.exports=function(e,t){return a(e)||o(e,t)||i()}},function(e,t){function n(e){return(n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function a(t){return"function"==typeof Symbol&&"symbol"===n(Symbol.iterator)?e.exports=a=function(e){return n(e)}:e.exports=a=function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":n(e)},a(t)}e.exports=a},function(e,t){e.exports=function(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}},function(e,t,n){"use strict";(function(e){var a=n(12),o={formatArgs:function(e){if(e[0]="".concat((this.useColors?"%c":"")+this.namespace+(this.useColors?" %c":" ")+e[0]+(this.useColors?"%c ":" "),"+").concat(i.humanize(this.diff)),!this.useColors)return;var t="color: ".concat(this.color);e.splice(1,0,t,"color: inherit");var n=0,a=0;e[0].replace(/%[a-zA-Z%]/g,(function(e){"%%"!==e&&(n++,"%c"===e&&(a=n))})),e.splice(a,0,t)},save:function(e){try{e?o.storage.setItem("debug",e):o.storage.removeItem("debug")}catch(e){}},load:function(){var t;try{t=o.storage.getItem("debug")}catch(e){}!t&&void 0!==e&&"env"in e&&(t=e.env.DEBUG);return t},useColors:function(){if("undefined"!=typeof window&&window.process&&("renderer"===window.process.type||window.process.__nwjs))return!0;if("undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/))return!1;return"undefined"!=typeof document&&document.documentElement&&document.documentElement.style&&document.documentElement.style.WebkitAppearance||"undefined"!=typeof window&&window.console&&(window.console.firebug||window.console.exception&&window.console.table)||"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)&&parseInt(RegExp.$1,10)>=31||"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/)},storage:function(){try{return localStorage}catch(e){}}()};o.colors=["#0000CC","#0000FF","#0033CC","#0033FF","#0066CC","#0066FF","#0099CC","#0099FF","#00CC00","#00CC33","#00CC66","#00CC99","#00CCCC","#00CCFF","#3300CC","#3300FF","#3333CC","#3333FF","#3366CC","#3366FF","#3399CC","#3399FF","#33CC00","#33CC33","#33CC66","#33CC99","#33CCCC","#33CCFF","#6600CC","#6600FF","#6633CC","#6633FF","#66CC00","#66CC33","#9900CC","#9900FF","#9933CC","#9933FF","#99CC00","#99CC33","#CC0000","#CC0033","#CC0066","#CC0099","#CC00CC","#CC00FF","#CC3300","#CC3333","#CC3366","#CC3399","#CC33CC","#CC33FF","#CC6600","#CC6633","#CC9900","#CC9933","#CCCC00","#CCCC33","#FF0000","#FF0033","#FF0066","#FF0099","#FF00CC","#FF00FF","#FF3300","#FF3333","#FF3366","#FF3399","#FF33CC","#FF33FF","#FF6600","#FF6633","#FF9900","#FF9933","#FFCC00","#FFCC33"],o.log=console.debug||console.log||function(){};var i=Object(a.a)(o);i.formatters.j=function(e){try{return JSON.stringify(e)}catch(e){return"[UnexpectedJSONParseError]: ".concat(e.message)}},t.a=i}).call(this,n(15))},function(e,t,n){e.exports=n(23)},function(e,t,n){"use strict";var a=n(6),o=n.n(a);t.a=function(e){function t(e){for(var t=0,n=0;n<e.length;n++)t=(t<<5)-t+e.charCodeAt(n),t|=0;return a.colors[Math.abs(t)%a.colors.length]}function a(e){var n;function o(){for(var e=arguments.length,t=new Array(e),i=0;i<e;i++)t[i]=arguments[i];if(o.enabled){var r=o,s=Number(new Date),l=s-(n||s);r.diff=l,r.prev=n,r.curr=s,n=s,t[0]=a.coerce(t[0]),"string"!=typeof t[0]&&t.unshift("%O");var c=0;t[0]=t[0].replace(/%([a-zA-Z%])/g,(function(e,n){if("%%"===e)return e;c++;var o=a.formatters[n];if("function"==typeof o){var i=t[c];e=o.call(r,i),t.splice(c,1),c--}return e})),a.formatArgs.call(r,t);var u=r.log||a.log;u.apply(r,t)}}return o.namespace=e,o.enabled=a.enabled(e),o.useColors=a.useColors(),o.color=t(e),o.destroy=i,o.extend=r,"function"==typeof a.init&&a.init(o),a.instances.push(o),o}function i(){var e=a.instances.indexOf(this);return-1!==e&&(a.instances.splice(e,1),!0)}function r(e,t){var n=a(this.namespace+(void 0===t?":":t)+e);return n.log=this.log,n}function s(e){return e.toString().substring(2,e.toString().length-2).replace(/\.\*\?$/,"*")}return a.debug=a,a.default=a,a.coerce=function(e){if(e instanceof Error)return e.stack||e.message;return e},a.disable=function(){var e=[].concat(o()(a.names.map(s)),o()(a.skips.map(s).map((function(e){return"-".concat(e)})))).join(",");return a.enable(""),e},a.enable=function(e){var t;a.save(e),a.names=[],a.skips=[];var n=("string"==typeof e?e:"").split(/[\s,]+/),o=n.length;for(t=0;t<o;t++)n[t]&&("-"===(e=n[t].replace(/\*/g,".*?"))[0]?a.skips.push(new RegExp("^".concat(e.substr(1),"$"))):a.names.push(new RegExp("^".concat(e,"$"))));for(t=0;t<a.instances.length;t++){var i=a.instances[t];i.enabled=a.enabled(i.namespace)}},a.enabled=function(e){if("*"===e[e.length-1])return!0;var t,n;for(t=0,n=a.skips.length;t<n;t++)if(a.skips[t].test(e))return!1;for(t=0,n=a.names.length;t<n;t++)if(a.names[t].test(e))return!0;return!1},a.humanize=n(19),Object.keys(e).forEach((function(t){a[t]=e[t]})),a.instances=[],a.names=[],a.skips=[],a.formatters={},a.selectColor=t,a.enable(a.load()),a}},function(e,t){function n(e,t,n,a,o,i,r){try{var s=e[i](r),l=s.value}catch(e){return void n(e)}s.done?t(l):Promise.resolve(l).then(a,o)}e.exports=function(e){return function(){var t=this,a=arguments;return new Promise((function(o,i){var r=e.apply(t,a);function s(e){n(r,o,i,s,l,"next",e)}function l(e){n(r,o,i,s,l,"throw",e)}s(void 0)}))}}},function(e,t){function n(t,a){return e.exports=n=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},n(t,a)}e.exports=n},function(e,t){var n,a,o=e.exports={};function i(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function s(e){if(n===setTimeout)return setTimeout(e,0);if((n===i||!n)&&setTimeout)return n=setTimeout,setTimeout(e,0);try{return n(e,0)}catch(t){try{return n.call(null,e,0)}catch(t){return n.call(this,e,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:i}catch(e){n=i}try{a="function"==typeof clearTimeout?clearTimeout:r}catch(e){a=r}}();var l,c=[],u=!1,d=-1;function h(){u&&l&&(u=!1,l.length?c=l.concat(c):d=-1,c.length&&v())}function v(){if(!u){var e=s(h);u=!0;for(var t=c.length;t;){for(l=c,c=[];++d<t;)l&&l[d].run();d=-1,t=c.length}l=null,u=!1,function(e){if(a===clearTimeout)return clearTimeout(e);if((a===r||!a)&&clearTimeout)return a=clearTimeout,clearTimeout(e);try{a(e)}catch(t){try{return a.call(null,e)}catch(t){return a.call(this,e)}}}(e)}}function g(e,t){this.fun=e,this.array=t}function f(){}o.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];c.push(new g(e,t)),1!==c.length||u||s(v)},g.prototype.run=function(){this.fun.apply(null,this.array)},o.title="browser",o.browser=!0,o.env={},o.argv=[],o.version="",o.versions={},o.on=f,o.addListener=f,o.once=f,o.off=f,o.removeListener=f,o.removeAllListeners=f,o.emit=f,o.prependListener=f,o.prependOnceListener=f,o.listeners=function(e){return[]},o.binding=function(e){throw new Error("process.binding is not supported")},o.cwd=function(){return"/"},o.chdir=function(e){throw new Error("process.chdir is not supported")},o.umask=function(){return 0}},function(e,t){e.exports=function(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++)n[t]=e[t];return n}}},function(e,t){e.exports=function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}},function(e,t){e.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}},function(e,t){var n=1e3,a=6e4,o=60*a,i=24*o;function r(e,t,n,a){var o=t>=1.5*n;return Math.round(e/n)+" "+a+(o?"s":"")}e.exports=function(e,t){t=t||{};var s=typeof e;if("string"===s&&e.length>0)return function(e){if((e=String(e)).length>100)return;var t=/^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(e);if(!t)return;var r=parseFloat(t[1]);switch((t[2]||"ms").toLowerCase()){case"years":case"year":case"yrs":case"yr":case"y":return 315576e5*r;case"weeks":case"week":case"w":return 6048e5*r;case"days":case"day":case"d":return r*i;case"hours":case"hour":case"hrs":case"hr":case"h":return r*o;case"minutes":case"minute":case"mins":case"min":case"m":return r*a;case"seconds":case"second":case"secs":case"sec":case"s":return r*n;case"milliseconds":case"millisecond":case"msecs":case"msec":case"ms":return r;default:return}}(e);if("number"===s&&isFinite(e))return t.long?function(e){var t=Math.abs(e);if(t>=i)return r(e,t,i,"day");if(t>=o)return r(e,t,o,"hour");if(t>=a)return r(e,t,a,"minute");if(t>=n)return r(e,t,n,"second");return e+" ms"}(e):function(e){var t=Math.abs(e);if(t>=i)return Math.round(e/i)+"d";if(t>=o)return Math.round(e/o)+"h";if(t>=a)return Math.round(e/a)+"m";if(t>=n)return Math.round(e/n)+"s";return e+"ms"}(e);throw new Error("val is not a non-empty string or a valid number. val="+JSON.stringify(e))}},function(e,t){e.exports=function(e){if(Array.isArray(e))return e}},function(e,t){e.exports=function(e,t){var n=[],a=!0,o=!1,i=void 0;try{for(var r,s=e[Symbol.iterator]();!(a=(r=s.next()).done)&&(n.push(r.value),!t||n.length!==t);a=!0);}catch(e){o=!0,i=e}finally{try{a||null==s.return||s.return()}finally{if(o)throw i}}return n}},function(e,t){e.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}},function(e,t,n){var a=function(){return this||"object"==typeof self&&self}()||Function("return this")(),o=a.regeneratorRuntime&&Object.getOwnPropertyNames(a).indexOf("regeneratorRuntime")>=0,i=o&&a.regeneratorRuntime;if(a.regeneratorRuntime=void 0,e.exports=n(24),o)a.regeneratorRuntime=i;else try{delete a.regeneratorRuntime}catch(e){a.regeneratorRuntime=void 0}},function(e,t){!function(t){"use strict";var n=Object.prototype,a=n.hasOwnProperty,o="function"==typeof Symbol?Symbol:{},i=o.iterator||"@@iterator",r=o.asyncIterator||"@@asyncIterator",s=o.toStringTag||"@@toStringTag",l="object"==typeof e,c=t.regeneratorRuntime;if(c)l&&(e.exports=c);else{(c=t.regeneratorRuntime=l?e.exports:{}).wrap=f;var u={},d={};d[i]=function(){return this};var h=Object.getPrototypeOf,v=h&&h(h(I([])));v&&v!==n&&a.call(v,i)&&(d=v);var g=x.prototype=p.prototype=Object.create(d);y.prototype=g.constructor=x,x.constructor=y,x[s]=y.displayName="GeneratorFunction",c.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===y||"GeneratorFunction"===(t.displayName||t.name))},c.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,x):(e.__proto__=x,s in e||(e[s]="GeneratorFunction")),e.prototype=Object.create(g),e},c.awrap=function(e){return{__await:e}},T(b.prototype),b.prototype[r]=function(){return this},c.AsyncIterator=b,c.async=function(e,t,n,a){var o=new b(f(e,t,n,a));return c.isGeneratorFunction(t)?o:o.next().then((function(e){return e.done?e.value:o.next()}))},T(g),g[s]="Generator",g[i]=function(){return this},g.toString=function(){return"[object Generator]"},c.keys=function(e){var t=[];for(var n in e)t.push(n);return t.reverse(),function n(){for(;t.length;){var a=t.pop();if(a in e)return n.value=a,n.done=!1,n}return n.done=!0,n}},c.values=I,w.prototype={constructor:w,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(E),!e)for(var t in this)"t"===t.charAt(0)&&a.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=void 0)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var t=this;function n(n,a){return r.type="throw",r.arg=e,t.next=n,a&&(t.method="next",t.arg=void 0),!!a}for(var o=this.tryEntries.length-1;o>=0;--o){var i=this.tryEntries[o],r=i.completion;if("root"===i.tryLoc)return n("end");if(i.tryLoc<=this.prev){var s=a.call(i,"catchLoc"),l=a.call(i,"finallyLoc");if(s&&l){if(this.prev<i.catchLoc)return n(i.catchLoc,!0);if(this.prev<i.finallyLoc)return n(i.finallyLoc)}else if(s){if(this.prev<i.catchLoc)return n(i.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return n(i.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var o=this.tryEntries[n];if(o.tryLoc<=this.prev&&a.call(o,"finallyLoc")&&this.prev<o.finallyLoc){var i=o;break}}i&&("break"===e||"continue"===e)&&i.tryLoc<=t&&t<=i.finallyLoc&&(i=null);var r=i?i.completion:{};return r.type=e,r.arg=t,i?(this.method="next",this.next=i.finallyLoc,u):this.complete(r)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),u},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),E(n),u}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var a=n.completion;if("throw"===a.type){var o=a.arg;E(n)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,n){return this.delegate={iterator:I(e),resultName:t,nextLoc:n},"next"===this.method&&(this.arg=void 0),u}}}function f(e,t,n,a){var o=t&&t.prototype instanceof p?t:p,i=Object.create(o.prototype),r=new w(a||[]);return i._invoke=function(e,t,n){var a="suspendedStart";return function(o,i){if("executing"===a)throw new Error("Generator is already running");if("completed"===a){if("throw"===o)throw i;return S()}for(n.method=o,n.arg=i;;){var r=n.delegate;if(r){var s=C(r,n);if(s){if(s===u)continue;return s}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if("suspendedStart"===a)throw a="completed",n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);a="executing";var l=m(e,t,n);if("normal"===l.type){if(a=n.done?"completed":"suspendedYield",l.arg===u)continue;return{value:l.arg,done:n.done}}"throw"===l.type&&(a="completed",n.method="throw",n.arg=l.arg)}}}(e,n,r),i}function m(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}function p(){}function y(){}function x(){}function T(e){["next","throw","return"].forEach((function(t){e[t]=function(e){return this._invoke(t,e)}}))}function b(e){var t;this._invoke=function(n,o){function i(){return new Promise((function(t,i){!function t(n,o,i,r){var s=m(e[n],e,o);if("throw"!==s.type){var l=s.arg,c=l.value;return c&&"object"==typeof c&&a.call(c,"__await")?Promise.resolve(c.__await).then((function(e){t("next",e,i,r)}),(function(e){t("throw",e,i,r)})):Promise.resolve(c).then((function(e){l.value=e,i(l)}),(function(e){return t("throw",e,i,r)}))}r(s.arg)}(n,o,t,i)}))}return t=t?t.then(i,i):i()}}function C(e,t){var n=e.iterator[t.method];if(void 0===n){if(t.delegate=null,"throw"===t.method){if(e.iterator.return&&(t.method="return",t.arg=void 0,C(e,t),"throw"===t.method))return u;t.method="throw",t.arg=new TypeError("The iterator does not provide a 'throw' method")}return u}var a=m(n,e.iterator,t.arg);if("throw"===a.type)return t.method="throw",t.arg=a.arg,t.delegate=null,u;var o=a.arg;return o?o.done?(t[e.resultName]=o.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=void 0),t.delegate=null,u):o:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,u)}function M(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function E(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function w(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(M,this),this.reset(!0)}function I(e){if(e){var t=e[i];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var n=-1,o=function t(){for(;++n<e.length;)if(a.call(e,n))return t.value=e[n],t.done=!1,t;return t.value=void 0,t.done=!0,t};return o.next=o}}return{next:S}}function S(){return{value:void 0,done:!0}}}(function(){return this||"object"==typeof self&&self}()||Function("return this")())},function(e,t,n){"use strict";n.r(t);var a={};n.r(a),n.d(a,"drawBrushPixels",(function(){return te})),n.d(a,"eraseIfSegmentIndex",(function(){return ee})),n.d(a,"eraseOutsideBoundingBox",(function(){return ne})),n.d(a,"eraseInsideShape",(function(){return se})),n.d(a,"eraseOutsideShape",(function(){return le})),n.d(a,"fillOutsideBoundingBox",(function(){return ce})),n.d(a,"fillInsideShape",(function(){return he})),n.d(a,"fillOutsideShape",(function(){return ve})),n.d(a,"floodFill",(function(){return ge})),n.d(a,"getBoundingBoxAroundCircle",(function(){return xe})),n.d(a,"getBoundingBoxAroundPolygon",(function(){return Te})),n.d(a,"getCircle",(function(){return be})),n.d(a,"getPixelPathBetweenPixels",(function(){return Ee})),n.d(a,"isSameSegment",(function(){return ie})),n.d(a,"triggerLabelmapModifiedEvent",(function(){return Oe})),n.d(a,"getDiffBetweenPixelData",(function(){return Le}));var o={};n.r(o),n.d(o,"angleCursor",(function(){return To})),n.d(o,"arrowAnnotateCursor",(function(){return bo})),n.d(o,"bidirectionalCursor",(function(){return Co})),n.d(o,"cobbAngleCursor",(function(){return Mo})),n.d(o,"circleRoiCursor",(function(){return Eo})),n.d(o,"ellipticalRoiCursor",(function(){return wo})),n.d(o,"freehandRoiCursor",(function(){return Io})),n.d(o,"freehandRoiSculptorCursor",(function(){return So})),n.d(o,"lengthCursor",(function(){return ko})),n.d(o,"probeCursor",(function(){return _o})),n.d(o,"rectangleRoiCursor",(function(){return Po})),n.d(o,"textMarkerCursor",(function(){return Do})),n.d(o,"crosshairsCursor",(function(){return Oo})),n.d(o,"eraserCursor",(function(){return Lo})),n.d(o,"magnifyCursor",(function(){return Ao})),n.d(o,"panCursor",(function(){return Ho})),n.d(o,"rotateCursor",(function(){return Ro})),n.d(o,"stackScrollCursor",(function(){return Uo})),n.d(o,"wwwcRegionCursor",(function(){return No})),n.d(o,"wwwcCursor",(function(){return Fo})),n.d(o,"zoomCursor",(function(){return Bo})),n.d(o,"freehandEraseInsideCursor",(function(){return Yo})),n.d(o,"freehandFillInsideCursor",(function(){return Xo})),n.d(o,"freehandEraseOutsideCursor",(function(){return Ko})),n.d(o,"freehandFillOutsideCursor",(function(){return Zo})),n.d(o,"segRectangleEraseInsideCursor",(function(){return $o})),n.d(o,"segRectangleFillInsideCursor",(function(){return Jo})),n.d(o,"segRectangleEraseOutsideCursor",(function(){return Qo})),n.d(o,"segRectangleFillOutsideCursor",(function(){return ei})),n.d(o,"segCircleEraseInsideCursor",(function(){return ti})),n.d(o,"segCircleFillInsideCursor",(function(){return ni})),n.d(o,"segCircleEraseOutsideCursor",(function(){return ai})),n.d(o,"segCircleFillOutsideCursor",(function(){return oi}));var i=n(0),r=n.n(i),s=n(1),l=n.n(s),c=n(2),u=n.n(c),d=n(3),h=n.n(d),v=n(4),g=n.n(v),f=window.cornerstone,m=window.cornerstoneMath,p=window.Hammer,y={set cornerstone(e){f=e},get cornerstone(){return f},set cornerstoneMath(e){m=e},get cornerstoneMath(){return m},set Hammer(e){p=e},get Hammer(){return p}},x=n(8),T=n.n(x),b={MOUSE_DOWN:"cornerstonetoolsmousedown",MOUSE_UP:"cornerstonetoolsmouseup",MOUSE_DOWN_ACTIVATE:"cornerstonetoolsmousedownactivate",MOUSE_DRAG:"cornerstonetoolsmousedrag",MOUSE_MOVE:"cornerstonetoolsmousemove",MOUSE_CLICK:"cornerstonetoolsmouseclick",MOUSE_DOUBLE_CLICK:"cornerstonetoolsmousedoubleclick",MOUSE_WHEEL:"cornerstonetoolsmousewheel",TOUCH_START:"cornerstonetoolstouchstart",TOUCH_START_ACTIVE:"cornerstonetoolstouchstartactive",TOUCH_END:"cornerstonetoolstouchend",TOUCH_DRAG:"cornerstonetoolstouchdrag",TOUCH_DRAG_END:"cornerstonetoolstouchdragend",TOUCH_PINCH:"cornerstonetoolstouchpinch",TOUCH_ROTATE:"cornerstonetoolstouchrotate",TOUCH_PRESS:"cornerstonetoolstouchpress",TAP:"cornerstonetoolstap",DOUBLE_TAP:"cornerstonetoolsdoubletap",MULTI_TOUCH_START:"cornerstonetoolsmultitouchstart",MULTI_TOUCH_START_ACTIVE:"cornerstonetoolsmultitouchstartactive",MULTI_TOUCH_DRAG:"cornerstonetoolsmultitouchdrag",KEY_DOWN:"cornerstonetoolskeydown",KEY_UP:"cornerstonetoolskeyup",KEY_PRESS:"cornerstonetoolskeypress",MEASUREMENT_ADDED:"cornerstonetoolsmeasurementadded",MEASUREMENT_MODIFIED:"cornerstonetoolsmeasurementmodified",MEASUREMENT_COMPLETED:"cornerstonetoolsmeasurementcompleted",MEASUREMENT_REMOVED:"cornerstonetoolsmeasurementremoved",TOOL_DEACTIVATED:"cornerstonetoolstooldeactivated",CLIP_STOPPED:"cornerstonetoolsclipstopped",STACK_SCROLL:"cornerstonetoolsstackscroll",STACK_PREFETCH_IMAGE_LOADED:"cornerstonetoolsstackprefetchimageloaded",STACK_PREFETCH_DONE:"cornerstonetoolsstackprefetchdone",LABELMAP_MODIFIED:"cornersontetoolslabelmapmodified"};function C(e,t){var n,a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;return"function"==typeof window.CustomEvent?n=new CustomEvent(t,{detail:a,cancelable:!0}):(n=document.createEvent("CustomEvent")).initCustomEvent(t,!0,!0,a),e.dispatchEvent(n)}function M(e){return e instanceof HTMLElement?e:yt.enabledElementByUID(e)}var E={UINT_16_ARRAY:0,FLOAT_32_ARRAY:1},w=E.UINT_16_ARRAY,I=E.FLOAT_32_ARRAY;function S(e,t,n){var a,o=Tt("segmentation").configuration;switch(o.arrayType){case w:a=2;break;case I:a=4;break;default:throw new Error("Unsupported Array Type ".concat(o.arrayType))}e.labelmaps3D[t]={buffer:new ArrayBuffer(n*a),labelmaps2D:[],metadata:[],activeSegmentIndex:1,colorLUTIndex:0,segmentsHidden:[],undo:[],redo:[]}}function k(){var e={};function t(t,n,a){!1===e.hasOwnProperty(t)&&(e[t]={});var o=e[t];!1===o.hasOwnProperty(n)&&(o[n]={data:[]}),o[n].data.push(a)}function n(t,n){if(!1!==e.hasOwnProperty(t)){var a=e[t];if(!1!==a.hasOwnProperty(n))return a[n]}}function a(t,n,a){e[t][n]=a}function o(t){!1!==e.hasOwnProperty(t)&&delete e[t]}return{get:function(e,t){var a=y.cornerstone.getEnabledElement(e);if(a.image)return n(a.image.imageId,t)},add:function(e,n,a){var o=y.cornerstone.getEnabledElement(e);o.image&&t(o.image.imageId,n,a)},set:function(e,t,n){var o=y.cornerstone.getEnabledElement(e);o.image&&a(o.image.imageId,t,n)},clear:function(e){var t=y.cornerstone.getEnabledElement(e);t.image&&o(t.image.imageId)},getImageIdToolState:n,addImageIdToolState:t,setImageIdToolState:a,clearImageIdToolState:o,saveImageIdToolState:function(t){return e[t]},restoreImageIdToolState:function(t,n){e[t]=n},saveToolState:function(){return e},restoreToolState:function(t){e=t},toolState:e}}var _=k();function P(e){var t=y.cornerstone.getEnabledElement(e);return void 0===t.toolStateManager&&(t.toolStateManager=_),t.toolStateManager}function D(e,t,n){var a=P(e);n.uuid=n.uuid||"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(e){var t=16*Math.random()|0;return("x"===e?t:3&t|8).toString(16)})),a.add(e,t,n),C(e,b.MEASUREMENT_ADDED,{toolName:t,toolType:t,element:e,measurementData:n})}function O(e,t){return P(e).get(e,t)}function L(e,t,n){var a=P(e).get(e,t);if(a&&a.data&&a.data.length){for(var o=-1,i=0;i<a.data.length;i++)a.data[i]===n&&(o=i);if(-1!==o)a.data.splice(o,1),C(e,b.MEASUREMENT_REMOVED,{toolName:t,toolType:t,element:e,measurementData:n})}}function A(e,t){var n=P(e).get(e,t);void 0!==n&&(n.data=[])}function H(e,t){y.cornerstone.getEnabledElement(e).toolStateManager=t}var R=n(10),U=Object(R.a)("cornerstoneTools");var N=function(e){var t=U.extend(e);return{log:t,warn:t,error:void 0}},F=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"".concat("cornerstoneTools",":*");return R.a.enable(e)},B=function(){return R.a.disable()},V={series:{},colorLutTables:[]},q=N("store:modules:segmentationModule:metadata");function j(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"increase",n=Tt("segmentation"),a=n.configuration,o=O(e,"stack"),i=o.data[0],r=i.imageIds[0],s=V.series[r];if(s){var l=s.activeLabelmapIndex,c=s.labelmaps3D[l];switch(t){case"increase":c.activeSegmentIndex++,c.activeSegmentIndex>a.segmentsPerLabelmap&&(c.activeSegmentIndex=1);break;case"decrease":c.activeSegmentIndex--,c.activeSegmentIndex<=0&&(c.activeSegmentIndex=a.segmentsPerLabelmap)}}}var z=N("store:modules:segmentationModule:segmentVisibility");var W=N("store:modules:segmentationModule:getLabelmaps3D");function G(e){var t=M(e);if(t){var n=O(t,"stack");if(n){var a,o,i=n.data[0],r=i.imageIds[0],s=V.series[r];return s&&(a=s.labelmaps3D,o=s.activeLabelmapIndex),{labelmaps3D:a,activeLabelmapIndex:o,currentImageIdIndex:i.currentImageIdIndex}}W.error("Consumers must define stacks in their application if using segmentations in cornerstoneTools.")}}function Y(e,t){var n=G(e),a=n.labelmaps3D,o=n.activeLabelmapIndex;return a[t=void 0!==t?t:o]}var X=E.UINT_16_ARRAY,K=E.FLOAT_32_ARRAY;function Z(e,t){var n=M(e);if(n){var a=G(n).labelmaps3D;if(!a)return[];var o,i,r=Tt("segmentation").configuration;switch(r.arrayType){case X:o="Uint16Array",i="2";break;case K:o="Float32Array",i="4";break;default:throw new Error("Unsupported Array Type ".concat(r.arrayType))}var s=V.colorLutTables;if(void 0!==t){var l=a[t];return l?{labelmapIndex:t,bytesPerVoxel:i,type:o,buffer:l.buffer,colorLUT:s[l.colorLUTIndex]}:void 0}for(var c=[],u=0;u<a.length;u++){var d=a[u];d&&c.push({labelmapIndex:u,bytesPerVoxel:2,buffer:d.buffer,colorLUT:s[d.colorLUTIndex]})}return c}}var $=n(6),J=n.n($);function Q(e){return J()(new Set(e))}function ee(e,t,n){t[e]===n&&(t[e]=0)}function te(e,t,n,a){var o=arguments.length>4&&void 0!==arguments[4]&&arguments[4],i=function(e,t){return t*a+e};e.forEach((function(e){var a=i.apply(void 0,J()(e));o?ee(a,t,n):t[a]=n}))}function ne(e,t,n,a){for(var o=e.detail,i=t.pixelData,r=t.segmentIndex,s=o.image,l=s.width,c=s.height,u=0;u<l;u++)for(var d=0;d<n[1];d++)ee(d*l+u,i,r);for(var h=0;h<n[0];h++)for(var v=n[1];v<a[1];v++)ee(v*l+h,i,r);for(var g=a[0];g<l;g++)for(var f=n[1];f<a[1];f++)ee(f*l+g,i,r);for(var m=0;m<l;m++)for(var p=a[1];p<c;p++)ee(p*l+m,i,r)}var ae=n(7),oe=n.n(ae);function ie(e,t,n){return t[e]===n}N("util:segmentation:operations:eraseOutsideCircle");function re(e,t,n,a,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"inside",r=e.detail.image.width,s=t.pixelData,l=t.segmentIndex,c=oe()(a,2),u=c[0],d=c[1],h=oe()(o,2),v=h[0],g=h[1];"outside"===i&&ne(e,t,a,o);for(var f=u;f<v;f++)for(var m=d;m<g;m++){var p=m*r+f;ie(p,s,l)&&n({x:f,y:m})&&(s[p]=0)}}function se(e,t,n,a,o){re(e,t,n,a,o,"inside")}function le(e,t,n,a,o){re(e,t,(function(e){return!n(e)}),a,o,"outside")}function ce(e,t,n,a){for(var o=t.pixelData,i=t.segmentIndex,r=e.detail.image,s=r.width,l=r.height,c=0;c<s;c++)for(var u=0;u<n[1];u++)o[u*s+c]=i;for(var d=0;d<n[0];d++)for(var h=n[1];h<a[1];h++)o[h*s+d]=i;for(var v=a[0];v<s;v++)for(var g=n[1];g<a[1];g++)o[g*s+v]=i;for(var f=0;f<s;f++)for(var m=a[1];m<l;m++)o[m*s+f]=i}var ue=N("util:segmentation:operations:helpers:fillShape");function de(e,t,n,a,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"inside",r=t.pixelData,s=t.segmentIndex;if(void 0!==r&&void 0!==s){var l=e.detail.image.width,c=oe()(a,2),u=c[0],d=c[1],h=oe()(o,2),v=h[0],g=h[1];"outside"===i&&ce(e,t,a,o);for(var f=u;f<v;f++)for(var m=d;m<g;m++){var p=m*l+f;n({x:f,y:m})&&(r[p]=s)}}else ue.error("fillInsideShape requires operationData to contain pixelData and segmentIndex")}function he(e,t,n,a,o){de(e,t,n,a,o,"inside")}function ve(e,t,n,a,o){de(e,t,(function(e){return!n(e)}),a,o,"outside")}var ge=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},a=n.onFlood||function(){},o=n.onBoundary||function(){},i=n.equals||fe,r=n.diagonals||!1,s=T(t),l=C(),c=[],u=[],d={},h={};for(c.push({currentArgs:t});c.length>0;)v(c.pop());return{flooded:u,boundaries:E()};function v(e){var t=e.currentArgs,n=e.previousArgs;g(t)||(f(t),m(t)?(p(t),x(t)):y(n))}function g(e){return!0===d[e]}function f(e){d[e]=!0}function m(e){var t=b(T,[e]);return b(i,[t,s])}function p(e){u.push(e),a.apply(void 0,J()(e))}function y(e){h[e]=e,o.apply(void 0,J()(e))}function x(e){for(var t=0;t<l.length;t+=1){for(var n=l[t],a=e.slice(0),o=0;o<e.length;o+=1)a[o]+=n[o];c.push({currentArgs:a,previousArgs:e})}}function T(t){return e.apply(void 0,J()(t))}function b(e,t){try{return e.apply(void 0,J()(t))}catch(e){return}}function C(){return M(t.length).filter((function(e){var t=me(e);return 0!==t&&(1===t||r)}))}function M(e){for(var t=[],n=function(e){return e.split("").map((function(e){return parseInt(e,10)-1}))},a=0;a<Math.pow(3,e);a+=1){var o=pe(a.toString(3),"0",e);t.push(n(o))}return t}function E(){var e=[];for(var t in h)h.hasOwnProperty(t)&&e.unshift(h[t]);return e}};function fe(e,t){return e===t}function me(e){for(var t=0,n=0;n<e.length;n+=1)0!==e[n]&&(t+=1);return t}function pe(e,t,n){return(new Array(n+1).join(t)+e).slice(-n)}function ye(e,t){var n=(0,y.cornerstoneMath.point.distance)(e,t);return{left:Math.floor(Math.min(e.x-n,t.x)),top:Math.floor(Math.min(e.y-n,t.y)),width:2*n,height:2*n}}function xe(e){var t=e.detail.handles,n=e.detail.image,a=n.width,o=n.height,i=ye(t.start,t.end),r=i.width+i.left,s=i.left,l=i.top+i.height,c=i.top;return s=Math.floor(s),c=Math.floor(c),r=Math.floor(r),l=Math.floor(l),r=Math.min(a,r),s=Math.max(0,s),l=Math.min(o,l),[[s,c=Math.max(0,c)],[r,l]]}function Te(e,t){var n=1/0,a=0,o=1/0,i=0,r=t.width,s=t.height;return e.forEach((function(e){n=Math.min(e[0],n),a=Math.max(e[0],a),o=Math.min(e[1],o),i=Math.max(e[1],i)})),n=Math.floor(n),o=Math.floor(o),a=Math.floor(a),i=Math.floor(i),a=Math.min(r,a),n=Math.max(0,n),i=Math.min(s,i),o=Math.max(0,o),[[n,o],[a,i]]}function be(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,i=Math.floor(a),r=Math.floor(o);if(1===e)return[[i,r]];for(var s=[],l=0,c=-e;c<=e;c++){var u=r+c;if(!(u>t||u<0))for(var d=-e;d<=e;d++){var h=i+d;h>=n||h<0||d*d+c*c<e*e&&(s[l++]=[i+d,r+c])}}return s}var Ce=1/Math.sqrt(2),Me={up:{x:0,y:1},upRight:{x:Ce,y:Ce},right:{x:1,y:0},downRight:{x:Ce,y:-Ce},down:{x:0,y:1},downLeft:{x:-Ce,y:-Ce},left:{x:-1,y:0},upLeft:{x:-Ce,y:Ce}},Ee=function(e,t){for(var n={x:e.x,y:e.y},a=[];t.x!==n.x||t.y!==n.y;)t.x===n.x?t.y>n.y?n.y++:n.y--:t.y===n.y?t.x>n.x?n.x++:n.x--:t.y>n.y?t.x>n.x?we(n,t):Ie(n,t):t.x>n.x?Se(n,t):ke(n,t),a.push({x:n.x,y:n.y});return a.pop(),a};function we(e,t){var n=_e(e,t);switch(De([Pe(n,Me.up),Pe(n,Me.right),Pe(n,Me.upRight)])){case 0:e.y++;break;case 1:e.x++;break;case 2:e.y++,e.x++}}function Ie(e,t){var n=_e(e,t);switch(De([Pe(n,Me.up),Pe(n,Me.left),Pe(n,Me.upLeft)])){case 0:e.y++;break;case 1:e.x--;break;case 2:e.y++,e.x--}}function Se(e,t){var n=_e(e,t);switch(De([Pe(n,Me.down),Pe(n,Me.right),Pe(n,Me.downRight)])){case 0:e.y--;break;case 1:e.x++;break;case 2:e.y--,e.x++}}function ke(e,t){var n=_e(e,t);switch(De([Pe(n,Me.down),Pe(n,Me.left),Pe(n,Me.downLeft)])){case 0:e.y--;break;case 1:e.x--;break;case 2:e.y--,e.x--}}function _e(e,t){var n=y.cornerstoneMath.point.distance(e,t);return{x:(t.x-e.x)/n,y:(t.y-e.y)/n}}function Pe(e,t){return e.x*t.x+e.y*t.y}function De(e){var t=e[0]>e[1]?0:1;return e[2]>e[t]&&(t=2),t}function Oe(e,t){var n=Tt("segmentation").getters;t=void 0===t?n.activeLabelmapIndex(e):t,y.cornerstone.triggerEvent(e,b.LABELMAP_MODIFIED,{labelmapIndex:t})}function Le(e,t){for(var n=[],a=0;a<e.length;a++)e[a]!==t[a]&&n.push([a,e[a],t[a]]);return n}var Ae=E.UINT_16_ARRAY,He=E.FLOAT_32_ARRAY;function Re(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:[],o=arguments.length>4?arguments[4]:void 0,i=arguments.length>5?arguments[5]:void 0,r=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0,s=Tt("segmentation"),l=s.configuration,c=V.series[e];c||(V.series[e]={activeLabelmapIndex:n,labelmaps3D:[]},c=V.series[e]),c.labelmaps3D[n]={buffer:t,labelmaps2D:[],metadata:a,activeSegmentIndex:1,colorLUTIndex:r,segmentsHidden:[],undo:[],redo:[]};for(var u=c.labelmaps3D[n].labelmaps2D,d=t.byteLength/o,h=0;h<o;h++){var v=void 0;switch(l.arrayType){case Ae:v=new Uint16Array(t,d*h,d/2);break;case He:v=new Float32Array(t,d*h,d/4);break;default:throw new Error("Unsupported Array Type ".concat(l.arrayType))}var g=i?i[h]:Q(v);g&&g.some((function(e){return e}))&&(u[h]={pixelData:v,segmentsOnLabelmap:g})}}var Ue=N("store:modules:segmentationModule:getLabelmapStats");function Ne(e,t,n){var a=e.length,o=t[n].imagePositionPatient;if(0===n)return Fe(o,t[n+1].imagePositionPatient);if(n===a-1)return Fe(o,t[n-1].imagePositionPatient);var i=t[n-1].imagePositionPatient,r=t[n+1].imagePositionPatient;return(Fe(o,i)+Fe(o,r))/2}function Fe(e,t){return Math.sqrt(Math.pow(e[0]-t[0],2)+Math.pow(e[1]-t[1],2)+Math.pow(e[2]-t[2],2))}var Be=E.UINT_16_ARRAY,Ve=E.FLOAT_32_ARRAY;function qe(e,t,n,a,o){var i,r=Tt("segmentation").configuration,s=a*o,l=s*n;switch(r.arrayType){case Be:i=new Uint16Array(e.labelmaps3D[t].buffer,2*l,s);break;case Ve:i=new Float32Array(e.labelmaps3D[t].buffer,4*l,s);break;default:throw new Error("Unsupported Array Type ".concat(r.arrayType))}e.labelmaps3D[t].labelmaps2D[n]={pixelData:i,segmentsOnLabelmap:[]}}var je=E.UINT_16_ARRAY,ze=E.FLOAT_32_ARRAY,We=N("store:modules:segmentationModule:getLabelmap2D");function Ge(e,t,n){var a=e.x,o=e.y;return a<n&&a>=0&&o<t&&o>=0}var Ye=N("store:modules:segmentationModule:getSegmentOfActiveLabelmapAtEvent");var Xe=N("store:modules:segmentationModule:setColorLUT");function Ke(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=Tt("segmentation"),a=n.configuration,o=a.segmentsPerLabelmap;t?($e(t,o),t.length<o&&(t=[].concat(J()(t),J()(Je(o-t.length))))):t=t||Je(o),t.unshift([0,0,0,0]),V.colorLutTables[e]=t}function Ze(e){return"number"==typeof e?V.colorLutTables[e]:V.colorLutTables[e.colorLUTIndex]}function $e(e,t){e.length<t?Xe.warn("The provided colorLUT only provides ".concat(e.length," labels, whereas segmentsPerLabelmap is set to ").concat(t,". Autogenerating the rest.")):e.length>t&&Xe.warn("segmentsPerLabelmap is set to ".concat(t,", and the provided colorLUT provides ").concat(e.length,". Using the first ").concat(t," colors from the LUT."))}function Je(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:255,t=[],n=0;n<e;n++)t.push(at(et(),nt()));return t}var Qe=222.5;function et(){return(Qe+=137.5)>=360&&(Qe-=360),Qe}var tt=.6;function nt(){(tt+=.07)>.82&&(tt=.3+(tt-.82));return tt}function at(e){var t,n,a,o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:.6,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:255,s=(1-Math.abs(2*i-1))*o,l=s*(1-Math.abs(e/60%2-1)),c=i-s/2;return e<60?(t=s,n=l,a=0):e<120?(t=l,n=s,a=0):e<180?(t=0,n=s,a=l):e<240?(t=0,n=l,a=s):e<300?(t=l,n=0,a=s):e<360&&(t=s,n=0,a=l),[255*(t+c),255*(n+c),255*(a+c),r]}var ot=N("store:modules:segmentationModule:getBrushColor");var it={renderOutline:!0,renderFill:!0,shouldRenderInactiveLabelmaps:!0,radius:10,minRadius:1,maxRadius:50,fillAlpha:.2,fillAlphaInactive:.1,outlineAlpha:.7,outlineAlphaInactive:.35,outlineWidth:3,storeHistory:!0,segmentsPerLabelmap:65535,arrayType:E.UINT_16_ARRAY},rt=N("util:segmentation:labelmap3DHistory");function st(e,t,n){var a=e.labelmaps2D;t.forEach((function(e){for(var t=e.imageIdIndex,o=e.diff,i=a[t].pixelData,r=0;r<o.length;r++){var s=o[r];i[s[0]]=s[n]}}))}var lt={state:V,configuration:it,onRegisterCallback:function(){Ke(0)},getters:{metadata:function(e,t,n){var a=M(e);if(a){var o=O(a,"stack").data[0].imageIds[0],i=V.series[o];if(i){if(t=void 0===t?i.activeLabelmapIndex:t,i.labelmaps3D[t]){var r=i.labelmaps3D[t];return void 0===n?r.metadata:r.metadata[n]}q.warn("No labelmap3D of labelmap index ".concat(t," on stack."))}else q.warn("brushStackState is undefined")}},labelmap3D:Y,labelmaps3D:G,activeLabelmapIndex:function(e){var t=M(e);if(t){var n=O(t,"stack").data[0].imageIds[0],a=V.series[n];if(a)return a.activeLabelmapIndex}},activeSegmentIndex:function(e,t){var n=M(e);if(n){var a=O(n,"stack").data[0].imageIds[0],o=V.series[a];if(o){t=void 0===t?o.activeLabelmapIndex:t;var i=o.labelmaps3D[t];if(i)return i.activeSegmentIndex}return 1}},isSegmentVisible:function(e,t,n){if(t){var a=M(e);if(a){var o=O(a,"stack").data[0].imageIds[0],i=V.series[o];if(i){if(n=void 0===n?i.activeLabelmapIndex:n,i.labelmaps3D[n])return!i.labelmaps3D[n].segmentsHidden[t];z.warn("No labelmap3D of labelmap index ".concat(n," on stack."))}else z.warn("brushStackState is undefined")}}},labelmap2D:function(e){var t=M(e);if(t){var n=y.cornerstone,a=O(t,"stack");if(a){var o,i=a.data[0],r=n.getEnabledElement(t),s=i.currentImageIdIndex,l=r.image,c=l.rows,u=l.columns,d=i.imageIds.length,h=i.imageIds[0],v=V.series[h];if(v){if(o=v.activeLabelmapIndex,!v.labelmaps3D[o])S(v,o,c*u*d);v.labelmaps3D[o].labelmaps2D[s]||qe(v,o,s,c,u)}else{o=0,V.series[h]={activeLabelmapIndex:o,labelmaps3D:[]},S(v=V.series[h],o,c*u*d),qe(v,o,s,c,u)}var g=v.labelmaps3D[o];return{labelmap2D:g.labelmaps2D[s],labelmap3D:g,currentImageIdIndex:s,activeLabelmapIndex:o}}We.error("Consumers must define stacks in their application if using segmentations in cornerstoneTools.")}},labelmap2DByImageIdIndex:function(e,t,n,a){if(!e.labelmaps2D[t]){var o,i=Tt("segmentation").configuration,r=n*a,s=r*t;switch(i.arrayType){case je:o=new Uint16Array(e.buffer,2*s,r);break;case ze:o=new Float32Array(e.buffer,4*s,r);break;default:throw new Error("Unsupported Array Type ".concat(i.arrayType))}e.labelmaps2D[t]={pixelData:o,segmentsOnLabelmap:Q(o)}}return e.labelmaps2D[t]},labelmapStats:function(e,t,n){var a=y.cornerstone,o=M(e);if(!o)return null;var i=O(o,"stack").data[0].imageIds,r=i[0];return new Promise((function(e){var o=V.series[r];o||e(null);var s=function(e){for(var t=[],n=y.cornerstone.metaData,a=!0,o=0;o<e.length;o++){var i=n.get("imagePlaneModule",e[o]);if(!i){a=!1;break}t.push(i)}return{sufficientMetadata:a,imagePlanes:t}}(i),l=s.sufficientMetadata,c=s.imagePlanes;l||(Ue.warn("Insufficient imagePlaneModule information to calculate volume statistics."),e(null)),n=void 0===n?o.activeLabelmapIndex:n;for(var u=o.labelmaps3D[n],d=[],h=0;h<i.length;h++)d.push(a.loadAndCacheImage(i[h]));Promise.all(d).then((function(n){var a=function(e,t,n,a){for(var o=function(e,t,n,a){for(var o=t[0],i=o.rowPixelSpacing,r=o.columnPixelSpacing,s=e.labelmaps2D,l=[],c=0;c<s.length;c++){var u=s[c];if(u&&u.segmentsOnLabelmap.includes(a)){for(var d=Ne(t,n,c)*i*r,h=u.pixelData,v=t[c].getPixelData(),g=[],f=0;f<h.length;f++)h[f]===a&&g.push(v[f]);l.push({voxelInMM3:d,values:g})}}return l}(e,t,n,a),i=0,r=o[0].values[0],s=r,l=0,c=0;c<o.length;c++){var u=o[c],d=u.values,h=u.voxelInMM3;l+=h*d.length;var v=0;d.forEach((function(e){e>r?r=e:e<s&&(s=e),v+=e})),i+=v*h}i/=l;for(var g=0,f=0;f<o.length;f++){var m=o[f],p=(d=m.values,h=m.voxelInMM3,0);d.forEach((function(e){p+=Math.pow(e-i,2)})),g+=p*h}return g/=l,g=Math.sqrt(g),{volume:l,mean:i,stdDev:g,max:r,min:s}}(u,n,c,t);e(a)}))}))},segmentOfActiveLabelmapAtEvent:function(e){var t=e.detail,n=t.element,a=t.image,o=t.currentPoints;if(o){var i=a.width,r=a.height;if(n){var s=O(n,"stack").data[0],l=s.currentImageIdIndex,c=s.imageIds[0],u=V.series[c],d=u.activeLabelmapIndex,h=u.labelmaps3D[d];if(h){var v=h.labelmaps2D[l];if(v){var g=v.pixelData,f=o.image,m=f.x,p=f.y;if(Ge({x:m=Math.floor(m),y:p=Math.floor(p)},r,i)){var y=g[p*i+m];if(0===y)return;return{segmentIndex:y,metadata:h.metadata[y]}}}}}}else Ye.warn("Not a cornerstone input event.")},brushColor:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=M(e);if(n){var a=O(n,"stack");if(a){var o,i=a.data[0],r=i.imageIds[0],s=V.series[r];if(s){var l=s.activeLabelmapIndex,c=s.labelmaps3D[l],u=c.activeSegmentIndex;o=V.colorLutTables[c.colorLUTIndex][u]}else o=V.colorLutTables[0][1];return t?"rgba(".concat(o[0],", ").concat(o[1],", ").concat(o[2],", 1.0 )"):"rgba(".concat(o[0],", ").concat(o[1],", ").concat(o[2],", 0.8 )")}ot.error("Consumers must define stacks in their application if using segmentations in cornerstoneTools.")}},labelmapBuffers:Z,activeLabelmapBuffer:function(e){var t=M(e);if(t){var n=O(t,"stack").data[0].imageIds[0],a=V.series[n];if(a)return Z(t,a.activeLabelmapIndex)}},colorLUT:Ze,colorForSegmentIndexColorLUT:function(e,t){return Ze(e)[t]}},setters:{metadata:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2?arguments[2]:void 0,a=arguments.length>3?arguments[3]:void 0,o=M(e);if(o){var i=y.cornerstone,r=O(o,"stack"),s=r.data[0],l=s.imageIds[0],c=V.series[l];if(c||(V.series[l]={labelmapIndex:t,labelmaps3D:[]},c=V.series[l]),!c.labelmaps3D[t]){var u=i.getEnabledElement(o),d=u.image,h=d.rows,v=d.columns,g=s.imageIds.length,f=h*v*g;S(c,t,f)}var m=c.labelmaps3D[t];m.metadata[n]=a}},labelmap3DForElement:function(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:[],o=arguments.length>4?arguments[4]:void 0,i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,r=M(e);if(r){var s=O(r,"stack"),l=s.data[0].imageIds.length,c=s.data[0].imageIds[0];Re(c,t,n,a,l,o,i),Oe(r,n)}},labelmap3DByFirstImageId:Re,incrementActiveSegmentIndex:function(e){var t=M(e);t&&j(t,"increase")},decrementActiveSegmentIndex:function(e){var t=M(e);t&&j(t,"decrease")},activeSegmentIndex:function(e,t){var n=M(e);if(n){var a=O(n,"stack").data[0].imageIds[0],o=V.series[a];if(o){var i=o.activeLabelmapIndex,r=o.labelmaps3D[i],s=Tt("segmentation").configuration;t<=0?t=1:t>s.segmentsPerLabelmap&&(t=s.segmentsPerLabelmap),r.activeSegmentIndex=t}}},toggleSegmentVisibility:function(e,t,n){if(t){var a=M(e);if(a){var o=O(a,"stack").data[0].imageIds[0],i=V.series[o];if(i){if(n=void 0===n?i.activeLabelmapIndex:n,i.labelmaps3D[n]){var r=i.labelmaps3D[n].segmentsHidden;return r[t]=!r[t],!r[t]}z.warn("No labelmap3D of labelmap index ".concat(n," on stack."))}else z.warn("brushStackState is undefined")}}},updateSegmentsOnLabelmap2D:function(e){e.segmentsOnLabelmap=Q(e.pixelData)},deleteSegment:function(e,t,n){if(t){var a=M(e);if(a){var o=O(a,"stack").data[0].imageIds[0],i=V.series[o];if(i){n=void 0===n?i.activeLabelmapIndex:n;var r=i.labelmaps3D[n];if(r){delete r.metadata[t];for(var s=r.labelmaps2D,l=0;l<s.length;l++){var c=s[l];if(c&&c.segmentsOnLabelmap.includes(t)){var u=c.pixelData,d=c.segmentsOnLabelmap.indexOf(t);c.segmentsOnLabelmap.splice(d,1);for(var h=0;h<u.length;h++)u[h]===t&&(u[h]=0)}}y.cornerstone.updateImage(a)}}}}},colorLUT:Ke,colorLUTIndexForLabelmap3D:function(e,t){e.colorLUTIndex=t},colorForSegmentIndexOfColorLUT:function(e,t,n){Ze(e)[t]=n},activeLabelmapIndex:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=M(e);if(n){var a=y.cornerstone,o=O(n,"stack"),i=o.data[0],r=a.getEnabledElement(n),s=r.image,l=s.rows,c=s.columns,u=i.imageIds.length,d=l*c*u,h=i.imageIds[0],v=V.series[h];v?(v.activeLabelmapIndex=t,v.labelmaps3D[t]||S(v,t,d)):(V.series[h]={activeLabelmapIndex:t,labelmaps3D:[]},S(v=V.series[h],t,d)),a.updateImage(n)}},radius:function(e){var t=Tt("segmentation").configuration;t.radius=Math.min(Math.max(e,t.minRadius),t.maxRadius)},pushState:function(e,t,n){var a=Y(e,n);a.undo.push(t),a.redo=[]},undo:function(e,t){var n=Y(e,t),a=n.undo,o=n.redo;if(a.length){var i=a.pop();st(n,i,1),o.push(i),y.cornerstone.updateImage(e)}else rt.warn("No undos left.")},redo:function(e,t){var n=Y(e,t),a=n.undo,o=n.redo;if(o.length){var i=o.pop();st(n,i,2),a.push(i),y.cornerstone.updateImage(e)}else rt.warn("No redos left.")}}},ct={activeManipulators:{}};function ut(e){var t=y.cornerstone.getEnabledElement(e).uuid;delete ct.activeManipulators[t]}function dt(e){var t=ct.activeManipulators,n=t[e];"function"==typeof n&&n(),delete t[e]}function ht(e){ut(e.detail.element)}var vt={setters:{addActiveManipulatorForElement:function(e,t){var n=y.cornerstone.getEnabledElement(e).uuid;ct.activeManipulators[n]=t},removeActiveManipulatorForElement:ut,cancelActiveManipulatorsForElement:function(e){dt(y.cornerstone.getEnabledElement(e).uuid)},cancelActiveManipulators:function(){var e=ct.activeManipulators;Object.keys(e).forEach((function(e){return dt(e)}))}},state:ct,enabledElementCallback:function(e){var t=y.cornerstone.EVENTS.NEW_IMAGE;e.removeEventListener(t,ht),e.addEventListener(t,ht)},removeEnabledElementCallback:function(e){var t=y.cornerstone.EVENTS.NEW_IMAGE;e.removeEventListener(t,ht),ut(e)}},gt={iconSize:16,viewBox:{x:16,y:16},mousePoint:{x:8,y:8},mousePointerGroupString:'\n    <path stroke="ACTIVE_COLOR" d="M8 16L8 0"></path>\n    <path stroke="ACTIVE_COLOR" d="M16 8L0 8"></path>\n  '},ft={configuration:gt,getters:{defaultOptions:function(){return gt}},setters:{defaultOptions:function(e){Object.assign(gt,e)}}},mt={configuration:{mouseEnabled:!0,touchEnabled:!0,globalToolSyncEnabled:!1,showSVGCursors:!1,autoResizeViewports:!0,lineDash:[4,4]}},pt=(N("store:modules:storeLogger"),{globalTools:{},globalToolChangeHistory:[],enabledElements:[],tools:[],isToolLocked:!1,activeMultiPartTool:null,mousePositionImage:{},clickProximity:6,touchProximity:10,handleRadius:6,deleteIfHandleOutsideImage:!0,preventHandleOutsideImage:!1,preventTextBoxOutsideDisplayedArea:!1,handleTouchOffset:{x:0,y:-57},svgCursorUrl:null}),yt={mouseTools:function(){return pt.tools.filter((function(e){return e.supportedInteractionTypes.includes("Mouse")}))},touchTools:function(){return pt.tools.filter((function(e){return e.supportedInteractionTypes.includes("Touch")}))},enabledElementByUID:function(e){return pt.enabledElements.find((function(t){return y.cornerstone.getEnabledElement(t).uuid===e}))}},xt={segmentation:lt,cursor:ft,globalConfiguration:mt,manipulatorState:vt};function Tt(e){return xt[e]}var bt={modules:xt,state:pt,getters:yt},Ct=function(e,t){return pt.tools.find((function(n){return n.element===e&&n.name===t}))},Mt=xt.globalConfiguration;function Et(e,t){if(Mt.configuration.showSVGCursors){var n=t.getIconWithPointerSVG(),a=t.mousePoint,o=window.URL.createObjectURL(n);e.style.cursor="url('".concat(o,"') ").concat(a,", auto"),pt.svgCursorUrl=o}}function wt(e){Mt.configuration.showSVGCursors&&It(e,"none")}function It(e,t){pt.svgCursorUrl&&window.URL.revokeObjectURL(pt.svgCursorUrl),pt.svgCursorUrl=null,e.style.cursor=t}var St=Tt("globalConfiguration"),kt=N("store:setToolMode"),_t=function(e,t,n,a){void 0===a&&Array.isArray(n)&&(a=n,n=null);var o=Ct(e,t);o&&(function(e,t,n,a){t.supportedInteractionTypes.forEach((function(o){if(void 0===a||a.includes(o)){var i=Vt[o];i?i(t,e,n):kt.warn("Unable to resolve input conflicts for type %s",o)}})),bt.state.tools.filter((function(t){return t.element===e&&"active"===t.mode&&t.supportedInteractionTypes.length>0})).forEach((function(t){var n=!1;t.supportedInteractionTypes.forEach((function(e){t.options["is".concat(e,"Active")]&&(n=!0)})),n||(kt.log("Setting tool %s's to PASSIVE",t.name),Ht(e,t.name))}))}(e,o,n,a),o.supportedInteractionTypes.forEach((function(e){void 0===a||a.includes(e)?n["is".concat(e,"Active")]=!0:n["is".concat(e,"Active")]=!1})),St.configuration.showSVGCursors&&o.supportedInteractionTypes.includes("Mouse")&&function(e,t,n){var a;a="number"==typeof t?[t]:t.mouseButtonMask;a.includes(1)&&(n.svgCursor?Et(n.element,n.svgCursor):n.hideDefaultCursor?wt(e):function(e){It(e,"initial")}(e))}(e,n,o)),Ut("active",null,e,t,n)};var Pt=function(e,t,n){Bt("active",e,t,n),bt.state.enabledElements.forEach((function(a){_t(a,e,t,n)}))},Dt=Ut.bind(null,"disabled",null),Ot=Nt.bind(null,"disabled",null),Lt=Ut.bind(null,"enabled",null),At=Nt.bind(null,"enabled",null),Ht=Ut.bind(null,"passive",b.TOOL_DEACTIVATED),Rt=Nt.bind(null,"passive",b.TOOL_DEACTIVATED);function Ut(e,t,n,a,o){var i,r,s=Ct(n,a);s?(o=qt(o),Array.isArray(o.mouseButtonMask)&&0!==o.mouseButtonMask.length&&Array.isArray(s.options.mouseButtonMask)&&(o.mouseButtonMask=(i=o.mouseButtonMask,r=s.options.mouseButtonMask,i.concat(r).reduce((function(e,t){return-1===e.indexOf(t)&&e.push(t),e}),[]))),s.mode=e,s.mergeOptions(o),s["".concat(e,"Callback")]&&s["".concat(e,"Callback")](n,o),t&&C(n,t,{options:o,toolName:a,toolType:a,type:t})):kt.warn('Unable to find tool "%s" for enabledElement',a)}function Nt(e,t,n,a){Bt(e,n,a),bt.state.enabledElements.forEach((function(o){Ut(e,t,o,n,a)}))}function Ft(e,t,n){var a="is".concat(e,"Active"),o=bt.state.tools.find((function(e){return e.element===n&&"active"===e.mode&&!0===e.options[a]}));o&&(kt.log("Setting tool %s's %s to false",o.name,a),o.options[a]=!1)}function Bt(e,t,n,a){if(St.configuration.globalToolSyncEnabled){var o={mode:e,args:[t,n]};a&&o.push(a),bt.state.globalToolChangeHistory.push(o);bt.state.globalToolChangeHistory.length>50&&bt.state.globalToolChangeHistory.shift();var i=bt.state.globalTools[t];if(i)if("active"===e){var r=function(e,t,n){void 0===n&&Array.isArray(t)&&(n=t,t=null);var a=[],o=bt.state.globalTools[e];if(o){var i=new o.tool(o.props);i.supportedInteractionTypes.forEach((function(e){if(void 0===n||n.includes(e))if("Mouse"===e){var o=qt(t).mouseButtonMask;Array.isArray(o)&&o.length>0?o.forEach((function(t){return a.push("".concat(e,"-").concat(t))})):Array.isArray(o)&&0===o.length&&a.push("".concat(e,"-DELETE"))}else"MultiTouch"===e?a.push("".concat(e,"-").concat(i.configuration.touchPointers)):a.push(e)}))}return a}(t,n,a);Object.keys(bt.state.globalTools).forEach((function(e){var t=bt.state.globalTools[e];t.activeBindings=t.activeBindings.filter((function(e){return!r.includes(e)}))})),r.some((function(e){return e.includes("Mouse-DELETE")}))&&(i.activeBindings=i.activeBindings.filter((function(e){return!e.includes("Mouse")})),r=r.filter((function(e){return!e.includes("Mouse")}))),i.activeBindings=i.activeBindings.concat(r)}else i.activeBindings=[];else kt.warn("setToolMode call for tool not available globally: ".concat(t))}}var Vt={Mouse:function(e,t,n){var a=qt(n).mouseButtonMask;if(Array.isArray(a)&&a.length>0){var o=bt.state.tools.find((function(e){return e.element===t&&"active"===e.mode&&!0===e.options.isMouseActive&&Array.isArray(e.options.mouseButtonMask)&&e.options.mouseButtonMask.some((function(e){return a.includes(e)}))}));o&&(o.options.mouseButtonMask=o.options.mouseButtonMask.filter((function(e){return!a.includes(e)})),0===o.options.mouseButtonMask.length&&(o.options.isMouseActive=!1))}},MouseWheel:Ft.bind(void 0,"MouseWheel"),Touch:function(e,t){var n=bt.state.tools.find((function(e){return e.element===t&&"active"===e.mode&&!0===e.options.isTouchActive})),a=bt.state.tools.find((function(e){return e.element===t&&"active"===e.mode&&!0===e.options.isMultiTouchActive&&1===e.configuration.touchPointers}));n&&(kt.log("Setting tool %s's isTouchActive to false",n.name),n.options.isTouchActive=!1),a&&(kt.log("Setting tool %s's isTouchActive to false",a.name),a.options.isMultiTouchActive=!1)},TouchPinch:Ft.bind(void 0,"TouchPinch"),TouchRotate:Ft.bind(void 0,"TouchRotate"),DoubleTap:Ft.bind(void 0,"DoubleTap"),MultiTouch:function(e,t){var n,a=bt.state.tools.find((function(n){return n.element===t&&"active"===n.mode&&!0===n.options.isMultiTouchActive&&n.configuration.touchPointers===e.configuration.touchPointers}));1===e.configuration.touchPointers&&(n=bt.state.tools.find((function(e){return e.element===t&&"active"===e.mode&&!0===e.options.isTouchActive}))),a&&(kt.log("Setting tool %s's isMultiTouchActive to false",a.name),a.options.isMultiTouchActive=!1),n&&(kt.log("Setting tool %s's isTouchActive to false",n.name),n.options.isTouchActive=!1)}};function qt(e){return Array.isArray(e)?e={mouseButtonMask:e}:e!==Object(e)&&(e={mouseButtonMask:[e]}),e.hasOwnProperty("mouseButtonMask")||(e.mouseButtonMask=[]),Array.isArray(e.mouseButtonMask)||(e.mouseButtonMask=[e.mouseButtonMask]),e.mouseButtonMask=e.mouseButtonMask.filter((function(e){return"number"==typeof e&&0!==e})),e}var jt={passiveCallback:function(e){Dt(e,this.name)},enabledCallback:function(e){_t(e,this.name)}};var zt={passiveCallback:function(e){Dt(e,this.name)},activeCallback:function(e){Lt(e,this.name)}},Wt=function(e,t){e.save(),t(e),e.restore()},Gt=1,Yt=2;var Xt={setToolWidth:function(e){Gt=e},getToolWidth:function(){return Gt},setActiveWidth:function(e){Yt=e},getActiveWidth:function(){return Yt}},Kt=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2?arguments[2]:void 0,a=t.color,o=t.lineWidth,i=t.fillStyle,r=t.lineDash,s=t.shouldDrawLines,l=void 0===s||s;e.beginPath(),e.strokeStyle=a||e.strokeStyle,e.lineWidth=o||void 0===o&&Xt.getToolWidth()||e.lineWidth,r&&e.setLineDash(r),n(e),i&&(e.fillStyle=i,e.fill()),l&&e.stroke(),r&&e.setLineDash([])};function Zt(e,t,n,a,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"pixel";Kt(e,o,(function(e){"pixel"===i&&(n=y.cornerstone.pixelToCanvas(t,n),a=y.cornerstone.pixelToCanvas(t,a)),e.moveTo(n.x,n.y),e.lineTo(a.x,a.y)}))}var $t=function(e,t,n,a,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"pixel";Kt(e,o,(function(e){"pixel"===i&&(n=y.cornerstone.pixelToCanvas(t,n),a=a.map((function(e){return y.cornerstone.pixelToCanvas(t,e)}))),e.moveTo(n.x,n.y),a.forEach((function(t){var n=t.x,a=t.y;e.lineTo(n,a)}))}))},Jt=function(e,t,n,a,o,i){var r=Math.atan2(n.y-t.y,n.x-t.x),s={color:a,lineWidth:o};i&&(s.lineDash=i),Zt(e,void 0,t,n,s,"canvas"),s={color:a,lineWidth:o,fillStyle:a};var l=[{x:n.x-10*Math.cos(r-Math.PI/7),y:n.y-10*Math.sin(r-Math.PI/7)},{x:n.x-10*Math.cos(r+Math.PI/7),y:n.y-10*Math.sin(r+Math.PI/7)},n];$t(e,void 0,n,l,s,"canvas")},Qt=function(e,t,n,a,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"pixel";"pixel"===i&&(n=y.cornerstone.pixelToCanvas(t,n)),Kt(e,o,(function(e){e.arc(n.x,n.y,a,0,2*Math.PI)}))};function en(e){var t=y.cornerstoneMath;if(e instanceof t.Vector3)return e;var n=Object.keys(e);return n.includes("x")&&n.includes("y")&&n.includes("z")?new t.Vector3(e.x,e.y,e.z):new t.Vector3(e[0],e[1],e[2])}function tn(e,t){var n=en(t.rowCosines),a=en(t.columnCosines),o=en(t.imagePositionPatient),i=e.clone().sub(o);return{x:n.dot(i)/t.columnPixelSpacing,y:a.dot(i)/t.rowPixelSpacing}}function nn(e,t){var n=en(t.rowCosines),a=en(t.columnCosines),o=en(t.imagePositionPatient),i=n.clone().multiplyScalar(e.x);i.multiplyScalar(t.columnPixelSpacing);var r=a.clone().multiplyScalar(e.y);r.multiplyScalar(t.rowPixelSpacing);var s=i.add(r);return s.add(o),s}function an(e,t){var n=en(e.rowCosines),a=en(e.columnCosines),o=en(e.imagePositionPatient),i=en(t.rowCosines),r=en(t.columnCosines),s=en(t.imagePositionPatient),l=n.clone().cross(a),c=new y.cornerstoneMath.Plane;c.setFromNormalAndCoplanarPoint(l,o);var u=i.clone().cross(r),d=new y.cornerstoneMath.Plane;d.setFromNormalAndCoplanarPoint(u,s);var h=d.clone().intersectPlane(c),v=h.origin,g=h.direction,f=nn({x:t.columns,y:t.rows},t),m=s.distanceTo(f),p=new y.cornerstoneMath.Line3;p.start=v,p.end=v.clone().add(g.multiplyScalar(m));var x=function(e,t){var n=[];return Object.keys(t).forEach((function(a){var o=t[a],i=e.intersectLine(o);i&&n.push(i)})),n}(p,function(e){var t=nn({x:0,y:0},e),n=nn({x:e.columns,y:0},e),a=nn({x:0,y:e.rows},e),o=nn({x:e.columns,y:e.rows},e);return{top:new y.cornerstoneMath.Line3(t,n),left:new y.cornerstoneMath.Line3(t,a),right:new y.cornerstoneMath.Line3(n,o),bottom:new y.cornerstoneMath.Line3(a,o)}}(t));if(2===x.length)return{start:x[0],end:x[1]}}function on(e,t,n){var a=n*(Math.PI/180);return{x:Math.cos(a)*(e.x-t.x)-Math.sin(a)*(e.y-t.y)+t.x,y:Math.sin(a)*(e.x-t.x)+Math.cos(a)*(e.y-t.y)+t.y}}var rn=function(e,t,n,a,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"pixel",r=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0;"pixel"===i&&(n=y.cornerstone.pixelToCanvas(t,n),a=y.cornerstone.pixelToCanvas(t,a));var s=y.cornerstone.getViewport(t),l=t.clientWidth,c=t.clientHeight,u=s.scale,d=s.translation,h=s.rotation-r,v={x:l/2+d.x*u,y:c/2+d.y*u};Math.abs(h)>.05&&(n=on(n,v,-h),a=on(a,v,-h));var g=Math.abs(n.x-a.x),f=Math.abs(n.y-a.y),m=Math.min(n.x,a.x),p=Math.min(n.y,a.y),x={x:m+g/2,y:p+f/2};Math.abs(h)>.05&&(x=on(x,v,h));var T=h*Math.PI/180;Kt(e,o,(function(e){e.ellipse(x.x,x.y,g/2,f/2,T,0,2*Math.PI),e.closePath()}))},sn="white",ln="greenyellow",cn="transparent";var un={setFillColor:function(e){cn=e},getFillColor:function(){return cn},setToolColor:function(e){sn=e},getToolColor:function(){return sn},setActiveColor:function(e){ln=e},getActiveColor:function(){return ln},getColorIfActive:function(e){return e.color?e.color:e.active?ln:sn}},dn=function(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},o=t.element,i=un.getToolColor();e.strokeStyle=a.color||i;for(var r=Object.keys(n),s=function(t){var i=r[t],s=n[i];if(!0===s.drawnIndependently)return"continue";if(!0===a.drawHandlesIfActive&&!s.active)return"continue";if(a.hideHandlesIfMoving&&s.moving)return"continue";var l={lineWidth:s.active?Xt.getActiveWidth():Xt.getToolWidth(),fillStyle:a.fill};a.lineDash&&(l.lineDash=a.lineDash),Kt(e,l,(function(e){var t=y.cornerstone.pixelToCanvas(o,s),n=s.radius||a.handleRadius||pt.handleRadius;e.arc(t.x,t.y,n,0,2*Math.PI)}))},l=0;l<r.length;l++)s(l)},hn=function(e,t,n,a){var o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:"pixel";Kt(e,a,(function(e){n.forEach((function(n){var a=n.start,i=n.end;if("pixel"===o){var r=y.cornerstone;a=r.pixelToCanvas(t,a),i=r.pixelToCanvas(t,i)}e.moveTo(a.x,a.y),e.lineTo(i.x,i.y)}))}))},vn=function(e,t,n,a,o,i){var r=e.length>0?y.cornerstoneMath.point.findClosestPoint(e,t):t,s=[{x:n.left+n.width/2,y:n.top},{x:n.left,y:n.top+n.height/2},{x:n.left+n.width/2,y:n.top+n.height},{x:n.left+n.width,y:n.top+n.height/2}];Zt(a,void 0,r,y.cornerstoneMath.point.findClosestPoint(s,r),{color:o,lineWidth:i,lineDash:[2,3]},"canvas")},gn={fontSize:15,fontFamily:"Arial",backgroundColor:"transparent"};function fn(e){if("string"!=typeof e)throw new Error("Font family must be a valid string");gn.fontFamily=e}function mn(e){if("number"!=typeof e||isNaN(e)||!isFinite(e))throw new Error("Font size must be a valid number");gn.fontSize=parseFloat(e)}var pn={setFont:function(e){var t=e.split("px ");2===t.length&&(mn(parseFloat(t[0])),fn(t[1]))},getFont:function(){return"".concat(gn.fontSize,"px ").concat(gn.fontFamily)},setFontSize:mn,getFontSize:function(){return gn.fontSize},setFontFamily:fn,getFontFamily:function(){return gn.fontFamily},setBackgroundColor:function(e){gn.backgroundColor=e},getBackgroundColor:function(){return gn.backgroundColor}},yn=function(e,t,n,a,o){var i=pn.getFontSize();e.font=pn.getFont(),e.textBaseline="top",e.fillStyle=a,n.forEach((function(n,a){e.fillText(n,t.left+o,t.top+o+a*(i+o))}))},xn=function(e,t,n){e.fillStyle=n,e.fillRect(t.left,t.top,t.width,t.height)};function Tn(e,t,n){var a=pn.getFont(),o=e.font;a&&a!==o&&(e.font=a);var i=e.measureText(t).width;return a&&a!==o&&(e.font=o),i+2*n}var bn=function(e,t,n,a,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:{};"[object Array]"!==Object.prototype.toString.call(t)&&(t=[t]);var r=5,s=pn.getFontSize(),l=pn.getBackgroundColor(),c=0;t.forEach((function(t){var n=Tn(e,t,r);c=Math.max(c,n)}));var u={width:c,height:r+t.length*(s+r)};return Wt(e,(function(e){e.strokeStyle=o,i.centering&&(!0===i.centering.x&&(n-=u.width/2),!0===i.centering.y&&(a-=u.height/2)),u.left=n,u.top=a,"function"==typeof i.displacer&&i.displacer(u),xn(e,u,l),yn(e,u,t,o,r)})),u};function Cn(e,t,n){return Math.min(Math.max(t,e),n)}function Mn(e,t){var n=t.left||0,a=t.top||0;e.x=Cn(e.x,n,n+t.width),e.y=Cn(e.y,a,a+t.height)}var En=function(e,t,n,a,o,i){i-o<a-n?(e[t]+=o-n,e[t]+=(i-o)/2,e[t]-=(a-n)/2):n<o?e[t]+=o-n:a>i&&(e[t]-=a-i)};function wn(e,t){var n=y.cornerstone,a=n.pixelToCanvas,o=n.canvasToPixel,i=n.getViewport,r=n.getEnabledElement,s=n.getDisplayedArea,l=o(e,{x:t.left,y:t.top}),c=function(e,t){var n=function(t){return y.cornerstone.canvasToPixel(e,t)},a=t.top,o=t.left,i=t.width,r=t.height,s=[n({x:o,y:a}),n({x:o+i,y:a}),n({x:o,y:a+r}),n({x:o+i,y:a+r})],l=s.map((function(e){return e.x})),c=s.map((function(e){return e.y}));return{minX:Math.min.apply(Math,J()(l)),minY:Math.min.apply(Math,J()(c)),maxX:Math.max.apply(Math,J()(l)),maxY:Math.max.apply(Math,J()(c))}}(e,t),u=c.minX,d=c.minY,h=c.maxX,v=c.maxY,g=i(e),f=s(r(e).image,g),m=g.displayedArea?g.displayedArea:f,p=m.tlhc,x=m.brhc,T=p.y-1,b=p.x-1,C=x.y,M=x.x;En(l,"y",d,v,T,C),En(l,"x",u,h,b,M);var E=a(e,l);t.top=E.y,t.left=E.x}var In=Cn,Sn=function(e,t,n,a,o,i,r,s,l,c){var u=y.cornerstone.pixelToCanvas,d=u(t,n);l&&(d.x+=l);var h={centering:{x:!1,y:c}};if(pt.preventTextBoxOutsideDisplayedArea&&(h.displacer=function(e){return wn(t,e)}),n.boundingBox=bn(e,a,d.x,d.y,r,h),n.hasMoved){var v=i(o).map((function(e){return u(t,e)}));vn(v,d,n.boundingBox,e,r,s)}},kn=function(e,t,n,a,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"pixel",r=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0;if("pixel"===i){var s=y.cornerstone;n=s.pixelToCanvas(t,n),a=s.pixelToCanvas(t,a)}var l=y.cornerstone.getViewport(t),c=t.clientWidth,u=t.clientHeight,d=l.scale,h=l.translation,v=l.rotation-r,g={x:c/2+h.x*d,y:u/2+h.y*d};Math.abs(v)>.05&&(n=on(n,g,-v),a=on(a,g,-v));var f=Math.abs(n.x-a.x),m=Math.abs(n.y-a.y);n={x:Math.min(n.x,a.x),y:Math.min(n.y,a.y)},a={x:n.x+f,y:n.y+m};var p={x:n.x+f,y:n.y},x={x:n.x,y:n.y+m};Math.abs(v)>.05&&(n=on(n,g,v),a=on(a,g,v),p=on(p,g,v),x=on(x,g,v)),Kt(e,o,(function(e){e.moveTo(n.x,n.y),e.lineTo(p.x,p.y),e.lineTo(a.x,a.y),e.lineTo(x.x,x.y),e.lineTo(n.x,n.y)}))},_n=function(e){var t=e.getContext("2d");return t.setTransform(1,0,0,1,0,0),t},Pn=function(e,t){return void 0===e?t:e},Dn=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};t.shadow&&(e.shadowColor=Pn(t.shadowColor,"#000000"),e.shadowBlur=Pn(t.shadowBlur,0),e.shadowOffsetX=Pn(t.shadowOffsetX,1),e.shadowOffsetY=Pn(t.shadowOffsetY,1))},On=function(e){return 0===Object.keys(e).length&&e.constructor===Object},Ln=Tt("segmentation"),An=Ln.getters,Hn=Ln.setters;function Rn(){this.handles={start:{},end:{}}}function Un(e){var t=e.detail.element,n=e.detail.currentPoints.image;return On(this.handles.start)?this.handles.start=n:(this.handles.end=n,this._applyStrategy(e)),y.cornerstone.updateImage(t),!0}function Nn(e){var t=e.detail,n=t.element,a=t.currentPoints.image;this.handles.end=a,y.cornerstone.updateImage(n)}function Fn(e){e.detail.handles=this.handles;var t=e.detail.element,n=An.labelmap2D(t),a=n.labelmap2D,o=n.labelmap3D,i=n.currentImageIdIndex,r=a.pixelData,s=r.slice(),l={points:{start:{x:this.handles.start.x,y:this.handles.start.y},end:{x:this.handles.end.x,y:this.handles.end.y}},pixelData:r,segmentIndex:o.activeSegmentIndex,segmentationMixinType:"circleSegmentationMixin"};this.applyActiveStrategy(e,l);var c={imageIdIndex:i,diff:Le(s,r)};Hn.pushState(this.element,[c]),Hn.updateSegmentsOnLabelmap2D(a),y.cornerstone.updateImage(t),this._resetHandles()}var Bn={postTouchStartCallback:Un,postMouseDownCallback:Un,mouseClickCallback:Un,touchDragCallback:Nn,mouseDragCallback:Nn,mouseMoveCallback:Nn,touchEndCallback:Fn,mouseUpCallback:Fn,initializeMixin:Rn,renderToolData:function(e){var t=this,n=e.detail,a=n.element,o=An.brushColor(a,!0),i=_n(n.canvasContext.canvas),r=y.cornerstoneMath.point.distance;Wt(i,(function(e){if(!t.handles)return null;var n=y.cornerstone.pixelToCanvas(a,t.handles.start),i=y.cornerstone.pixelToCanvas(a,t.handles.end),s=r(n,i);Qt(e,a,t.handles.start,s,{color:o})}))},_resetHandles:Rn,_applyStrategy:Fn},Vn=N("tools:ScissorsTool"),qn=Tt("segmentation"),jn=qn.getters,zn=qn.setters;function Wn(e){var t=e.detail.element,n=e.detail.currentPoints.image,a=this.handles.points;if(!a.length)return Vn.warn("Something went wrong, empty handles detected."),null;a.push({x:n.x,y:n.y,lines:[]}),this.currentHandle+=1,y.cornerstone.updateImage(t)}function Gn(e){var t=e.detail,n=e.detail.element;this._addPoint(t),y.cornerstone.updateImage(n)}function Yn(e){var t=this.handles.points,n=e.detail.element,a=jn.labelmap2D(n),o=a.labelmap2D,i=a.labelmap3D,r=a.currentImageIdIndex,s=o.pixelData,l=s.slice(),c={points:t,pixelData:s,segmentIndex:i.activeSegmentIndex,segmentationMixinType:"freehandSegmentationMixin"};this.applyActiveStrategy(e,c);var u={imageIdIndex:r,diff:Le(l,s)};zn.pushState(this.element,[u]),zn.updateSegmentsOnLabelmap2D(o),y.cornerstone.updateImage(n),this._resetHandles()}function Xn(){this.handles={points:[]},this.currentHandle=0}var Kn={postTouchStartCallback:Wn,postMouseDownCallback:Wn,mouseClickCallback:Wn,touchDragCallback:Gn,mouseDragCallback:Gn,mouseMoveCallback:Gn,touchEndCallback:Yn,mouseUpCallback:Yn,initializeMixin:Xn,renderToolData:function(e){var t=e.detail,n=t.element,a=jn.brushColor(n,!0),o=_n(t.canvasContext.canvas),i=this.handles.points;i.length<2||Wt(o,(function(e){for(var t=0;t<i.length;t++){var o=J()(i[t].lines);t===i.length-1&&o.push(i[0]),$t(e,n,i[t],o,{color:a})}}))},_resetHandles:Xn,_addPoint:function(e){var t=this.handles.points;t.length&&t[this.currentHandle-1].lines.push({x:e.currentPoints.image.x,y:e.currentPoints.image.y,lines:[]}),t.push({x:e.currentPoints.image.x,y:e.currentPoints.image.y,lines:[]}),this.currentHandle+=1,y.cornerstone.updateImage(e.element)},_applyStrategy:Yn},Zn=Tt("segmentation").getters;var $n=Object.assign({},Kn,{renderToolData:function(e){var t=this,n=e.detail,a=n.element,o=Zn.brushColor(a,!0),i=_n(n.canvasContext.canvas),r=this.handles;Wt(i,(function(e){if(r.points.length>1)for(var n=0;n<r.points.length;n++){var i=J()(r.points[n].lines);$t(e,a,t.handles.points[n],i,{color:o})}}))}}),Jn=Tt("segmentation"),Qn=Jn.getters,ea=Jn.setters;function ta(e){var t=e.detail.element,n=e.detail.currentPoints.image;return On(this.handles.start)?this.handles.start=n:(this.handles.end=n,this._applyStrategy(e)),y.cornerstone.updateImage(t),!0}function na(e){var t=e.detail,n=t.element,a=t.currentPoints.image;this.handles.end=a,y.cornerstone.updateImage(n)}function aa(e){e.detail.handles=this.handles;var t=e.detail.element,n=Qn.labelmap2D(t),a=n.labelmap2D,o=n.labelmap3D,i=n.currentImageIdIndex,r=a.pixelData,s=r.slice(),l={points:[{x:this.handles.start.x,y:this.handles.start.y},{x:this.handles.end.x,y:this.handles.end.y}],pixelData:r,segmentIndex:o.activeSegmentIndex,segmentationMixinType:"rectangleSegmentationMixin"};this.applyActiveStrategy(e,l);var c={imageIdIndex:i,diff:Le(s,r)};ea.pushState(this.element,[c]),ea.updateSegmentsOnLabelmap2D(a),y.cornerstone.updateImage(t),this._resetHandles()}function oa(){this.handles={start:{},end:{}}}var ia={activeOrDisabledBinaryTool:jt,enabledOrDisabledBinaryTool:zt,circleSegmentationMixin:Bn,polylineSegmentationMixin:$n,freehandSegmentationMixin:Kn,rectangleSegmentationMixin:{postTouchStartCallback:ta,postMouseDownCallback:ta,mouseClickCallback:ta,touchDragCallback:na,mouseDragCallback:na,mouseMoveCallback:na,touchEndCallback:aa,mouseUpCallback:aa,initializeMixin:oa,renderToolData:function(e){var t=this,n=e.detail,a=n.element,o=Qn.brushColor(a,!0),i=_n(n.canvasContext.canvas);Wt(i,(function(e){kn(e,a,t.handles.start,t.handles.end,{color:o})}))},_resetHandles:oa,_applyStrategy:aa},renderBrushMixin:{renderBrush:function(e){var t,n=y.cornerstone,a=Tt("segmentation"),o=a.getters,i=a.configuration,r=e.detail,s=r.viewport;if(this._drawing?t=this._lastImageCoords:this._mouseUpRender?(t=this._lastImageCoords,this._mouseUpRender=!1):t=bt.state.mousePositionImage,t){var l=r.image,c=l.rows,u=l.columns,d=t,h=d.x,v=d.y;if(!(h<0||h>u||v<0||v>c)){var g=i.radius,f=r.canvasContext,m=r.element,p=o.brushColor(m,this._drawing);f.setTransform(1,0,0,1,0,0);var x=g*s.scale,T=n.pixelToCanvas(m,t);f.beginPath(),f.strokeStyle=p,f.ellipse(T.x,T.y,x,x,0,0,2*Math.PI),f.stroke()}}}}},ra=function(e){return e&&"object"===T()(e)&&"[object RegExp]"!==Object.prototype.toString.call(e)&&"[object Date]"!==Object.prototype.toString.call(e)},sa=function(e,t){var n;return t&&!0===t.clone&&ra(e)?ua((n=e,Array.isArray(n)?[]:{}),e,t):e},la=function(e,t,n){var a=e.slice();return t.forEach((function(t,o){void 0===a[o]?a[o]=sa(t,n):ra(t)?a[o]=ua(e[o],t,n):-1===e.indexOf(t)&&a.push(sa(t,n))})),a},ca=function(e,t,n){var a={};return ra(e)&&Object.keys(e).forEach((function(t){a[t]=sa(e[t],n)})),Object.keys(t).forEach((function(o){ra(t[o])&&e[o]?a[o]=ua(e[o],t[o],n):a[o]=sa(t[o],n)})),a},ua=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2?arguments[2]:void 0,a=Array.isArray(t),o=n||{arrayMerge:la},i=o.arrayMerge||la;if(a)return Array.isArray(e)?i(e,t,n):sa(t,n);var r=ca(e,t,n);return Object.getPrototypeOf(e)!==Object.prototype&&Object.setPrototypeOf(r,Object.getPrototypeOf(e)),r},da=ua,ha=N("tools:base:BaseTool"),va=Tt("globalConfiguration"),ga=function(){function e(t,n){r()(this,e),this.initialConfiguration=da(n,t);var a=this.initialConfiguration,o=a.name,i=a.strategies,s=a.defaultStrategy,l=a.configuration,c=a.supportedInteractionTypes,u=a.mixins,d=a.svgCursor;this.name=o,this.mode="disabled",this.element=void 0,this.supportedInteractionTypes=c||[],this.strategies=i||{},this.defaultStrategy=s||Object.keys(this.strategies)[0]||void 0,this.activeStrategy=this.defaultStrategy,d&&(this.svgCursor=d),this._options={},this._configuration=Object.assign({},l),this.updateOnMouseMove=!1,this.hideDefaultCursor=!1,u&&u.length&&this._applyMixins(u),this._cursors=Object.assign({},this.initialConfiguration.cursors);var h=this.defaultStrategy&&this._cursors[this.activeStrategy];h&&(this.svgCursor=h)}return l()(e,[{key:"mergeOptions",value:function(e){this._options=Object.assign({},this._options,e)}},{key:"clearOptions",value:function(){this._options={}}},{key:"applyActiveStrategy",value:function(e,t){return this.strategies[this.activeStrategy].call(this,e,t)}},{key:"_applyMixins",value:function(e){for(var t=0;t<e.length;t++){var n=ia["".concat(e[t])];"object"===T()(n)?(Object.assign(this,n),"function"==typeof this.initializeMixin&&this.initializeMixin()):ha.warn("".concat(this.name,": mixin ").concat(ia[t]," does not exist."))}"function"===this.initializeMixin&&delete this.initializeMixin}},{key:"setActiveStrategy",value:function(e){this.activeStrategy=e,va.configuration.showSVGCursors&&this.changeCursor(this.element,e)}},{key:"changeCursor",value:function(e,t){if(e){var n=this._cursors[t];n&&(this.svgCursor=n,"active"===this.mode&&Et(e,n))}}},{key:"configuration",get:function(){return this._configuration},set:function(e){this._configuration=e}},{key:"options",get:function(){return this._options}}],[{key:"configuration",get:function(){}}]),e}(),fa=function(e,t){if(e.boundingBox)return y.cornerstoneMath.point.insideRect(t,e.boundingBox)},ma=function(e,t,n,a){if(e.hasOwnProperty("pointNearHandle")){if(e.pointNearHandle(t,e,n))return!0}else if(!0===e.hasBoundingBox){if(fa(e,n))return!0}else{var o=y.cornerstone.pixelToCanvas(t,e);if(y.cornerstoneMath.point.distance(o,n)<=a)return!0}return!1},pa=function e(t,n,a,o){var i;if(n){if(Array.isArray(n))for(var r=Object.keys(n),s=0;s<r.length;s++){var l=n[r[s]];if(l.hasOwnProperty("x")&&l.hasOwnProperty("y")&&ma(l,t,a,o)){i=l;break}}else if("object"===T()(n))for(var c=Object.keys(n),u=0;u<c.length;u++){var d=c[u];if(Array.isArray(n[d])){if(i=e(t,n[d],a,o))break}else{var h=n[d];if(ma(h,t,a,o)){i=h;break}}}return i}},ya=function(e,t,n,a){a||(a=6);var o=function(e){var t;return Object.keys(e).forEach((function(n){var a=e[n];!0!==a.active||(t=a)})),t}(t),i=pa(e,t,n,a);return o!==i&&(void 0!==i&&(i.active=!0),void 0!==o&&(o.active=!1),!0)};var xa=n(9),Ta=n.n(xa),ba=function(e,t){var n=e.image,a={left:0,top:0,width:n.width,height:n.height},o=!1;return Object.keys(t).forEach((function(e){var n=t[e];!0!==n.allowedOutsideImage&&!1===y.cornerstoneMath.point.insideRect(n,a)&&(o=!0)})),o},Ca=function(e,t){var n=e.currentPoints,a=e.element,o=n.page,i=pt.handleTouchOffset,r=0,s=0;return"touch"===t&&(r=i.x,s=i.y),y.cornerstone.pageToPixel(a,o.x+r,o.y+s)},Ma=function(e,t,n){return t.filter((function(t){return t.element===e&&"active"===t.mode&&(void 0===n||t.options["is".concat(n,"Active")])}))},Ea=n(5),wa=n.n(Ea),Ia=function(e,t){return"active"===Ct(e,t).mode},Sa=Tt("segmentation"),ka=function(e){function t(e){var n,a=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return r()(this,t),a.configuration||(a.configuration={alwaysEraseOnClick:!1}),(n=u()(this,h()(t).call(this,e,a))).updateOnMouseMove=!0,n.hideDefaultCursor=!0,n._drawing=!1,n._drawingMouseUpCallback=n._drawingMouseUpCallback.bind(wa()(n)),n}return g()(t,e),l()(t,[{key:"renderBrush",value:function(e){throw new Error("Method renderBrush not implemented for ".concat(this.name,"."))}},{key:"_paint",value:function(e){throw new Error("Method _paint not implemented for ".concat(this.name,"."))}},{key:"mouseDragCallback",value:function(e){var t=e.detail.currentPoints;this._lastImageCoords=t.image,this._drawing&&this._paint(e)}},{key:"preMouseDownCallback",value:function(e){var t=e.detail,n=t.element,a=t.currentPoints;return this._startPainting(e),this._lastImageCoords=a.image,this._drawing=!0,this._startListeningForMouseUp(n),this._paint(e),!0}},{key:"_startPainting",value:function(e){var t=e.detail,n=t.element,a=Sa.configuration,o=Sa.getters.labelmap2D(n),i=o.labelmap2D,r=o.labelmap3D,s=o.currentImageIdIndex,l=o.activeLabelmapIndex,c=this._isCtrlDown(t)||this.configuration.alwaysEraseOnClick;if(this.paintEventData={labelmap2D:i,labelmap3D:r,currentImageIdIndex:s,activeLabelmapIndex:l,shouldErase:c},a.storeHistory){var u=i.pixelData.slice();this.paintEventData.previousPixelData=u}}},{key:"_endPainting",value:function(e){for(var t=Sa.configuration,n=Sa.setters,a=this.paintEventData,o=a.labelmap2D,i=a.currentImageIdIndex,r=new Set(o.pixelData).values(),s=[],l=!1;!l;){var c=r.next();(l=c.done)||s.push(c.value)}if(o.segmentsOnLabelmap=s,t.storeHistory){var u={imageIdIndex:i,diff:Le(this.paintEventData.previousPixelData,o.pixelData)};n.pushState(this.element,[u])}Oe(this.element)}},{key:"mouseMoveCallback",value:function(e){var t=e.detail.currentPoints;this._lastImageCoords=t.image}},{key:"renderToolData",value:function(e){var t=e.detail.element;Ia(t,this.name)&&this.renderBrush(e)}},{key:"passiveCallback",value:function(e){try{y.cornerstone.updateImage(this.element)}catch(e){return}}},{key:"_drawingMouseUpCallback",value:function(e){var t=e.detail.element;this._endPainting(e),this._drawing=!1,this._mouseUpRender=!0,this._stopListeningForMouseUp(t)}},{key:"newImageCallback",value:function(e){this._drawing&&(this._endPainting(e),this._startPainting(e))}},{key:"_startListeningForMouseUp",value:function(e){e.removeEventListener(b.MOUSE_UP,this._drawingMouseUpCallback),e.removeEventListener(b.MOUSE_CLICK,this._drawingMouseUpCallback),e.addEventListener(b.MOUSE_UP,this._drawingMouseUpCallback),e.addEventListener(b.MOUSE_CLICK,this._drawingMouseUpCallback),y.cornerstone.updateImage(e)}},{key:"_stopListeningForMouseUp",value:function(e){e.removeEventListener(b.MOUSE_UP,this._drawingMouseUpCallback),e.removeEventListener(b.MOUSE_CLICK,this._drawingMouseUpCallback),y.cornerstone.updateImage(e)}},{key:"increaseBrushSize",value:function(){var e=Sa.configuration,t=Sa.setters,n=e.radius,a=Math.floor(1.2*n);a===n&&(a+=1),t.radius(a)}},{key:"decreaseBrushSize",value:function(){var e=Sa.configuration,t=Sa.setters,n=e.radius,a=Math.floor(.8*n);t.radius(a)}},{key:"_isCtrlDown",value:function(e){return e.event&&e.event.ctrlKey||e.ctrlKey}}]),t}(ga),_a=function(e){return e.filter((function(e){return!(e.isMultiPartTool||e instanceof fo||e instanceof ka)}))};function Pa(e,t){var n,a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"mouse";if("touch"===a?n=(n=Ma(e,yt.touchTools())).filter((function(e){return e.options.isTouchActive})):(n=(n=Ma(e,yt.mouseTools())).filter((function(e){return Array.isArray(e.options.mouseButtonMask)&&t&&e.options.mouseButtonMask.includes(t)&&e.options.isMouseActive})),pt.isMultiPartToolActive&&(n=_a(n))),0!==n.length)return n[0]}var Da=N("manipulators:moveAllHandles"),Oa=Tt("manipulatorState"),La={mouse:[b.MOUSE_DRAG],touch:[b.TOUCH_DRAG]},Aa={mouse:[b.MOUSE_UP,b.MOUSE_CLICK],touch:[b.TOUCH_END,b.TOUCH_DRAG_END,b.TOUCH_PINCH,b.TOUCH_PRESS,b.TAP]},Ha=function(e,t,n,a){var o=e.element,i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:{},r=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"mouse",s=arguments.length>6?arguments[6]:void 0;i=Object.assign({deleteIfHandleOutsideImage:pt.deleteIfHandleOutsideImage,preventHandleOutsideImage:pt.preventHandleOutsideImage},i);var l=Ra.bind(this,t,n,i,r),c=function e(a){Na(t,n,i,r,{dragHandler:l,upOrEndHandler:e},a,s)};Oa.setters.addActiveManipulatorForElement(o,Ua.bind(null,n,i,r,{dragHandler:l,upOrEndHandler:c},o,s)),n.active=!0,pt.isToolLocked=!0,La[r].forEach((function(e){o.addEventListener(e,l)})),Aa[r].forEach((function(e){o.addEventListener(e,c)}))};function Ra(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},a=arguments.length>3?arguments[3]:void 0,o=arguments.length>4?arguments[4]:void 0,i=o.detail,r=i.element,s=i.image,l=i.buttons,c=o.detail.deltaPoints.image,u=c.x,d=c.y;t.active=!0,t.invalidated=!0;for(var h=Object.keys(t.handles),v=0;v<h.length;v++){var g=h[v],f=t.handles[g];!0!==f.movesIndependently&&f.hasOwnProperty("x")&&f.hasOwnProperty("y")&&(f.x+=u,f.y+=d,n.preventHandleOutsideImage&&Mn(f,s))}y.cornerstone.updateImage(r);var m=Pa(r,l,a);m instanceof fo&&m.updateCachedStats(s,r,t);var p=b.MEASUREMENT_MODIFIED,x={toolName:e,toolType:e,element:r,measurementData:t};C(r,p,x),o.preventDefault(),o.stopPropagation()}function Ua(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2?arguments[2]:void 0,a=arguments.length>3?arguments[3]:void 0,o=a.dragHandler,i=a.upOrEndHandler,r=arguments.length>4?arguments[4]:void 0,s=arguments.length>5?arguments[5]:void 0;Fa(e,t,n,{dragHandler:o,upOrEndHandler:i},r,s,!1)}function Na(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},a=arguments.length>3?arguments[3]:void 0,o=arguments.length>4?arguments[4]:void 0,i=o.dragHandler,r=o.upOrEndHandler,s=arguments.length>5?arguments[5]:void 0,l=arguments.length>6?arguments[6]:void 0,c=s.detail,u=c.element;Oa.setters.removeActiveManipulatorForElement(u),n.deleteIfHandleOutsideImage&&ba(c,t.handles)&&L(u,e,t),Fa(t,n,a,{dragHandler:i,upOrEndHandler:r},u,l,!0)}function Fa(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2?arguments[2]:void 0,a=arguments.length>3?arguments[3]:void 0,o=a.dragHandler,i=a.upOrEndHandler,r=arguments.length>4?arguments[4]:void 0,s=arguments.length>5?arguments[5]:void 0,l=!(arguments.length>6&&void 0!==arguments[6])||arguments[6];e.active=!1,e.invalidated=!0,pt.isToolLocked=!1,La[n].forEach((function(e){r.removeEventListener(e,o)})),Aa[n].forEach((function(e){r.removeEventListener(e,i)})),"function"==typeof t.doneMovingCallback&&(Da.warn("`options.doneMovingCallback` has been depricated. See https://github.com/cornerstonejs/cornerstoneTools/pull/915 for details."),t.doneMovingCallback(l)),"function"==typeof s&&s(l),y.cornerstone.updateImage(r)}var Ba=N("manipulators:moveHandle"),Va=Tt("manipulatorState"),qa={value:!1},ja={mouse:[b.MOUSE_DRAG],touch:[b.TOUCH_DRAG]},za={mouse:[b.MOUSE_UP,b.MOUSE_CLICK],touch:[b.TOUCH_END,b.TOUCH_DRAG_END,b.TOUCH_PINCH,b.TOUCH_PRESS,b.TAP]},Wa=function(e,t,n,a){var o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:{},i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"mouse",r=arguments.length>6?arguments[6]:void 0;o=Object.assign({deleteIfHandleOutsideImage:pt.deleteIfHandleOutsideImage,preventHandleOutsideImage:pt.preventHandleOutsideImage},o);var s=e.element,l=Ga.bind(this,t,n,a,o,i),c=function s(){Xa(t,e,n,a,o,i,{dragHandler:l,upOrEndHandler:s},r)};if(Va.setters.addActiveManipulatorForElement(s,Ya.bind(null,t,e,n,a,o,i,{dragHandler:l,upOrEndHandler:c},r)),a.active=!0,a.moving=!0,n.active=!0,pt.isToolLocked=!0,ja[i].forEach((function(e){s.addEventListener(e,l)})),za[i].forEach((function(e){s.addEventListener(e,c)})),"touch"===i){qa.value=!0;var u=y.cornerstone.getEnabledElement(s),d=Ca(e,i);Za(a,qa,u,d)}};function Ga(e,t,n,a,o,i){var r=i.detail,s=r.image,l=r.element,c=r.buttons,u=Ca(i.detail,o);qa.value=!1,n.active=!0,n.hasMoved=!0,n.x=u.x,n.y=u.y,t.invalidated=!0,a.preventHandleOutsideImage&&Mn(n,s),y.cornerstone.updateImage(l);var d=Pa(l,c,o);d instanceof fo&&d.updateCachedStats(s,l,t),C(l,b.MEASUREMENT_MODIFIED,{toolName:e,toolType:e,element:l,measurementData:t})}function Ya(e,t,n,a){var o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:{},i=arguments.length>5?arguments[5]:void 0,r=arguments.length>6?arguments[6]:void 0,s=r.dragHandler,l=r.upOrEndHandler,c=arguments.length>7?arguments[7]:void 0;Ka(e,t,n,a,o,i,{dragHandler:s,upOrEndHandler:l},c,!1)}function Xa(e,t,n,a){var o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:{},i=arguments.length>5?arguments[5]:void 0,r=arguments.length>6?arguments[6]:void 0,s=r.dragHandler,l=r.upOrEndHandler,c=arguments.length>7?arguments[7]:void 0,u=t.element;Va.setters.removeActiveManipulatorForElement(u),Ka(e,t,n,a,o,i,{dragHandler:s,upOrEndHandler:l},c,!0)}function Ka(e,t,n,a){var o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:{},i=arguments.length>5?arguments[5]:void 0,r=arguments.length>6?arguments[6]:void 0,s=r.dragHandler,l=r.upOrEndHandler,c=arguments.length>7?arguments[7]:void 0,u=!(arguments.length>8&&void 0!==arguments[8])||arguments[8],d=t.element;a.active=!1,a.moving=!1,n.active=!1,n.invalidated=!0,qa.value=!1,pt.isToolLocked=!1,ja[i].forEach((function(e){d.removeEventListener(e,s)})),za[i].forEach((function(e){d.removeEventListener(e,l)})),o.deleteIfHandleOutsideImage&&ba(t,n.handles)&&L(d,e,n),"function"==typeof o.doneMovingCallback&&(Ba.warn("`options.doneMovingCallback` has been depricated. See https://github.com/cornerstonejs/cornerstoneTools/pull/915 for details."),o.doneMovingCallback(u)),"function"==typeof c&&c(u),y.cornerstone.updateImage(d)}function Za(e,t,n,a){if(t.value){var o=Math.abs(e.y-a.y),i=o/10;if(o<1)return e.y=a.y,void(t.value=!1);e.y>a.y?e.y-=i:e.y<a.y&&(e.y+=i),y.cornerstone.updateImage(n.element),y.cornerstone.requestAnimationFrame((function(){Za(e,t,n,a)}))}}var $a=N("manipulators:moveNewHandle"),Ja=Tt("manipulatorState"),Qa={mouse:[b.MOUSE_MOVE,b.MOUSE_DRAG],touch:[b.TOUCH_DRAG]},eo={mouse:[b.MOUSE_UP,b.MOUSE_CLICK],touch:[b.TOUCH_END,b.TOUCH_PINCH,b.TAP]},to=function(e,t,n,a,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"mouse",r=arguments.length>6?arguments[6]:void 0;(o=Object.assign({deleteIfHandleOutsideImage:pt.deleteIfHandleOutsideImage,preventHandleOutsideImage:pt.preventHandleOutsideImage},o)).hasMoved=!1;var s=e.element;function l(e){no(t,n,a,o,i,e)}function c(e){oo(t,n,a,o,i,{moveHandler:l,moveEndHandler:c},e,r)}n.active=!0,a.moving=!0,a.active=!0,pt.isToolLocked=!0,Qa[i].forEach((function(e){s.addEventListener(e,l)})),s.addEventListener(b.TOUCH_START,ro),eo[i].forEach((function(e){s.addEventListener(e,c)})),Ja.setters.addActiveManipulatorForElement(s,io.bind(null,n,a,o,i,{moveHandler:l,moveEndHandler:c},s,r))};function no(e,t,n,a,o,i){var r=i.detail,s=r.image,l=r.element,c=r.buttons,u=Ca(i.detail,o);a.hasMoved=!0,t.invalidated=!0,n.active=!0,n.x=u.x,n.y=u.y,a&&a.preventHandleOutsideImage&&Mn(n,s),y.cornerstone.updateImage(l);var d=Pa(l,c,o);d instanceof fo&&d.updateCachedStats(s,l,t),C(l,b.MEASUREMENT_MODIFIED,{toolName:e,toolType:e,element:l,measurementData:t})}function ao(e,t,n,a,o){var i=a.moveHandler,r=a.moveEndHandler,s=!(arguments.length>5&&void 0!==arguments[5])||arguments[5];Qa[e].forEach((function(e){n.removeEventListener(e,i)})),eo[e].forEach((function(e){n.removeEventListener(e,r)})),n.removeEventListener(b.TOUCH_START,ro),pt.isToolLocked=!1,"function"==typeof o&&o(s),"function"==typeof t.doneMovingCallback&&($a.warn("`options.doneMovingCallback` has been depricated. See https://github.com/cornerstonejs/cornerstoneTools/pull/915 for details."),t.doneMovingCallback(s)),y.cornerstone.updateImage(n)}function oo(e,t,n,a,o,i,r,s){var l=i.moveHandler,c=i.moveEndHandler,u=r.detail,d=u.element,h=!0;if(!1!==a.hasMoved){var v=Ca(u,o);t.active=!1,t.invalidated=!0,n.active=!1,n.moving=!1,n.x=v.x,n.y=v.y,Ja.setters.removeActiveManipulatorForElement(d),a.preventHandleOutsideImage&&Mn(n,r.detail.image),a.deleteIfHandleOutsideImage&&ba(r.detail,t.handles)&&(t.cancelled=!0,h=!1,L(d,e,t)),ao(o,a,d,{moveHandler:l,moveEndHandler:c},s,h)}}function io(e,t,n,a,o,i,r){var s=o.moveHandler,l=o.moveEndHandler;e.active=!1,e.invalidated=!0,t.active=!1,ao(a,n,i,{moveHandler:s,moveEndHandler:l},r,!1)}function ro(e){return e.stopImmediatePropagation(),!1}function so(e,t){var n=pt.clickProximity,a=pt.touchProximity,o=pt.tools.find((function(e){return e.name===t}));return o&&o.configuration&&(n=o.configuration.clickProximity||n,a=o.configuration.touchProximity||a),"mouse"===e?n:a}function lo(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,a)}return n}function co(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?lo(n,!0).forEach((function(t){Ta()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):lo(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var uo=function(e,t,n,a,o){n.active=!0,pt.isToolLocked=!0;Wa(e.detail,t.name,n,a,t.options,o,(function(t){var a=e.detail.element,o=n.toolType||n.toolName,i={toolName:o,toolType:o,element:a,measurementData:co({},n,{active:!1})};C(a,b.MEASUREMENT_COMPLETED,i)})),e.stopImmediatePropagation(),e.stopPropagation(),e.preventDefault()},ho=function(e,t,n,a){for(var o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:"mouse",i=0;i<t.data.length;i++){var r=t.data[i],s=pa(e,r.handles,a,so(o,n));if(s)return{handle:s,data:r}}},vo=function(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"mouse";n.active=!0,pt.isToolLocked=!0,Ha(e.detail,t.name,n,null,t.options,a,(function(){n.active=!1,pt.isToolLocked=!1})),e.stopImmediatePropagation(),e.stopPropagation(),e.preventDefault()},go=N("baseAnnotationTool"),fo=function(e){function t(){return r()(this,t),u()(this,h()(t).apply(this,arguments))}return g()(t,e),l()(t,[{key:"createNewMeasurement",value:function(e){throw new Error("Method createNewMeasurement not implemented for ".concat(this.name,"."))}},{key:"pointNearTool",value:function(e,t,n){arguments.length>3&&void 0!==arguments[3]&&arguments[3];throw new Error("Method pointNearTool not implemented for ".concat(this.name,"."))}},{key:"distanceFromPoint",value:function(e,t,n){throw new Error("Method distanceFromPoint not implemented for ".concat(this.name,"."))}},{key:"renderToolData",value:function(e){throw new Error("renderToolData not implemented for ".concat(this.name,"."))}},{key:"mouseMoveCallback",value:function(e){for(var t=e.detail,n=t.element,a=t.currentPoints.canvas,o=O(n,this.name),i=!1,r=0;r<o.data.length;r++){var s=o.data[r];!0===ya(n,s.handles,a)&&(i=!0);var l=this.pointNearTool(n,s,a,"mouse")&&!s.active,c=!this.pointNearTool(n,s,a,"mouse")&&s.active;(l||c)&&(s.active=!s.active,i=!0)}return i}},{key:"handleSelectedCallback",value:function(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"mouse";uo(e,this,t,n,a)}},{key:"toolSelectedCallback",value:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"mouse";vo(e,this,t,n)}},{key:"updateCachedStats",value:function(e,t,n){go.warn("updateCachedStats not implemented for ".concat(this.name,"."))}}]),t}(ga),mo=function(e,t,n,a){var o=y.cornerstone,i={start:o.pixelToCanvas(e,t),end:o.pixelToCanvas(e,n)};return y.cornerstoneMath.lineSegment.distanceToPoint(i,a)},po=function(e,t){var n=Math.pow(10,t);return Math.round(e*n)/n},yo=xt.cursor,xo=function(){function e(t,n){r()(this,e),this.iconGroupString=t,this.options=Object.assign({},yo.getters.defaultOptions(),n)}return l()(e,[{key:"getIconSVG",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=this._generateIconSVGString(e);return new Blob([t],{type:"image/svg+xml"})}},{key:"getIconSVGString",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this._generateIconSVGString(e)}},{key:"getIconWithPointerSVG",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=this._generateIconWithPointerSVGString(e);return new Blob([t],{type:"image/svg+xml"})}},{key:"getIconWithPointerString",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this._generateIconWithPointerSVGString(e)}},{key:"_generateIconWithPointerSVGString",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},this.options,e),n=t.mousePointerGroupString,a=t.iconSize,o=t.viewBox,i=a/Math.max(o.x,o.y),r=16+a,s='\n        <svg\n        data-icon="cursor" role="img" xmlns="http://www.w3.org/2000/svg"\n        width="'.concat(r,'" height="').concat(r,'" viewBox="0 0 ').concat(r," ").concat(r,'"\n      >\n        <g>\n          ').concat(n,'\n        </g>\n        <g transform="translate(16, 16) scale(').concat(i,')">\n          ').concat(this.iconGroupString,"\n        </g>\n      </svg>");return this._injectColors(s,t)}},{key:"_generateIconSVGString",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},this.options,e),n=t.iconSize,a=t.viewBox,o='\n      <svg\n        data-icon="cursor" role="img" xmlns="http://www.w3.org/2000/svg"\n        width="'.concat(n,'" height="').concat(n,'" viewBox="0 0\n        ').concat(a.x," ").concat(a.y,'"\n      >\n        ').concat(this.iconGroupString,"\n      </svg>");return this._injectColors(o,t)}},{key:"_injectColors",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.activeColor||un.getActiveColor(),a=t.toolColor||un.getToolColor(),o=t.fillColor||un.getFillColor();return e.replace(/ACTIVE_COLOR/g,"".concat(n)).replace(/TOOL_COLOR/g,"".concat(a)).replace(/FILL_COLOR/g,"".concat(o))}},{key:"mousePoint",get:function(){var e=this.options.mousePoint;return"".concat(e.x," ").concat(e.y)}}]),e}(),To=new xo('<path fill="ACTIVE_COLOR" d="M1203 544q0 13-10 23l-393 393 393 393q10 10 10 23t-10 23l-50\n        50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23\n        10l50 50q10 10 10 23z"\n      />',{viewBox:{x:1792,y:1792}}),bo=new xo('<g id="arrowAnnotate-group" fill="none" stroke-width="1" stroke="ACTIVE_COLOR" stroke-linecap="round" stroke-linejoin="round">\n    <path id="arrowAnnotate-arrow" d="M23,7 l-15,15 M7,17 l0,6 6,0" stroke-width="2" />\n  </g>',{viewBox:{x:24,y:24}}),Co=new xo('<g fill="ACTIVE_COLOR" stroke-width="3" stroke="ACTIVE_COLOR">\n    <path d="M27.63 3.21L3.12 28.81"></path>\n    <path d="M27.63 15.75L15.27 4.43"></path>\n    <path d="M16.5 4.28C16.5 4.96 15.95 5.51 15.27 5.51C14.59 5.51 14.03 4.96 14.03 4.28C14.03 3.59 14.59 3.04 15.27 3.04C15.95 3.04 16.5 3.59 16.5 4.28Z" ></path>\n    <path d="M28.87 3.19C28.87 3.87 28.31 4.43 27.63 4.43C26.95 4.43 26.4 3.87 26.4 3.19C26.4 2.51 26.95 1.95 27.63 1.95C28.31 1.95 28.87 2.51 28.87 3.19Z"></path>\n    <path d="M28.87 15.75C28.87 16.43 28.31 16.99 27.63 16.99C26.95 16.99 26.4 16.43 26.4 15.75C26.4 15.07 26.95 14.51 27.63 14.51C28.31 14.51 28.87 15.07 28.87 15.75Z"></path>\n    <path d="M4.73 28.44C4.73 29.12 4.17 29.68 3.49 29.68C2.81 29.68 2.25 29.12 2.25 28.44C2.25 27.76 2.81 27.2 3.49 27.2C4.17 27.2 4.73 27.76 4.73 28.44Z"></path>\n  </g>',{viewBox:{x:48,y:48}}),Mo=new xo('<g stroke="ACTIVE_COLOR" stroke-width="3">\n    <path d="M28.59 2.34L3.82 12.32"></path>\n    <path d="M28.59 29.66L3.82 19.68"></path>\n    <path stroke-dasharray="2" fill-opacity="0" d="M12.37\n      23.06C12.67 22.36 12.85 21.93 12.92 21.76C14.6 17.8 14.68 13.35 13.15\n      9.33C13.11 9.24 13.02 9 12.88 8.63">\n    </path>\n  </g>',{viewBox:{x:32,y:32}}),Eo=new xo('<circle stroke="ACTIVE_COLOR" fill="none" stroke-width="3" cx="16" cy="16" r="14" />',{viewBox:{x:32,y:32}}),wo=new xo('<path stroke="ACTIVE_COLOR" fill="none" stroke-width="3" d="M30.74 15.76C30.74 20.99 24.14 25.23 16\n    25.23C7.86 25.23 1.26 20.99 1.26 15.76C1.26 10.54 7.86 6.3 16 6.3C24.14\n    6.3 30.74 10.54 30.74 15.76Z"\n    />',{viewBox:{x:32,y:32}}),Io=new xo('\n  <g fill="ACTIVE_COLOR" stroke="ACTIVE_COLOR" stroke-width="2">\n    <ellipse ry="1" rx="1" id="svg_3" cy="4.240343" cx="14.306499"/>\n    <line id="svg_4" y2="3.58462" x2="12.242186" y1="3.997482" x1="13.432202"/>\n    <line id="svg_5" y2="3.268901" x2="10.857882" y1="3.608906" x1="12.387902"/>\n    <line id="svg_6" y2="3.147471" x2="9.740724" y1="3.293187" x1="10.955026"/>\n    <line id="svg_7" y2="3.147471" x2="8.089274" y1="3.196043" x1="9.983585"/>\n    <line id="svg_8" y2="3.268901" x2="6.874972" y1="3.123185" x1="8.307848"/>\n    <line id="svg_9" y2="3.657478" x2="5.587812" y1="3.220329" x1="7.020688"/>\n    <line id="svg_10" y2="4.046054" x2="4.737801" y1="3.560334" x1="5.854959"/>\n    <line id="svg_11" y2="4.337487" x2="4.300652" y1="3.997482" x1="4.834945"/>\n    <line id="svg_12" y2="4.726063" x2="3.88779" y1="4.191771" x1="4.470655"/>\n    <line id="svg_15" y2="5.3575" x2="3.377783" y1="4.604633" x1="3.960648"/>\n    <line id="svg_16" y2="6.183226" x2="2.916348" y1="5.138926" x1="3.547785"/>\n    <line id="svg_17" y2="6.960379" x2="2.770632" y1="5.867507" x1="3.037779"/>\n    <line id="svg_18" y2="7.713246" x2="2.673488" y1="6.741804" x1="2.819204"/>\n    <line id="svg_19" y2="8.684687" x2="2.697774" y1="7.616102" x1="2.673488"/>\n    <line id="svg_20" y2="9.753273" x2="2.892062" y1="8.611829" x1="2.697774"/>\n    <line id="svg_21" y2="10.724714" x2="3.134923" y1="9.534698" x1="2.84349"/>\n    <line id="svg_23" y2="11.647583" x2="3.596357" y1="10.578998" x1="3.086351"/>\n    <line id="svg_25" y2="12.521881" x2="4.276366" y1="11.501867" x1="3.499213"/>\n    <line id="svg_26" y2="13.930471" x2="5.830673" y1="12.376165" x1="4.13065"/>\n    <line id="svg_28" y2="14.707624" x2="7.263549" y1="13.881899" x1="5.733528"/>\n    <line id="svg_29" y2="15.339061" x2="8.963571" y1="14.61048" x1="7.06926"/>\n    <line id="svg_30" y2="15.581921" x2="10.882168" y1="15.314775" x1="8.817855"/>\n    <line id="svg_31" y2="15.460491" x2="12.023612" y1="15.581921" x1="10.785024"/>\n    <line id="svg_33" y2="15.120487" x2="13.092197" y1="15.484777" x1="11.877895"/>\n    <line id="svg_34" y2="14.586194" x2="13.86935" y1="15.217631" x1="12.897909"/>\n    <line id="svg_35" y2="13.833327" x2="14.597931" y1="14.756196" x1="13.699348"/>\n    <line id="svg_37" y2="12.716169" x2="15.180796" y1="13.881899" x1="14.549359"/>\n    <line id="svg_39" y2="11.429009" x2="15.520801" y1="12.813313" x1="15.15651"/>\n    <ellipse ry="1" rx="1" id="svg_40" cy="10.967574" cx="15.520801"/>\n  </g>',{viewBox:{x:18,y:18}}),So=new xo('<g id="icon-freehand-sculpt" fill="none" stroke-width="1.5" stroke="ACTIVE_COLOR" stroke-linecap="round" stroke-linejoin="round">\n      <line id="svg_1" y2="2.559367" x2="10.184807" y1="4.467781" x1="8.81711"/>\n      <line id="svg_4" y2="1.493836" x2="11.727442" y1="2.766112" x1="10.089386"/>\n      <line id="svg_7" y2="1.080346" x2="13.047428" y1="1.748291" x1="11.345759"/>\n      <line id="svg_8" y2="1.000829" x2="14.351511" y1="1.112153" x1="12.77707"/>\n      <line id="svg_9" y2="1.350705" x2="15.242104" y1="0.905408" x1="13.969828"/>\n      <line id="svg_10" y2="2.098167" x2="15.862339" y1="1.14396" x1="14.955842"/>\n      <line id="svg_11" y2="3.195505" x2="16.41896" y1="1.939133" x1="15.766918"/>\n      <line id="svg_12" y2="4.292843" x2="16.530284" y1="2.925147" x1="16.387153"/>\n      <line id="svg_16" y2="5.644637" x2="16.196311" y1="3.831643" x1="16.593898"/>\n      <line id="svg_18" y2="7.266789" x2="15.623787" y1="5.19934" x1="16.275829"/>\n      <line id="svg_19" y2="10.813258" x2="14.526449" y1="6.726071" x1="15.766918"/>\n      <line id="svg_20" y2="5.056209" x2="8.085552" y1="4.181519" x1="8.976145"/>\n      <line id="svg_23" y2="5.326568" x2="7.481221" y1="4.78585" x1="8.403621"/>\n      <line id="svg_24" y2="5.565119" x2="6.749662" y1="5.294761" x1="7.624352"/>\n      <line id="svg_25" y2="5.994512" x2="5.429675" y1="5.533312" x1="6.956407"/>\n      <line id="svg_27" y2="6.551133" x2="4.284627" y1="5.962706" x1="5.572807"/>\n      <line id="svg_28" y2="7.584858" x2="3.044158" y1="6.392099" x1="4.427758"/>\n      <line id="svg_29" y2="8.84123" x2="2.185372" y1="7.489437" x1="3.219096"/>\n      <line id="svg_31" y2="10.606513" x2="1.644654" y1="8.602678" x1="2.280792"/>\n      <line id="svg_32" y2="13.214679" x2="1.48562" y1="10.352058" x1="1.724171"/>\n      <line id="svg_33" y2="14.375631" x2="1.676461" y1="12.992031" x1="1.453813"/>\n      <line id="svg_34" y2="15.298031" x2="2.264889" y1="14.152983" x1="1.517427"/>\n      <line id="svg_35" y2="16.172721" x2="3.521261" y1="14.948155" x1="1.915013"/>\n      <line id="svg_36" y2="16.824762" x2="5.207027" y1="15.997783" x1="3.28271"/>\n      <line id="svg_38" y2="17.063314" x2="7.035924" y1="16.745245" x1="4.968475"/>\n      <line id="svg_39" y2="16.888376" x2="9.278311" y1="17.047411" x1="6.733758"/>\n      <line id="svg_40" y2="16.284045" x2="10.661911" y1="16.983797" x1="8.992048"/>\n      <line id="svg_41" y2="15.313934" x2="11.647925" y1="16.395369" x1="10.455166"/>\n      <line id="svg_44" y2="13.898527" x2="12.82478" y1="15.425259" x1="11.504794"/>\n      <line id="svg_45" y2="12.037824" x2="14.144766" y1="14.312017" x1="12.522614"/>\n      <line id="svg_47" y2="10.59061" x2="14.605966" y1="12.228665" x1="13.953925"/>\n      <ellipse ry="1" rx="1" id="svg_48" cy="3.982726" cx="13.460918"/>\n    </g>',{viewBox:{x:18,y:18}}),ko=new xo('<g id="length-group" fill="none" stroke-width="1" stroke="ACTIVE_COLOR" stroke-linecap="round" stroke-linejoin="round">\n    <path id="length-dashes" d="m22.5,6 -16.5,16.5" stroke-width="3" stroke-dasharray="0.6666,5" />\n  </g>',{viewBox:{x:24,y:24}}),_o=new xo('<path fill="ACTIVE_COLOR" d="M1152 896q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75\n    75 181zm-256-544q-148 0-273 73t-198 198-73 273 73 273 198 198 273 73 273-73\n    198-198 73-273-73-273-198-198-273-73zm768 544q0 209-103 385.5t-279.5\n    279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5\n    385.5-103 385.5 103 279.5 279.5 103 385.5z"\n  />',{viewBox:{x:1792,y:1792}}),Po=new xo('<path fill="ACTIVE_COLOR" d="M1312 256h-832q-66 0-113 47t-47 113v832q0 66 47\n    113t113 47h832q66 0 113-47t47-113v-832q0-66-47-113t-113-47zm288 160v832q0\n    119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119\n    84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"\n  />',{viewBox:{x:1792,y:1792}}),Do=new xo('<path fill="ACTIVE_COLOR" d="M789 559l-170 450q33 0 136.5 2t160.5 2q19 0\n    57-2-87-253-184-452zm-725 1105l2-79q23-7 56-12.5t57-10.5 49.5-14.5 44.5-29\n    31-50.5l237-616 280-724h128q8 14 11 21l205 480q33 78 106 257.5t114 274.5q15\n    34 58 144.5t72 168.5q20 45 35 57 19 15 88 29.5t84 20.5q6 38 6 57 0 5-.5\n    13.5t-.5 12.5q-63 0-190-8t-191-8q-76 0-215 7t-178 8q0-43 4-78l131-28q1 0\n    12.5-2.5t15.5-3.5 14.5-4.5 15-6.5 11-8 9-11\n    2.5-14q0-16-31-96.5t-72-177.5-42-100l-450-2q-26 58-76.5 195.5t-50.5 162.5q0\n    22 14 37.5t43.5 24.5 48.5 13.5 57 8.5 41 4q1 19 1 58 0 9-2 27-58\n    0-174.5-10t-174.5-10q-8 0-26.5 4t-21.5 4q-80 14-188 14z"\n  />',{viewBox:{x:1792,y:1792}}),Oo=new xo('<path fill="ACTIVE_COLOR" d="M1325 1024h-109q-26 0-45-19t-19-45v-128q0-26\n    19-45t45-19h109q-32-108-112.5-188.5t-188.5-112.5v109q0 26-19 45t-45\n    19h-128q-26 0-45-19t-19-45v-109q-108 32-188.5 112.5t-112.5 188.5h109q26\n    0 45 19t19 45v128q0 26-19 45t-45 19h-109q32 108 112.5 188.5t188.5\n    112.5v-109q0-26 19-45t45-19h128q26 0 45 19t19 45v109q108-32\n    188.5-112.5t112.5-188.5zm339-192v128q0 26-19 45t-45 19h-143q-37 161-154.5\n    278.5t-278.5 154.5v143q0 26-19 45t-45 19h-128q-26\n    0-45-19t-19-45v-143q-161-37-278.5-154.5t-154.5-278.5h-143q-26\n    0-45-19t-19-45v-128q0-26 19-45t45-19h143q37-161\n    154.5-278.5t278.5-154.5v-143q0-26 19-45t45-19h128q26 0 45 19t19 45v143q161\n    37 278.5 154.5t154.5 278.5h143q26 0 45 19t19 45z"\n  />',{viewBox:{x:1792,y:1792}}),Lo=new xo('<path transform="translate(0,1792) scale(1,-1)" fill="ACTIVE_COLOR" d="M960 1408l336-384h-768l-336 384h768zm1013-1077q15\n      34 9.5 71.5t-30.5 65.5l-896 1024q-38 44-96 44h-768q-38\n      0-69.5-20.5t-47.5-54.5q-15-34-9.5-71.5t30.5-65.5l896-1024q38-44 96-44h768q38\n      0 69.5 20.5t47.5 54.5z"\n    />',{viewBox:{x:2048,y:1792}}),Ao=new xo('<path fill="ACTIVE_COLOR" d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395\n      312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5\n      0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17\n      0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208\n      32s176 78.7 176 176-78.7 176-176 176z"\n    />',{viewBox:{x:512,y:512}}),Ho=new xo('<path fill="ACTIVE_COLOR" d="M1411 541l-355 355 355 355 144-144q29-31 70-14 39 17\n      39 59v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l144-144-355-355-355\n      355 144 144q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59\n      39-17 69 14l144 144 355-355-355-355-144 144q-19 19-45 19-12\n      0-24-5-40-17-40-59v-448q0-26 19-45t45-19h448q42 0 59 40 17 39-14 69l-144\n      144 355 355 355-355-144-144q-31-30-14-69 17-40 59-40h448q26 0 45 19t19\n      45v448q0 42-39 59-13 5-25 5-26 0-45-19z"\n    />',{viewBox:{x:1792,y:1792}}),Ro=new xo('<path fill="ACTIVE_COLOR" d="M1664 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39\n      14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5\n      163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0\n      225-52t179-147q7-10 23-12 15 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109\n      132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298\n      164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14\n      39 17 39 59z"\n    />',{viewBox:{x:1792,y:1792}}),Uo=new xo('<path fill="ACTIVE_COLOR" d="M24 21v2c0 0.547-0.453 1-1 1h-22c-0.547\n      0-1-0.453-1-1v-2c0-0.547 0.453-1 1-1h22c0.547 0 1 0.453 1 1zM24 13v2c0\n      0.547-0.453 1-1 1h-22c-0.547 0-1-0.453-1-1v-2c0-0.547 0.453-1 1-1h22c0.547\n      0 1 0.453 1 1zM24 5v2c0 0.547-0.453 1-1 1h-22c-0.547\n      0-1-0.453-1-1v-2c0-0.547 0.453-1 1-1h22c0.547 0 1 0.453 1 1z"\n      />',{viewBox:{x:24,y:28}}),No=new xo('<path fill="ACTIVE_COLOR" d="M1664 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119\n    0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5\n    84.5t84.5 203.5z"\n  />',{viewBox:{x:1792,y:1792}}),Fo=new xo('<path fill="ACTIVE_COLOR" d="M14.5,3.5 a1 1 0 0 1 -11,11 Z" stroke="none" opacity="0.8" />\n    <circle cx="9" cy="9" r="8" fill="none" stroke-width="2" stroke="ACTIVE_COLOR" />',{viewBox:{x:18,y:18}}),Bo=new xo('<path fill="ACTIVE_COLOR" d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395\n      312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5\n      0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17\n      0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208\n      32s176 78.7 176 176-78.7 176-176 176z"\n    />\n    <path fill="ACTIVE_COLOR" transform="scale(0.22,0.22) translate(1400,0)" d="M1216\n      320q0 26-19 45t-45 19h-128v1024h128q26 0 45 19t19 45-19 45l-256 256q-19\n      19-45 19t-45-19l-256-256q-19-19-19-45t19-45 45-19h128v-1024h-128q-26\n      0-45-19t-19-45 19-45l256-256q19-19 45-19t45 19l256 256q19 19 19 45z"\n    />',{viewBox:{x:640,y:512}}),Vo={x:127,y:60},qo=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"ACTIVE_COLOR";return'<rect fill="'.concat(e,'" x="80.19" y="25.03" width="47.14" height="15.85"/>')},jo=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"ACTIVE_COLOR";return'<rect fill="'.concat(e,'" x="80.19" y="25.03" width="47.14" height="15.85"/>\n      <rect fill="').concat(e,'" x="95.84" y="9.38" width="15.85" height="47.14"/>')},zo='<path fill="ACTIVE_COLOR" d="M82.89,10a12.09,12.09,0,0,0-16.8-2.5l-27.5,20.4-8.5-6.3a2.93,2.93,0,0,1-1.1-3,14.66,14.66,0,0,0,.1-6.6,14.08,14.08,0,1,0-6.5,15.2,2.87,2.87,0,0,1,3.2.2l8.2,6.1-8.2,6.1a2.87,2.87,0,0,1-3.2.2,14.16,14.16,0,1,0,6.7,14.4,14,14,0,0,0-.3-5.8,2.93,2.93,0,0,1,1.1-3l8.5-6.3,27.5,20.4A11.91,11.91,0,0,0,82.89,57l-31.7-23.5ZM15.29,21a5.9,5.9,0,1,1,5.9-5.9A5.91,5.91,0,0,1,15.29,21Zm0,36.8a5.9,5.9,0,1,1,5.9-5.9A5.91,5.91,0,0,1,15.29,57.77Zm28.3-21.5a2.8,2.8,0,1,1,2.8-2.8A2.8,2.8,0,0,1,43.59,36.27Z" transform="translate(-1.17 -0.96)"/>',Wo='<path fill="ACTIVE_COLOR" d="M8.86,2.25V66.08H72.69V2.25H8.86ZM65.28,58.67h-49v-49h49v49Z" transform="translate(-8.86 -2.25)"/>',Go='<path fill="ACTIVE_COLOR" d="M40.77,2.25A31.92,31.92,0,1,0,72.69,34.16,31.92,31.92,0,0,0,40.77,2.25Zm0,57.63A25.71,25.71,0,1,1,66.48,34.16,25.71,25.71,0,0,1,40.77,59.87Z" transform="translate(-8.86 -2.25)"/>',Yo=new xo("".concat(zo," ").concat(qo()),{viewBox:Vo}),Xo=new xo("".concat(zo," ").concat(jo()),{viewBox:Vo}),Ko=new xo("".concat(zo," ").concat(qo()),{viewBox:Vo}),Zo=new xo("".concat(zo," ").concat(jo()),{viewBox:Vo}),$o=new xo("".concat(Wo," ").concat(qo()),{viewBox:Vo}),Jo=new xo("".concat(Wo," ").concat(jo()),{viewBox:Vo}),Qo=new xo("".concat(Wo," ").concat(qo()),{viewBox:Vo}),ei=new xo("".concat(Wo," ").concat(jo()),{viewBox:Vo}),ti=new xo("".concat(Go," ").concat(qo()),{viewBox:Vo}),ni=new xo("".concat(Go," ").concat(jo()),{viewBox:Vo}),ai=new xo("".concat(Go," ").concat(qo()),{viewBox:Vo}),oi=new xo("".concat(Go," ").concat(jo()),{viewBox:Vo});function ii(e){var t=y.cornerstone.metaData.get("imagePlaneModule",e.imageId);return t?{rowPixelSpacing:t.rowPixelSpacing||t.rowImagePixelSpacing,colPixelSpacing:t.columnPixelSpacing||t.colImagePixelSpacing}:{rowPixelSpacing:e.rowPixelSpacing,colPixelSpacing:e.columnPixelSpacing}}var ri=function(e){var t=T()(e);return null!==e&&("object"===t||"function"===t)};var si=function(e,t,n){var a,o,i,r,s,l,c=0,u=!1,d=!1,h=!0,v=!t&&0!==t&&"function"==typeof window.requestAnimationFrame;if("function"!=typeof e)throw new TypeError("Expected a function");function g(t){var n=a,i=o;return a=o=void 0,c=t,r=e.apply(i,n)}function f(e,t){return v?window.requestAnimationFrame(e):setTimeout(e,t)}function m(e){return c=e,s=f(y,t),u?g(e):r}function p(e){var n=e-l;return void 0===l||n>=t||n<0||d&&e-c>=i}function y(){var e=Date.now();if(p(e))return x(e);s=f(y,function(e){var n=e-c,a=t-(e-l);return d?Math.min(a,i-n):a}(e))}function x(e){return s=void 0,h&&a?g(e):(a=o=void 0,r)}function T(){for(var e=Date.now(),n=p(e),i=arguments.length,c=new Array(i),u=0;u<i;u++)c[u]=arguments[u];if(a=c,o=this,l=e,n){if(void 0===s)return m(l);if(d)return s=f(y,t),g(l)}return void 0===s&&(s=f(y,t)),r}return t=Number(t)||0,ri(n)&&(u=Boolean(n.leading),i=(d="maxWait"in n)?Math.max(Number(n.maxWait)||0,t):i,h="trailing"in n?Boolean(n.trailing):h),T.cancel=function(){void 0!==s&&function(e){if(v)return window.cancelAnimationFrame(e);clearTimeout(e)}(s),c=0,a=l=o=s=void 0},T.flush=function(){return void 0===s?r:x(Date.now())},T.pending=function(){return void 0!==s},T};var li=function(e,t,n){var a=!0,o=!0;if("function"!=typeof e)throw new TypeError("Expected a function");return ri(n)&&(a="leading"in n?Boolean(n.leading):a,o="trailing"in n?Boolean(n.trailing):o),si(e,t,{leading:a,trailing:o,maxWait:t})},ci=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"Angle",supportedInteractionTypes:["Mouse","Touch"],svgCursor:To,configuration:{drawHandles:!0,drawHandlesOnHover:!1,hideHandlesIfMoving:!1,renderDashed:!1}};return(e=u()(this,h()(t).call(this,n,a))).preventNewMeasurement=!1,e.throttledUpdateCachedStats=li(e.updateCachedStats,110),e}return g()(t,e),l()(t,[{key:"createNewMeasurement",value:function(e){return{visible:!0,active:!0,color:void 0,invalidated:!0,handles:{start:{x:e.currentPoints.image.x,y:e.currentPoints.image.y,highlight:!0,active:!1},middle:{x:e.currentPoints.image.x,y:e.currentPoints.image.y,highlight:!0,active:!0},end:{x:e.currentPoints.image.x,y:e.currentPoints.image.y,highlight:!0,active:!1},textBox:{active:!1,hasMoved:!1,movesIndependently:!1,drawnIndependently:!0,allowedOutsideImage:!0,hasBoundingBox:!0}}}}},{key:"pointNearTool",value:function(e,t,n){return!1!==t.visible&&(mo(e,t.handles.start,t.handles.middle,n)<25||mo(e,t.handles.middle,t.handles.end,n)<25)}},{key:"updateCachedStats",value:function(e,t,n){var a=di(e,n.handles.middle,n.handles.start),o=di(e,n.handles.end,n.handles.middle),i=di(e,n.handles.end,n.handles.start),r=ui(a),s=ui(o),l=ui(i),c=Math.acos((Math.pow(r,2)+Math.pow(s,2)-Math.pow(l,2))/(2*r*s));c*=180/Math.PI,n.rAngle=po(c,2),n.invalidated=!1}},{key:"renderToolData",value:function(e){var t=this,n=e.detail,a=n.enabledElement,o=this.configuration,i=o.handleRadius,r=o.drawHandlesOnHover,s=o.hideHandlesIfMoving,l=o.renderDashed,c=O(e.currentTarget,this.name),u=Tt("globalConfiguration").configuration.lineDash;if(c)for(var d=_n(n.canvasContext.canvas),h=n.image,v=n.element,g=ii(h),f=g.rowPixelSpacing,m=g.colPixelSpacing,p=Xt.getToolWidth(),x=function(e){var o=c.data[e];if(!1===o.visible)return"continue";Wt(d,(function(e){Dn(e,t.configuration);var c=un.getColorIfActive(o),d=y.cornerstone.pixelToCanvas(n.element,o.handles.start),g=y.cornerstone.pixelToCanvas(n.element,o.handles.middle),x={color:c};l&&(x.lineDash=u),$t(e,n.element,o.handles.start,[o.handles.middle,o.handles.end],x);var T={color:c,handleRadius:i,drawHandlesIfActive:r,hideHandlesIfMoving:s};if(t.configuration.drawHandles&&dn(e,n,o.handles,T),!0===o.invalidated&&(o.rAngle?t.throttledUpdateCachedStats(h,v,o):t.updateCachedStats(h,v,o)),o.rAngle){var C,M=function(e,t,n){var a=t&&n?"":" (isotropic)";return e.rAngle.toString()+String.fromCharCode(parseInt("00B0",16))+a}(o,f,m);if(!o.handles.textBox.hasMoved){C={x:g.x,y:g.y};var E=Tn(e,M,5);g.x<d.x?C.x-=15+E+10:C.x+=15;var w=y.cornerstone.internal.getTransform(a);w.invert();var I=w.transformPoint(C.x,C.y);o.handles.textBox.x=I.x,o.handles.textBox.y=I.y}Sn(e,n.element,o.handles.textBox,M,o.handles,b,c,p,0,!0)}}))},T=0;T<c.data.length;T++)x(T);function b(e){return[e.start,e.middle,e.end]}}},{key:"addNewMeasurement",value:function(e,t){var n=this;if(!this.preventNewMeasurement){this.preventNewMeasurement=!0,e.preventDefault(),e.stopPropagation();var a=e.detail,o=this.createNewMeasurement(a),i=e.detail.element;D(i,this.name,o),y.cornerstone.updateImage(i),to(a,this.name,o,o.handles.middle,this.options,t,(function(e){if(o.active=!1,!e)return L(i,n.name,o),void(n.preventNewMeasurement=!1);o.handles.end.active=!0,y.cornerstone.updateImage(i),to(a,n.name,o,o.handles.end,n.options,t,(function(e){e?(o.active=!1,y.cornerstone.updateImage(i)):L(i,n.name,o),n.preventNewMeasurement=!1,y.cornerstone.updateImage(i);var t={toolName:n.name,toolType:n.name,element:i,measurementData:o};C(i,b.MEASUREMENT_COMPLETED,t)}))}))}}}]),t}(fo);function ui(e){return Math.sqrt(Math.pow(e.x,2)+Math.pow(e.y,2))}function di(e,t,n){var a=ii(e),o=a.rowPixelSpacing,i=a.colPixelSpacing;return{x:(t.x-n.x)*(i||1),y:(t.y-n.y)*(o||1)}}var hi=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"ArrowAnnotate",supportedInteractionTypes:["Mouse","Touch"],configuration:{getTextCallback:vi,changeTextCallback:gi,drawHandles:!0,drawHandlesOnHover:!1,hideHandlesIfMoving:!1,arrowFirst:!0,renderDashed:!1,allowEmptyLabel:!1},svgCursor:bo};return(e=u()(this,h()(t).call(this,n,a))).preventNewMeasurement=!1,e}return g()(t,e),l()(t,[{key:"createNewMeasurement",value:function(e){return{visible:!0,active:!0,color:void 0,handles:{start:{x:e.detail.currentPoints.image.x,y:e.detail.currentPoints.image.y,highlight:!0,active:!1},end:{x:e.detail.currentPoints.image.x,y:e.detail.currentPoints.image.y,highlight:!0,active:!1},textBox:{active:!1,hasMoved:!1,movesIndependently:!1,drawnIndependently:!0,allowedOutsideImage:!0,hasBoundingBox:!0}}}}},{key:"pointNearTool",value:function(e,t,n){return!1!==t.visible&&mo(e,t.handles.start,t.handles.end,n)<25}},{key:"updateCachedStats",value:function(){}},{key:"renderToolData",value:function(e){var t=this,n=e.detail,a=n.element,o=n.enabledElement,i=this.configuration,r=i.handleRadius,s=i.drawHandlesOnHover,l=i.hideHandlesIfMoving,c=i.renderDashed,u=O(a,this.name);if(u){var d,h=e.detail.canvasContext.canvas,v=_n(h),g=Xt.getToolWidth();c&&(d=Tt("globalConfiguration").configuration.lineDash);for(var f=function(n){var i=u.data[n];if(!1===i.visible)return"continue";Wt(v,(function(n){Dn(n,t.configuration);var c=un.getColorIfActive(i),u=y.cornerstone.pixelToCanvas(a,i.handles.start),h=y.cornerstone.pixelToCanvas(a,i.handles.end);t.configuration.arrowFirst?Jt(n,h,u,c,g,d):Jt(n,u,h,c,g,d);var v={color:c,handleRadius:r,drawHandlesIfActive:s,hideHandlesIfMoving:l};t.configuration.drawHandles&&dn(n,e.detail,i.handles,v);var f=function(e){return e.text}(i);if(f&&""!==f){var m=Tn(n,f,5),x=pn.getFontSize()+10,T=Math.max(m,x)/2+5;if(h.x<u.x&&(T=-T),!i.handles.textBox.hasMoved){var b;b=t.configuration.arrowFirst?{x:h.x-m/2+T,y:h.y-x/2}:{x:u.x-m/2-T,y:u.y-x/2};var C=y.cornerstone.internal.getTransform(o);C.invert();var M=C.transformPoint(b.x,b.y);i.handles.textBox.x=M.x,i.handles.textBox.y=M.y}Sn(n,a,i.handles.textBox,f,i.handles,p,c,g,0,!1)}}))},m=0;m<u.data.length;m++)f(m)}function p(e){var t={x:(e.start.x+e.end.x)/2,y:(e.start.y+e.end.y)/2};return[e.start,t,e.end]}}},{key:"addNewMeasurement",value:function(e,t){var n=this,a=e.detail.element,o=this.createNewMeasurement(e),i=this.configuration.allowEmptyLabel;D(a,this.name,o),y.cornerstone.updateImage(a),to(e.detail,this.name,o,o.handles.end,this.options,t,(function(t){t?void 0===o.text&&n.configuration.getTextCallback((function(e){if(e||i){o.text=e,o.active=!1;var t={toolName:n.name,toolType:n.name,element:a,measurementData:o};y.cornerstone.updateImage(a),C(a,b.MEASUREMENT_COMPLETED,t)}else L(a,n.name,o)}),e.detail):L(a,n.name,o),y.cornerstone.updateImage(a)}))}},{key:"doubleClickCallback",value:function(e){return this._updateTextForNearbyAnnotation(e)}},{key:"touchPressCallback",value:function(e){return this._updateTextForNearbyAnnotation(e)}},{key:"_updateTextForNearbyAnnotation",value:function(e){var t=e.detail.element,n=e.detail.currentPoints.canvas,a=O(t,this.name);if(!a)return!1;for(var o=0;o<a.data.length;o++){var i=a.data[o];if(this.pointNearTool(t,i,n)||fa(i.handles.textBox,n))return i.active=!0,y.cornerstone.updateImage(t),this.configuration.changeTextCallback(i,e.detail,this._doneChangingTextCallback.bind(this,t,i)),e.stopImmediatePropagation(),e.preventDefault(),e.stopPropagation(),!0}}},{key:"_doneChangingTextCallback",value:function(e,t,n,a){!0===a?L(e,this.name,t):t.text=n,t.active=!1,y.cornerstone.updateImage(e),C(e,b.MEASUREMENT_MODIFIED,{toolName:this.name,toolType:this.name,element:e,measurementData:t})}}]),t}(fo);function vi(e){e(prompt("Enter your annotation:"))}function gi(e,t,n){n(prompt("Change your annotation:"))}var fi=function(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};return Object.assign({x:e,y:t,index:n,drawnIndependently:!1,allowedOutsideImage:!1,highlight:!0,active:!1},a)},mi=function(e){var t=e.currentPoints.image,n=t.x,a=t.y;return{toolName:this.name,toolType:this.name,isCreating:!0,visible:!0,active:!0,invalidated:!0,handles:{start:fi(n,a,0),end:fi(n,a,1,{active:!0}),perpendicularStart:fi(n,a,2,{locked:!0}),perpendicularEnd:fi(n,a,3),textBox:fi(n-50,a-70,null,{highlight:!1,hasMoved:!0,active:!1,movesIndependently:!1,drawnIndependently:!0,allowedOutsideImage:!0,hasBoundingBox:!0})},longestDiameter:0,shortestDiameter:0}},pi=function(e,t,n,a){var o=y.cornerstone,i=y.cornerstoneMath,r={start:o.pixelToCanvas(e,t.perpendicularStart),end:o.pixelToCanvas(e,t.perpendicularEnd)};return i.lineSegment.distanceToPoint(r,n)<a},yi=function(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"mouse",o=y.cornerstone,i=y.cornerstoneMath,r=t.handles,s={start:o.pixelToCanvas(e,r.start),end:o.pixelToCanvas(e,r.end)},l=i.lineSegment.distanceToPoint(s,n);if(fa(r.textBox,n))return!0;var c=so(a,"Bidirectional");return!!pi(e,r,n,c)||l<c};function xi(e,t,n,a){var o=(n.x-a.x)*e,i=(n.y-a.y)*t,r=Math.sqrt(o*o+i*i);return{x:o/r,y:i/r,length:r}}function Ti(e,t){if(!t.handles.perpendicularStart.locked)return!1;var n,a,o,i,r=t.handles,s=r.start,l=r.end,c=e.image,u=c.columnPixelSpacing,d=void 0===u?1:u,h=c.rowPixelSpacing,v=void 0===h?1:h;if(s.x===l.x&&s.y===l.y)n=s.x,a=s.y,o=l.x,i=l.y;else{var g={x:(s.x+l.x)/2,y:(s.y+l.y)/2},f=xi(d,v,s,l),m=f.length/2,p=m/(2*v),y=m/(2*d);n=g.x+y*f.y,a=g.y-p*f.x,o=g.x-y*f.y,i=g.y+p*f.x}return t.handles.perpendicularStart.x=n,t.handles.perpendicularStart.y=a,t.handles.perpendicularEnd.x=o,t.handles.perpendicularEnd.y=i,!0}var bi,Ci=function(e){var t=this,n=e.detail,a=n.element,o=n.canvasContext,i=n.image,r=this.configuration,s=r.handleRadius,l=r.drawHandlesOnHover,c=r.hideHandlesIfMoving,u=r.renderDashed,d=Tt("globalConfiguration").configuration.lineDash,h=O(a,this.name);if(h){var v=ii(i),g=v.rowPixelSpacing,f=v.colPixelSpacing;if(g&&f)for(var m,p=_n(o.canvas),y=Xt.getToolWidth(),x=function(e){var o=h.data[e];if(!1===o.visible)return"continue";m=un.getColorIfActive(o),!0===o.invalidated&&(o.longestDiameter&&o.shortestDiameter?t.throttledUpdateCachedStats(i,a,o):t.updateCachedStats(i,a,o)),Wt(p,(function(e){Dn(e,t.configuration);var i=o.handles,r=i.start,h=i.end,v=i.perpendicularStart,p=i.perpendicularEnd,x=i.textBox,T={color:m},b={color:m,strokeWidth:C};u&&(T.lineDash=d,b.lineDash=d),Zt(e,a,r,h,T);var C=y;Ti(n,o),Zt(e,a,v,p,b);var M={color:m,handleRadius:s,drawHandlesIfActive:l,hideHandlesIfMoving:c};t.configuration.drawHandles&&dn(e,n,o.handles,M);var E=Mi(o,g,f);Sn(e,a,x,E,o.handles,(function(e){return[e.start,e.end,e.perpendicularStart,e.perpendicularEnd]}),m,y,10,!0)}))},T=0;T<h.data.length;T++)x(T)}},Mi=function(e,t,n){var a=" mm";t&&n||(a=" pixels");var o=" L ".concat(e.longestDiameter).concat(a),i=" W ".concat(e.shortestDiameter).concat(a),r=e.labels;return r&&Array.isArray(r)?[].concat(J()(r),[o,i]):[o,i]},Ei=function(e,t){var n=this,a=e.detail,o=a.element,i=a.image,r=a.buttons,s=this.configuration;if(!wi(i)){var l=this.createNewMeasurement(a),c=function(){l.active=!1,y.cornerstone.updateImage(o)};D(o,this.name,l),y.cornerstone.updateImage(o);var u=(new Date).getTime(),d=l.handles,h=d.end,v=d.perpendicularStart;to(a,this.name,l,h,{},t,(function(e){if(e){var d=l.handles,h=l.longestDiameter,g=l.shortestDiameter,f=ba(a,d),m=parseFloat(h)||0,p=parseFloat(g)||0,x=m<1||p<1,T=(new Date).getTime()-u<150;f||x||T?(l.cancelled=!0,L(o,n.name,l)):s.getMeasurementLocationCallback(l,a,c),Ti(a,l),v.locked=!1,l.invalidated=!0,y.cornerstone.updateImage(o);var M=Pa(o,r,t);M instanceof Zi&&M.updateCachedStats(i,o,l);var E={toolName:n.name,toolType:n.name,element:o,measurementData:l};C(o,b.MEASUREMENT_MODIFIED,E),C(o,b.MEASUREMENT_COMPLETED,E)}else L(o,n.name,l)}))}},wi=function(e){var t=y.cornerstone.metaData.get("imagePlaneModule",e.imageId),n=e.rowPixelSpacing,a=e.columnPixelSpacing;return t&&(n=t.rowPixelSpacing||t.rowImagePixelSpacing,a=t.columnPixelSpacing||t.colImagePixelSpacing),!n||!a};var Ii={setCoords:function(e){bi=e.currentPoints.canvas},getCoords:function(){return bi}},Si=function(e){var t=this,n=e.detail,a=n.element;Ii.setCoords(n);var o=O(a,this.name);if(o){for(var i=!1,r=function(e){var r=n.currentPoints.canvas,s=o.data[e],l=function(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:6,o=pa(e,t,n,a),i=!1;return Object.keys(t).forEach((function(e){if("textBox"!==e){var n=t[e],a=n===o;n.active!==a&&(i=!0),n.active=a}})),i}(a,s.handles,r);Object.keys(s.handles).forEach((function(e){if("textBox"!==e){var t=s.handles[e];t.hover=t.active}})),l&&(i=!0);var c=t.pointNearTool(a,s,r,"mouse"),u=c&&!s.active,d=!c&&s.active;(u||d)&&(s.active=!s.active,i=!0)},s=0;s<o.data.length;s++)r(s);!0===i&&y.cornerstone.updateImage(a)}},ki=function(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"mouse";"touch"===a?this.handleSelectedTouchCallback(e):this.handleSelectedMouseCallback(e)};function _i(e,t,n,a){var o=(n.x-a.x)/t,i=(n.y-a.y)/e;return Math.sqrt(o*o+i*i)}function Pi(e,t){return{start:e,end:t}}function Di(e,t,n){var a=y.cornerstoneMath.lineSegment,o=e.handles,i=o.start,r=o.end,s=o.perpendicularStart,l=o.perpendicularEnd,c=t.image,u=c.columnPixelSpacing,d=void 0===u?1:u,h=c.rowPixelSpacing,v=void 0===h?1:h,g=Pi(i,r),f=Pi(s,l),m=a.intersectLine(g,f);return{columnPixelSpacing:d,rowPixelSpacing:v,start:i,end:r,perpendicularStart:s,perpendicularEnd:l,longLine:g,intersection:m,distanceToFixed:_i(d,v,n,m),fixedPoint:n}}function Oi(e,t,n,a){var o=Di(t,n,a),i=o.columnPixelSpacing,r=o.rowPixelSpacing,s=o.distanceToFixed,l=_i(i,r,a,e);if(l<=s)return!1;var c=s/l,u=function(e,t){var n=e.columnPixelSpacing,a=e.rowPixelSpacing,o=e.start,i=e.perpendicularStart,r=e.perpendicularEnd,s=e.intersection,l=e.fixedPoint,c=_i(n,a,i,s),u=_i(n,a,r,s),d=xi(n,a,l,t),h=l===o?1:-1,v=h*a,g=h*n;return{start:{x:t.x+d.y*c*v,y:t.y+d.x*c*g*-1},end:{x:t.x+d.y*u*v*-1,y:t.y+d.x*u*g}}}(o,{x:a.x+(e.x-a.x)*c,y:a.y+(e.y-a.y)*c});return t.handles.perpendicularStart.x=u.start.x,t.handles.perpendicularStart.y=u.start.y,t.handles.perpendicularEnd.x=u.end.x,t.handles.perpendicularEnd.y=u.end.y,!0}function Li(e,t){return e===t}function Ai(e,t){return Li(e,t)?-1:1}function Hi(e,t,n,a){var o,i=e.columnPixelSpacing,r=e.rowPixelSpacing,s=e.fixedPoint,l=e.perpendicularStart,c=e.perpendicularEnd,u=e.distanceToFixed,d=Ai(s,c)*u,h=function(e,t,n){return Li(e,n)?t:n}(s,l,c)===l,v=h?"start":"end",g=h?"end":"start";return o={},Ta()(o,v,{x:n.start.x,y:n.start.y}),Ta()(o,g,{x:t.x+a.y*r*d,y:t.y+a.x*i*d*-1}),o}function Ri(e,t,n,a){var o=y.cornerstoneMath.lineSegment,i=Di(t,n,a),r=i.columnPixelSpacing,s=i.rowPixelSpacing,l=i.start,c=i.longLine,u=i.intersection;if(!function(e,t,n){return 0!==_i(e,t,n.start,n.end)}(r,s,c))return!1;var d=xi(r,s,l,u),h=function(e,t,n){var a=e.columnPixelSpacing,o=e.rowPixelSpacing,i=e.perpendicularEnd,r=e.fixedPoint,s=Number.MAX_SAFE_INTEGER,l=Ai(r,i)*s;return{start:t,end:{x:t.x+n.y*o*l,y:t.y+n.x*a*l*-1}}}(i,e,d),v=o.intersectLine(c,h);if(!v)return!1;var g=Hi(i,v,h,d);return t.handles.perpendicularStart.x=g.start.x,t.handles.perpendicularStart.y=g.start.y,t.handles.perpendicularEnd.x=g.end.x,t.handles.perpendicularEnd.y=g.end.y,!0}var Ui=function(e,t,n,a){var o,i,r,s,l={},c={},u={x:t.currentPoints.image.x+a.x,y:t.currentPoints.image.y+a.y};0===e.index?Oi(u,n,t,n.handles.end)?(e.x=u.x,e.y=u.y):(t.currentPoints.image.x=e.x,t.currentPoints.image.y=e.y):1===e.index?Oi(u,n,t,n.handles.start)?(e.x=u.x,e.y=u.y):(t.currentPoints.image.x=e.x,t.currentPoints.image.y=e.y):2===e.index?(o=!1,l.start={x:n.handles.start.x,y:n.handles.start.y},l.end={x:n.handles.end.x,y:n.handles.end.y},c.start={x:n.handles.perpendicularEnd.x,y:n.handles.perpendicularEnd.y},c.end={x:u.x,y:u.y},(i=y.cornerstoneMath.lineSegment.intersectLine(l,c))||(c.end={x:n.handles.perpendicularStart.x,y:n.handles.perpendicularStart.y},i=y.cornerstoneMath.lineSegment.intersectLine(l,c),r=y.cornerstoneMath.point.distance(i,n.handles.start),s=y.cornerstoneMath.point.distance(i,n.handles.end),(!i||r<3||s<3)&&(o=!0)),!1,o||Ri(u,n,t,n.handles.perpendicularEnd)||(t.currentPoints.image.x=n.handles.perpendicularStart.x,t.currentPoints.image.y=n.handles.perpendicularStart.y)):3===e.index&&(o=!1,l.start={x:n.handles.start.x,y:n.handles.start.y},l.end={x:n.handles.end.x,y:n.handles.end.y},c.start={x:n.handles.perpendicularStart.x,y:n.handles.perpendicularStart.y},c.end={x:u.x,y:u.y},(i=y.cornerstoneMath.lineSegment.intersectLine(l,c))||(c.end={x:n.handles.perpendicularEnd.x,y:n.handles.perpendicularEnd.y},i=y.cornerstoneMath.lineSegment.intersectLine(l,c),r=y.cornerstoneMath.point.distance(i,n.handles.start),s=y.cornerstoneMath.point.distance(i,n.handles.end),(!i||r<3||s<3)&&(o=!0)),!1,o||Ri(u,n,t,n.handles.perpendicularStart)||(t.currentPoints.image.x=n.handles.perpendicularEnd.x,t.currentPoints.image.y=n.handles.perpendicularEnd.y))},Ni=function(e,t,n){var a=e[n],o=t[n];e[n]=o,t[n]=a},Fi=function(e,t){Ni(e,t,"x"),Ni(e,t,"y"),Ni(e,t,"moving"),Ni(e,t,"hover"),Ni(e,t,"active"),Ni(e,t,"selected")};var Bi=function(e){var t,n=this,a=e.detail,o=a.element,i=so("mouse",this.name),r=function(e){t.invalidated=!0,ba(a,t.handles)&&L(o,n.name,t),e&&(e.moving=!1,e.selected=!0),Et(n.element,n.svgCursor),y.cornerstone.updateImage(o),o.addEventListener(b.MOUSE_MOVE,n._moveCallback),o.addEventListener(b.TOUCH_START,n._moveCallback)},s=a.startPoints.canvas,l=O(e.currentTarget,this.name);if(l){for(var c=function(c){t=l.data[c];var u=[o,t.handles,s,i],d=pa.apply(void 0,u);if(d)return o.removeEventListener(b.MOUSE_MOVE,n._moveCallback),o.removeEventListener(b.TOUCH_START,n._moveCallback),t.active=!0,Vi(t.handles),d.moving=!0,(d=function(e,t,n){var a=e.image,o=a.rowPixelSpacing,i=a.columnPixelSpacing,r=t.handles,s=r.start,l=r.end,c=r.perpendicularStart,u=r.perpendicularEnd,d=(s.x-l.x)*(i||1),h=(s.y-l.y)*(o||1),v=Math.sqrt(d*d+h*h),g=(c.x-u.x)*(i||1),f=(c.y-u.y)*(o||1);return(Math.sqrt(g*g+f*f)||0)>v?(Fi(s,l),Fi(s,c),Fi(l,u),Object.values(r).find((function(e){return!0===e.moving}))):n}(a,t,d)).hasBoundingBox||wt(n.element),function(e,t,n,a,o,i){var r=e.element,s=e.image,l=e.buttons,c={x:a.x-e.currentPoints.image.x,y:a.y-e.currentPoints.image.y},u=function(e){var o=e.detail;a.hasMoved=!0,void 0===a.index||null===a.index?(a.x=o.currentPoints.image.x+c.x,a.y=o.currentPoints.image.y+c.y):Ui(a,o,n,c),i&&(a.x=Math.max(a.x,0),a.x=Math.min(a.x,o.image.width),a.y=Math.max(a.y,0),a.y=Math.min(a.y,o.image.height)),n.invalidated=!0,y.cornerstone.updateImage(r);var u=Pa(r,l,"mouse");u instanceof fo&&u.updateCachedStats(s,r,n);var d={toolName:t,toolType:t,element:r,measurementData:n};y.cornerstone.triggerEvent(r,b.MEASUREMENT_MODIFIED,d)};a.active=!0,a.moving=!0,pt.isToolLocked=!0,r.addEventListener(b.MOUSE_DRAG,u),r.addEventListener(b.TOUCH_DRAG,u);var d=y.cornerstone.getImage(r),h=function(){y.cornerstone.getImage(r).imageId!==d.imageId&&v()};r.addEventListener(y.cornerstone.EVENTS.IMAGE_RENDERED,h);var v=function e(){a.active=!1,pt.isToolLocked=!1,r.removeEventListener(y.cornerstone.EVENTS.IMAGE_RENDERED,h),r.removeEventListener(b.MOUSE_DRAG,u),r.removeEventListener(b.MOUSE_UP,e),r.removeEventListener(b.MOUSE_CLICK,e),r.removeEventListener(b.TOUCH_DRAG,u),r.removeEventListener(b.TOUCH_DRAG_END,e),r.removeEventListener(b.TAP,e),y.cornerstone.updateImage(r),"function"==typeof o&&o()};r.addEventListener(b.MOUSE_UP,v),r.addEventListener(b.MOUSE_CLICK,v),r.addEventListener(b.TOUCH_DRAG_END,v),r.addEventListener(b.TAP,v)}(a,n.name,t,d,(function(){return r(d)})),ji(e),{v:!0}},u=0;u<l.data.length;u++){var d=c(u);if("object"===T()(d))return d.v}var h=function(e){return function(){qi(e,!1),r()}};for(u=0;u<l.data.length;u++)if(t=l.data[u],this.pointNearTool(o,t,s,"mouse")){o.removeEventListener(b.MOUSE_MOVE,this._moveCallback),o.removeEventListener(b.TOUCH_START,this._moveCallback),t.active=!0,Vi(t.handles),qi(t.handles,!0);var v=h(t.handles);return Ha(a,this.name,t,null,{deleteIfHandleOutsideImage:!0,preventHandleOutsideImage:!1},"mouse",v),ji(e),!0}}},Vi=function(e){var t=!1;return Object.keys(e).forEach((function(n){"textBox"!==n&&(e[n].selected=!1,t=e[n].active||t,e[n].active=!1)})),t},qi=function(e,t){Object.keys(e).forEach((function(n){"textBox"!==n&&(e[n].moving=t)}))},ji=function(e){e.stopImmediatePropagation(),e.stopPropagation(),e.preventDefault()},zi=[b.TOUCH_END,b.TOUCH_DRAG_END,b.TOUCH_PINCH,b.TOUCH_PRESS,b.TAP],Wi=function(e){var t,n=this,a=e.detail,o=a.element,i=pt.touchProximity,r=function(e){t.invalidated=!0,ba(a,t.handles)&&L(o,n.name,t),e&&(e.moving=!1,e.selected=!0),y.cornerstone.updateImage(o),o.addEventListener(b.TOUCH_DRAG,n._moveCallback)},s=a.startPoints.canvas,l=O(e.currentTarget,this.name);if(l){for(var c=function(c){t=l.data[c];var u=[o,t.handles,s,i],d=pa.apply(void 0,u);if(d)return o.removeEventListener(b.TOUCH_DRAG,n._moveCallback),t.active=!0,Gi(t.handles),d.moving=!0,function(e,t,n,a,o,i){var r=e.element,s=e.image,l=e.buttons,c={x:a.x-e.currentPoints.image.x,y:a.y-e.currentPoints.image.y},u=function(e){var o=e.detail;a.hasMoved=!0,void 0===a.index||null===a.index?(a.x=o.currentPoints.image.x+c.x,a.y=o.currentPoints.image.y+c.y):Ui(a,o,n,c),i&&(a.x=Math.max(a.x,0),a.x=Math.min(a.x,o.image.width),a.y=Math.max(a.y,0),a.y=Math.min(a.y,o.image.height)),n.invalidated=!0,y.cornerstone.updateImage(r);var u=Pa(r,l,"touch");u instanceof fo&&u.updateCachedStats(s,r,n);var d={toolName:t,toolType:t,element:r,measurementData:n};y.cornerstone.triggerEvent(r,b.MEASUREMENT_MODIFIED,d)};a.active=!0,pt.isToolLocked=!0,r.addEventListener(b.TOUCH_DRAG,u);var d=function e(){a.active=!1,pt.isToolLocked=!1,r.removeEventListener(b.TOUCH_DRAG,u),zi.forEach((function(t){r.removeEventListener(t,e)})),y.cornerstone.updateImage(r),"function"==typeof o&&o()};zi.forEach((function(e){r.addEventListener(e,d)}))}(a,n.name,t,d,(function(){return r(d)})),Xi(e),{v:!0}},u=0;u<l.data.length;u++){var d=c(u);if("object"===T()(d))return d.v}var h=function(e){return function(){Yi(e,!1),r()}};for(u=0;u<l.data.length;u++)if(t=l.data[u],this.pointNearTool(o,t,s,"touch")){o.removeEventListener(b.TOUCH_DRAG,this._moveCallback),t.active=!0,Gi(t.handles),Yi(t.handles,!0);var v=h(t.handles);return Ha(a,this.name,t,null,{deleteIfHandleOutsideImage:!0,preventHandleOutsideImage:!1},"touch",v),Xi(e),!0}}},Gi=function(e){var t=!1;return Object.keys(e).forEach((function(n){"textBox"!==n&&(e[n].selected=!1,t=e[n].active||t,e[n].active=!1)})),t},Yi=function(e,t){Object.keys(e).forEach((function(n){"textBox"!==n&&(e[n].moving=t)}))},Xi=function(e){e.stopImmediatePropagation(),e.stopPropagation(),e.preventDefault()};var Ki=function(e,t,n){return n()},Zi=function(e){function t(e){var n;r()(this,t);var a={name:"Bidirectional",supportedInteractionTypes:["Mouse","Touch"],configuration:{changeMeasurementLocationCallback:Ki,getMeasurementLocationCallback:Ki,textBox:"",shadow:"",drawHandles:!0,drawHandlesOnHover:!0,hideHandlesIfMoving:!1,renderDashed:!1,additionalData:[]},svgCursor:Co};return(n=u()(this,h()(t).call(this,e,a))).throttledUpdateCachedStats=li(n.updateCachedStats,110),n.createNewMeasurement=mi.bind(wa()(n)),n.pointNearTool=yi.bind(wa()(n)),n.renderToolData=Ci.bind(wa()(n)),n.addNewMeasurement=Ei.bind(wa()(n)),n._moveCallback=Si.bind(wa()(n)),n.handleSelectedCallback=ki.bind(wa()(n)),n.handleSelectedMouseCallback=Bi.bind(wa()(n)),n.handleSelectedTouchCallback=Wi.bind(wa()(n)),n}return g()(t,e),l()(t,[{key:"updateCachedStats",value:function(e,t,n){if(n.toolName===this.name){var a=function(e,t){var n=t.rowPixelSpacing,a=t.colPixelSpacing,o=e.handles,i=o.start,r=o.end,s=o.perpendicularStart,l=o.perpendicularEnd,c=(i.x-r.x)*(a||1),u=(i.y-r.y)*(n||1),d=Math.sqrt(c*c+u*u),h=(s.x-l.x)*(a||1),v=(s.y-l.y)*(n||1),g=Math.sqrt(h*h+v*v);if(g||(g=0),g>d){var f=d;d=g,g=f}return{longestDiameter:d.toFixed(1),shortestDiameter:g.toFixed(1)}}(n,ii(e)),o=a.longestDiameter,i=a.shortestDiameter;n.longestDiameter=o,n.shortestDiameter=i,n.invalidated=!1}}}]),t}(fo),$i=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],a=y.cornerstone,o=a.metaData.get("patientStudyModule",e.imageId),i=a.metaData.get("generalSeriesModule",e.imageId);if(o&&i){var r=i.modality;if("PT"===r){var s=n?t:t*e.slope+e.intercept,l=o.patientWeight;if(l){var c=a.metaData.get("petIsotopeModule",e.imageId);if(c){var u=c.radiopharmaceuticalInfo,d=u.radiopharmaceuticalStartTime,h=u.radionuclideTotalDose,v=u.radionuclideHalfLife,g=i.seriesTime;if(d&&h&&v&&g){var f=Ji(g.fractionalSeconds||0)+g.seconds+60*g.minutes+60*g.hours*60,m=Ji(d.fractionalSeconds||0)+d.seconds+60*d.minutes+60*d.hours*60,p=f-m,x=h*Math.exp(-p*Math.log(2)/v),T=s*l/x*1e3;return T}}}}}};function Ji(e){return parseFloat(".".concat(e))}var Qi=function(e,t){var n=e.width/2,a=e.height/2;if(n<=0||a<=0)return!1;var o=e.left+n,i=e.top+a,r=t.x-o,s=t.y-i;return r*r/(n*n)+s*s/(a*a)<=1},er=function(e,t){for(var n=0,a=0,o=0,i=0,r=null,s=null,l=t.top;l<t.top+t.height;l++)for(var c=t.left;c<t.left+t.width;c++){Qi(t,{x:c,y:l})&&(null===r&&(r=e[i],s=e[i]),n+=e[i],a+=e[i]*e[i],r=Math.min(r,e[i]),s=Math.max(s,e[i]),o++),i++}if(0===o)return{count:o,mean:0,variance:0,stdDev:0,min:0,max:0};var u=n/o,d=a/o-u*u;return{count:o,mean:u,variance:d,stdDev:Math.sqrt(d),min:r,max:s}},tr={calculateEllipseStatistics:er,pointInEllipse:Qi};function nr(e,t){var n=function(e){var t=[e.start,e.end].sort((function(e,t){return e.x<t.x?-1:1})),n=[e.start,e.end].sort((function(e,t){return e.y<t.y?-1:1})),a=t[0],o=t[t.length-1],i=n[0],r=n[n.length-1];return{top:i,left:a,bottom:r,right:o}}(t),a=(n.left.x+n.right.x)/2,o=(n.top.y+n.bottom.y)/2,i={};return e.rotation>=0&&e.rotation<90&&(i.x=e.hflip?n.left.x:n.right.x,i.y=o),e.rotation>=90&&e.rotation<180&&(i.x=a,i.y=e.vflip?n.bottom.y:n.top.y),e.rotation>=180&&e.rotation<270&&(i.x=e.hflip?n.right.x:n.left.x,i.y=o),e.rotation>=270&&e.rotation<360&&(i.x=a,i.y=e.vflip?n.top.y:n.bottom.y),i}var ar=function(e){var t=e.toString().split(".");return t[0]=t[0].replace(/\B(?=(\d{3})+(?!\d))/g,","),t.join(".")},or=N("tools:annotation:CircleRoiTool"),ir=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"CircleRoi",supportedInteractionTypes:["Mouse","Touch"],svgCursor:Eo,configuration:{centerPointRadius:0,renderDashed:!1,hideHandlesIfMoving:!1}};return(e=u()(this,h()(t).call(this,n,a))).throttledUpdateCachedStats=li(e.updateCachedStats,110),e}return g()(t,e),l()(t,[{key:"createNewMeasurement",value:function(e){if(e&&e.currentPoints&&e.currentPoints.image)return{visible:!0,active:!0,color:void 0,invalidated:!0,handles:{start:{x:e.currentPoints.image.x,y:e.currentPoints.image.y,highlight:!0,active:!1},end:{x:e.currentPoints.image.x,y:e.currentPoints.image.y,highlight:!0,active:!0},initialRotation:e.viewport.rotation,textBox:{active:!1,hasMoved:!1,movesIndependently:!1,drawnIndependently:!0,allowedOutsideImage:!0,hasBoundingBox:!0}}};or.error("required eventData not supplied to tool ".concat(this.name,"'s createNewMeasurement"))}},{key:"pointNearTool",value:function(e,t,n,a){var o=t&&t.handles&&t.handles.start&&t.handles.end,i=y.cornerstoneMath.point.distance;if(o||or.warn("invalid parameters supplied to tool ".concat(this.name,"'s pointNearTool")),!o||!1===t.visible)return!1;var r="mouse"===a?15:25,s=y.cornerstone.pixelToCanvas(e,t.handles.start),l=y.cornerstone.pixelToCanvas(e,t.handles.end),c=i(s,n),u=i(s,l);return c>u-r/2&&c<u+r/2}},{key:"updateCachedStats",value:function(e,t,n){var a=(y.cornerstone.metaData.get("generalSeriesModule",e.imageId)||{}).modality,o=ii(e),i=function(e,t,n,a,o){var i,r=ye(n.start,n.end),s=y.cornerstone.getPixels(t,r.left,r.top,r.width,r.height),l=er(s,r);"PT"===a&&(i={mean:$i(e,l.mean,!0)||0,stdDev:$i(e,l.stdDev,!0)||0});var c=r.width*(o&&o.colPixelSpacing||1)/2,u=2*Math.PI*c;return{area:Math.PI*(r.width*(o&&o.colPixelSpacing||1)/2)*(r.height*(o&&o.rowPixelSpacing||1)/2)||0,radius:c||0,perimeter:u||0,count:l.count||0,mean:l.mean||0,variance:l.variance||0,stdDev:l.stdDev||0,min:l.min||0,max:l.max||0,meanStdDevSUV:i}}(e,t,n.handles,a,o);n.cachedStats=i,n.invalidated=!1}},{key:"renderToolData",value:function(e){var t=this,n=O(e.currentTarget,this.name);if(n){var a=y.cornerstoneMath.point.distance,o=e.detail,i=o.image,r=o.element,s=o.canvasContext,l=Xt.getToolWidth(),c=this.configuration,u=c.handleRadius,d=c.drawHandlesOnHover,h=c.hideHandlesIfMoving,v=c.renderDashed,g=c.centerPointRadius,f=_n(s.canvas),m=ii(i),p=m.rowPixelSpacing,x=m.colPixelSpacing,T=Tt("globalConfiguration").configuration.lineDash,b=(y.cornerstone.metaData.get("generalSeriesModule",i.imageId)||{}).modality,C=p&&x;Wt(f,(function(e){for(var s=0;s<n.data.length;s++){var c=n.data[s];if(!1!==c.visible){var f=un.getColorIfActive(c),m={color:f,handleRadius:u,drawHandlesIfActive:d,hideHandlesIfMoving:h};Dn(e,t.configuration);var p=y.cornerstone.pixelToCanvas(r,c.handles.start),x=y.cornerstone.pixelToCanvas(r,c.handles.end),M=a(p,x),E={color:f};if(v&&(E.lineDash=T),Qt(e,r,c.handles.start,M,E,"pixel"),g&&M>3*g&&Qt(e,r,c.handles.start,g,E,"pixel"),c.handles&&(c.handles.start.drawnIndependently=!0,c.handles.end.drawnIndependently=!0),dn(e,o,c.handles,m),!0===c.invalidated&&(c.cachedStats?t.throttledUpdateCachedStats(i,r,c):t.updateCachedStats(i,r,c)),!c.handles.textBox.hasMoved){var w=nr(o.viewport,c.handles);Object.assign(c.handles.textBox,w)}var I=sr(e,i.color,c.cachedStats,b,C,t.configuration);c.unit=rr(b,t.configuration.showHounsfieldUnits),Sn(e,r,c.handles.textBox,I,c.handles,(function(e){return t=e.start,n=e.end,a=ye(t,n),o=a.left,i=a.top,r=a.width,s=a.height,[{x:o+r/2,y:i},{x:o,y:i+s/2},{x:o+r/2,y:i+s},{x:o+r,y:i+s/2}];var t,n,a,o,i,r,s}),f,l,10,!0)}}}))}}}]),t}(fo);function rr(e,t){return"CT"===e&&!1!==t?"HU":""}function sr(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},a=n.area,o=void 0===a?0:a,i=n.radius,r=void 0===i?0:i,s=n.perimeter,l=void 0===s?0:s,c=n.mean,u=void 0===c?0:c,d=n.stdDev,h=void 0===d?0:d,v=n.min,g=void 0===v?0:v,f=n.max,m=void 0===f?0:f,p=n.meanStdDevSUV,y=void 0===p?0:p,x=arguments.length>3?arguments[3]:void 0,T=arguments.length>4?arguments[4]:void 0,b=arguments.length>5&&void 0!==arguments[5]?arguments[5]:{},C=b.showMinMax||!1,M=[],E=[];if(!t){var w=y&&0!==y.mean,I=rr(x,b.showHounsfieldUnits),S="Mean: ".concat(ar(u.toFixed(2))," ").concat(I),k="Std Dev: ".concat(ar(h.toFixed(2))," ").concat(I);if(w){for(var _=" SUV: ",P="".concat(_).concat(ar(y.mean.toFixed(2))),D="".concat(_).concat(ar(y.stdDev.toFixed(2))),O=Math.floor(e.measureText("".concat(k,"     ")).width);e.measureText(S).width<O;)S+=" ";E.push("".concat(S).concat(P)),E.push("".concat(k,"     ").concat(D))}else E.push("".concat(S,"     ").concat(k));if(C){for(var L="Min: ".concat(g," ").concat(I),A="Max: ".concat(m," ").concat(I),H=w?Math.floor(e.measureText("".concat(k,"     ")).width):Math.floor(e.measureText("".concat(S,"     ")).width);e.measureText(L).width<H;)L+=" ";E.push("".concat(L).concat(A))}}return M.push(lr(o,T)),r&&M.push(cr(r,"Radius",T)),l&&M.push(cr(l,"Perimeter",T)),E.forEach((function(e){return M.push(e)})),M}function lr(e,t){var n=t?" mm".concat(String.fromCharCode(178)):" px".concat(String.fromCharCode(178));return"Area: ".concat(ar(e.toFixed(2))).concat(n)}function cr(e,t,n){if(!e)return"";var a=n?" mm":" px";return"".concat(t,": ").concat(ar(e.toFixed(1))).concat(a)}var ur=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"CobbAngle",supportedInteractionTypes:["Mouse","Touch"],svgCursor:Mo,configuration:{drawHandles:!0,drawHandlesOnHover:!1,hideHandlesIfMoving:!1,renderDashed:!1}};return(e=u()(this,h()(t).call(this,n,a))).hasIncomplete=!1,e.throttledUpdateCachedStats=li(e.updateCachedStats,110),e}return g()(t,e),l()(t,[{key:"createNewMeasurement",value:function(e){return this.hasIncomplete=!0,{visible:!0,active:!0,color:void 0,invalidated:!0,complete:!1,value:"",handles:{start:{x:e.currentPoints.image.x,y:e.currentPoints.image.y,highlight:!0,active:!1},end:{x:e.currentPoints.image.x,y:e.currentPoints.image.y,highlight:!0,active:!0},start2:{x:e.currentPoints.image.x,y:e.currentPoints.image.y,highlight:!0,active:!1,drawnIndependently:!0},end2:{x:e.currentPoints.image.x+1,y:e.currentPoints.image.y,highlight:!0,active:!1,drawnIndependently:!0},textBox:{active:!1,hasMoved:!1,movesIndependently:!1,drawnIndependently:!0,allowedOutsideImage:!0,hasBoundingBox:!0}}}}},{key:"pointNearTool",value:function(e,t,n){if(!1===t.visible)return!1;if(this.hasIncomplete)return!1;var a=mo(e,t.handles.start,t.handles.end,n)<25,o=mo(e,t.handles.start2,t.handles.end2,n)<25;return a||o}},{key:"updateCachedStats",value:function(e,t,n){var a=ii(e),o=a.rowPixelSpacing,i=a.colPixelSpacing,r=(Math.ceil(n.handles.start.x)-Math.ceil(n.handles.end.x))*(i||1),s=(Math.ceil(n.handles.start.y)-Math.ceil(n.handles.end.y))*(o||1),l=(Math.ceil(n.handles.start2.x)-Math.ceil(n.handles.end2.x))*(i||1),c=(Math.ceil(n.handles.start2.y)-Math.ceil(n.handles.end2.y))*(o||1),u=Math.acos(Math.abs((r*l+s*c)/(Math.sqrt(r*r+s*s)*Math.sqrt(l*l+c*c))));u*=180/Math.PI,n.rAngle=po(u,2),n.invalidated=!1}},{key:"renderToolData",value:function(e){var t=this,n=e.detail,a=this.configuration,o=a.handleRadius,i=a.drawHandlesOnHover,r=a.hideHandlesIfMoving,s=a.renderDashed,l=O(e.currentTarget,this.name);if(l)for(var c=_n(n.canvasContext.canvas),u=Xt.getToolWidth(),d=Tt("globalConfiguration").configuration.lineDash,h=pn.getFont(),v=e.detail.element,g=ii(y.cornerstone.getEnabledElement(v).image),f=g.rowPixelSpacing,m=g.colPixelSpacing,p=function(e){var a=l.data[e];if(!1===a.visible)return"continue";a.value||(a.value=t.textBoxText(a,f,m)),Wt(c,(function(e){Dn(e,t.configuration);var l=un.getColorIfActive(a),c={color:l};s&&(c.lineDash=d),Zt(e,n.element,a.handles.start,a.handles.end,c),a.complete&&Zt(e,n.element,a.handles.start2,a.handles.end2,c);var v={color:l,handleRadius:o,drawHandlesIfActive:i,hideHandlesIfMoving:r};t.configuration.drawHandles&&dn(e,n,a.handles,v),e.fillStyle=l;var g=a.value;if(!a.handles.textBox.hasMoved){var f={x:(a.handles.start.x+a.handles.end.x)/2,y:(a.handles.start.y+a.handles.end.y)/2-10};e.font=h,a.handles.textBox.x=f.x,a.handles.textBox.y=f.y}Sn(e,n.element,a.handles.textBox,g,a.handles,T,l,u,0,!0)}))},x=0;x<l.data.length;x++)p(x);function T(e){return[e.start,e.start2,e.end,e.end2]}}},{key:"getIncomplete",value:function(e){var t=O(e,this.name);if(t&&Array.isArray(t.data))return t.data.find((function(e){return!1===e.complete}))}},{key:"addNewMeasurement",value:function(e,t){var n=this;e.preventDefault(),e.stopPropagation();var a,o,i=e.detail,r=function(e){if(e){var t=b.MEASUREMENT_COMPLETED,o={toolName:n.name,toolType:n.name,element:s,measurementData:a};C(s,t,o)}else L(s,n.name,a)},s=e.detail.element,l=this.getIncomplete(s);l?((a=l).complete=!0,a.handles.start2={x:i.currentPoints.image.x,y:i.currentPoints.image.y,drawnIndependently:!1,highlight:!0,active:!1},a.handles.end2={x:i.currentPoints.image.x,y:i.currentPoints.image.y,drawnIndependently:!1,highlight:!0,active:!0},o=a.handles.end2,this.hasIncomplete=!1,r=function(e){if(e){var t=b.MEASUREMENT_COMPLETED,o={toolName:n.name,toolType:n.name,element:s,measurementData:a};C(s,t,o)}else L(s,n.name,a)}):(a=this.createNewMeasurement(i),D(s,this.name,a),o=a.handles.end),y.cornerstone.updateImage(s),to(i,this.name,a,o,this.options,t,r)}},{key:"onMeasureModified",value:function(e){var t=e.detail.element,n=y.cornerstone.getEnabledElement(t).image,a=ii(n),o=a.rowPixelSpacing,i=a.colPixelSpacing;if(e.detail.toolName===this.name){var r=e.detail.measurementData;!0===r.invalidated&&(r.rAngle?this.throttledUpdateCachedStats(n,t,r):this.updateCachedStats(n,t,r)),r.value=this.textBoxText(r,o,i)}}},{key:"textBoxText",value:function(e,t,n){var a=e.rAngle;if(void 0===a)return"";if(Number.isNaN(a))return"";var o=t&&n?"":" (isotropic)";return"".concat(a,"°").concat(o)}},{key:"activeCallback",value:function(e){this.onMeasureModified=this.onMeasureModified.bind(this),e.addEventListener(b.MEASUREMENT_MODIFIED,this.onMeasureModified)}},{key:"passiveCallback",value:function(e){this.onMeasureModified=this.onMeasureModified.bind(this),e.addEventListener(b.MEASUREMENT_MODIFIED,this.onMeasureModified)}},{key:"enabledCallback",value:function(e){e.removeEventListener(b.MEASUREMENT_MODIFIED,this.onMeasureModified)}},{key:"disabledCallback",value:function(e){e.removeEventListener(b.MEASUREMENT_MODIFIED,this.onMeasureModified)}}]),t}(fo),dr=N("tools:annotation:EllipticalRoiTool"),hr=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"EllipticalRoi",supportedInteractionTypes:["Mouse","Touch"],configuration:{drawHandlesOnHover:!1,hideHandlesIfMoving:!1,renderDashed:!1},svgCursor:wo};return(e=u()(this,h()(t).call(this,n,a))).throttledUpdateCachedStats=li(e.updateCachedStats,110),e}return g()(t,e),l()(t,[{key:"createNewMeasurement",value:function(e){if(e&&e.currentPoints&&e.currentPoints.image)return{visible:!0,active:!0,color:void 0,invalidated:!0,handles:{start:{x:e.currentPoints.image.x,y:e.currentPoints.image.y,highlight:!0,active:!1},end:{x:e.currentPoints.image.x,y:e.currentPoints.image.y,highlight:!0,active:!0},initialRotation:e.viewport.rotation,textBox:{active:!1,hasMoved:!1,movesIndependently:!1,drawnIndependently:!0,allowedOutsideImage:!0,hasBoundingBox:!0}}};dr.error("required eventData not supplied to tool ".concat(this.name,"'s createNewMeasurement"))}},{key:"pointNearTool",value:function(e,t,n,a){var o=t&&t.handles&&t.handles.start&&t.handles.end;if(o||dr.warn("invalid parameters supplied to tool ".concat(this.name,"'s pointNearTool")),!o||!1===t.visible)return!1;if(pa(e,t.handles,n,6))return!0;var i="mouse"===a?15:25,r=y.cornerstone.pixelToCanvas(e,t.handles.start),s=y.cornerstone.pixelToCanvas(e,t.handles.end),l={left:Math.min(r.x,s.x)+i/2,top:Math.min(r.y,s.y)+i/2,width:Math.abs(r.x-s.x)-i,height:Math.abs(r.y-s.y)-i},c={left:Math.min(r.x,s.x)-i/2,top:Math.min(r.y,s.y)-i/2,width:Math.abs(r.x-s.x)+i,height:Math.abs(r.y-s.y)+i},u=Qi(l,n);return!(!Qi(c,n)||u)}},{key:"updateCachedStats",value:function(e,t,n){var a=(y.cornerstone.metaData.get("generalSeriesModule",e.imageId)||{}).modality,o=ii(e),i=function(e,t,n,a,o){var i,r=mr(n.start,n.end),s=y.cornerstone.getPixels(t,r.left,r.top,r.width,r.height),l=er(s,r);"PT"===a&&(i={mean:$i(e,l.mean,!0)||0,stdDev:$i(e,l.stdDev,!0)||0});return{area:Math.PI*(r.width*(o.colPixelSpacing||1)/2)*(r.height*(o.rowPixelSpacing||1)/2)||0,count:l.count||0,mean:l.mean||0,variance:l.variance||0,stdDev:l.stdDev||0,min:l.min||0,max:l.max||0,meanStdDevSUV:i}}(e,t,n.handles,a,o);n.cachedStats=i,n.invalidated=!1}},{key:"renderToolData",value:function(e){var t=this,n=O(e.currentTarget,this.name);if(n){var a=e.detail,o=a.image,i=a.element,r=Xt.getToolWidth(),s=Tt("globalConfiguration").configuration.lineDash,l=this.configuration,c=l.handleRadius,u=l.drawHandlesOnHover,d=l.hideHandlesIfMoving,h=l.renderDashed,v=_n(a.canvasContext.canvas),g=ii(o),f=g.rowPixelSpacing,m=g.colPixelSpacing,p=(y.cornerstone.metaData.get("generalSeriesModule",o.imageId)||{}).modality,x=f&&m;Wt(v,(function(e){for(var l=0;l<n.data.length;l++){var v=n.data[l];if(!1!==v.visible){var g=un.getColorIfActive(v),f={color:g,handleRadius:c,drawHandlesIfActive:u,hideHandlesIfMoving:d};Dn(e,t.configuration);var m={color:g};if(h&&(m.lineDash=s),rn(e,i,v.handles.start,v.handles.end,m,"pixel",v.handles.initialRotation),dn(e,a,v.handles,f),!0===v.invalidated&&(v.cachedStats?t.throttledUpdateCachedStats(o,i,v):t.updateCachedStats(o,i,v)),!v.handles.textBox.hasMoved){var y=nr(a.viewport,v.handles);Object.assign(v.handles.textBox,y)}var T=gr(e,o.color,v.cachedStats,p,x,t.configuration);v.unit=vr(p,t.configuration.showHounsfieldUnits),Sn(e,i,v.handles.textBox,T,v.handles,(function(e){return t=e.start,n=e.end,a=mr(t,n),o=a.left,i=a.top,r=a.width,s=a.height,[{x:o+r/2,y:i},{x:o,y:i+s/2},{x:o+r/2,y:i+s},{x:o+r,y:i+s/2}];var t,n,a,o,i,r,s}),g,r,10,!0)}}}))}}}]),t}(fo);function vr(e,t){return"CT"===e&&!1!==t?"HU":""}function gr(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},a=n.area,o=void 0===a?0:a,i=n.mean,r=void 0===i?0:i,s=n.stdDev,l=void 0===s?0:s,c=n.min,u=void 0===c?0:c,d=n.max,h=void 0===d?0:d,v=n.meanStdDevSUV,g=void 0===v?0:v,f=arguments.length>3?arguments[3]:void 0,m=arguments.length>4?arguments[4]:void 0,p=arguments.length>5&&void 0!==arguments[5]?arguments[5]:{},y=p.showMinMax||!1,x=[],T=[];if(!t){var b=g&&0!==g.mean,C=vr(f,p.showHounsfieldUnits),M="Mean: ".concat(ar(r.toFixed(2))," ").concat(C),E="Std Dev: ".concat(ar(l.toFixed(2))," ").concat(C);if(b){for(var w=" SUV: ",I="".concat(w).concat(ar(g.mean.toFixed(2))),S="".concat(w).concat(ar(g.stdDev.toFixed(2))),k=Math.floor(e.measureText("".concat(E,"     ")).width);e.measureText(M).width<k;)M+=" ";T.push("".concat(M).concat(I)),T.push("".concat(E,"     ").concat(S))}else T.push("".concat(M)),T.push("".concat(E));if(y){for(var _="Min: ".concat(u," ").concat(C),P="Max: ".concat(h," ").concat(C),D=b?Math.floor(e.measureText("".concat(E,"     ")).width):Math.floor(e.measureText("".concat(M,"     ")).width);e.measureText(_).width<D;)_+=" ";T.push("".concat(_).concat(P))}}return x.push(fr(o,m)),T.forEach((function(e){return x.push(e)})),x}function fr(e,t){var n=t?" mm".concat(String.fromCharCode(178)):" px".concat(String.fromCharCode(178));return"Area: ".concat(ar(e.toFixed(2))).concat(n)}function mr(e,t){return{left:Math.round(Math.min(e.x,t.x)),top:Math.round(Math.min(e.y,t.y)),width:Math.round(Math.abs(e.x-t.x)),height:Math.round(Math.abs(e.y-t.y))}}var pr=function(e,t){for(var n=!1,a=e.length-1,o=0;o<e.length;o++)yr(t,e[o],e[a])&&(n=!n),a=o;return n};function yr(e,t,n){return a=e.y,o=t.y,i=n.y,!(!(o<a&&a<i||i<a&&a<o)||!function(e,t,n){if(t.x>e.x&&n.x>e.x)return!0;if(t.x===n.x)return e.x<t.x;if(t.x>n.x){var a=t;t=n,n=a}var o=function(e,t,n){var a=(n.y-t.y)/(n.x-t.x);return{value:t.y+a*(e.x-t.x),gradient:a}}(e,t,n);return Math.sign(o.gradient)*e.y>Math.sign(o.gradient)*o.value}(e,t,n));var a,o,i}function xr(e,t,n,a){pr(e,t)&&(n.value+=a,n.squared+=a*a,n.count++)}var Tr=function e(t,n){r()(this,e),this.toolIndex=t,this.handleIndexArray=n},br=function e(t){var n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],a=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];r()(this,e),this.x=t.x,this.y=t.y,this.highlight=n,this.active=a,this.lines=[]};function Cr(e,t,n,a){for(var o=e.length-1,i=0;i<e.length;i++)if(-1===a.indexOf(i)&&-1===a.indexOf(o)){if(Mr(t,n,Er(e[o]),Er(e[i])))return!0;o=i}else o=i;return!1}function Mr(e,t,n,a){var o=!1,i=[wr(e,t,n),wr(e,t,a),wr(n,a,e),wr(n,a,t)];return i[0]!==i[1]&&i[2]!==i[3]||((0===i[0]&&Ir(e,n,t)||0===i[1]&&Ir(e,a,t)||0===i[2]&&Ir(n,e,a)||0===i[3]&&Ir(n,t,a))&&(o=!0),o)}function Er(e){return{x:e.x,y:e.y}}function wr(e,t,n){var a=(t.y-e.y)*(n.x-t.x)-(t.x-e.x)*(n.y-t.y);return 0===a?0:a>0?1:2}function Ir(e,t,n){return t.x<=Math.max(e.x,n.x)&&t.x>=Math.min(e.x,n.x)&&t.y<=Math.max(e.y,n.y)&&t.y>=Math.min(e.y,n.y)}var Sr={newHandle:function(e,t){var n=t.length-1;return Cr(t,Er(t[n]),Er(e),[n])},end:function(e){var t=e.length-1;return Cr(e,Er(e[t]),Er(e[0]),[t,0])},modify:function(e,t){var n=Er(e[t]),a=t-1;0===t&&(a=e.length-1);var o=Er(e[a]);return!!Cr(e,n,o,[t,a])||Cr(e,n,o=Er(e[a=t===e.length-1?0:t+1]),[t,a])}},kr=function(){function e(t,n){r()(this,e),this._eventData=t,this._toolName=n}return l()(e,[{key:"findLine",value:function(){var e=this.findTool();if(null===e)return null;var t=this._getCloseLinesInTool(e);return t?this._findCorrectLine(e,t):null}},{key:"findTool",value:function(){return this._toolData=O(this._eventData.element,this._toolName),this._mousePoint=this._eventData.currentPoints.canvas,this._toolData?this._nearestHandleToPointAllTools().toolIndex:null}},{key:"_nearestHandleToPointAllTools",value:function(){for(var e=this._toolData,t={toolIndex:null,handleIndex:null,distance:1/0},n=0;n<e.data.length;n++){var a=this._nearestHandleToPoint(n);null!==a&&(a.distance<t.distance&&(t=a))}return t}},{key:"_nearestHandleToPoint",value:function(e){var t=this._eventData,n=this._toolData.data[e],a=n.handles.points;if(void 0===a)return null;if(!1===n.visible)return null;for(var o={toolIndex:e,handleIndex:null,distance:1/0},i=0;i<a.length;i++){var r=y.cornerstone.pixelToCanvas(t.element,a[i]),s=y.cornerstoneMath.point.distance(r,this._mousePoint);s<o.distance&&(o.handleIndex=i,o.distance=s)}return o}},{key:"_getCloseLinesInTool",value:function(t){for(var n=this._toolData.data[t].handles.points,a=[],o=0;o<n.length;o++){var i=e.getNextHandleIndex(o,n.length);this._distanceOfPointfromLine(n[o],n[i])<10&&a.push([o,i])}return a}},{key:"_findCorrectLine",value:function(e,t){for(var n=0;n<t.length;n++)if(this._pointProjectsToLineSegment(e,t[n]))return new Tr(e,t[n]);return null}},{key:"_pointProjectsToLineSegment",value:function(t,n){var a=this._eventData,o=this._toolData.data[t],i=o.handles.points;if(void 0!==o.handles.points){if(!1===o.visible)return!1;var r=i[n[0]],s=i[n[1]],l=e.getCanvasPointsFromHandles(r,s,a.element),c=e.getLineAsVector(l),u=this._getLineOriginToMouseAsVector(l),d=(u[0]*c[0]+u[1]*c[1])/c.magnitude;return d>0&&d<c.magnitude}}},{key:"_getLineOriginToMouseAsVector",value:function(e){return[this._mousePoint.x-e[0].x,this._mousePoint.y-e[0].y]}},{key:"_distanceOfPointfromLine",value:function(e,t){var n=this._eventData,a=y.cornerstone.pixelToCanvas(n.element,e),o=y.cornerstone.pixelToCanvas(n.element,t),i=this._mousePoint;return Math.abs((o.y-a.y)*i.x-(o.x-a.x)*i.y+o.x*a.y-o.y*a.x)/y.cornerstoneMath.point.distance(a,o)}}],[{key:"getCanvasPointsFromHandles",value:function(e,t,n){var a=[];return e.x<t.x?(a.push(y.cornerstone.pixelToCanvas(n,e)),a.push(y.cornerstone.pixelToCanvas(n,t))):(a.push(y.cornerstone.pixelToCanvas(n,t)),a.push(y.cornerstone.pixelToCanvas(n,e))),a}},{key:"getLineAsVector",value:function(e){var t=[e[1].x-e[0].x,e[1].y-e[0].y];return t.magnitude=y.cornerstoneMath.point.distance(e[0],e[1]),t}},{key:"getNextHandleIndex",value:function(e,t){return e<t-1?e+1:0}}]),e}(),_r=function(e,t){t===e.length-1?e[t].lines.push(e[0]):e[t].lines.push(e[t+1])};function Pr(e,t){var n=O(e.element,this.name);if(void 0!==n){var a=t.handleIndex,o=t.toolIndex,i=n.data[o],r=i.handles.points;r.length<=3||(a===r.length-1?(r[a-1].lines.pop(),r[a-1].lines.push(r[0])):0===a?(r[r.length-1].lines.pop(),r[r.length-1].lines.push(r[a+1])):(r[a-1].lines.pop(),r[a-1].lines.push(r[a+1])),r.splice(a,1),i.invalidated=!0,i.active=!0,i.highlight=!0,y.cornerstone.updateImage(e.element))}}function Dr(e,t){var n=O(e.element,this.name);if(void 0!==n){var a=n.data[t.toolIndex],o=function(e){for(var t=e.handleIndexArray,n=1/0,a=t.includes(0),o=0;o<t.length;o++){var i=t[o];0!==i&&i<n&&(n=i)}a&&1===n&&(n=0);return++n}(t);if(o!==1/0){var i=new br(e.currentPoints.image),r=a.handles.points;r.splice(o,0,i),r[o-1].lines.pop(),r[o-1].lines.push(e.currentPoints.image),_r(r,o),a.active=!0,a.highlight=!0,a.invalidated=!0,y.cornerstone.updateImage(e.element)}}}var Or={calculateFreehandStatistics:function(e,t,n){var a={count:0,mean:0,variance:0,stdDev:0},o=function(e,t,n){for(var a={value:0,squared:0,count:0},o=0,i=t.top;i<t.top+t.height;i++)for(var r=t.left;r<t.left+t.width;r++){xr(n,{x:r,y:i},a,e[o]),o++}return a}(e,t,n);return 0===o.count||(a.count=o.count,a.mean=o.value/o.count,a.variance=o.squared/o.count-a.mean*a.mean,a.stdDev=Math.sqrt(a.variance)),a},ClickedLineData:Tr,freehandArea:function(e,t){var n=0,a=e.length-1;t=t||1;for(var o=0;o<e.length;o++)n+=(e[a].x+e[o].x)*(e[a].y-e[o].y),a=o;return Math.abs(n*t/2)},FreehandHandleData:br,freehandIntersect:Sr,FreehandLineFinder:kr,insertOrDelete:function(e,t){var n=e.detail;if(t&&null!==t.handleNearby){var a={toolIndex:t.toolIndex,handleIndex:t.handleNearby};Pr.call(this,n,a)}else{var o=new kr(n,this.name).findLine();o&&Dr.call(this,n,o)}},pointInFreehand:pr,addLine:_r},Lr=N("tools:annotation:FreehandRoiTool"),Ar=Or.insertOrDelete,Hr=Or.freehandArea,Rr=Or.calculateFreehandStatistics,Ur=Or.freehandIntersect,Nr=Or.FreehandHandleData,Fr=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"FreehandRoi",supportedInteractionTypes:["Mouse","Touch"],configuration:{mouseLocation:{handles:{start:{highlight:!0,active:!0}}},spacing:1,activeHandleRadius:3,completeHandleRadius:6,completeHandleRadiusTouch:28,alwaysShowHandles:!1,invalidColor:"crimson",currentHandle:0,currentTool:-1,drawHandles:!0,renderDashed:!1},svgCursor:Io};return(e=u()(this,h()(t).call(this,n,a))).isMultiPartTool=!0,e._drawing=!1,e._dragging=!1,e._modifying=!1,e._drawingMouseDownCallback=e._drawingMouseDownCallback.bind(wa()(e)),e._drawingMouseMoveCallback=e._drawingMouseMoveCallback.bind(wa()(e)),e._drawingMouseDragCallback=e._drawingMouseDragCallback.bind(wa()(e)),e._drawingMouseUpCallback=e._drawingMouseUpCallback.bind(wa()(e)),e._drawingMouseDoubleClickCallback=e._drawingMouseDoubleClickCallback.bind(wa()(e)),e._editMouseUpCallback=e._editMouseUpCallback.bind(wa()(e)),e._editMouseDragCallback=e._editMouseDragCallback.bind(wa()(e)),e._drawingTouchStartCallback=e._drawingTouchStartCallback.bind(wa()(e)),e._drawingTouchDragCallback=e._drawingTouchDragCallback.bind(wa()(e)),e._drawingDoubleTapClickCallback=e._drawingDoubleTapClickCallback.bind(wa()(e)),e._editTouchDragCallback=e._editTouchDragCallback.bind(wa()(e)),e.throttledUpdateCachedStats=li(e.updateCachedStats,110),e}return g()(t,e),l()(t,[{key:"createNewMeasurement",value:function(e){if(e&&e.currentPoints&&e.currentPoints.image){var t={visible:!0,active:!0,invalidated:!0,color:void 0,handles:{points:[]}};return t.handles.textBox={active:!1,hasMoved:!1,movesIndependently:!1,drawnIndependently:!0,allowedOutsideImage:!0,hasBoundingBox:!0},t}Lr.error("required eventData not supplied to tool ".concat(this.name,"'s createNewMeasurement"))}},{key:"pointNearTool",value:function(e,t,n){var a=t&&t.handles&&t.handles.points;if(!a)throw new Error("invalid parameters supplied to tool ".concat(this.name,"'s pointNearTool"));return!(!a||!1===t.visible)&&void 0!==this._pointNearHandle(e,t,n)}},{key:"distanceFromPoint",value:function(e,t,n){for(var a=1/0,o=0;o<t.handles.points.length;o++){var i=y.cornerstoneMath.point.distance(t.handles.points[o],n);a=Math.min(a,i)}return a===1/0?-1:a}},{key:"distanceFromPointCanvas",value:function(e,t,n){var a=1/0;if(!t)return-1;for(var o=y.cornerstone.pixelToCanvas(e,n),i=t.handles.points,r=0;r<i.length;r++){var s=y.cornerstone.pixelToCanvas(e,i[r]),l=y.cornerstoneMath.point.distance(s,o);a=Math.min(a,l)}return a===1/0?-1:a}},{key:"updateCachedStats",value:function(e,t,n){for(var a,o,i=y.cornerstone.metaData.get("generalSeriesModule",e.imageId),r=i?i.modality:null,s=n.handles.points,l={left:s[0].x,right:s[0].x,bottom:s[0].y,top:s[0].x},c=0;c<s.length;c++)l.left=Math.min(l.left,s[c].x),l.right=Math.max(l.right,s[c].x),l.bottom=Math.min(l.bottom,s[c].y),l.top=Math.max(l.top,s[c].y);var u={left:l.left,top:l.bottom,width:Math.abs(l.right-l.left),height:Math.abs(l.top-l.bottom)};if(n.polyBoundingBox=u,!e.color){var d=y.cornerstone.getPixels(t,u.left,u.top,u.width,u.height);a=Rr.call(this,d,u,n.handles.points),"PT"===r&&(o={mean:$i(e,(a.mean-e.intercept)/e.slope),stdDev:$i(e,(a.stdDev-e.intercept)/e.slope)}),a&&!isNaN(a.mean)&&(n.meanStdDev=a,n.meanStdDevSUV=o)}var h=ii(e),v=(h.colPixelSpacing||1)*(h.rowPixelSpacing||1),g=Hr(n.handles.points,v);isNaN(g)||(n.area=g),n.invalidated=!1}},{key:"renderToolData",value:function(e){var t=this,n=e.detail,a=O(e.currentTarget,this.name);if(a)for(var o=n.image,i=n.element,r=this.configuration,s=y.cornerstone.metaData.get("generalSeriesModule",o.imageId),l=s?s.modality:null,c=_n(n.canvasContext.canvas),u=Xt.getToolWidth(),d=r.renderDashed,h=Tt("globalConfiguration").configuration.lineDash,v=function(e){var s=a.data[e];if(!1===s.visible)return"continue";Wt(c,(function(e){var a,l=un.getColorIfActive(s);s.active?s.handles.invalidHandlePlacement?(l=r.invalidColor,a=r.invalidColor):(l=un.getColorIfActive(s),a=un.getFillColor()):a=un.getToolColor();var c={color:l};if(d&&(c.lineDash=h),s.handles.points.length){var v=s.handles.points;$t(e,i,v[0],v,c),s.polyBoundingBox?$t(e,i,v[v.length-1],[v[0]],c):$t(e,i,v[v.length-1],[r.mouseLocation.handles.start],c)}if(c={color:l,fill:a},(r.alwaysShowHandles||s.active&&s.polyBoundingBox)&&(c.handleRadius=r.activeHandleRadius,t.configuration.drawHandles&&dn(e,n,s.handles.points,c)),s.canComplete){c.handleRadius=r.completeHandleRadius;var g=s.handles.points[0];t.configuration.drawHandles&&dn(e,n,[g],c)}if(s.active&&!s.polyBoundingBox){c.handleRadius=r.activeHandleRadius,t.configuration.drawHandles&&dn(e,n,r.mouseLocation.handles,c);var p=s.handles.points[0];t.configuration.drawHandles&&dn(e,n,[p],c)}if(!0!==s.invalidated||s.active||(s.meanStdDev&&s.meanStdDevSUV&&s.area?t.throttledUpdateCachedStats(o,i,s):t.updateCachedStats(o,i,s)),s.polyBoundingBox&&!s.handles.textBox.freehand){s.handles.textBox.hasMoved||(s.handles.textBox.x=s.polyBoundingBox.left+s.polyBoundingBox.width,s.handles.textBox.y=s.polyBoundingBox.top+s.polyBoundingBox.height/2);var y=f.call(t,s);Sn(e,i,s.handles.textBox,y,s.handles.points,m,l,u,0,!0)}}))},g=0;g<a.data.length;g++)v(g);function f(e){var t=e.meanStdDev,n=e.meanStdDevSUV,a=e.area,i=[];if(t&&void 0!==t.mean){var r="";"CT"===l&&(r="HU"),e.unit=r;var s="Mean: ".concat(ar(t.mean.toFixed(2))," ").concat(r),c="StdDev: ".concat(ar(t.stdDev.toFixed(2))," ").concat(r);if(n&&void 0!==n.mean){s+=" SUV: "+ar(n.mean.toFixed(2)),c+=" SUV: "+ar(n.stdDev.toFixed(2))}i.push(s),i.push(c)}if(a){var u=" mm".concat(String.fromCharCode(178)),d=ii(o),h=d.rowPixelSpacing,v=d.colPixelSpacing;h&&v||(u=" pixels".concat(String.fromCharCode(178)));var g="Area: ".concat(ar(a.toFixed(2))).concat(u);i.push(g)}return i}function m(e){return e}}},{key:"addNewMeasurement",value:function(e){var t=e.detail;this._startDrawing(e),this._addPoint(t),Br(e)}},{key:"preMouseDownCallback",value:function(e){var t=e.detail,n=this._pointNearHandleAllTools(t);return!!t.event.ctrlKey&&(void 0!==n&&n.handleNearby.hasBoundingBox||Ar.call(this,e,n),Br(e),!0)}},{key:"handleSelectedCallback",value:function(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"mouse",o=e.detail.element,i=O(o,this.name);if(n.hasBoundingBox)uo(e,this,t,n,a);else{var r=this.configuration;r.dragOrigin={x:n.x,y:n.y};for(var s=0;s<i.data.length;s++)for(var l=i.data[s].handles.points,c=0;c<l.length;c++)l[c]===n&&(r.currentHandle=c,r.currentTool=s);this._modifying=!0,this._activateModify(o),Br(e)}}},{key:"_drawingMouseMoveCallback",value:function(e){var t=e.detail,n=t.currentPoints,a=t.element,o=O(a,this.name),i=this.configuration,r=i.currentTool,s=o.data[r],l=n.canvas;this._getMouseLocation(t),this._checkInvalidHandleLocation(s,t);var c=this._pointNearHandle(a,s,l),u=s.handles.points;void 0!==c&&!c.hasBoundingBox&&c<u.length-1&&(i.mouseLocation.handles.start.x=u[c].x,i.mouseLocation.handles.start.y=u[c].y),y.cornerstone.updateImage(a)}},{key:"_drawingMouseDragCallback",value:function(e){this.options.mouseButtonMask.includes(e.detail.buttons)&&this._drawingDrag(e)}},{key:"_drawingTouchDragCallback",value:function(e){this._drawingDrag(e)}},{key:"_drawingDrag",value:function(e){var t=e.detail,n=t.element,a=O(n,this.name),o=this.configuration.currentTool,i=a.data[o];this._getMouseLocation(t),this._checkInvalidHandleLocation(i,t),this._addPointPencilMode(t,i.handles.points),this._dragging=!0,y.cornerstone.updateImage(n)}},{key:"_drawingMouseUpCallback",value:function(e){var t=e.detail.element;if(this._dragging){this._dragging=!1;var n=this.configuration,a=n.currentTool,o=O(t,this.name).data[a];if(!Ur.end(o.handles.points)&&o.canComplete){var i=n.currentHandle;this._endDrawing(t,i)}Br(e)}}},{key:"_drawingMouseDownCallback",value:function(e){var t=e.detail,n=t.buttons,a=t.currentPoints,o=t.element;if(this.options.mouseButtonMask.includes(n)){var i=a.canvas,r=this.configuration,s=r.currentTool,l=O(o,this.name).data[s],c=this._pointNearHandle(o,l,i);if(!Ur.end(l.handles.points)&&l.canComplete){var u=r.currentHandle;this._endDrawing(o,u)}else void 0===c&&this._addPoint(t);Br(e)}}},{key:"_drawingTouchStartCallback",value:function(e){var t=e.detail,n=t.currentPoints,a=t.element,o=n.canvas,i=this.configuration,r=i.currentTool,s=O(a,this.name).data[r],l=this._pointNearHandle(a,s,o);if(!Ur.end(s.handles.points)&&s.canComplete){var c=i.currentHandle;this._endDrawing(a,c)}else void 0===l&&this._addPoint(t);Br(e)}},{key:"completeDrawing",value:function(e){if(this._drawing){var t=O(e,this.name),n=this.configuration,a=t.data[n.currentTool];if(!Ur.end(a.handles.points)&&a.handles.points.length>=2){var o=n.currentHandle;a.polyBoundingBox={},this._endDrawing(e,o)}}}},{key:"_drawingMouseDoubleClickCallback",value:function(e){var t=e.detail.element;this.completeDrawing(t),Br(e)}},{key:"_drawingDoubleTapClickCallback",value:function(e){var t=e.detail.element;this.completeDrawing(t),Br(e)}},{key:"_editMouseDragCallback",value:function(e){var t=e.detail,n=t.element,a=t.buttons;if(this.options.mouseButtonMask.includes(a)){var o,i=O(n,this.name),r=this.configuration,s=i.data[r.currentTool],l=r.currentHandle,c=s.handles.points;if(this._getMouseLocation(t),s.handles.invalidHandlePlacement=Ur.modify(c,l),s.active=!0,s.highlight=!0,c[l].x=r.mouseLocation.handles.start.x,c[l].y=r.mouseLocation.handles.start.y,o=this._getPrevHandleIndex(l,c),l>=0){var u=c[o].lines.length-1,d=c[o].lines[u];d.x=r.mouseLocation.handles.start.x,d.y=r.mouseLocation.handles.start.y}y.cornerstone.updateImage(n)}}},{key:"_editTouchDragCallback",value:function(e){var t,n=e.detail,a=n.element,o=O(a,this.name),i=this.configuration,r=o.data[i.currentTool],s=i.currentHandle,l=r.handles.points;if(this._getMouseLocation(n),r.handles.invalidHandlePlacement=Ur.modify(l,s),r.active=!0,r.highlight=!0,l[s].x=i.mouseLocation.handles.start.x,l[s].y=i.mouseLocation.handles.start.y,t=this._getPrevHandleIndex(s,l),s>=0){var c=l[t].lines.length-1,u=l[t].lines[c];u.x=i.mouseLocation.handles.start.x,u.y=i.mouseLocation.handles.start.y}y.cornerstone.updateImage(a)}},{key:"_getPrevHandleIndex",value:function(e,t){return 0===e?t.length-1:e-1}},{key:"_editMouseUpCallback",value:function(e){var t=e.detail,n=t.element,a=O(n,this.name);this._deactivateModify(n),this._dropHandle(t,a),this._endDrawing(n),y.cornerstone.updateImage(n)}},{key:"_dropHandle",value:function(e,t){var n=this.configuration,a=n.currentTool,o=t.data[a].handles,i=o.points;if(o.invalidHandlePlacement){var r,s=n.currentHandle,l=i[s];if(0===s)r=i[i.length-1];else r=i[s-1];l.x=n.dragOrigin.x,l.y=n.dragOrigin.y,r.lines[0]=l,o.invalidHandlePlacement=!1}}},{key:"_startDrawing",value:function(e){var t,n=e.detail,a=this.createNewMeasurement(n),o=n.element,i=this.configuration;e.type===b.MOUSE_DOWN_ACTIVATE?t="Mouse":e.type===b.TOUCH_START_ACTIVE&&(t="Touch"),this._activateDraw(o,t),this._getMouseLocation(n),D(o,this.name,a);var r=O(o,this.name);i.currentTool=r.data.length-1,this._activeDrawingToolReference=r.data[i.currentTool]}},{key:"_addPoint",value:function(e){var t=e.currentPoints,n=e.element,a=O(n,this.name),o=this.configuration,i=a.data[o.currentTool];if(!i.handles.invalidHandlePlacement){var r=new Nr(t.image);i.handles.points.length&&i.handles.points[o.currentHandle-1].lines.push(t.image),i.handles.points.push(r),o.currentHandle+=1,y.cornerstone.updateImage(n),this.fireModifiedEvent(n,i)}}},{key:"_addPointPencilMode",value:function(e,t){var n=this,a=this.configuration,o=e.element,i=a.mouseLocation.handles.start;t.every((function(e){return n._isDistanceLargerThanSpacing(o,e,i)}))&&this._addPoint(e)}},{key:"_endDrawing",value:function(e,t){var n=O(e,this.name),a=this.configuration,o=n.data[a.currentTool];if(o.active=!1,o.highlight=!1,o.handles.invalidHandlePlacement=!1,void 0!==t){var i=o.handles.points;i[a.currentHandle-1].lines.push(i[0])}this._modifying&&(this._modifying=!1,o.invalidated=!0),a.currentHandle=0,a.currentTool=-1,o.canComplete=!1,this._drawing&&this._deactivateDraw(e),y.cornerstone.updateImage(e),this.fireModifiedEvent(e,o),this.fireCompletedEvent(e,o)}},{key:"_pointNearHandle",value:function(e,t,n){if(void 0!==t.handles&&void 0!==t.handles.points&&!1!==t.visible){for(var a=0;a<t.handles.points.length;a++){var o=y.cornerstone.pixelToCanvas(e,t.handles.points[a]);if(y.cornerstoneMath.point.distance(o,n)<6)return a}return t.handles.textBox&&fa(t.handles.textBox,n)?t.handles.textBox:void 0}}},{key:"_pointNearHandleAllTools",value:function(e){var t=e.currentPoints,n=e.element,a=t.canvas,o=O(n,this.name);if(o)for(var i,r=0;r<o.data.length;r++)if(void 0!==(i=this._pointNearHandle(n,o.data[r],a)))return{handleNearby:i,toolIndex:r}}},{key:"_getMouseLocation",value:function(e){var t=e.currentPoints,n=e.image,a=this.configuration;a.mouseLocation.handles.start.x=t.image.x,a.mouseLocation.handles.start.y=t.image.y,Mn(a.mouseLocation.handles.start,n)}},{key:"_checkInvalidHandleLocation",value:function(e,t){if(e.handles.points.length<2)return!0;var n;n=this._dragging?this._checkHandlesPencilMode(e,t):this._checkHandlesPolygonMode(e,t),e.handles.invalidHandlePlacement=n}},{key:"_checkHandlesPolygonMode",value:function(e,t){var n=this.configuration,a=t.element,o=n.mouseLocation.handles.start,i=e.handles.points,r=!1;return e.canComplete=!1,this._isDistanceSmallerThanCompleteSpacingCanvas(a,i[0],o)&&!Ur.end(i)&&i.length>2?(e.canComplete=!0,r=!1):r=Ur.newHandle(o,i),r}},{key:"_checkHandlesPencilMode",value:function(e,t){var n=this.configuration.mouseLocation.handles.start,a=e.handles.points,o=Ur.newHandle(n,a);return!1===o&&(o=this._invalidHandlePencilMode(e,t)),o}},{key:"_invalidHandlePencilMode",value:function(e,t){var n=this.configuration,a=t.element,o=n.mouseLocation.handles.start,i=e.handles.points;if(this._isDistanceSmallerThanCompleteSpacingCanvas(a,i[0],o))return e.canComplete=!0,!1;e.canComplete=!1;for(var r=1;r<i.length-1;r++)if(this._isDistanceSmallerThanSpacing(a,i[r],o))return!0;return!1}},{key:"_isDistanceSmallerThanCompleteSpacingCanvas",value:function(e,t,n){var a,o=y.cornerstone.pixelToCanvas(e,t),i=y.cornerstone.pixelToCanvas(e,n);return"Mouse"===this._drawingInteractionType?a=this.configuration.completeHandleRadius:"Touch"===this._drawingInteractionType&&(a=this.configuration.completeHandleRadiusTouch),this._compareDistanceToSpacing(e,o,i,"<",a)}},{key:"_isDistanceSmallerThanSpacing",value:function(e,t,n){return this._compareDistanceToSpacing(e,t,n,"<")}},{key:"_isDistanceLargerThanSpacing",value:function(e,t,n){return this._compareDistanceToSpacing(e,t,n,">")}},{key:"_compareDistanceToSpacing",value:function(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:">",o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:this.configuration.spacing;return">"===a?y.cornerstoneMath.point.distance(t,n)>o:y.cornerstoneMath.point.distance(t,n)<o}},{key:"_activateDraw",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"Mouse";this._drawing=!0,this._drawingInteractionType=t,pt.isMultiPartToolActive=!0,wt(this.element),e.addEventListener(b.MOUSE_DOWN,this._drawingMouseDownCallback),e.addEventListener(b.MOUSE_MOVE,this._drawingMouseMoveCallback),e.addEventListener(b.MOUSE_DOUBLE_CLICK,this._drawingMouseDoubleClickCallback),e.addEventListener(b.MOUSE_DRAG,this._drawingMouseDragCallback),e.addEventListener(b.MOUSE_UP,this._drawingMouseUpCallback),e.addEventListener(b.TOUCH_START,this._drawingMouseMoveCallback),e.addEventListener(b.TOUCH_START,this._drawingTouchStartCallback),e.addEventListener(b.TOUCH_DRAG,this._drawingTouchDragCallback),e.addEventListener(b.TOUCH_END,this._drawingMouseUpCallback),e.addEventListener(b.DOUBLE_TAP,this._drawingDoubleTapClickCallback),y.cornerstone.updateImage(e)}},{key:"_deactivateDraw",value:function(e){this._drawing=!1,pt.isMultiPartToolActive=!1,this._activeDrawingToolReference=null,this._drawingInteractionType=null,Et(this.element,this.svgCursor),e.removeEventListener(b.MOUSE_DOWN,this._drawingMouseDownCallback),e.removeEventListener(b.MOUSE_MOVE,this._drawingMouseMoveCallback),e.removeEventListener(b.MOUSE_DOUBLE_CLICK,this._drawingMouseDoubleClickCallback),e.removeEventListener(b.MOUSE_DRAG,this._drawingMouseDragCallback),e.removeEventListener(b.MOUSE_UP,this._drawingMouseUpCallback),e.removeEventListener(b.TOUCH_START,this._drawingTouchStartCallback),e.removeEventListener(b.TOUCH_DRAG,this._drawingTouchDragCallback),e.removeEventListener(b.TOUCH_START,this._drawingMouseMoveCallback),e.removeEventListener(b.TOUCH_END,this._drawingMouseUpCallback),y.cornerstone.updateImage(e)}},{key:"_activateModify",value:function(e){pt.isToolLocked=!0,e.addEventListener(b.MOUSE_UP,this._editMouseUpCallback),e.addEventListener(b.MOUSE_DRAG,this._editMouseDragCallback),e.addEventListener(b.MOUSE_CLICK,this._editMouseUpCallback),e.addEventListener(b.TOUCH_END,this._editMouseUpCallback),e.addEventListener(b.TOUCH_DRAG,this._editTouchDragCallback),y.cornerstone.updateImage(e)}},{key:"_deactivateModify",value:function(e){pt.isToolLocked=!1,e.removeEventListener(b.MOUSE_UP,this._editMouseUpCallback),e.removeEventListener(b.MOUSE_DRAG,this._editMouseDragCallback),e.removeEventListener(b.MOUSE_CLICK,this._editMouseUpCallback),e.removeEventListener(b.TOUCH_END,this._editMouseUpCallback),e.removeEventListener(b.TOUCH_DRAG,this._editTouchDragCallback),y.cornerstone.updateImage(e)}},{key:"passiveCallback",value:function(e){this._closeToolIfDrawing(e)}},{key:"enabledCallback",value:function(e){this._closeToolIfDrawing(e)}},{key:"disabledCallback",value:function(e){this._closeToolIfDrawing(e)}},{key:"_closeToolIfDrawing",value:function(e){if(this._drawing){var t=this.configuration.currentHandle;this._endDrawing(e,t),y.cornerstone.updateImage(e)}}},{key:"fireModifiedEvent",value:function(e,t){C(e,b.MEASUREMENT_MODIFIED,{toolName:this.name,toolType:this.name,element:e,measurementData:t})}},{key:"fireCompletedEvent",value:function(e,t){C(e,b.MEASUREMENT_COMPLETED,{toolName:this.name,toolType:this.name,element:e,measurementData:t})}},{key:"cancelDrawing",value:function(e){if(this._drawing){var t=O(e,this.name),n=this.configuration,a=t.data[n.currentTool];a.active=!1,a.highlight=!1,a.handles.invalidHandlePlacement=!1,n.currentHandle=0,n.currentTool=-1,a.canComplete=!1,L(e,this.name,a),this._deactivateDraw(e),y.cornerstone.updateImage(e)}}},{key:"newImageCallback",value:function(e){var t=this.configuration;if(this._drawing&&this._activeDrawingToolReference){var n=e.detail.element,a=this._activeDrawingToolReference;a.active=!1,a.highlight=!1,a.handles.invalidHandlePlacement=!1;var o=a.handles.points;o[t.currentHandle-1].lines.push(o[0]),t.currentHandle=0,t.currentTool=-1,a.canComplete=!1,this._deactivateDraw(n),y.cornerstone.updateImage(n)}}},{key:"spacing",get:function(){return this.configuration.spacing},set:function(e){if("number"!=typeof e)throw new Error("Attempting to set freehand spacing to a value other than a number.");this.configuration.spacing=e,y.cornerstone.updateImage(this.element)}},{key:"activeHandleRadius",get:function(){return this.configuration.activeHandleRadius},set:function(e){if("number"!=typeof e)throw new Error("Attempting to set freehand activeHandleRadius to a value other than a number.");this.configuration.activeHandleRadius=e,y.cornerstone.updateImage(this.element)}},{key:"completeHandleRadius",get:function(){return this.configuration.completeHandleRadius},set:function(e){if("number"!=typeof e)throw new Error("Attempting to set freehand completeHandleRadius to a value other than a number.");this.configuration.completeHandleRadius=e,y.cornerstone.updateImage(this.element)}},{key:"alwaysShowHandles",get:function(){return this.configuration.alwaysShowHandles},set:function(e){if("boolean"!=typeof e)throw new Error("Attempting to set freehand alwaysShowHandles to a value other than a boolean.");this.configuration.alwaysShowHandles=e,y.cornerstone.updateImage(this.element)}},{key:"invalidColor",get:function(){return this.configuration.invalidColor},set:function(e){this.configuration.invalidColor=e,y.cornerstone.updateImage(this.element)}}]),t}(fo);function Br(e){e.stopImmediatePropagation(),e.stopPropagation(),e.preventDefault()}var Vr=N("tools:annotation:LengthTool"),qr=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"Length",supportedInteractionTypes:["Mouse","Touch"],svgCursor:ko,configuration:{drawHandles:!0,drawHandlesOnHover:!1,hideHandlesIfMoving:!1,renderDashed:!1,digits:2}};return(e=u()(this,h()(t).call(this,n,a))).throttledUpdateCachedStats=li(e.updateCachedStats,110),e}return g()(t,e),l()(t,[{key:"createNewMeasurement",value:function(e){if(e&&e.currentPoints&&e.currentPoints.image){var t=e.currentPoints.image,n=t.x,a=t.y;return{visible:!0,active:!0,color:void 0,invalidated:!0,handles:{start:{x:n,y:a,highlight:!0,active:!1},end:{x:n,y:a,highlight:!0,active:!0},textBox:{active:!1,hasMoved:!1,movesIndependently:!1,drawnIndependently:!0,allowedOutsideImage:!0,hasBoundingBox:!0}}}}Vr.error("required eventData not supplied to tool ".concat(this.name,"'s createNewMeasurement"))}},{key:"pointNearTool",value:function(e,t,n){return t&&t.handles&&t.handles.start&&t.handles.end?!1!==t.visible&&mo(e,t.handles.start,t.handles.end,n)<25:(Vr.warn("invalid parameters supplied to tool ".concat(this.name,"'s pointNearTool")),!1)}},{key:"updateCachedStats",value:function(e,t,n){var a=ii(e),o=a.rowPixelSpacing,i=a.colPixelSpacing,r=(n.handles.end.x-n.handles.start.x)*(i||1),s=(n.handles.end.y-n.handles.start.y)*(o||1),l=Math.sqrt(r*r+s*s);n.length=l,n.invalidated=!1}},{key:"renderToolData",value:function(e){var t=this,n=e.detail,a=this.configuration,o=a.handleRadius,i=a.drawHandlesOnHover,r=a.hideHandlesIfMoving,s=a.renderDashed,l=a.digits,c=O(e.currentTarget,this.name);if(c)for(var u=_n(n.canvasContext.canvas),d=n.image,h=n.element,v=ii(d),g=v.rowPixelSpacing,f=v.colPixelSpacing,m=Xt.getToolWidth(),p=Tt("globalConfiguration").configuration.lineDash,y=function(e){var a=c.data[e];if(!1===a.visible)return"continue";Wt(u,(function(e){Dn(e,t.configuration);var c=un.getColorIfActive(a),u={color:c};s&&(u.lineDash=p),Zt(e,h,a.handles.start,a.handles.end,u);var v={color:c,handleRadius:o,drawHandlesIfActive:i,hideHandlesIfMoving:r};if(t.configuration.drawHandles&&dn(e,n,a.handles,v),!a.handles.textBox.hasMoved){var y={x:Math.max(a.handles.start.x,a.handles.end.x)};y.x===a.handles.start.x?y.y=a.handles.start.y:y.y=a.handles.end.y,a.handles.textBox.x=y.x,a.handles.textBox.y=y.y}!0===a.invalidated&&(a.length?t.throttledUpdateCachedStats(d,h,a):t.updateCachedStats(d,h,a));var x=function(e,t,n){var a=(o=e.length,i=Number(o),isNaN(i)?void 0:i);var o,i;if(!a)return"";var r="mm";t&&n||(r="pixels");return e.unit=r,"".concat(a.toFixed(l)," ").concat(r)}(a,g,f);Sn(e,h,a.handles.textBox,x,a.handles,T,c,m,10,!0)}))},x=0;x<c.data.length;x++)y(x);function T(e){var t={x:(e.start.x+e.end.x)/2,y:(e.start.y+e.end.y)/2};return[e.start,t,e.end]}}}]),t}(fo);var jr=function(e,t,n,a,o){if(!e)throw new Error("getRGBPixels: parameter element must not be undefined");t=Math.round(t),n=Math.round(n);var i,r,s,l=y.cornerstone.getEnabledElement(e),c=[],u=0,d=l.image.getPixelData();if(l.image.color)for(r=0;r<o;r++)for(s=0;s<a;s++){var h=d[i=4*((r+n)*l.image.columns+(s+t))],v=d[i+1],g=d[i+2],f=d[i+3];c[u++]=h,c[u++]=v,c[u++]=g,c[u++]=f}return c},zr=N("tools:annotation:ProbeTool"),Wr=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"Probe",supportedInteractionTypes:["Mouse","Touch"],svgCursor:_o,configuration:{drawHandles:!0,renderDashed:!1}};return(e=u()(this,h()(t).call(this,n,a))).throttledUpdateCachedStats=li(e.updateCachedStats,110),e}return g()(t,e),l()(t,[{key:"createNewMeasurement",value:function(e){if(e&&e.currentPoints&&e.currentPoints.image)return{visible:!0,active:!0,color:void 0,invalidated:!0,handles:{end:{x:e.currentPoints.image.x,y:e.currentPoints.image.y,highlight:!0,active:!0}}};zr.error("required eventData not supplied to tool ".concat(this.name,"'s createNewMeasurement"))}},{key:"pointNearTool",value:function(e,t,n){var a=t&&t.handles&&t.handles.end;if(a||zr.warn("invalid parameters supplied to tool ".concat(this.name,"'s pointNearTool")),!a||!1===t.visible)return!1;var o=y.cornerstone.pixelToCanvas(e,t.handles.end);return y.cornerstoneMath.point.distance(o,n)<5}},{key:"updateCachedStats",value:function(e,t,n){var a=Math.round(n.handles.end.x),o=Math.round(n.handles.end.y),i={};a>=0&&o>=0&&a<e.columns&&o<e.rows&&(i.x=a,i.y=o,e.color?i.storedPixels=jr(t,a,o,1,1):(i.storedPixels=y.cornerstone.getStoredPixels(t,a,o,1,1),i.sp=i.storedPixels[0],i.mo=i.sp*e.slope+e.intercept,i.suv=$i(e,i.sp))),n.cachedStats=i,n.invalidated=!1}},{key:"renderToolData",value:function(e){var t=this,n=e.detail,a=this.configuration,o=a.handleRadius,i=a.renderDashed,r=O(e.currentTarget,this.name);if(r)for(var s=_n(n.canvasContext.canvas),l=n.image,c=n.element,u=pn.getFontSize(),d=Tt("globalConfiguration").configuration.lineDash,h=function(e){var a=r.data[e];if(!1===a.visible)return"continue";Wt(s,(function(e){var r,s,h=un.getColorIfActive(a);if(t.configuration.drawHandles){var v={handleRadius:o,color:h};i&&(v.lineDash=d),dn(e,n,a.handles,v)}!0===a.invalidated&&(a.cachedStats?t.throttledUpdateCachedStats(l,c,a):t.updateCachedStats(l,c,a));var g=a.cachedStats,f=g.x,m=g.y,p=g.storedPixels,x=g.sp,T=g.mo,b=g.suv;if(f>=0&&m>=0&&f<l.columns&&m<l.rows){r="".concat(f,", ").concat(m),l.color?s="R: ".concat(p[0]," G: ").concat(p[1]," B: ").concat(p[2]):(s="SP: ".concat(x," MO: ").concat(parseFloat(T.toFixed(3))),b&&(s+=" SUV: ".concat(parseFloat(b.toFixed(3)))));var C={x:a.handles.end.x+3,y:a.handles.end.y-3},M=y.cornerstone.pixelToCanvas(n.element,C);bn(e,s,M.x,M.y+u+5,h),bn(e,r,M.x,M.y,h)}}))},v=0;v<r.data.length;v++)h(v)}}]),t}(fo),Gr=N("tools:annotation:RectangleRoiTool"),Yr=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"RectangleRoi",supportedInteractionTypes:["Mouse","Touch"],configuration:{drawHandles:!0,drawHandlesOnHover:!1,hideHandlesIfMoving:!1,renderDashed:!1},svgCursor:Po};return(e=u()(this,h()(t).call(this,n,a))).throttledUpdateCachedStats=li(e.updateCachedStats,110),e}return g()(t,e),l()(t,[{key:"createNewMeasurement",value:function(e){if(e&&e.currentPoints&&e.currentPoints.image)return{visible:!0,active:!0,color:void 0,invalidated:!0,handles:{start:{x:e.currentPoints.image.x,y:e.currentPoints.image.y,highlight:!0,active:!1},end:{x:e.currentPoints.image.x,y:e.currentPoints.image.y,highlight:!0,active:!0},initialRotation:e.viewport.rotation,textBox:{active:!1,hasMoved:!1,movesIndependently:!1,drawnIndependently:!0,allowedOutsideImage:!0,hasBoundingBox:!0}}};Gr.error("required eventData not supplied to tool ".concat(this.name,"'s createNewMeasurement"))}},{key:"pointNearTool",value:function(e,t,n,a){var o=t&&t.handles&&t.handles.start&&t.handles.end;if(o||Gr.warn("invalid parameters supplied to tool ".concat(this.name,"'s pointNearTool")),!o||!1===t.visible)return!1;var i="mouse"===a?15:25,r=y.cornerstone.pixelToCanvas(e,t.handles.start),s=y.cornerstone.pixelToCanvas(e,t.handles.end),l={left:Math.min(r.x,s.x),top:Math.min(r.y,s.y),width:Math.abs(r.x-s.x),height:Math.abs(r.y-s.y)};return y.cornerstoneMath.rect.distanceToPoint(l,n)<i}},{key:"updateCachedStats",value:function(e,t,n){var a=(y.cornerstone.metaData.get("generalSeriesModule",e.imageId)||{}).modality,o=ii(e),i=function(e,t,n,a,o){var i,r=Xr(n.start,n.end),s=function(e,t){for(var n=0,a=0,o=0,i=0,r=e?e[0]:null,s=e?e[0]:null,l=t.top;l<t.top+t.height;l++)for(var c=t.left;c<t.left+t.width;c++)n+=e[i],a+=e[i]*e[i],r=Math.min(r,e[i]),s=Math.max(s,e[i]),o++,i++;if(0===o)return{count:o,mean:0,variance:0,stdDev:0,min:0,max:0};var u=n/o,d=a/o-u*u;return{count:o,mean:u,variance:d,stdDev:Math.sqrt(d),min:r,max:s}}(y.cornerstone.getPixels(t,r.left,r.top,r.width,r.height),r);"PT"===a&&(i={mean:$i(e,s.mean,!0)||0,stdDev:$i(e,s.stdDev,!0)||0});var l=r.width*(o.colPixelSpacing||1)*(r.height*(o.rowPixelSpacing||1)),c=2*r.width*(o.colPixelSpacing||1)+2*r.height*(o.rowPixelSpacing||1);return{area:l||0,perimeter:c,count:s.count||0,mean:s.mean||0,variance:s.variance||0,stdDev:s.stdDev||0,min:s.min||0,max:s.max||0,meanStdDevSUV:i}}(e,t,n.handles,a,o);n.cachedStats=i,n.invalidated=!1}},{key:"renderToolData",value:function(e){var t=this,n=O(e.currentTarget,this.name);if(n){var a=e.detail,o=a.image,i=a.element,r=Xt.getToolWidth(),s=Tt("globalConfiguration").configuration.lineDash,l=this.configuration,c=l.handleRadius,u=l.drawHandlesOnHover,d=l.hideHandlesIfMoving,h=l.renderDashed,v=_n(a.canvasContext.canvas),g=ii(o),f=g.rowPixelSpacing,m=g.colPixelSpacing,p=(y.cornerstone.metaData.get("generalSeriesModule",o.imageId)||{}).modality,x=f&&m;Wt(v,(function(e){for(var l=0;l<n.data.length;l++){var v=n.data[l];if(!1!==v.visible){var g=un.getColorIfActive(v),f={color:g,handleRadius:c,drawHandlesIfActive:u,hideHandlesIfMoving:d};Dn(e,t.configuration);var m={color:g};if(h&&(m.lineDash=s),kn(e,i,v.handles.start,v.handles.end,m,"pixel",v.handles.initialRotation),t.configuration.drawHandles&&dn(e,a,v.handles,f),!0===v.invalidated&&(v.cachedStats?t.throttledUpdateCachedStats(o,i,v):t.updateCachedStats(o,i,v)),!v.handles.textBox.hasMoved){var y=nr(a.viewport,v.handles);Object.assign(v.handles.textBox,y)}var T=$r(e,o.color,v.cachedStats,p,x,t.configuration);v.unit=Zr(p,t.configuration.showHounsfieldUnits),Sn(e,i,v.handles.textBox,T,v.handles,(function(e){return t=e.start,n=e.end,a=Xr(t,n),o=a.left,i=a.top,r=a.width,s=a.height,[{x:o+r/2,y:i},{x:o,y:i+s/2},{x:o+r/2,y:i+s},{x:o+r,y:i+s/2}];var t,n,a,o,i,r,s}),g,r,10,!0)}}}))}}}]),t}(fo);function Xr(e,t){return{left:Math.min(e.x,t.x),top:Math.min(e.y,t.y),width:Math.abs(e.x-t.x),height:Math.abs(e.y-t.y)}}function Kr(e,t){var n=t?" mm".concat(String.fromCharCode(178)):" px".concat(String.fromCharCode(178));return"Area: ".concat(ar(e.toFixed(2))).concat(n)}function Zr(e,t){return"CT"===e&&!1!==t?"HU":""}function $r(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},a=n.area,o=void 0===a?0:a,i=n.mean,r=void 0===i?0:i,s=n.stdDev,l=void 0===s?0:s,c=n.min,u=void 0===c?0:c,d=n.max,h=void 0===d?0:d,v=n.meanStdDevSUV,g=void 0===v?0:v,f=arguments.length>3?arguments[3]:void 0,m=arguments.length>4?arguments[4]:void 0,p=arguments.length>5&&void 0!==arguments[5]?arguments[5]:{},y=p.showMinMax||!1,x=[],T=[];if(!t){var b=g&&0!==g.mean,C=Zr(f,p.showHounsfieldUnits),M="Mean: ".concat(ar(r.toFixed(2))," ").concat(C),E="Std Dev: ".concat(ar(l.toFixed(2))," ").concat(C);if(b){for(var w=" SUV: ",I="".concat(w).concat(ar(g.mean.toFixed(2))),S="".concat(w).concat(ar(g.stdDev.toFixed(2))),k=Math.floor(e.measureText("".concat(E,"     ")).width);e.measureText(M).width<k;)M+=" ";T.push("".concat(M).concat(I)),T.push("".concat(E,"     ").concat(S))}else T.push("".concat(M)),T.push("".concat(E));if(y){for(var _="Min: ".concat(u," ").concat(C),P="Max: ".concat(h," ").concat(C),D=b?Math.floor(e.measureText("".concat(E,"     ")).width):Math.floor(e.measureText("".concat(M,"     ")).width);e.measureText(_).width<D;)_+=" ";T.push("".concat(_).concat(P))}}return x.push(Kr(o,m)),T.forEach((function(e){return x.push(e)})),x}var Jr=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"TextMarker",supportedInteractionTypes:["Mouse","Touch"],configuration:{markers:[],current:"",ascending:!0,loop:!1,changeTextCallback:Qr},svgCursor:Do};return(e=u()(this,h()(t).call(this,n,a))).touchPressCallback=e._changeText.bind(wa()(e)),e.doubleClickCallback=e._changeText.bind(wa()(e)),e}return g()(t,e),l()(t,[{key:"createNewMeasurement",value:function(e){var t=this.configuration;if(t.current){var n={visible:!0,active:!0,text:t.current,color:void 0,handles:{end:{x:e.currentPoints.image.x,y:e.currentPoints.image.y,highlight:!0,active:!0,hasBoundingBox:!0}}},a={left:0,top:0,width:e.image.width,height:e.image.height};if(y.cornerstoneMath.point.insideRect(n.handles.end,a)){var o=t.markers.indexOf(t.current);return(o+=t.ascending?1:-1)>=t.markers.length?o=t.loop?0:-1:o<0&&(o=t.loop?t.markers.length:-1),t.current=t.markers[o],n}}}},{key:"pointNearTool",value:function(e,t,n){if(!1===t.visible)return!1;if(t.handles.end.boundingBox){var a=y.cornerstoneMath.rect.distanceToPoint(t.handles.end.boundingBox,n),o=fa(t.handles.end,n);return a<10||o}}},{key:"updateCachedStats",value:function(){}},{key:"renderToolData",value:function(e){var t=e.detail,n=this.configuration,a=O(t.element,this.name);if(a)for(var o=_n(t.canvasContext.canvas),i=function(e){var i=a.data[e];if(!1===i.visible)return"continue";var r=un.getColorIfActive(i);Wt(o,(function(e){Dn(e,n);var a=y.cornerstone.pixelToCanvas(t.element,i.handles.end);i.handles.end.boundingBox=bn(e,i.text,a.x,a.y-10,r,{centering:{x:!0,y:!0}})}))},r=0;r<a.data.length;r++)i(r)}},{key:"_changeText",value:function(e){var t,n=e.detail,a=n.element,o=n.currentPoints;function i(e,t,n){!0===n?L(a,this.name,e):e.text=t,e.active=!1,y.cornerstone.updateImage(a)}var r=this.configuration,s=o.canvas,l=O(a,this.name);if(l)for(var c=0;c<l.data.length;c++)if(t=l.data[c],this.pointNearTool(a,t,s))return t.active=!0,y.cornerstone.updateImage(a),r.changeTextCallback(t,n,i),e.stopImmediatePropagation(),e.preventDefault(),void e.stopPropagation()}}]),t}(fo),Qr=function(e,t,n){n(e,prompt("Change your annotation:"))},es=(N("tools:BrushTool"),Tt("segmentation")),ts=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"Brush",supportedInteractionTypes:["Mouse","Touch"],configuration:{},mixins:["renderBrushMixin"]};return(e=u()(this,h()(t).call(this,n,a))).touchDragCallback=e._paint.bind(wa()(e)),e}return g()(t,e),l()(t,[{key:"_paint",value:function(e){var t=es.configuration,n=e.detail,a=(n.element,n.image),o=a.rows,i=a.columns,r=n.currentPoints.image,s=r.x,l=r.y;if(!(s<0||s>i||l<0||l>o)){var c=be(t.radius,o,i,s,l),u=this.paintEventData,d=u.labelmap2D,h=u.labelmap3D,v=u.shouldErase;te(c,d.pixelData,h.activeSegmentIndex,i,v),y.cornerstone.updateImage(e.detail.element)}}}]),t}(ka),ns=N("tools:SphericalBrushTool"),as=Tt("segmentation"),os=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"SphericalBrush",supportedInteractionTypes:["Mouse","Touch"],configuration:{alwaysEraseOnClick:!1},mixins:["renderBrushMixin"]};return(e=u()(this,h()(t).call(this,n,a))).touchDragCallback=e._paint.bind(wa()(e)),e}return g()(t,e),l()(t,[{key:"_startPainting",value:function(e){var t,n=as.configuration,a=as.getters,o=e.detail,i=o.element,r=o.image,s=y.cornerstone,l=n.radius,c=r.rows,u=r.columns,d=Math.max(r.rowPixelSpacing,r.columnPixelSpacing),h=O(i,"stack").data[0].imageIds,v=a.labelmap2D(i),g=v.labelmap2D,f=v.labelmap3D,m=v.currentImageIdIndex,p=v.activeLabelmapIndex,x=this._isCtrlDown(o)||this.configuration.alwaysEraseOnClick,T=s.metaData.get("imagePlaneModule",r.imageId);if(T){var b=T.imagePositionPatient;t=this._getImagesInRange(m,b,h,l,d)}else ns.warn("No imagePlane metadata found for image, defaulting to circle brush application."),t=[{imageIdIndex:m,radiusOnImage:l}];if(this.paintEventData={labelmap2D:g,labelmap3D:f,currentImageIdIndex:m,activeLabelmapIndex:p,shouldErase:x,imagesInRange:t},n.storeHistory){for(var C=[],M=0;M<t.length;M++){var E=t[M].imageIdIndex,w=a.labelmap2DByImageIdIndex(f,E,c,u).pixelData.slice();C.push(w)}this.paintEventData.previousPixeldataForImagesInRange=C}}},{key:"_paint",value:function(e){var t=as.getters,n=e.detail,a=(n.element,n.image),o=a.rows,i=a.columns,r=n.currentPoints.image,s=r.x,l=r.y;if(!(s<0||s>i||l<0||l>o)){for(var c=this.paintEventData,u=c.labelmap3D,d=c.imagesInRange,h=c.shouldErase,v=0;v<d.length;v++){var g=d[v],f=g.imageIdIndex;te(be(g.radiusOnImage,o,i,s,l),t.labelmap2DByImageIdIndex(u,f,o,i).pixelData,u.activeSegmentIndex,i,h)}y.cornerstone.updateImage(e.detail.element)}}},{key:"_getImagesInRange",value:function(e,t,n,a,o){for(var i=a*o,r=[{imageIdIndex:e,radiusOnImage:a}],s=e+1;s<n.length;s++){var l=this._getRadiusOnImage(n[s],t,i,o);if(!l)break;r.push({imageIdIndex:s,radiusOnImage:l})}for(var c=e-1;c>=0;c--){var u=this._getRadiusOnImage(n[c],t,i,o);if(!u)break;r.push({imageIdIndex:c,radiusOnImage:u})}return r}},{key:"_getRadiusOnImage",value:function(e,t,n,a){var o=y.cornerstone.metaData.get("imagePlaneModule",e);if(o){var i=o.imagePositionPatient,r=Math.sqrt(Math.pow(i[0]-t[0],2)+Math.pow(i[1]-t[1],2)+Math.pow(i[2]-t[2],2));if(!(r>n))return Math.floor(Math.sqrt(Math.pow(n,2)-Math.pow(r,2))/a)}else ns.warn("Can't find imagePlane metadata for image, cancelling spherical brushing on: ".concat(e,","))}},{key:"_endPainting",value:function(e){for(var t=this.paintEventData,n=t.labelmap3D,a=t.imagesInRange,o=[],i=as.configuration,r=as.setters,s=0;s<a.length;s++){for(var l=a[s].imageIdIndex,c=n.labelmaps2D[l],u=new Set(c.pixelData).values(),d=[],h=!1;!h;){var v=u.next();(h=v.done)||d.push(v.value)}if(c.segmentsOnLabelmap=d,i.storeHistory){var g=this.paintEventData.previousPixeldataForImagesInRange[s],f=n.labelmaps2D[l].pixelData;o.push({imageIdIndex:l,diff:Le(g,f)})}}i.storeHistory&&r.pushState(this.element,o),Oe(this.element)}}]),t}(ka),is=N("util:segmentation:operations:correction");function rs(e,t){var n=t.pixelData,a=t.segmentIndex,o=t.segmentationMixinType;if("freehandSegmentationMixin"===o){var i=function(e,t){for(var n=t.pixelData,a=t.points,o=e.detail.image,i=o.width,r=o.height,s=[],l=0;l<a.length;l++){var c=a[l],u=Math.floor(c.x),d=Math.floor(c.y);u=In(u,0,i-1),d=In(d,0,r-1);var h=s[s.length-1];h&&u===h.x&&d===h.y||s.push({x:u,y:d,segment:n[d*i+u]})}return s}(e,t),r=function(e,t){for(var n=!0,a=!0,o=0;o<e.length;o++){if(e[o].segment===t?a=!1:n=!1,!n&&!a)break}if(a)return{isScissorOperation:!0,operation:"fillInsideFreehand"};if(n)return{isScissorOperation:!0,operation:"eraseInsideFreehand"};return{isScissorOperation:!1}}(i,a);if(r.isScissorOperation)"fillInsideFreehand"===r.operation?(is.warn("The line never intersects a segment."),bs(e,t)):"eraseInsideFreehand"===r.operation&&(is.warn("The line is only ever inside the segment."),vs(e,t));else{var s=new Uint8Array(n.length);(function(e,t){var n=e[0].segment===t,a=[];a.push({additive:!n,nodes:[]});for(var o=0,i=0;i<e.length;i++){var r=e[i];n?(a[o].nodes.push(r),r.segment!==t&&(o++,n=!n,a.push({additive:!0,nodes:[]}),a[o].nodes.push(e[i-1]),a[o].nodes.push(r))):(a[o].nodes.push(r),r.segment===t&&(o++,n=!n,a.push({additive:!1,nodes:[]}),a[o].nodes.push(e[i-1]),a[o].nodes.push(r)))}return a.pop(),a.shift(),a})(i,a).forEach((function(t){!function(e,t,n,a,o){var i=o.detail.image,r=i.width,s=i.height,l=e.nodes,c=e.additive,u=c?0:1,d=function(e){return e.y*r+e.x},h=function(e){return{x:e%r,y:Math.floor(e/r)}};c?is.warn("additive operation..."):is.warn("subtractive operation...");for(var v=function(e){for(var t=[],n=0;n<e.length-1;n++)t.push(e[n]),t.push.apply(t,J()(Ee(e[n],e[n+1])));t.push[e[e.length-1]];for(var a=[],o=[],i=0;i<t.length-1;i++){var r=cs(t[i],t[i+1]),s=r.left,l=r.right;a.push(s),o.push(l)}return{pixelPath:t,leftPath:a,rightPath:o}}(l),g=v.pixelPath,f=v.leftPath,m=v.rightPath,p=g[0],y={xMin:p.x,xMax:p.x,yMin:p.y,yMax:p.y},x=0;x<n.length;x++)if(t[x]===a){var T=h(x);ss(y,T),n[x]=1}else n[x]=0;for(var b=0;b<g.length;b++){var C=g[b];n[d(C)]=2,ss(y,C)}!function(e,t,n){e.xMax=Math.min(e.xMax+2,n),e.xMin=Math.max(e.xMin-2,0),e.yMax=Math.min(e.yMax+2,t),e.yMin=Math.max(e.yMin-2,0)}(y,s,r);var M=y.xMin,E=y.xMax,w=y.yMin,I=y.yMax;function S(e,t){if(!(e>=E||e<M||t>=I||t<w))return n[t*r+e]}for(var k=0,_=0,P=0;P<f.length;P++){var D=f[P];n[d(D)]===u&&Ge(D,s,r)&&(k+=ls(D,3,n,S,r));var O=m[P];n[d(O)]===u&&Ge(O,s,r)&&(_+=ls(O,4,n,S,r))}if(0===k||0===_)return;for(var L=c?a:0,A=k<_?3:4,H=0;H<n.length;H++)n[H]===A&&(t[H]=L);if(L===a)for(var R=0;R<g.length;R++)t[d(g[R])]=a;else for(var U=0;U<g.length;U++){var N=d(g[U]);t[N]===a&&(t[N]=0)}}(t,n,s,a,e)}))}}else is.error("correction operation requires freehandSegmentationMixin operationData, recieved ".concat(o))}function ss(e,t){var n=t.x,a=t.y;n<e.xMin&&(e.xMin=n),n>e.xMax&&(e.xMax=n),a<e.yMin&&(e.yMin=a),a>e.yMax&&(e.yMax=a)}function ls(e,t,n,a,o){for(var i=ge(a,[e.x,e.y]).flooded,r=0;r<i.length;r++){var s=i[r];n[s[1]*o+s[0]]=t}return i.length}function cs(e,t){var n={x:t.x-e.x,y:t.y-e.y};return-1===n.x&&1===n.y?{left:{x:e.x-1,y:e.y-1},right:{x:e.x+1,y:e.y+1}}:0===n.x&&1===n.y?{left:{x:e.x-1,y:e.y},right:{x:e.x+1,y:e.y}}:1===n.x&&1===n.y?{left:{x:e.x-1,y:e.y+1},right:{x:e.x+1,y:e.y-1}}:1===n.x&&0===n.y?{left:{x:e.x,y:e.y+1},right:{x:e.x,y:e.y-1}}:1===n.x&&-1===n.y?{left:{x:e.x+1,y:e.y+1},right:{x:e.x-1,y:e.y-1}}:0===n.x&&-1===n.y?{left:{x:e.x+1,y:e.y},right:{x:e.x-1,y:e.y}}:-1===n.x&&-1===n.y?{left:{x:e.x+1,y:e.y-1},right:{x:e.x-1,y:e.y+1}}:-1===n.x&&0===n.y?{left:{x:e.x,y:e.y-1},right:{x:e.x,y:e.y+1}}:void is.error("Unable to find left and right paths for flood fill ",e,t,n)}function us(e,t){for(var n=e[0],a=e[1],o=!1,i=0,r=t.length-1;i<t.length;r=i++){var s=t[i][0],l=t[i][1],c=t[r][0],u=t[r][1];l>a!=u>a&&n<(c-s)*(a-l)/(u-l)+s&&(o=!o)}return o}var ds=N("util:segmentation:operations:eraseInsideFreehand");function hs(e,t){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=t.points,o=t.segmentationMixinType;if("freehandSegmentationMixin"===o){var i=e.detail.image,r=a.map((function(e){return[e.x,e.y]})),s=Te(r,i),l=oe()(s,2),c=l[0],u=l[1];n?se(e,t,(function(e){return us([e.x,e.y],r)}),c,u):le(e,t,(function(e){return us([e.x,e.y],r)}),c,u)}else ds.error("eraseInsideFreehand operation requires freehandSegmentationMixin operationData, recieved ".concat(o))}function vs(e,t){hs(e,t,!0)}function gs(e,t){hs(e,t,!1)}var fs=N("util:segmentation:operations:eraseInsideRectangle");function ms(e,t){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=t.points,o=t.segmentationMixinType;if("rectangleSegmentationMixin"===o){var i=e.detail,r=i.image,s=a.map((function(e){return[e.x,e.y]})),l=Te(s,r),c=oe()(l,2),u=c[0],d=c[1];n?se(e,t,(function(){return!0}),u,d):ne(e,t,u,d)}else fs.error("eraseInsideRectangle operation requires rectangleSegmentationMixin operationData, recieved ".concat(o))}function ps(e,t){ms(e,t,!0)}function ys(e,t){ms(e,t,!1)}var xs=N("util:segmentation:operations:fillInsideFreehand");function Ts(e,t){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=t.points,o=t.segmentationMixinType;if("freehandSegmentationMixin"===o){var i=e.detail.image,r=a.map((function(e){return[e.x,e.y]})),s=Te(r,i),l=oe()(s,2),c=l[0],u=l[1];n?he(e,t,(function(e){return us([e.x,e.y],r)}),c,u):ve(e,t,(function(e){return us([e.x,e.y],r)}),c,u)}else xs.error("eraseInsideFreehand operation requires freehandSegmentationMixin operationData, recieved ".concat(o))}function bs(e,t){Ts(e,t,!0)}function Cs(e,t){Ts(e,t,!1)}var Ms=N("util:segmentation:operations:fillInsideRectangle");function Es(e,t){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=t.points,o=t.segmentationMixinType;if("rectangleSegmentationMixin"===o){var i=e.detail.image,r=a.map((function(e){return[e.x,e.y]})),s=Te(r,i),l=oe()(s,2),c=l[0],u=l[1];n?he(e,t,(function(){return!0}),c,u):ce(e,t,c,u)}else Ms.error("eraseInsideRectangle operation requires rectangleSegmentationMixin operationData, recieved ".concat(o))}function ws(e,t){Es(e,t,!0)}function Is(e,t){Es(e,t,!1)}var Ss=N("util:segmentation:operations:fillCircle");function ks(e,t){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=t.segmentationMixinType;if("circleSegmentationMixin"===a){var o=e.detail,i=xe(e),r=oe()(i,2),s=r[0],l=r[1],c=ye(o.handles.start,o.handles.end);n?he(e,t,(function(e){return Qi(c,e)}),s,l):ve(e,t,(function(e){return Qi(c,e)}),s,l)}else Ss.error("fillInsideCircle operation requires circleSegmentationMixin operationData, recieved ".concat(a))}function _s(e,t){ks(e,t,!0)}function Ps(e,t){ks(e,t,!1)}var Ds=N("util:segmentation:operations:eraseInsideCircle");function Os(e,t){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=t.segmentationMixinType;if("circleSegmentationMixin"===a){var o=e.detail,i=xe(e),r=oe()(i,2),s=r[0],l=r[1],c=ye(o.handles.start,o.handles.end);n?se(e,t,(function(e){return Qi(c,e)}),s,l):le(e,t,(function(e){return Qi(c,e)}),s,l)}else Ds.error("eraseInsideCircle operation requires circleSegmentationMixin operationData, recieved ".concat(a))}function Ls(e,t){Os(e,t,!0)}function As(e,t){Os(e,t,!1)}var Hs=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var n={name:"FreehandScissors",strategies:{FILL_INSIDE:bs,FILL_OUTSIDE:Cs,ERASE_OUTSIDE:gs,ERASE_INSIDE:vs},cursors:{FILL_INSIDE:Xo,FILL_OUTSIDE:Zo,ERASE_OUTSIDE:Ko,ERASE_INSIDE:Yo},defaultStrategy:"FILL_INSIDE",supportedInteractionTypes:["Mouse","Touch"],svgCursor:Xo,mixins:["freehandSegmentationMixin"]};return u()(this,h()(t).call(this,e,n))}return g()(t,e),t}(ga),Rs=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var n={name:"RectangleScissors",strategies:{FILL_INSIDE:ws,FILL_OUTSIDE:Is,ERASE_OUTSIDE:ys,ERASE_INSIDE:ps},cursors:{FILL_INSIDE:Jo,FILL_OUTSIDE:ei,ERASE_OUTSIDE:Qo,ERASE_INSIDE:$o},defaultStrategy:"FILL_INSIDE",supportedInteractionTypes:["Mouse","Touch"],mixins:["rectangleSegmentationMixin"]};return u()(this,h()(t).call(this,e,n))}return g()(t,e),t}(ga),Us=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var n={name:"CircleScissors",strategies:{FILL_INSIDE:_s,FILL_OUTSIDE:Ps,ERASE_OUTSIDE:As,ERASE_INSIDE:Ls},cursors:{FILL_INSIDE:ni,FILL_OUTSIDE:oi,ERASE_OUTSIDE:ai,ERASE_INSIDE:ti},defaultStrategy:"FILL_INSIDE",supportedInteractionTypes:["Mouse","Touch"],svgCursor:ni,mixins:["circleSegmentationMixin"]};return u()(this,h()(t).call(this,e,n))}return g()(t,e),t}(ga),Ns=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var n={name:"CorrectionScissors",strategies:{CORRECTION:rs},cursors:{CORRECTION:Xo},defaultStrategy:"CORRECTION",supportedInteractionTypes:["Mouse","Touch"],svgCursor:Xo,mixins:["polylineSegmentationMixin"]};return u()(this,h()(t).call(this,e,n))}return g()(t,e),t}(ga),Fs={},Bs={},Vs={};function qs(e){if(!e)return"DEFAULT";var t=y.cornerstone.getEnabledElement(e).uuid;if(!t)throw new Error("Something went wrong when getting uuid from element");return t}var js={setStartLoadHandler:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:void 0;if(!e)throw new Error("The Handler function must be defined");var n=qs(t);Fs[n]=e},getStartLoadHandler:function(e){var t=qs(e);return Fs[t]||Fs.DEFAULT},setEndLoadHandler:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:void 0;if(!e)throw new Error("The Handler function must be defined");var n=qs(t);Bs[n]=e},getEndLoadHandler:function(e){var t=qs(e);return Bs[t]||Bs.DEFAULT},setErrorLoadingHandler:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:void 0;if(!e)throw new Error("The Handler function must be defined");var n=qs(t);Vs[n]=e},getErrorLoadingHandler:function(e){var t=qs(e);return Vs[t]||Vs.DEFAULT},removeHandlers:function(e){var t=qs(e);delete Fs[t],delete Bs[t],delete Vs[t]}},zs={};function Ws(e,t){if(!zs[e])return{};var n=zs[e].find((function(e){return e.element===t}));return n?n.options:{}}function Gs(e,t,n){if(zs[e]){var a=zs[e].findIndex((function(e){return e.element===t}));if(-1===a)zs[e].push({element:t,options:n});else{var o=zs[e][a].options||{};zs[e][a].options=Object.assign(o,n)}}else zs[e]=[{element:t,options:n}]}var Ys=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"Crosshairs",supportedInteractionTypes:["Mouse","Touch"],svgCursor:Oo};return(e=u()(this,h()(t).call(this,n,a))).preMouseDownCallback=e._chooseLocation.bind(wa()(e)),e.mouseDragCallback=e._chooseLocation.bind(wa()(e)),e.touchDragCallback=e._chooseLocation.bind(wa()(e)),e}return g()(t,e),l()(t,[{key:"_chooseLocation",value:function(e){var t=e.detail,n=t.element;e.stopImmediatePropagation();var a=O(n,this.name);if(a){var o=n,i=y.cornerstone.getEnabledElement(o).image.imageId,r=y.cornerstone.metaData.get("imagePlaneModule",i);if(r){var s=nn(t.currentPoints.image,r);a.data[0].synchronizationContext.getSourceElements().forEach((function(e){if(e!==o){var t=Number.MAX_VALUE,n=-1,a=O(e,"stack");if(void 0!==a){var i=a.data[0];if(i.imageIds.forEach((function(e,a){var o=y.cornerstone.metaData.get("imagePlaneModule",e);if(o&&o.imagePositionPatient&&o.rowCosines&&o.columnCosines){var i=en(o.imagePositionPatient),r=en(o.rowCosines),l=en(o.columnCosines).clone().cross(r.clone()),c=Math.abs(l.clone().dot(i)-l.clone().dot(s));c<t&&(t=c,n=a)}})),n!==i.currentImageIdIndex&&-1!==n&&void 0!==i.imageIds[n]){var r=js.getStartLoadHandler(e),l=js.getEndLoadHandler(e),c=js.getErrorLoadingHandler(e);r&&r(e),(!0===i.preventCache?y.cornerstone.loadImage(i.imageIds[n]):y.cornerstone.loadAndCacheImage(i.imageIds[n])).then((function(t){var a=y.cornerstone.getViewport(e);i.currentImageIdIndex=n,y.cornerstone.displayImage(e,t,a),l&&l(e,t)}),(function(t){var a=i.imageIds[n];c&&c(e,a,t)}))}}}}))}}}},{key:"activeCallback",value:function(e,t){var n=t.mouseButtonMask,a=t.synchronizationContext;Gs(this.name,e,{mouseButtonMask:n}),A(e,this.name),D(e,this.name,{synchronizationContext:a})}}]),t}(ga),Xs=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var n={name:"DoubleTapFitToWindow",supportedInteractionTypes:["DoubleTap"]};return u()(this,h()(t).call(this,e,n))}return g()(t,e),l()(t,[{key:"doubleTapCallback",value:function(e){var t=e.detail;y.cornerstone.fitToWindow(t.element)}}]),t}(ga),Ks=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"DragProbe",strategies:{default:Zs,minimal:$s},defaultStrategy:"default",supportedInteractionTypes:["Mouse","Touch"],svgCursor:_o};return(e=u()(this,h()(t).call(this,n,a))).touchDragCallback=e._movingEventCallback.bind(wa()(e)),e.touchEndCallback=e._endMovingEventCallback.bind(wa()(e)),e.mouseDragCallback=e._movingEventCallback.bind(wa()(e)),e.mouseUpCallback=e._endMovingEventCallback.bind(wa()(e)),e.dragEventData={},e}return g()(t,e),l()(t,[{key:"_movingEventCallback",value:function(e){var t=e.detail,n=t.element;this.dragEventData=t,y.cornerstone.updateImage(n)}},{key:"_endMovingEventCallback",value:function(e){var t=e.detail.element;this.dragEventData={},y.cornerstone.updateImage(t)}},{key:"renderToolData",value:function(e){this.dragEventData.currentPoints&&e&&e.detail&&Boolean(Object.keys(this.dragEventData.currentPoints).length)&&(e.detail.currentPoints=this.dragEventData.currentPoints,this.applyActiveStrategy(e))}}]),t}(ga);function Zs(e){var t=this.configuration,n=y.cornerstone,a=e.detail,o=a.element,i=a.image,r=a.currentPoints,s=a.canvasContext,l=_n(s.canvas),c=un.getActiveColor(),u=pn.getFontSize(),d=Math.round(r.image.x),h=Math.round(r.image.y);d<0||h<0||d>=i.columns||h>=i.rows||Wt(l,(function(e){Dn(e,t);var a,s,l="".concat(d,", ").concat(h);if(i.color)a=jr(o,d,h,1,1),s="R: ".concat(a[0]," G: ").concat(a[1]," B: ").concat(a[2]," A: ").concat(a[3]);else{var v=(a=n.getStoredPixels(o,d,h,1,1))[0],g=v*i.slope+i.intercept,f=$i(i,v);s="SP: ".concat(v," MO: ").concat(parseFloat(g.toFixed(3))),f&&(s+=" SUV: ".concat(parseFloat(f.toFixed(3))))}var m={x:r.canvas.x+5,y:r.canvas.y-5};bn(e,s,m.x,m.y+u+5,c),bn(e,l,m.x,m.y,c)}))}function $s(e){var t=this.configuration,n=y.cornerstone,a=e.detail,o=a.element,i=a.image,r=a.currentPoints,s=a.canvasContext,l=a.isTouchEvent,c=_n(s.canvas),u=un.getActiveColor(),d=r.page.y-pn.getFontSize()/2;l&&(d=r.page.y-4*pn.getFontSize());var h=n.pageToPixel(o,r.page.x,d);h.x<0||h.y<0||h.x>=i.columns||h.y>=i.rows||Wt(c,(function(e){Dn(e,t);var a,r=n.metaData.get("generalSeriesModule",i.imageId),s=r&&r.modality,c="";if(i.color)a=jr(o,h.x,h.y,1,1),c="R: ".concat(a[0]," G: ").concat(a[1]," B: ").concat(a[2]);else{var d=(a=n.getStoredPixels(o,h.x,h.y,1,1))[0],v=d*i.slope+i.intercept,g=parseFloat(v.toFixed(2));if("CT"===s)c+="HU: ".concat(g);else if("PT"===s){c+=g;var f=$i(i,d);f&&(c+=" SUV: ".concat(parseFloat(f.toFixed(2))))}else c+=g}var m=n.pixelToCanvas(o,h),p={x:12,y:-(pn.getFontSize()+10)/2},y=Tn(e,c,5);l&&(p={x:-y/2,y:-pn.getFontSize()-10-12}),Qt(e,o,m,6,{color:u},"canvas"),bn(e,c,m.x+p.x,m.y+p.y,u)}))}var Js=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"Eraser",supportedInteractionTypes:["Mouse","Touch"],svgCursor:Lo};return(e=u()(this,h()(t).call(this,n,a))).preMouseDownCallback=e._deleteAllNearbyTools.bind(wa()(e)),e.preTouchStartCallback=e._deleteAllNearbyTools.bind(wa()(e)),e}return g()(t,e),l()(t,[{key:"_deleteAllNearbyTools",value:function(e){var t=e.detail.currentPoints.canvas,n=e.detail.element;pt.tools.forEach((function(e){var a=O(n,e.name);a&&a.data.forEach((function(a){"function"==typeof e.pointNearTool&&e.pointNearTool(n,a,t)&&(L(n,e.name,a),y.cornerstone.updateImage(n))}))}));return!0}}]),t}(ga),Qs=Or.FreehandHandleData,el=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"FreehandRoiSculptor",referencedToolName:"FreehandRoi",supportedInteractionTypes:["Mouse","Touch","DoubleTap"],mixins:["activeOrDisabledBinaryTool"],configuration:tl(),svgCursor:So};return(e=u()(this,h()(t).call(this,n,a))).updateOnMouseMove=!0,e.isMultiPartTool=!0,e.referencedToolName=e.initialConfiguration.referencedToolName,e._active=!1,e.activeMouseUpCallback=e.activeMouseUpCallback.bind(wa()(e)),e.activeTouchEndCallback=e.activeTouchEndCallback.bind(wa()(e)),e.activeMouseDragCallback=e.activeMouseDragCallback.bind(wa()(e)),e}return g()(t,e),l()(t,[{key:"renderToolData",value:function(e){var t=e.detail;if(null===this.configuration.currentTool)return!1;var n=t.element,a=this.configuration;if(!O(n,this.referencedToolName).data[a.currentTool])return!1;if(this._active){var o=t.canvasContext.canvas.getContext("2d"),i={color:this.configuration.dragColor,fill:null,handleRadius:this._toolSizeCanvas};dn(o,t,this.configuration.mouseLocation.handles,i)}else this.configuration.showCursorOnHover&&!this._recentTouchEnd&&this._renderHoverCursor(e)}},{key:"doubleClickCallback",value:function(e){var t=e.detail;this._selectFreehandTool(t),y.cornerstone.updateImage(t.element)}},{key:"doubleTapCallback",value:function(e){var t=e.detail;this._selectFreehandTool(t),y.cornerstone.updateImage(t.element)}},{key:"preTouchStartCallback",value:function(e){return this._initialiseSculpting(e),!0}},{key:"preMouseDownCallback",value:function(e){if(this.options.mouseButtonMask.includes(e.detail.buttons))return this._initialiseSculpting(e),!0}},{key:"activeMouseDragCallback",value:function(e){var t=this.configuration;if(this._active){var n=e.detail,a=O(n.element,this.referencedToolName);if(a){var o=a.data[t.currentTool].handles.points;this._getMouseLocation(n),this._sculpt(n,o),y.cornerstone.updateImage(n.element)}}}},{key:"activeMouseUpCallback",value:function(e){this._activeEnd(e)}},{key:"activeTouchEndCallback",value:function(e){this._activeEnd(e),this._deselectAllTools(e),this._recentTouchEnd=!0}},{key:"_activeEnd",value:function(e){var t=e.detail,n=t.element,a=this.configuration;this._active=!1,pt.isMultiPartToolActive=!1,this._getMouseLocation(t),this._invalidateToolData(t),a.mouseUpRender=!0,this._deactivateSculpt(n),y.cornerstone.updateImage(t.element),function(e){e.stopImmediatePropagation(),e.stopPropagation(),e.preventDefault()}(e)}},{key:"_renderHoverCursor",value:function(e){var t,n=e.detail,a=n.element,o=n.canvasContext.canvas.getContext("2d"),i=O(a,this.referencedToolName).data[this.configuration.currentTool];this._recentTouchEnd=!1,this.configuration.mouseUpRender?(t=this.configuration.mouseLocation.handles.start,this.configuration.mouseUpRender=!1):t=pt.mousePositionImage;var r=Ct(a,this.referencedToolName).distanceFromPointCanvas(a,i,t);if(this.configuration.mouseLocation.handles.start.x=t.x,this.configuration.mouseLocation.handles.start.y=t.y,this.configuration.limitRadiusOutsideRegion){var s=r;r=this._limitCursorRadiusCanvas(n,r),s>this.configuration.hoverCursorFadeDistance*r&&(o.globalAlpha=this.configuration.hoverCursorFadeAlpha)}var l={fill:null,color:this.configuration.hoverColor,handleRadius:r};dn(o,n,this.configuration.mouseLocation.handles,l),this.configuration.limitRadiusOutsideRegion&&(o.globalAlpha=1)}},{key:"newImageCallback",value:function(e){this._deselectAllTools(e)}},{key:"enabledCallback",value:function(e){this._deselectAllTools(e)}},{key:"passiveCallback",value:function(e){this._deselectAllTools(e)}},{key:"disabledCallback",value:function(e){this._deselectAllTools(e)}},{key:"_selectFreehandTool",value:function(e){var t=this.configuration,n=e.element,a=this._getClosestFreehandToolOnElement(n,e);void 0!==a&&(t.currentTool=a,wt(n))}},{key:"_activateFreehandTool",value:function(e,t){var n=O(e,this.referencedToolName).data;this.configuration.currentTool=t;for(var a=0;a<n.length;a++)n[a].active=a===t}},{key:"_initialiseSculpting",value:function(e){var t=e.detail,n=this.configuration,a=t.element;null===n.currentTool&&(this._selectFreehandTool(t),null===n.currentTool)||(this._active=!0,pt.isMultiPartToolActive=!0,this._configureToolSize(t),this._getMouseLocation(t),this._activateFreehandTool(a,n.currentTool),this._activateSculpt(a),y.cornerstone.updateImage(t.element))}},{key:"_sculpt",value:function(e,t){var n=this.configuration;this._sculptData={element:e.element,image:e.image,mousePoint:e.currentPoints.image,points:t,toolSize:this._toolSizeImage,minSpacing:n.minSpacing,maxSpacing:Math.max(this._toolSizeImage,2*n.minSpacing)};var a=this._pushHandles();void 0!==a.first&&(this._insertNewHandles(a),this._consolidateHandles())}},{key:"_pushHandles",value:function(){for(var e=this._sculptData,t=e.points,n=e.mousePoint,a=e.toolSize,o={},i=0;i<t.length;i++){var r=y.cornerstoneMath.point.distance(t[i],n);r>a||(this._pushOneHandle(i,r),void 0===o.first?(o.first=i,o.last=i):o.last=i)}return o}},{key:"_pushOneHandle",value:function(e,t){var n=this._sculptData,a=n.points,o=n.mousePoint,i=n.toolSize,r=n.image,s=a[e],l=(s.x-o.x)/t,c=(s.y-o.y)/t,u={x:o.x+i*l,y:o.y+i*c};Mn(u,r),s.x=u.x,s.y=u.y;var d=this.constructor._getPreviousHandleIndex(e,a.length);a[d].lines.pop(),a[d].lines.push(s)}},{key:"_insertNewHandles",value:function(e){for(var t=this._findNewHandleIndicies(e),n=0,a=0;a<t.length;a++){var o=t[a]+1+n;this._insertHandleRadially(o),n++}}},{key:"_findNewHandleIndicies",value:function(e){for(var t=this._sculptData,n=t.points,a=t.maxSpacing,o=[],i=e.first;i<=e.last;i++)this._checkSpacing(i,n,o,a);var r=this.constructor._getNextHandleIndex(e.last,n.length);if(r!==e.first){this._checkSpacing(r,n,o,a);var s=this.constructor._getPreviousHandleIndex(e.first,n.length);s!==r&&this._checkSpacing(s,n,o,a)}return o}},{key:"_checkSpacing",value:function(e,t,n,a){var o=this.constructor._getNextHandleIndex(e,t.length);y.cornerstoneMath.point.distance(t[e],t[o])>a&&n.push(e)}},{key:"_insertHandleRadially",value:function(e){var t=this._sculptData.points,n=e-1,a=this.constructor._getNextHandleIndexBeforeInsert(e,t.length),o=this._getInsertPosition(e,n,a),i=new Qs(o);t.splice(e,0,i),t[n].lines.pop(),t[n].lines.push(t[e]),Or.addLine(t,e)}},{key:"_consolidateHandles",value:function(){if(!(this._sculptData.points.length<=3)){var e=this._findCloseHandlePairs();this._mergeCloseHandles(e)}}},{key:"_findCloseHandlePairs",value:function(){for(var e=this._sculptData,t=e.points,n=e.minSpacing,a=[],o=t.length,i=0;i<o;i++){var r=this.constructor._getNextHandleIndex(i,t.length);if(y.cornerstoneMath.point.distance(t[i],t[r])<n){var s=[i,r];a.push(s),0===i&&(o-=1),i++}}return a}},{key:"_mergeCloseHandles",value:function(e){for(var t=0,n=0;n<e.length;n++){var a=this.constructor._getCorrectedPair(e[n],t);this._combineHandles(a),t++}var o=this._findCloseHandlePairs();o.length&&this._mergeCloseHandles(o)}},{key:"_combineHandles",value:function(e){var t=this._sculptData,n=t.points,a=t.image,o={x:(n[e[0]].x+n[e[1]].x)/2,y:(n[e[0]].y+n[e[1]].y)/2};Mn(o,a),n[e[0]].x=o.x,n[e[0]].y=o.y;var i=this.constructor._getNextHandleIndex(e[1],n.length);n[e[0]].lines.pop(),n[e[0]].lines.push(n[i]),n.splice(e[1],1)}},{key:"_configureToolSize",value:function(e){var t=e.element,n=this.configuration,a=n.currentTool,o=e.currentPoints.image,i=O(t,this.referencedToolName).data[a],r=Ct(t,this.referencedToolName),s=r.distanceFromPoint(t,i,o),l=r.distanceFromPointCanvas(t,i,o);n.limitRadiusOutsideRegion&&(s=this._limitCursorRadiusImage(e,s),l=this._limitCursorRadiusCanvas(e,l)),this._toolSizeImage=s,this._toolSizeCanvas=l}},{key:"_getMouseLocation",value:function(e){var t=this.configuration;t.mouseLocation.handles.start.x=e.currentPoints.image.x,t.mouseLocation.handles.start.y=e.currentPoints.image.y,Mn(t.mouseLocation.handles.start,e.image)}},{key:"_activateSculpt",value:function(e){this._deactivateSculpt(e),e.addEventListener(b.MOUSE_UP,this.activeMouseUpCallback),e.addEventListener(b.MOUSE_CLICK,this.activeMouseUpCallback),e.addEventListener(b.MOUSE_DRAG,this.activeMouseDragCallback),e.addEventListener(b.TOUCH_END,this.activeTouchEndCallback),e.addEventListener(b.TOUCH_TAP,this.activeTouchEndCallback),e.addEventListener(b.TOUCH_DRAG,this.activeMouseDragCallback),y.cornerstone.updateImage(e)}},{key:"_deactivateSculpt",value:function(e){e.removeEventListener(b.MOUSE_UP,this.activeMouseUpCallback),e.removeEventListener(b.MOUSE_CLICK,this.activeMouseUpCallback),e.removeEventListener(b.MOUSE_DRAG,this.activeMouseDragCallback),e.removeEventListener(b.TOUCH_END,this.activeTouchEndCallback),e.removeEventListener(b.TOUCH_TAP,this.activeTouchEndCallback),e.removeEventListener(b.TOUCH_DRAG,this.activeMouseDragCallback),y.cornerstone.updateImage(e)}},{key:"_invalidateToolData",value:function(e){var t=this.configuration;O(e.element,this.referencedToolName).data[t.currentTool].invalidated=!0}},{key:"_deselectAllTools",value:function(e){var t=this.configuration,n=O(this.element,this.referencedToolName);if(t.currentTool=null,n)for(var a=0;a<n.data.length;a++)n.data[a].active=!1;Et(this.element,this.svgCursor),y.cornerstone.updateImage(this.element)}},{key:"_limitCursorRadiusCanvas",value:function(e,t){return this._limitCursorRadius(e,t,!0)}},{key:"_limitCursorRadiusImage",value:function(e,t){return this._limitCursorRadius(e,t,!1)}},{key:"_limitCursorRadius",value:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],a=e.element,o=e.image,i=this.configuration,r=O(a,this.referencedToolName),s=r.data[i.currentTool],l=1;if(n){var c=y.cornerstone.pixelToCanvas(a,{x:0,y:0}),u=y.cornerstone.pixelToCanvas(a,{x:o.width,y:o.height}),d=(u.x-c.x)*(u.y-c.y);l=d/(o.width*o.height)}var h=s.area*l,v=Math.pow(h/Math.PI,.5);return Math.min(t,v)}},{key:"_getClosestFreehandToolOnElement",value:function(e,t){var n=Ct(e,this.referencedToolName),a=O(e,this.referencedToolName);if(a){for(var o=a.data,i=t.currentPoints.image,r={distance:1/0,toolIndex:null},s=0;s<o.length;s++){var l=n.distanceFromPoint(e,o[s],i);-1!==l&&(l<r.distance&&(r.distance=l,r.toolIndex=s))}return r.toolIndex}}},{key:"_getInsertPosition",value:function(e,t,n){var a,o=this._sculptData,i=o.points,r=o.toolSize,s=o.mousePoint,l=o.image,c={x:(i[t].x+i[n].x)/2,y:(i[t].y+i[n].y)/2},u=y.cornerstoneMath.point.distance(s,c);if(u<r){var d={x:(c.x-s.x)/u,y:(c.y-s.y)/u};a={x:s.x+r*d.x,y:s.y+r*d.y}}else a=c;return Mn(a,l),a}},{key:"minSpacing",get:function(){return this.configuration.minSpacing},set:function(e){if("number"!=typeof e)throw new Error("Attempting to set freehandSculpter minSpacing to a value other than a number.");this.configuration.minSpacing=e}},{key:"maxSpacing",get:function(){return this.configuration.maxSpacing},set:function(e){if("number"!=typeof e)throw new Error("Attempting to set freehandSculpter maxSpacing to a value other than a number.");this.configuration.maxSpacing=e}},{key:"showCursorOnHover",get:function(){return this.configuration.showCursorOnHover},set:function(e){if("boolean"!=typeof e)throw new Error("Attempting to set freehandSculpter showCursorOnHover to a value other than a boolean.");this.configuration.showCursorOnHover=e,y.cornerstone.updateImage(this.element)}},{key:"limitRadiusOutsideRegion",get:function(){return this.configuration.limitRadiusOutsideRegion},set:function(e){if("boolean"!=typeof e)throw new Error("Attempting to set freehandSculpter limitRadiusOutsideRegion to a value other than a boolean.");this.configuration.limitRadiusOutsideRegion=e,y.cornerstone.updateImage(this.element)}},{key:"hoverCursorFadeAlpha",get:function(){return this.configuration.hoverCursorFadeAlpha},set:function(e){if("number"!=typeof e)throw new Error("Attempting to set freehandSculpter hoverCursorFadeAlpha to a value other than a number.");e=Math.max(Math.min(e,1),0),this.configuration.hoverCursorFadeAlpha=e,y.cornerstone.updateImage(this.element)}},{key:"hoverCursorFadeDistance",get:function(){return this.configuration.hoverCursorFadeDistance},set:function(e){if("number"!=typeof e)throw new Error("Attempting to set freehandSculpter hoverCursorFadeDistance to a value other than a number.");e=Math.max(e,1),this.configuration.hoverCursorFadeDistance=e,y.cornerstone.updateImage(this.element)}}],[{key:"_getCorrectedPair",value:function(e,t){var n=[e[0]-t,e[1]-t];return n[1]<0&&(n[1]=0),n}},{key:"_getNextHandleIndex",value:function(e,t){return e===t-1?0:e+1}},{key:"_getPreviousHandleIndex",value:function(e,t){return 0===e?t-1:e-1}},{key:"_getNextHandleIndexBeforeInsert",value:function(e,t){return e===t?0:e}}]),t}(ga);function tl(){return{mouseLocation:{handles:{start:{highlight:!0,active:!0}}},minSpacing:1,currentTool:null,dragColor:un.getActiveColor(),hoverColor:un.getToolColor(),showCursorOnHover:!0,limitRadiusOutsideRegion:!0,hoverCursorFadeAlpha:.5,hoverCursorFadeDistance:1.2}}var nl=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"Magnify",supportedInteractionTypes:["Mouse","Touch"],configuration:{magnifySize:300,magnificationLevel:2},svgCursor:Ao};return(e=u()(this,h()(t).call(this,n,a))).zoomCanvas=void 0,e.zoomElement=void 0,e.activeCallback=e._createMagnificationCanvas.bind(wa()(e)),e.enabledCallback=e._createMagnificationCanvas.bind(wa()(e)),e.disabledCallback=e._destroyMagnificationCanvas.bind(wa()(e)),e.postTouchStartCallback=e._addMagnifyingGlass.bind(wa()(e)),e.touchDragCallback=e._updateMagnifyingGlass.bind(wa()(e)),e.touchEndCallback=e._removeMagnifyingGlass.bind(wa()(e)),e.touchDragEndCallback=e._removeMagnifyingGlass.bind(wa()(e)),e.postMouseDownCallback=e._addMagnifyingGlass.bind(wa()(e)),e.mouseDragCallback=e._updateMagnifyingGlass.bind(wa()(e)),e.mouseUpCallback=e._removeMagnifyingGlass.bind(wa()(e)),e.mouseClickCallback=e._removeMagnifyingGlass.bind(wa()(e)),e.newImageCallback=e._drawMagnificationTool.bind(wa()(e)),e}return g()(t,e),l()(t,[{key:"_addMagnifyingGlass",value:function(e){var t=this;this._removeZoomElement(),this._drawZoomedElement(e),window.requestAnimationFrame((function(){return t._drawMagnificationTool(e)})),wt(e.detail.element),e.preventDefault(),e.stopPropagation()}},{key:"_updateMagnifyingGlass",value:function(e){this._drawMagnificationTool(e),e.preventDefault(),e.stopPropagation()}},{key:"_removeMagnifyingGlass",value:function(e){var t=e.detail.element;Et(this.element,this.svgCursor),t.querySelector(".magnifyTool").style.display="none",this._removeZoomElement()}},{key:"_drawMagnificationTool",value:function(e){var t=e.detail.element,n=t.querySelector(".magnifyTool");if(n||this._createMagnificationCanvas(t),void 0!==this.zoomCanvas){var a=t.querySelector("canvas:not(.magnifyTool)"),o=_n(n),i=y.cornerstone.pixelToCanvas(e.detail.element,e.detail.currentPoints.image),r=Math.min(this.configuration.magnifySize,a.width,a.height),s=this.configuration.magnificationLevel;n.width=r,n.height=r,i.x=Math.max(i.x,.5*r/s),i.x=Math.min(i.x,a.width-.5*r/s),i.y=Math.max(i.y,.5*r/s),i.y=Math.min(i.y,a.height-.5*r/s);var l={x:i.x*s-.5*r,y:i.y*s-.5*r};l.x=Math.max(l.x,0),l.y=Math.max(l.y,0),o.drawImage(this.zoomCanvas,l.x,l.y,r,r,0,0,r,r);var c=e.detail.isTouchEvent?120:0,u={top:Math.max(i.y-.5*r-c,0),left:Math.max(i.x-.5*r,0)},d=n.getBoundingClientRect();u.top=Math.min(u.top,a.height-d.height),u.left=Math.min(u.left,a.width-d.width),n.style.top="".concat(u.top,"px"),n.style.left="".concat(u.left,"px"),n.style.display="block"}}},{key:"_drawZoomedElement",value:function(e){var t=e.detail.element,n=e.detail.enabledElement;void 0===n&&(n=y.cornerstone.getEnabledElement(t));var a=this.configuration.magnificationLevel,o=n.canvas,i=n.image;this.zoomElement||(this.zoomElement=document.createElement("div"),this.zoomElement.width=o.width*a,this.zoomElement.height=o.height*a,y.cornerstone.enable(this.zoomElement,n.options));var r=y.cornerstone.getEnabledElement(this.zoomElement),s=y.cornerstone.getViewport(n.element);this.zoomCanvas=r.canvas,this.zoomCanvas.width=o.width*a,this.zoomCanvas.height=o.height*a,r.viewport=Object.assign({},s),s.scale*=a,y.cornerstone.displayImage(this.zoomElement,i),y.cornerstone.setViewport(this.zoomElement,s)}},{key:"_removeZoomElement",value:function(){void 0!==this.zoomElement&&(y.cornerstone.disable(this.zoomElement),this.zoomElement=void 0,this.zoomCanvas=void 0)}},{key:"_createMagnificationCanvas",value:function(e){if(null===e.querySelector(".magnifyTool")){var t=document.createElement("canvas");t.classList.add("magnifyTool"),t.width=this.configuration.magnifySize,t.height=this.configuration.magnifySize,t.style.position="absolute",t.style.display="none",e.appendChild(t)}}},{key:"_destroyMagnificationCanvas",value:function(e){var t=e.querySelector(".magnifyTool");t&&e.removeChild(t)}}]),t}(ga),al=xt.globalConfiguration,ol=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"Overlay",configuration:{},mixins:["enabledOrDisabledBinaryTool"]},o=Object.assign(a,n);return(e=u()(this,h()(t).call(this,o))).initialConfiguration=o,e}return g()(t,e),l()(t,[{key:"enabledCallback",value:function(e){this.forceImageUpdate(e)}},{key:"disabledCallback",value:function(e){this.forceImageUpdate(e)}},{key:"forceImageUpdate",value:function(e){y.cornerstone.getEnabledElement(e).image&&y.cornerstone.updateImage(e)}},{key:"setupRender",value:function(e){if(e){var t=y.cornerstone.metaData.get("overlayPlaneModule",e.imageId);if(t&&t.overlays&&t.overlays.length)return t}}},{key:"setupViewport",value:function(e){if(void 0===e.overlayColor&&(e.overlayColor=al.configuration.overlayColor||"white"),!1!==e.overlayColor)return!0}},{key:"renderToolData",value:function(e){var t=e.detail,n=t.enabledElement,a=t.image,o=t.viewport,i=t.canvasContext,r=this.setupRender(a);if(t&&n&&r&&this.setupViewport(o)){var s=a.columns,l=a.rows;r.overlays.forEach((function(e){if(!1!==e.visible){var t=document.createElement("canvas");t.width=s,t.height=l;var n=t.getContext("2d");n.fillStyle=e.fillStyle||o.overlayColor,"R"===e.type&&(n.fillRect(0,0,t.width,t.height),n.globalCompositeOperation="xor");for(var a=0,r=0;r<e.rows;r++)for(var c=0;c<e.columns;c++)e.pixelData[a++]>0&&n.fillRect(c,r,1,1);var u=!isNaN(parseFloat(e.x))&&isFinite(e.x)?e.x:0,d=!isNaN(parseFloat(e.y))&&isFinite(e.y)?e.y:0;i.drawImage(t,u,d)}}))}}}]),t}(ga),il={getOrientationString:function(e){for(var t=en(e),n="",a=t.x<0?"R":"L",o=t.y<0?"A":"P",i=t.z<0?"F":"H",r=new y.cornerstoneMath.Vector3(Math.abs(t.x),Math.abs(t.y),Math.abs(t.z)),s=1e-4,l=0;l<3;l++)if(r.x>s&&r.x>r.y&&r.x>r.z)n+=a,r.x=0;else if(r.y>s&&r.y>r.x&&r.y>r.z)n+=o,r.y=0;else if(r.z>s&&r.z>r.x&&r.z>r.y)n+=i,r.z=0;else if(r.x>s&&r.y>s&&r.x===r.y)n+=a+o,r.x=0,r.y=0;else if(r.x>s&&r.z>s&&r.x===r.z)n+=a+i,r.x=0,r.z=0;else{if(!(r.y>s&&r.z>s&&r.y===r.z))break;n+=o+i,r.y=0,r.z=0}return n},invertOrientationString:function(e){var t=e.replace("H","f");return t=(t=(t=(t=(t=(t=t.replace("F","h")).replace("R","l")).replace("L","r")).replace("A","p")).replace("P","a")).toUpperCase()}},rl=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var n={name:"OrientationMarkers",configuration:{drawAllMarkers:!0},mixins:["enabledOrDisabledBinaryTool"]};return u()(this,h()(t).call(this,e,n))}return g()(t,e),l()(t,[{key:"enabledCallback",value:function(e){this.forceImageUpdate(e)}},{key:"disabledCallback",value:function(e){this.forceImageUpdate(e)}},{key:"forceImageUpdate",value:function(e){var t=y.cornerstone;t.getEnabledElement(e).image&&t.updateImage(e)}},{key:"renderToolData",value:function(e){var t=e.detail,n=_n(t.canvasContext.canvas),a=t.element,o=cl(a);if(o){var i=ul(a,o),r=un.getToolColor(),s={top:Tn(n,o.top,0),left:Tn(n,o.left,0),right:Tn(n,o.right,0),bottom:Tn(n,o.bottom,0),height:Tn(n,"M",0)};sl(n,o,i,s,r),this.configuration.drawAllMarkers&&ll(n,o,i,s,r)}}}]),t}(ga),sl=function(e,t,n,a,o){bn(e,t.top,n.top.x-a.top/2,n.top.y,o),bn(e,t.left,n.left.x-a.left/2,n.left.y,o)},ll=function(e,t,n,a,o){bn(e,t.right,n.right.x-a.right,n.right.y,o),bn(e,t.bottom,n.bottom.x-a.bottom/2,n.bottom.y-a.height,o)},cl=function(e){var t=y.cornerstone,n=t.getEnabledElement(e),a=t.metaData.get("imagePlaneModule",n.image.imageId);if(a&&a.rowCosines&&a.columnCosines){var o=il.getOrientationString(a.rowCosines),i=il.getOrientationString(a.columnCosines),r=il.invertOrientationString(o);return{top:il.invertOrientationString(i),bottom:i,left:r,right:o}}},ul=function(e){var t=y.cornerstone.getEnabledElement(e);return{top:y.cornerstone.pixelToCanvas(e,{x:t.image.width/2,y:5}),bottom:y.cornerstone.pixelToCanvas(e,{x:t.image.width/2,y:t.image.height-15}),left:y.cornerstone.pixelToCanvas(e,{x:5,y:t.image.height/2}),right:y.cornerstone.pixelToCanvas(e,{x:t.image.width-10,y:t.image.height/2})}},dl=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"PanMultiTouch",supportedInteractionTypes:["MultiTouch"],configuration:{touchPointers:2}};return(e=u()(this,h()(t).call(this,n,a))).multiTouchDragCallback=e._dragCallback.bind(wa()(e)),e}return g()(t,e),l()(t,[{key:"_dragCallback",value:function(e){var t=e.detail,n=t.element,a=t.viewport;if(t.numPointers===this.configuration.touchPointers){var o=this._getTranslation(t);this._applyTranslation(a,o),y.cornerstone.setViewport(n,a)}}},{key:"_getTranslation",value:function(e){var t=e.viewport,n=e.image,a=e.deltaPoints,o=t.scale,i=t.scale;return n.rowPixelSpacing<n.columnPixelSpacing?o*=n.columnPixelSpacing/n.rowPixelSpacing:n.columnPixelSpacing<n.rowPixelSpacing&&(i*=n.rowPixelSpacing/n.columnPixelSpacing),{x:a.page.x/o,y:a.page.y/i}}},{key:"_applyTranslation",value:function(e,t){e.translation.x+=t.x,e.translation.y+=t.y}}]),t}(ga),hl=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"Pan",supportedInteractionTypes:["Mouse","Touch"],svgCursor:Ho};return(e=u()(this,h()(t).call(this,n,a))).touchDragCallback=e._dragCallback.bind(wa()(e)),e.mouseDragCallback=e._dragCallback.bind(wa()(e)),e}return g()(t,e),l()(t,[{key:"_dragCallback",value:function(e){var t=e.detail,n=t.element,a=t.viewport,o=this._getTranslation(t);this._applyTranslation(a,o),y.cornerstone.setViewport(n,a)}},{key:"_getTranslation",value:function(e){var t=e.viewport,n=e.image,a=e.deltaPoints,o=t.scale,i=t.scale;return n.rowPixelSpacing<n.columnPixelSpacing?o*=n.columnPixelSpacing/n.rowPixelSpacing:n.columnPixelSpacing<n.rowPixelSpacing&&(i*=n.rowPixelSpacing/n.columnPixelSpacing),{x:a.page.x/o,y:a.page.y/i}}},{key:"_applyTranslation",value:function(e,t){e.translation.x+=t.x,e.translation.y+=t.y}}]),t}(ga),vl=n(11),gl=n.n(vl),fl=n(13),ml=n.n(fl),pl=function(e,t,n,a){var o=y.cornerstone,i=o.getEnabledElement(n).image,r=o.getEnabledElement(a).image;if(i&&r){var s=o.metaData.get("imagePlaneModule",i.imageId),l=o.metaData.get("imagePlaneModule",r.imageId);if(s&&l&&s.rowCosines&&s.columnCosines&&s.imagePositionPatient&&l.rowCosines&&l.columnCosines&&l.imagePositionPatient&&s.frameOfReferenceUID===l.frameOfReferenceUID){s.rowCosines=en(s.rowCosines),s.columnCosines=en(s.columnCosines),s.imagePositionPatient=en(s.imagePositionPatient),l.rowCosines=en(l.rowCosines),l.columnCosines=en(l.columnCosines),l.imagePositionPatient=en(l.imagePositionPatient);var c=s.rowCosines.clone().cross(s.columnCosines),u=l.rowCosines.clone().cross(l.columnCosines),d=c.angleTo(u);if(!((d=Math.abs(d))<.5)){var h=function(e,t){var n=an(e,t);if(n)return{start:tn(n.start,e),end:tn(n.end,e)}}(s,l);if(h){var v=un.getActiveColor();e.setTransform(1,0,0,1,0,0),Wt(e,(function(e){Zt(e,t.element,h.start,h.end,{color:v})}))}}}}},yl=function(e){return new Promise((function(t){return setTimeout(t,e)}))};function xl(e){try{var t=y.cornerstone.getEnabledElement(e);return t.image?t:yl(250).then((function(){return xl(e)}))}catch(e){return null}}var Tl=N("tools:ReferenceLinesTool"),bl=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"ReferenceLines",mixins:["enabledOrDisabledBinaryTool"],configuration:{renderer:pl}};return(e=u()(this,h()(t).call(this,n,a))).renderer=null,e.synchronizationContext=null,e}var n;return g()(t,e),l()(t,[{key:"enabledCallback",value:(n=ml()(gl.a.mark((function e(t){var n,a,o,i=arguments;return gl.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=i.length>1&&void 0!==i[1]?i[1]:{},a=n.synchronizationContext,o=this.configuration.renderer,e.next=4,xl(t);case 4:if(e.sent&&o&&a){e.next=8;break}return Tl.warn("Unable to enable ".concat(this.name,". Exiting enable callback. Tool will be enabled, but will not render.")),e.abrupt("return");case 8:this.renderer=o,this.synchronizationContext=a,this.forceImageUpdate(t);case 11:case"end":return e.stop()}}),e,this)}))),function(e){return n.apply(this,arguments)})},{key:"disabledCallback",value:function(e){this.forceImageUpdate(e)}},{key:"forceImageUpdate",value:function(e){y.cornerstone.getEnabledElement(e).image&&y.cornerstone.updateImage(e)}},{key:"renderToolData",value:function(e){var t=this,n=e.detail;if(this.renderer&&this.synchronizationContext){var a=this.synchronizationContext.getSourceElements(),o=_n(n.canvasContext.canvas);y.cornerstone.setToPixelCoordinateSystem(n.enabledElement,o),a.forEach((function(a){a!==e.currentTarget&&t.renderer(o,n,e.currentTarget,a)}))}}}]),t}(ga),Cl=function(e,t,n){var a=Math.sqrt(Math.pow(e.x-t.x,2)+Math.pow(e.y-t.y,2)),o=Math.sqrt(Math.pow(e.x-n.x,2)+Math.pow(e.y-n.y,2)),i=Math.sqrt(Math.pow(t.x-n.x,2)+Math.pow(t.y-n.y,2));return{angle:180*Math.acos((Math.pow(a,2)+Math.pow(o,2)-Math.pow(i,2))/(2*a*o))/Math.PI,direction:(t.x-e.x)*(n.y-e.y)-(t.y-e.y)*(n.x-e.x)}},Ml=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var n={name:"Rotate",strategies:{default:El,horizontal:wl,vertical:Il},defaultStrategy:"default",supportedInteractionTypes:["Mouse","Touch"],configuration:{roundAngles:!1,flipHorizontal:!1,flipVertical:!1,rotateScale:1},svgCursor:Ro};return u()(this,h()(t).call(this,e,n))}return g()(t,e),l()(t,[{key:"touchDragCallback",value:function(e){this.dragCallback(e)}},{key:"mouseDragCallback",value:function(e){this.dragCallback(e)}},{key:"postMouseDownCallback",value:function(e){this.initialRotation=e.detail.viewport.rotation}},{key:"dragCallback",value:function(e){e.detail.viewport.initialRotation=this.initialRotation,this.applyActiveStrategy(e),y.cornerstone.setViewport(e.detail.element,e.detail.viewport)}}]),t}(ga);function El(e){var t=this.configuration,n=t.roundAngles,a=t.rotateScale,o=e.detail,i=o.element,r=o.viewport,s=o.startPoints,l=o.currentPoints,c=r.initialRotation?r.initialRotation:r.rotation,u=i.getBoundingClientRect(i),d=i.clientWidth,h=i.clientHeight,v=r.scale,g=r.translation,f={x:u.left+d/2+g.x*v,y:u.top+h/2+g.y*v},m=Cl(f,s.client,l.client);m.angle*=a,n&&(m.angle=Math.ceil(m.angle)),m.direction<0&&(m.angle=-m.angle),r.rotation=c+m.angle}function wl(e){var t=this.configuration,n=t.roundAngles,a=t.flipHorizontal,o=t.rotateScale,i=e.detail,r=i.viewport,s=i.startPoints,l=i.currentPoints,c=r.initialRotation,u=s.client.x,d=(l.client.x-u)*o;n&&(d=Math.round(Math.abs(d))*(d>0?1:-1)),a&&(d=-d),r.rotation=c+d}function Il(e){var t=this.configuration,n=t.roundAngles,a=t.flipVertical,o=t.rotateScale,i=e.detail,r=i.viewport,s=i.startPoints,l=i.currentPoints,c=r.initialRotation,u=s.client.y,d=(l.client.y-u)*o;n&&(d=Math.round(Math.abs(d))*(d>0?1:-1)),a&&(d=-d),r.rotation=c+d}var Sl=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var n={name:"RotateTouch",supportedInteractionTypes:["TouchRotate"]};return u()(this,h()(t).call(this,e,n))}return g()(t,e),l()(t,[{key:"touchRotateCallback",value:function(e){var t=e.detail,n=t.element,a=t.viewport,o=t.rotation;a.rotation+=o,y.cornerstone.setViewport(n,a)}}]),t}(ga),kl=N("tools:ScaleOverlayTool"),_l=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var n={name:"ScaleOverlay",configuration:{minorTickLength:12.5,majorTickLength:25},mixins:["enabledOrDisabledBinaryTool"]};return u()(this,h()(t).call(this,e,n))}return g()(t,e),l()(t,[{key:"enabledCallback",value:function(e){this.forceImageUpdate(e)}},{key:"disabledCallback",value:function(e){this.forceImageUpdate(e)}},{key:"forceImageUpdate",value:function(e){y.cornerstone.getEnabledElement(e).image&&y.cornerstone.updateImage(e)}},{key:"renderToolData",value:function(e){var t=e.detail,n=_n(t.canvasContext.canvas),a=t.image,o=t.viewport,i=t.element,r=a.rowPixelSpacing,s=a.columnPixelSpacing,l=y.cornerstone.metaData.get("imagePlaneModule",a.imageId);if(l&&(r=l.rowPixelSpacing||l.rowImagePixelSpacing,s=l.columnPixelSpacing||l.colImagePixelSpacing),r&&s){var c={width:n.canvas.width,height:n.canvas.height},u=10/r*o.scale,d=10/s*o.scale,h=Pl(c,.25,.05),v=Pl(c,.05,.15);if(c.width&&c.height&&h&&v){var g=un.getToolColor(),f=Xt.getToolWidth(),m=Object.assign({},{hscaleBounds:h,vscaleBounds:v,verticalMinorTick:u,horizontalMinorTick:d,verticalLine:{start:{x:v.bottomRight.x,y:v.topLeft.y},end:{x:v.bottomRight.x,y:v.bottomRight.y}},horizontalLine:{start:{x:h.topLeft.x,y:h.bottomRight.y},end:{x:h.bottomRight.x,y:h.bottomRight.y}},color:g,lineWidth:f},this.configuration);Wt(n,(function(e){Dn(e,m),Zt(e,i,m.verticalLine.start,m.verticalLine.end,{color:m.color,lineWidth:m.lineWidth},"canvas"),Dl(e,i,m),Zt(e,i,m.horizontalLine.start,m.horizontalLine.end,{color:m.color,lineWidth:m.lineWidth},"canvas"),Ol(e,i,m)}))}}else kl.warn("unable to define rowPixelSpacing or colPixelSpacing from data on ".concat(this.name,"'s renderToolData"))}}]),t}(ga),Pl=function(e,t,n){var a=t*Math.min(1e3,e.width),o=n*Math.min(1e3,e.height),i={left:a,top:o,width:e.width-2*a,height:e.height-2*o};return{topLeft:{x:i.left,y:i.top},bottomRight:{x:i.left+i.width,y:i.top+i.height}}},Dl=function(e,t,n){for(var a=0;n.verticalLine.start.y+a*n.verticalMinorTick<=n.vscaleBounds.bottomRight.y;){var o=n.color,i=n.lineWidth,r={x:n.verticalLine.start.x,y:n.verticalLine.start.y+a*n.verticalMinorTick},s={x:0,y:n.verticalLine.start.y+a*n.verticalMinorTick};s.x=a%5==0?n.verticalLine.start.x-n.majorTickLength:n.verticalLine.start.x-n.minorTickLength,Zt(e,t,r,s,{color:o,lineWidth:i},"canvas"),a++}},Ol=function(e,t,n){for(var a=0;n.horizontalLine.start.x+a*n.horizontalMinorTick<=n.hscaleBounds.bottomRight.x;){var o=n.color,i=n.lineWidth,r={x:n.horizontalLine.start.x+a*n.horizontalMinorTick,y:n.horizontalLine.start.y},s={x:n.horizontalLine.start.x+a*n.horizontalMinorTick,y:0};s.y=a%5==0?n.horizontalLine.start.y-n.majorTickLength:n.horizontalLine.start.y-n.minorTickLength,Zt(e,t,r,s,{color:o,lineWidth:i},"canvas"),a++}},Ll=function(e,t){var n=O(e,"stack");if(n&&n.data&&n.data.length){var a,o=y.cornerstone;if(n.data.length>1){var i=O(e,"stackRenderer");i&&i.data&&i.data.length&&(a=i.data[0])}var r=n.data[0];t<0&&(t+=r.imageIds.length);var s=js.getStartLoadHandler(e),l=js.getEndLoadHandler(e),c=js.getErrorLoadingHandler(e);if(t!==r.currentImageIdIndex){s&&s(e);var u={newImageIdIndex:t,direction:t-r.currentImageIdIndex};r.currentImageIdIndex=t;var d=r.imageIds[t];(Boolean(r.preventCache)?o.loadImage(d):o.loadAndCacheImage(d)).then((function(i){if(r.currentImageIdIndex===t){try{o.getEnabledElement(e)}catch(e){return}a?(a.currentImageIdIndex=t,a.render(e,n.data)):o.displayImage(e,i),l&&l(e,i)}}),(function(n){var a=r.imageIds[t];c&&c(e,a,n)})),C(e,b.STACK_SCROLL,u)}}},Al=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],a=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],o=O(e,"stack");if(o&&o.data&&o.data.length){var i=o.data[0];i.pending||(i.pending=[]);var r=i.currentImageIdIndex+t;if(n){var s=i.imageIds.length;r%=s}else r=In(r,0,i.imageIds.length-1);if(a)Ll(e,r);else{var l={index:r};i.pending.push(l),Hl(i,l,e)}}};function Hl(e,t,n){if(e.pending[0]===t){if(e.currentImageIdIndex===t.index)return e.pending.splice(e.pending.indexOf(t),1),void(e.pending.length>0&&Hl(e,e.pending[0],n));n.addEventListener(y.cornerstone.EVENTS.NEW_IMAGE,(function a(o){e.imageIds.indexOf(o.detail.image.imageId)===t.index&&(e.pending.splice(e.pending.indexOf(t),1),n.removeEventListener(y.cornerstone.EVENTS.NEW_IMAGE,a),e.pending.length>0&&Hl(e,e.pending[0],n))})),Ll(n,t.index)}}var Rl=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var n={name:"StackScrollMouseWheel",supportedInteractionTypes:["MouseWheel"],configuration:{loop:!1,allowSkipping:!0,invert:!1}};return u()(this,h()(t).call(this,e,n))}return g()(t,e),l()(t,[{key:"mouseWheelCallback",value:function(e){var t=e.detail,n=t.direction,a=t.element,o=this.configuration,i=o.loop,r=o.allowSkipping,s=o.invert;Al(a,s?-n:n,i,r)}}]),t}(ga),Ul=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"StackScrollMultiTouch",supportedInteractionTypes:["MultiTouch"],configuration:{loop:!1,allowSkipping:!0,touchPointers:3}};return(e=u()(this,h()(t).call(this,n,a))).multiTouchDragCallback=e._dragCallback.bind(wa()(e)),e}return g()(t,e),l()(t,[{key:"_dragCallback",value:function(e){var t=e.detail;if(t.numPointers===this.configuration.touchPointers){var n=t.element,a=t.deltaPoints,o=this.configuration,i=o.loop,r=o.allowSkipping,s=Ws(this.name,n),l=this._getPixelPerImage(n),c=this._getDeltaY(n,a.page.y);if(!l)return;if(Math.abs(c)>=l){var u=Math.round(c/l);Al(n,u,i,r),s.deltaY=c%l}else s.deltaY=c;Gs(this.name,n,s)}}},{key:"_getDeltaY",value:function(e,t){return(Ws(this.name,e).deltaY||0)+t}},{key:"_getPixelPerImage",value:function(e){var t=O(e,"stack");if(t&&t.data&&t.data.length){var n=t.data[0];return this.configuration.stackScrollSpeed||Math.max(2,e.offsetHeight/Math.max(n.imageIds.length,8))}}}]),t}(ga),Nl=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"StackScroll",supportedInteractionTypes:["Mouse","Touch"],configuration:{loop:!1,allowSkipping:!0},svgCursor:Uo};return(e=u()(this,h()(t).call(this,n,a))).mouseDragCallback=e._dragCallback.bind(wa()(e)),e.touchDragCallback=e._dragCallback.bind(wa()(e)),e}return g()(t,e),l()(t,[{key:"_dragCallback",value:function(e){var t=e.detail,n=t.element,a=t.deltaPoints,o=this.configuration,i=o.loop,r=o.allowSkipping,s=Ws(this.name,n),l=this._getPixelPerImage(n),c=this._getDeltaY(n,a.page.y);if(l){if(Math.abs(c)>=l){var u=Math.round(c/l);Al(n,u,i,r),s.deltaY=c%l}else s.deltaY=c;Gs(this.name,n,s)}}},{key:"_getDeltaY",value:function(e,t){return(Ws(this.name,e).deltaY||0)+t}},{key:"_getPixelPerImage",value:function(e){var t=O(e,"stack");if(t&&t.data&&t.data.length){var n=t.data[0];return this.configuration.stackScrollSpeed||Math.max(2,e.offsetHeight/Math.max(n.imageIds.length,8))}}}]),t}(ga),Fl=function(e,t,n,a,o){if(!e)throw new Error("getLuminance: parameter element must not be undefined");t=Math.round(t),n=Math.round(n);var i,r,s,l=y.cornerstone.getEnabledElement(e).image,c=[],u=0,d=l.getPixelData();if(l.color)for(r=0;r<o;r++)for(s=0;s<a;s++){var h=d[i=4*((r+n)*l.columns+(s+t))],v=d[i+1],g=d[i+2];c[u++]=.2126*h+.7152*v+.0722*g}else for(r=0;r<o;r++)for(s=0;s<a;s++)i=(r+n)*l.columns+(s+t),c[u++]=d[i]*l.slope+l.intercept;return c},Bl=function(e){function t(){var e,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var a={name:"WwwcRegion",supportedInteractionTypes:["Mouse","Touch"],configuration:{minWindowWidth:10},svgCursor:No};return(e=u()(this,h()(t).call(this,n,a)))._resetHandles(),e.postTouchStartCallback=e._startOutliningRegion.bind(wa()(e)),e.touchDragCallback=e._setHandlesAndUpdate.bind(wa()(e)),e.touchEndCallback=e._applyStrategy.bind(wa()(e)),e.postMouseDownCallback=e._startOutliningRegion.bind(wa()(e)),e.mouseClickCallback=e._startOutliningRegion.bind(wa()(e)),e.mouseDragCallback=e._setHandlesAndUpdate.bind(wa()(e)),e.mouseMoveCallback=e._setHandlesAndUpdate.bind(wa()(e)),e.mouseUpCallback=e._applyStrategy.bind(wa()(e)),e}return g()(t,e),l()(t,[{key:"renderToolData",value:function(e){var t=this,n=e.detail,a=n.element,o=un.getColorIfActive({active:!0}),i=_n(n.canvasContext.canvas);Wt(i,(function(e){kn(e,a,t.handles.start,t.handles.end,{color:o})}))}},{key:"_startOutliningRegion",value:function(e){var t=e.detail.element,n=e.detail.currentPoints.image;return Vl(this.handles.start)?this.handles.start=n:(this.handles.end=n,this._applyStrategy(e)),y.cornerstone.updateImage(t),!0}},{key:"_setHandlesAndUpdate",value:function(e){var t=e.detail.element,n=e.detail.currentPoints.image;this.handles.end=n,y.cornerstone.updateImage(t)}},{key:"_applyStrategy",value:function(e){Vl(this.handles.start)||Vl(this.handles.end)||(e.detail.handles=this.handles,ql(e,this.configuration),this._resetHandles())}},{key:"_resetHandles",value:function(){this.handles={start:{},end:{}}}}]),t}(ga),Vl=function(e){return 0===Object.keys(e).length&&e.constructor===Object},ql=function(e,t){var n=e.detail,a=n.image,o=n.element,i=e.detail.handles,r=i.start,s=i.end,l=Math.min(r.x,s.x),c=Math.min(r.y,s.y),u=Math.abs(r.x-s.x),d=Math.abs(r.y-s.y);l=In(l,0,a.width),c=In(c,0,a.height),u=Math.floor(Math.min(u,Math.abs(a.width-l))),d=Math.floor(Math.min(d,Math.abs(a.height-c)));var h=Fl(o,l,c,u,d),v=jl(h,a.minPixelValue,a.maxPixelValue),g=n.viewport;void 0===t.minWindowWidth&&(t.minWindowWidth=10),g.voi.windowWidth=Math.max(Math.abs(v.max-v.min),t.minWindowWidth),g.voi.windowCenter=v.mean,g.voiLUT=void 0,y.cornerstone.setViewport(o,g),y.cornerstone.updateImage(o)},jl=function(e,t,n){var a=e.length,o=n,i=t,r=0;if(a<2)return{min:o,max:i,mean:(t+n)/2};for(var s=0;s<a;s++){var l=e[s];o=Math.min(o,l),i=Math.max(i,l),r+=l}return{min:o,max:i,mean:r/a}},zl=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var n={name:"Wwwc",strategies:{basicLevelingStrategy:Wl},supportedInteractionTypes:["Mouse","Touch"],configuration:{orientation:0},svgCursor:Fo};return u()(this,h()(t).call(this,e,n))}return g()(t,e),l()(t,[{key:"mouseDragCallback",value:function(e){this.applyActiveStrategy(e),y.cornerstone.setViewport(e.detail.element,e.detail.viewport)}},{key:"touchDragCallback",value:function(e){e.stopImmediatePropagation(),this.applyActiveStrategy(e),y.cornerstone.setViewport(e.detail.element,e.detail.viewport)}}]),t}(ga);function Wl(e){var t=this.configuration.orientation,n=e.detail,a=(n.image.maxPixelValue*n.image.slope+n.image.intercept-(n.image.minPixelValue*n.image.slope+n.image.intercept))/1024,o=n.deltaPoints.page.x*a,i=n.deltaPoints.page.y*a;0===t?(n.viewport.voi.windowWidth+=o,n.viewport.voi.windowCenter+=i):(n.viewport.voi.windowWidth+=i,n.viewport.voi.windowCenter+=o),n.viewport.voiLUT=void 0}var Gl=function(e,t,n){var a=n.maxScale,o=n.minScale,i=Math.log(e.scale)/Math.log(1.7)+t,r=Math.pow(1.7,i);return e.scale=a&&r>a?a:o&&r<o?o:r,e},Yl={changeViewportScale:Gl,correctShift:function(e,t){var n=t.hflip,a=t.vflip,o=t.rotation;if(e.x*=n?-1:1,e.y*=a?-1:1,0!==o){var i=o*Math.PI/180,r=Math.cos(i),s=Math.sin(i),l=e.x*r-e.y*s,c=e.x*s+e.y*r;e.x=l,e.y=c}return e}},Xl=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var n={name:"ZoomMouseWheel",supportedInteractionTypes:["MouseWheel"],configuration:{minScale:.25,maxScale:20,invert:!1}};return u()(this,h()(t).call(this,e,n))}return g()(t,e),l()(t,[{key:"mouseWheelCallback",value:function(e){var t=e.detail,n=t.element,a=t.viewport,o=t.spinY,i=this.configuration,r=i.invert,s=i.maxScale,l=i.minScale,c=Gl(a,r?o/4:-o/4,{maxScale:s,minScale:l});y.cornerstone.setViewport(n,c)}}]),t}(ga),Kl=Yl.correctShift,Zl=Yl.changeViewportScale,$l=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var n={name:"Zoom",strategies:{default:Ql,translate:ec,zoomToCenter:tc},defaultStrategy:"default",supportedInteractionTypes:["Mouse","Touch"],configuration:{invert:!1,preventZoomOutsideImage:!1,minScale:.25,maxScale:20},svgCursor:Bo};return u()(this,h()(t).call(this,e,n))}return g()(t,e),l()(t,[{key:"touchDragCallback",value:function(e){Jl.call(this,e)}},{key:"mouseDragCallback",value:function(e){Jl.call(this,e)}}]),t}(ga),Jl=function(e){if(!e.detail.deltaPoints.page.y)return!1;this.applyActiveStrategy(e,this.configuration),y.cornerstone.setViewport(e.detail.element,e.detail.viewport)};function Ql(e){var t=this.configuration,n=t.invert,a=t.maxScale,o=t.minScale,i=e.detail.deltaPoints.page.y,r=n?-i/100:i/100,s=e.detail,l=s.element,c=s.viewport,u=[e.detail.startPoints.page.x,e.detail.startPoints.page.y,e.detail.startPoints.image.x,e.detail.startPoints.image.y],d=u[0],h=u[1],v=u[2],g=u[3],f=Zl(c,r,{maxScale:a,minScale:o});y.cornerstone.setViewport(l,f);var m=y.cornerstone.pageToPixel(l,d,h),p={x:v-m.x,y:g-m.y};p=Kl(p,f),c.translation.x-=p.x,c.translation.y-=p.y}function ec(e){var t=this.configuration,n=t.invert,a=t.preventZoomOutsideImage,o=t.maxScale,i=t.minScale,r=e.detail.deltaPoints.page.y,s=n?-r/100:r/100,l=e.detail.image,c=e.detail.viewport,u=[e.detail.startPoints.image.x,e.detail.startPoints.image.y],d=u[0],h=u[1],v=Zl(c,s,{maxScale:o,minScale:i}),g={x:0,y:0};if(s<0)v.scale<3&&(Math.abs(v.translation.x)<.01?v.translation.x=0:g.x=v.translation.x/8,Math.abs(v.translation.y)<.01?v.translation.y=0:g.y=v.translation.y/8);else{a&&Mn(e.detail.startPoints.image,l);var f={x:l.width/2-d,y:l.height/2-h};f=Kl(f,v);var m={x:v.translation.x-f.x,y:v.translation.y-f.y};Math.abs(m.x)<.01?v.translation.x=f.x:g.x=m.x/8,Math.abs(m.y)<.01?v.translation.y=f.y:g.y=m.y/8}v.translation.x-=g.x,v.translation.y-=g.y}function tc(e){var t=this.configuration,n=t.invert,a=t.maxScale,o=t.minScale,i=e.detail.deltaPoints.page.y,r=n?-i/100:i/100,s=e.detail.viewport;Zl(s,r,{maxScale:a,minScale:o})}var nc=Yl.correctShift,ac=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r()(this,t);var n={name:"ZoomTouchPinch",supportedInteractionTypes:["TouchPinch"],configuration:{minScale:.25,maxScale:20}};return u()(this,h()(t).call(this,e,n))}return g()(t,e),l()(t,[{key:"touchPinchCallback",value:function(e){var t=e.detail,n=t.element,a=t.viewport,o=t.scaleChange,i=[e.detail.startPoints.page.x,e.detail.startPoints.page.y,e.detail.startPoints.image.x,e.detail.startPoints.image.y],r=i[0],s=i[1],l=i[2],c=i[3],u=this.configuration,d=u.maxScale,h=u.minScale;a.scale+=o*a.scale,d&&a.scale>d?a.scale=d:h&&a.scale<h&&(a.scale=h),y.cornerstone.setViewport(n,a);var v=y.cornerstone.pageToPixel(n,r,s),g={x:l-v.x,y:c-v.y};g=nc(g,a),a.translation.x-=g.x,a.translation.y-=g.y,y.cornerstone.setViewport(n,a)}}]),t}(ga),oc=function(e){return{page:ic(e.page),image:ic(e.image),client:ic(e.client),canvas:ic(e.canvas)}};function ic(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.x,n=e.y;return{x:t,y:n}}var rc,sc=N("eventListeners:mouseEventListeners"),lc=!0,cc=new Map;function uc(e){if("number"==typeof e.buttons)return e.buttons;switch(e.which){case 0:return 0;case 1:return 1;case 2:return 4;case 3:return 2}return 0}function dc(){lc=!1}function hc(e){var t=e.currentTarget,n=y.cornerstone.getEnabledElement(t);if(n.image){var a=b.MOUSE_DOUBLE_CLICK,o={page:y.cornerstoneMath.point.pageToPoint(e),image:y.cornerstone.pageToPixel(t,e.pageX,e.pageY),client:{x:e.clientX,y:e.clientY}};o.canvas=y.cornerstone.pixelToCanvas(t,o.image);var i=oc(o);sc.log("double-click: %o",uc(e)),C(t,a,{event:e,buttons:uc(e),viewport:y.cornerstone.getViewport(t),image:n.image,element:t,startPoints:o,lastPoints:i,currentPoints:o,deltaPoints:{x:0,y:0},type:a})}}function vc(e){var t=e.currentTarget,n=y.cornerstone.getEnabledElement(t);if(n.image){rc=setTimeout(dc,200),t.removeEventListener("mousemove",gc);var a={page:y.cornerstoneMath.point.pageToPoint(e),image:y.cornerstone.pageToPixel(t,e.pageX,e.pageY),client:{x:e.clientX,y:e.clientY}};a.canvas=y.cornerstone.pixelToCanvas(t,a.image);var o=oc(a),i={event:e,buttons:uc(e),viewport:y.cornerstone.getViewport(t),image:n.image,element:t,startPoints:a,lastPoints:o,currentPoints:a,deltaPoints:{x:0,y:0},type:b.MOUSE_DOWN};C(i.element,b.MOUSE_DOWN,i)&&(i.type=b.MOUSE_DOWN_ACTIVATE,C(i.element,b.MOUSE_DOWN_ACTIVATE,i)),document.addEventListener("mousemove",r),document.addEventListener("mouseup",s),cc.set(r,"mousemove"),cc.set(s,"mouseup")}function r(e){var i=b.MOUSE_DRAG,r={page:y.cornerstoneMath.point.pageToPoint(e),image:y.cornerstone.pageToPixel(t,e.pageX,e.pageY),client:{x:e.clientX,y:e.clientY}};r.canvas=y.cornerstone.pixelToCanvas(t,r.image);var s={page:y.cornerstoneMath.point.subtract(r.page,o.page),image:y.cornerstoneMath.point.subtract(r.image,o.image),client:y.cornerstoneMath.point.subtract(r.client,o.client),canvas:y.cornerstoneMath.point.subtract(r.canvas,o.canvas)};sc.log("mousemove: %o",uc(e));var l={buttons:uc(e),viewport:y.cornerstone.getViewport(t),image:n.image,element:t,startPoints:a,lastPoints:o,currentPoints:r,deltaPoints:s,type:i,ctrlKey:e.ctrlKey,metaKey:e.metaKey,shiftKey:e.shiftKey};C(l.element,i,l),o=oc(r)}function s(e){clearTimeout(rc);var i=b.MOUSE_UP;lc&&(i=b.MOUSE_CLICK);var l={page:y.cornerstoneMath.point.pageToPoint(e),image:y.cornerstone.pageToPixel(t,e.pageX,e.pageY),client:{x:e.clientX,y:e.clientY}};l.canvas=y.cornerstone.pixelToCanvas(t,l.image);var c={page:y.cornerstoneMath.point.subtract(l.page,o.page),image:y.cornerstoneMath.point.subtract(l.image,o.image),client:y.cornerstoneMath.point.subtract(l.client,o.client),canvas:y.cornerstoneMath.point.subtract(l.canvas,o.canvas)};sc.log("mouseup: %o",uc(e));var u={event:e,buttons:uc(e),viewport:y.cornerstone.getViewport(t),image:n.image,element:t,startPoints:a,lastPoints:o,currentPoints:l,deltaPoints:c,type:i};C(u.element,i,u),document.removeEventListener("mousemove",r),document.removeEventListener("mouseup",s),cc.delete(r),cc.delete(s),t.addEventListener("mousemove",gc),lc=!0}}function gc(e){var t=e.currentTarget,n=y.cornerstone.getEnabledElement(t);if(n.image){var a=b.MOUSE_MOVE,o={page:y.cornerstoneMath.point.pageToPoint(e),image:y.cornerstone.pageToPixel(t,e.pageX,e.pageY),client:{x:e.clientX,y:e.clientY}};o.canvas=y.cornerstone.pixelToCanvas(t,o.image);var i=oc(o),r={page:y.cornerstoneMath.point.pageToPoint(e),image:y.cornerstone.pageToPixel(t,e.pageX,e.pageY),client:{x:e.clientX,y:e.clientY}};r.canvas=y.cornerstone.pixelToCanvas(t,r.image);var s={page:y.cornerstoneMath.point.subtract(r.page,i.page),image:y.cornerstoneMath.point.subtract(r.image,i.image),client:y.cornerstoneMath.point.subtract(r.client,i.client),canvas:y.cornerstoneMath.point.subtract(r.canvas,i.canvas)};C(t,a,{viewport:y.cornerstone.getViewport(t),image:n.image,element:t,startPoints:o,lastPoints:i,currentPoints:r,deltaPoints:s,type:a}),i=oc(r)}}function fc(e){e.removeEventListener("mousedown",vc),e.removeEventListener("mousemove",gc),e.removeEventListener("dblclick",hc),cc.forEach((function(e,t){document.removeEventListener(e,t)})),cc.clear()}var mc={enable:function(e){fc(e),e.addEventListener("mousedown",vc),e.addEventListener("mousemove",gc),e.addEventListener("dblclick",hc)},disable:fc};function pc(e){var t=e.currentTarget,n=y.cornerstone.getEnabledElement(t);if(n.image&&!(e.deltaY>-1&&e.deltaY<1)){e.preventDefault();var a=e.pageX,o=e.pageY,i=y.cornerstone.pageToPixel(t,a,o),r=function(e){var t=0,n=0,a=0,o=0;return"detail"in e&&(n=e.detail),"wheelDelta"in e&&(n=-e.wheelDelta/120),"wheelDeltaY"in e&&(n=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),a=10*t,o=10*n,"deltaY"in e&&(o=e.deltaY),"deltaX"in e&&(a=e.deltaX),(a||o)&&e.deltaMode&&(1===e.deltaMode?(a*=40,o*=40):(a*=800,o*=800)),a&&!t&&(t=a<1?-1:1),o&&!n&&(n=o<1?-1:1),{spinX:t,spinY:n,pixelX:a,pixelY:o}}(e),s=r.spinX,l=r.spinY,c=r.pixelX,u=r.pixelY,d=l<0?-1:1,h={element:t,viewport:y.cornerstone.getViewport(t),detail:e,image:n.image,direction:d,spinX:s,spinY:l,pixelX:c,pixelY:u,pageX:a,pageY:o,imageX:i.x,imageY:i.y};C(t,b.MOUSE_WHEEL,h)}}function yc(e){e.removeEventListener("wheel",pc,{passive:!1})}var xc,Tc,bc={enable:function(e){yc(e),e.addEventListener("wheel",pc,{passive:!1})},disable:yc},Cc=0,Mc=1;function Ec(e,t){var n=Date.now();if(e!==xc){if(n-Tc<=2e3)return t.preventDefault(),t.stopPropagation(),t.stopImmediatePropagation(),!1;xc=e}Tc=n}var wc=Ec.bind(null,Cc),Ic=Ec.bind(null,Mc);function Sc(e,t,n){var a=n?wc:Ic;t.forEach((function(t){e.addEventListener(t,a,{passive:!1})}))}function kc(e,t,n){var a=n?wc:Ic;t.forEach((function(t){e.removeEventListener(t,a)}))}var _c=["mousedown","mouseup"],Pc=["touchstart","touchend"];function Dc(e){kc(e,_c,Cc),kc(e,Pc,Mc)}var Oc,Lc,Ac,Hc,Rc,Uc,Nc,Fc,Bc,Vc={enable:function(e){Dc(e),Sc(e,_c,Cc),Sc(e,Pc,Mc)},disable:Dc},qc=1,jc=0,zc=!1,Wc=!1;function Gc(e){var t=e.currentTarget||e.srcEvent.currentTarget,n=y.cornerstone.getEnabledElement(t);if(n.image){var a,o,i,r;switch(e.preventDefault(),(e.pointers&&e.pointers.length>1||e.touches&&e.touches.length>1)&&(Wc=!1,clearTimeout(Nc)),e.type){case"tap":Wc=!1,clearTimeout(Nc),(Lc={page:y.cornerstoneMath.point.pageToPoint(e.pointers[0]),image:y.cornerstone.pageToPixel(t,e.pointers[0].pageX,e.pointers[0].pageY),client:{x:e.pointers[0].clientX,y:e.pointers[0].clientY}}).canvas=y.cornerstone.pixelToCanvas(t,Lc.image),a=b.TAP,Rc={event:e,viewport:y.cornerstone.getViewport(t),image:n.image,element:t,currentPoints:Lc,type:a,isTouchEvent:!0},C(t,a,Rc);break;case"doubletap":Wc=!1,clearTimeout(Nc),(Lc={page:y.cornerstoneMath.point.pageToPoint(e.pointers[0]),image:y.cornerstone.pageToPixel(t,e.pointers[0].pageX,e.pointers[0].pageY),client:{x:e.pointers[0].clientX,y:e.pointers[0].clientY}}).canvas=y.cornerstone.pixelToCanvas(t,Lc.image),a=b.DOUBLE_TAP,Rc={event:e,viewport:y.cornerstone.getViewport(t),image:n.image,element:t,currentPoints:Lc,type:a,isTouchEvent:!0},C(t,a,Rc);break;case"pinchstart":Wc=!1,clearTimeout(Nc),qc=1;break;case"pinchmove":if(Wc=!1,clearTimeout(Nc),!0===zc){qc=e.scale,zc=!1;break}o=(e.scale-qc)/qc,(Oc={page:e.center,image:y.cornerstone.pageToPixel(t,e.center.x,e.center.y)}).canvas=y.cornerstone.pixelToCanvas(t,Oc.image),a=b.TOUCH_PINCH,Rc={event:e,startPoints:Oc,viewport:y.cornerstone.getViewport(t),image:n.image,element:t,direction:e.scale<1?1:-1,scaleChange:o,type:a,isTouchEvent:!0},C(t,a,Rc),qc=e.scale;break;case"touchstart":qc=1,clearTimeout(Nc),clearTimeout(Uc),Uc=setTimeout((function(){(Oc={page:y.cornerstoneMath.point.pageToPoint(e.touches[0]),image:y.cornerstone.pageToPixel(t,e.touches[0].pageX,e.touches[0].pageY),client:{x:e.touches[0].clientX,y:e.touches[0].clientY}}).canvas=y.cornerstone.pixelToCanvas(t,Oc.image),a=b.TOUCH_START,e.touches.length>1&&(a=b.MULTI_TOUCH_START),Rc={event:e,viewport:y.cornerstone.getViewport(t),image:n.image,element:t,startPoints:Oc,currentPoints:Oc,type:a,isTouchEvent:!0},!0===C(t,a,Rc)&&(a=b.TOUCH_START_ACTIVE,e.touches.length>1&&(a=b.MULTI_TOUCH_START_ACTIVE),Rc.type=a,C(t,a,Rc)),Ac=oc(Oc)}),50),Wc=!0,Fc=0,Nc=setTimeout((function(){Wc&&((Lc={page:y.cornerstoneMath.point.pageToPoint(e.touches[0]),image:y.cornerstone.pageToPixel(t,e.touches[0].pageX,e.touches[0].pageY),client:{x:e.touches[0].clientX,y:e.touches[0].clientY}}).canvas=y.cornerstone.pixelToCanvas(t,Oc.image),a=b.TOUCH_PRESS,Rc={event:e,viewport:y.cornerstone.getViewport(t),image:n.image,element:t,currentPoints:Lc,type:a,isTouchEvent:!0},C(t,a,Rc))}),700);break;case"touchend":qc=1,Wc=!1,clearTimeout(Nc),setTimeout((function(){(Oc={page:y.cornerstoneMath.point.pageToPoint(e.changedTouches[0]),image:y.cornerstone.pageToPixel(t,e.changedTouches[0].pageX,e.changedTouches[0].pageY),client:{x:e.changedTouches[0].clientX,y:e.changedTouches[0].clientY}}).canvas=y.cornerstone.pixelToCanvas(t,Oc.image),a=b.TOUCH_END,Rc={event:e,viewport:y.cornerstone.getViewport(t),image:n.image,element:t,startPoints:Oc,currentPoints:Oc,type:a,isTouchEvent:!0},C(t,a,Rc)}),50);break;case"panmove":i={x:e.deltaX-Bc.x,y:e.deltaY-Bc.y},Bc={x:e.deltaX,y:e.deltaY},(Lc={page:{x:Ac.page.x+i.x,y:Ac.page.y+i.y},image:y.cornerstone.pageToPixel(t,Ac.page.x+i.x,Ac.page.y+i.y),client:{x:Ac.client.x+i.x,y:Ac.client.y+i.y}}).canvas=y.cornerstone.pixelToCanvas(t,Lc.image),Hc={page:y.cornerstoneMath.point.subtract(Lc.page,Ac.page),image:y.cornerstoneMath.point.subtract(Lc.image,Ac.image),client:y.cornerstoneMath.point.subtract(Lc.client,Ac.client),canvas:y.cornerstoneMath.point.subtract(Lc.canvas,Ac.canvas)},(Fc+=Math.sqrt(Hc.page.x*Hc.page.x+Hc.page.y*Hc.page.y))>5&&(Wc=!1,clearTimeout(Nc)),a=b.TOUCH_DRAG,e.pointers.length>1&&(a=b.MULTI_TOUCH_DRAG),Rc={viewport:y.cornerstone.getViewport(t),image:n.image,element:t,startPoints:Oc,lastPoints:Ac,currentPoints:Lc,deltaPoints:Hc,numPointers:e.pointers.length,type:a,isTouchEvent:!0},C(t,a,Rc),Ac=oc(Lc);break;case"panstart":Bc={x:e.deltaX,y:e.deltaY},(Lc={page:y.cornerstoneMath.point.pageToPoint(e.pointers[0]),image:y.cornerstone.pageToPixel(t,e.pointers[0].pageX,e.pointers[0].pageY),client:{x:e.pointers[0].clientX,y:e.pointers[0].clientY}}).canvas=y.cornerstone.pixelToCanvas(t,Lc.image),Ac=oc(Lc);break;case"panend":if(Wc=!1,clearTimeout(Nc),!Ac)return!1;(Lc={page:y.cornerstoneMath.point.pageToPoint(e.pointers[0]),image:y.cornerstone.pageToPixel(t,e.pointers[0].pageX,e.pointers[0].pageY),client:{x:e.pointers[0].clientX,y:e.pointers[0].clientY}}).canvas=y.cornerstone.pixelToCanvas(t,Lc.image),Hc={page:y.cornerstoneMath.point.subtract(Lc.page,Ac.page),image:y.cornerstoneMath.point.subtract(Lc.image,Ac.image),client:y.cornerstoneMath.point.subtract(Lc.client,Ac.client),canvas:y.cornerstoneMath.point.subtract(Lc.canvas,Ac.canvas)},a=b.TOUCH_DRAG_END,Rc={event:e.srcEvent,viewport:y.cornerstone.getViewport(t),image:n.image,element:t,startPoints:Oc,lastPoints:Ac,currentPoints:Lc,deltaPoints:Hc,type:a,isTouchEvent:!0},C(t,a,Rc),2===e.pointers.length-e.changedPointers.length&&(zc=!0);break;case"rotatemove":Wc=!1,clearTimeout(Nc),r=e.rotation-jc,jc=e.rotation,a=b.TOUCH_ROTATE,Rc={event:e.srcEvent,viewport:y.cornerstone.getViewport(t),image:n.image,element:t,rotation:r,type:a},C(t,a,Rc)}return!1}}function Yc(e){Vc.disable(e);["touchstart","touchend"].forEach((function(t){e.removeEventListener(t,Gc)}));var t=Ws("touchInput",e),n=t.hammer;n&&(n.off("tap doubletap panstart panmove panend pinchstart pinchmove rotatemove",Gc),n.input.destroy()),t.hammer=null,function(e,t){var n=zs[e];n&&(zs[e]=n.filter((function(e){return e.element!==t})))}("touchInput",e)}var Xc={enable:function(e){Yc(e);var t=y.Hammer,n={inputClass:t.SUPPORT_POINTER_EVENTS?t.PointerEventInput:t.TouchInput},a=new t.Manager(e,n),o={pointers:0,direction:t.DIRECTION_ALL,threshold:0},i=new t.Pan(o),r=new t.Pinch({threshold:0}),s=new t.Rotate({threshold:0});r.recognizeWith(i),r.recognizeWith(s),s.recognizeWith(i);var l=new t.Tap({event:"doubletap",taps:2,interval:1500,threshold:50,posThreshold:50});l.recognizeWith(i),a.add([l,i,s,r]),a.on("tap doubletap panstart panmove panend pinchstart pinchmove rotatemove",Gc),Vc.enable(e),["touchstart","touchend"].forEach((function(t){e.addEventListener(t,Gc,{passive:!1})}));var c=Ws("touchInput",e);c.hammer=a,Gs("touchInput",e,c)},disable:Yc},Kc=Tt("segmentation");function Zc(e,t,n,a,o){!function(e,t,n){var a=Kc.configuration,o=e.detail,i=o.canvasContext,r=o.element,s=o.image,l=o.viewport,c=i.getTransform(),u=_n(i.canvas),d=y.cornerstone.pixelToCanvas(r,{x:0,y:0}),h=y.cornerstone.pixelToCanvas(r,{x:s.width,y:0}),v=y.cornerstone.pixelToCanvas(r,{x:s.width,y:s.height}),g=y.cornerstoneMath.point.distance(d,h),f=y.cornerstoneMath.point.distance(h,v),m=i.canvas,p=u.imageSmoothingEnabled,x=u.globalAlpha;u.imageSmoothingEnabled=!1,u.globalAlpha=n?a.fillAlpha:a.fillAlphaInactive,function(e,t,n){if(n.hflip||n.vflip||n.rotation){var a={x:t.width/2+n.translation.x*n.scale,y:t.height/2+n.translation.y*n.scale};e.translate(a.x,a.y),n.rotation&&e.rotate(n.rotation*Math.PI/180),n.vflip&&e.scale(1,-1),n.hflip&&e.scale(-1,1),e.translate(-a.x,-a.y)}}(u,m,l);var T=function(e){var t=e.viewport,n=e.image,a=t.scale,o=t.scale;n.rowPixelSpacing<n.columnPixelSpacing?a*=n.columnPixelSpacing/n.rowPixelSpacing:n.columnPixelSpacing<n.rowPixelSpacing&&(o*=n.rowPixelSpacing/n.columnPixelSpacing);return{x:t.translation.x*a,y:t.translation.y*o}}(o);u.drawImage(t,m.width/2-g/2+T.x,m.height/2-f/2+T.y,g,f),u.globalAlpha=x,u.imageSmoothingEnabled=p,u.setTransform(c)}(e,function(e,t,n){var a=Kc.state,o=e.detail.image,i=o.width,r=o.height,s=t.segmentsHidden,l=n.pixelData,c=a.colorLutTables[t.colorLUTIndex],u=document.createElement("canvas");u.width=i,u.height=r;for(var d=_n(u),h=new ImageData(i,r),v=h.data,g=0;g<l.length;g++){var f=l[g];if(0!==f&&!s[f]){var m=c[l[g]];v[4*g]=m[0],v[4*g+1]=m[1],v[4*g+2]=m[2],v[4*g+3]=m[3]}}return d.putImageData(h,0,0),u}(e,t,n),o)}var $c=Tt("segmentation");function Jc(e,t,n,a,o){!function(e,t,n){var a=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],o=$c.configuration,i=$c.state,r=e.detail,s=r.element,l=r.canvasContext,c=o.outlineWidth||1,u=l.getTransform(),d=_n(l.canvas),h=i.colorLutTables[n],v=d.globalAlpha;d.globalAlpha=a?o.outlineAlpha:o.outlineAlphaInactive,Wt(d,(function(e){for(var n=1;n<t.length;n++)if(t[n]){var a=h[n];hn(e,s,t[n],{color:"rgba(".concat(a[0],", ").concat(a[1],", ").concat(a[2],", 1.0 )"),lineWidth:c},"canvas")}})),d.globalAlpha=v,d.setTransform(u)}(e,function(e,t,n,a){var o=e.detail,i=o.element,r=o.image,s=o.viewport,l=r.width,c=r.height;a=a||1;var u=t.segmentsHidden,d=n.pixelData,h=t.activeSegmentIndex,v=[];n.segmentsOnLabelmap.forEach((function(e){!u[e]&&(v[e]=[])})),v[h]||(v[h]=[]);for(var g=function(e,t){var n=t/2,a=e.rotation;a*=Math.PI/180;var o=Math.cos(a),i=Math.sin(a),r=[o,i],s=[-i,o],l={x:n*r[0],y:n*r[1]},c={x:n*s[0],y:n*s[1]};e.hflip&&(l.x*=-1,l.y*=-1);e.vflip&&(c.x*=-1,c.y*=-1);return{i:l,j:c}}(s,a),f=0;f<d.length;f++){var m=d[f];if(0!==m)if(!u[m]){var p={x:(x=f)%l,y:Math.floor(x/l)},y=Qc(p,c,l);void 0!==y.top&&d[y.top]===m||ou(v[m],i,p,g),void 0!==y.bottom&&d[y.bottom]===m||iu(v[m],i,p,g),void 0!==y.left&&d[y.left]===m||ru(v[m],i,p,g),void 0!==y.right&&d[y.right]===m||su(v[m],i,p,g),void 0!==y.topLeft&&d[y.topLeft]!==m&&d[y.top]===m&&d[y.left]===m&&eu(v[m],i,p,g),void 0!==y.topRight&&d[y.topRight]!==m&&d[y.top]===m&&d[y.right]===m&&tu(v[m],i,p,g),void 0!==y.bottomLeft&&d[y.bottomLeft]!==m&&d[y.bottom]===m&&d[y.left]===m&&nu(v[m],i,p,g),void 0!==y.bottomRight&&d[y.bottomRight]!==m&&d[y.bottom]===m&&d[y.right]===m&&au(v[m],i,p,g)}}var x;return v}(e,t,n,$c.configuration.outlineWidth),t.colorLUTIndex,o)}function Qc(e,t,n){var a=e.y*n+e.x,o={},i=e.y-1>=0,r=e.y+1<t,s=e.x-1>=0,l=e.x+1<n;return i&&(o.top=a-n,l&&(o.topRight=o.top+1),s&&(o.topLeft=o.top-1)),r&&(o.bottom=a+n,l&&(o.bottomRight=o.bottom+1),s&&(o.bottomLeft=o.bottom-1)),s&&(o.left=a-1),l&&(o.right=a+1),o}function eu(e,t,n,a){var o=(0,y.cornerstone.pixelToCanvas)(t,n);o.x+=a.j.x,o.y+=a.j.y;var i={x:o.x,y:o.y};i.x+=2*a.i.x,i.y+=2*a.i.y,e.push({start:o,end:i})}function tu(e,t,n,a){var o=(0,y.cornerstone.pixelToCanvas)(t,{x:n.x+1,y:n.y});o.x+=a.j.x,o.y+=a.j.y;var i={x:o.x,y:o.y};i.x-=2*a.i.x,i.y-=2*a.i.y,e.push({start:o,end:i})}function nu(e,t,n,a){var o=(0,y.cornerstone.pixelToCanvas)(t,{x:n.x,y:n.y+1});o.x-=a.j.x,o.y-=a.j.y;var i={x:o.x,y:o.y};i.x+=2*a.i.x,i.y+=2*a.i.y,e.push({start:o,end:i})}function au(e,t,n,a){var o=(0,y.cornerstone.pixelToCanvas)(t,{x:n.x+1,y:n.y+1});o.x-=a.j.x,o.y-=a.j.y;var i={x:o.x,y:o.y};i.x-=2*a.i.x,i.y-=2*a.i.y,e.push({start:o,end:i})}function ou(e,t,n,a){var o=y.cornerstone.pixelToCanvas,i=o(t,n),r=o(t,{x:n.x+1,y:n.y});i.x+=a.j.x,i.y+=a.j.y,r.x+=a.j.x,r.y+=a.j.y,e.push({start:i,end:r})}function iu(e,t,n,a){var o=y.cornerstone.pixelToCanvas,i=o(t,{x:n.x,y:n.y+1}),r=o(t,{x:n.x+1,y:n.y+1});i.x-=a.j.x,i.y-=a.j.y,r.x-=a.j.x,r.y-=a.j.y,e.push({start:i,end:r})}function ru(e,t,n,a){var o=y.cornerstone.pixelToCanvas,i=o(t,n),r=o(t,{x:n.x,y:n.y+1});i.x+=a.i.x,i.y+=a.i.y,r.x+=a.i.x,r.y+=a.i.y,e.push({start:i,end:r})}function su(e,t,n,a){var o=y.cornerstone.pixelToCanvas,i=o(t,{x:n.x+1,y:n.y}),r=o(t,{x:n.x+1,y:n.y+1});i.x-=a.i.x,i.y-=a.i.y,r.x-=a.i.x,r.y-=a.i.y,e.push({start:i,end:r})}var lu=Tt("segmentation");function cu(e,t,n,a,o){(function(e){var t=lu.configuration;return t.renderFill&&(e&&0!==t.fillAlpha||!e&&0!==t.fillAlphaInactive)})(o)&&Zc(e,t,a,0,o),function(e){var t=lu.configuration;return t.renderOutline&&(e&&0!==t.outlineAlpha||!e&&0!==t.outlineAlphaInactive)}(o)&&Jc(e,t,a,0,o)}var uu=Tt("segmentation"),du=function(e){var t=e.detail.element,n=uu.configuration,a=uu.getters.labelmaps3D(t),o=a.activeLabelmapIndex,i=a.labelmaps3D,r=a.currentImageIdIndex;i&&(n.shouldRenderInactiveLabelmaps&&function(e,t,n,a){for(var o=0;o<t.length;o++){var i=t[o];if(o!==n&&i){var r=i.labelmaps2D[a];r&&cu(e,i,0,r,!1)}}}(e,i,o,r),function(e,t,n,a){var o=t[n];if(!o)return;var i=o.labelmaps2D[a];i&&cu(e,o,0,i,!0)}(e,i,o,r))};var hu=Tt("segmentation"),vu=function(e){var t=e.detail,n=t.element,a=pt.tools.filter((function(e){return e.element===n&&("active"===e.mode||"passive"===e.mode||"enabled"===e.mode)})),o=O(n,"stack"),i=hu.configuration;o&&(i.renderFill||i.renderOutline)&&du(e);var r=t.canvasContext.canvas.getContext("2d");a.forEach((function(t){t.renderToolData&&(r.save(),t.renderToolData(e),r.restore())}))},gu=function(e){e.addEventListener(y.cornerstone.EVENTS.IMAGE_RENDERED,vu)},fu=function(e){e.removeEventListener(y.cornerstone.EVENTS.IMAGE_RENDERED,vu)},mu=function(e,t,n){if(pt.isToolLocked)return!1;var a=n.detail.element,o=pt.tools.filter((function(t){return t.supportedInteractionTypes.includes(e)}));if(o=(o=Ma(a,o,e)).filter((function(e){return"function"==typeof e[t]})),pt.isMultiPartToolActive&&(o=_a(o)),0===o.length)return!1;o[0][t](n)},pu=function(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"mouse";return t.filter((function(t){for(var o=so(a,t.name),i=O(e,t.name),r=0;r<i.data.length;r++)if(void 0!==pa(e,i.data[r].handles,n,o))return!0;return!1}))},yu=function(e,t){return t.filter((function(t){return t.element===e&&("active"===t.mode||"passive"===t.mode)}))},xu=function(e,t){return t.filter((function(t){var n=O(e,t.name);return n&&n.data.length>0}))},Tu=function(e){if(!pt.isToolLocked){var t=e.detail,n=e.detail.element,a=e.detail.currentPoints.canvas,o=yu(n,yt.mouseTools()),i=o.filter((function(e){return"active"===e.mode&&Array.isArray(e.options.mouseButtonMask)&&e.options.mouseButtonMask.includes(t.buttons)&&e.options.isMouseActive}));if(pt.isMultiPartToolActive&&(i=_a(i)),i.length>0){var r=i.find((function(e){return"function"==typeof e.preMouseDownCallback}));if(r)if(r.preMouseDownCallback(e))return}if(!pt.isMultiPartToolActive){var s=xu(n,o),l=pu(n,s,a,"mouse");if(l.length>0){var c=l[0],u=O(n,c.name),d=ho(n,u,c.name,a),h=d.handle,v=d.data;c.handleSelectedCallback(e,v,h,"mouse")}else{var g=o.filter((function(e){var t=O(n,e.name);return t&&t.data&&e.pointNearTool&&t.data.some((function(t){return e.pointNearTool(n,t,a,"mouse")}))}));if(g.length>0){var f=g[0],m=O(n,f.name).data.find((function(e){return f.pointNearTool(n,e,a)}));f.toolSelectedCallback(e,m,"mouse")}else if(i.length>0){var p=i.find((function(e){return"function"==typeof e.postMouseDownCallback}));if(p)if(p.postMouseDownCallback(e))return}}}}},bu=N("eventDispatchers:mouseEventHandlers"),Cu=function(e){if(!pt.isToolLocked){var t=e.detail,n=Pa(t.element,t.buttons,"mouse");if(n){if("function"==typeof n.preMouseDownActivateCallback)if(n.preMouseDownActivateCallback(e))return;pt.isMultiPartToolActive||(n.addNewMeasurement?n.addNewMeasurement(e,"mouse"):n instanceof fo&&function(e,t){bu.log("addNewMeasurement"),e.preventDefault(),e.stopPropagation();var n=e.detail,a=n.element,o=t.createNewMeasurement(n);if(o){D(a,t.name,o),y.cornerstone.updateImage(a);var i=1===Object.keys(o.handles).length?Wa:to,r=(new Date).getTime();i(n,t.name,o,o.handles.end,t.options,"mouse",(function(e){if(!o.cancelled){var n=!!(t.configuration&&Object(t.configuration).hasOwnProperty("measurementCreationThreshold"))&&(new Date).getTime()-r<t.configuration.measurementCreationThreshold;if(e&&!1===n){var i=b.MEASUREMENT_COMPLETED,s={toolName:t.name,toolType:t.name,element:a,measurementData:o};C(a,i,s)}else L(a,t.name,o)}}))}}(e,n))}}},Mu=function(e){if(!pt.isToolLocked){var t,n=e.detail,a=n.element;if(t=(t=(t=Ma(a,yt.mouseTools())).filter((function(e){return Array.isArray(e.options.mouseButtonMask)&&e.options.mouseButtonMask.includes(n.buttons)&&e.options.isMouseActive}))).filter((function(e){return"function"==typeof e.mouseDragCallback})),pt.isMultiPartToolActive&&(t=_a(t)),0!==t.length)t[0].mouseDragCallback(e)}},Eu=function(e){if(!pt.isToolLocked&&!pt.isMultiPartToolActive){var t,n=e.detail,a=n.element,o=n.currentPoints;pt.mousePositionImage=o.image;var i=(t=yu(a,yt.mouseTools())).filter((function(e){return"active"===e.mode&&e.options.isMouseActive})),r=!1;i.length>0&&(r=i.some((function(e){return e.updateOnMouseMove}))),t=xu(a,t);for(var s=0;s<t.length;s++){var l=t[s];"function"==typeof l.mouseMoveCallback&&(r=l.mouseMoveCallback(e)||r)}!0===r&&y.cornerstone.updateImage(a)}},wu=mu.bind(null,"Mouse","mouseClickCallback"),Iu=mu.bind(null,"Mouse","doubleClickCallback"),Su=mu.bind(null,"Mouse","mouseUpCallback"),ku=mu.bind(null,"MouseWheel","mouseWheelCallback"),_u=function(e){e.addEventListener(b.MOUSE_CLICK,wu),e.addEventListener(b.MOUSE_DOWN,Tu),e.addEventListener(b.MOUSE_DOWN_ACTIVATE,Cu),e.addEventListener(b.MOUSE_DOUBLE_CLICK,Iu),e.addEventListener(b.MOUSE_DRAG,Mu),e.addEventListener(b.MOUSE_MOVE,Eu),e.addEventListener(b.MOUSE_UP,Su),e.addEventListener(b.MOUSE_WHEEL,ku)},Pu=function(e){e.removeEventListener(b.MOUSE_CLICK,wu),e.removeEventListener(b.MOUSE_DOWN,Tu),e.removeEventListener(b.MOUSE_DOWN_ACTIVATE,Cu),e.removeEventListener(b.MOUSE_DOUBLE_CLICK,Iu),e.removeEventListener(b.MOUSE_DRAG,Mu),e.removeEventListener(b.MOUSE_MOVE,Eu),e.removeEventListener(b.MOUSE_UP,Su),e.removeEventListener(b.MOUSE_WHEEL,ku)},Du=function(e){if(pt.isToolLocked)return!1;var t=e.detail.element,n=pt.tools.filter((function(e){return e.element===t&&("active"===e.mode||"passive"===e.mode||"enabled"===e.mode)}));if(0===n.length)return!1;n.forEach((function(t){t.newImageCallback&&t.newImageCallback(e)}))},Ou=function(e){e.addEventListener(y.cornerstone.EVENTS.NEW_IMAGE,Du)},Lu=function(e){e.removeEventListener(y.cornerstone.EVENTS.NEW_IMAGE,Du)},Au=function(e){if(pt.isToolLocked)return!1;var t=e.detail,n=t.element,a=t.numPointers,o=pt.tools.filter((function(e){return e.supportedInteractionTypes.includes("MultiTouch")}));if(o=(o=Ma(n,o,"MultiTouch")).filter((function(e){return"function"==typeof e.multiTouchDragCallback&&a===e.configuration.touchPointers})),pt.isMultiPartToolActive&&(o=_a(o)),0===o.length)return!1;o[0].multiTouchDragCallback(e)},Hu=N("eventDispatchers:touchEventHandlers"),Ru=function(e){if(!pt.isToolLocked&&!pt.isMultiPartToolActive){var t=Pa(e.detail.element,null,"touch");t&&t.addNewMeasurement?t.addNewMeasurement(e,"touch"):t instanceof fo&&function(e,t){Hu.log("addNewMeasurement"),e.preventDefault(),e.stopPropagation();var n=e.detail,a=n.element,o=t.createNewMeasurement(n);if(o){if(D(a,t.name,o),1===Object.keys(o.handles).length&&n.type===b.TAP)return o.active=!1,o.handles.end.active=!1,o.handles.end.highlight=!1,o.invalidated=!0,(pt.deleteIfHandleOutsideImage||t.options.deleteIfHandleOutsideImage)&&ba(n,o.handles)&&L(a,t.name,o),void y.cornerstone.updateImage(a);y.cornerstone.updateImage(a),to(n,t.name,o,o.handles.end,t.options,"touch",(function(){var e=b.MEASUREMENT_COMPLETED,n={toolName:t.name,toolType:t.name,element:a,measurementData:o};C(a,e,n)}))}}(e,t)}},Uu=function(e){if(e)for(var t=0;t<e.data.length;t++){var n=e.data[t];n.active=!1,n.handles&&Nu(n.handles)}};function Nu(e){Object.keys(e).forEach((function(t){e[t].active=!1}))}var Fu=function(e){if(!pt.isToolLocked&&!pt.isMultiPartToolActive){var t,n=e.detail.element,a=e.detail.currentPoints.canvas;t=Ma(n,yt.touchTools());var o=(t=xu(n,t)).filter((function(e){for(var t=O(n,e.name),o=0;o<t.data.length;o++)if(void 0!==pa(n,t.data[o].handles,a,28))return!0;return!1}));if(o.length>0){var i=o[0],r=O(n,i.name),s=r.data.find((function(e){return void 0!==pa(n,e.handles,a,28)}));return r.data.active=!0,s.active=!0,y.cornerstone.updateImage(n),Wa(e.detail,i.name,r.data,s,i.options,"touch",(function(){return Uu(r)})),e.stopImmediatePropagation(),void e.preventDefault()}var l=t.filter((function(e){var t=O(n,e.name);return t&&t.data&&e.pointNearTool&&t.data.some((function(t){return e.pointNearTool(n,t,a)}))}));if(l.length>0){var c=l[0],u=O(n,c.name),d=u.data.find((function(e){return c.pointNearTool(n,e,a)}));return d.active=!0,y.cornerstone.updateImage(n),Ha(e.detail,c.name,d,null,c.options,"touch",(function(){return Uu(u)})),e.stopImmediatePropagation(),void e.preventDefault()}var h=Ma(n,yt.touchTools());return h.length>0&&h[0].touchStartActiveCallback?h[0].touchStartActiveCallback(e):Ru(e),!1}},Bu=function(e){if(!pt.isToolLocked){var t=e.detail,n=t.element,a=t.startPoints.canvas,o=yu(n,yt.touchTools()),i=o.filter((function(e){return"active"===e.mode&&e.options.isTouchActive}));if(pt.isMultiPartToolActive&&(i=_a(i)),i.length>0){var r=i.find((function(e){return"function"==typeof e.preTouchStartCallback}));if(r)if(r.preTouchStartCallback(e))return}if(!pt.isMultiPartToolActive){var s=xu(n,o),l=pu(n,s,a,"touch");if(l.length>0){var c=l[0],u=O(n,c.name),d=ho(n,u,c.name,a,"touch"),h=d.handle,v=d.data;c.handleSelectedCallback(e,v,h,"touch")}else{var g=s.filter((function(e){var t=O(n,e.name);return t&&t.data&&e.pointNearTool&&t.data.some((function(t){return e.pointNearTool(n,t,a,"touch")}))}));if(g.length>0){var f=g[0],m=O(n,f.name).data.find((function(e){return f.pointNearTool(n,e,a)}));f.toolSelectedCallback(e,m,"touch")}else if(i.length>0){var p=i.find((function(e){return"function"==typeof e.postTouchStartCallback}));if(p)if(p.postTouchStartCallback(e))return}}}}},Vu=mu.bind(null,"DoubleTap","doubleTapCallback"),qu=mu.bind(null,"Touch","touchDragCallback"),ju=mu.bind(null,"Touch","touchEndCallback"),zu=mu.bind(null,"TouchPinch","touchPinchCallback"),Wu=mu.bind(null,"Touch","touchPressCallback"),Gu=mu.bind(null,"TouchRotate","touchRotateCallback"),Yu=function(e){e.addEventListener(b.TAP,Fu),e.addEventListener(b.TOUCH_START,Bu,{passive:!1}),e.addEventListener(b.TOUCH_DRAG,qu,{passive:!1}),e.addEventListener(b.TOUCH_END,ju),e.addEventListener(b.TOUCH_START_ACTIVE,Ru),e.addEventListener(b.TOUCH_PRESS,Wu),e.addEventListener(b.DOUBLE_TAP,Vu),e.addEventListener(b.TOUCH_PINCH,zu),e.addEventListener(b.TOUCH_ROTATE,Gu),e.addEventListener(b.MULTI_TOUCH_DRAG,Au)},Xu=function(e){e.removeEventListener(b.TAP,Fu),e.removeEventListener(b.TOUCH_START,Bu),e.removeEventListener(b.TOUCH_DRAG,qu),e.removeEventListener(b.TOUCH_END,ju),e.removeEventListener(b.TOUCH_START_ACTIVE,Ru),e.removeEventListener(b.TOUCH_PRESS,Wu),e.removeEventListener(b.DOUBLE_TAP,Vu),e.removeEventListener(b.TOUCH_PINCH,zu),e.removeEventListener(b.TOUCH_ROTATE,Gu),e.removeEventListener(b.MULTI_TOUCH_DRAG,Au)},Ku=N("addTool"),Zu=function(e,t,n){var a=new t(n);Ct(e,a.name)?Ku.warn("%s has already been added to the target element",a.name):(a.element=e,bt.state.tools.push(a))},$u=function(e,t){Ju(e,t),bt.state.enabledElements.forEach((function(n){Zu(n,e,t)}))},Ju=function(e,t){if(Tt("globalConfiguration").configuration.globalToolSyncEnabled){var n=new e(t);void 0!==bt.state.globalTools[n.name]?Ku.warn("%s has already been added globally",n.name):bt.state.globalTools[n.name]={tool:e,props:t,activeBindings:[]}}},Qu=N("internals:addEnabledElement"),ed=function(e){Qu.log("EVENT:ELEMENT_ENABLED");var t=e.detail.element;gu(t),Ou(t);var n=Tt("globalConfiguration").configuration;n.mouseEnabled&&(mc.enable(t),bc.enable(t),_u(t)),n.touchEnabled&&(Xc.enable(t),Yu(t)),td(t)},td=function(e){bt.state.enabledElements.push(e),bt.modules&&function(e){var t=bt.modules;Object.keys(t).forEach((function(n){"function"==typeof t[n].enabledElementCallback&&t[n].enabledElementCallback(e)}))}(e),function(e){if(!Tt("globalConfiguration").configuration.globalToolSyncEnabled)return;Object.keys(bt.state.globalTools).forEach((function(t){var n=bt.state.globalTools[t],a=n.tool,o=n.props;Zu(e,a,o)}))}(e),function(e){if(!Tt("globalConfiguration").configuration.globalToolSyncEnabled)return;var t={active:_t,passive:Ht,enabled:Lt,disabled:Dt};bt.state.globalToolChangeHistory.forEach((function(n){var a=n.args.slice(0);a.unshift(e),t[n.mode].apply(null,a)}))}(e)};var nd=N("internals:removeEnabledElement"),ad=function(e){nd.log("EVENT:ELEMENT_DISABLED");var t=e.detail.element,n=Tt("globalConfiguration").configuration;fu(t),Lu(t),n.mouseEnabled&&(mc.disable(t),bc.disable(t),Pu(t)),n.touchEnabled&&(Xc.disable(t),Xu(t)),od(t),id(t),rd(t)},od=function(e){bt.state.tools.forEach((function(t){t.element===e&&Dt(t.element,t.name)})),bt.state.tools=bt.state.tools.filter((function(t){return t.element!==e}))},id=function(e){bt.modules&&function(e){var t=bt.modules;Object.keys(t).forEach((function(n){"function"==typeof t[n].removeEnabledElementCallback&&t[n].removeEnabledElementCallback(e)}))}(e);var t=bt.state.enabledElements.findIndex((function(t){return t===e}));t>-1?bt.state.enabledElements.splice(t,1):nd.warn("unable to remove element")},rd=function(e){js.removeHandlers(e)};var sd,ld=function(){window.removeEventListener("resize",cd,!1)};function cd(){sd||(sd=setTimeout((function(){sd=null,ud()}),66))}var ud=function(){pt.enabledElements.forEach((function(e){y.cornerstone.resize(e)}))},dd=function(){ld(),window.addEventListener("resize",cd,!1)},hd=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};vd(),gd();var t=Tt("globalConfiguration");Array.isArray(e)?e.forEach((function(e){var t=e.moduleName,n=e.configuration,a=Tt(t);a&&(a.configuration=Object.assign({},a.configuration,n))})):t.configuration=Object.assign({},t.configuration,e),t.configuration.autoResizeViewports&&dd()};function vd(){!function(){var e=y.cornerstone,t=e.EVENTS.ELEMENT_ENABLED,n=e.EVENTS.ELEMENT_DISABLED;e.events.removeEventListener(t,ed),e.events.removeEventListener(n,ad)}();var e=y.cornerstone,t=e.EVENTS.ELEMENT_ENABLED,n=e.EVENTS.ELEMENT_DISABLED;e.events.addEventListener(t,ed),e.events.addEventListener(n,ad)}function gd(){var e=bt.modules;Object.keys(e).forEach((function(t){"function"==typeof e[t].onRegisterCallback&&e[t].onRegisterCallback()}))}var fd,md=N("stackTools:stackPrefetch"),pd={maxImagesToPrefetch:1/0,preserveExistingPool:!1};function yd(e,t){e=Math.round(e)||0;var n=[],a=(t=Math.round(t)||0)-e+1;if(a<=0)return n;for(;a--;)n[a]=t--;return n}function xd(e){var t=O(e,"stack");if(t&&t.data&&t.data.length){var n=t.data[0],a=O(e,"stackPrefetch");if(a){var o=a.data[0]||{};if(o.indicesToRequest&&o.indicesToRequest.length||(o.enabled=!1),!1!==o.enabled)if(a.data[0].indicesToRequest.sort((function(e,t){return e-t})),o.indicesToRequest.slice().forEach((function(e){var t=n.imageIds[e];t&&(y.cornerstone.imageCache.getImageLoadObject(t)&&b(e))})),o.indicesToRequest.length){pd.preserveExistingPool||y.cornerstone.imageLoadPoolManager.clearRequestStack("prefetch");for(var i,r,s,l,c,u,d,h=(i=o.indicesToRequest,r=n.currentImageIdIndex,s=0,l=i.length-1,i.forEach((function(e,t){e<r?s=Math.max(t,s):e>r&&(l=Math.min(t,l))})),{low:s,high:l}),v=(js.getErrorLoadingHandler(e),h.low),g=h.high,f=[];v>=0||g<o.indicesToRequest.length;){var m=n.currentImageIdIndex,p=!(m-o.indicesToRequest[v]>pd.maxImagesToPrefetch)&&v>=0,x=!(o.indicesToRequest[g]-m>pd.maxImagesToPrefetch)&&g<o.indicesToRequest.length;if(!x&&!p)break;p&&(u=o.indicesToRequest[v--],c=n.imageIds[u],f.push(c)),x&&(u=o.indicesToRequest[g++],c=n.imageIds[u],f.push(c))}var T={addToBeginning:!0,priority:0,requestType:"prefetch"};d=function(e){return y.cornerstone.loadAndCacheImage(e,T)},f.reverse().forEach((function(e){y.cornerstone.imageLoadPoolManager.addRequest(d.bind(null,e),"prefetch",{imageId:e},0,!0)}))}}}function b(e){var t=o.indicesToRequest.indexOf(e);t>-1&&o.indicesToRequest.splice(t,1)}}function Td(e){return function(t){var n,a=t.detail;try{n=O(e,"stack")}catch(e){return}if(n&&n.data&&n.data.length){var o=n.data[0].imageIds.indexOf(a.imageId);if(!(o<0)){var i=O(e,"stackPrefetch");i&&i.data&&i.data.length&&i.data[0].indicesToRequest.push(o)}}}}function bd(e){clearTimeout(fd),fd=setTimeout((function(){var t=e.target;try{xd(t)}catch(e){return}}),10)}var Cd={enable:function(e){O(e,"stackPrefetch").data=[];var t=O(e,"stack");if(t&&t.data&&t.data.length){var n=t.data[0];if(!0!==n.preventCache){var a={indicesToRequest:yd(0,n.imageIds.length-1),enabled:!0,direction:1},o=a.indicesToRequest.indexOf(n.currentImageIdIndex);a.indicesToRequest.splice(o,1),D(e,"stackPrefetch",a),xd(e),e.removeEventListener(y.cornerstone.EVENTS.NEW_IMAGE,bd),e.addEventListener(y.cornerstone.EVENTS.NEW_IMAGE,bd);var i=Td(e);y.cornerstone.events.removeEventListener(y.cornerstone.EVENTS.IMAGE_CACHE_PROMISE_REMOVED,i),y.cornerstone.events.addEventListener(y.cornerstone.EVENTS.IMAGE_CACHE_PROMISE_REMOVED,i)}else md.warn("A stack that should not be cached was given the stackPrefetch")}},disable:function(e){clearTimeout(fd),e.removeEventListener(y.cornerstone.EVENTS.NEW_IMAGE,bd);var t=Td(e);y.cornerstone.events.removeEventListener(y.cornerstone.EVENTS.IMAGE_CACHE_PROMISE_REMOVED,t);var n=O(e,"stackPrefetch");n&&n.data.length&&(n.data[0].enabled=!1,y.cornerstone.imageLoadPoolManager.clearRequestStack("prefetch"))},getConfiguration:function(){return pd},setConfiguration:function(e){pd=e}},Md=function(){function e(){r()(this,e),this.currentImageIdIndex=0,this.layerIds=[],this.findImageFn=void 0}return l()(e,[{key:"render",value:function(e,t){var n=this;if(!Number.isInteger(this.currentImageIdIndex))throw new Error("FusionRenderer: render - Image ID Index is not an integer");if(!this.findImageFn)throw new Error("No findImage function has been defined");t||(t=O(e,"stack").data);var a=y.cornerstone,o=t[0],i=o.imageIds[this.currentImageIdIndex],r=t.slice(1,t.length);a.loadAndCacheImage(i).then((function(t){var s=n.layerIds[0];s?a.setLayerImage(e,t,s):(s=a.addLayer(e,t,o.options),n.layerIds.push(s)),a.displayImage(e,t),r.forEach((function(t,o){var r=n.findImageFn(t.imageIds,i),l=o+1,c=n.layerIds[l];c||(c=a.addLayer(e,void 0,t.options),n.layerIds.push(c)),r?a.loadAndCacheImage(r).then((function(t){a.setLayerImage(e,t,c),a.updateImage(e)})):(a.setLayerImage(e,void 0,c),a.setActiveLayer(e,s),a.updateImage(e))}))}))}}]),e}(),Ed={};Ed.FusionRenderer=Md;var wd=Ed;function Id(e){var t=e.intervalId;void 0!==t&&(e.intervalId=void 0,e.usingFrameTimeVector?clearTimeout(t):clearInterval(t))}function Sd(e,t){var n,a;if(void 0===e)throw new Error("playClip: element must not be undefined");var o=O(e,"stack");if(o&&o.data&&o.data.length){var i,r=y.cornerstone;if(o.data.length>1){var s=O(e,"stackRenderer");s&&s.data&&s.data.length&&(i=s.data[0])}var l=o.data[0],c=O(e,"playClip");c&&c.data&&c.data.length?Id(n=c.data[0]):D(e,"playClip",n={intervalId:void 0,framesPerSecond:30,lastFrameTimeStamp:void 0,frameRate:0,frameTimeVector:void 0,ignoreFrameTimeVector:!1,usingFrameTimeVector:!1,speed:1,reverse:!1,loop:!0}),(t<0||t>0)&&(n.framesPerSecond=Number(t),n.reverse=n.framesPerSecond<0,n.ignoreFrameTimeVector=!0),!0!==n.ignoreFrameTimeVector&&n.frameTimeVector&&n.frameTimeVector.length===l.imageIds.length&&(a=function(e,t){var n,a,o,i=0,r=e.length,s=[];for(s.isTimeVarying=!1,("number"!=typeof t||t<=0)&&(t=1),n=1;n<r;n++)o=Number(e[n])/t|0,s.push(o),1===n?a=o:o!==a&&(s.isTimeVarying=!0),i+=o;return s.length>0&&(o=s.isTimeVarying?i/s.length|0:s[0],s.push(o)),s}(n.frameTimeVector,n.speed));var u=function(){var t,a,s,c=l.currentImageIdIndex,u=l.imageIds.length;if(n.reverse?c--:c++,!n.loop&&(c<0||c>=u))return Id(n),void function(e){C(e,b.CLIP_STOPPED,{element:e})}(e);c>=u&&(c=0),c<0&&(c=u-1),c!==l.currentImageIdIndex&&(t=js.getStartLoadHandler(e),a=js.getEndLoadHandler(e),s=js.getErrorLoadingHandler(e),t&&t(e),(!0===l.preventCache?r.loadImage(l.imageIds[c]):r.loadAndCacheImage(l.imageIds[c])).then((function(t){try{l.currentImageIdIndex=c,i?(i.currentImageIdIndex=c,i.render(e,o.data)):r.displayImage(e,t),a&&a(e,t)}catch(e){return}}),(function(t){var n=l.imageIds[c];s&&s(e,n,t)})))};a&&a.length>0&&a.isTimeVarying?(n.usingFrameTimeVector=!0,n.intervalId=setTimeout((function e(){n.intervalId=setTimeout(e,a[l.currentImageIdIndex]),u()}),0)):(n.usingFrameTimeVector=!1,n.intervalId=setInterval(u,1e3/Math.abs(n.framesPerSecond)))}}function kd(e){var t=O(e,"playClip");t&&t.data&&t.data.length&&Id(t.data[0])}var _d=function(e,t){var n=bt.state.tools.findIndex((function(n){return n.element===e&&n.name===t}));n>=0&&bt.state.tools.splice(n,1)},Pd=function(e){Dd(e),bt.state.enabledElements.forEach((function(t){_d(t,e)}))},Dd=function(e){Tt("globalConfiguration").configuration.globalToolSyncEnabled&&bt.state.globalTools[e]&&delete bt.state.globalTools[e]},Od=function(e,t,n){var a=Ct(e,t);a&&a.mergeOptions(n)},Ld=function(e,t){pt.enabledElements.forEach((function(n){Od(n,e,t)}))};function Ad(e,t){var n={};return{get:function(a,o){return e.indexOf(o)>=0?(!1===n.hasOwnProperty(o)&&(n[o]={data:[]}),n[o]):t.get(a,o)},add:function(a,o,i){if(!(e.indexOf(o)>=0))return t.add(a,o,i);!1===n.hasOwnProperty(o)&&(n[o]={data:[]}),n[o].data.push(i)},saveToolState:function(){return n},restoreToolState:function(e){n=e},toolState:n}}var Hd=[];function Rd(e,t){var n=P(e);n||(n=_);var a=["stack","stackPrefetch","playClip","volume","slab","referenceLines","crosshairs","stackRenderer"];t&&(a=a.concat(t));var o=Ad(a,n);Hd.push(o),H(e,o)}var Ud={newStackSpecificToolStateManager:Ad,addStackStateManager:Rd};function Nd(){var e={};return{get:function(t,n){if(!1!==e.hasOwnProperty(t)){var a=e[t];if(!1!==a.hasOwnProperty(n))return a[n]}},add:function(t,n,a){!1===e.hasOwnProperty(t)&&(e[t]={});var o=e[t];!1===o.hasOwnProperty(n)&&(o[n]={data:[]}),o[n].data.push(a)},remove:function(t,n,a){if(!1!==e.hasOwnProperty(t)){var o=e[t];if(!1!==o.hasOwnProperty(n)){for(var i=o[n],r=-1,s=0;s<i.data.length;s++)i.data[s]===a&&(r=s);-1!==r&&i.data.splice(r,1)}}}}}var Fd=Nd(),Bd=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"image/png",a=e.querySelector("canvas");if(a.msToBlob){var o=a.msToBlob();return window.navigator.msSaveBlob(o,t)}var i=document.createElement("a");if(i.download=t,i.href=a.toDataURL(n,1),document.createEvent){var r=document.createEvent("MouseEvents");r.initMouseEvent("click",!0,!0,window,0,0,0,0,0,!1,!1,!1,!1,0,null),i.dispatchEvent(r)}else i.fireEvent&&i.fireEvent("onclick")},Vd=N("thirdParty:registerModule"),qd=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],a=jd(e);!a||n?(a&&Vd.warn("Overwriting module %s",e),xt[e]=t,"function"==typeof xt[e].onRegisterCallback&&xt[e].onRegisterCallback()):Vd.warn("A module with the name %s is already registered",e)};function jd(e){return void 0!==xt[e]}function zd(){var e,t=navigator.userAgent,n=t.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i)||[];return/trident/i.test(n[1])?(e=/\brv[ :]+(\d+)/g.exec(t)||[],"IE ".concat(e[1]||"")):"Chrome"===n[1]&&null!==(e=t.match(/\b(OPR|Edge)\/(\d+)/))?e.slice(1).join(" ").replace("OPR","Opera"):(n=n[2]?[n[1],n[2]]:[navigator.appName,navigator.appVersion,"-?"],null!==(e=t.match(/version\/(\d+)/i))&&n.splice(1,1,e[1]),n.join(" "))}var Wd={"base/BaseTool":ga,"base/BaseAnnotationTool":fo,"base/BaseBrushTool":ka,"tools/cursors/MouseCursor":xo,"tools/cursors":o,"manipulators/anyHandlesOutsideImage":ba,"manipulators/getHandleNearImagePoint":pa,"manipulators/getHandlePixelPosition":Ca,"manipulators/handleActivator":ya,"manipulators/moveAllHandles":Ha,"manipulators/moveHandle":Wa,"manipulators/moveNewHandle":to,"manipulators/moveHandleNearImagePoint":uo,"manipulators/findHandleDataNearImagePoint":ho,"manipulators/moveAnnotation":vo,"mixins/activeOrDisabledBinaryTool":ia.activeOrDisabledBinaryTool,"mixins/enabledOrDisabledBinaryTool":ia.enabledOrDisabledBinaryTool,"drawing/getNewContext":_n,"drawing/draw":Wt,"drawing/path":Kt,"drawing/setShadow":Dn,"drawing/drawLine":Zt,"drawing/drawLines":hn,"drawing/drawJoinedLines":$t,"drawing/drawCircle":Qt,"drawing/drawEllipse":rn,"drawing/drawRect":kn,"drawing/fillOutsideRect":function(e,t,n,a,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"pixel";if("pixel"===i){var r=y.cornerstone;n=r.pixelToCanvas(t,n),a=r.pixelToCanvas(t,a)}var s=Math.min(n.x,a.x),l=Math.min(n.y,a.y),c=Math.abs(n.x-a.x),u=Math.abs(n.y-a.y);Kt(e,o,(function(e){e.rect(0,0,e.canvas.clientWidth,e.canvas.clientHeight),e.rect(s+c,l,-c,u)}))},"drawing/drawTextBox":bn,"drawing/drawArrow":Jt,"drawing/fillBox":xn,"drawing/fillTextLines":yn,"drawing/drawLink":vn,"drawing/drawLinkedTextBox":Sn,"drawing/drawHandles":dn,"drawing/textBoxWidth":Tn,"util/getActiveTool":Pa,"util/getLuminance":Fl,"util/getROITextBoxCoords":nr,"util/copyPoints":oc,"util/calculateSUV":$i,"util/setContextToDisplayFontSize":function(e,t,n){return y.cornerstone.setToPixelCoordinateSystem(e,t,.1),{fontSize:n/e.viewport.scale/.1,lineHeight:n/e.viewport.scale/.1,fontScale:.1}},"util/scrollToIndex":Ll,"util/scroll":Al,"util/roundToDecimal":po,"util/projectPatientPointToImagePlane":tn,"util/imagePointToPatientPoint":nn,"util/planePlaneIntersection":an,"util/pointInsideBoundingBox":fa,"util/makeUnselectable":function(e,t){e.style.webkitUserSelect="none",e.style.webkitTouchCallout="none",e.style.mozUserSelect="none",e.style.msUserSelect="none",e.style.oUserSelect="none",e.style.khtmlUserSelect="none",e.style.userSelect="none",e.unselectable="on",e.oncontextmenu=function(){return!1},!0===t&&(e.style.pointerEvents="none")},"util/getRGBPixels":jr,"util/getBrowserInfo":zd,"util/isMobileDevice":function(){return new RegExp("Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini").test(navigator.userAgent)},"util/angleBetweenPoints":Cl,"util/numbersWithCommas":ar,"util/lineSegDistance":mo,"util/triggerEvent":C,"util/convertToVector3":en,"util/clip":Cn,"util/clipToBox":Mn,"util/clipBoxToDisplayedArea":wn,"util/debounce":si,"util/deepmerge":da,"util/getDefault":Pn,"util/getProximityThreshold":so,"util/getPixelSpacing":ii,"util/isEmptyObject":On,"util/isObject":ri,"util/isPointInImage":Ge,"util/isPointInPolygon":us,"util/getLogger":N,"util/throttle":li,"util/wait":yl,"util/waitForEnabledElementImageToLoad":xl,"util/getKeyPressData":function(e){var t=y.cornerstone,n=e.currentTarget,a=t.getEnabledElement(n);if(a&&a.image){var o=bt.state.mousePositionImage;return{event:window.event||e,element:n,viewport:t.getViewport(n),image:a.image,currentPoints:{image:o,canvas:t.pixelToCanvas(n,o)},keyCode:e.keyCode,which:e.which}}},"util/ellipseUtils":tr,"util/freehandUtils":Or,"util/segmentationUtils":a,"util/zoomUtils":Yl},Gd=N("thirdParty:registerMixin"),Yd=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],a=Xd(e);!a||n?(a&&Gd.warn("Overwriting mixins/%s",e),ia[e]=t,Wd["mixins/".concat(e)]=ia[e]):Gd.warn("mixins/%s is already registered",e)};function Xd(e){return void 0!==ia[e]}var Kd=N("thirdParty:registerType"),Zd=function(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]&&arguments[3],o="".concat(e,"/").concat(t),i=$d(o);!i||a?(i&&Kd.warn("Overwriting %s",o),Wd[o]=n):Kd.warn("%s is already registered",o)};function $d(e){return void 0!==Wd[e]}var Jd=N("thirdParty:register"),Qd=function(e,t,n){var a=arguments.length>3&&void 0!==arguments[3]&&arguments[3];if(eh(e,t,n))switch(e){case"module":qd(t,n,a);break;case"mixin":Yd(t,n,a);break;default:Zd(e,t,n,a)}};function eh(e,t,n){return e?t?"object"===T()(n)||"function"==typeof n||(Jd.warn("The %s is a %s, it should be an Object or a function.",n,T()(n)),!1):(Jd.warn("The %s must have a name in order to register.",e),!1):(Jd.warn("The type must be given in order to register."),!1)}var th=function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];e.forEach((function(e){var n=e.type,a=e.name,o=e.item;Qd(n,a,o,t)}))},nh=function(e,t,n){if(n!==t){var a=y.cornerstone,o=a.getViewport(t),i=a.getViewport(n);i.voi.windowWidth===o.voi.windowWidth&&i.voi.windowCenter===o.voi.windowCenter&&i.invert===o.invert||(i.voi.windowWidth=o.voi.windowWidth,i.voi.windowCenter=o.voi.windowCenter,i.invert=o.invert,e.setViewport(n,i))}},ah=function(e,t,n){n!==t&&y.cornerstone.updateImage(n)};function oh(e){return e.filter((function(e,t,n){return n.indexOf(e)===t}))}var ih=function(e,t){y.cornerstone;var n=this,a=[],o=[],i=!1,r={},s=t;function l(e){var t=e.detail.element;n.remove(t),function(e){for(var t in zs)zs[t]=zs[t].filter((function(t){return t.element!==e}))}(t)}this.enabled=!0,this.setHandler=function(e){s=e},this.getHandler=function(){return s},this.getDistances=function(){if(a.length&&o.length){var e=y.cornerstone;r.distances={},r.imageIds={sourceElements:[],targetElements:[]},a.forEach((function(t){var n=e.getEnabledElement(t);if(n&&n.image){var a=n.image.imageId,i=e.metaData.get("imagePlaneModule",a);if(i&&i.imagePositionPatient){var s=en(i.imagePositionPatient);r.hasOwnProperty(n)||(r.distances[a]={},r.imageIds.sourceElements.push(a),o.forEach((function(n){var o=e.getEnabledElement(n);if(o&&o.image){var i=o.image.imageId;if(r.imageIds.targetElements.push(i),t!==n&&a!==i&&!r.distances[a].hasOwnProperty(i)){var l=e.metaData.get("imagePlaneModule",i);if(l&&l.imagePositionPatient){var c=en(l.imagePositionPatient);r.distances[a][i]=c.clone().sub(s)}}}})),Object.keys(r.distances[a]).length||delete r.distances[a])}}}))}},this.fireEvent=function(e,t){var l=!n.enabled,c=!a.length||!o.length;l||c||(i=!0,o.forEach((function(i){var l=o.indexOf(i);if(-1!==l){var c=r.imageIds.targetElements[l],u=a.indexOf(e);if(-1!==u){var d,h=r.imageIds.sourceElements[u];h===c?d=0:void 0!==r.distances[h]&&(d=r.distances[h][c]),s(n,e,i,t,d)}}})),i=!1)},this.onEvent=function(e){var t=e.detail;!0!==i&&n.fireEvent(e.currentTarget,t)},this.addSource=function(t){-1===a.indexOf(t)&&(a.push(t),e.split(" ").forEach((function(e){t.addEventListener(e,n.onEvent)})),n.getDistances(),n.updateDisableHandlers())},this.addTarget=function(e){-1===o.indexOf(e)&&(o.push(e),n.getDistances(),s(n,e,e,0),n.updateDisableHandlers())},this.add=function(e){n.addSource(e),n.addTarget(e)},this.removeSource=function(t){var o=a.indexOf(t);-1!==o&&(a.splice(o,1),e.split(" ").forEach((function(e){t.removeEventListener(e,n.onEvent)})),n.getDistances(),n.fireEvent(t),n.updateDisableHandlers())},this.removeTarget=function(e){var t=o.indexOf(e);-1!==t&&(o.splice(t,1),n.getDistances(),s(n,e,e,0),n.updateDisableHandlers())},this.remove=function(e){n.removeTarget(e),n.removeSource(e)},this.getSourceElements=function(){return a},this.getTargetElements=function(){return o},this.displayImage=function(e,t,n){i=!0,y.cornerstone.displayImage(e,t,n),i=!1},this.setViewport=function(e,t){i=!0,y.cornerstone.setViewport(e,t),i=!1},this.updateDisableHandlers=function(){oh(a.concat(o)).forEach((function(e){e.removeEventListener(y.cornerstone.EVENTS.ELEMENT_DISABLED,l),e.addEventListener(y.cornerstone.EVENTS.ELEMENT_DISABLED,l)}))},this.destroy=function(){oh(a.concat(o)).forEach((function(e){n.remove(e)}))}},rh=function(e,t,n,a){if(t!==n&&a&&a.direction){var o=y.cornerstone,i=O(n,"stack").data[0],r=i.currentImageIdIndex+a.direction;if(r=In(r,0,i.imageIds.length-1),i.currentImageIdIndex!==r){var s=js.getStartLoadHandler(n),l=js.getEndLoadHandler(n),c=js.getErrorLoadingHandler(n);i.currentImageIdIndex=r;var u=i.imageIds[r];s&&s(n),(!0===i.preventCache?o.loadImage(u):o.loadAndCacheImage(u)).then((function(t){var a=o.getViewport(n);i.currentImageIdIndex===r&&(e.displayImage(n,t,a),l&&l(n,t))}),(function(e){var t=i.imageIds[r];c&&c(n,t,e)}))}}},sh=function(e,t,n){if(n!==t){var a=y.cornerstone,o=O(t,"stack").data[0],i=o.imageIds[o.currentImageIdIndex],r=a.metaData.get("imagePlaneModule",i);if(void 0!==r&&void 0!==r.imagePositionPatient){var s=en(r.imagePositionPatient),l=O(n,"stack").data[0],c=Number.MAX_VALUE,u=-1;if(l.imageIds.forEach((function(e,t){var n=a.metaData.get("imagePlaneModule",e);if(void 0!==n&&void 0!==n.imagePositionPatient){var o=en(n.imagePositionPatient).distanceToSquared(s);o<c&&(c=o,u=t)}})),u!==l.currentImageIdIndex){var d=js.getStartLoadHandler(n),h=js.getEndLoadHandler(n),v=js.getErrorLoadingHandler(n);l.currentImageIdIndex=u;var g=l.imageIds[u];if(d&&d(n),-1!==u)(!0===l.preventCache?a.loadImage(g):a.loadAndCacheImage(g)).then((function(t){var o=a.getViewport(n);l.currentImageIdIndex===u&&(e.displayImage(n,t,o),h&&h(n,t))}),(function(e){var t=l.imageIds[u];v&&v(n,t,e)}))}}}},lh=function(e,t,n,a,o){if(n!==t){var i=y.cornerstone,r=O(t,"stack").data[0],s=r.imageIds[r.currentImageIdIndex],l=i.metaData.get("imagePlaneModule",s);if(void 0!==l&&void 0!==l.imagePositionPatient){var c=en(l.imagePositionPatient),u=O(n,"stack").data[0],d=Number.MAX_VALUE,h=-1;if(o){var v=c.clone().add(o);if(u.imageIds.forEach((function(e,t){var n=i.metaData.get("imagePlaneModule",e);if(void 0!==n&&void 0!==n.imagePositionPatient){var a=en(n.imagePositionPatient),o=v.distanceToSquared(a);o<d&&(d=o,h=t)}})),h!==u.currentImageIdIndex&&-1!==h){var g=js.getStartLoadHandler(n),f=js.getEndLoadHandler(n),m=js.getErrorLoadingHandler(n);u.currentImageIdIndex=h;var p=u.imageIds[h];g&&g(n),(!0===u.preventCache?i.loadImage(p):i.loadAndCacheImage(p)).then((function(t){var a=i.getViewport(n);u.currentImageIdIndex===h&&(e.displayImage(n,t,a),f&&f(n,t))}),(function(e){var t=u.imageIds[h];m&&m(n,t,e)}))}}}}},ch=function(e,t,n){if(n!==t){var a=y.cornerstone,o=O(t,"stack").data[0],i=O(n,"stack").data[0],r=o.currentImageIdIndex;if((r=In(r,0,i.imageIds.length-1))!==i.currentImageIdIndex){var s=js.getStartLoadHandler(n),l=js.getEndLoadHandler(n),c=js.getErrorLoadingHandler(n);s&&s(n),(!0===i.preventCache?a.loadImage(i.imageIds[r]):a.loadAndCacheImage(i.imageIds[r])).then((function(t){var o=a.getViewport(n);i.currentImageIdIndex=r,e.displayImage(n,t,o),l&&l(n,t)}),(function(e){var t=i.imageIds[r];c&&c(n,t,e)}))}}},uh=function(e,t,n){if(n!==t){var a=y.cornerstone,o=a.getViewport(t),i=a.getViewport(n);i.scale===o.scale&&i.translation.x===o.translation.x&&i.translation.y===o.translation.y||(i.scale=o.scale,i.translation.x=o.translation.x,i.translation.y=o.translation.y,e.setViewport(n,i))}},dh=function(e){return Wd[e]};n.d(t,"AngleTool",(function(){return ci})),n.d(t,"ArrowAnnotateTool",(function(){return hi})),n.d(t,"BidirectionalTool",(function(){return Zi})),n.d(t,"CircleRoiTool",(function(){return ir})),n.d(t,"CobbAngleTool",(function(){return ur})),n.d(t,"EllipticalRoiTool",(function(){return hr})),n.d(t,"FreehandRoiTool",(function(){return Fr})),n.d(t,"LengthTool",(function(){return qr})),n.d(t,"ProbeTool",(function(){return Wr})),n.d(t,"RectangleRoiTool",(function(){return Yr})),n.d(t,"TextMarkerTool",(function(){return Jr})),n.d(t,"BrushTool",(function(){return ts})),n.d(t,"SphericalBrushTool",(function(){return os})),n.d(t,"RectangleScissorsTool",(function(){return Rs})),n.d(t,"FreehandScissorsTool",(function(){return Hs})),n.d(t,"CircleScissorsTool",(function(){return Us})),n.d(t,"CorrectionScissorsTool",(function(){return Ns})),n.d(t,"CrosshairsTool",(function(){return Ys})),n.d(t,"DoubleTapFitToWindowTool",(function(){return Xs})),n.d(t,"DragProbeTool",(function(){return Ks})),n.d(t,"EraserTool",(function(){return Js})),n.d(t,"FreehandRoiSculptorTool",(function(){return el})),n.d(t,"MagnifyTool",(function(){return nl})),n.d(t,"OverlayTool",(function(){return ol})),n.d(t,"OrientationMarkersTool",(function(){return rl})),n.d(t,"PanMultiTouchTool",(function(){return dl})),n.d(t,"PanTool",(function(){return hl})),n.d(t,"ReferenceLinesTool",(function(){return bl})),n.d(t,"RotateTool",(function(){return Ml})),n.d(t,"RotateTouchTool",(function(){return Sl})),n.d(t,"ScaleOverlayTool",(function(){return _l})),n.d(t,"StackScrollMouseWheelTool",(function(){return Rl})),n.d(t,"StackScrollMultiTouchTool",(function(){return Ul})),n.d(t,"StackScrollTool",(function(){return Nl})),n.d(t,"WwwcRegionTool",(function(){return Bl})),n.d(t,"WwwcTool",(function(){return zl})),n.d(t,"ZoomMouseWheelTool",(function(){return Xl})),n.d(t,"ZoomTool",(function(){return $l})),n.d(t,"ZoomTouchPinchTool",(function(){return ac})),n.d(t,"init",(function(){return hd})),n.d(t,"stackPrefetch",(function(){return Cd})),n.d(t,"stackRenderers",(function(){return wd})),n.d(t,"playClip",(function(){return Sd})),n.d(t,"stopClip",(function(){return kd})),n.d(t,"store",(function(){return bt})),n.d(t,"getModule",(function(){return Tt})),n.d(t,"getToolForElement",(function(){return Ct})),n.d(t,"addTool",(function(){return $u})),n.d(t,"addToolForElement",(function(){return Zu})),n.d(t,"removeTool",(function(){return Pd})),n.d(t,"removeToolForElement",(function(){return _d})),n.d(t,"setToolOptions",(function(){return Ld})),n.d(t,"setToolOptionsForElement",(function(){return Od})),n.d(t,"isToolActiveForElement",(function(){return Ia})),n.d(t,"setToolActive",(function(){return Pt})),n.d(t,"setToolActiveForElement",(function(){return _t})),n.d(t,"setToolEnabled",(function(){return At})),n.d(t,"setToolEnabledForElement",(function(){return Lt})),n.d(t,"setToolDisabled",(function(){return Ot})),n.d(t,"setToolDisabledForElement",(function(){return Dt})),n.d(t,"setToolPassive",(function(){return Rt})),n.d(t,"setToolPassiveForElement",(function(){return Ht})),n.d(t,"addToolState",(function(){return D})),n.d(t,"getToolState",(function(){return O})),n.d(t,"removeToolState",(function(){return L})),n.d(t,"clearToolState",(function(){return A})),n.d(t,"setElementToolStateManager",(function(){return H})),n.d(t,"getElementToolStateManager",(function(){return P})),n.d(t,"textStyle",(function(){return pn})),n.d(t,"toolStyle",(function(){return Xt})),n.d(t,"toolColors",(function(){return un})),n.d(t,"toolCoordinates",(function(){return Ii})),n.d(t,"stackSpecificStateManager",(function(){return Ud})),n.d(t,"newStackSpecificToolStateManager",(function(){return Ad})),n.d(t,"addStackStateManager",(function(){return Rd})),n.d(t,"loadHandlerManager",(function(){return js})),n.d(t,"newImageIdSpecificToolStateManager",(function(){return k})),n.d(t,"globalImageIdSpecificToolStateManager",(function(){return _})),n.d(t,"newFrameOfReferenceSpecificToolStateManager",(function(){return Nd})),n.d(t,"globalFrameOfReferenceSpecificToolStateManager",(function(){return Fd})),n.d(t,"forceEnabledElementResize",(function(){return ud})),n.d(t,"orientation",(function(){return il})),n.d(t,"SaveAs",(function(){return Bd})),n.d(t,"enableLogger",(function(){return F})),n.d(t,"disableLogger",(function(){return B})),n.d(t,"register",(function(){return Qd})),n.d(t,"registerSome",(function(){return th})),n.d(t,"wwwcSynchronizer",(function(){return nh})),n.d(t,"updateImageSynchronizer",(function(){return ah})),n.d(t,"Synchronizer",(function(){return ih})),n.d(t,"stackScrollSynchronizer",(function(){return rh})),n.d(t,"stackImagePositionSynchronizer",(function(){return sh})),n.d(t,"stackImagePositionOffsetSynchronizer",(function(){return lh})),n.d(t,"stackImageIndexSynchronizer",(function(){return ch})),n.d(t,"panZoomSynchronizer",(function(){return uh})),n.d(t,"importInternal",(function(){return dh})),n.d(t,"external",(function(){return y})),n.d(t,"EVENTS",(function(){return b})),n.d(t,"version",(function(){return"6.0.10"})),n.d(t,"import",(function(){return dh}));var hh={AngleTool:ci,ArrowAnnotateTool:hi,BidirectionalTool:Zi,CircleRoiTool:ir,CobbAngleTool:ur,EllipticalRoiTool:hr,FreehandRoiTool:Fr,LengthTool:qr,ProbeTool:Wr,RectangleRoiTool:Yr,TextMarkerTool:Jr,BrushTool:ts,SphericalBrushTool:os,RectangleScissorsTool:Rs,FreehandScissorsTool:Hs,CircleScissorsTool:Us,CorrectionScissorsTool:Ns,CrosshairsTool:Ys,DoubleTapFitToWindowTool:Xs,DragProbeTool:Ks,EraserTool:Js,FreehandRoiSculptorTool:el,MagnifyTool:nl,OverlayTool:ol,OrientationMarkersTool:rl,PanMultiTouchTool:dl,PanTool:hl,ReferenceLinesTool:bl,RotateTool:Ml,RotateTouchTool:Sl,ScaleOverlayTool:_l,StackScrollMouseWheelTool:Rl,StackScrollMultiTouchTool:Ul,StackScrollTool:Nl,WwwcRegionTool:Bl,WwwcTool:zl,ZoomMouseWheelTool:Xl,ZoomTool:$l,ZoomTouchPinchTool:ac,init:hd,stackPrefetch:Cd,stackRenderers:wd,playClip:Sd,stopClip:kd,store:bt,getModule:Tt,getToolForElement:Ct,addTool:$u,addToolForElement:Zu,removeTool:Pd,removeToolForElement:_d,setToolOptions:Ld,setToolOptionsForElement:Od,isToolActiveForElement:Ia,setToolActive:Pt,setToolActiveForElement:_t,setToolEnabled:At,setToolEnabledForElement:Lt,setToolDisabled:Ot,setToolDisabledForElement:Dt,setToolPassive:Rt,setToolPassiveForElement:Ht,addToolState:D,getToolState:O,removeToolState:L,clearToolState:A,setElementToolStateManager:H,getElementToolStateManager:P,textStyle:pn,toolStyle:Xt,toolColors:un,toolCoordinates:Ii,stackSpecificStateManager:Ud,newStackSpecificToolStateManager:Ad,addStackStateManager:Rd,loadHandlerManager:js,newImageIdSpecificToolStateManager:k,globalImageIdSpecificToolStateManager:_,newFrameOfReferenceSpecificToolStateManager:Nd,globalFrameOfReferenceSpecificToolStateManager:Fd,forceEnabledElementResize:ud,orientation:il,SaveAs:Bd,enableLogger:F,disableLogger:B,importInternal:dh,import:dh,register:Qd,registerSome:th,wwwcSynchronizer:nh,updateImageSynchronizer:ah,Synchronizer:ih,stackScrollSynchronizer:rh,stackImagePositionSynchronizer:sh,stackImagePositionOffsetSynchronizer:lh,stackImageIndexSynchronizer:ch,panZoomSynchronizer:uh,external:y,EVENTS:b,version:"6.0.10"};t.default=hh}])}));
//# sourceMappingURL=cornerstoneTools.min.js.map